import { jsx as C, jsxs as ie, Fragment as da } from "react/jsx-runtime";
import * as ne from "react";
import V, { useRef as he, useCallback as ue, useState as fe, useEffect as be, useContext as Ct, useMemo as wt, useDebugValue as U2, createElement as le, forwardRef as Ae, Fragment as ua, createContext as $n, cloneElement as Ci, Component as Si, Children as Ya, isValidElement as fo, useLayoutEffect as Pl, useReducer as t6, memo as ba, PureComponent as n6 } from "react";
import * as r6 from "react-dom";
import qi, { flushSync as jh, createPortal as Eg } from "react-dom";
function je() {
  return je = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, je.apply(this, arguments);
}
function a6(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function ru(e, t) {
  return ru = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, ru(e, t);
}
function Ig(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, ru(e, t);
}
var _i = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ll(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var au = { exports: {} }, iu = { exports: {} }, He = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Y2;
function i6() {
  if (Y2)
    return He;
  Y2 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, f = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
  function x(w) {
    if (typeof w == "object" && w !== null) {
      var M = w.$$typeof;
      switch (M) {
        case t:
          switch (w = w.type, w) {
            case c:
            case l:
            case r:
            case i:
            case a:
            case h:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case s:
                case u:
                case y:
                case f:
                case o:
                  return w;
                default:
                  return M;
              }
          }
        case n:
          return M;
      }
    }
  }
  function g(w) {
    return x(w) === l;
  }
  return He.AsyncMode = c, He.ConcurrentMode = l, He.ContextConsumer = s, He.ContextProvider = o, He.Element = t, He.ForwardRef = u, He.Fragment = r, He.Lazy = y, He.Memo = f, He.Portal = n, He.Profiler = i, He.StrictMode = a, He.Suspense = h, He.isAsyncMode = function(w) {
    return g(w) || x(w) === c;
  }, He.isConcurrentMode = g, He.isContextConsumer = function(w) {
    return x(w) === s;
  }, He.isContextProvider = function(w) {
    return x(w) === o;
  }, He.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }, He.isForwardRef = function(w) {
    return x(w) === u;
  }, He.isFragment = function(w) {
    return x(w) === r;
  }, He.isLazy = function(w) {
    return x(w) === y;
  }, He.isMemo = function(w) {
    return x(w) === f;
  }, He.isPortal = function(w) {
    return x(w) === n;
  }, He.isProfiler = function(w) {
    return x(w) === i;
  }, He.isStrictMode = function(w) {
    return x(w) === a;
  }, He.isSuspense = function(w) {
    return x(w) === h;
  }, He.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === r || w === l || w === i || w === a || w === h || w === p || typeof w == "object" && w !== null && (w.$$typeof === y || w.$$typeof === f || w.$$typeof === o || w.$$typeof === s || w.$$typeof === u || w.$$typeof === v || w.$$typeof === k || w.$$typeof === b || w.$$typeof === m);
  }, He.typeOf = x, He;
}
var $e = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var J2;
function o6() {
  return J2 || (J2 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, f = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function x(Y) {
      return typeof Y == "string" || typeof Y == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Y === r || Y === l || Y === i || Y === a || Y === h || Y === p || typeof Y == "object" && Y !== null && (Y.$$typeof === y || Y.$$typeof === f || Y.$$typeof === o || Y.$$typeof === s || Y.$$typeof === u || Y.$$typeof === v || Y.$$typeof === k || Y.$$typeof === b || Y.$$typeof === m);
    }
    function g(Y) {
      if (typeof Y == "object" && Y !== null) {
        var re = Y.$$typeof;
        switch (re) {
          case t:
            var te = Y.type;
            switch (te) {
              case c:
              case l:
              case r:
              case i:
              case a:
              case h:
                return te;
              default:
                var me = te && te.$$typeof;
                switch (me) {
                  case s:
                  case u:
                  case y:
                  case f:
                  case o:
                    return me;
                  default:
                    return re;
                }
            }
          case n:
            return re;
        }
      }
    }
    var w = c, M = l, S = s, D = o, A = t, $ = u, F = r, Z = y, B = f, O = n, I = i, N = a, R = h, L = !1;
    function W(Y) {
      return L || (L = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), E(Y) || g(Y) === c;
    }
    function E(Y) {
      return g(Y) === l;
    }
    function q(Y) {
      return g(Y) === s;
    }
    function z(Y) {
      return g(Y) === o;
    }
    function H(Y) {
      return typeof Y == "object" && Y !== null && Y.$$typeof === t;
    }
    function _(Y) {
      return g(Y) === u;
    }
    function X(Y) {
      return g(Y) === r;
    }
    function P(Y) {
      return g(Y) === y;
    }
    function Q(Y) {
      return g(Y) === f;
    }
    function U(Y) {
      return g(Y) === n;
    }
    function ae(Y) {
      return g(Y) === i;
    }
    function ee(Y) {
      return g(Y) === a;
    }
    function de(Y) {
      return g(Y) === h;
    }
    $e.AsyncMode = w, $e.ConcurrentMode = M, $e.ContextConsumer = S, $e.ContextProvider = D, $e.Element = A, $e.ForwardRef = $, $e.Fragment = F, $e.Lazy = Z, $e.Memo = B, $e.Portal = O, $e.Profiler = I, $e.StrictMode = N, $e.Suspense = R, $e.isAsyncMode = W, $e.isConcurrentMode = E, $e.isContextConsumer = q, $e.isContextProvider = z, $e.isElement = H, $e.isForwardRef = _, $e.isFragment = X, $e.isLazy = P, $e.isMemo = Q, $e.isPortal = U, $e.isProfiler = ae, $e.isStrictMode = ee, $e.isSuspense = de, $e.isValidElementType = x, $e.typeOf = g;
  }()), $e;
}
process.env.NODE_ENV === "production" ? iu.exports = i6() : iu.exports = o6();
var Ai = iu.exports;
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var G1, K2;
function s6() {
  if (K2)
    return G1;
  K2 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(o).map(function(u) {
        return o[u];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        l[u] = u;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return G1 = a() ? Object.assign : function(i, o) {
    for (var s, c = r(i), l, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var h in s)
        t.call(s, h) && (c[h] = s[h]);
      if (e) {
        l = e(s);
        for (var p = 0; p < l.length; p++)
          n.call(s, l[p]) && (c[l[p]] = s[l[p]]);
      }
    }
    return c;
  }, G1;
}
var Z1, Q2;
function Fh() {
  if (Q2)
    return Z1;
  Q2 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Z1 = e, Z1;
}
var X1, e0;
function Dg() {
  return e0 || (e0 = 1, X1 = Function.call.bind(Object.prototype.hasOwnProperty)), X1;
}
var U1, t0;
function c6() {
  if (t0)
    return U1;
  t0 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Fh(), n = {}, r = Dg();
    e = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, s, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (r(i, u)) {
          var h;
          try {
            if (typeof i[u] != "function") {
              var p = Error(
                (c || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            h = i[u](o, u, c, s, null, t);
          } catch (y) {
            h = y;
          }
          if (h && !(h instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in n)) {
            n[h.message] = !0;
            var f = l ? l() : "";
            e(
              "Failed " + s + " type: " + h.message + (f ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, U1 = a, U1;
}
var Y1, n0;
function l6() {
  if (n0)
    return Y1;
  n0 = 1;
  var e = Ai, t = s6(), n = Fh(), r = Dg(), a = c6(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Y1 = function(s, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function h(E) {
      var q = E && (l && E[l] || E[u]);
      if (typeof q == "function")
        return q;
    }
    var p = "<<anonymous>>", f = {
      array: k("array"),
      bigint: k("bigint"),
      bool: k("boolean"),
      func: k("function"),
      number: k("number"),
      object: k("object"),
      string: k("string"),
      symbol: k("symbol"),
      any: b(),
      arrayOf: x,
      element: g(),
      elementType: w(),
      instanceOf: M,
      node: $(),
      objectOf: D,
      oneOf: S,
      oneOfType: A,
      shape: Z,
      exact: B
    };
    function y(E, q) {
      return E === q ? E !== 0 || 1 / E === 1 / q : E !== E && q !== q;
    }
    function m(E, q) {
      this.message = E, this.data = q && typeof q == "object" ? q : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function v(E) {
      if (process.env.NODE_ENV !== "production")
        var q = {}, z = 0;
      function H(X, P, Q, U, ae, ee, de) {
        if (U = U || p, ee = ee || Q, de !== n) {
          if (c) {
            var Y = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Y.name = "Invariant Violation", Y;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var re = U + ":" + Q;
            !q[re] && // Avoid spamming the console because they are often not actionable except for lib authors
            z < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + ee + "` prop on `" + U + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), q[re] = !0, z++);
          }
        }
        return P[Q] == null ? X ? P[Q] === null ? new m("The " + ae + " `" + ee + "` is marked as required " + ("in `" + U + "`, but its value is `null`.")) : new m("The " + ae + " `" + ee + "` is marked as required in " + ("`" + U + "`, but its value is `undefined`.")) : null : E(P, Q, U, ae, ee);
      }
      var _ = H.bind(null, !1);
      return _.isRequired = H.bind(null, !0), _;
    }
    function k(E) {
      function q(z, H, _, X, P, Q) {
        var U = z[H], ae = N(U);
        if (ae !== E) {
          var ee = R(U);
          return new m(
            "Invalid " + X + " `" + P + "` of type " + ("`" + ee + "` supplied to `" + _ + "`, expected ") + ("`" + E + "`."),
            { expectedType: E }
          );
        }
        return null;
      }
      return v(q);
    }
    function b() {
      return v(o);
    }
    function x(E) {
      function q(z, H, _, X, P) {
        if (typeof E != "function")
          return new m("Property `" + P + "` of component `" + _ + "` has invalid PropType notation inside arrayOf.");
        var Q = z[H];
        if (!Array.isArray(Q)) {
          var U = N(Q);
          return new m("Invalid " + X + " `" + P + "` of type " + ("`" + U + "` supplied to `" + _ + "`, expected an array."));
        }
        for (var ae = 0; ae < Q.length; ae++) {
          var ee = E(Q, ae, _, X, P + "[" + ae + "]", n);
          if (ee instanceof Error)
            return ee;
        }
        return null;
      }
      return v(q);
    }
    function g() {
      function E(q, z, H, _, X) {
        var P = q[z];
        if (!s(P)) {
          var Q = N(P);
          return new m("Invalid " + _ + " `" + X + "` of type " + ("`" + Q + "` supplied to `" + H + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(E);
    }
    function w() {
      function E(q, z, H, _, X) {
        var P = q[z];
        if (!e.isValidElementType(P)) {
          var Q = N(P);
          return new m("Invalid " + _ + " `" + X + "` of type " + ("`" + Q + "` supplied to `" + H + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(E);
    }
    function M(E) {
      function q(z, H, _, X, P) {
        if (!(z[H] instanceof E)) {
          var Q = E.name || p, U = W(z[H]);
          return new m("Invalid " + X + " `" + P + "` of type " + ("`" + U + "` supplied to `" + _ + "`, expected ") + ("instance of `" + Q + "`."));
        }
        return null;
      }
      return v(q);
    }
    function S(E) {
      if (!Array.isArray(E))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function q(z, H, _, X, P) {
        for (var Q = z[H], U = 0; U < E.length; U++)
          if (y(Q, E[U]))
            return null;
        var ae = JSON.stringify(E, function(de, Y) {
          var re = R(Y);
          return re === "symbol" ? String(Y) : Y;
        });
        return new m("Invalid " + X + " `" + P + "` of value `" + String(Q) + "` " + ("supplied to `" + _ + "`, expected one of " + ae + "."));
      }
      return v(q);
    }
    function D(E) {
      function q(z, H, _, X, P) {
        if (typeof E != "function")
          return new m("Property `" + P + "` of component `" + _ + "` has invalid PropType notation inside objectOf.");
        var Q = z[H], U = N(Q);
        if (U !== "object")
          return new m("Invalid " + X + " `" + P + "` of type " + ("`" + U + "` supplied to `" + _ + "`, expected an object."));
        for (var ae in Q)
          if (r(Q, ae)) {
            var ee = E(Q, ae, _, X, P + "." + ae, n);
            if (ee instanceof Error)
              return ee;
          }
        return null;
      }
      return v(q);
    }
    function A(E) {
      if (!Array.isArray(E))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var q = 0; q < E.length; q++) {
        var z = E[q];
        if (typeof z != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + L(z) + " at index " + q + "."
          ), o;
      }
      function H(_, X, P, Q, U) {
        for (var ae = [], ee = 0; ee < E.length; ee++) {
          var de = E[ee], Y = de(_, X, P, Q, U, n);
          if (Y == null)
            return null;
          Y.data && r(Y.data, "expectedType") && ae.push(Y.data.expectedType);
        }
        var re = ae.length > 0 ? ", expected one of type [" + ae.join(", ") + "]" : "";
        return new m("Invalid " + Q + " `" + U + "` supplied to " + ("`" + P + "`" + re + "."));
      }
      return v(H);
    }
    function $() {
      function E(q, z, H, _, X) {
        return O(q[z]) ? null : new m("Invalid " + _ + " `" + X + "` supplied to " + ("`" + H + "`, expected a ReactNode."));
      }
      return v(E);
    }
    function F(E, q, z, H, _) {
      return new m(
        (E || "React class") + ": " + q + " type `" + z + "." + H + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + _ + "`."
      );
    }
    function Z(E) {
      function q(z, H, _, X, P) {
        var Q = z[H], U = N(Q);
        if (U !== "object")
          return new m("Invalid " + X + " `" + P + "` of type `" + U + "` " + ("supplied to `" + _ + "`, expected `object`."));
        for (var ae in E) {
          var ee = E[ae];
          if (typeof ee != "function")
            return F(_, X, P, ae, R(ee));
          var de = ee(Q, ae, _, X, P + "." + ae, n);
          if (de)
            return de;
        }
        return null;
      }
      return v(q);
    }
    function B(E) {
      function q(z, H, _, X, P) {
        var Q = z[H], U = N(Q);
        if (U !== "object")
          return new m("Invalid " + X + " `" + P + "` of type `" + U + "` " + ("supplied to `" + _ + "`, expected `object`."));
        var ae = t({}, z[H], E);
        for (var ee in ae) {
          var de = E[ee];
          if (r(E, ee) && typeof de != "function")
            return F(_, X, P, ee, R(de));
          if (!de)
            return new m(
              "Invalid " + X + " `" + P + "` key `" + ee + "` supplied to `" + _ + "`.\nBad object: " + JSON.stringify(z[H], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(E), null, "  ")
            );
          var Y = de(Q, ee, _, X, P + "." + ee, n);
          if (Y)
            return Y;
        }
        return null;
      }
      return v(q);
    }
    function O(E) {
      switch (typeof E) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !E;
        case "object":
          if (Array.isArray(E))
            return E.every(O);
          if (E === null || s(E))
            return !0;
          var q = h(E);
          if (q) {
            var z = q.call(E), H;
            if (q !== E.entries) {
              for (; !(H = z.next()).done; )
                if (!O(H.value))
                  return !1;
            } else
              for (; !(H = z.next()).done; ) {
                var _ = H.value;
                if (_ && !O(_[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function I(E, q) {
      return E === "symbol" ? !0 : q ? q["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && q instanceof Symbol : !1;
    }
    function N(E) {
      var q = typeof E;
      return Array.isArray(E) ? "array" : E instanceof RegExp ? "object" : I(q, E) ? "symbol" : q;
    }
    function R(E) {
      if (typeof E > "u" || E === null)
        return "" + E;
      var q = N(E);
      if (q === "object") {
        if (E instanceof Date)
          return "date";
        if (E instanceof RegExp)
          return "regexp";
      }
      return q;
    }
    function L(E) {
      var q = R(E);
      switch (q) {
        case "array":
        case "object":
          return "an " + q;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + q;
        default:
          return q;
      }
    }
    function W(E) {
      return !E.constructor || !E.constructor.name ? p : E.constructor.name;
    }
    return f.checkPropTypes = a, f.resetWarningCache = a.resetWarningCache, f.PropTypes = f, f;
  }, Y1;
}
var J1, r0;
function d6() {
  if (r0)
    return J1;
  r0 = 1;
  var e = Fh();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, J1 = function() {
    function r(o, s, c, l, u, h) {
      if (h !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, J1;
}
if (process.env.NODE_ENV !== "production") {
  var u6 = Ai, h6 = !0;
  au.exports = l6()(u6.isElement, h6);
} else
  au.exports = d6()();
var p6 = au.exports;
const j = /* @__PURE__ */ Ll(p6), a0 = {
  disabled: !1
};
var f6 = process.env.NODE_ENV !== "production" ? j.oneOfType([j.number, j.shape({
  enter: j.number,
  exit: j.number,
  appear: j.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && j.oneOfType([j.string, j.shape({
  enter: j.string,
  exit: j.string,
  active: j.string
}), j.shape({
  enter: j.string,
  enterDone: j.string,
  enterActive: j.string,
  exit: j.string,
  exitDone: j.string,
  exitActive: j.string
})]);
const Tg = V.createContext(null);
var y6 = function(t) {
  return t.scrollTop;
}, Gi = "unmounted", qr = "exited", _r = "entering", Ba = "entered", ou = "exiting", cr = /* @__PURE__ */ function(e) {
  Ig(t, e);
  function t(r, a) {
    var i;
    i = e.call(this, r, a) || this;
    var o = a, s = o && !o.isMounting ? r.enter : r.appear, c;
    return i.appearStatus = null, r.in ? s ? (c = qr, i.appearStatus = _r) : c = Ba : r.unmountOnExit || r.mountOnEnter ? c = Gi : c = qr, i.state = {
      status: c
    }, i.nextCallback = null, i;
  }
  t.getDerivedStateFromProps = function(a, i) {
    var o = a.in;
    return o && i.status === Gi ? {
      status: qr
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(a) {
    var i = null;
    if (a !== this.props) {
      var o = this.state.status;
      this.props.in ? o !== _r && o !== Ba && (i = _r) : (o === _r || o === Ba) && (i = ou);
    }
    this.updateStatus(!1, i);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var a = this.props.timeout, i, o, s;
    return i = o = s = a, a != null && typeof a != "number" && (i = a.exit, o = a.enter, s = a.appear !== void 0 ? a.appear : o), {
      exit: i,
      enter: o,
      appear: s
    };
  }, n.updateStatus = function(a, i) {
    if (a === void 0 && (a = !1), i !== null)
      if (this.cancelNextCallback(), i === _r) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var o = this.props.nodeRef ? this.props.nodeRef.current : qi.findDOMNode(this);
          o && y6(o);
        }
        this.performEnter(a);
      } else
        this.performExit();
    else
      this.props.unmountOnExit && this.state.status === qr && this.setState({
        status: Gi
      });
  }, n.performEnter = function(a) {
    var i = this, o = this.props.enter, s = this.context ? this.context.isMounting : a, c = this.props.nodeRef ? [s] : [qi.findDOMNode(this), s], l = c[0], u = c[1], h = this.getTimeouts(), p = s ? h.appear : h.enter;
    if (!a && !o || a0.disabled) {
      this.safeSetState({
        status: Ba
      }, function() {
        i.props.onEntered(l);
      });
      return;
    }
    this.props.onEnter(l, u), this.safeSetState({
      status: _r
    }, function() {
      i.props.onEntering(l, u), i.onTransitionEnd(p, function() {
        i.safeSetState({
          status: Ba
        }, function() {
          i.props.onEntered(l, u);
        });
      });
    });
  }, n.performExit = function() {
    var a = this, i = this.props.exit, o = this.getTimeouts(), s = this.props.nodeRef ? void 0 : qi.findDOMNode(this);
    if (!i || a0.disabled) {
      this.safeSetState({
        status: qr
      }, function() {
        a.props.onExited(s);
      });
      return;
    }
    this.props.onExit(s), this.safeSetState({
      status: ou
    }, function() {
      a.props.onExiting(s), a.onTransitionEnd(o.exit, function() {
        a.safeSetState({
          status: qr
        }, function() {
          a.props.onExited(s);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(a, i) {
    i = this.setNextCallback(i), this.setState(a, i);
  }, n.setNextCallback = function(a) {
    var i = this, o = !0;
    return this.nextCallback = function(s) {
      o && (o = !1, i.nextCallback = null, a(s));
    }, this.nextCallback.cancel = function() {
      o = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(a, i) {
    this.setNextCallback(i);
    var o = this.props.nodeRef ? this.props.nodeRef.current : qi.findDOMNode(this), s = a == null && !this.props.addEndListener;
    if (!o || s) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var c = this.props.nodeRef ? [this.nextCallback] : [o, this.nextCallback], l = c[0], u = c[1];
      this.props.addEndListener(l, u);
    }
    a != null && setTimeout(this.nextCallback, a);
  }, n.render = function() {
    var a = this.state.status;
    if (a === Gi)
      return null;
    var i = this.props, o = i.children;
    i.in, i.mountOnEnter, i.unmountOnExit, i.appear, i.enter, i.exit, i.timeout, i.addEndListener, i.onEnter, i.onEntering, i.onEntered, i.onExit, i.onExiting, i.onExited, i.nodeRef;
    var s = a6(i, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ V.createElement(Tg.Provider, {
        value: null
      }, typeof o == "function" ? o(a, s) : V.cloneElement(V.Children.only(o), s))
    );
  }, t;
}(V.Component);
cr.contextType = Tg;
cr.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: j.shape({
    current: typeof Element > "u" ? j.any : function(e, t, n, r, a, i) {
      var o = e[t];
      return j.instanceOf(o && "ownerDocument" in o ? o.ownerDocument.defaultView.Element : Element)(e, t, n, r, a, i);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: j.oneOfType([j.func.isRequired, j.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: j.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: j.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: j.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: j.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: j.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: j.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var n = f6;
    t.addEndListener || (n = n.isRequired);
    for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
      a[i - 1] = arguments[i];
    return n.apply(void 0, [t].concat(a));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: j.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: j.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: j.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: j.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: j.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: j.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: j.func
} : {};
function Oa() {
}
cr.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Oa,
  onEntering: Oa,
  onEntered: Oa,
  onExit: Oa,
  onExiting: Oa,
  onExited: Oa
};
cr.UNMOUNTED = Gi;
cr.EXITED = qr;
cr.ENTERING = _r;
cr.ENTERED = Ba;
cr.EXITING = ou;
const Wh = cr;
function i0(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
const Cc = {
  object: (e) => typeof e == "object" && e !== null && !Array.isArray(e),
  string: (e) => typeof e == "string"
};
class Ja {
  static isObject(t) {
    return Cc.object(t);
  }
  static createModifier(t, n) {
    return `${t}--${n}`;
  }
  static createStaticModifier(t, n) {
    return `${t}-${n}`;
  }
  static createElement(t, n) {
    return `${t}__${n}`;
  }
  static flatModifiers(t) {
    return t.join(" ");
  }
  static hasUsageOfPackage(t = "") {
    return /useCSS/.test(t);
  }
}
var qh = /* @__PURE__ */ ((e) => (e.block = "block", e))(qh || {}), Rl = /* @__PURE__ */ ((e) => (e.string = "string", e))(Rl || {});
const m6 = ({
  element: e,
  modifiers: t,
  context: n
}) => {
  const { elements: r } = n;
  if (!e)
    return r.block.base.value;
  if (Cc.string(e) && Cc.object(t)) {
    const a = r[e].modifiers, i = t, o = Object.keys(a).filter((s) => i[s]).map((s) => {
      const { type: c, value: l } = a[s];
      return c === Rl.string ? Ja.createStaticModifier(l, i[s]) : l;
    });
    return `${r[e].base.value} ${Ja.flatModifiers(o)}`.trim();
  }
  return "";
}, g6 = ({
  element: e,
  modifiers: t,
  context: n
}) => {
  const { cache: r, elements: a } = n, { block: i } = a, o = Object.keys(t), s = `${e}-${JSON.stringify(o)}`;
  if (r[s])
    return;
  const c = o.map((u) => {
    const h = typeof t[u];
    let { value: p } = i.base;
    return e === qh.block ? p = Ja.createModifier(i.base.value, u) : p += `__${Ja.createModifier(e, u)}`, [
      u,
      {
        type: h,
        value: p
      }
    ];
  }), l = Object.fromEntries(c);
  Cc.string(e) && (a[e] ? n.elements[e].modifiers = {
    ...n.elements[e].modifiers,
    ...l
  } : n.elements[e] = {
    base: {
      type: Rl.string,
      value: Ja.createElement(i.base.value, e)
    },
    modifiers: {
      ...l
    }
  }), n.cache[s] = !0;
};
function x4e(e) {
  const t = he({
    elements: {
      block: {
        base: {
          type: Rl.string,
          value: e
        },
        modifiers: {}
      }
    },
    cache: {}
  });
  return ue((r, a = {}) => {
    const i = Ja.isObject(r), o = {
      element: i ? qh.block : r,
      modifiers: i ? r : a,
      context: t.current
    };
    return g6(o), m6(o);
  }, []);
}
const v6 = (e, t) => {
  typeof e == "function" ? e(t) : e && (e.current = t);
}, _h = (...e) => ne.useMemo(() => e.every((t) => t == null) ? null : (t) => {
  e.forEach((n) => {
    v6(n, t);
  });
}, e), k6 = (e, t) => {
  const [n, r] = fe(e);
  return be(() => {
    const a = setTimeout(() => {
      r(e);
    }, t);
    return () => {
      clearTimeout(a);
    };
  }, [e, t]), n;
}, b6 = (e, t) => {
  const n = he(e), r = he();
  be(() => {
    n.current = e;
  }, [e]);
  const a = ue(() => {
    r.current = setTimeout(() => n.current(), t);
  }, [t]), i = ue(() => {
    r.current && clearTimeout(r.current);
  }, []);
  return be(() => (a(), i), [t, a, i]), { reset: ue(() => {
    i(), a();
  }, [i, a]), clear: i };
}, o0 = (e, t, n) => {
  const { reset: r, clear: a } = b6(e, t);
  be(r, [...n, r]), be(a, []);
}, x6 = (e, t) => {
  be(() => {
    const n = (r) => {
      !e.current || e.current.contains(r.target) || t(r);
    };
    return document.addEventListener("mousedown", n), document.addEventListener("touchstart", n), () => {
      document.removeEventListener("mousedown", n), document.removeEventListener("touchstart", n);
    };
  }, [e, t]);
}, M6 = 300;
function w6(e) {
  function t(z, H, _, X, P) {
    for (var Q = 0, U = 0, ae = 0, ee = 0, de, Y, re = 0, te = 0, me, Pe = me = de = 0, Se = 0, _e = 0, Ot = 0, Re = 0, Qe = _.length, Rt = Qe - 1, Xe, Me = "", Fe = "", xn = "", Mn = "", Et; Se < Qe; ) {
      if (Y = _.charCodeAt(Se), Se === Rt && U + ee + ae + Q !== 0 && (U !== 0 && (Y = U === 47 ? 10 : 47), ee = ae = Q = 0, Qe++, Rt++), U + ee + ae + Q === 0) {
        if (Se === Rt && (0 < _e && (Me = Me.replace(p, "")), 0 < Me.trim().length)) {
          switch (Y) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              Me += _.charAt(Se);
          }
          Y = 59;
        }
        switch (Y) {
          case 123:
            for (Me = Me.trim(), de = Me.charCodeAt(0), me = 1, Re = ++Se; Se < Qe; ) {
              switch (Y = _.charCodeAt(Se)) {
                case 123:
                  me++;
                  break;
                case 125:
                  me--;
                  break;
                case 47:
                  switch (Y = _.charCodeAt(Se + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (Pe = Se + 1; Pe < Rt; ++Pe)
                          switch (_.charCodeAt(Pe)) {
                            case 47:
                              if (Y === 42 && _.charCodeAt(Pe - 1) === 42 && Se + 2 !== Pe) {
                                Se = Pe + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (Y === 47) {
                                Se = Pe + 1;
                                break e;
                              }
                          }
                        Se = Pe;
                      }
                  }
                  break;
                case 91:
                  Y++;
                case 40:
                  Y++;
                case 34:
                case 39:
                  for (; Se++ < Rt && _.charCodeAt(Se) !== Y; )
                    ;
              }
              if (me === 0)
                break;
              Se++;
            }
            switch (me = _.substring(Re, Se), de === 0 && (de = (Me = Me.replace(h, "").trim()).charCodeAt(0)), de) {
              case 64:
                switch (0 < _e && (Me = Me.replace(p, "")), Y = Me.charCodeAt(1), Y) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    _e = H;
                    break;
                  default:
                    _e = N;
                }
                if (me = t(H, _e, me, Y, P + 1), Re = me.length, 0 < L && (_e = n(N, Me, Ot), Et = s(3, me, _e, H, B, Z, Re, Y, P, X), Me = _e.join(""), Et !== void 0 && (Re = (me = Et.trim()).length) === 0 && (Y = 0, me = "")), 0 < Re)
                  switch (Y) {
                    case 115:
                      Me = Me.replace(M, o);
                    case 100:
                    case 109:
                    case 45:
                      me = Me + "{" + me + "}";
                      break;
                    case 107:
                      Me = Me.replace(b, "$1 $2"), me = Me + "{" + me + "}", me = I === 1 || I === 2 && i("@" + me, 3) ? "@-webkit-" + me + "@" + me : "@" + me;
                      break;
                    default:
                      me = Me + me, X === 112 && (me = (Fe += me, ""));
                  }
                else
                  me = "";
                break;
              default:
                me = t(H, n(H, Me, Ot), me, X, P + 1);
            }
            xn += me, me = Ot = _e = Pe = de = 0, Me = "", Y = _.charCodeAt(++Se);
            break;
          case 125:
          case 59:
            if (Me = (0 < _e ? Me.replace(p, "") : Me).trim(), 1 < (Re = Me.length))
              switch (Pe === 0 && (de = Me.charCodeAt(0), de === 45 || 96 < de && 123 > de) && (Re = (Me = Me.replace(" ", ":")).length), 0 < L && (Et = s(1, Me, H, z, B, Z, Fe.length, X, P, X)) !== void 0 && (Re = (Me = Et.trim()).length) === 0 && (Me = "\0\0"), de = Me.charCodeAt(0), Y = Me.charCodeAt(1), de) {
                case 0:
                  break;
                case 64:
                  if (Y === 105 || Y === 99) {
                    Mn += Me + _.charAt(Se);
                    break;
                  }
                default:
                  Me.charCodeAt(Re - 1) !== 58 && (Fe += a(Me, de, Y, Me.charCodeAt(2)));
              }
            Ot = _e = Pe = de = 0, Me = "", Y = _.charCodeAt(++Se);
        }
      }
      switch (Y) {
        case 13:
        case 10:
          U === 47 ? U = 0 : 1 + de === 0 && X !== 107 && 0 < Me.length && (_e = 1, Me += "\0"), 0 < L * E && s(0, Me, H, z, B, Z, Fe.length, X, P, X), Z = 1, B++;
          break;
        case 59:
        case 125:
          if (U + ee + ae + Q === 0) {
            Z++;
            break;
          }
        default:
          switch (Z++, Xe = _.charAt(Se), Y) {
            case 9:
            case 32:
              if (ee + Q + U === 0)
                switch (re) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    Xe = "";
                    break;
                  default:
                    Y !== 32 && (Xe = " ");
                }
              break;
            case 0:
              Xe = "\\0";
              break;
            case 12:
              Xe = "\\f";
              break;
            case 11:
              Xe = "\\v";
              break;
            case 38:
              ee + U + Q === 0 && (_e = Ot = 1, Xe = "\f" + Xe);
              break;
            case 108:
              if (ee + U + Q + O === 0 && 0 < Pe)
                switch (Se - Pe) {
                  case 2:
                    re === 112 && _.charCodeAt(Se - 3) === 58 && (O = re);
                  case 8:
                    te === 111 && (O = te);
                }
              break;
            case 58:
              ee + U + Q === 0 && (Pe = Se);
              break;
            case 44:
              U + ae + ee + Q === 0 && (_e = 1, Xe += "\r");
              break;
            case 34:
            case 39:
              U === 0 && (ee = ee === Y ? 0 : ee === 0 ? Y : ee);
              break;
            case 91:
              ee + U + ae === 0 && Q++;
              break;
            case 93:
              ee + U + ae === 0 && Q--;
              break;
            case 41:
              ee + U + Q === 0 && ae--;
              break;
            case 40:
              if (ee + U + Q === 0) {
                if (de === 0)
                  switch (2 * re + 3 * te) {
                    case 533:
                      break;
                    default:
                      de = 1;
                  }
                ae++;
              }
              break;
            case 64:
              U + ae + ee + Q + Pe + me === 0 && (me = 1);
              break;
            case 42:
            case 47:
              if (!(0 < ee + Q + ae))
                switch (U) {
                  case 0:
                    switch (2 * Y + 3 * _.charCodeAt(Se + 1)) {
                      case 235:
                        U = 47;
                        break;
                      case 220:
                        Re = Se, U = 42;
                    }
                    break;
                  case 42:
                    Y === 47 && re === 42 && Re + 2 !== Se && (_.charCodeAt(Re + 2) === 33 && (Fe += _.substring(Re, Se + 1)), Xe = "", U = 0);
                }
          }
          U === 0 && (Me += Xe);
      }
      te = re, re = Y, Se++;
    }
    if (Re = Fe.length, 0 < Re) {
      if (_e = H, 0 < L && (Et = s(2, Fe, _e, z, B, Z, Re, X, P, X), Et !== void 0 && (Fe = Et).length === 0))
        return Mn + Fe + xn;
      if (Fe = _e.join(",") + "{" + Fe + "}", I * O !== 0) {
        switch (I !== 2 || i(Fe, 2) || (O = 0), O) {
          case 111:
            Fe = Fe.replace(g, ":-moz-$1") + Fe;
            break;
          case 112:
            Fe = Fe.replace(x, "::-webkit-input-$1") + Fe.replace(x, "::-moz-$1") + Fe.replace(x, ":-ms-input-$1") + Fe;
        }
        O = 0;
      }
    }
    return Mn + Fe + xn;
  }
  function n(z, H, _) {
    var X = H.trim().split(v);
    H = X;
    var P = X.length, Q = z.length;
    switch (Q) {
      case 0:
      case 1:
        var U = 0;
        for (z = Q === 0 ? "" : z[0] + " "; U < P; ++U)
          H[U] = r(z, H[U], _).trim();
        break;
      default:
        var ae = U = 0;
        for (H = []; U < P; ++U)
          for (var ee = 0; ee < Q; ++ee)
            H[ae++] = r(z[ee] + " ", X[U], _).trim();
    }
    return H;
  }
  function r(z, H, _) {
    var X = H.charCodeAt(0);
    switch (33 > X && (X = (H = H.trim()).charCodeAt(0)), X) {
      case 38:
        return H.replace(k, "$1" + z.trim());
      case 58:
        return z.trim() + H.replace(k, "$1" + z.trim());
      default:
        if (0 < 1 * _ && 0 < H.indexOf("\f"))
          return H.replace(k, (z.charCodeAt(0) === 58 ? "" : "$1") + z.trim());
    }
    return z + H;
  }
  function a(z, H, _, X) {
    var P = z + ";", Q = 2 * H + 3 * _ + 4 * X;
    if (Q === 944) {
      z = P.indexOf(":", 9) + 1;
      var U = P.substring(z, P.length - 1).trim();
      return U = P.substring(0, z).trim() + U + ";", I === 1 || I === 2 && i(U, 1) ? "-webkit-" + U + U : U;
    }
    if (I === 0 || I === 2 && !i(P, 1))
      return P;
    switch (Q) {
      case 1015:
        return P.charCodeAt(10) === 97 ? "-webkit-" + P + P : P;
      case 951:
        return P.charCodeAt(3) === 116 ? "-webkit-" + P + P : P;
      case 963:
        return P.charCodeAt(5) === 110 ? "-webkit-" + P + P : P;
      case 1009:
        if (P.charCodeAt(4) !== 100)
          break;
      case 969:
      case 942:
        return "-webkit-" + P + P;
      case 978:
        return "-webkit-" + P + "-moz-" + P + P;
      case 1019:
      case 983:
        return "-webkit-" + P + "-moz-" + P + "-ms-" + P + P;
      case 883:
        if (P.charCodeAt(8) === 45)
          return "-webkit-" + P + P;
        if (0 < P.indexOf("image-set(", 11))
          return P.replace(F, "$1-webkit-$2") + P;
        break;
      case 932:
        if (P.charCodeAt(4) === 45)
          switch (P.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + P.replace("-grow", "") + "-webkit-" + P + "-ms-" + P.replace("grow", "positive") + P;
            case 115:
              return "-webkit-" + P + "-ms-" + P.replace("shrink", "negative") + P;
            case 98:
              return "-webkit-" + P + "-ms-" + P.replace("basis", "preferred-size") + P;
          }
        return "-webkit-" + P + "-ms-" + P + P;
      case 964:
        return "-webkit-" + P + "-ms-flex-" + P + P;
      case 1023:
        if (P.charCodeAt(8) !== 99)
          break;
        return U = P.substring(P.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + U + "-webkit-" + P + "-ms-flex-pack" + U + P;
      case 1005:
        return y.test(P) ? P.replace(f, ":-webkit-") + P.replace(f, ":-moz-") + P : P;
      case 1e3:
        switch (U = P.substring(13).trim(), H = U.indexOf("-") + 1, U.charCodeAt(0) + U.charCodeAt(H)) {
          case 226:
            U = P.replace(w, "tb");
            break;
          case 232:
            U = P.replace(w, "tb-rl");
            break;
          case 220:
            U = P.replace(w, "lr");
            break;
          default:
            return P;
        }
        return "-webkit-" + P + "-ms-" + U + P;
      case 1017:
        if (P.indexOf("sticky", 9) === -1)
          break;
      case 975:
        switch (H = (P = z).length - 10, U = (P.charCodeAt(H) === 33 ? P.substring(0, H) : P).substring(z.indexOf(":", 7) + 1).trim(), Q = U.charCodeAt(0) + (U.charCodeAt(7) | 0)) {
          case 203:
            if (111 > U.charCodeAt(8))
              break;
          case 115:
            P = P.replace(U, "-webkit-" + U) + ";" + P;
            break;
          case 207:
          case 102:
            P = P.replace(U, "-webkit-" + (102 < Q ? "inline-" : "") + "box") + ";" + P.replace(U, "-webkit-" + U) + ";" + P.replace(U, "-ms-" + U + "box") + ";" + P;
        }
        return P + ";";
      case 938:
        if (P.charCodeAt(5) === 45)
          switch (P.charCodeAt(6)) {
            case 105:
              return U = P.replace("-items", ""), "-webkit-" + P + "-webkit-box-" + U + "-ms-flex-" + U + P;
            case 115:
              return "-webkit-" + P + "-ms-flex-item-" + P.replace(D, "") + P;
            default:
              return "-webkit-" + P + "-ms-flex-line-pack" + P.replace("align-content", "").replace(D, "") + P;
          }
        break;
      case 973:
      case 989:
        if (P.charCodeAt(3) !== 45 || P.charCodeAt(4) === 122)
          break;
      case 931:
      case 953:
        if ($.test(z) === !0)
          return (U = z.substring(z.indexOf(":") + 1)).charCodeAt(0) === 115 ? a(z.replace("stretch", "fill-available"), H, _, X).replace(":fill-available", ":stretch") : P.replace(U, "-webkit-" + U) + P.replace(U, "-moz-" + U.replace("fill-", "")) + P;
        break;
      case 962:
        if (P = "-webkit-" + P + (P.charCodeAt(5) === 102 ? "-ms-" + P : "") + P, _ + X === 211 && P.charCodeAt(13) === 105 && 0 < P.indexOf("transform", 10))
          return P.substring(0, P.indexOf(";", 27) + 1).replace(m, "$1-webkit-$2") + P;
    }
    return P;
  }
  function i(z, H) {
    var _ = z.indexOf(H === 1 ? ":" : "{"), X = z.substring(0, H !== 3 ? _ : 10);
    return _ = z.substring(_ + 1, z.length - 1), W(H !== 2 ? X : X.replace(A, "$1"), _, H);
  }
  function o(z, H) {
    var _ = a(H, H.charCodeAt(0), H.charCodeAt(1), H.charCodeAt(2));
    return _ !== H + ";" ? _.replace(S, " or ($1)").substring(4) : "(" + H + ")";
  }
  function s(z, H, _, X, P, Q, U, ae, ee, de) {
    for (var Y = 0, re = H, te; Y < L; ++Y)
      switch (te = R[Y].call(u, z, re, _, X, P, Q, U, ae, ee, de)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          re = te;
      }
    if (re !== H)
      return re;
  }
  function c(z) {
    switch (z) {
      case void 0:
      case null:
        L = R.length = 0;
        break;
      default:
        if (typeof z == "function")
          R[L++] = z;
        else if (typeof z == "object")
          for (var H = 0, _ = z.length; H < _; ++H)
            c(z[H]);
        else
          E = !!z | 0;
    }
    return c;
  }
  function l(z) {
    return z = z.prefix, z !== void 0 && (W = null, z ? typeof z != "function" ? I = 1 : (I = 2, W = z) : I = 0), l;
  }
  function u(z, H) {
    var _ = z;
    if (33 > _.charCodeAt(0) && (_ = _.trim()), q = _, _ = [q], 0 < L) {
      var X = s(-1, H, _, _, B, Z, 0, 0, 0, 0);
      X !== void 0 && typeof X == "string" && (H = X);
    }
    var P = t(N, _, H, 0, 0);
    return 0 < L && (X = s(-2, P, _, _, B, Z, P.length, 0, 0, 0), X !== void 0 && (P = X)), q = "", O = 0, Z = B = 1, P;
  }
  var h = /^\0+/g, p = /[\0\r\f]/g, f = /: */g, y = /zoo|gra/, m = /([,: ])(transform)/g, v = /,\r+?/g, k = /([\t\r\n ])*\f?&/g, b = /@(k\w+)\s*(\S*)\s*/, x = /::(place)/g, g = /:(read-only)/g, w = /[svh]\w+-[tblr]{2}/, M = /\(\s*(.*)\s*\)/g, S = /([\s\S]*?);/g, D = /-self|flex-/g, A = /[^]*?(:[rp][el]a[\w-]+)[^]*/, $ = /stretch|:\s*\w+\-(?:conte|avail)/, F = /([^-])(image-set\()/, Z = 1, B = 1, O = 0, I = 1, N = [], R = [], L = 0, W = null, E = 0, q = "";
  return u.use = c, u.set = l, e !== void 0 && l(e), u;
}
var C6 = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function S6(e) {
  var t = {};
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var A6 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, s0 = S6(
  function(e) {
    return A6.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Gh = Ai, O6 = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, E6 = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, I6 = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Ng = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Zh = {};
Zh[Gh.ForwardRef] = I6;
Zh[Gh.Memo] = Ng;
function c0(e) {
  return Gh.isMemo(e) ? Ng : Zh[e.$$typeof] || O6;
}
var D6 = Object.defineProperty, T6 = Object.getOwnPropertyNames, l0 = Object.getOwnPropertySymbols, N6 = Object.getOwnPropertyDescriptor, P6 = Object.getPrototypeOf, d0 = Object.prototype;
function Pg(e, t, n) {
  if (typeof t != "string") {
    if (d0) {
      var r = P6(t);
      r && r !== d0 && Pg(e, r, n);
    }
    var a = T6(t);
    l0 && (a = a.concat(l0(t)));
    for (var i = c0(e), o = c0(t), s = 0; s < a.length; ++s) {
      var c = a[s];
      if (!E6[c] && !(n && n[c]) && !(o && o[c]) && !(i && i[c])) {
        var l = N6(t, c);
        try {
          D6(e, c, l);
        } catch {
        }
      }
    }
  }
  return e;
}
var L6 = Pg;
const R6 = /* @__PURE__ */ Ll(L6);
function Ln() {
  return (Ln = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
var u0 = function(e, t) {
  for (var n = [e[0]], r = 0, a = t.length; r < a; r += 1)
    n.push(t[r], e[r + 1]);
  return n;
}, su = function(e) {
  return e !== null && typeof e == "object" && (e.toString ? e.toString() : Object.prototype.toString.call(e)) === "[object Object]" && !Ai.typeOf(e);
}, Sc = Object.freeze([]), wr = Object.freeze({});
function ri(e) {
  return typeof e == "function";
}
function cu(e) {
  return process.env.NODE_ENV !== "production" && typeof e == "string" && e || e.displayName || e.name || "Component";
}
function Xh(e) {
  return e && typeof e.styledComponentId == "string";
}
var ai = typeof process < "u" && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", Uh = typeof window < "u" && "HTMLElement" in window, V6 = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"), z6 = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
` } : {};
function B6() {
  for (var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)
    t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
  return t.forEach(function(a) {
    e = e.replace(/%[a-z]/, a);
  }), e;
}
function nr(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  throw process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : "")) : new Error(B6.apply(void 0, [z6[e]].concat(n)).trim());
}
var H6 = function() {
  function e(n) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = n;
  }
  var t = e.prototype;
  return t.indexOfGroup = function(n) {
    for (var r = 0, a = 0; a < n; a++)
      r += this.groupSizes[a];
    return r;
  }, t.insertRules = function(n, r) {
    if (n >= this.groupSizes.length) {
      for (var a = this.groupSizes, i = a.length, o = i; n >= o; )
        (o <<= 1) < 0 && nr(16, "" + n);
      this.groupSizes = new Uint32Array(o), this.groupSizes.set(a), this.length = o;
      for (var s = i; s < o; s++)
        this.groupSizes[s] = 0;
    }
    for (var c = this.indexOfGroup(n + 1), l = 0, u = r.length; l < u; l++)
      this.tag.insertRule(c, r[l]) && (this.groupSizes[n]++, c++);
  }, t.clearGroup = function(n) {
    if (n < this.length) {
      var r = this.groupSizes[n], a = this.indexOfGroup(n), i = a + r;
      this.groupSizes[n] = 0;
      for (var o = a; o < i; o++)
        this.tag.deleteRule(a);
    }
  }, t.getGroup = function(n) {
    var r = "";
    if (n >= this.length || this.groupSizes[n] === 0)
      return r;
    for (var a = this.groupSizes[n], i = this.indexOfGroup(n), o = i + a, s = i; s < o; s++)
      r += this.tag.getRule(s) + `/*!sc*/
`;
    return r;
  }, e;
}(), ec = /* @__PURE__ */ new Map(), Ac = /* @__PURE__ */ new Map(), Ji = 1, Ms = function(e) {
  if (ec.has(e))
    return ec.get(e);
  for (; Ac.has(Ji); )
    Ji++;
  var t = Ji++;
  return process.env.NODE_ENV !== "production" && ((0 | t) < 0 || t > 1 << 30) && nr(16, "" + t), ec.set(e, t), Ac.set(t, e), t;
}, $6 = function(e) {
  return Ac.get(e);
}, j6 = function(e, t) {
  t >= Ji && (Ji = t + 1), ec.set(e, t), Ac.set(t, e);
}, F6 = "style[" + ai + '][data-styled-version="5.3.1"]', W6 = new RegExp("^" + ai + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), q6 = function(e, t, n) {
  for (var r, a = n.split(","), i = 0, o = a.length; i < o; i++)
    (r = a[i]) && e.registerName(t, r);
}, _6 = function(e, t) {
  for (var n = (t.innerHTML || "").split(`/*!sc*/
`), r = [], a = 0, i = n.length; a < i; a++) {
    var o = n[a].trim();
    if (o) {
      var s = o.match(W6);
      if (s) {
        var c = 0 | parseInt(s[1], 10), l = s[2];
        c !== 0 && (j6(l, c), q6(e, l, s[3]), e.getTag().insertRules(c, r)), r.length = 0;
      } else
        r.push(o);
    }
  }
}, G6 = function() {
  return typeof window < "u" && window.__webpack_nonce__ !== void 0 ? window.__webpack_nonce__ : null;
}, Lg = function(e) {
  var t = document.head, n = e || t, r = document.createElement("style"), a = function(s) {
    for (var c = s.childNodes, l = c.length; l >= 0; l--) {
      var u = c[l];
      if (u && u.nodeType === 1 && u.hasAttribute(ai))
        return u;
    }
  }(n), i = a !== void 0 ? a.nextSibling : null;
  r.setAttribute(ai, "active"), r.setAttribute("data-styled-version", "5.3.1");
  var o = G6();
  return o && r.setAttribute("nonce", o), n.insertBefore(r, i), r;
}, Z6 = function() {
  function e(n) {
    var r = this.element = Lg(n);
    r.appendChild(document.createTextNode("")), this.sheet = function(a) {
      if (a.sheet)
        return a.sheet;
      for (var i = document.styleSheets, o = 0, s = i.length; o < s; o++) {
        var c = i[o];
        if (c.ownerNode === a)
          return c;
      }
      nr(17);
    }(r), this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    try {
      return this.sheet.insertRule(r, n), this.length++, !0;
    } catch {
      return !1;
    }
  }, t.deleteRule = function(n) {
    this.sheet.deleteRule(n), this.length--;
  }, t.getRule = function(n) {
    var r = this.sheet.cssRules[n];
    return r !== void 0 && typeof r.cssText == "string" ? r.cssText : "";
  }, e;
}(), X6 = function() {
  function e(n) {
    var r = this.element = Lg(n);
    this.nodes = r.childNodes, this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    if (n <= this.length && n >= 0) {
      var a = document.createTextNode(r), i = this.nodes[n];
      return this.element.insertBefore(a, i || null), this.length++, !0;
    }
    return !1;
  }, t.deleteRule = function(n) {
    this.element.removeChild(this.nodes[n]), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.nodes[n].textContent : "";
  }, e;
}(), U6 = function() {
  function e(n) {
    this.rules = [], this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    return n <= this.length && (this.rules.splice(n, 0, r), this.length++, !0);
  }, t.deleteRule = function(n) {
    this.rules.splice(n, 1), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.rules[n] : "";
  }, e;
}(), h0 = Uh, Y6 = { isServer: !Uh, useCSSOMInjection: !V6 }, Rg = function() {
  function e(n, r, a) {
    n === void 0 && (n = wr), r === void 0 && (r = {}), this.options = Ln({}, Y6, {}, n), this.gs = r, this.names = new Map(a), this.server = !!n.isServer, !this.server && Uh && h0 && (h0 = !1, function(i) {
      for (var o = document.querySelectorAll(F6), s = 0, c = o.length; s < c; s++) {
        var l = o[s];
        l && l.getAttribute(ai) !== "active" && (_6(i, l), l.parentNode && l.parentNode.removeChild(l));
      }
    }(this));
  }
  e.registerId = function(n) {
    return Ms(n);
  };
  var t = e.prototype;
  return t.reconstructWithOptions = function(n, r) {
    return r === void 0 && (r = !0), new e(Ln({}, this.options, {}, n), this.gs, r && this.names || void 0);
  }, t.allocateGSInstance = function(n) {
    return this.gs[n] = (this.gs[n] || 0) + 1;
  }, t.getTag = function() {
    return this.tag || (this.tag = (a = (r = this.options).isServer, i = r.useCSSOMInjection, o = r.target, n = a ? new U6(o) : i ? new Z6(o) : new X6(o), new H6(n)));
    var n, r, a, i, o;
  }, t.hasNameForId = function(n, r) {
    return this.names.has(n) && this.names.get(n).has(r);
  }, t.registerName = function(n, r) {
    if (Ms(n), this.names.has(n))
      this.names.get(n).add(r);
    else {
      var a = /* @__PURE__ */ new Set();
      a.add(r), this.names.set(n, a);
    }
  }, t.insertRules = function(n, r, a) {
    this.registerName(n, r), this.getTag().insertRules(Ms(n), a);
  }, t.clearNames = function(n) {
    this.names.has(n) && this.names.get(n).clear();
  }, t.clearRules = function(n) {
    this.getTag().clearGroup(Ms(n)), this.clearNames(n);
  }, t.clearTag = function() {
    this.tag = void 0;
  }, t.toString = function() {
    return function(n) {
      for (var r = n.getTag(), a = r.length, i = "", o = 0; o < a; o++) {
        var s = $6(o);
        if (s !== void 0) {
          var c = n.names.get(s), l = r.getGroup(o);
          if (c && l && c.size) {
            var u = ai + ".g" + o + '[id="' + s + '"]', h = "";
            c !== void 0 && c.forEach(function(p) {
              p.length > 0 && (h += p + ",");
            }), i += "" + l + u + '{content:"' + h + `"}/*!sc*/
`;
          }
        }
      }
      return i;
    }(this);
  }, e;
}(), J6 = /(a)(d)/gi, p0 = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function lu(e) {
  var t, n = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0)
    n = p0(t % 52) + n;
  return (p0(t % 52) + n).replace(J6, "$1-$2");
}
var Xr = function(e, t) {
  for (var n = t.length; n; )
    e = 33 * e ^ t.charCodeAt(--n);
  return e;
}, Vg = function(e) {
  return Xr(5381, e);
};
function K6(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (ri(n) && !Xh(n))
      return !1;
  }
  return !0;
}
var Q6 = Vg("5.3.1"), ex = function() {
  function e(t, n, r) {
    this.rules = t, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (r === void 0 || r.isStatic) && K6(t), this.componentId = n, this.baseHash = Xr(Q6, n), this.baseStyle = r, Rg.registerId(n);
  }
  return e.prototype.generateAndInjectStyles = function(t, n, r) {
    var a = this.componentId, i = [];
    if (this.baseStyle && i.push(this.baseStyle.generateAndInjectStyles(t, n, r)), this.isStatic && !r.hash)
      if (this.staticRulesId && n.hasNameForId(a, this.staticRulesId))
        i.push(this.staticRulesId);
      else {
        var o = ii(this.rules, t, n, r).join(""), s = lu(Xr(this.baseHash, o) >>> 0);
        if (!n.hasNameForId(a, s)) {
          var c = r(o, "." + s, void 0, a);
          n.insertRules(a, s, c);
        }
        i.push(s), this.staticRulesId = s;
      }
    else {
      for (var l = this.rules.length, u = Xr(this.baseHash, r.hash), h = "", p = 0; p < l; p++) {
        var f = this.rules[p];
        if (typeof f == "string")
          h += f, process.env.NODE_ENV !== "production" && (u = Xr(u, f + p));
        else if (f) {
          var y = ii(f, t, n, r), m = Array.isArray(y) ? y.join("") : y;
          u = Xr(u, m + p), h += m;
        }
      }
      if (h) {
        var v = lu(u >>> 0);
        if (!n.hasNameForId(a, v)) {
          var k = r(h, "." + v, void 0, a);
          n.insertRules(a, v, k);
        }
        i.push(v);
      }
    }
    return i.join(" ");
  }, e;
}(), tx = /^\s*\/\/.*$/gm, nx = [":", "[", ".", "#"];
function rx(e) {
  var t, n, r, a, i = e === void 0 ? wr : e, o = i.options, s = o === void 0 ? wr : o, c = i.plugins, l = c === void 0 ? Sc : c, u = new w6(s), h = [], p = function(m) {
    function v(k) {
      if (k)
        try {
          m(k + "}");
        } catch {
        }
    }
    return function(k, b, x, g, w, M, S, D, A, $) {
      switch (k) {
        case 1:
          if (A === 0 && b.charCodeAt(0) === 64)
            return m(b + ";"), "";
          break;
        case 2:
          if (D === 0)
            return b + "/*|*/";
          break;
        case 3:
          switch (D) {
            case 102:
            case 112:
              return m(x[0] + b), "";
            default:
              return b + ($ === 0 ? "/*|*/" : "");
          }
        case -2:
          b.split("/*|*/}").forEach(v);
      }
    };
  }(function(m) {
    h.push(m);
  }), f = function(m, v, k) {
    return v === 0 && nx.indexOf(k[n.length]) !== -1 || k.match(a) ? m : "." + t;
  };
  function y(m, v, k, b) {
    b === void 0 && (b = "&");
    var x = m.replace(tx, ""), g = v && k ? k + " " + v + " { " + x + " }" : x;
    return t = b, n = v, r = new RegExp("\\" + n + "\\b", "g"), a = new RegExp("(\\" + n + "\\b){2,}"), u(k || !v ? "" : v, g);
  }
  return u.use([].concat(l, [function(m, v, k) {
    m === 2 && k.length && k[0].lastIndexOf(n) > 0 && (k[0] = k[0].replace(r, f));
  }, p, function(m) {
    if (m === -2) {
      var v = h;
      return h = [], v;
    }
  }])), y.hash = l.length ? l.reduce(function(m, v) {
    return v.name || nr(15), Xr(m, v.name);
  }, 5381).toString() : "", y;
}
var zg = V.createContext();
zg.Consumer;
var Bg = V.createContext(), ax = (Bg.Consumer, new Rg()), du = rx();
function ix() {
  return Ct(zg) || ax;
}
function ox() {
  return Ct(Bg) || du;
}
var Hg = function() {
  function e(t, n) {
    var r = this;
    this.inject = function(a, i) {
      i === void 0 && (i = du);
      var o = r.name + i.hash;
      a.hasNameForId(r.id, o) || a.insertRules(r.id, o, i(r.rules, o, "@keyframes"));
    }, this.toString = function() {
      return nr(12, String(r.name));
    }, this.name = t, this.id = "sc-keyframes-" + t, this.rules = n;
  }
  return e.prototype.getName = function(t) {
    return t === void 0 && (t = du), this.name + t.hash;
  }, e;
}(), sx = /([A-Z])/, cx = /([A-Z])/g, lx = /^ms-/, dx = function(e) {
  return "-" + e.toLowerCase();
};
function f0(e) {
  return sx.test(e) ? e.replace(cx, dx).replace(lx, "-ms-") : e;
}
var y0 = function(e) {
  return e == null || e === !1 || e === "";
};
function ii(e, t, n, r) {
  if (Array.isArray(e)) {
    for (var a, i = [], o = 0, s = e.length; o < s; o += 1)
      (a = ii(e[o], t, n, r)) !== "" && (Array.isArray(a) ? i.push.apply(i, a) : i.push(a));
    return i;
  }
  if (y0(e))
    return "";
  if (Xh(e))
    return "." + e.styledComponentId;
  if (ri(e)) {
    if (typeof (l = e) != "function" || l.prototype && l.prototype.isReactComponent || !t)
      return e;
    var c = e(t);
    return process.env.NODE_ENV !== "production" && Ai.isElement(c) && console.warn(cu(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), ii(c, t, n, r);
  }
  var l;
  return e instanceof Hg ? n ? (e.inject(n, r), e.getName(r)) : e : su(e) ? function u(h, p) {
    var f, y, m = [];
    for (var v in h)
      h.hasOwnProperty(v) && !y0(h[v]) && (Array.isArray(h[v]) && h[v].isCss || ri(h[v]) ? m.push(f0(v) + ":", h[v], ";") : su(h[v]) ? m.push.apply(m, u(h[v], v)) : m.push(f0(v) + ": " + (f = v, (y = h[v]) == null || typeof y == "boolean" || y === "" ? "" : typeof y != "number" || y === 0 || f in C6 ? String(y).trim() : y + "px") + ";"));
    return p ? [p + " {"].concat(m, ["}"]) : m;
  }(e) : e.toString();
}
var m0 = function(e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};
function ke(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return ri(e) || su(e) ? m0(ii(u0(Sc, [e].concat(n)))) : n.length === 0 && e.length === 1 && typeof e[0] == "string" ? e : m0(ii(u0(e, n)));
}
var g0 = /invalid hook call/i, ws = /* @__PURE__ */ new Set(), ux = function(e, t) {
  if (process.env.NODE_ENV !== "production") {
    var n = "The component " + e + (t ? ' with the id of "' + t + '"' : "") + ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, r = console.error;
    try {
      var a = !0;
      console.error = function(i) {
        if (g0.test(i))
          a = !1, ws.delete(n);
        else {
          for (var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), c = 1; c < o; c++)
            s[c - 1] = arguments[c];
          r.apply(void 0, [i].concat(s));
        }
      }, he(), a && !ws.has(n) && (console.warn(n), ws.add(n));
    } catch (i) {
      g0.test(i.message) && ws.delete(n);
    } finally {
      console.error = r;
    }
  }
}, hx = function(e, t, n) {
  return n === void 0 && (n = wr), e.theme !== n.theme && e.theme || t || n.theme;
}, px = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, fx = /(^-|-$)/g;
function K1(e) {
  return e.replace(px, "-").replace(fx, "");
}
var $g = function(e) {
  return lu(Vg(e) >>> 0);
};
function Cs(e) {
  return typeof e == "string" && (process.env.NODE_ENV === "production" || e.charAt(0) === e.charAt(0).toLowerCase());
}
var uu = function(e) {
  return typeof e == "function" || typeof e == "object" && e !== null && !Array.isArray(e);
}, yx = function(e) {
  return e !== "__proto__" && e !== "constructor" && e !== "prototype";
};
function mx(e, t, n) {
  var r = e[n];
  uu(t) && uu(r) ? jg(r, t) : e[n] = t;
}
function jg(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  for (var a = 0, i = n; a < i.length; a++) {
    var o = i[a];
    if (uu(o))
      for (var s in o)
        yx(s) && mx(e, o[s], s);
  }
  return e;
}
var Oc = V.createContext();
Oc.Consumer;
function M4e(e) {
  var t = Ct(Oc), n = wt(function() {
    return function(r, a) {
      if (!r)
        return nr(14);
      if (ri(r)) {
        var i = r(a);
        return process.env.NODE_ENV === "production" || i !== null && !Array.isArray(i) && typeof i == "object" ? i : nr(7);
      }
      return Array.isArray(r) || typeof r != "object" ? nr(8) : a ? Ln({}, a, {}, r) : r;
    }(e.theme, t);
  }, [e.theme, t]);
  return e.children ? V.createElement(Oc.Provider, { value: n }, e.children) : null;
}
var Q1 = {};
function Fg(e, t, n) {
  var r = Xh(e), a = !Cs(e), i = t.attrs, o = i === void 0 ? Sc : i, s = t.componentId, c = s === void 0 ? function(b, x) {
    var g = typeof b != "string" ? "sc" : K1(b);
    Q1[g] = (Q1[g] || 0) + 1;
    var w = g + "-" + $g("5.3.1" + g + Q1[g]);
    return x ? x + "-" + w : w;
  }(t.displayName, t.parentComponentId) : s, l = t.displayName, u = l === void 0 ? function(b) {
    return Cs(b) ? "styled." + b : "Styled(" + cu(b) + ")";
  }(e) : l, h = t.displayName && t.componentId ? K1(t.displayName) + "-" + t.componentId : t.componentId || c, p = r && e.attrs ? Array.prototype.concat(e.attrs, o).filter(Boolean) : o, f = t.shouldForwardProp;
  r && e.shouldForwardProp && (f = t.shouldForwardProp ? function(b, x, g) {
    return e.shouldForwardProp(b, x, g) && t.shouldForwardProp(b, x, g);
  } : e.shouldForwardProp);
  var y, m = new ex(n, h, r ? e.componentStyle : void 0), v = m.isStatic && o.length === 0, k = function(b, x) {
    return function(g, w, M, S) {
      var D = g.attrs, A = g.componentStyle, $ = g.defaultProps, F = g.foldedComponentIds, Z = g.shouldForwardProp, B = g.styledComponentId, O = g.target;
      process.env.NODE_ENV !== "production" && U2(B);
      var I = function(X, P, Q) {
        X === void 0 && (X = wr);
        var U = Ln({}, P, { theme: X }), ae = {};
        return Q.forEach(function(ee) {
          var de, Y, re, te = ee;
          for (de in ri(te) && (te = te(U)), te)
            U[de] = ae[de] = de === "className" ? (Y = ae[de], re = te[de], Y && re ? Y + " " + re : Y || re) : te[de];
        }), [U, ae];
      }(hx(w, Ct(Oc), $) || wr, w, D), N = I[0], R = I[1], L = function(X, P, Q, U) {
        var ae = ix(), ee = ox(), de = P ? X.generateAndInjectStyles(wr, ae, ee) : X.generateAndInjectStyles(Q, ae, ee);
        return process.env.NODE_ENV !== "production" && U2(de), process.env.NODE_ENV !== "production" && !P && U && U(de), de;
      }(A, S, N, process.env.NODE_ENV !== "production" ? g.warnTooManyClasses : void 0), W = M, E = R.$as || w.$as || R.as || w.as || O, q = Cs(E), z = R !== w ? Ln({}, w, {}, R) : w, H = {};
      for (var _ in z)
        _[0] !== "$" && _ !== "as" && (_ === "forwardedAs" ? H.as = z[_] : (Z ? Z(_, s0, E) : !q || s0(_)) && (H[_] = z[_]));
      return w.style && R.style !== w.style && (H.style = Ln({}, w.style, {}, R.style)), H.className = Array.prototype.concat(F, B, L !== B ? L : null, w.className, R.className).filter(Boolean).join(" "), H.ref = W, le(E, H);
    }(y, b, x, v);
  };
  return k.displayName = u, (y = V.forwardRef(k)).attrs = p, y.componentStyle = m, y.displayName = u, y.shouldForwardProp = f, y.foldedComponentIds = r ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : Sc, y.styledComponentId = h, y.target = r ? e.target : e, y.withComponent = function(b) {
    var x = t.componentId, g = function(M, S) {
      if (M == null)
        return {};
      var D, A, $ = {}, F = Object.keys(M);
      for (A = 0; A < F.length; A++)
        D = F[A], S.indexOf(D) >= 0 || ($[D] = M[D]);
      return $;
    }(t, ["componentId"]), w = x && x + "-" + (Cs(b) ? b : K1(cu(b)));
    return Fg(b, Ln({}, g, { attrs: p, componentId: w }), n);
  }, Object.defineProperty(y, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(b) {
    this._foldedDefaultProps = r ? jg({}, e.defaultProps, b) : b;
  } }), process.env.NODE_ENV !== "production" && (ux(u, h), y.warnTooManyClasses = function(b, x) {
    var g = {}, w = !1;
    return function(M) {
      if (!w && (g[M] = !0, Object.keys(g).length >= 200)) {
        var S = x ? ' with the id of "' + x + '"' : "";
        console.warn("Over 200 classes were generated for component " + b + S + `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), w = !0, g = {};
      }
    };
  }(u, h)), y.toString = function() {
    return "." + y.styledComponentId;
  }, a && R6(y, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0, withComponent: !0 }), y;
}
var hu = function(e) {
  return function t(n, r, a) {
    if (a === void 0 && (a = wr), !Ai.isValidElementType(r))
      return nr(1, String(r));
    var i = function() {
      return n(r, a, ke.apply(void 0, arguments));
    };
    return i.withConfig = function(o) {
      return t(n, r, Ln({}, a, {}, o));
    }, i.attrs = function(o) {
      return t(n, r, Ln({}, a, { attrs: Array.prototype.concat(a.attrs, o).filter(Boolean) }));
    }, i;
  }(Fg, e);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e) {
  hu[e] = hu(e);
});
function Pr(e) {
  process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var a = ke.apply(void 0, [e].concat(n)).join(""), i = $g(a);
  return new Hg(i, a);
}
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window["__styled-components-init__"] += 1);
const G = hu, gx = (e, t) => {
  switch (e) {
    case "entering":
      return ke`
        height: ${t}px;
        overflow: hidden;
      `;
    case "entered":
      return ke`
        height: ${t}px;
        overflow: visible;
      `;
    case "exiting":
      return ke`
        height: 0px;
        overflow: hidden;
      `;
    case "exited":
      return ke`
        height: 0px;
        visibility: hidden;
        overflow: hidden;
      `;
  }
}, vx = G.div`
  min-height: 0px;
  transition-duration: ${({ $duration: e }) => `${e}ms`};
  transition: ${({ $duration: e }) => `height ${e}ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`};
  ${({ $height: e, $transitionState: t }) => gx(t, e)}
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`, kx = G.div`
  display: flex;
`, bx = G.div`
  width: 100%;
`, xx = Ae(
  ({ show: e, children: t, duration: n = M6, ...r }, a) => {
    var u;
    const i = he(null), o = he(null), [s, c] = fe(0), l = _h(i, a);
    return be(() => {
      o.current && c(o.current.clientHeight);
    }, [(u = o.current) == null ? void 0 : u.clientHeight, t]), /* @__PURE__ */ C(Wh, { nodeRef: i, in: e, timeout: n, ...r, children: (h) => /* @__PURE__ */ C(vx, { ref: l, $height: s, $transitionState: h, $duration: n, children: /* @__PURE__ */ C(kx, { ref: o, "aria-hidden": !e, children: /* @__PURE__ */ C(bx, { children: t }) }) }) });
  }
), Wg = () => {
  var e, t;
  return ((t = (e = window == null ? void 0 : window.matchMedia) == null ? void 0 : e.call(window, "(prefers-reduced-motion: reduce)")) == null ? void 0 : t.matches) || !1;
}, v0 = typeof window < "u" ? navigator.platform.toUpperCase().indexOf("MAC") >= 0 : !1, Mx = 300, wx = (e = 1) => ({
  entering: { opacity: e },
  entered: { opacity: e },
  exiting: { opacity: 0 },
  exited: { opacity: 0, visibility: "hidden" }
}), w4e = ({ show: e, children: t, duration: n = Mx, initialOpacity: r = 1, ...a }) => {
  const i = he(null), o = _h(i, t == null ? void 0 : t.ref), s = {
    transition: Wg() ? "none" : `opacity ${n}ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
    opacity: 0
  };
  return /* @__PURE__ */ C(Wh, { nodeRef: i, in: e, timeout: n, ...a, children: (c) => {
    const l = wx(r);
    return V.cloneElement(t, {
      ...t.props,
      style: {
        ...s,
        ...typeof t.props.style == "object" && t.props.style,
        ...l[c]
      },
      ref: o,
      "aria-hidden": !e
    });
  } });
}, Cx = 300, Sx = (e = "left", t = 200) => {
  let n = "";
  switch (e) {
    case "up":
      n = `translateY(-${t}%)`;
      break;
    case "down":
      n = `translateY(${t}%)`;
      break;
    case "right":
      n = `translateX(${t}%)`;
      break;
    case "left":
    default:
      n = `translateX(-${t}%)`;
      break;
  }
  return {
    entering: { transform: "none" },
    entered: { transform: "none" },
    exiting: { transform: n },
    exited: { transform: n, visibility: "hidden" }
  };
}, C4e = ({
  show: e,
  children: t,
  duration: n = Cx,
  direction: r = "left",
  movePercentage: a = 200,
  ...i
}) => {
  const o = he(null), s = _h(o, t == null ? void 0 : t.ref), c = {
    transition: Wg() ? "none" : `transform ${n}ms cubic-bezier(0, 0, 0.2, 1) 0ms`
  };
  return /* @__PURE__ */ C(Wh, { nodeRef: o, in: e, timeout: n, ...i, children: (l) => V.cloneElement(t, {
    ...t.props,
    style: {
      ...c,
      ...typeof t.props.styles == "object" && t.props.styles,
      ...Sx(r, a)[l]
    },
    ref: s,
    "aria-hidden": !e
  }) });
};
var Yh = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.sanitizeUrl = e.BLANK_URL = void 0;
  var t = /^([^\w]*)(javascript|data|vbscript)/im, n = /&#(\w+)(^\w|;)?/g, r = /&(newline|tab);/gi, a = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim, i = /^.+(:|&colon;)/gim, o = [".", "/"];
  e.BLANK_URL = "about:blank";
  function s(u) {
    return o.indexOf(u[0]) > -1;
  }
  function c(u) {
    var h = u.replace(a, "");
    return h.replace(n, function(p, f) {
      return String.fromCharCode(f);
    });
  }
  function l(u) {
    if (!u)
      return e.BLANK_URL;
    var h = c(u).replace(r, "").replace(a, "").trim();
    if (!h)
      return e.BLANK_URL;
    if (s(h))
      return h;
    var p = h.match(i);
    if (!p)
      return h;
    var f = p[0];
    return t.test(f) ? e.BLANK_URL : h;
  }
  e.sanitizeUrl = l;
})(Yh);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Te = function() {
  return Te = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Te.apply(this, arguments);
};
function Le(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function Oi(e, t, n) {
  return n = {
    path: t,
    exports: {},
    require: function(r, a) {
      return Ax(r, a ?? n.path);
    }
  }, e(n, n.exports), n.exports;
}
function Ax() {
  throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var Ne = Oi(function(e) {
  /*!
    Copyright (c) 2018 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = [], a = 0; a < arguments.length; a++) {
        var i = arguments[a];
        if (i) {
          var o = typeof i;
          if (o === "string" || o === "number")
            r.push(i);
          else if (Array.isArray(i)) {
            if (i.length) {
              var s = n.apply(null, i);
              s && r.push(s);
            }
          } else if (o === "object")
            if (i.toString === Object.prototype.toString)
              for (var c in i)
                t.call(i, c) && i[c] && r.push(c);
            else
              r.push(i.toString());
        }
      }
      return r.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
}), ot = function(e) {
  var t, n = e.name, r = e.size, a = r === void 0 ? "md" : r, i = e.weight, o = i === void 0 ? "regular" : i, s = e.className, c = Le(e, ["name", "size", "weight", "className"]), l = Ne("dl-icon", (t = {}, t["dli-" + n + (o ? "-" + o : "")] = !!n, t["dl-icon-" + a] = a, t), s);
  return V.createElement("i", Te({ className: l }, c));
}, Ox = Ae(function(e, t) {
  var n, r, a = e.imgSrc, i = e.imgAlt, o = e.size, s = o === void 0 ? "md" : o, c = e.hasBadge, l = c === void 0 ? !1 : c, u = e.badgeStatus, h = e.isInverse, p = h === void 0 ? !1 : h, f = e.className, y = Le(e, ["imgSrc", "imgAlt", "size", "hasBadge", "badgeStatus", "isInverse", "className"]), m = Ne("dl-avatar", (n = {}, n["dl-avatar-" + s] = s, n["dl-avatar-inverse"] = p, n), f), v = Ne("dl-avatar-badge", (r = {}, r["dl-avatar-badge-" + s] = s, r), f);
  return V.createElement(
    "div",
    Te({ className: m, ref: t }, y),
    a ? V.createElement("img", { src: a, alt: i, className: "dl-avatar-image", "aria-hidden": "true", role: "img" }) : V.createElement(ot, { name: "user", size: s === "lg" ? "lg" : "sm", weight: "bold", role: "img", "aria-hidden": "true" }),
    l && s !== "lg" && V.createElement("i", { className: v, "aria-hidden": "false", "aria-label": u, title: u })
  );
});
Ox.displayName = "Avatar";
var lr = V.forwardRef(function(e, t) {
  var n, r = e.children, a = e.variant, i = e.size, o = e.className, s = e.href, c = e.isActive, l = e.isBlock, u = e.isLoading, h = e.hasIcon, p = e.iconName, f = e.iconWeight, y = e.isIconOnly, m = e.onClick, v = e.onFocus, k = e.onBlur, b = e.disabled, x = Le(e, ["children", "variant", "size", "className", "href", "isActive", "isBlock", "isLoading", "hasIcon", "iconName", "iconWeight", "isIconOnly", "onClick", "onFocus", "onBlur", "disabled"]), g = Ne("dl-btn", (n = {}, n["dl-btn-" + a] = a, n.active = c, n["dl-btn-" + i] = i, n["dl-disabled"] = s && b, n["dl-btn-block"] = l, n["dl-btn-loading"] = u, n["dl-btn-with-icon-" + h] = h, n["dl-btn-icon-only"] = y, n), o), w = V.createElement(ot, { name: p || "", size: i === "sm" || i === "xs" ? "sm" : "md", weight: f });
  return V.createElement(ua, null, s ? V.createElement(
    "a",
    Te({ className: g, href: Yh.sanitizeUrl(s), role: "button", rel: x.target === "_blank" ? "noopener noreferrer" : void 0 }, x),
    h === "left" && w,
    r
  ) : V.createElement(
    "button",
    Te({ className: g, disabled: b, onClick: m, onFocus: v, onBlur: k, ref: t }, x),
    V.createElement("span", { className: "dl-btn-content-text" }, u ? V.createElement(
      "div",
      { className: "dl-btn-content-loading" },
      V.createElement(
        "svg",
        { version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: i === "lg" ? "32px" : "24px", height: i === "lg" ? "32px" : "24px", viewBox: "0 0 50 50", xmlSpace: "preserve" },
        V.createElement(
          "path",
          { fill: "currentColor", d: "M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z" },
          V.createElement("animateTransform", { attributeType: "xml", attributeName: "transform", type: "rotate", from: "0 25 25", to: "360 25 25", dur: "0.6s", repeatCount: "indefinite" })
        )
      ),
      V.createElement("span", null, h === "left" && w),
      V.createElement("span", null, r)
    ) : V.createElement(
      V.Fragment,
      null,
      h === "left" && w,
      y ? w : r
    ))
  ));
});
lr.displayName = "Button";
lr.defaultProps = {
  variant: "primary",
  size: "md",
  type: "button",
  isActive: !1,
  isBlock: !1,
  isIconOnly: !1
};
var Ex = function(e) {
  var t = e.className, n = e.children, r = Le(e, ["className", "children"]), a = Ne("dl-card-product-header", t);
  return V.createElement("div", Te({ className: a }, r), n);
}, Ix = function(e) {
  var t = e.className, n = e.children, r = Le(e, ["className", "children"]), a = Ne("dl-card-product-body", t);
  return V.createElement("div", Te({ className: a }, r), n);
}, Dx = function(e) {
  var t = e.className, n = e.children, r = Le(e, ["className", "children"]), a = Ne("dl-card-product-body-top", t);
  return V.createElement("div", Te({ className: a }, r), n);
}, Tx = function(e) {
  var t = e.className, n = e.children, r = Le(e, ["className", "children"]), a = Ne("dl-card-product-body-bottom", t);
  return V.createElement("div", Te({ className: a }, r), n);
}, Vl = function(e) {
  var t = e.src, n = e.alt, r = e.isResponsive, a = e.className, i = Le(e, ["src", "alt", "isResponsive", "className"]), o = Ne({ "img-fluid": r }, a);
  return V.createElement("img", Te({ className: o, src: t, alt: n }, i));
};
Vl.defaultProps = {
  isResponsive: !1
};
var Nx = function(e) {
  var t = e.src, n = e.name, r = e.className, a = e.hasActions, i = a === void 0 ? !1 : a, o = e.mixBlendMode, s = o === void 0 ? !0 : o, c = Le(e, ["src", "name", "className", "hasActions", "mixBlendMode"]), l = Ne("dl-card-product-header-img", {
    "dl-card-product-header-img-has-actions": i,
    "dl-card-product-header-img-blend-mode": s
  }, r);
  return V.createElement(Vl, Te({ className: l, src: t, alt: n, isResponsive: !0 }, c));
}, qo = function(e) {
  var t, n = e.children, r = e.as, a = e.size, i = e.className, o = Le(e, ["children", "as", "size", "className"]), s = Ne("dl-text", (t = {}, t["dl-text-" + a] = a, t), i), c = {
    className: s
  }, l = "p";
  return r && (l = r), V.createElement(l, Te(Te({}, c), o), n);
};
qo.defaultProps = {
  as: "p",
  size: "paragraph"
};
var Px = function(e) {
  var t = e.title, n = e.className, r = Le(e, ["title", "className"]), a = Ne("dl-card-product-title", n);
  return V.createElement(qo, Te({ className: a }, r), t);
}, Lx = function(e) {
  var t = e.description, n = e.className, r = Le(e, ["description", "className"]), a = Ne("dl-card-product-description", n);
  return V.createElement(qo, Te({ className: a }, r), t);
}, Rx = function(e) {
  var t = e.className, n = e.children, r = Le(e, ["className", "children"]), a = Ne("dl-card-product-amounts", t);
  return V.createElement("div", Te({ className: a }, r), n);
}, Vx = function(e) {
  var t = e.className, n = e.children, r = Le(e, ["className", "children"]), a = Ne("dl-card-product-discount-price", t);
  return V.createElement(qo, Te({ className: a, size: "caption" }, r), n);
}, zx = function(e) {
  var t = e.className, n = e.children, r = e.hasDiscount, a = Le(e, ["className", "children", "hasDiscount"]), i = Ne("dl-card-product-final-price", {
    "dl-card-product-final-price-has-discount": r
  }, t);
  return V.createElement(qo, Te({ className: i }, a), n);
}, Bx = function(e) {
  var t = e.className, n = e.children, r = Le(e, ["className", "children"]), a = Ne("dl-card-product-actions", t);
  return V.createElement("div", Te({ className: a }, r), n);
}, Hx = function(e) {
  var t, n = e.className, r = e.position, a = r === void 0 ? "left" : r, i = Le(e, ["className", "position"]), o = Ne("dl-card-product-menu", (t = {}, t["dl-card-product-menu-" + a] = a, t), n);
  return V.createElement("div", Te({ className: o }, i));
}, $x = function(e) {
  var t = e.className, n = Le(e, ["className"]), r = Ne("dl-card-product-tags", t);
  return V.createElement("div", Te({ className: r }, n));
}, qt = Ae(function(e, t) {
  var n, r = e.hasStock, a = r === void 0 ? !0 : r, i = e.horizontalResponsive, o = i === void 0 ? !1 : i, s = e.isActive, c = s === void 0 ? !1 : s, l = e.kind, u = l === void 0 ? "default" : l, h = e.backgroundColor, p = e.border, f = e.borderColor, y = e.borderStyle, m = e.borderWidth, v = e.width, k = e.className, b = e.children, x = Le(e, ["hasStock", "horizontalResponsive", "isActive", "kind", "backgroundColor", "border", "borderColor", "borderStyle", "borderWidth", "width", "className", "children"]), g = Ne("dl-card-product", (n = {}, n["dl-card-product-" + u] = u, n["dl-card-product-no-stock"] = !a, n["dl-card-product-horizontal-responsive"] = o, n["dl-card-product-active"] = c, n), k), w = {
    backgroundColor: h,
    border: p,
    borderColor: f,
    borderStyle: y,
    borderWidth: m,
    width: v
  };
  return V.createElement("article", Te({ className: g, style: w, ref: t }, x), b);
});
qt.displayName = "CardProduct";
qt.Header = Ex;
qt.Body = Ix;
qt.BodyTop = Dx;
qt.BodyBottom = Tx;
qt.Image = Nx;
qt.Title = Px;
qt.Description = Lx;
qt.Amounts = Rx;
qt.DiscountPrice = Vx;
qt.FinalPrice = zx;
qt.Actions = Bx;
qt.Menu = Hx;
qt.Tags = $x;
var zl = V.createContext({}), qg = V.forwardRef(function(e, t) {
  var n, r, a = e.id, i = e.name, o = e.type, s = e.size, c = e.label, l = e.value, u = e.className, h = e.inline, p = e.checked, f = e.disabled, y = e.onClick, m = e.onChange, v = e.children, k = Le(e, ["id", "name", "type", "size", "label", "value", "className", "inline", "checked", "disabled", "onClick", "onChange", "children"]), b = Ct(zl).controlId, x = Ne("dl-custom-control", (n = {}, n["dl-custom-" + o] = o, n["dl-custom-control-inline"] = h, n), u), g = Ne("dl-custom-control-label", (r = {}, r["dl-custom-control-label-" + s] = s, r["dl-custom-control-label-" + o] = c || v, r));
  return V.createElement(
    "div",
    { className: x },
    V.createElement("input", Te({
      id: b || a,
      name: b || i,
      type: o === "radio" ? "radio" : "checkbox",
      className: "dl-custom-control-input",
      disabled: f,
      value: l,
      checked: p,
      // onChange={(e) => onChange && onChange(e)}
      onChange: m,
      onClick: y,
      ref: t
    }, k)),
    V.createElement(
      "label",
      { className: g, htmlFor: b || a },
      V.createElement(
        "span",
        null,
        " ",
        c || v
      )
    )
  );
});
qg.displayName = "Check";
qg.defaultProps = {
  type: "checkbox",
  inline: !1,
  disabled: !1
};
function Bi(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function st() {
  return st = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, st.apply(this, arguments);
}
function k0(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function pu(e, t) {
  return pu = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, pu(e, t);
}
function jx(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, pu(e, t);
}
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ut = typeof Symbol == "function" && Symbol.for, Jh = ut ? Symbol.for("react.element") : 60103, Kh = ut ? Symbol.for("react.portal") : 60106, Bl = ut ? Symbol.for("react.fragment") : 60107, Hl = ut ? Symbol.for("react.strict_mode") : 60108, $l = ut ? Symbol.for("react.profiler") : 60114, jl = ut ? Symbol.for("react.provider") : 60109, Fl = ut ? Symbol.for("react.context") : 60110, Qh = ut ? Symbol.for("react.async_mode") : 60111, Wl = ut ? Symbol.for("react.concurrent_mode") : 60111, ql = ut ? Symbol.for("react.forward_ref") : 60112, _l = ut ? Symbol.for("react.suspense") : 60113, Fx = ut ? Symbol.for("react.suspense_list") : 60120, Gl = ut ? Symbol.for("react.memo") : 60115, Zl = ut ? Symbol.for("react.lazy") : 60116, Wx = ut ? Symbol.for("react.block") : 60121, qx = ut ? Symbol.for("react.fundamental") : 60117, _x = ut ? Symbol.for("react.responder") : 60118, Gx = ut ? Symbol.for("react.scope") : 60119;
function tn(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case Jh:
        switch (e = e.type, e) {
          case Qh:
          case Wl:
          case Bl:
          case $l:
          case Hl:
          case _l:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case Fl:
              case ql:
              case Zl:
              case Gl:
              case jl:
                return e;
              default:
                return t;
            }
        }
      case Kh:
        return t;
    }
  }
}
function _g(e) {
  return tn(e) === Wl;
}
var Zx = Qh, Xx = Wl, Ux = Fl, Yx = jl, Jx = Jh, Kx = ql, Qx = Bl, eM = Zl, tM = Gl, nM = Kh, rM = $l, aM = Hl, iM = _l, oM = function(e) {
  return _g(e) || tn(e) === Qh;
}, sM = _g, cM = function(e) {
  return tn(e) === Fl;
}, lM = function(e) {
  return tn(e) === jl;
}, dM = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === Jh;
}, uM = function(e) {
  return tn(e) === ql;
}, hM = function(e) {
  return tn(e) === Bl;
}, pM = function(e) {
  return tn(e) === Zl;
}, fM = function(e) {
  return tn(e) === Gl;
}, yM = function(e) {
  return tn(e) === Kh;
}, mM = function(e) {
  return tn(e) === $l;
}, gM = function(e) {
  return tn(e) === Hl;
}, vM = function(e) {
  return tn(e) === _l;
}, kM = function(e) {
  return typeof e == "string" || typeof e == "function" || e === Bl || e === Wl || e === $l || e === Hl || e === _l || e === Fx || typeof e == "object" && e !== null && (e.$$typeof === Zl || e.$$typeof === Gl || e.$$typeof === jl || e.$$typeof === Fl || e.$$typeof === ql || e.$$typeof === qx || e.$$typeof === _x || e.$$typeof === Gx || e.$$typeof === Wx);
}, bM = tn, xM = {
  AsyncMode: Zx,
  ConcurrentMode: Xx,
  ContextConsumer: Ux,
  ContextProvider: Yx,
  Element: Jx,
  ForwardRef: Kx,
  Fragment: Qx,
  Lazy: eM,
  Memo: tM,
  Portal: nM,
  Profiler: rM,
  StrictMode: aM,
  Suspense: iM,
  isAsyncMode: oM,
  isConcurrentMode: sM,
  isContextConsumer: cM,
  isContextProvider: lM,
  isElement: dM,
  isForwardRef: uM,
  isFragment: hM,
  isLazy: pM,
  isMemo: fM,
  isPortal: yM,
  isProfiler: mM,
  isStrictMode: gM,
  isSuspense: vM,
  isValidElementType: kM,
  typeOf: bM
}, MM = Oi(function(e, t) {
  process.env.NODE_ENV !== "production" && function() {
    var n = typeof Symbol == "function" && Symbol.for, r = n ? Symbol.for("react.element") : 60103, a = n ? Symbol.for("react.portal") : 60106, i = n ? Symbol.for("react.fragment") : 60107, o = n ? Symbol.for("react.strict_mode") : 60108, s = n ? Symbol.for("react.profiler") : 60114, c = n ? Symbol.for("react.provider") : 60109, l = n ? Symbol.for("react.context") : 60110, u = n ? Symbol.for("react.async_mode") : 60111, h = n ? Symbol.for("react.concurrent_mode") : 60111, p = n ? Symbol.for("react.forward_ref") : 60112, f = n ? Symbol.for("react.suspense") : 60113, y = n ? Symbol.for("react.suspense_list") : 60120, m = n ? Symbol.for("react.memo") : 60115, v = n ? Symbol.for("react.lazy") : 60116, k = n ? Symbol.for("react.block") : 60121, b = n ? Symbol.for("react.fundamental") : 60117, x = n ? Symbol.for("react.responder") : 60118, g = n ? Symbol.for("react.scope") : 60119;
    function w(te) {
      return typeof te == "string" || typeof te == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      te === i || te === h || te === s || te === o || te === f || te === y || typeof te == "object" && te !== null && (te.$$typeof === v || te.$$typeof === m || te.$$typeof === c || te.$$typeof === l || te.$$typeof === p || te.$$typeof === b || te.$$typeof === x || te.$$typeof === g || te.$$typeof === k);
    }
    function M(te) {
      if (typeof te == "object" && te !== null) {
        var me = te.$$typeof;
        switch (me) {
          case r:
            var Pe = te.type;
            switch (Pe) {
              case u:
              case h:
              case i:
              case s:
              case o:
              case f:
                return Pe;
              default:
                var Se = Pe && Pe.$$typeof;
                switch (Se) {
                  case l:
                  case p:
                  case v:
                  case m:
                  case c:
                    return Se;
                  default:
                    return me;
                }
            }
          case a:
            return me;
        }
      }
    }
    var S = u, D = h, A = l, $ = c, F = r, Z = p, B = i, O = v, I = m, N = a, R = s, L = o, W = f, E = !1;
    function q(te) {
      return E || (E = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), z(te) || M(te) === u;
    }
    function z(te) {
      return M(te) === h;
    }
    function H(te) {
      return M(te) === l;
    }
    function _(te) {
      return M(te) === c;
    }
    function X(te) {
      return typeof te == "object" && te !== null && te.$$typeof === r;
    }
    function P(te) {
      return M(te) === p;
    }
    function Q(te) {
      return M(te) === i;
    }
    function U(te) {
      return M(te) === v;
    }
    function ae(te) {
      return M(te) === m;
    }
    function ee(te) {
      return M(te) === a;
    }
    function de(te) {
      return M(te) === s;
    }
    function Y(te) {
      return M(te) === o;
    }
    function re(te) {
      return M(te) === f;
    }
    t.AsyncMode = S, t.ConcurrentMode = D, t.ContextConsumer = A, t.ContextProvider = $, t.Element = F, t.ForwardRef = Z, t.Fragment = B, t.Lazy = O, t.Memo = I, t.Portal = N, t.Profiler = R, t.StrictMode = L, t.Suspense = W, t.isAsyncMode = q, t.isConcurrentMode = z, t.isContextConsumer = H, t.isContextProvider = _, t.isElement = X, t.isForwardRef = P, t.isFragment = Q, t.isLazy = U, t.isMemo = ae, t.isPortal = ee, t.isProfiler = de, t.isStrictMode = Y, t.isSuspense = re, t.isValidElementType = w, t.typeOf = M;
  }();
}), Gg = Oi(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = xM : e.exports = MM;
});
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var b0 = Object.getOwnPropertySymbols, wM = Object.prototype.hasOwnProperty, CM = Object.prototype.propertyIsEnumerable;
function SM(e) {
  if (e == null)
    throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}
function AM() {
  try {
    if (!Object.assign)
      return !1;
    var e = new String("abc");
    if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5")
      return !1;
    for (var t = {}, n = 0; n < 10; n++)
      t["_" + String.fromCharCode(n)] = n;
    var r = Object.getOwnPropertyNames(t).map(function(i) {
      return t[i];
    });
    if (r.join("") !== "0123456789")
      return !1;
    var a = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(i) {
      a[i] = i;
    }), Object.keys(Object.assign({}, a)).join("") === "abcdefghijklmnopqrst";
  } catch {
    return !1;
  }
}
var OM = AM() ? Object.assign : function(e, t) {
  for (var n, r = SM(e), a, i = 1; i < arguments.length; i++) {
    n = Object(arguments[i]);
    for (var o in n)
      wM.call(n, o) && (r[o] = n[o]);
    if (b0) {
      a = b0(n);
      for (var s = 0; s < a.length; s++)
        CM.call(n, a[s]) && (r[a[s]] = n[a[s]]);
    }
  }
  return r;
}, EM = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", IM = EM, DM = Function.call.bind(Object.prototype.hasOwnProperty), yr = IM, tc = DM, fu = function() {
};
if (process.env.NODE_ENV !== "production") {
  var TM = yr, yu = {}, NM = tc;
  fu = function(e) {
    var t = "Warning: " + e;
    typeof console < "u" && console.error(t);
    try {
      throw new Error(t);
    } catch {
    }
  };
}
function Zg(e, t, n, r, a) {
  if (process.env.NODE_ENV !== "production") {
    for (var i in e)
      if (NM(e, i)) {
        var o;
        try {
          if (typeof e[i] != "function") {
            var s = Error(
              (r || "React class") + ": " + n + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[i] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
            );
            throw s.name = "Invariant Violation", s;
          }
          o = e[i](t, i, r, n, null, TM);
        } catch (l) {
          o = l;
        }
        if (o && !(o instanceof Error) && fu(
          (r || "React class") + ": type specification of " + n + " `" + i + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof o + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
        ), o instanceof Error && !(o.message in yu)) {
          yu[o.message] = !0;
          var c = a ? a() : "";
          fu(
            "Failed " + n + " type: " + o.message + (c ?? "")
          );
        }
      }
  }
}
Zg.resetWarningCache = function() {
  process.env.NODE_ENV !== "production" && (yu = {});
};
var PM = Zg, x0 = PM, Ha = function() {
};
process.env.NODE_ENV !== "production" && (Ha = function(e) {
  var t = "Warning: " + e;
  typeof console < "u" && console.error(t);
  try {
    throw new Error(t);
  } catch {
  }
});
function Ss() {
  return null;
}
var LM = function(e, t) {
  var n = typeof Symbol == "function" && Symbol.iterator, r = "@@iterator";
  function a(B) {
    var O = B && (n && B[n] || B[r]);
    if (typeof O == "function")
      return O;
  }
  var i = "<<anonymous>>", o = {
    array: u("array"),
    bigint: u("bigint"),
    bool: u("boolean"),
    func: u("function"),
    number: u("number"),
    object: u("object"),
    string: u("string"),
    symbol: u("symbol"),
    any: h(),
    arrayOf: p,
    element: f(),
    elementType: y(),
    instanceOf: m,
    node: x(),
    objectOf: k,
    oneOf: v,
    oneOfType: b,
    shape: w,
    exact: M
  };
  function s(B, O) {
    return B === O ? B !== 0 || 1 / B === 1 / O : B !== B && O !== O;
  }
  function c(B, O) {
    this.message = B, this.data = O && typeof O == "object" ? O : {}, this.stack = "";
  }
  c.prototype = Error.prototype;
  function l(B) {
    if (process.env.NODE_ENV !== "production")
      var O = {}, I = 0;
    function N(L, W, E, q, z, H, _) {
      if (q = q || i, H = H || E, _ !== yr) {
        if (t) {
          var X = new Error(
            "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
          );
          throw X.name = "Invariant Violation", X;
        } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
          var P = q + ":" + E;
          !O[P] && // Avoid spamming the console because they are often not actionable except for lib authors
          I < 3 && (Ha(
            "You are manually calling a React.PropTypes validation function for the `" + H + "` prop on `" + q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
          ), O[P] = !0, I++);
        }
      }
      return W[E] == null ? L ? W[E] === null ? new c("The " + z + " `" + H + "` is marked as required " + ("in `" + q + "`, but its value is `null`.")) : new c("The " + z + " `" + H + "` is marked as required in " + ("`" + q + "`, but its value is `undefined`.")) : null : B(W, E, q, z, H);
    }
    var R = N.bind(null, !1);
    return R.isRequired = N.bind(null, !0), R;
  }
  function u(B) {
    function O(I, N, R, L, W, E) {
      var q = I[N], z = A(q);
      if (z !== B) {
        var H = $(q);
        return new c(
          "Invalid " + L + " `" + W + "` of type " + ("`" + H + "` supplied to `" + R + "`, expected ") + ("`" + B + "`."),
          { expectedType: B }
        );
      }
      return null;
    }
    return l(O);
  }
  function h() {
    return l(Ss);
  }
  function p(B) {
    function O(I, N, R, L, W) {
      if (typeof B != "function")
        return new c("Property `" + W + "` of component `" + R + "` has invalid PropType notation inside arrayOf.");
      var E = I[N];
      if (!Array.isArray(E)) {
        var q = A(E);
        return new c("Invalid " + L + " `" + W + "` of type " + ("`" + q + "` supplied to `" + R + "`, expected an array."));
      }
      for (var z = 0; z < E.length; z++) {
        var H = B(E, z, R, L, W + "[" + z + "]", yr);
        if (H instanceof Error)
          return H;
      }
      return null;
    }
    return l(O);
  }
  function f() {
    function B(O, I, N, R, L) {
      var W = O[I];
      if (!e(W)) {
        var E = A(W);
        return new c("Invalid " + R + " `" + L + "` of type " + ("`" + E + "` supplied to `" + N + "`, expected a single ReactElement."));
      }
      return null;
    }
    return l(B);
  }
  function y() {
    function B(O, I, N, R, L) {
      var W = O[I];
      if (!Gg.isValidElementType(W)) {
        var E = A(W);
        return new c("Invalid " + R + " `" + L + "` of type " + ("`" + E + "` supplied to `" + N + "`, expected a single ReactElement type."));
      }
      return null;
    }
    return l(B);
  }
  function m(B) {
    function O(I, N, R, L, W) {
      if (!(I[N] instanceof B)) {
        var E = B.name || i, q = Z(I[N]);
        return new c("Invalid " + L + " `" + W + "` of type " + ("`" + q + "` supplied to `" + R + "`, expected ") + ("instance of `" + E + "`."));
      }
      return null;
    }
    return l(O);
  }
  function v(B) {
    if (!Array.isArray(B))
      return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? Ha(
        "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
      ) : Ha("Invalid argument supplied to oneOf, expected an array.")), Ss;
    function O(I, N, R, L, W) {
      for (var E = I[N], q = 0; q < B.length; q++)
        if (s(E, B[q]))
          return null;
      var z = JSON.stringify(B, function(_, X) {
        var P = $(X);
        return P === "symbol" ? String(X) : X;
      });
      return new c("Invalid " + L + " `" + W + "` of value `" + String(E) + "` " + ("supplied to `" + R + "`, expected one of " + z + "."));
    }
    return l(O);
  }
  function k(B) {
    function O(I, N, R, L, W) {
      if (typeof B != "function")
        return new c("Property `" + W + "` of component `" + R + "` has invalid PropType notation inside objectOf.");
      var E = I[N], q = A(E);
      if (q !== "object")
        return new c("Invalid " + L + " `" + W + "` of type " + ("`" + q + "` supplied to `" + R + "`, expected an object."));
      for (var z in E)
        if (tc(E, z)) {
          var H = B(E, z, R, L, W + "." + z, yr);
          if (H instanceof Error)
            return H;
        }
      return null;
    }
    return l(O);
  }
  function b(B) {
    if (!Array.isArray(B))
      return process.env.NODE_ENV !== "production" && Ha("Invalid argument supplied to oneOfType, expected an instance of array."), Ss;
    for (var O = 0; O < B.length; O++) {
      var I = B[O];
      if (typeof I != "function")
        return Ha(
          "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + F(I) + " at index " + O + "."
        ), Ss;
    }
    function N(R, L, W, E, q) {
      for (var z = [], H = 0; H < B.length; H++) {
        var _ = B[H], X = _(R, L, W, E, q, yr);
        if (X == null)
          return null;
        X.data && tc(X.data, "expectedType") && z.push(X.data.expectedType);
      }
      var P = z.length > 0 ? ", expected one of type [" + z.join(", ") + "]" : "";
      return new c("Invalid " + E + " `" + q + "` supplied to " + ("`" + W + "`" + P + "."));
    }
    return l(N);
  }
  function x() {
    function B(O, I, N, R, L) {
      return S(O[I]) ? null : new c("Invalid " + R + " `" + L + "` supplied to " + ("`" + N + "`, expected a ReactNode."));
    }
    return l(B);
  }
  function g(B, O, I, N, R) {
    return new c(
      (B || "React class") + ": " + O + " type `" + I + "." + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + R + "`."
    );
  }
  function w(B) {
    function O(I, N, R, L, W) {
      var E = I[N], q = A(E);
      if (q !== "object")
        return new c("Invalid " + L + " `" + W + "` of type `" + q + "` " + ("supplied to `" + R + "`, expected `object`."));
      for (var z in B) {
        var H = B[z];
        if (typeof H != "function")
          return g(R, L, W, z, $(H));
        var _ = H(E, z, R, L, W + "." + z, yr);
        if (_)
          return _;
      }
      return null;
    }
    return l(O);
  }
  function M(B) {
    function O(I, N, R, L, W) {
      var E = I[N], q = A(E);
      if (q !== "object")
        return new c("Invalid " + L + " `" + W + "` of type `" + q + "` " + ("supplied to `" + R + "`, expected `object`."));
      var z = OM({}, I[N], B);
      for (var H in z) {
        var _ = B[H];
        if (tc(B, H) && typeof _ != "function")
          return g(R, L, W, H, $(_));
        if (!_)
          return new c(
            "Invalid " + L + " `" + W + "` key `" + H + "` supplied to `" + R + "`.\nBad object: " + JSON.stringify(I[N], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(B), null, "  ")
          );
        var X = _(E, H, R, L, W + "." + H, yr);
        if (X)
          return X;
      }
      return null;
    }
    return l(O);
  }
  function S(B) {
    switch (typeof B) {
      case "number":
      case "string":
      case "undefined":
        return !0;
      case "boolean":
        return !B;
      case "object":
        if (Array.isArray(B))
          return B.every(S);
        if (B === null || e(B))
          return !0;
        var O = a(B);
        if (O) {
          var I = O.call(B), N;
          if (O !== B.entries) {
            for (; !(N = I.next()).done; )
              if (!S(N.value))
                return !1;
          } else
            for (; !(N = I.next()).done; ) {
              var R = N.value;
              if (R && !S(R[1]))
                return !1;
            }
        } else
          return !1;
        return !0;
      default:
        return !1;
    }
  }
  function D(B, O) {
    return B === "symbol" ? !0 : O ? O["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && O instanceof Symbol : !1;
  }
  function A(B) {
    var O = typeof B;
    return Array.isArray(B) ? "array" : B instanceof RegExp ? "object" : D(O, B) ? "symbol" : O;
  }
  function $(B) {
    if (typeof B > "u" || B === null)
      return "" + B;
    var O = A(B);
    if (O === "object") {
      if (B instanceof Date)
        return "date";
      if (B instanceof RegExp)
        return "regexp";
    }
    return O;
  }
  function F(B) {
    var O = $(B);
    switch (O) {
      case "array":
      case "object":
        return "an " + O;
      case "boolean":
      case "date":
      case "regexp":
        return "a " + O;
      default:
        return O;
    }
  }
  function Z(B) {
    return !B.constructor || !B.constructor.name ? i : B.constructor.name;
  }
  return o.checkPropTypes = x0, o.resetWarningCache = x0.resetWarningCache, o.PropTypes = o, o;
};
function Xg() {
}
function Ug() {
}
Ug.resetWarningCache = Xg;
var RM = function() {
  function e(r, a, i, o, s, c) {
    if (c !== yr) {
      var l = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      throw l.name = "Invariant Violation", l;
    }
  }
  e.isRequired = e;
  function t() {
    return e;
  }
  var n = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: Ug,
    resetWarningCache: Xg
  };
  return n.PropTypes = n, n;
}, VM = LM, zM = RM, BM = Oi(function(e) {
  if (process.env.NODE_ENV !== "production") {
    var t = Gg, n = !0;
    e.exports = VM(t.isElement, n);
  } else
    e.exports = zM();
}), J = BM;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xl = 60103, Ul = 60106, _o = 60107, Go = 60108, Zo = 60114, Xo = 60109, Uo = 60110, Yo = 60112, Jo = 60113, ep = 60120, Ko = 60115, Qo = 60116, Yg = 60121, Jg = 60122, Kg = 60117, Qg = 60129, ev = 60131;
if (typeof Symbol == "function" && Symbol.for) {
  var ht = Symbol.for;
  Xl = ht("react.element"), Ul = ht("react.portal"), _o = ht("react.fragment"), Go = ht("react.strict_mode"), Zo = ht("react.profiler"), Xo = ht("react.provider"), Uo = ht("react.context"), Yo = ht("react.forward_ref"), Jo = ht("react.suspense"), ep = ht("react.suspense_list"), Ko = ht("react.memo"), Qo = ht("react.lazy"), Yg = ht("react.block"), Jg = ht("react.server.block"), Kg = ht("react.fundamental"), Qg = ht("react.debug_trace_mode"), ev = ht("react.legacy_hidden");
}
function bn(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case Xl:
        switch (e = e.type, e) {
          case _o:
          case Zo:
          case Go:
          case Jo:
          case ep:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case Uo:
              case Yo:
              case Qo:
              case Ko:
              case Xo:
                return e;
              default:
                return t;
            }
        }
      case Ul:
        return t;
    }
  }
}
var HM = Xo, $M = Xl, jM = Yo, FM = _o, WM = Qo, qM = Ko, _M = Ul, GM = Zo, ZM = Go, XM = Jo, UM = Uo, YM = HM, JM = $M, KM = jM, QM = FM, e8 = WM, t8 = qM, n8 = _M, r8 = GM, a8 = ZM, i8 = XM, o8 = function() {
  return !1;
}, s8 = function() {
  return !1;
}, c8 = function(e) {
  return bn(e) === Uo;
}, l8 = function(e) {
  return bn(e) === Xo;
}, d8 = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === Xl;
}, u8 = function(e) {
  return bn(e) === Yo;
}, h8 = function(e) {
  return bn(e) === _o;
}, p8 = function(e) {
  return bn(e) === Qo;
}, f8 = function(e) {
  return bn(e) === Ko;
}, y8 = function(e) {
  return bn(e) === Ul;
}, m8 = function(e) {
  return bn(e) === Zo;
}, g8 = function(e) {
  return bn(e) === Go;
}, v8 = function(e) {
  return bn(e) === Jo;
}, k8 = function(e) {
  return typeof e == "string" || typeof e == "function" || e === _o || e === Zo || e === Qg || e === Go || e === Jo || e === ep || e === ev || typeof e == "object" && e !== null && (e.$$typeof === Qo || e.$$typeof === Ko || e.$$typeof === Xo || e.$$typeof === Uo || e.$$typeof === Yo || e.$$typeof === Kg || e.$$typeof === Yg || e[0] === Jg);
}, b8 = bn, x8 = {
  ContextConsumer: UM,
  ContextProvider: YM,
  Element: JM,
  ForwardRef: KM,
  Fragment: QM,
  Lazy: e8,
  Memo: t8,
  Portal: n8,
  Profiler: r8,
  StrictMode: a8,
  Suspense: i8,
  isAsyncMode: o8,
  isConcurrentMode: s8,
  isContextConsumer: c8,
  isContextProvider: l8,
  isElement: d8,
  isForwardRef: u8,
  isFragment: h8,
  isLazy: p8,
  isMemo: f8,
  isPortal: y8,
  isProfiler: m8,
  isStrictMode: g8,
  isSuspense: v8,
  isValidElementType: k8,
  typeOf: b8
}, M8 = Oi(function(e, t) {
  process.env.NODE_ENV !== "production" && function() {
    var n = 60103, r = 60106, a = 60107, i = 60108, o = 60114, s = 60109, c = 60110, l = 60112, u = 60113, h = 60120, p = 60115, f = 60116, y = 60121, m = 60122, v = 60117, k = 60129, b = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var x = Symbol.for;
      n = x("react.element"), r = x("react.portal"), a = x("react.fragment"), i = x("react.strict_mode"), o = x("react.profiler"), s = x("react.provider"), c = x("react.context"), l = x("react.forward_ref"), u = x("react.suspense"), h = x("react.suspense_list"), p = x("react.memo"), f = x("react.lazy"), y = x("react.block"), m = x("react.server.block"), v = x("react.fundamental"), x("react.scope"), x("react.opaque.id"), k = x("react.debug_trace_mode"), x("react.offscreen"), b = x("react.legacy_hidden");
    }
    var g = !1;
    function w(re) {
      return !!(typeof re == "string" || typeof re == "function" || re === a || re === o || re === k || re === i || re === u || re === h || re === b || g || typeof re == "object" && re !== null && (re.$$typeof === f || re.$$typeof === p || re.$$typeof === s || re.$$typeof === c || re.$$typeof === l || re.$$typeof === v || re.$$typeof === y || re[0] === m));
    }
    function M(re) {
      if (typeof re == "object" && re !== null) {
        var te = re.$$typeof;
        switch (te) {
          case n:
            var me = re.type;
            switch (me) {
              case a:
              case o:
              case i:
              case u:
              case h:
                return me;
              default:
                var Pe = me && me.$$typeof;
                switch (Pe) {
                  case c:
                  case l:
                  case f:
                  case p:
                  case s:
                    return Pe;
                  default:
                    return te;
                }
            }
          case r:
            return te;
        }
      }
    }
    var S = c, D = s, A = n, $ = l, F = a, Z = f, B = p, O = r, I = o, N = i, R = u, L = !1, W = !1;
    function E(re) {
      return L || (L = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function q(re) {
      return W || (W = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function z(re) {
      return M(re) === c;
    }
    function H(re) {
      return M(re) === s;
    }
    function _(re) {
      return typeof re == "object" && re !== null && re.$$typeof === n;
    }
    function X(re) {
      return M(re) === l;
    }
    function P(re) {
      return M(re) === a;
    }
    function Q(re) {
      return M(re) === f;
    }
    function U(re) {
      return M(re) === p;
    }
    function ae(re) {
      return M(re) === r;
    }
    function ee(re) {
      return M(re) === o;
    }
    function de(re) {
      return M(re) === i;
    }
    function Y(re) {
      return M(re) === u;
    }
    t.ContextConsumer = S, t.ContextProvider = D, t.Element = A, t.ForwardRef = $, t.Fragment = F, t.Lazy = Z, t.Memo = B, t.Portal = O, t.Profiler = I, t.StrictMode = N, t.Suspense = R, t.isAsyncMode = E, t.isConcurrentMode = q, t.isContextConsumer = z, t.isContextProvider = H, t.isElement = _, t.isForwardRef = X, t.isFragment = P, t.isLazy = Q, t.isMemo = U, t.isPortal = ae, t.isProfiler = ee, t.isStrictMode = de, t.isSuspense = Y, t.isValidElementType = w, t.typeOf = M;
  }();
}), M0 = Oi(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = x8 : e.exports = M8;
});
function w0(e) {
  return typeof e == "object" && e != null && e.nodeType === 1;
}
function C0(e, t) {
  return (!t || e !== "hidden") && e !== "visible" && e !== "clip";
}
function ed(e, t) {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    var n = getComputedStyle(e, null);
    return C0(n.overflowY, t) || C0(n.overflowX, t) || function(r) {
      var a = function(i) {
        if (!i.ownerDocument || !i.ownerDocument.defaultView)
          return null;
        try {
          return i.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      }(r);
      return !!a && (a.clientHeight < r.scrollHeight || a.clientWidth < r.scrollWidth);
    }(e);
  }
  return !1;
}
function As(e, t, n, r, a, i, o, s) {
  return i < e && o > t || i > e && o < t ? 0 : i <= e && s <= n || o >= t && s >= n ? i - e - r : o > t && s < n || i < e && s > n ? o - t + a : 0;
}
function w8(e, t) {
  var n = window, r = t.scrollMode, a = t.block, i = t.inline, o = t.boundary, s = t.skipOverflowHiddenElements, c = typeof o == "function" ? o : function(ee) {
    return ee !== o;
  };
  if (!w0(e))
    throw new TypeError("Invalid target");
  for (var l = document.scrollingElement || document.documentElement, u = [], h = e; w0(h) && c(h); ) {
    if ((h = h.parentElement) === l) {
      u.push(h);
      break;
    }
    h != null && h === document.body && ed(h) && !ed(document.documentElement) || h != null && ed(h, s) && u.push(h);
  }
  for (var p = n.visualViewport ? n.visualViewport.width : innerWidth, f = n.visualViewport ? n.visualViewport.height : innerHeight, y = window.scrollX || pageXOffset, m = window.scrollY || pageYOffset, v = e.getBoundingClientRect(), k = v.height, b = v.width, x = v.top, g = v.right, w = v.bottom, M = v.left, S = a === "start" || a === "nearest" ? x : a === "end" ? w : x + k / 2, D = i === "center" ? M + b / 2 : i === "end" ? g : M, A = [], $ = 0; $ < u.length; $++) {
    var F = u[$], Z = F.getBoundingClientRect(), B = Z.height, O = Z.width, I = Z.top, N = Z.right, R = Z.bottom, L = Z.left;
    if (r === "if-needed" && x >= 0 && M >= 0 && w <= f && g <= p && x >= I && w <= R && M >= L && g <= N)
      return A;
    var W = getComputedStyle(F), E = parseInt(W.borderLeftWidth, 10), q = parseInt(W.borderTopWidth, 10), z = parseInt(W.borderRightWidth, 10), H = parseInt(W.borderBottomWidth, 10), _ = 0, X = 0, P = "offsetWidth" in F ? F.offsetWidth - F.clientWidth - E - z : 0, Q = "offsetHeight" in F ? F.offsetHeight - F.clientHeight - q - H : 0;
    if (l === F)
      _ = a === "start" ? S : a === "end" ? S - f : a === "nearest" ? As(m, m + f, f, q, H, m + S, m + S + k, k) : S - f / 2, X = i === "start" ? D : i === "center" ? D - p / 2 : i === "end" ? D - p : As(y, y + p, p, E, z, y + D, y + D + b, b), _ = Math.max(0, _ + m), X = Math.max(0, X + y);
    else {
      _ = a === "start" ? S - I - q : a === "end" ? S - R + H + Q : a === "nearest" ? As(I, R, B, q, H + Q, S, S + k, k) : S - (I + B / 2) + Q / 2, X = i === "start" ? D - L - E : i === "center" ? D - (L + O / 2) + P / 2 : i === "end" ? D - N + z + P : As(L, N, O, E, z + P, D, D + b, b);
      var U = F.scrollLeft, ae = F.scrollTop;
      S += ae - (_ = Math.max(0, Math.min(ae + _, F.scrollHeight - B + Q))), D += U - (X = Math.max(0, Math.min(U + X, F.scrollWidth - O + P)));
    }
    A.push({ el: F, top: _, left: X });
  }
  return A;
}
var C8 = 0;
function S0(e) {
  return typeof e == "function" ? e : Jn;
}
function Jn() {
}
function tv(e, t) {
  if (e) {
    var n = w8(e, {
      boundary: t,
      block: "nearest",
      scrollMode: "if-needed"
    });
    n.forEach(function(r) {
      var a = r.el, i = r.top, o = r.left;
      a.scrollTop = i, a.scrollLeft = o;
    });
  }
}
function A0(e, t, n) {
  var r = e === t || t instanceof n.Node && e.contains && e.contains(t);
  return r;
}
function tp(e, t) {
  var n;
  function r() {
    n && clearTimeout(n);
  }
  function a() {
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    r(), n = setTimeout(function() {
      n = null, e.apply(void 0, o);
    }, t);
  }
  return a.cancel = r, a;
}
function wn() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var a = arguments.length, i = new Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++)
      i[o - 1] = arguments[o];
    return t.some(function(s) {
      return s && s.apply(void 0, [r].concat(i)), r.preventDownshiftDefault || r.hasOwnProperty("nativeEvent") && r.nativeEvent.preventDownshiftDefault;
    });
  };
}
function O0() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    t.forEach(function(a) {
      typeof a == "function" ? a(r) : a && (a.current = r);
    });
  };
}
function S8() {
  return String(C8++);
}
function nv(e) {
  var t = e.isOpen, n = e.resultCount, r = e.previousResultCount;
  return t ? n ? n !== r ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function E0(e, t) {
  return e = Array.isArray(e) ? (
    /* istanbul ignore next (preact) */
    e[0]
  ) : e, !e && t ? t : e;
}
function rv(e) {
  return typeof e.type == "string";
}
function av(e) {
  return e.props;
}
function A8(e, t) {
  console.error('The property "' + t + '" is required in "' + e + '"');
}
var O8 = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function Os(e) {
  e === void 0 && (e = {});
  var t = {};
  return O8.forEach(function(n) {
    e.hasOwnProperty(n) && (t[n] = e[n]);
  }), t;
}
function E8(e, t) {
  return Object.keys(e).reduce(function(n, r) {
    return n[r] = mu(t, r) ? t[r] : e[r], n;
  }, {});
}
function mu(e, t) {
  return e[t] !== void 0;
}
function I0(e) {
  var t = e.key, n = e.keyCode;
  return n >= 37 && n <= 40 && t.indexOf("Arrow") !== 0 ? "Arrow" + t : t;
}
function I8(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function td(e, t, n, r, a) {
  if (a === void 0 && (a = !0), n === 0)
    return -1;
  var i = n - 1;
  (typeof t != "number" || t < 0 || t >= n) && (t = e > 0 ? -1 : i + 1);
  var o = t + e;
  o < 0 ? o = a ? i : 0 : o > i && (o = a ? 0 : i);
  var s = yo(e, o, n, r, a);
  return s === -1 ? t >= n ? -1 : t : s;
}
function yo(e, t, n, r, a) {
  var i = r(t);
  if (!i || !i.hasAttribute("disabled"))
    return t;
  if (e > 0) {
    for (var o = t + 1; o < n; o++)
      if (!r(o).hasAttribute("disabled"))
        return o;
  } else
    for (var s = t - 1; s >= 0; s--)
      if (!r(s).hasAttribute("disabled"))
        return s;
  return a ? e > 0 ? yo(1, 0, n, r, !1) : yo(-1, n - 1, n, r, !1) : -1;
}
function D0(e, t, n, r) {
  return r === void 0 && (r = !0), t.some(function(a) {
    return a && (A0(a, e, n) || r && A0(a, n.document.activeElement, n));
  });
}
var iv = Jn;
process.env.NODE_ENV !== "production" && (iv = function(t, n, r) {
  var a = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(t).forEach(function(i) {
    n[i] !== void 0 && r[i] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + i + '" to be uncontrolled. ' + a) : n[i] === void 0 && r[i] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + i + '" to be controlled. ' + a);
  });
});
var D8 = tp(function(e) {
  sv(e).textContent = "";
}, 500);
function ov(e, t) {
  var n = sv(t);
  e && (n.textContent = e, D8(t));
}
function sv(e) {
  e === void 0 && (e = document);
  var t = e.getElementById("a11y-status-message");
  return t || (t = e.createElement("div"), t.setAttribute("id", "a11y-status-message"), t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-relevant", "additions text"), Object.assign(t.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), e.body.appendChild(t), t);
}
var cv = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, lv = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, dv = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, nc = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, rc = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, uv = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, hv = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, pv = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, fv = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, yv = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, mv = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, gv = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, vv = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, gu = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, kv = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, bv = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, xv = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, T8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  unknown: cv,
  mouseUp: lv,
  itemMouseEnter: dv,
  keyDownArrowUp: nc,
  keyDownArrowDown: rc,
  keyDownEscape: uv,
  keyDownEnter: hv,
  keyDownHome: pv,
  keyDownEnd: fv,
  clickItem: yv,
  blurInput: mv,
  changeInput: gv,
  keyDownSpaceButton: vv,
  clickButton: gu,
  blurButton: kv,
  controlledPropUpdatedSelectedItem: bv,
  touchEnd: xv
}), N8 = ["refKey", "ref"], P8 = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], L8 = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], R8 = ["refKey", "ref"], V8 = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], z8 = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ function(t) {
    jx(n, t);
    function n(a) {
      var i;
      i = t.call(this, a) || this, i.id = i.props.id || "downshift-" + S8(), i.menuId = i.props.menuId || i.id + "-menu", i.labelId = i.props.labelId || i.id + "-label", i.inputId = i.props.inputId || i.id + "-input", i.getItemId = i.props.getItemId || function(b) {
        return i.id + "-item-" + b;
      }, i.input = null, i.items = [], i.itemCount = null, i.previousResultCount = 0, i.timeoutIds = [], i.internalSetTimeout = function(b, x) {
        var g = setTimeout(function() {
          i.timeoutIds = i.timeoutIds.filter(function(w) {
            return w !== g;
          }), b();
        }, x);
        i.timeoutIds.push(g);
      }, i.setItemCount = function(b) {
        i.itemCount = b;
      }, i.unsetItemCount = function() {
        i.itemCount = null;
      }, i.setHighlightedIndex = function(b, x) {
        b === void 0 && (b = i.props.defaultHighlightedIndex), x === void 0 && (x = {}), x = Os(x), i.internalSetState(st({
          highlightedIndex: b
        }, x));
      }, i.clearSelection = function(b) {
        i.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: i.props.defaultHighlightedIndex,
          isOpen: i.props.defaultIsOpen
        }, b);
      }, i.selectItem = function(b, x, g) {
        x = Os(x), i.internalSetState(st({
          isOpen: i.props.defaultIsOpen,
          highlightedIndex: i.props.defaultHighlightedIndex,
          selectedItem: b,
          inputValue: i.props.itemToString(b)
        }, x), g);
      }, i.selectItemAtIndex = function(b, x, g) {
        var w = i.items[b];
        w != null && i.selectItem(w, x, g);
      }, i.selectHighlightedItem = function(b, x) {
        return i.selectItemAtIndex(i.getState().highlightedIndex, b, x);
      }, i.internalSetState = function(b, x) {
        var g, w, M = {}, S = typeof b == "function";
        return !S && b.hasOwnProperty("inputValue") && i.props.onInputValueChange(b.inputValue, st({}, i.getStateAndHelpers(), b)), i.setState(function(D) {
          D = i.getState(D);
          var A = S ? b(D) : b;
          A = i.props.stateReducer(D, A), g = A.hasOwnProperty("selectedItem");
          var $ = {};
          return g && A.selectedItem !== D.selectedItem && (w = A.selectedItem), A.type = A.type || cv, Object.keys(A).forEach(function(F) {
            D[F] !== A[F] && (M[F] = A[F]), F !== "type" && (A[F], mu(i.props, F) || ($[F] = A[F]));
          }), S && A.hasOwnProperty("inputValue") && i.props.onInputValueChange(A.inputValue, st({}, i.getStateAndHelpers(), A)), $;
        }, function() {
          S0(x)();
          var D = Object.keys(M).length > 1;
          D && i.props.onStateChange(M, i.getStateAndHelpers()), g && i.props.onSelect(b.selectedItem, i.getStateAndHelpers()), w !== void 0 && i.props.onChange(w, i.getStateAndHelpers()), i.props.onUserAction(M, i.getStateAndHelpers());
        });
      }, i.rootRef = function(b) {
        return i._rootNode = b;
      }, i.getRootProps = function(b, x) {
        var g, w = b === void 0 ? {} : b, M = w.refKey, S = M === void 0 ? "ref" : M, D = w.ref, A = Bi(w, N8), $ = x === void 0 ? {} : x, F = $.suppressRefError, Z = F === void 0 ? !1 : F;
        i.getRootProps.called = !0, i.getRootProps.refKey = S, i.getRootProps.suppressRefError = Z;
        var B = i.getState(), O = B.isOpen;
        return st((g = {}, g[S] = O0(D, i.rootRef), g.role = "combobox", g["aria-expanded"] = O, g["aria-haspopup"] = "listbox", g["aria-owns"] = O ? i.menuId : null, g["aria-labelledby"] = i.labelId, g), A);
      }, i.keyDownHandlers = {
        ArrowDown: function(x) {
          var g = this;
          if (x.preventDefault(), this.getState().isOpen) {
            var w = x.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(w, {
              type: rc
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: rc
            }, function() {
              var M = g.getItemCount();
              if (M > 0) {
                var S = g.getState(), D = S.highlightedIndex, A = td(1, D, M, function($) {
                  return g.getItemNodeFromIndex($);
                });
                g.setHighlightedIndex(A, {
                  type: rc
                });
              }
            });
        },
        ArrowUp: function(x) {
          var g = this;
          if (x.preventDefault(), this.getState().isOpen) {
            var w = x.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(w, {
              type: nc
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: nc
            }, function() {
              var M = g.getItemCount();
              if (M > 0) {
                var S = g.getState(), D = S.highlightedIndex, A = td(-1, D, M, function($) {
                  return g.getItemNodeFromIndex($);
                });
                g.setHighlightedIndex(A, {
                  type: nc
                });
              }
            });
        },
        Enter: function(x) {
          if (x.which !== 229) {
            var g = this.getState(), w = g.isOpen, M = g.highlightedIndex;
            if (w && M != null) {
              x.preventDefault();
              var S = this.items[M], D = this.getItemNodeFromIndex(M);
              if (S == null || D && D.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: hv
              });
            }
          }
        },
        Escape: function(x) {
          x.preventDefault(), this.reset(st({
            type: uv
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, i.buttonKeyDownHandlers = st({}, i.keyDownHandlers, {
        " ": function(x) {
          x.preventDefault(), this.toggleMenu({
            type: vv
          });
        }
      }), i.inputKeyDownHandlers = st({}, i.keyDownHandlers, {
        Home: function(x) {
          var g = this, w = this.getState(), M = w.isOpen;
          if (M) {
            x.preventDefault();
            var S = this.getItemCount();
            if (!(S <= 0 || !M)) {
              var D = yo(1, 0, S, function(A) {
                return g.getItemNodeFromIndex(A);
              }, !1);
              this.setHighlightedIndex(D, {
                type: pv
              });
            }
          }
        },
        End: function(x) {
          var g = this, w = this.getState(), M = w.isOpen;
          if (M) {
            x.preventDefault();
            var S = this.getItemCount();
            if (!(S <= 0 || !M)) {
              var D = yo(-1, S - 1, S, function(A) {
                return g.getItemNodeFromIndex(A);
              }, !1);
              this.setHighlightedIndex(D, {
                type: fv
              });
            }
          }
        }
      }), i.getToggleButtonProps = function(b) {
        var x = b === void 0 ? {} : b, g = x.onClick;
        x.onPress;
        var w = x.onKeyDown, M = x.onKeyUp, S = x.onBlur, D = Bi(x, P8), A = i.getState(), $ = A.isOpen, F = {
          onClick: wn(g, i.buttonHandleClick),
          onKeyDown: wn(w, i.buttonHandleKeyDown),
          onKeyUp: wn(M, i.buttonHandleKeyUp),
          onBlur: wn(S, i.buttonHandleBlur)
        }, Z = D.disabled ? {} : F;
        return st({
          type: "button",
          role: "button",
          "aria-label": $ ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, Z, D);
      }, i.buttonHandleKeyUp = function(b) {
        b.preventDefault();
      }, i.buttonHandleKeyDown = function(b) {
        var x = I0(b);
        i.buttonKeyDownHandlers[x] && i.buttonKeyDownHandlers[x].call(k0(i), b);
      }, i.buttonHandleClick = function(b) {
        b.preventDefault(), i.props.environment.document.activeElement === i.props.environment.document.body && b.target.focus(), process.env.NODE_ENV === "test" ? i.toggleMenu({
          type: gu
        }) : i.internalSetTimeout(function() {
          return i.toggleMenu({
            type: gu
          });
        });
      }, i.buttonHandleBlur = function(b) {
        var x = b.target;
        i.internalSetTimeout(function() {
          !i.isMouseDown && (i.props.environment.document.activeElement == null || i.props.environment.document.activeElement.id !== i.inputId) && i.props.environment.document.activeElement !== x && i.reset({
            type: kv
          });
        });
      }, i.getLabelProps = function(b) {
        return st({
          htmlFor: i.inputId,
          id: i.labelId
        }, b);
      }, i.getInputProps = function(b) {
        var x = b === void 0 ? {} : b, g = x.onKeyDown, w = x.onBlur, M = x.onChange, S = x.onInput;
        x.onChangeText;
        var D = Bi(x, L8), A, $ = {};
        A = "onChange";
        var F = i.getState(), Z = F.inputValue, B = F.isOpen, O = F.highlightedIndex;
        if (!D.disabled) {
          var I;
          $ = (I = {}, I[A] = wn(M, S, i.inputHandleChange), I.onKeyDown = wn(g, i.inputHandleKeyDown), I.onBlur = wn(w, i.inputHandleBlur), I);
        }
        return st({
          "aria-autocomplete": "list",
          "aria-activedescendant": B && typeof O == "number" && O >= 0 ? i.getItemId(O) : null,
          "aria-controls": B ? i.menuId : null,
          "aria-labelledby": i.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: Z,
          id: i.inputId
        }, $, D);
      }, i.inputHandleKeyDown = function(b) {
        var x = I0(b);
        x && i.inputKeyDownHandlers[x] && i.inputKeyDownHandlers[x].call(k0(i), b);
      }, i.inputHandleChange = function(b) {
        i.internalSetState({
          type: gv,
          isOpen: !0,
          inputValue: b.target.value,
          highlightedIndex: i.props.defaultHighlightedIndex
        });
      }, i.inputHandleBlur = function() {
        i.internalSetTimeout(function() {
          var b = i.props.environment.document && !!i.props.environment.document.activeElement && !!i.props.environment.document.activeElement.dataset && i.props.environment.document.activeElement.dataset.toggle && i._rootNode && i._rootNode.contains(i.props.environment.document.activeElement);
          !i.isMouseDown && !b && i.reset({
            type: mv
          });
        });
      }, i.menuRef = function(b) {
        i._menuNode = b;
      }, i.getMenuProps = function(b, x) {
        var g, w = b === void 0 ? {} : b, M = w.refKey, S = M === void 0 ? "ref" : M, D = w.ref, A = Bi(w, R8), $ = x === void 0 ? {} : x, F = $.suppressRefError, Z = F === void 0 ? !1 : F;
        return i.getMenuProps.called = !0, i.getMenuProps.refKey = S, i.getMenuProps.suppressRefError = Z, st((g = {}, g[S] = O0(D, i.menuRef), g.role = "listbox", g["aria-labelledby"] = A && A["aria-label"] ? null : i.labelId, g.id = i.menuId, g), A);
      }, i.getItemProps = function(b) {
        var x, g = b === void 0 ? {} : b, w = g.onMouseMove, M = g.onMouseDown, S = g.onClick;
        g.onPress;
        var D = g.index, A = g.item, $ = A === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : A8("getItemProps", "item") : A, F = Bi(g, V8);
        D === void 0 ? (i.items.push($), D = i.items.indexOf($)) : i.items[D] = $;
        var Z = "onClick", B = S, O = (x = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: wn(w, function() {
            D !== i.getState().highlightedIndex && (i.setHighlightedIndex(D, {
              type: dv
            }), i.avoidScrolling = !0, i.internalSetTimeout(function() {
              return i.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: wn(M, function(N) {
            N.preventDefault();
          })
        }, x[Z] = wn(B, function() {
          i.selectItemAtIndex(D, {
            type: yv
          });
        }), x), I = F.disabled ? {
          onMouseDown: O.onMouseDown
        } : O;
        return st({
          id: i.getItemId(D),
          role: "option",
          "aria-selected": i.getState().highlightedIndex === D
        }, I, F);
      }, i.clearItems = function() {
        i.items = [];
      }, i.reset = function(b, x) {
        b === void 0 && (b = {}), b = Os(b), i.internalSetState(function(g) {
          var w = g.selectedItem;
          return st({
            isOpen: i.props.defaultIsOpen,
            highlightedIndex: i.props.defaultHighlightedIndex,
            inputValue: i.props.itemToString(w)
          }, b);
        }, x);
      }, i.toggleMenu = function(b, x) {
        b === void 0 && (b = {}), b = Os(b), i.internalSetState(function(g) {
          var w = g.isOpen;
          return st({
            isOpen: !w
          }, w && {
            highlightedIndex: i.props.defaultHighlightedIndex
          }, b);
        }, function() {
          var g = i.getState(), w = g.isOpen, M = g.highlightedIndex;
          w && i.getItemCount() > 0 && typeof M == "number" && i.setHighlightedIndex(M, b), S0(x)();
        });
      }, i.openMenu = function(b) {
        i.internalSetState({
          isOpen: !0
        }, b);
      }, i.closeMenu = function(b) {
        i.internalSetState({
          isOpen: !1
        }, b);
      }, i.updateStatus = tp(function() {
        var b = i.getState(), x = i.items[b.highlightedIndex], g = i.getItemCount(), w = i.props.getA11yStatusMessage(st({
          itemToString: i.props.itemToString,
          previousResultCount: i.previousResultCount,
          resultCount: g,
          highlightedItem: x
        }, b));
        i.previousResultCount = g, ov(w, i.props.environment.document);
      }, 200);
      var o = i.props, s = o.defaultHighlightedIndex, c = o.initialHighlightedIndex, l = c === void 0 ? s : c, u = o.defaultIsOpen, h = o.initialIsOpen, p = h === void 0 ? u : h, f = o.initialInputValue, y = f === void 0 ? "" : f, m = o.initialSelectedItem, v = m === void 0 ? null : m, k = i.getState({
        highlightedIndex: l,
        isOpen: p,
        inputValue: y,
        selectedItem: v
      });
      return k.selectedItem != null && i.props.initialInputValue === void 0 && (k.inputValue = i.props.itemToString(k.selectedItem)), i.state = k, i;
    }
    var r = n.prototype;
    return r.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(i) {
        clearTimeout(i);
      }), this.timeoutIds = [];
    }, r.getState = function(i) {
      return i === void 0 && (i = this.state), E8(i, this.props);
    }, r.getItemCount = function() {
      var i = this.items.length;
      return this.itemCount != null ? i = this.itemCount : this.props.itemCount !== void 0 && (i = this.props.itemCount), i;
    }, r.getItemNodeFromIndex = function(i) {
      return this.props.environment.document.getElementById(this.getItemId(i));
    }, r.scrollHighlightedItemIntoView = function() {
      {
        var i = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(i, this._menuNode);
      }
    }, r.moveHighlightedIndex = function(i, o) {
      var s = this, c = this.getItemCount(), l = this.getState(), u = l.highlightedIndex;
      if (c > 0) {
        var h = td(i, u, c, function(p) {
          return s.getItemNodeFromIndex(p);
        });
        this.setHighlightedIndex(h, o);
      }
    }, r.getStateAndHelpers = function() {
      var i = this.getState(), o = i.highlightedIndex, s = i.inputValue, c = i.selectedItem, l = i.isOpen, u = this.props.itemToString, h = this.id, p = this.getRootProps, f = this.getToggleButtonProps, y = this.getLabelProps, m = this.getMenuProps, v = this.getInputProps, k = this.getItemProps, b = this.openMenu, x = this.closeMenu, g = this.toggleMenu, w = this.selectItem, M = this.selectItemAtIndex, S = this.selectHighlightedItem, D = this.setHighlightedIndex, A = this.clearSelection, $ = this.clearItems, F = this.reset, Z = this.setItemCount, B = this.unsetItemCount, O = this.internalSetState;
      return {
        // prop getters
        getRootProps: p,
        getToggleButtonProps: f,
        getLabelProps: y,
        getMenuProps: m,
        getInputProps: v,
        getItemProps: k,
        // actions
        reset: F,
        openMenu: b,
        closeMenu: x,
        toggleMenu: g,
        selectItem: w,
        selectItemAtIndex: M,
        selectHighlightedItem: S,
        setHighlightedIndex: D,
        clearSelection: A,
        clearItems: $,
        setItemCount: Z,
        unsetItemCount: B,
        setState: O,
        // props
        itemToString: u,
        // derived
        id: h,
        // state
        highlightedIndex: o,
        inputValue: s,
        isOpen: l,
        selectedItem: c
      };
    }, r.componentDidMount = function() {
      var i = this;
      process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && T0(this._menuNode, this.getMenuProps);
      {
        var o = function() {
          i.isMouseDown = !0;
        }, s = function(f) {
          i.isMouseDown = !1;
          var y = D0(f.target, [i._rootNode, i._menuNode], i.props.environment);
          !y && i.getState().isOpen && i.reset({
            type: lv
          }, function() {
            return i.props.onOuterClick(i.getStateAndHelpers());
          });
        }, c = function() {
          i.isTouchMove = !1;
        }, l = function() {
          i.isTouchMove = !0;
        }, u = function(f) {
          var y = D0(f.target, [i._rootNode, i._menuNode], i.props.environment, !1);
          !i.isTouchMove && !y && i.getState().isOpen && i.reset({
            type: xv
          }, function() {
            return i.props.onOuterClick(i.getStateAndHelpers());
          });
        }, h = this.props.environment;
        h.addEventListener("mousedown", o), h.addEventListener("mouseup", s), h.addEventListener("touchstart", c), h.addEventListener("touchmove", l), h.addEventListener("touchend", u), this.cleanup = function() {
          i.internalClearTimeouts(), i.updateStatus.cancel(), h.removeEventListener("mousedown", o), h.removeEventListener("mouseup", s), h.removeEventListener("touchstart", c), h.removeEventListener("touchmove", l), h.removeEventListener("touchend", u);
        };
      }
    }, r.shouldScroll = function(i, o) {
      var s = this.props.highlightedIndex === void 0 ? this.getState() : this.props, c = s.highlightedIndex, l = o.highlightedIndex === void 0 ? i : o, u = l.highlightedIndex, h = c && this.getState().isOpen && !i.isOpen, p = c !== u;
      return h || p;
    }, r.componentDidUpdate = function(i, o) {
      process.env.NODE_ENV !== "production" && (iv(this.state, i, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && T0(this._menuNode, this.getMenuProps)), mu(this.props, "selectedItem") && this.props.selectedItemChanged(i.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: bv,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(o, i) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, r.componentWillUnmount = function() {
      this.cleanup();
    }, r.render = function() {
      var i = E0(this.props.children, Jn);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var o = E0(i(this.getStateAndHelpers()));
      if (!o)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && B8(o, this.getRootProps), o;
      if (rv(o))
        return /* @__PURE__ */ Ci(o, this.getRootProps(av(o)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, n;
  }(Si);
  return e.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: nv,
    itemToString: function(n) {
      return n == null ? "" : (process.env.NODE_ENV !== "production" && I8(n) && !n.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", n), String(n));
    },
    onStateChange: Jn,
    onInputValueChange: Jn,
    onUserAction: Jn,
    onChange: Jn,
    onSelect: Jn,
    onOuterClick: Jn,
    selectedItemChanged: function(n, r) {
      return n !== r;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? {} : window
    ),
    stateReducer: function(n, r) {
      return r;
    },
    suppressRefError: !1,
    scrollIntoView: tv
  }, e.stateChangeTypes = T8, e;
}();
process.env.NODE_ENV !== "production" && (z8.propTypes = {
  children: J.func,
  defaultHighlightedIndex: J.number,
  defaultIsOpen: J.bool,
  initialHighlightedIndex: J.number,
  initialSelectedItem: J.any,
  initialInputValue: J.string,
  initialIsOpen: J.bool,
  getA11yStatusMessage: J.func,
  itemToString: J.func,
  onChange: J.func,
  onSelect: J.func,
  onStateChange: J.func,
  onInputValueChange: J.func,
  onUserAction: J.func,
  onOuterClick: J.func,
  selectedItemChanged: J.func,
  stateReducer: J.func,
  itemCount: J.number,
  id: J.string,
  environment: J.shape({
    addEventListener: J.func,
    removeEventListener: J.func,
    document: J.shape({
      getElementById: J.func,
      activeElement: J.any,
      body: J.any
    })
  }),
  suppressRefError: J.bool,
  scrollIntoView: J.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: J.any,
  isOpen: J.bool,
  inputValue: J.string,
  highlightedIndex: J.number,
  labelId: J.string,
  inputId: J.string,
  menuId: J.string,
  getItemId: J.func
  /* eslint-enable react/no-unused-prop-types */
});
function T0(e, t) {
  var n = t.refKey;
  e || console.error('downshift: The ref prop "' + n + '" from getMenuProps was not applied correctly on your menu element.');
}
function B8(e, t) {
  var n = t.refKey, r = n !== "ref", a = !rv(e);
  a && !r && !M0.isForwardRef(e) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !a && r && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + n + '"'), !M0.isForwardRef(e) && !av(e)[n] && console.error('downshift: You must apply the ref prop "' + n + '" from getRootProps onto your root element.');
}
function H8(e, t) {
  return t.changes;
}
function $8(e) {
  var t = e.selectedItem, n = e.itemToString;
  return t ? n(t) + " has been selected." : "";
}
tp(function(e, t) {
  ov(e(), t);
}, 200);
function j8(e) {
  return e ? String(e) : "";
}
var Ki = {
  itemToString: j8,
  stateReducer: H8,
  getA11ySelectionMessage: $8,
  scrollIntoView: tv,
  circularNavigation: !1,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? {} : window
  )
};
process.env.NODE_ENV;
process.env.NODE_ENV;
J.array.isRequired, J.func, J.func, J.func, J.bool, J.number, J.number, J.number, J.bool, J.bool, J.bool, J.any, J.any, J.any, J.string, J.string, J.string, J.func, J.string, J.func, J.func, J.func, J.func, J.func, J.shape({
  addEventListener: J.func,
  removeEventListener: J.func,
  document: J.shape({
    getElementById: J.func,
    activeElement: J.any,
    body: J.any
  })
});
function F8(e) {
  var t = e.isOpen, n = e.resultCount, r = e.previousResultCount;
  return t ? n ? n !== r ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select." : "" : "No results are available." : "";
}
Te(Te({}, Ki), { getA11yStatusMessage: F8 });
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
J.array.isRequired, J.func, J.func, J.func, J.bool, J.number, J.number, J.number, J.bool, J.bool, J.bool, J.any, J.any, J.any, J.string, J.string, J.string, J.string, J.string, J.string, J.func, J.string, J.string, J.func, J.func, J.func, J.func, J.func, J.func, J.shape({
  addEventListener: J.func,
  removeEventListener: J.func,
  document: J.shape({
    getElementById: J.func,
    activeElement: J.any,
    body: J.any
  })
});
process.env.NODE_ENV;
st({}, Ki, {
  getA11yStatusMessage: nv,
  circularNavigation: !0
});
function W8(e) {
  var t = e.removedSelectedItem, n = e.itemToString;
  return n(t) + " has been removed.";
}
J.array, J.array, J.array, J.func, J.func, J.func, J.number, J.number, J.number, J.func, J.func, J.string, J.string, J.shape({
  addEventListener: J.func,
  removeEventListener: J.func,
  document: J.shape({
    getElementById: J.func,
    activeElement: J.any,
    body: J.any
  })
});
Ki.itemToString, Ki.stateReducer, Ki.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var Mv = function(e) {
  var t = e.children, n = e.iconName, r = e.iconSize, a = e.isInvalid, i = e.isValid, o = e.onClick, s = e.showPassword, c = Ne("dl-input-icon-right");
  return V.createElement(
    "div",
    { className: c },
    t,
    V.createElement(
      "div",
      { className: "dl-icon-container" },
      V.createElement(ot, { name: s ? n || "" : a ? "x" : i ? "check" : n || "", size: r, role: s ? "button" : n || a || i ? "img" : "", onClick: o })
    )
  );
};
Mv.defaultProps = {
  iconSize: "md",
  showPassword: !1
};
var wv = V.forwardRef(function(e, t) {
  var n, r, a = e.name, i = e.type, o = e.defaultValue, s = e.value, c = e.className, l = e.size, u = e.placeholder, h = e.ariaLabel, p = e.iconName, f = e.showPassword, y = e.isValid, m = e.isInvalid, v = e.readOnly, k = e.onChange, b = e.onBlur, x = e.onClick, g = Le(e, ["name", "type", "defaultValue", "value", "className", "size", "placeholder", "ariaLabel", "iconName", "showPassword", "isValid", "isInvalid", "readOnly", "onChange", "onBlur", "onClick"]), w = Ct(zl).controlId, M = fe(!1), S = M[0], D = M[1], A = fe(!1), $ = A[0], F = A[1], Z = Ne("dl-form-control-container", (n = {}, n["dl-form-control-container-" + l] = l, n["dl-form-control-has-icon"] = p, n)), B = Ne("dl-form-control", (r = {}, r["dl-form-control-" + l] = l, r["dl-is-valid"] = y, r["dl-is-invalid"] = m, r["dl-form-control-filled"] = S, r), c), O = function(L) {
    D(!!L.target.value.trim());
  }, I = V.createElement("input", Te({ id: w || a, name: w || a, type: f && $ ? "text" : i, value: s, defaultValue: o, className: B, "aria-label": h, placeholder: u, readOnly: v, onChange: k, onClick: x, onBlur: function(L) {
    O(L), b && b(L);
  }, ref: t }, g)), N = function() {
    F(!$);
  }, R = V.createElement(Mv, { iconName: f && !$ ? "eye" : f && $ ? "eye-slash" : p, iconSize: l, isInvalid: m, isValid: y, showPassword: f, onClick: N }, I);
  return V.createElement("div", { className: Z }, R);
});
wv.defaultProps = {
  type: "text",
  size: "md",
  isValid: !1,
  isInvalid: !1,
  disabled: !1,
  readOnly: !1,
  showPassword: !1
};
wv.displayName = "Input";
var Cv = V.forwardRef(function(e, t) {
  var n = e.name, r = e.className, a = e.defaultValue, i = e.value, o = e.placeholder, s = e.ariaLabel, c = e.isValid, l = e.isInvalid, u = e.readOnly, h = e.onChange, p = e.onClick, f = e.onBlur, y = Le(e, ["name", "className", "defaultValue", "value", "placeholder", "ariaLabel", "isValid", "isInvalid", "readOnly", "onChange", "onClick", "onBlur"]), m = Ct(zl).controlId, v = fe(!1), k = v[0], b = v[1], x = Ne("dl-form-control-container dl-form-control-container-md"), g = Ne("dl-form-control dl-form-control-md", {
    "dl-is-valid": c,
    "dl-is-invalid": l,
    "dl-form-control-filled": k
  }, r), w = function(M) {
    b(!!M.target.value.trim());
  };
  return V.createElement(
    "div",
    { className: x },
    V.createElement("textarea", Te({ id: m ?? n, name: m ?? n, className: g, value: i, defaultValue: a, "aria-label": s, placeholder: o, readOnly: u, onChange: h, onClick: p, onBlur: function(M) {
      w(M), f && f(M);
    }, ref: t }, y))
  );
});
Cv.defaultProps = {
  isValid: !1,
  isInvalid: !1,
  disabled: !1,
  readOnly: !1
};
Cv.displayName = "Textarea";
var q8 = function(e) {
  var t = e.children, n = e.className, r = e.isValid, a = e.isInvalid, i = Le(e, ["children", "className", "isValid", "isInvalid"]), o = Ne("dl-feedback-container", n), s = Ne("dl-form-text", {
    "dl-valid-feedback": r,
    "dl-invalid-feedback": a
  });
  return V.createElement(
    "div",
    Te({ className: o }, i),
    V.createElement("div", { className: s }, t)
  );
};
q8.defaultProps = {
  isValid: !1,
  isInvalid: !1
};
var Sv = function(e) {
  var t = e.value, n = e.disabled, r = e.content, a = Le(e, ["value", "disabled", "content"]);
  return V.createElement("option", Te({ value: t, disabled: n }, a), r);
};
Sv.defaultProps = { disabled: !1 };
var np = V.forwardRef(function(e, t) {
  var n, r = e.name, a = e.size, i = e.defaultValue, o = e.value, s = e.className, c = e.isValid, l = e.isInvalid, u = e.disabled, h = e.children, p = e.onChange, f = e.onBlur, y = e.onClick, m = Le(e, ["name", "size", "defaultValue", "value", "className", "isValid", "isInvalid", "disabled", "children", "onChange", "onBlur", "onClick"]), v = Ct(zl).controlId, k = fe(!1), b = k[0], x = k[1], g = Ne("dl-select dl-form-control-container", (n = {}, n["dl-form-control-container-" + a] = a, n["dl-select-selected"] = b, n)), w = Ne("dl-form-control dl-form-control-md", {
    "dl-is-valid": c,
    "dl-is-invalid": l
  }, s), M = function(S) {
    S.target.value !== "" && S.target.value !== "0" ? x(!0) : x(!1);
  };
  return V.createElement(
    "div",
    { className: g },
    V.createElement("select", Te({ id: v || r, name: v || r, value: o, className: w, disabled: u, onChange: function(S) {
      M(S), p && p(S);
    }, onClick: y, onBlur: f, ref: t, defaultValue: i }, m), h)
  );
});
np.defaultProps = {
  size: "md",
  isValid: !1,
  isInvalid: !1,
  disabled: !1
};
np.Item = Sv;
np.displayName = "Select";
var Av = V.forwardRef(function(e, t) {
  var n = e.title, r = n === void 0 ? "Más" : n, a = e.className, i = e.disabled, o = i === void 0 ? !1 : i, s = e.isLoading, c = s === void 0 ? !1 : s, l = e.onClick, u = e.onBlur, h = Le(e, ["title", "className", "disabled", "isLoading", "onClick", "onBlur"]), p = Ne(a);
  return V.createElement(lr, Te({ variant: "primary", className: p, title: r, isIconOnly: !0, iconName: "plus", iconWeight: "bold", size: "sm", ref: t, disabled: o, isLoading: c, onClick: l, onBlur: u }, h));
});
Av.displayName = "InputAmountIncrease";
var Ov = Ae(function(e, t) {
  var n = e.title, r = n === void 0 ? "Menos" : n, a = e.className, i = e.disabled, o = i === void 0 ? !1 : i, s = e.isLoading, c = s === void 0 ? !1 : s, l = e.onClick, u = e.onBlur, h = Le(e, ["title", "className", "disabled", "isLoading", "onClick", "onBlur"]), p = Ne(a);
  return V.createElement(lr, Te({ variant: "secondary", title: r, className: p, isIconOnly: !0, iconName: "minus", size: "sm", ref: t, disabled: o, onClick: l, onBlur: u, isLoading: c }, h));
});
Ov.displayName = "InputAmountDecrease";
var Ev = Ae(function(e, t) {
  var n = e.type, r = n === void 0 ? "text" : n, a = e.value, i = e.min, o = i === void 0 ? 1 : i, s = e.max, c = s === void 0 ? 9999 : s, l = e.className, u = e.readOnly, h = u === void 0 ? !1 : u, p = e.disabled, f = p === void 0 ? !1 : p, y = e.onChange, m = e.onBlur, v = e.onClick, k = e.isLoading, b = k === void 0 ? !1 : k, x = Le(e, ["type", "value", "min", "max", "className", "readOnly", "disabled", "onChange", "onBlur", "onClick", "isLoading"]), g = Ne("dl-form-control dl-form-control-md dl-input-field", {
    "dl-is-disabled": b || f
  }, l);
  return V.createElement(
    "label",
    null,
    V.createElement("input", Te({ className: g, type: r, max: c, min: o, maxLength: c.toString().length, value: a, pattern: "[0-9]*", ref: t, disabled: f || b, readOnly: h, onChange: y, onClick: v, onBlur: m }, x))
  );
});
Ev.displayName = "InputAmountInput";
var Yl = Ae(function(e, t) {
  var n = e.className, r = e.children, a = Le(e, ["className", "children"]), i = Ne("dl-input-amount", {}, n);
  return V.createElement("div", Te({ className: i, ref: t }, a), r);
});
Yl.BtnIncrease = Av;
Yl.BtnDecrease = Ov;
Yl.Input = Ev;
Yl.displayName = "InputAmount";
var Iv = V.forwardRef(function(e, t) {
  var n, r = e.children, a = e.variant, i = e.className, o = e.href, s = e.hasIcon, c = e.onClick, l = e.onFocus, u = e.onBlur, h = e.disabled, p = Le(e, ["children", "variant", "className", "href", "hasIcon", "onClick", "onFocus", "onBlur", "disabled"]), f = Ne("dl-link", (n = {}, n["dl-link-" + a] = a, n["dl-disabled"] = o && h, n["dl-link-icon-" + s] = s, n), i), y = function(m) {
    return V.createElement(ot, { name: m, size: "sm" });
  };
  return V.createElement(ua, null, o ? V.createElement(
    "a",
    Te({ className: f, href: Yh.sanitizeUrl(o), onClick: c, onFocus: l, onBlur: u, rel: p.target === "_blank" ? "noopener noreferrer" : void 0 }, p),
    s === "left" && y("caret-left"),
    r,
    s === "right" && y("caret-right")
  ) : V.createElement(
    "button",
    Te({ className: f, disabled: h, onClick: c, onFocus: l, onBlur: u, ref: t }, p),
    s === "left" && y("caret-left"),
    r,
    s === "right" && y("caret-right")
  ));
});
Iv.displayName = "Link";
Iv.defaultProps = {
  variant: "default",
  disabled: !1
};
var _8 = Ae(function(e, t) {
  var n, r = e.name, a = r === void 0 ? "s" : r, i = e.className, o = e.value, s = e.size, c = s === void 0 ? "md" : s, l = e.placeholder, u = e.ariaLabel, h = u === void 0 ? "Buscador" : u, p = e.onChange, f = e.onClick, y = e.onBlur, m = e.onDeleteContent, v = Le(e, ["name", "className", "value", "size", "placeholder", "ariaLabel", "onChange", "onClick", "onBlur", "onDeleteContent"]), k = Ne(" dl-searchbox", (n = {}, n["dl-searchbox-" + c] = c, n), i);
  return V.createElement(
    "div",
    Te({ className: k }, v),
    V.createElement(
      "div",
      { className: "dl-searchbox-icon-left" },
      V.createElement(ot, { name: "magnifying-glass", size: c, role: "img", title: "Search" })
    ),
    V.createElement("input", { className: "dl-form-control", type: "search", name: a, value: o, "aria-label": h, placeholder: l, ref: t, onChange: p, onClick: f, onBlur: y }),
    V.createElement("div", { className: "dl-searchbox-icon-right" }, !!o && V.createElement(ot, { name: "x", size: "sm", role: "button", onClick: function(b) {
      m && m(b);
    } }))
  );
});
_8.displayName = "SearchBox";
var Dv = V.forwardRef(function(e, t) {
  var n, r = e.variant, a = e.textOnly, i = e.className, o = e.children, s = Le(e, ["variant", "textOnly", "className", "children"]), c = Ne("dl-section-message", (n = {}, n["dl-message-" + r] = r, n), i), l;
  return r === "positive" && (l = "👍"), r === "warning" && (l = "☝️"), r === "negative" && (l = "🚫"), V.createElement(
    "div",
    Te({ className: c, ref: t }, s),
    !a && V.createElement("div", { className: "dl-section-message-icon" }, l),
    V.createElement("div", { className: "dl-section-message-text" }, o)
  );
});
Dv.defaultProps = {
  variant: "positive",
  textOnly: !1
};
Dv.displayName = "SectionMessage";
$n({});
var G8 = V.forwardRef(function(e, t) {
  var n, r = e.variant, a = r === void 0 ? "positive" : r, i = e.isOpen, o = i === void 0 ? !1 : i, s = e.isLongMessage, c = s === void 0 ? !1 : s, l = e.autoHideDuration, u = l === void 0 ? 4500 : l, h = e.action, p = h === void 0 ? "Cerrar" : h, f = e.animationIn, y = e.animationOut, m = e.className, v = e.onClose, k = e.children, b = Le(e, ["variant", "isOpen", "isLongMessage", "autoHideDuration", "action", "animationIn", "animationOut", "className", "onClose", "children"]), x = Ne("dl-snackbar", (n = {}, n["dl-snackbar-" + a] = a, n["dl-snackbar-long-text"] = c, n), m), g = fe(!1), w = g[0], M = g[1], S = fe(100), D = S[0], A = S[1], $ = V.useRef(), F = V.useRef(), Z = function() {
    clearInterval(F.current);
  }, B = function() {
    var R = u;
    Z(), F.current = window.setInterval(function() {
      R <= -1 ? Z() : A(R / u), R -= 1e3;
    }, 10);
  }, O = function() {
    for (var R = [], L = 0; L < arguments.length; L++)
      R[L] = arguments[L];
    v && v.apply(void 0, R);
  }, I = function(R) {
    !v || R == null || (B(), clearTimeout($.current), $.current = window.setTimeout(function() {
      O("timeout");
    }, R));
  };
  be(function() {
    return o && (M(!0), A(100), I(u)), function() {
      clearTimeout($.current);
    };
  }, [o]);
  var N = function() {
    o || (M(!1), A(100), clearTimeout($.current), clearInterval(F.current));
  };
  return V.createElement(V.Fragment, null, w ? V.createElement(
    "div",
    Te({ className: x, ref: t, style: {
      animation: (o ? f || "snackbarFadein" : y || "snackbarFadeout") + " 250ms linear"
    }, onAnimationEnd: N }, b),
    V.createElement(
      "div",
      { className: "dl-snackbar-progress-bar" },
      V.createElement("div", { className: "dl-progress-counter", style: {
        width: D + "%",
        transition: "width " + u + "ms linear"
      } })
    ),
    V.createElement(
      "div",
      { className: "dl-snackbar-content-info" },
      V.createElement("div", { className: "dl-snackbar-text" }, k),
      V.createElement(lr, { variant: "tertiary", size: "xs", onClick: O }, p)
    )
  ) : null);
});
G8.displayName = "Snackbar";
const Z8 = (e) => {
  switch (e.size) {
    case "xs":
      return e.theme.fontSizeNano;
    case "sm":
      return e.theme.fontSizeXxxs;
    case "md":
      return e.theme.fontSizeXs;
    case "lg":
      return e.theme.fontSizeSm;
  }
}, X8 = G.a`
  font-family: ${(e) => e.theme.fontFamilyRegular};
  font-weight: ${(e) => e.theme.fontWeightRegular};
  color: ${(e) => e.theme.brandHighlightMedium};
  background-color: transparent;
  cursor: pointer;
  display: flex;
  width: fit-content;
  div {
    line-height: 1;
  }
  ${(e) => e.disabled && ke`
      pointer-events: none;
      cursor: default;
      text-decoration: none;
      color: ${(t) => t.theme.colorNeutralDark};
    `}
  &:active {
    color: ${(e) => e.theme.brandHighlightDark};
    ${(e) => e.disabled && ke`
        color: ${(t) => t.theme.colorNeutralDark};
      `}
  }
  &:focus {
    color: ${(e) => e.theme.brandHighlightDark};
    ${(e) => e.disabled && ke`
        color: ${(t) => t.theme.colorNeutralDark};
      `}
  }
  &:hover {
    color: ${(e) => e.theme.brandHighlightDark};
    ${(e) => e.disabled && ke`
        color: ${(t) => t.theme.colorNeutralDark};
      `}
  }
`, U8 = G.div`
  font-family: ${(e) => e.theme.fontFamilyRegular};
  font-size: ${(e) => e.theme.fontSizeNano};
  line-height: ${(e) => e.theme.lineHeightConfy};
  margin-right: ${(e) => e.theme.spacingInlineQuarckRem};
  font-size: ${Z8};
  align-items: center;
  display: flex;
`, S4e = ({ message: e, icon: t = "", size: n = "sm", disabled: r, children: a, ...i }) => /* @__PURE__ */ ie(X8, { disabled: r, ...i, children: [
  /* @__PURE__ */ C(U8, { size: n, children: e || a }),
  /* @__PURE__ */ C(ot, { name: t, size: n, "data-testid": "buttonLinkIcon" })
] }), Tv = ke`
  outline: 0;
  padding-right: 8px;
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  z-index: 0;
  margin-top: 0;
  margin-bottom: 0;
  p {
    line-height: 1.5;
    margin-top: 0;
    margin-bottom: 0;
  }
  & > p {
    margin-top: 0.5rem;
    margin-bottom: 0;
  }
  h1 {
    font-size: 3rem;
  }
  h2 {
    font-size: 2rem;
  }
  h3 {
    font-size: 1.5rem;
  }
  h4 {
    font-size: 1.25rem;
  }
  h5 {
    font-size: 1rem;
  }
  h6 {
    font-size: 0.875rem;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: ${(e) => e.theme.fontFamilyBold};
    margin-top: 0;
    margin-bottom: 0;
  }
  h1,
  h2,
  h3 {
    margin-top: 1rem;
  }
  h4,
  h5,
  h6 {
    margin-top: 0.5rem;
  }
  a {
    color: #3182ce;
    font-family: ${(e) => e.theme.fontFamilyBold} !important;
    cursor: pointer;
  }
  strong {
    font-family: ${(e) => e.theme.fontFamilyBold} !important;
  }
  mark {
    background-color: #f56565;
    text-decoration: inherit;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    padding-left: 0;
  }
  & img {
    height: auto;
    width: 100%;
    max-width: 100%;
  }
  [data-type='horizontalRule'] {
    margin-top: 2rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    transition-duration: 0.1s;
    transition-timing-function: ease-in-out;
    cursor: pointer;
    &.ProseMirror-selectednode {
      background-color: rgba(0, 0, 0, 0.05);
      hr {
        border-top-color: rgba(0, 0, 0, 0.3);
      }
    }
    &:hover:not(&.ProseMirror-selectednode) {
      background-color: rgba(0, 0, 0, 0.05);
    }
    hr {
      border: 0;
      border-top: 1px solid rgba(0, 0, 0, 0.2);
      background-color: rgba(0, 0, 0, 0.8);
    }
  }
  & > * {
    margin-left: auto;
    margin-right: auto;
    max-width: 2xl;
  }
  .selection {
    display: inline;
  }
  .selection,
  *::selection {
    /* background-color: rgba(0, 0, 0, 0.1); */
  }
  & > .react-renderer {
    margin-top: 2.25rem;
    margin-bottom: 0;
  }
  &.resize-cursor {
    cursor: col-resize;
  }
  ol {
    list-style-type: decimal;
  }
  ul {
    list-style-type: disc;
  }
  ul,
  ol {
    padding-top: 0;
    padding-right: 8px;
    padding-bottom: 0;
    padding-left: 8px;
    margin-top: 1rem;
    margin-bottom: 0;
    ul,
    ol,
    li {
      margin-top: 0.25rem;
    }
    p {
      margin-top: 0;
      margin-bottom: 0.25rem;
    }
  }
  & > ul,
  & > ol {
    margin-top: 1rem;
    margin-bottom: 0;
  }
  ul[data-type='taskList'] {
    list-style-type: none;
    padding: 0;
    p {
      margin: 0;
    }
    li {
      display: flex;
      > label {
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: auto;
        margin-top: 0.25rem;
        margin-right: 0.5rem;
        user-select: none;
      }
      > div {
        flex-grow: 1;
      }
      &[data-checked='true'] {
        text-decoration: line-through;
      }
    }
  }
  /* Placeholder Styles */
  .is-empty::before {
    content: '';
    float: left;
    pointer-events: none;
    height: 0;
    width: 100%;
  }
  &.ProseMirror-focused {
    /* Slashmenu Placeholder */
    > p.has-focus.is-empty::before {
      content: 'Escribe / para ver las opciones';
    }
    > [data-type='columns'] > [data-type='column'] > p.is-empty.has-focus::before {
      content: 'Escribe / para ver las opciones';
    }
  }
  /* Default Placeholder */
  & > .is-editor-empty::before {
    content: 'Click aquí para empezar a escribir…';
  }
  /* Blockquote Placeholder */
  blockquote .is-empty:not(.is-editor-empty):first-child:last-child::before {
    content: '';
  }
  blockquote + figcaption.is-empty:not(.is-editor-empty)::before {
    content: 'Author';
  }
  [data-placeholder][data-suggestion]::before,
  [data-placeholder][data-suggestion] *::before {
    content: none !important;
  }
  .is-empty::before {
    color: #a0aec0;
  }
  & > *:first-child,
  [data-type='column'] > * {
    margin-top: 0;
    margin-bottom: 0;
  }
  & > * + * {
    margin-top: 0.75em;
  }
  .node-imageUpload {
    border-radius: 0.25rem;
    border-width: 2px;
    border-style: dotted;
    border-color: rgba(0, 0, 0, 0.1);
    padding: 0.5rem;
    transition: border 160ms cubic-bezier(0.45, 0.05, 0.55, 0.95);
    &:hover {
      border-color: rgba(0, 0, 0, 0.3);
    }
    &:has(.is-active),
    &.has-focus {
      border-color: rgba(0, 0, 0, 0.4);
    }
  }
  [data-type='columns'] {
    &.has-focus [data-type='column'],
    &:hover [data-type='column'] {
      border-color: #e2e8f0;
    }
    [data-type='column'].has-focus {
      border-color: #cbd5e0;
    }
  }
  [data-type='column'] {
    border-radius: 0.25rem;
    border-width: 2px;
    border-style: dotted;
    border-color: transparent;
    padding: 0.25rem;
    transition: border 160ms cubic-bezier(0.45, 0.05, 0.55, 0.95);
    &:hover {
      border-color: #edf2f7;
    }
    &:has(.is-active),
    &.has-focus {
      border-color: #edf2f7;
    }
  }
  .node-imageBlock {
    & img {
      border-width: 2px;
      border-style: solid;
      border-color: transparent;
      border-radius: 0.25rem;
    }
    &:hover img {
      border-width: 2px;
      border-color: #edf2f7;
    }
    &:has(.is-active) img,
    &.has-focus img {
      border-width: 2px;
      border-color: #2d3748;
    }
  }
  .node-aiWriter,
  .node-aiImage,
  .node-tableOfContentsNode {
    &.has-focus [data-node-view-wrapper] > * {
      box-shadow: 0 0 2px rgba(0, 0, 0, 0.3), 0 0 2px rgba(0, 0, 0, 0.3);
    }
  }
  .ProseMirror-gapcursor + .node-imageBlock,
  .ProseMirror-gapcursor + .node-imageUpload,
  .ProseMirror-gapcursor + [data-type='blockquoteFigure'] {
    outline-color: #4a5568;
    &:hover {
      outline-color: #2d3748;
    }
  }
  [data-type='blockquoteFigure'] > div {
    border-left-width: 4px;
    border-left-color: #4a5568;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    background-color: rgba(0, 0, 0, 0.8);
  }
  [data-type='blockquoteFigure'] > blockquote {
    font-size: 1.25rem;
    color: #000;
  }
  [data-type='blockquoteFigure'] figcaption {
    font-size: 0.875rem;
    color: #a0aec0;
    margin-top: 1rem;
    transition: all;
    overflow: hidden;
  }
`, Y8 = G.div`
  .ProseMirror {
    ${Tv}
  }
`, J8 = G.div`
  ${Tv}
`, A4e = ({ children: e, ...t }) => /* @__PURE__ */ C(J8, { ...t, children: e });
function pt(e) {
  this.content = e;
}
pt.prototype = {
  constructor: pt,
  find: function(e) {
    for (var t = 0; t < this.content.length; t += 2)
      if (this.content[t] === e)
        return t;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(e) {
    var t = this.find(e);
    return t == -1 ? void 0 : this.content[t + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(e, t, n) {
    var r = n && n != e ? this.remove(n) : this, a = r.find(e), i = r.content.slice();
    return a == -1 ? i.push(n || e, t) : (i[a + 1] = t, n && (i[a] = n)), new pt(i);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(e) {
    var t = this.find(e);
    if (t == -1)
      return this;
    var n = this.content.slice();
    return n.splice(t, 2), new pt(n);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(e, t) {
    return new pt([e, t].concat(this.remove(e).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(e, t) {
    var n = this.remove(e).content.slice();
    return n.push(e, t), new pt(n);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(e, t, n) {
    var r = this.remove(t), a = r.content.slice(), i = r.find(e);
    return a.splice(i == -1 ? a.length : i, 0, t, n), new pt(a);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(e) {
    for (var t = 0; t < this.content.length; t += 2)
      e(this.content[t], this.content[t + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(e) {
    return e = pt.from(e), e.size ? new pt(e.content.concat(this.subtract(e).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(e) {
    return e = pt.from(e), e.size ? new pt(this.subtract(e).content.concat(e.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(e) {
    var t = this;
    e = pt.from(e);
    for (var n = 0; n < e.content.length; n += 2)
      t = t.remove(e.content[n]);
    return t;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var e = {};
    return this.forEach(function(t, n) {
      e[t] = n;
    }), e;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
pt.from = function(e) {
  if (e instanceof pt)
    return e;
  var t = [];
  if (e)
    for (var n in e)
      t.push(n, e[n]);
  return new pt(t);
};
function Nv(e, t, n) {
  for (let r = 0; ; r++) {
    if (r == e.childCount || r == t.childCount)
      return e.childCount == t.childCount ? null : n;
    let a = e.child(r), i = t.child(r);
    if (a == i) {
      n += a.nodeSize;
      continue;
    }
    if (!a.sameMarkup(i))
      return n;
    if (a.isText && a.text != i.text) {
      for (let o = 0; a.text[o] == i.text[o]; o++)
        n++;
      return n;
    }
    if (a.content.size || i.content.size) {
      let o = Nv(a.content, i.content, n + 1);
      if (o != null)
        return o;
    }
    n += a.nodeSize;
  }
}
function Pv(e, t, n, r) {
  for (let a = e.childCount, i = t.childCount; ; ) {
    if (a == 0 || i == 0)
      return a == i ? null : { a: n, b: r };
    let o = e.child(--a), s = t.child(--i), c = o.nodeSize;
    if (o == s) {
      n -= c, r -= c;
      continue;
    }
    if (!o.sameMarkup(s))
      return { a: n, b: r };
    if (o.isText && o.text != s.text) {
      let l = 0, u = Math.min(o.text.length, s.text.length);
      for (; l < u && o.text[o.text.length - l - 1] == s.text[s.text.length - l - 1]; )
        l++, n--, r--;
      return { a: n, b: r };
    }
    if (o.content.size || s.content.size) {
      let l = Pv(o.content, s.content, n - 1, r - 1);
      if (l)
        return l;
    }
    n -= c, r -= c;
  }
}
class oe {
  /**
  @internal
  */
  constructor(t, n) {
    if (this.content = t, this.size = n || 0, n == null)
      for (let r = 0; r < t.length; r++)
        this.size += t[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(t, n, r, a = 0, i) {
    for (let o = 0, s = 0; s < n; o++) {
      let c = this.content[o], l = s + c.nodeSize;
      if (l > t && r(c, a + s, i || null, o) !== !1 && c.content.size) {
        let u = s + 1;
        c.nodesBetween(Math.max(0, t - u), Math.min(c.content.size, n - u), r, a + u);
      }
      s = l;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(t) {
    this.nodesBetween(0, this.size, t);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(t, n, r, a) {
    let i = "", o = !0;
    return this.nodesBetween(t, n, (s, c) => {
      let l = s.isText ? s.text.slice(Math.max(t, c) - c, n - c) : s.isLeaf ? a ? typeof a == "function" ? a(s) : a : s.type.spec.leafText ? s.type.spec.leafText(s) : "" : "";
      s.isBlock && (s.isLeaf && l || s.isTextblock) && r && (o ? o = !1 : i += r), i += l;
    }, 0), i;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(t) {
    if (!t.size)
      return this;
    if (!this.size)
      return t;
    let n = this.lastChild, r = t.firstChild, a = this.content.slice(), i = 0;
    for (n.isText && n.sameMarkup(r) && (a[a.length - 1] = n.withText(n.text + r.text), i = 1); i < t.content.length; i++)
      a.push(t.content[i]);
    return new oe(a, this.size + t.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(t, n = this.size) {
    if (t == 0 && n == this.size)
      return this;
    let r = [], a = 0;
    if (n > t)
      for (let i = 0, o = 0; o < n; i++) {
        let s = this.content[i], c = o + s.nodeSize;
        c > t && ((o < t || c > n) && (s.isText ? s = s.cut(Math.max(0, t - o), Math.min(s.text.length, n - o)) : s = s.cut(Math.max(0, t - o - 1), Math.min(s.content.size, n - o - 1))), r.push(s), a += s.nodeSize), o = c;
      }
    return new oe(r, a);
  }
  /**
  @internal
  */
  cutByIndex(t, n) {
    return t == n ? oe.empty : t == 0 && n == this.content.length ? this : new oe(this.content.slice(t, n));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(t, n) {
    let r = this.content[t];
    if (r == n)
      return this;
    let a = this.content.slice(), i = this.size + n.nodeSize - r.nodeSize;
    return a[t] = n, new oe(a, i);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(t) {
    return new oe([t].concat(this.content), this.size + t.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(t) {
    return new oe(this.content.concat(t), this.size + t.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(t) {
    if (this.content.length != t.content.length)
      return !1;
    for (let n = 0; n < this.content.length; n++)
      if (!this.content[n].eq(t.content[n]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(t) {
    let n = this.content[t];
    if (!n)
      throw new RangeError("Index " + t + " out of range for " + this);
    return n;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(t) {
    return this.content[t] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(t) {
    for (let n = 0, r = 0; n < this.content.length; n++) {
      let a = this.content[n];
      t(a, r, n), r += a.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(t, n = 0) {
    return Nv(this, t, n);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(t, n = this.size, r = t.size) {
    return Pv(this, t, n, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. (Not public.)
  */
  findIndex(t, n = -1) {
    if (t == 0)
      return Es(0, t);
    if (t == this.size)
      return Es(this.content.length, t);
    if (t > this.size || t < 0)
      throw new RangeError(`Position ${t} outside of fragment (${this})`);
    for (let r = 0, a = 0; ; r++) {
      let i = this.child(r), o = a + i.nodeSize;
      if (o >= t)
        return o == t || n > 0 ? Es(r + 1, o) : Es(r, a);
      a = o;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((t) => t.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      return oe.empty;
    if (!Array.isArray(n))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new oe(n.map(t.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(t) {
    if (!t.length)
      return oe.empty;
    let n, r = 0;
    for (let a = 0; a < t.length; a++) {
      let i = t[a];
      r += i.nodeSize, a && i.isText && t[a - 1].sameMarkup(i) ? (n || (n = t.slice(0, a)), n[n.length - 1] = i.withText(n[n.length - 1].text + i.text)) : n && n.push(i);
    }
    return new oe(n || t, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(t) {
    if (!t)
      return oe.empty;
    if (t instanceof oe)
      return t;
    if (Array.isArray(t))
      return this.fromArray(t);
    if (t.attrs)
      return new oe([t], t.nodeSize);
    throw new RangeError("Can not convert " + t + " to a Fragment" + (t.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
oe.empty = new oe([], 0);
const nd = { index: 0, offset: 0 };
function Es(e, t) {
  return nd.index = e, nd.offset = t, nd;
}
function Ec(e, t) {
  if (e === t)
    return !0;
  if (!(e && typeof e == "object") || !(t && typeof t == "object"))
    return !1;
  let n = Array.isArray(e);
  if (Array.isArray(t) != n)
    return !1;
  if (n) {
    if (e.length != t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!Ec(e[r], t[r]))
        return !1;
  } else {
    for (let r in e)
      if (!(r in t) || !Ec(e[r], t[r]))
        return !1;
    for (let r in t)
      if (!(r in e))
        return !1;
  }
  return !0;
}
let qe = class vu {
  /**
  @internal
  */
  constructor(t, n) {
    this.type = t, this.attrs = n;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(t) {
    let n, r = !1;
    for (let a = 0; a < t.length; a++) {
      let i = t[a];
      if (this.eq(i))
        return t;
      if (this.type.excludes(i.type))
        n || (n = t.slice(0, a));
      else {
        if (i.type.excludes(this.type))
          return t;
        !r && i.type.rank > this.type.rank && (n || (n = t.slice(0, a)), n.push(this), r = !0), n && n.push(i);
      }
    }
    return n || (n = t.slice()), r || n.push(this), n;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(t) {
    for (let n = 0; n < t.length; n++)
      if (this.eq(t[n]))
        return t.slice(0, n).concat(t.slice(n + 1));
    return t;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(t) {
    for (let n = 0; n < t.length; n++)
      if (this.eq(t[n]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(t) {
    return this == t || this.type == t.type && Ec(this.attrs, t.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let t = { type: this.type.name };
    for (let n in this.attrs) {
      t.attrs = this.attrs;
      break;
    }
    return t;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(t, n) {
    if (!n)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = t.marks[n.type];
    if (!r)
      throw new RangeError(`There is no mark type ${n.type} in this schema`);
    return r.create(n.attrs);
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(t, n) {
    if (t == n)
      return !0;
    if (t.length != n.length)
      return !1;
    for (let r = 0; r < t.length; r++)
      if (!t[r].eq(n[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(t) {
    if (!t || Array.isArray(t) && t.length == 0)
      return vu.none;
    if (t instanceof vu)
      return [t];
    let n = t.slice();
    return n.sort((r, a) => r.type.rank - a.type.rank), n;
  }
};
qe.none = [];
class Ic extends Error {
}
let ye = class $a {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(t, n, r) {
    this.content = t, this.openStart = n, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(t, n) {
    let r = Rv(this.content, t + this.openStart, n);
    return r && new $a(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(t, n) {
    return new $a(Lv(this.content, t + this.openStart, n + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(t) {
    return this.content.eq(t.content) && this.openStart == t.openStart && this.openEnd == t.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let t = { content: this.content.toJSON() };
    return this.openStart > 0 && (t.openStart = this.openStart), this.openEnd > 0 && (t.openEnd = this.openEnd), t;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      return $a.empty;
    let r = n.openStart || 0, a = n.openEnd || 0;
    if (typeof r != "number" || typeof a != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new $a(oe.fromJSON(t, n.content), r, a);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(t, n = !0) {
    let r = 0, a = 0;
    for (let i = t.firstChild; i && !i.isLeaf && (n || !i.type.spec.isolating); i = i.firstChild)
      r++;
    for (let i = t.lastChild; i && !i.isLeaf && (n || !i.type.spec.isolating); i = i.lastChild)
      a++;
    return new $a(t, r, a);
  }
};
ye.empty = new ye(oe.empty, 0, 0);
function Lv(e, t, n) {
  let { index: r, offset: a } = e.findIndex(t), i = e.maybeChild(r), { index: o, offset: s } = e.findIndex(n);
  if (a == t || i.isText) {
    if (s != n && !e.child(o).isText)
      throw new RangeError("Removing non-flat range");
    return e.cut(0, t).append(e.cut(n));
  }
  if (r != o)
    throw new RangeError("Removing non-flat range");
  return e.replaceChild(r, i.copy(Lv(i.content, t - a - 1, n - a - 1)));
}
function Rv(e, t, n, r) {
  let { index: a, offset: i } = e.findIndex(t), o = e.maybeChild(a);
  if (i == t || o.isText)
    return r && !r.canReplace(a, a, n) ? null : e.cut(0, t).append(n).append(e.cut(t));
  let s = Rv(o.content, t - i - 1, n);
  return s && e.replaceChild(a, o.copy(s));
}
function K8(e, t, n) {
  if (n.openStart > e.depth)
    throw new Ic("Inserted content deeper than insertion position");
  if (e.depth - n.openStart != t.depth - n.openEnd)
    throw new Ic("Inconsistent open depths");
  return Vv(e, t, n, 0);
}
function Vv(e, t, n, r) {
  let a = e.index(r), i = e.node(r);
  if (a == t.index(r) && r < e.depth - n.openStart) {
    let o = Vv(e, t, n, r + 1);
    return i.copy(i.content.replaceChild(a, o));
  } else if (n.content.size)
    if (!n.openStart && !n.openEnd && e.depth == r && t.depth == r) {
      let o = e.parent, s = o.content;
      return ra(o, s.cut(0, e.parentOffset).append(n.content).append(s.cut(t.parentOffset)));
    } else {
      let { start: o, end: s } = Q8(n, e);
      return ra(i, Bv(e, o, s, t, r));
    }
  else
    return ra(i, Dc(e, t, r));
}
function zv(e, t) {
  if (!t.type.compatibleContent(e.type))
    throw new Ic("Cannot join " + t.type.name + " onto " + e.type.name);
}
function ku(e, t, n) {
  let r = e.node(n);
  return zv(r, t.node(n)), r;
}
function na(e, t) {
  let n = t.length - 1;
  n >= 0 && e.isText && e.sameMarkup(t[n]) ? t[n] = e.withText(t[n].text + e.text) : t.push(e);
}
function Qi(e, t, n, r) {
  let a = (t || e).node(n), i = 0, o = t ? t.index(n) : a.childCount;
  e && (i = e.index(n), e.depth > n ? i++ : e.textOffset && (na(e.nodeAfter, r), i++));
  for (let s = i; s < o; s++)
    na(a.child(s), r);
  t && t.depth == n && t.textOffset && na(t.nodeBefore, r);
}
function ra(e, t) {
  return e.type.checkContent(t), e.copy(t);
}
function Bv(e, t, n, r, a) {
  let i = e.depth > a && ku(e, t, a + 1), o = r.depth > a && ku(n, r, a + 1), s = [];
  return Qi(null, e, a, s), i && o && t.index(a) == n.index(a) ? (zv(i, o), na(ra(i, Bv(e, t, n, r, a + 1)), s)) : (i && na(ra(i, Dc(e, t, a + 1)), s), Qi(t, n, a, s), o && na(ra(o, Dc(n, r, a + 1)), s)), Qi(r, null, a, s), new oe(s);
}
function Dc(e, t, n) {
  let r = [];
  if (Qi(null, e, n, r), e.depth > n) {
    let a = ku(e, t, n + 1);
    na(ra(a, Dc(e, t, n + 1)), r);
  }
  return Qi(t, null, n, r), new oe(r);
}
function Q8(e, t) {
  let n = t.depth - e.openStart, a = t.node(n).copy(e.content);
  for (let i = n - 1; i >= 0; i--)
    a = t.node(i).copy(oe.from(a));
  return {
    start: a.resolveNoCache(e.openStart + n),
    end: a.resolveNoCache(a.content.size - e.openEnd - n)
  };
}
class mo {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.pos = t, this.path = n, this.parentOffset = r, this.depth = n.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(t) {
    return t == null ? this.depth : t < 0 ? this.depth + t : t;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(t) {
    return this.path[this.resolveDepth(t) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(t) {
    return this.path[this.resolveDepth(t) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(t) {
    return t = this.resolveDepth(t), this.index(t) + (t == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(t) {
    return t = this.resolveDepth(t), t == 0 ? 0 : this.path[t * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(t) {
    return t = this.resolveDepth(t), this.start(t) + this.node(t).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(t) {
    if (t = this.resolveDepth(t), !t)
      throw new RangeError("There is no position before the top-level node");
    return t == this.depth + 1 ? this.pos : this.path[t * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(t) {
    if (t = this.resolveDepth(t), !t)
      throw new RangeError("There is no position after the top-level node");
    return t == this.depth + 1 ? this.pos : this.path[t * 3 - 1] + this.path[t * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let t = this.parent, n = this.index(this.depth);
    if (n == t.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], a = t.child(n);
    return r ? t.child(n).cut(r) : a;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let t = this.index(this.depth), n = this.pos - this.path[this.path.length - 1];
    return n ? this.parent.child(t).cut(0, n) : t == 0 ? null : this.parent.child(t - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(t, n) {
    n = this.resolveDepth(n);
    let r = this.path[n * 3], a = n == 0 ? 0 : this.path[n * 3 - 1] + 1;
    for (let i = 0; i < t; i++)
      a += r.child(i).nodeSize;
    return a;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let t = this.parent, n = this.index();
    if (t.content.size == 0)
      return qe.none;
    if (this.textOffset)
      return t.child(n).marks;
    let r = t.maybeChild(n - 1), a = t.maybeChild(n);
    if (!r) {
      let s = r;
      r = a, a = s;
    }
    let i = r.marks;
    for (var o = 0; o < i.length; o++)
      i[o].type.spec.inclusive === !1 && (!a || !i[o].isInSet(a.marks)) && (i = i[o--].removeFromSet(i));
    return i;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(t) {
    let n = this.parent.maybeChild(this.index());
    if (!n || !n.isInline)
      return null;
    let r = n.marks, a = t.parent.maybeChild(t.index());
    for (var i = 0; i < r.length; i++)
      r[i].type.spec.inclusive === !1 && (!a || !r[i].isInSet(a.marks)) && (r = r[i--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(t) {
    for (let n = this.depth; n > 0; n--)
      if (this.start(n) <= t && this.end(n) >= t)
        return n;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(t = this, n) {
    if (t.pos < this.pos)
      return t.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == t.pos ? 1 : 0); r >= 0; r--)
      if (t.pos <= this.end(r) && (!n || n(this.node(r))))
        return new Tc(this, t, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(t) {
    return this.pos - this.parentOffset == t.pos - t.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(t) {
    return t.pos > this.pos ? t : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(t) {
    return t.pos < this.pos ? t : this;
  }
  /**
  @internal
  */
  toString() {
    let t = "";
    for (let n = 1; n <= this.depth; n++)
      t += (t ? "/" : "") + this.node(n).type.name + "_" + this.index(n - 1);
    return t + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(t, n) {
    if (!(n >= 0 && n <= t.content.size))
      throw new RangeError("Position " + n + " out of range");
    let r = [], a = 0, i = n;
    for (let o = t; ; ) {
      let { index: s, offset: c } = o.content.findIndex(i), l = i - c;
      if (r.push(o, s, a + c), !l || (o = o.child(s), o.isText))
        break;
      i = l - 1, a += c + 1;
    }
    return new mo(n, r, i);
  }
  /**
  @internal
  */
  static resolveCached(t, n) {
    for (let a = 0; a < rd.length; a++) {
      let i = rd[a];
      if (i.pos == n && i.doc == t)
        return i;
    }
    let r = rd[ad] = mo.resolve(t, n);
    return ad = (ad + 1) % e7, r;
  }
}
let rd = [], ad = 0, e7 = 12;
class Tc {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(t, n, r) {
    this.$from = t, this.$to = n, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const t7 = /* @__PURE__ */ Object.create(null);
let aa = class bu {
  /**
  @internal
  */
  constructor(t, n, r, a = qe.none) {
    this.type = t, this.attrs = n, this.marks = a, this.content = r || oe.empty;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(t) {
    return this.content.child(t);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(t) {
    return this.content.maybeChild(t);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(t) {
    this.content.forEach(t);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(t, n, r, a = 0) {
    this.content.nodesBetween(t, n, r, a, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(t) {
    this.nodesBetween(0, this.content.size, t);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(t, n, r, a) {
    return this.content.textBetween(t, n, r, a);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(t) {
    return this == t || this.sameMarkup(t) && this.content.eq(t.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(t) {
    return this.hasMarkup(t.type, t.attrs, t.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(t, n, r) {
    return this.type == t && Ec(this.attrs, n || t.defaultAttrs || t7) && qe.sameSet(this.marks, r || qe.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(t = null) {
    return t == this.content ? this : new bu(this.type, this.attrs, t, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(t) {
    return t == this.marks ? this : new bu(this.type, this.attrs, this.content, t);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(t, n = this.content.size) {
    return t == 0 && n == this.content.size ? this : this.copy(this.content.cut(t, n));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(t, n = this.content.size, r = !1) {
    if (t == n)
      return ye.empty;
    let a = this.resolve(t), i = this.resolve(n), o = r ? 0 : a.sharedDepth(n), s = a.start(o), l = a.node(o).content.cut(a.pos - s, i.pos - s);
    return new ye(l, a.depth - o, i.depth - o);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(t, n, r) {
    return K8(this.resolve(t), this.resolve(n), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(t) {
    for (let n = this; ; ) {
      let { index: r, offset: a } = n.content.findIndex(t);
      if (n = n.maybeChild(r), !n)
        return null;
      if (a == t || n.isText)
        return n;
      t -= a + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(t) {
    let { index: n, offset: r } = this.content.findIndex(t);
    return { node: this.content.maybeChild(n), index: n, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(t) {
    if (t == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: n, offset: r } = this.content.findIndex(t);
    if (r < t)
      return { node: this.content.child(n), index: n, offset: r };
    let a = this.content.child(n - 1);
    return { node: a, index: n - 1, offset: r - a.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(t) {
    return mo.resolveCached(this, t);
  }
  /**
  @internal
  */
  resolveNoCache(t) {
    return mo.resolve(this, t);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(t, n, r) {
    let a = !1;
    return n > t && this.nodesBetween(t, n, (i) => (r.isInSet(i.marks) && (a = !0), !a)), a;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let t = this.type.name;
    return this.content.size && (t += "(" + this.content.toStringInner() + ")"), Hv(this.marks, t);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(t) {
    let n = this.type.contentMatch.matchFragment(this.content, 0, t);
    if (!n)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return n;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(t, n, r = oe.empty, a = 0, i = r.childCount) {
    let o = this.contentMatchAt(t).matchFragment(r, a, i), s = o && o.matchFragment(this.content, n);
    if (!s || !s.validEnd)
      return !1;
    for (let c = a; c < i; c++)
      if (!this.type.allowsMarks(r.child(c).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(t, n, r, a) {
    if (a && !this.type.allowsMarks(a))
      return !1;
    let i = this.contentMatchAt(t).matchType(r), o = i && i.matchFragment(this.content, n);
    return o ? o.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(t) {
    return t.content.size ? this.canReplace(this.childCount, this.childCount, t.content) : this.type.compatibleContent(t.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise error when they do not.
  */
  check() {
    this.type.checkContent(this.content);
    let t = qe.none;
    for (let n = 0; n < this.marks.length; n++)
      t = this.marks[n].addToSet(t);
    if (!qe.sameSet(t, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((n) => n.type.name)}`);
    this.content.forEach((n) => n.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let t = { type: this.type.name };
    for (let n in this.attrs) {
      t.attrs = this.attrs;
      break;
    }
    return this.content.size && (t.content = this.content.toJSON()), this.marks.length && (t.marks = this.marks.map((n) => n.toJSON())), t;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r = null;
    if (n.marks) {
      if (!Array.isArray(n.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = n.marks.map(t.markFromJSON);
    }
    if (n.type == "text") {
      if (typeof n.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return t.text(n.text, r);
    }
    let a = oe.fromJSON(t, n.content);
    return t.nodeType(n.type).create(n.attrs, a, r);
  }
};
aa.prototype.text = void 0;
class Nc extends aa {
  /**
  @internal
  */
  constructor(t, n, r, a) {
    if (super(t, n, null, a), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : Hv(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(t, n) {
    return this.text.slice(t, n);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(t) {
    return t == this.marks ? this : new Nc(this.type, this.attrs, this.text, t);
  }
  withText(t) {
    return t == this.text ? this : new Nc(this.type, this.attrs, t, this.marks);
  }
  cut(t = 0, n = this.text.length) {
    return t == 0 && n == this.text.length ? this : this.withText(this.text.slice(t, n));
  }
  eq(t) {
    return this.sameMarkup(t) && this.text == t.text;
  }
  toJSON() {
    let t = super.toJSON();
    return t.text = this.text, t;
  }
}
function Hv(e, t) {
  for (let n = e.length - 1; n >= 0; n--)
    t = e[n].type.name + "(" + t + ")";
  return t;
}
class ha {
  /**
  @internal
  */
  constructor(t) {
    this.validEnd = t, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(t, n) {
    let r = new n7(t, n);
    if (r.next == null)
      return ha.empty;
    let a = $v(r);
    r.next && r.err("Unexpected trailing text");
    let i = l7(c7(a));
    return d7(i, r), i;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(t) {
    for (let n = 0; n < this.next.length; n++)
      if (this.next[n].type == t)
        return this.next[n].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(t, n = 0, r = t.childCount) {
    let a = this;
    for (let i = n; a && i < r; i++)
      a = a.matchType(t.child(i).type);
    return a;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let t = 0; t < this.next.length; t++) {
      let { type: n } = this.next[t];
      if (!(n.isText || n.hasRequiredAttrs()))
        return n;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(t) {
    for (let n = 0; n < this.next.length; n++)
      for (let r = 0; r < t.next.length; r++)
        if (this.next[n].type == t.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(t, n = !1, r = 0) {
    let a = [this];
    function i(o, s) {
      let c = o.matchFragment(t, r);
      if (c && (!n || c.validEnd))
        return oe.from(s.map((l) => l.createAndFill()));
      for (let l = 0; l < o.next.length; l++) {
        let { type: u, next: h } = o.next[l];
        if (!(u.isText || u.hasRequiredAttrs()) && a.indexOf(h) == -1) {
          a.push(h);
          let p = i(h, s.concat(u));
          if (p)
            return p;
        }
      }
      return null;
    }
    return i(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(t) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == t)
        return this.wrapCache[r + 1];
    let n = this.computeWrapping(t);
    return this.wrapCache.push(t, n), n;
  }
  /**
  @internal
  */
  computeWrapping(t) {
    let n = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let a = r.shift(), i = a.match;
      if (i.matchType(t)) {
        let o = [];
        for (let s = a; s.type; s = s.via)
          o.push(s.type);
        return o.reverse();
      }
      for (let o = 0; o < i.next.length; o++) {
        let { type: s, next: c } = i.next[o];
        !s.isLeaf && !s.hasRequiredAttrs() && !(s.name in n) && (!a.type || c.validEnd) && (r.push({ match: s.contentMatch, type: s, via: a }), n[s.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(t) {
    if (t >= this.next.length)
      throw new RangeError(`There's no ${t}th edge in this content match`);
    return this.next[t];
  }
  /**
  @internal
  */
  toString() {
    let t = [];
    function n(r) {
      t.push(r);
      for (let a = 0; a < r.next.length; a++)
        t.indexOf(r.next[a].next) == -1 && n(r.next[a].next);
    }
    return n(this), t.map((r, a) => {
      let i = a + (r.validEnd ? "*" : " ") + " ";
      for (let o = 0; o < r.next.length; o++)
        i += (o ? ", " : "") + r.next[o].type.name + "->" + t.indexOf(r.next[o].next);
      return i;
    }).join(`
`);
  }
}
ha.empty = new ha(!0);
class n7 {
  constructor(t, n) {
    this.string = t, this.nodeTypes = n, this.inline = null, this.pos = 0, this.tokens = t.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(t) {
    return this.next == t && (this.pos++ || !0);
  }
  err(t) {
    throw new SyntaxError(t + " (in content expression '" + this.string + "')");
  }
}
function $v(e) {
  let t = [];
  do
    t.push(r7(e));
  while (e.eat("|"));
  return t.length == 1 ? t[0] : { type: "choice", exprs: t };
}
function r7(e) {
  let t = [];
  do
    t.push(a7(e));
  while (e.next && e.next != ")" && e.next != "|");
  return t.length == 1 ? t[0] : { type: "seq", exprs: t };
}
function a7(e) {
  let t = s7(e);
  for (; ; )
    if (e.eat("+"))
      t = { type: "plus", expr: t };
    else if (e.eat("*"))
      t = { type: "star", expr: t };
    else if (e.eat("?"))
      t = { type: "opt", expr: t };
    else if (e.eat("{"))
      t = i7(e, t);
    else
      break;
  return t;
}
function N0(e) {
  /\D/.test(e.next) && e.err("Expected number, got '" + e.next + "'");
  let t = Number(e.next);
  return e.pos++, t;
}
function i7(e, t) {
  let n = N0(e), r = n;
  return e.eat(",") && (e.next != "}" ? r = N0(e) : r = -1), e.eat("}") || e.err("Unclosed braced range"), { type: "range", min: n, max: r, expr: t };
}
function o7(e, t) {
  let n = e.nodeTypes, r = n[t];
  if (r)
    return [r];
  let a = [];
  for (let i in n) {
    let o = n[i];
    o.groups.indexOf(t) > -1 && a.push(o);
  }
  return a.length == 0 && e.err("No node type or group '" + t + "' found"), a;
}
function s7(e) {
  if (e.eat("(")) {
    let t = $v(e);
    return e.eat(")") || e.err("Missing closing paren"), t;
  } else if (/\W/.test(e.next))
    e.err("Unexpected token '" + e.next + "'");
  else {
    let t = o7(e, e.next).map((n) => (e.inline == null ? e.inline = n.isInline : e.inline != n.isInline && e.err("Mixing inline and block content"), { type: "name", value: n }));
    return e.pos++, t.length == 1 ? t[0] : { type: "choice", exprs: t };
  }
}
function c7(e) {
  let t = [[]];
  return a(i(e, 0), n()), t;
  function n() {
    return t.push([]) - 1;
  }
  function r(o, s, c) {
    let l = { term: c, to: s };
    return t[o].push(l), l;
  }
  function a(o, s) {
    o.forEach((c) => c.to = s);
  }
  function i(o, s) {
    if (o.type == "choice")
      return o.exprs.reduce((c, l) => c.concat(i(l, s)), []);
    if (o.type == "seq")
      for (let c = 0; ; c++) {
        let l = i(o.exprs[c], s);
        if (c == o.exprs.length - 1)
          return l;
        a(l, s = n());
      }
    else if (o.type == "star") {
      let c = n();
      return r(s, c), a(i(o.expr, c), c), [r(c)];
    } else if (o.type == "plus") {
      let c = n();
      return a(i(o.expr, s), c), a(i(o.expr, c), c), [r(c)];
    } else {
      if (o.type == "opt")
        return [r(s)].concat(i(o.expr, s));
      if (o.type == "range") {
        let c = s;
        for (let l = 0; l < o.min; l++) {
          let u = n();
          a(i(o.expr, c), u), c = u;
        }
        if (o.max == -1)
          a(i(o.expr, c), c);
        else
          for (let l = o.min; l < o.max; l++) {
            let u = n();
            r(c, u), a(i(o.expr, c), u), c = u;
          }
        return [r(c)];
      } else {
        if (o.type == "name")
          return [r(s, void 0, o.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function jv(e, t) {
  return t - e;
}
function P0(e, t) {
  let n = [];
  return r(t), n.sort(jv);
  function r(a) {
    let i = e[a];
    if (i.length == 1 && !i[0].term)
      return r(i[0].to);
    n.push(a);
    for (let o = 0; o < i.length; o++) {
      let { term: s, to: c } = i[o];
      !s && n.indexOf(c) == -1 && r(c);
    }
  }
}
function l7(e) {
  let t = /* @__PURE__ */ Object.create(null);
  return n(P0(e, 0));
  function n(r) {
    let a = [];
    r.forEach((o) => {
      e[o].forEach(({ term: s, to: c }) => {
        if (!s)
          return;
        let l;
        for (let u = 0; u < a.length; u++)
          a[u][0] == s && (l = a[u][1]);
        P0(e, c).forEach((u) => {
          l || a.push([s, l = []]), l.indexOf(u) == -1 && l.push(u);
        });
      });
    });
    let i = t[r.join(",")] = new ha(r.indexOf(e.length - 1) > -1);
    for (let o = 0; o < a.length; o++) {
      let s = a[o][1].sort(jv);
      i.next.push({ type: a[o][0], next: t[s.join(",")] || n(s) });
    }
    return i;
  }
}
function d7(e, t) {
  for (let n = 0, r = [e]; n < r.length; n++) {
    let a = r[n], i = !a.validEnd, o = [];
    for (let s = 0; s < a.next.length; s++) {
      let { type: c, next: l } = a.next[s];
      o.push(c.name), i && !(c.isText || c.hasRequiredAttrs()) && (i = !1), r.indexOf(l) == -1 && r.push(l);
    }
    i && t.err("Only non-generatable nodes (" + o.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function Fv(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n in e) {
    let r = e[n];
    if (!r.hasDefault)
      return null;
    t[n] = r.default;
  }
  return t;
}
function Wv(e, t) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let r in e) {
    let a = t && t[r];
    if (a === void 0) {
      let i = e[r];
      if (i.hasDefault)
        a = i.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    n[r] = a;
  }
  return n;
}
function qv(e) {
  let t = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let n in e)
      t[n] = new u7(e[n]);
  return t;
}
let L0 = class _v {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.name = t, this.schema = n, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = qv(r.attrs), this.defaultAttrs = Fv(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || t == "text"), this.isText = t == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == ha.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let t in this.attrs)
      if (this.attrs[t].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(t) {
    return this == t || this.contentMatch.compatible(t.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(t) {
    return !t && this.defaultAttrs ? this.defaultAttrs : Wv(this.attrs, t);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(t = null, n, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new aa(this, this.computeAttrs(t), oe.from(n), qe.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(t = null, n, r) {
    return n = oe.from(n), this.checkContent(n), new aa(this, this.computeAttrs(t), n, qe.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(t = null, n, r) {
    if (t = this.computeAttrs(t), n = oe.from(n), n.size) {
      let o = this.contentMatch.fillBefore(n);
      if (!o)
        return null;
      n = o.append(n);
    }
    let a = this.contentMatch.matchFragment(n), i = a && a.fillBefore(oe.empty, !0);
    return i ? new aa(this, t, n.append(i), qe.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(t) {
    let n = this.contentMatch.matchFragment(t);
    if (!n || !n.validEnd)
      return !1;
    for (let r = 0; r < t.childCount; r++)
      if (!this.allowsMarks(t.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(t) {
    if (!this.validContent(t))
      throw new RangeError(`Invalid content for node ${this.name}: ${t.toString().slice(0, 50)}`);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(t) {
    return this.markSet == null || this.markSet.indexOf(t) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(t) {
    if (this.markSet == null)
      return !0;
    for (let n = 0; n < t.length; n++)
      if (!this.allowsMarkType(t[n].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(t) {
    if (this.markSet == null)
      return t;
    let n;
    for (let r = 0; r < t.length; r++)
      this.allowsMarkType(t[r].type) ? n && n.push(t[r]) : n || (n = t.slice(0, r));
    return n ? n.length ? n : qe.none : t;
  }
  /**
  @internal
  */
  static compile(t, n) {
    let r = /* @__PURE__ */ Object.create(null);
    t.forEach((i, o) => r[i] = new _v(i, n, o));
    let a = n.spec.topNode || "doc";
    if (!r[a])
      throw new RangeError("Schema is missing its top node type ('" + a + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let i in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
class u7 {
  constructor(t) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(t, "default"), this.default = t.default;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Jl {
  /**
  @internal
  */
  constructor(t, n, r, a) {
    this.name = t, this.rank = n, this.schema = r, this.spec = a, this.attrs = qv(a.attrs), this.excluded = null;
    let i = Fv(this.attrs);
    this.instance = i ? new qe(this, i) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(t = null) {
    return !t && this.instance ? this.instance : new qe(this, Wv(this.attrs, t));
  }
  /**
  @internal
  */
  static compile(t, n) {
    let r = /* @__PURE__ */ Object.create(null), a = 0;
    return t.forEach((i, o) => r[i] = new Jl(i, a++, n, o)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(t) {
    for (var n = 0; n < t.length; n++)
      t[n].type == this && (t = t.slice(0, n).concat(t.slice(n + 1)), n--);
    return t;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(t) {
    for (let n = 0; n < t.length; n++)
      if (t[n].type == this)
        return t[n];
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(t) {
    return this.excluded.indexOf(t) > -1;
  }
}
class h7 {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(t) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let n = this.spec = {};
    for (let a in t)
      n[a] = t[a];
    n.nodes = pt.from(t.nodes), n.marks = pt.from(t.marks || {}), this.nodes = L0.compile(this.spec.nodes, this), this.marks = Jl.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let a in this.nodes) {
      if (a in this.marks)
        throw new RangeError(a + " can not be both a node and a mark");
      let i = this.nodes[a], o = i.spec.content || "", s = i.spec.marks;
      if (i.contentMatch = r[o] || (r[o] = ha.parse(o, this.nodes)), i.inlineContent = i.contentMatch.inlineContent, i.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!i.isInline || !i.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = i;
      }
      i.markSet = s == "_" ? null : s ? R0(this, s.split(" ")) : s == "" || !i.inlineContent ? [] : null;
    }
    for (let a in this.marks) {
      let i = this.marks[a], o = i.spec.excludes;
      i.excluded = o == null ? [i] : o == "" ? [] : R0(this, o.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(t, n = null, r, a) {
    if (typeof t == "string")
      t = this.nodeType(t);
    else if (t instanceof L0) {
      if (t.schema != this)
        throw new RangeError("Node type from different schema used (" + t.name + ")");
    } else
      throw new RangeError("Invalid node type: " + t);
    return t.createChecked(n, r, a);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(t, n) {
    let r = this.nodes.text;
    return new Nc(r, r.defaultAttrs, t, qe.setFrom(n));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(t, n) {
    return typeof t == "string" && (t = this.marks[t]), t.create(n);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(t) {
    return aa.fromJSON(this, t);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(t) {
    return qe.fromJSON(this, t);
  }
  /**
  @internal
  */
  nodeType(t) {
    let n = this.nodes[t];
    if (!n)
      throw new RangeError("Unknown node type: " + t);
    return n;
  }
}
function R0(e, t) {
  let n = [];
  for (let r = 0; r < t.length; r++) {
    let a = t[r], i = e.marks[a], o = i;
    if (i)
      n.push(i);
    else
      for (let s in e.marks) {
        let c = e.marks[s];
        (a == "_" || c.spec.group && c.spec.group.split(" ").indexOf(a) > -1) && n.push(o = c);
      }
    if (!o)
      throw new SyntaxError("Unknown mark type: '" + t[r] + "'");
  }
  return n;
}
function p7(e) {
  return e.tag != null;
}
function f7(e) {
  return e.style != null;
}
class oi {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(t, n) {
    this.schema = t, this.rules = n, this.tags = [], this.styles = [], n.forEach((r) => {
      p7(r) ? this.tags.push(r) : f7(r) && this.styles.push(r);
    }), this.normalizeLists = !this.tags.some((r) => {
      if (!/^(ul|ol)\b/.test(r.tag) || !r.node)
        return !1;
      let a = t.nodes[r.node];
      return a.contentMatch.matchType(a);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(t, n = {}) {
    let r = new z0(this, n, !1);
    return r.addAll(t, n.from, n.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(t, n = {}) {
    let r = new z0(this, n, !0);
    return r.addAll(t, n.from, n.to), ye.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(t, n, r) {
    for (let a = r ? this.tags.indexOf(r) + 1 : 0; a < this.tags.length; a++) {
      let i = this.tags[a];
      if (g7(t, i.tag) && (i.namespace === void 0 || t.namespaceURI == i.namespace) && (!i.context || n.matchesContext(i.context))) {
        if (i.getAttrs) {
          let o = i.getAttrs(t);
          if (o === !1)
            continue;
          i.attrs = o || void 0;
        }
        return i;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(t, n, r, a) {
    for (let i = a ? this.styles.indexOf(a) + 1 : 0; i < this.styles.length; i++) {
      let o = this.styles[i], s = o.style;
      if (!(s.indexOf(t) != 0 || o.context && !r.matchesContext(o.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      s.length > t.length && (s.charCodeAt(t.length) != 61 || s.slice(t.length + 1) != n))) {
        if (o.getAttrs) {
          let c = o.getAttrs(n);
          if (c === !1)
            continue;
          o.attrs = c || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(t) {
    let n = [];
    function r(a) {
      let i = a.priority == null ? 50 : a.priority, o = 0;
      for (; o < n.length; o++) {
        let s = n[o];
        if ((s.priority == null ? 50 : s.priority) < i)
          break;
      }
      n.splice(o, 0, a);
    }
    for (let a in t.marks) {
      let i = t.marks[a].spec.parseDOM;
      i && i.forEach((o) => {
        r(o = B0(o)), o.mark || o.ignore || o.clearMark || (o.mark = a);
      });
    }
    for (let a in t.nodes) {
      let i = t.nodes[a].spec.parseDOM;
      i && i.forEach((o) => {
        r(o = B0(o)), o.node || o.ignore || o.mark || (o.node = a);
      });
    }
    return n;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(t) {
    return t.cached.domParser || (t.cached.domParser = new oi(t, oi.schemaRules(t)));
  }
}
const Gv = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, y7 = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, Zv = { ol: !0, ul: !0 }, Pc = 1, Lc = 2, eo = 4;
function V0(e, t, n) {
  return t != null ? (t ? Pc : 0) | (t === "full" ? Lc : 0) : e && e.whitespace == "pre" ? Pc | Lc : n & ~eo;
}
class Is {
  constructor(t, n, r, a, i, o, s) {
    this.type = t, this.attrs = n, this.marks = r, this.pendingMarks = a, this.solid = i, this.options = s, this.content = [], this.activeMarks = qe.none, this.stashMarks = [], this.match = o || (s & eo ? null : t.contentMatch);
  }
  findWrapping(t) {
    if (!this.match) {
      if (!this.type)
        return [];
      let n = this.type.contentMatch.fillBefore(oe.from(t));
      if (n)
        this.match = this.type.contentMatch.matchFragment(n);
      else {
        let r = this.type.contentMatch, a;
        return (a = r.findWrapping(t.type)) ? (this.match = r, a) : null;
      }
    }
    return this.match.findWrapping(t.type);
  }
  finish(t) {
    if (!(this.options & Pc)) {
      let r = this.content[this.content.length - 1], a;
      if (r && r.isText && (a = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let i = r;
        r.text.length == a[0].length ? this.content.pop() : this.content[this.content.length - 1] = i.withText(i.text.slice(0, i.text.length - a[0].length));
      }
    }
    let n = oe.from(this.content);
    return !t && this.match && (n = n.append(this.match.fillBefore(oe.empty, !0))), this.type ? this.type.create(this.attrs, n, this.marks) : n;
  }
  popFromStashMark(t) {
    for (let n = this.stashMarks.length - 1; n >= 0; n--)
      if (t.eq(this.stashMarks[n]))
        return this.stashMarks.splice(n, 1)[0];
  }
  applyPending(t) {
    for (let n = 0, r = this.pendingMarks; n < r.length; n++) {
      let a = r[n];
      (this.type ? this.type.allowsMarkType(a.type) : v7(a.type, t)) && !a.isInSet(this.activeMarks) && (this.activeMarks = a.addToSet(this.activeMarks), this.pendingMarks = a.removeFromSet(this.pendingMarks));
    }
  }
  inlineContext(t) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : t.parentNode && !Gv.hasOwnProperty(t.parentNode.nodeName.toLowerCase());
  }
}
class z0 {
  constructor(t, n, r) {
    this.parser = t, this.options = n, this.isOpen = r, this.open = 0;
    let a = n.topNode, i, o = V0(null, n.preserveWhitespace, 0) | (r ? eo : 0);
    a ? i = new Is(a.type, a.attrs, qe.none, qe.none, !0, n.topMatch || a.type.contentMatch, o) : r ? i = new Is(null, null, qe.none, qe.none, !0, null, o) : i = new Is(t.schema.topNodeType, null, qe.none, qe.none, !0, null, o), this.nodes = [i], this.find = n.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(t) {
    t.nodeType == 3 ? this.addTextNode(t) : t.nodeType == 1 && this.addElement(t);
  }
  withStyleRules(t, n) {
    let r = t.style;
    if (!r || !r.length)
      return n();
    let a = this.readStyles(t.style);
    if (!a)
      return;
    let [i, o] = a, s = this.top;
    for (let c = 0; c < o.length; c++)
      this.removePendingMark(o[c], s);
    for (let c = 0; c < i.length; c++)
      this.addPendingMark(i[c]);
    n();
    for (let c = 0; c < i.length; c++)
      this.removePendingMark(i[c], s);
    for (let c = 0; c < o.length; c++)
      this.addPendingMark(o[c]);
  }
  addTextNode(t) {
    let n = t.nodeValue, r = this.top;
    if (r.options & Lc || r.inlineContext(t) || /[^ \t\r\n\u000c]/.test(n)) {
      if (r.options & Pc)
        r.options & Lc ? n = n.replace(/\r\n?/g, `
`) : n = n.replace(/\r?\n|\r/g, " ");
      else if (n = n.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(n) && this.open == this.nodes.length - 1) {
        let a = r.content[r.content.length - 1], i = t.previousSibling;
        (!a || i && i.nodeName == "BR" || a.isText && /[ \t\r\n\u000c]$/.test(a.text)) && (n = n.slice(1));
      }
      n && this.insertNode(this.parser.schema.text(n)), this.findInText(t);
    } else
      this.findInside(t);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(t, n) {
    let r = t.nodeName.toLowerCase(), a;
    Zv.hasOwnProperty(r) && this.parser.normalizeLists && m7(t);
    let i = this.options.ruleFromNode && this.options.ruleFromNode(t) || (a = this.parser.matchTag(t, this, n));
    if (i ? i.ignore : y7.hasOwnProperty(r))
      this.findInside(t), this.ignoreFallback(t);
    else if (!i || i.skip || i.closeParent) {
      i && i.closeParent ? this.open = Math.max(0, this.open - 1) : i && i.skip.nodeType && (t = i.skip);
      let o, s = this.top, c = this.needsBlock;
      if (Gv.hasOwnProperty(r))
        s.content.length && s.content[0].isInline && this.open && (this.open--, s = this.top), o = !0, s.type || (this.needsBlock = !0);
      else if (!t.firstChild) {
        this.leafFallback(t);
        return;
      }
      i && i.skip ? this.addAll(t) : this.withStyleRules(t, () => this.addAll(t)), o && this.sync(s), this.needsBlock = c;
    } else
      this.withStyleRules(t, () => {
        this.addElementByRule(t, i, i.consuming === !1 ? a : void 0);
      });
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(t) {
    t.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(t.ownerDocument.createTextNode(`
`));
  }
  // Called for ignored nodes
  ignoreFallback(t) {
    t.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"));
  }
  // Run any style parser associated with the node's styles. Either
  // return an array of marks, or null to indicate some of the styles
  // had a rule with `ignore` set.
  readStyles(t) {
    let n = qe.none, r = qe.none;
    for (let a = 0, i = t.length; a < i; a++) {
      let o = t.item(a);
      for (let s = void 0; ; ) {
        let c = this.parser.matchStyle(o, t.getPropertyValue(o), this, s);
        if (!c)
          break;
        if (c.ignore)
          return null;
        if (c.clearMark ? this.top.pendingMarks.concat(this.top.activeMarks).forEach((l) => {
          c.clearMark(l) && (r = l.addToSet(r));
        }) : n = this.parser.schema.marks[c.mark].create(c.attrs).addToSet(n), c.consuming === !1)
          s = c;
        else
          break;
      }
    }
    return [n, r];
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(t, n, r) {
    let a, i, o;
    n.node ? (i = this.parser.schema.nodes[n.node], i.isLeaf ? this.insertNode(i.create(n.attrs)) || this.leafFallback(t) : a = this.enter(i, n.attrs || null, n.preserveWhitespace)) : (o = this.parser.schema.marks[n.mark].create(n.attrs), this.addPendingMark(o));
    let s = this.top;
    if (i && i.isLeaf)
      this.findInside(t);
    else if (r)
      this.addElement(t, r);
    else if (n.getContent)
      this.findInside(t), n.getContent(t, this.parser.schema).forEach((c) => this.insertNode(c));
    else {
      let c = t;
      typeof n.contentElement == "string" ? c = t.querySelector(n.contentElement) : typeof n.contentElement == "function" ? c = n.contentElement(t) : n.contentElement && (c = n.contentElement), this.findAround(t, c, !0), this.addAll(c);
    }
    a && this.sync(s) && this.open--, o && this.removePendingMark(o, s);
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(t, n, r) {
    let a = n || 0;
    for (let i = n ? t.childNodes[n] : t.firstChild, o = r == null ? null : t.childNodes[r]; i != o; i = i.nextSibling, ++a)
      this.findAtPoint(t, a), this.addDOM(i);
    this.findAtPoint(t, a);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(t) {
    let n, r;
    for (let a = this.open; a >= 0; a--) {
      let i = this.nodes[a], o = i.findWrapping(t);
      if (o && (!n || n.length > o.length) && (n = o, r = i, !o.length) || i.solid)
        break;
    }
    if (!n)
      return !1;
    this.sync(r);
    for (let a = 0; a < n.length; a++)
      this.enterInner(n[a], null, !1);
    return !0;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(t) {
    if (t.isInline && this.needsBlock && !this.top.type) {
      let n = this.textblockFromContext();
      n && this.enterInner(n);
    }
    if (this.findPlace(t)) {
      this.closeExtra();
      let n = this.top;
      n.applyPending(t.type), n.match && (n.match = n.match.matchType(t.type));
      let r = n.activeMarks;
      for (let a = 0; a < t.marks.length; a++)
        (!n.type || n.type.allowsMarkType(t.marks[a].type)) && (r = t.marks[a].addToSet(r));
      return n.content.push(t.mark(r)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(t, n, r) {
    let a = this.findPlace(t.create(n));
    return a && this.enterInner(t, n, !0, r), a;
  }
  // Open a node of the given type
  enterInner(t, n = null, r = !1, a) {
    this.closeExtra();
    let i = this.top;
    i.applyPending(t), i.match = i.match && i.match.matchType(t);
    let o = V0(t, a, i.options);
    i.options & eo && i.content.length == 0 && (o |= eo), this.nodes.push(new Is(t, n, i.activeMarks, i.pendingMarks, r, null, o)), this.open++;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(t = !1) {
    let n = this.nodes.length - 1;
    if (n > this.open) {
      for (; n > this.open; n--)
        this.nodes[n - 1].content.push(this.nodes[n].finish(t));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(this.isOpen || this.options.topOpen);
  }
  sync(t) {
    for (let n = this.open; n >= 0; n--)
      if (this.nodes[n] == t)
        return this.open = n, !0;
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let t = 0;
    for (let n = this.open; n >= 0; n--) {
      let r = this.nodes[n].content;
      for (let a = r.length - 1; a >= 0; a--)
        t += r[a].nodeSize;
      n && t++;
    }
    return t;
  }
  findAtPoint(t, n) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == t && this.find[r].offset == n && (this.find[r].pos = this.currentPos);
  }
  findInside(t) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].pos == null && t.nodeType == 1 && t.contains(this.find[n].node) && (this.find[n].pos = this.currentPos);
  }
  findAround(t, n, r) {
    if (t != n && this.find)
      for (let a = 0; a < this.find.length; a++)
        this.find[a].pos == null && t.nodeType == 1 && t.contains(this.find[a].node) && n.compareDocumentPosition(this.find[a].node) & (r ? 2 : 4) && (this.find[a].pos = this.currentPos);
  }
  findInText(t) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == t && (this.find[n].pos = this.currentPos - (t.nodeValue.length - this.find[n].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(t) {
    if (t.indexOf("|") > -1)
      return t.split(/\s*\|\s*/).some(this.matchesContext, this);
    let n = t.split("/"), r = this.options.context, a = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), i = -(r ? r.depth + 1 : 0) + (a ? 0 : 1), o = (s, c) => {
      for (; s >= 0; s--) {
        let l = n[s];
        if (l == "") {
          if (s == n.length - 1 || s == 0)
            continue;
          for (; c >= i; c--)
            if (o(s - 1, c))
              return !0;
          return !1;
        } else {
          let u = c > 0 || c == 0 && a ? this.nodes[c].type : r && c >= i ? r.node(c - i).type : null;
          if (!u || u.name != l && u.groups.indexOf(l) == -1)
            return !1;
          c--;
        }
      }
      return !0;
    };
    return o(n.length - 1, this.open);
  }
  textblockFromContext() {
    let t = this.options.context;
    if (t)
      for (let n = t.depth; n >= 0; n--) {
        let r = t.node(n).contentMatchAt(t.indexAfter(n)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let n in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[n];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
  addPendingMark(t) {
    let n = k7(t, this.top.pendingMarks);
    n && this.top.stashMarks.push(n), this.top.pendingMarks = t.addToSet(this.top.pendingMarks);
  }
  removePendingMark(t, n) {
    for (let r = this.open; r >= 0; r--) {
      let a = this.nodes[r];
      if (a.pendingMarks.lastIndexOf(t) > -1)
        a.pendingMarks = t.removeFromSet(a.pendingMarks);
      else {
        a.activeMarks = t.removeFromSet(a.activeMarks);
        let o = a.popFromStashMark(t);
        o && a.type && a.type.allowsMarkType(o.type) && (a.activeMarks = o.addToSet(a.activeMarks));
      }
      if (a == n)
        break;
    }
  }
}
function m7(e) {
  for (let t = e.firstChild, n = null; t; t = t.nextSibling) {
    let r = t.nodeType == 1 ? t.nodeName.toLowerCase() : null;
    r && Zv.hasOwnProperty(r) && n ? (n.appendChild(t), t = n) : r == "li" ? n = t : r && (n = null);
  }
}
function g7(e, t) {
  return (e.matches || e.msMatchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector).call(e, t);
}
function B0(e) {
  let t = {};
  for (let n in e)
    t[n] = e[n];
  return t;
}
function v7(e, t) {
  let n = t.schema.nodes;
  for (let r in n) {
    let a = n[r];
    if (!a.allowsMarkType(e))
      continue;
    let i = [], o = (s) => {
      i.push(s);
      for (let c = 0; c < s.edgeCount; c++) {
        let { type: l, next: u } = s.edge(c);
        if (l == t || i.indexOf(u) < 0 && o(u))
          return !0;
      }
    };
    if (o(a.contentMatch))
      return !0;
  }
}
function k7(e, t) {
  for (let n = 0; n < t.length; n++)
    if (e.eq(t[n]))
      return t[n];
}
class Rn {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(t, n) {
    this.nodes = t, this.marks = n;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(t, n = {}, r) {
    r || (r = id(n).createDocumentFragment());
    let a = r, i = [];
    return t.forEach((o) => {
      if (i.length || o.marks.length) {
        let s = 0, c = 0;
        for (; s < i.length && c < o.marks.length; ) {
          let l = o.marks[c];
          if (!this.marks[l.type.name]) {
            c++;
            continue;
          }
          if (!l.eq(i[s][0]) || l.type.spec.spanning === !1)
            break;
          s++, c++;
        }
        for (; s < i.length; )
          a = i.pop()[1];
        for (; c < o.marks.length; ) {
          let l = o.marks[c++], u = this.serializeMark(l, o.isInline, n);
          u && (i.push([l, a]), a.appendChild(u.dom), a = u.contentDOM || u.dom);
        }
      }
      a.appendChild(this.serializeNodeInner(o, n));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(t, n) {
    let { dom: r, contentDOM: a } = Rn.renderSpec(id(n), this.nodes[t.type.name](t));
    if (a) {
      if (t.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(t.content, n, a);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(t, n = {}) {
    let r = this.serializeNodeInner(t, n);
    for (let a = t.marks.length - 1; a >= 0; a--) {
      let i = this.serializeMark(t.marks[a], t.isInline, n);
      i && ((i.contentDOM || i.dom).appendChild(r), r = i.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(t, n, r = {}) {
    let a = this.marks[t.type.name];
    return a && Rn.renderSpec(id(r), a(t, n));
  }
  /**
  Render an [output spec](https://prosemirror.net/docs/ref/#model.DOMOutputSpec) to a DOM node. If
  the spec has a hole (zero) in it, `contentDOM` will point at the
  node with the hole.
  */
  static renderSpec(t, n, r = null) {
    if (typeof n == "string")
      return { dom: t.createTextNode(n) };
    if (n.nodeType != null)
      return { dom: n };
    if (n.dom && n.dom.nodeType != null)
      return n;
    let a = n[0], i = a.indexOf(" ");
    i > 0 && (r = a.slice(0, i), a = a.slice(i + 1));
    let o, s = r ? t.createElementNS(r, a) : t.createElement(a), c = n[1], l = 1;
    if (c && typeof c == "object" && c.nodeType == null && !Array.isArray(c)) {
      l = 2;
      for (let u in c)
        if (c[u] != null) {
          let h = u.indexOf(" ");
          h > 0 ? s.setAttributeNS(u.slice(0, h), u.slice(h + 1), c[u]) : s.setAttribute(u, c[u]);
        }
    }
    for (let u = l; u < n.length; u++) {
      let h = n[u];
      if (h === 0) {
        if (u < n.length - 1 || u > l)
          throw new RangeError("Content hole must be the only child of its parent node");
        return { dom: s, contentDOM: s };
      } else {
        let { dom: p, contentDOM: f } = Rn.renderSpec(t, h, r);
        if (s.appendChild(p), f) {
          if (o)
            throw new RangeError("Multiple content holes");
          o = f;
        }
      }
    }
    return { dom: s, contentDOM: o };
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(t) {
    return t.cached.domSerializer || (t.cached.domSerializer = new Rn(this.nodesFromSchema(t), this.marksFromSchema(t)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(t) {
    let n = H0(t.nodes);
    return n.text || (n.text = (r) => r.text), n;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(t) {
    return H0(t.marks);
  }
}
function H0(e) {
  let t = {};
  for (let n in e) {
    let r = e[n].spec.toDOM;
    r && (t[n] = r);
  }
  return t;
}
function id(e) {
  return e.document || window.document;
}
const Xv = 65535, Uv = Math.pow(2, 16);
function b7(e, t) {
  return e + t * Uv;
}
function $0(e) {
  return e & Xv;
}
function x7(e) {
  return (e - (e & Xv)) / Uv;
}
const Yv = 1, Jv = 2, ac = 4, Kv = 8;
class xu {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.pos = t, this.delInfo = n, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & Kv) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (Yv | ac)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (Jv | ac)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & ac) > 0;
  }
}
class Xt {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(t, n = !1) {
    if (this.ranges = t, this.inverted = n, !t.length && Xt.empty)
      return Xt.empty;
  }
  /**
  @internal
  */
  recover(t) {
    let n = 0, r = $0(t);
    if (!this.inverted)
      for (let a = 0; a < r; a++)
        n += this.ranges[a * 3 + 2] - this.ranges[a * 3 + 1];
    return this.ranges[r * 3] + n + x7(t);
  }
  mapResult(t, n = 1) {
    return this._map(t, n, !1);
  }
  map(t, n = 1) {
    return this._map(t, n, !0);
  }
  /**
  @internal
  */
  _map(t, n, r) {
    let a = 0, i = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let c = this.ranges[s] - (this.inverted ? a : 0);
      if (c > t)
        break;
      let l = this.ranges[s + i], u = this.ranges[s + o], h = c + l;
      if (t <= h) {
        let p = l ? t == c ? -1 : t == h ? 1 : n : n, f = c + a + (p < 0 ? 0 : u);
        if (r)
          return f;
        let y = t == (n < 0 ? c : h) ? null : b7(s / 3, t - c), m = t == c ? Jv : t == h ? Yv : ac;
        return (n < 0 ? t != c : t != h) && (m |= Kv), new xu(f, m, y);
      }
      a += u - l;
    }
    return r ? t + a : new xu(t + a, 0, null);
  }
  /**
  @internal
  */
  touches(t, n) {
    let r = 0, a = $0(n), i = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let c = this.ranges[s] - (this.inverted ? r : 0);
      if (c > t)
        break;
      let l = this.ranges[s + i], u = c + l;
      if (t <= u && s == a * 3)
        return !0;
      r += this.ranges[s + o] - l;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(t) {
    let n = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let a = 0, i = 0; a < this.ranges.length; a += 3) {
      let o = this.ranges[a], s = o - (this.inverted ? i : 0), c = o + (this.inverted ? 0 : i), l = this.ranges[a + n], u = this.ranges[a + r];
      t(s, s + l, c, c + u), i += u - l;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new Xt(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(t) {
    return t == 0 ? Xt.empty : new Xt(t < 0 ? [0, -t, 0] : [0, 0, t]);
  }
}
Xt.empty = new Xt([]);
class to {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(t = [], n, r = 0, a = t.length) {
    this.maps = t, this.mirror = n, this.from = r, this.to = a;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(t = 0, n = this.maps.length) {
    return new to(this.maps, this.mirror, t, n);
  }
  /**
  @internal
  */
  copy() {
    return new to(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(t, n) {
    this.to = this.maps.push(t), n != null && this.setMirror(this.maps.length - 1, n);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(t) {
    for (let n = 0, r = this.maps.length; n < t.maps.length; n++) {
      let a = t.getMirror(n);
      this.appendMap(t.maps[n], a != null && a < n ? r + a : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(t) {
    if (this.mirror) {
      for (let n = 0; n < this.mirror.length; n++)
        if (this.mirror[n] == t)
          return this.mirror[n + (n % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(t, n) {
    this.mirror || (this.mirror = []), this.mirror.push(t, n);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(t) {
    for (let n = t.maps.length - 1, r = this.maps.length + t.maps.length; n >= 0; n--) {
      let a = t.getMirror(n);
      this.appendMap(t.maps[n].invert(), a != null && a > n ? r - a - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let t = new to();
    return t.appendMappingInverted(this), t;
  }
  /**
  Map a position through this mapping.
  */
  map(t, n = 1) {
    if (this.mirror)
      return this._map(t, n, !0);
    for (let r = this.from; r < this.to; r++)
      t = this.maps[r].map(t, n);
    return t;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(t, n = 1) {
    return this._map(t, n, !1);
  }
  /**
  @internal
  */
  _map(t, n, r) {
    let a = 0;
    for (let i = this.from; i < this.to; i++) {
      let o = this.maps[i], s = o.mapResult(t, n);
      if (s.recover != null) {
        let c = this.getMirror(i);
        if (c != null && c > i && c < this.to) {
          i = c, t = this.maps[c].recover(s.recover);
          continue;
        }
      }
      a |= s.delInfo, t = s.pos;
    }
    return r ? t : new xu(t, a, null);
  }
}
const od = /* @__PURE__ */ Object.create(null);
class St {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return Xt.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(t) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(t, n) {
    if (!n || !n.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = od[n.stepType];
    if (!r)
      throw new RangeError(`No step type ${n.stepType} defined`);
    return r.fromJSON(t, n);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(t, n) {
    if (t in od)
      throw new RangeError("Duplicate use of step JSON ID " + t);
    return od[t] = n, n.prototype.jsonID = t, n;
  }
}
class it {
  /**
  @internal
  */
  constructor(t, n) {
    this.doc = t, this.failed = n;
  }
  /**
  Create a successful step result.
  */
  static ok(t) {
    return new it(t, null);
  }
  /**
  Create a failed step result.
  */
  static fail(t) {
    return new it(null, t);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(t, n, r, a) {
    try {
      return it.ok(t.replace(n, r, a));
    } catch (i) {
      if (i instanceof Ic)
        return it.fail(i.message);
      throw i;
    }
  }
}
function rp(e, t, n) {
  let r = [];
  for (let a = 0; a < e.childCount; a++) {
    let i = e.child(a);
    i.content.size && (i = i.copy(rp(i.content, t, i))), i.isInline && (i = t(i, n, a)), r.push(i);
  }
  return oe.fromArray(r);
}
class br extends St {
  /**
  Create a mark step.
  */
  constructor(t, n, r) {
    super(), this.from = t, this.to = n, this.mark = r;
  }
  apply(t) {
    let n = t.slice(this.from, this.to), r = t.resolve(this.from), a = r.node(r.sharedDepth(this.to)), i = new ye(rp(n.content, (o, s) => !o.isAtom || !s.type.allowsMarkType(this.mark.type) ? o : o.mark(this.mark.addToSet(o.marks)), a), n.openStart, n.openEnd);
    return it.fromReplace(t, this.from, this.to, i);
  }
  invert() {
    return new Vn(this.from, this.to, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new br(n.pos, r.pos, this.mark);
  }
  merge(t) {
    return t instanceof br && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new br(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new br(n.from, n.to, t.markFromJSON(n.mark));
  }
}
St.jsonID("addMark", br);
class Vn extends St {
  /**
  Create a mark-removing step.
  */
  constructor(t, n, r) {
    super(), this.from = t, this.to = n, this.mark = r;
  }
  apply(t) {
    let n = t.slice(this.from, this.to), r = new ye(rp(n.content, (a) => a.mark(this.mark.removeFromSet(a.marks)), t), n.openStart, n.openEnd);
    return it.fromReplace(t, this.from, this.to, r);
  }
  invert() {
    return new br(this.from, this.to, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new Vn(n.pos, r.pos, this.mark);
  }
  merge(t) {
    return t instanceof Vn && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new Vn(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new Vn(n.from, n.to, t.markFromJSON(n.mark));
  }
}
St.jsonID("removeMark", Vn);
class xr extends St {
  /**
  Create a node mark step.
  */
  constructor(t, n) {
    super(), this.pos = t, this.mark = n;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return it.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.addToSet(n.marks));
    return it.fromReplace(t, this.pos, this.pos + 1, new ye(oe.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(t) {
    let n = t.nodeAt(this.pos);
    if (n) {
      let r = this.mark.addToSet(n.marks);
      if (r.length == n.marks.length) {
        for (let a = 0; a < n.marks.length; a++)
          if (!n.marks[a].isInSet(r))
            return new xr(this.pos, n.marks[a]);
        return new xr(this.pos, this.mark);
      }
    }
    return new si(this.pos, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new xr(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new xr(n.pos, t.markFromJSON(n.mark));
  }
}
St.jsonID("addNodeMark", xr);
class si extends St {
  /**
  Create a mark-removing step.
  */
  constructor(t, n) {
    super(), this.pos = t, this.mark = n;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return it.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.removeFromSet(n.marks));
    return it.fromReplace(t, this.pos, this.pos + 1, new ye(oe.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(t) {
    let n = t.nodeAt(this.pos);
    return !n || !this.mark.isInSet(n.marks) ? this : new xr(this.pos, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new si(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new si(n.pos, t.markFromJSON(n.mark));
  }
}
St.jsonID("removeNodeMark", si);
class ct extends St {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(t, n, r, a = !1) {
    super(), this.from = t, this.to = n, this.slice = r, this.structure = a;
  }
  apply(t) {
    return this.structure && Mu(t, this.from, this.to) ? it.fail("Structure replace would overwrite content") : it.fromReplace(t, this.from, this.to, this.slice);
  }
  getMap() {
    return new Xt([this.from, this.to - this.from, this.slice.size]);
  }
  invert(t) {
    return new ct(this.from, this.from + this.slice.size, t.slice(this.from, this.to));
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1);
    return n.deletedAcross && r.deletedAcross ? null : new ct(n.pos, Math.max(n.pos, r.pos), this.slice);
  }
  merge(t) {
    if (!(t instanceof ct) || t.structure || this.structure)
      return null;
    if (this.from + this.slice.size == t.from && !this.slice.openEnd && !t.slice.openStart) {
      let n = this.slice.size + t.slice.size == 0 ? ye.empty : new ye(this.slice.content.append(t.slice.content), this.slice.openStart, t.slice.openEnd);
      return new ct(this.from, this.to + (t.to - t.from), n, this.structure);
    } else if (t.to == this.from && !this.slice.openStart && !t.slice.openEnd) {
      let n = this.slice.size + t.slice.size == 0 ? ye.empty : new ye(t.slice.content.append(this.slice.content), t.slice.openStart, this.slice.openEnd);
      return new ct(t.from, this.to, n, this.structure);
    } else
      return null;
  }
  toJSON() {
    let t = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new ct(n.from, n.to, ye.fromJSON(t, n.slice), !!n.structure);
  }
}
St.jsonID("replace", ct);
class lt extends St {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(t, n, r, a, i, o, s = !1) {
    super(), this.from = t, this.to = n, this.gapFrom = r, this.gapTo = a, this.slice = i, this.insert = o, this.structure = s;
  }
  apply(t) {
    if (this.structure && (Mu(t, this.from, this.gapFrom) || Mu(t, this.gapTo, this.to)))
      return it.fail("Structure gap-replace would overwrite content");
    let n = t.slice(this.gapFrom, this.gapTo);
    if (n.openStart || n.openEnd)
      return it.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, n.content);
    return r ? it.fromReplace(t, this.from, this.to, r) : it.fail("Content does not fit in gap");
  }
  getMap() {
    return new Xt([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(t) {
    let n = this.gapTo - this.gapFrom;
    return new lt(this.from, this.from + this.slice.size + n, this.from + this.insert, this.from + this.insert + n, t.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1), a = this.from == this.gapFrom ? n.pos : t.map(this.gapFrom, -1), i = this.to == this.gapTo ? r.pos : t.map(this.gapTo, 1);
    return n.deletedAcross && r.deletedAcross || a < n.pos || i > r.pos ? null : new lt(n.pos, r.pos, a, i, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let t = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number" || typeof n.gapFrom != "number" || typeof n.gapTo != "number" || typeof n.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new lt(n.from, n.to, n.gapFrom, n.gapTo, ye.fromJSON(t, n.slice), n.insert, !!n.structure);
  }
}
St.jsonID("replaceAround", lt);
function Mu(e, t, n) {
  let r = e.resolve(t), a = n - t, i = r.depth;
  for (; a > 0 && i > 0 && r.indexAfter(i) == r.node(i).childCount; )
    i--, a--;
  if (a > 0) {
    let o = r.node(i).maybeChild(r.indexAfter(i));
    for (; a > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, a--;
    }
  }
  return !1;
}
function M7(e, t, n, r) {
  let a = [], i = [], o, s;
  e.doc.nodesBetween(t, n, (c, l, u) => {
    if (!c.isInline)
      return;
    let h = c.marks;
    if (!r.isInSet(h) && u.type.allowsMarkType(r.type)) {
      let p = Math.max(l, t), f = Math.min(l + c.nodeSize, n), y = r.addToSet(h);
      for (let m = 0; m < h.length; m++)
        h[m].isInSet(y) || (o && o.to == p && o.mark.eq(h[m]) ? o.to = f : a.push(o = new Vn(p, f, h[m])));
      s && s.to == p ? s.to = f : i.push(s = new br(p, f, r));
    }
  }), a.forEach((c) => e.step(c)), i.forEach((c) => e.step(c));
}
function w7(e, t, n, r) {
  let a = [], i = 0;
  e.doc.nodesBetween(t, n, (o, s) => {
    if (!o.isInline)
      return;
    i++;
    let c = null;
    if (r instanceof Jl) {
      let l = o.marks, u;
      for (; u = r.isInSet(l); )
        (c || (c = [])).push(u), l = u.removeFromSet(l);
    } else
      r ? r.isInSet(o.marks) && (c = [r]) : c = o.marks;
    if (c && c.length) {
      let l = Math.min(s + o.nodeSize, n);
      for (let u = 0; u < c.length; u++) {
        let h = c[u], p;
        for (let f = 0; f < a.length; f++) {
          let y = a[f];
          y.step == i - 1 && h.eq(a[f].style) && (p = y);
        }
        p ? (p.to = l, p.step = i) : a.push({ style: h, from: Math.max(s, t), to: l, step: i });
      }
    }
  }), a.forEach((o) => e.step(new Vn(o.from, o.to, o.style)));
}
function Qv(e, t, n, r = n.contentMatch, a = !0) {
  let i = e.doc.nodeAt(t), o = [], s = t + 1;
  for (let c = 0; c < i.childCount; c++) {
    let l = i.child(c), u = s + l.nodeSize, h = r.matchType(l.type);
    if (!h)
      o.push(new ct(s, u, ye.empty));
    else {
      r = h;
      for (let p = 0; p < l.marks.length; p++)
        n.allowsMarkType(l.marks[p].type) || e.step(new Vn(s, u, l.marks[p]));
      if (a && l.isText && n.whitespace != "pre") {
        let p, f = /\r?\n|\r/g, y;
        for (; p = f.exec(l.text); )
          y || (y = new ye(oe.from(n.schema.text(" ", n.allowedMarks(l.marks))), 0, 0)), o.push(new ct(s + p.index, s + p.index + p[0].length, y));
      }
    }
    s = u;
  }
  if (!r.validEnd) {
    let c = r.fillBefore(oe.empty, !0);
    e.replace(s, s, new ye(c, 0, 0));
  }
  for (let c = o.length - 1; c >= 0; c--)
    e.step(o[c]);
}
function C7(e, t, n) {
  return (t == 0 || e.canReplace(t, e.childCount)) && (n == e.childCount || e.canReplace(0, n));
}
function Ei(e) {
  let n = e.parent.content.cutByIndex(e.startIndex, e.endIndex);
  for (let r = e.depth; ; --r) {
    let a = e.$from.node(r), i = e.$from.index(r), o = e.$to.indexAfter(r);
    if (r < e.depth && a.canReplace(i, o, n))
      return r;
    if (r == 0 || a.type.spec.isolating || !C7(a, i, o))
      break;
  }
  return null;
}
function S7(e, t, n) {
  let { $from: r, $to: a, depth: i } = t, o = r.before(i + 1), s = a.after(i + 1), c = o, l = s, u = oe.empty, h = 0;
  for (let y = i, m = !1; y > n; y--)
    m || r.index(y) > 0 ? (m = !0, u = oe.from(r.node(y).copy(u)), h++) : c--;
  let p = oe.empty, f = 0;
  for (let y = i, m = !1; y > n; y--)
    m || a.after(y + 1) < a.end(y) ? (m = !0, p = oe.from(a.node(y).copy(p)), f++) : l++;
  e.step(new lt(c, l, o, s, new ye(u.append(p), h, f), u.size - h, !0));
}
function ap(e, t, n = null, r = e) {
  let a = A7(e, t), i = a && O7(r, t);
  return i ? a.map(j0).concat({ type: t, attrs: n }).concat(i.map(j0)) : null;
}
function j0(e) {
  return { type: e, attrs: null };
}
function A7(e, t) {
  let { parent: n, startIndex: r, endIndex: a } = e, i = n.contentMatchAt(r).findWrapping(t);
  if (!i)
    return null;
  let o = i.length ? i[0] : t;
  return n.canReplaceWith(r, a, o) ? i : null;
}
function O7(e, t) {
  let { parent: n, startIndex: r, endIndex: a } = e, i = n.child(r), o = t.contentMatch.findWrapping(i.type);
  if (!o)
    return null;
  let c = (o.length ? o[o.length - 1] : t).contentMatch;
  for (let l = r; c && l < a; l++)
    c = c.matchType(n.child(l).type);
  return !c || !c.validEnd ? null : o;
}
function E7(e, t, n) {
  let r = oe.empty;
  for (let o = n.length - 1; o >= 0; o--) {
    if (r.size) {
      let s = n[o].type.contentMatch.matchFragment(r);
      if (!s || !s.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = oe.from(n[o].type.create(n[o].attrs, r));
  }
  let a = t.start, i = t.end;
  e.step(new lt(a, i, a, i, new ye(r, 0, 0), n.length, !0));
}
function I7(e, t, n, r, a) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let i = e.steps.length;
  e.doc.nodesBetween(t, n, (o, s) => {
    if (o.isTextblock && !o.hasMarkup(r, a) && N7(e.doc, e.mapping.slice(i).map(s), r)) {
      let c = null;
      if (r.schema.linebreakReplacement) {
        let p = r.whitespace == "pre", f = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        p && !f ? c = !1 : !p && f && (c = !0);
      }
      c === !1 && T7(e, o, s, i), Qv(e, e.mapping.slice(i).map(s, 1), r, void 0, c === null);
      let l = e.mapping.slice(i), u = l.map(s, 1), h = l.map(s + o.nodeSize, 1);
      return e.step(new lt(u, h, u + 1, h - 1, new ye(oe.from(r.create(a, null, o.marks)), 0, 0), 1, !0)), c === !0 && D7(e, o, s, i), !1;
    }
  });
}
function D7(e, t, n, r) {
  t.forEach((a, i) => {
    if (a.isText) {
      let o, s = /\r?\n|\r/g;
      for (; o = s.exec(a.text); ) {
        let c = e.mapping.slice(r).map(n + 1 + i + o.index);
        e.replaceWith(c, c + 1, t.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function T7(e, t, n, r) {
  t.forEach((a, i) => {
    if (a.type == a.type.schema.linebreakReplacement) {
      let o = e.mapping.slice(r).map(n + 1 + i);
      e.replaceWith(o, o + 1, t.type.schema.text(`
`));
    }
  });
}
function N7(e, t, n) {
  let r = e.resolve(t), a = r.index();
  return r.parent.canReplaceWith(a, a + 1, n);
}
function P7(e, t, n, r, a) {
  let i = e.doc.nodeAt(t);
  if (!i)
    throw new RangeError("No node at given position");
  n || (n = i.type);
  let o = n.create(r, null, a || i.marks);
  if (i.isLeaf)
    return e.replaceWith(t, t + i.nodeSize, o);
  if (!n.validContent(i.content))
    throw new RangeError("Invalid content for node type " + n.name);
  e.step(new lt(t, t + i.nodeSize, t + 1, t + i.nodeSize - 1, new ye(oe.from(o), 0, 0), 1, !0));
}
function Ka(e, t, n = 1, r) {
  let a = e.resolve(t), i = a.depth - n, o = r && r[r.length - 1] || a.parent;
  if (i < 0 || a.parent.type.spec.isolating || !a.parent.canReplace(a.index(), a.parent.childCount) || !o.type.validContent(a.parent.content.cutByIndex(a.index(), a.parent.childCount)))
    return !1;
  for (let l = a.depth - 1, u = n - 2; l > i; l--, u--) {
    let h = a.node(l), p = a.index(l);
    if (h.type.spec.isolating)
      return !1;
    let f = h.content.cutByIndex(p, h.childCount), y = r && r[u + 1];
    y && (f = f.replaceChild(0, y.type.create(y.attrs)));
    let m = r && r[u] || h;
    if (!h.canReplace(p + 1, h.childCount) || !m.type.validContent(f))
      return !1;
  }
  let s = a.indexAfter(i), c = r && r[0];
  return a.node(i).canReplaceWith(s, s, c ? c.type : a.node(i + 1).type);
}
function L7(e, t, n = 1, r) {
  let a = e.doc.resolve(t), i = oe.empty, o = oe.empty;
  for (let s = a.depth, c = a.depth - n, l = n - 1; s > c; s--, l--) {
    i = oe.from(a.node(s).copy(i));
    let u = r && r[l];
    o = oe.from(u ? u.type.create(u.attrs, o) : a.node(s).copy(o));
  }
  e.step(new ct(t, t, new ye(i.append(o), n, n), !0));
}
function Lr(e, t) {
  let n = e.resolve(t), r = n.index();
  return ek(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(r, r + 1);
}
function ek(e, t) {
  return !!(e && t && !e.isLeaf && e.canAppend(t));
}
function Kl(e, t, n = -1) {
  let r = e.resolve(t);
  for (let a = r.depth; ; a--) {
    let i, o, s = r.index(a);
    if (a == r.depth ? (i = r.nodeBefore, o = r.nodeAfter) : n > 0 ? (i = r.node(a + 1), s++, o = r.node(a).maybeChild(s)) : (i = r.node(a).maybeChild(s - 1), o = r.node(a + 1)), i && !i.isTextblock && ek(i, o) && r.node(a).canReplace(s, s + 1))
      return t;
    if (a == 0)
      break;
    t = n < 0 ? r.before(a) : r.after(a);
  }
}
function R7(e, t, n) {
  let r = new ct(t - n, t + n, ye.empty, !0);
  e.step(r);
}
function V7(e, t, n) {
  let r = e.resolve(t);
  if (r.parent.canReplaceWith(r.index(), r.index(), n))
    return t;
  if (r.parentOffset == 0)
    for (let a = r.depth - 1; a >= 0; a--) {
      let i = r.index(a);
      if (r.node(a).canReplaceWith(i, i, n))
        return r.before(a + 1);
      if (i > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let a = r.depth - 1; a >= 0; a--) {
      let i = r.indexAfter(a);
      if (r.node(a).canReplaceWith(i, i, n))
        return r.after(a + 1);
      if (i < r.node(a).childCount)
        return null;
    }
  return null;
}
function z7(e, t, n) {
  let r = e.resolve(t);
  if (!n.content.size)
    return t;
  let a = n.content;
  for (let i = 0; i < n.openStart; i++)
    a = a.firstChild.content;
  for (let i = 1; i <= (n.openStart == 0 && n.size ? 2 : 1); i++)
    for (let o = r.depth; o >= 0; o--) {
      let s = o == r.depth ? 0 : r.pos <= (r.start(o + 1) + r.end(o + 1)) / 2 ? -1 : 1, c = r.index(o) + (s > 0 ? 1 : 0), l = r.node(o), u = !1;
      if (i == 1)
        u = l.canReplace(c, c, a);
      else {
        let h = l.contentMatchAt(c).findWrapping(a.firstChild.type);
        u = h && l.canReplaceWith(c, c, h[0]);
      }
      if (u)
        return s == 0 ? r.pos : s < 0 ? r.before(o + 1) : r.after(o + 1);
    }
  return null;
}
function Ql(e, t, n = t, r = ye.empty) {
  if (t == n && !r.size)
    return null;
  let a = e.resolve(t), i = e.resolve(n);
  return tk(a, i, r) ? new ct(t, n, r) : new B7(a, i, r).fit();
}
function tk(e, t, n) {
  return !n.openStart && !n.openEnd && e.start() == t.start() && e.parent.canReplace(e.index(), t.index(), n.content);
}
class B7 {
  constructor(t, n, r) {
    this.$from = t, this.$to = n, this.unplaced = r, this.frontier = [], this.placed = oe.empty;
    for (let a = 0; a <= t.depth; a++) {
      let i = t.node(a);
      this.frontier.push({
        type: i.type,
        match: i.contentMatchAt(t.indexAfter(a))
      });
    }
    for (let a = t.depth; a > 0; a--)
      this.placed = oe.from(t.node(a).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let l = this.findFittable();
      l ? this.placeNodes(l) : this.openMore() || this.dropNode();
    }
    let t = this.mustMoveInline(), n = this.placed.size - this.depth - this.$from.depth, r = this.$from, a = this.close(t < 0 ? this.$to : r.doc.resolve(t));
    if (!a)
      return null;
    let i = this.placed, o = r.depth, s = a.depth;
    for (; o && s && i.childCount == 1; )
      i = i.firstChild.content, o--, s--;
    let c = new ye(i, o, s);
    return t > -1 ? new lt(r.pos, t, this.$to.pos, this.$to.end(), c, n) : c.size || r.pos != this.$to.pos ? new ct(r.pos, a.pos, c) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let t = this.unplaced.openStart;
    for (let n = this.unplaced.content, r = 0, a = this.unplaced.openEnd; r < t; r++) {
      let i = n.firstChild;
      if (n.childCount > 1 && (a = 0), i.type.spec.isolating && a <= r) {
        t = r;
        break;
      }
      n = i.content;
    }
    for (let n = 1; n <= 2; n++)
      for (let r = n == 1 ? t : this.unplaced.openStart; r >= 0; r--) {
        let a, i = null;
        r ? (i = sd(this.unplaced.content, r - 1).firstChild, a = i.content) : a = this.unplaced.content;
        let o = a.firstChild;
        for (let s = this.depth; s >= 0; s--) {
          let { type: c, match: l } = this.frontier[s], u, h = null;
          if (n == 1 && (o ? l.matchType(o.type) || (h = l.fillBefore(oe.from(o), !1)) : i && c.compatibleContent(i.type)))
            return { sliceDepth: r, frontierDepth: s, parent: i, inject: h };
          if (n == 2 && o && (u = l.findWrapping(o.type)))
            return { sliceDepth: r, frontierDepth: s, parent: i, wrap: u };
          if (i && l.matchType(i.type))
            break;
        }
      }
  }
  openMore() {
    let { content: t, openStart: n, openEnd: r } = this.unplaced, a = sd(t, n);
    return !a.childCount || a.firstChild.isLeaf ? !1 : (this.unplaced = new ye(t, n + 1, Math.max(r, a.size + n >= t.size - r ? n + 1 : 0)), !0);
  }
  dropNode() {
    let { content: t, openStart: n, openEnd: r } = this.unplaced, a = sd(t, n);
    if (a.childCount <= 1 && n > 0) {
      let i = t.size - n <= n + a.size;
      this.unplaced = new ye(Zi(t, n - 1, 1), n - 1, i ? n - 1 : r);
    } else
      this.unplaced = new ye(Zi(t, n, 1), n, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: t, frontierDepth: n, parent: r, inject: a, wrap: i }) {
    for (; this.depth > n; )
      this.closeFrontierNode();
    if (i)
      for (let m = 0; m < i.length; m++)
        this.openFrontierNode(i[m]);
    let o = this.unplaced, s = r ? r.content : o.content, c = o.openStart - t, l = 0, u = [], { match: h, type: p } = this.frontier[n];
    if (a) {
      for (let m = 0; m < a.childCount; m++)
        u.push(a.child(m));
      h = h.matchFragment(a);
    }
    let f = s.size + t - (o.content.size - o.openEnd);
    for (; l < s.childCount; ) {
      let m = s.child(l), v = h.matchType(m.type);
      if (!v)
        break;
      l++, (l > 1 || c == 0 || m.content.size) && (h = v, u.push(nk(m.mark(p.allowedMarks(m.marks)), l == 1 ? c : 0, l == s.childCount ? f : -1)));
    }
    let y = l == s.childCount;
    y || (f = -1), this.placed = Xi(this.placed, n, oe.from(u)), this.frontier[n].match = h, y && f < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let m = 0, v = s; m < f; m++) {
      let k = v.lastChild;
      this.frontier.push({ type: k.type, match: k.contentMatchAt(k.childCount) }), v = k.content;
    }
    this.unplaced = y ? t == 0 ? ye.empty : new ye(Zi(o.content, t - 1, 1), t - 1, f < 0 ? o.openEnd : t - 1) : new ye(Zi(o.content, t, l), o.openStart, o.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let t = this.frontier[this.depth], n;
    if (!t.type.isTextblock || !cd(this.$to, this.$to.depth, t.type, t.match, !1) || this.$to.depth == this.depth && (n = this.findCloseLevel(this.$to)) && n.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, a = this.$to.after(r);
    for (; r > 1 && a == this.$to.end(--r); )
      ++a;
    return a;
  }
  findCloseLevel(t) {
    e:
      for (let n = Math.min(this.depth, t.depth); n >= 0; n--) {
        let { match: r, type: a } = this.frontier[n], i = n < t.depth && t.end(n + 1) == t.pos + (t.depth - (n + 1)), o = cd(t, n, a, r, i);
        if (o) {
          for (let s = n - 1; s >= 0; s--) {
            let { match: c, type: l } = this.frontier[s], u = cd(t, s, l, c, !0);
            if (!u || u.childCount)
              continue e;
          }
          return { depth: n, fit: o, move: i ? t.doc.resolve(t.after(n + 1)) : t };
        }
      }
  }
  close(t) {
    let n = this.findCloseLevel(t);
    if (!n)
      return null;
    for (; this.depth > n.depth; )
      this.closeFrontierNode();
    n.fit.childCount && (this.placed = Xi(this.placed, n.depth, n.fit)), t = n.move;
    for (let r = n.depth + 1; r <= t.depth; r++) {
      let a = t.node(r), i = a.type.contentMatch.fillBefore(a.content, !0, t.index(r));
      this.openFrontierNode(a.type, a.attrs, i);
    }
    return t;
  }
  openFrontierNode(t, n = null, r) {
    let a = this.frontier[this.depth];
    a.match = a.match.matchType(t), this.placed = Xi(this.placed, this.depth, oe.from(t.create(n, r))), this.frontier.push({ type: t, match: t.contentMatch });
  }
  closeFrontierNode() {
    let n = this.frontier.pop().match.fillBefore(oe.empty, !0);
    n.childCount && (this.placed = Xi(this.placed, this.frontier.length, n));
  }
}
function Zi(e, t, n) {
  return t == 0 ? e.cutByIndex(n, e.childCount) : e.replaceChild(0, e.firstChild.copy(Zi(e.firstChild.content, t - 1, n)));
}
function Xi(e, t, n) {
  return t == 0 ? e.append(n) : e.replaceChild(e.childCount - 1, e.lastChild.copy(Xi(e.lastChild.content, t - 1, n)));
}
function sd(e, t) {
  for (let n = 0; n < t; n++)
    e = e.firstChild.content;
  return e;
}
function nk(e, t, n) {
  if (t <= 0)
    return e;
  let r = e.content;
  return t > 1 && (r = r.replaceChild(0, nk(r.firstChild, t - 1, r.childCount == 1 ? n - 1 : 0))), t > 0 && (r = e.type.contentMatch.fillBefore(r).append(r), n <= 0 && (r = r.append(e.type.contentMatch.matchFragment(r).fillBefore(oe.empty, !0)))), e.copy(r);
}
function cd(e, t, n, r, a) {
  let i = e.node(t), o = a ? e.indexAfter(t) : e.index(t);
  if (o == i.childCount && !n.compatibleContent(i.type))
    return null;
  let s = r.fillBefore(i.content, !0, o);
  return s && !H7(n, i.content, o) ? s : null;
}
function H7(e, t, n) {
  for (let r = n; r < t.childCount; r++)
    if (!e.allowsMarks(t.child(r).marks))
      return !0;
  return !1;
}
function $7(e) {
  return e.spec.defining || e.spec.definingForContent;
}
function j7(e, t, n, r) {
  if (!r.size)
    return e.deleteRange(t, n);
  let a = e.doc.resolve(t), i = e.doc.resolve(n);
  if (tk(a, i, r))
    return e.step(new ct(t, n, r));
  let o = ak(a, e.doc.resolve(n));
  o[o.length - 1] == 0 && o.pop();
  let s = -(a.depth + 1);
  o.unshift(s);
  for (let p = a.depth, f = a.pos - 1; p > 0; p--, f--) {
    let y = a.node(p).type.spec;
    if (y.defining || y.definingAsContext || y.isolating)
      break;
    o.indexOf(p) > -1 ? s = p : a.before(p) == f && o.splice(1, 0, -p);
  }
  let c = o.indexOf(s), l = [], u = r.openStart;
  for (let p = r.content, f = 0; ; f++) {
    let y = p.firstChild;
    if (l.push(y), f == r.openStart)
      break;
    p = y.content;
  }
  for (let p = u - 1; p >= 0; p--) {
    let f = l[p], y = $7(f.type);
    if (y && !f.sameMarkup(a.node(Math.abs(s) - 1)))
      u = p;
    else if (y || !f.type.isTextblock)
      break;
  }
  for (let p = r.openStart; p >= 0; p--) {
    let f = (p + u + 1) % (r.openStart + 1), y = l[f];
    if (y)
      for (let m = 0; m < o.length; m++) {
        let v = o[(m + c) % o.length], k = !0;
        v < 0 && (k = !1, v = -v);
        let b = a.node(v - 1), x = a.index(v - 1);
        if (b.canReplaceWith(x, x, y.type, y.marks))
          return e.replace(a.before(v), k ? i.after(v) : n, new ye(rk(r.content, 0, r.openStart, f), f, r.openEnd));
      }
  }
  let h = e.steps.length;
  for (let p = o.length - 1; p >= 0 && (e.replace(t, n, r), !(e.steps.length > h)); p--) {
    let f = o[p];
    f < 0 || (t = a.before(f), n = i.after(f));
  }
}
function rk(e, t, n, r, a) {
  if (t < n) {
    let i = e.firstChild;
    e = e.replaceChild(0, i.copy(rk(i.content, t + 1, n, r, i)));
  }
  if (t > r) {
    let i = a.contentMatchAt(0), o = i.fillBefore(e).append(e);
    e = o.append(i.matchFragment(o).fillBefore(oe.empty, !0));
  }
  return e;
}
function F7(e, t, n, r) {
  if (!r.isInline && t == n && e.doc.resolve(t).parent.content.size) {
    let a = V7(e.doc, t, r.type);
    a != null && (t = n = a);
  }
  e.replaceRange(t, n, new ye(oe.from(r), 0, 0));
}
function W7(e, t, n) {
  let r = e.doc.resolve(t), a = e.doc.resolve(n), i = ak(r, a);
  for (let o = 0; o < i.length; o++) {
    let s = i[o], c = o == i.length - 1;
    if (c && s == 0 || r.node(s).type.contentMatch.validEnd)
      return e.delete(r.start(s), a.end(s));
    if (s > 0 && (c || r.node(s - 1).canReplace(r.index(s - 1), a.indexAfter(s - 1))))
      return e.delete(r.before(s), a.after(s));
  }
  for (let o = 1; o <= r.depth && o <= a.depth; o++)
    if (t - r.start(o) == r.depth - o && n > r.end(o) && a.end(o) - n != a.depth - o)
      return e.delete(r.before(o), n);
  e.delete(t, n);
}
function ak(e, t) {
  let n = [], r = Math.min(e.depth, t.depth);
  for (let a = r; a >= 0; a--) {
    let i = e.start(a);
    if (i < e.pos - (e.depth - a) || t.end(a) > t.pos + (t.depth - a) || e.node(a).type.spec.isolating || t.node(a).type.spec.isolating)
      break;
    (i == t.start(a) || a == e.depth && a == t.depth && e.parent.inlineContent && t.parent.inlineContent && a && t.start(a - 1) == i - 1) && n.push(a);
  }
  return n;
}
class Qa extends St {
  /**
  Construct an attribute step.
  */
  constructor(t, n, r) {
    super(), this.pos = t, this.attr = n, this.value = r;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return it.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in n.attrs)
      r[i] = n.attrs[i];
    r[this.attr] = this.value;
    let a = n.type.create(r, null, n.marks);
    return it.fromReplace(t, this.pos, this.pos + 1, new ye(oe.from(a), 0, n.isLeaf ? 0 : 1));
  }
  getMap() {
    return Xt.empty;
  }
  invert(t) {
    return new Qa(this.pos, this.attr, t.nodeAt(this.pos).attrs[this.attr]);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Qa(n.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(t, n) {
    if (typeof n.pos != "number" || typeof n.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new Qa(n.pos, n.attr, n.value);
  }
}
St.jsonID("attr", Qa);
class go extends St {
  /**
  Construct an attribute step.
  */
  constructor(t, n) {
    super(), this.attr = t, this.value = n;
  }
  apply(t) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let a in t.attrs)
      n[a] = t.attrs[a];
    n[this.attr] = this.value;
    let r = t.type.create(n, t.content, t.marks);
    return it.ok(r);
  }
  getMap() {
    return Xt.empty;
  }
  invert(t) {
    return new go(this.attr, t.attrs[this.attr]);
  }
  map(t) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(t, n) {
    if (typeof n.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new go(n.attr, n.value);
  }
}
St.jsonID("docAttr", go);
let ci = class extends Error {
};
ci = function e(t) {
  let n = Error.call(this, t);
  return n.__proto__ = e.prototype, n;
};
ci.prototype = Object.create(Error.prototype);
ci.prototype.constructor = ci;
ci.prototype.name = "TransformError";
class ik {
  /**
  Create a transform that starts with the given document.
  */
  constructor(t) {
    this.doc = t, this.steps = [], this.docs = [], this.mapping = new to();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(t) {
    let n = this.maybeStep(t);
    if (n.failed)
      throw new ci(n.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(t) {
    let n = t.apply(this.doc);
    return n.failed || this.addStep(t, n.doc), n;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(t, n) {
    this.docs.push(this.doc), this.steps.push(t), this.mapping.appendMap(t.getMap()), this.doc = n;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(t, n = t, r = ye.empty) {
    let a = Ql(this.doc, t, n, r);
    return a && this.step(a), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(t, n, r) {
    return this.replace(t, n, new ye(oe.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(t, n) {
    return this.replace(t, n, ye.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(t, n) {
    return this.replaceWith(t, t, n);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(t, n, r) {
    return j7(this, t, n, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(t, n, r) {
    return F7(this, t, n, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(t, n) {
    return W7(this, t, n), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(t, n) {
    return S7(this, t, n), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(t, n = 1) {
    return R7(this, t, n), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(t, n) {
    return E7(this, t, n), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(t, n = t, r, a = null) {
    return I7(this, t, n, r, a), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(t, n, r = null, a) {
    return P7(this, t, n, r, a), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(t, n, r) {
    return this.step(new Qa(t, n, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(t, n) {
    return this.step(new go(t, n)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(t, n) {
    return this.step(new xr(t, n)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(t, n) {
    if (!(n instanceof qe)) {
      let r = this.doc.nodeAt(t);
      if (!r)
        throw new RangeError("No node at position " + t);
      if (n = n.isInSet(r.marks), !n)
        return this;
    }
    return this.step(new si(t, n)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split.
  */
  split(t, n = 1, r) {
    return L7(this, t, n, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(t, n, r) {
    return M7(this, t, n, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(t, n, r) {
    return w7(this, t, n, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(t, n, r) {
    return Qv(this, t, n, r), this;
  }
}
const ld = /* @__PURE__ */ Object.create(null);
class Ie {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(t, n, r) {
    this.$anchor = t, this.$head = n, this.ranges = r || [new q7(t.min(n), t.max(n))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let t = this.ranges;
    for (let n = 0; n < t.length; n++)
      if (t[n].$from.pos != t[n].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(t, n = ye.empty) {
    let r = n.content.lastChild, a = null;
    for (let s = 0; s < n.openEnd; s++)
      a = r, r = r.lastChild;
    let i = t.steps.length, o = this.ranges;
    for (let s = 0; s < o.length; s++) {
      let { $from: c, $to: l } = o[s], u = t.mapping.slice(i);
      t.replaceRange(u.map(c.pos), u.map(l.pos), s ? ye.empty : n), s == 0 && q0(t, i, (r ? r.isInline : a && a.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(t, n) {
    let r = t.steps.length, a = this.ranges;
    for (let i = 0; i < a.length; i++) {
      let { $from: o, $to: s } = a[i], c = t.mapping.slice(r), l = c.map(o.pos), u = c.map(s.pos);
      i ? t.deleteRange(l, u) : (t.replaceRangeWith(l, u, n), q0(t, r, n.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(t, n, r = !1) {
    let a = t.parent.inlineContent ? new De(t) : ja(t.node(0), t.parent, t.pos, t.index(), n, r);
    if (a)
      return a;
    for (let i = t.depth - 1; i >= 0; i--) {
      let o = n < 0 ? ja(t.node(0), t.node(i), t.before(i + 1), t.index(i), n, r) : ja(t.node(0), t.node(i), t.after(i + 1), t.index(i) + 1, n, r);
      if (o)
        return o;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(t, n = 1) {
    return this.findFrom(t, n) || this.findFrom(t, -n) || new vn(t.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(t) {
    return ja(t, t, 0, 0, 1) || new vn(t);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(t) {
    return ja(t, t, t.content.size, t.childCount, -1) || new vn(t);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(t, n) {
    if (!n || !n.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = ld[n.type];
    if (!r)
      throw new RangeError(`No selection type ${n.type} defined`);
    return r.fromJSON(t, n);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(t, n) {
    if (t in ld)
      throw new RangeError("Duplicate use of selection JSON ID " + t);
    return ld[t] = n, n.prototype.jsonID = t, n;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return De.between(this.$anchor, this.$head).getBookmark();
  }
}
Ie.prototype.visible = !0;
class q7 {
  /**
  Create a range.
  */
  constructor(t, n) {
    this.$from = t, this.$to = n;
  }
}
let F0 = !1;
function W0(e) {
  !F0 && !e.parent.inlineContent && (F0 = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + e.parent.type.name + ")"));
}
class De extends Ie {
  /**
  Construct a text selection between the given points.
  */
  constructor(t, n = t) {
    W0(t), W0(n), super(t, n);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(t, n) {
    let r = t.resolve(n.map(this.head));
    if (!r.parent.inlineContent)
      return Ie.near(r);
    let a = t.resolve(n.map(this.anchor));
    return new De(a.parent.inlineContent ? a : r, r);
  }
  replace(t, n = ye.empty) {
    if (super.replace(t, n), n == ye.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && t.ensureMarks(r);
    }
  }
  eq(t) {
    return t instanceof De && t.anchor == this.anchor && t.head == this.head;
  }
  getBookmark() {
    return new e1(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.anchor != "number" || typeof n.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new De(t.resolve(n.anchor), t.resolve(n.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(t, n, r = n) {
    let a = t.resolve(n);
    return new this(a, r == n ? a : t.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(t, n, r) {
    let a = t.pos - n.pos;
    if ((!r || a) && (r = a >= 0 ? 1 : -1), !n.parent.inlineContent) {
      let i = Ie.findFrom(n, r, !0) || Ie.findFrom(n, -r, !0);
      if (i)
        n = i.$head;
      else
        return Ie.near(n, r);
    }
    return t.parent.inlineContent || (a == 0 ? t = n : (t = (Ie.findFrom(t, -r, !0) || Ie.findFrom(t, r, !0)).$anchor, t.pos < n.pos != a < 0 && (t = n))), new De(t, n);
  }
}
Ie.jsonID("text", De);
class e1 {
  constructor(t, n) {
    this.anchor = t, this.head = n;
  }
  map(t) {
    return new e1(t.map(this.anchor), t.map(this.head));
  }
  resolve(t) {
    return De.between(t.resolve(this.anchor), t.resolve(this.head));
  }
}
class xe extends Ie {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(t) {
    let n = t.nodeAfter, r = t.node(0).resolve(t.pos + n.nodeSize);
    super(t, r), this.node = n;
  }
  map(t, n) {
    let { deleted: r, pos: a } = n.mapResult(this.anchor), i = t.resolve(a);
    return r ? Ie.near(i) : new xe(i);
  }
  content() {
    return new ye(oe.from(this.node), 0, 0);
  }
  eq(t) {
    return t instanceof xe && t.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new ip(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new xe(t.resolve(n.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(t, n) {
    return new xe(t.resolve(n));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(t) {
    return !t.isText && t.type.spec.selectable !== !1;
  }
}
xe.prototype.visible = !1;
Ie.jsonID("node", xe);
class ip {
  constructor(t) {
    this.anchor = t;
  }
  map(t) {
    let { deleted: n, pos: r } = t.mapResult(this.anchor);
    return n ? new e1(r, r) : new ip(r);
  }
  resolve(t) {
    let n = t.resolve(this.anchor), r = n.nodeAfter;
    return r && xe.isSelectable(r) ? new xe(n) : Ie.near(n);
  }
}
class vn extends Ie {
  /**
  Create an all-selection over the given document.
  */
  constructor(t) {
    super(t.resolve(0), t.resolve(t.content.size));
  }
  replace(t, n = ye.empty) {
    if (n == ye.empty) {
      t.delete(0, t.doc.content.size);
      let r = Ie.atStart(t.doc);
      r.eq(t.selection) || t.setSelection(r);
    } else
      super.replace(t, n);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(t) {
    return new vn(t);
  }
  map(t) {
    return new vn(t);
  }
  eq(t) {
    return t instanceof vn;
  }
  getBookmark() {
    return _7;
  }
}
Ie.jsonID("all", vn);
const _7 = {
  map() {
    return this;
  },
  resolve(e) {
    return new vn(e);
  }
};
function ja(e, t, n, r, a, i = !1) {
  if (t.inlineContent)
    return De.create(e, n);
  for (let o = r - (a > 0 ? 0 : 1); a > 0 ? o < t.childCount : o >= 0; o += a) {
    let s = t.child(o);
    if (s.isAtom) {
      if (!i && xe.isSelectable(s))
        return xe.create(e, n - (a < 0 ? s.nodeSize : 0));
    } else {
      let c = ja(e, s, n + a, a < 0 ? s.childCount : 0, a, i);
      if (c)
        return c;
    }
    n += s.nodeSize * a;
  }
  return null;
}
function q0(e, t, n) {
  let r = e.steps.length - 1;
  if (r < t)
    return;
  let a = e.steps[r];
  if (!(a instanceof ct || a instanceof lt))
    return;
  let i = e.mapping.maps[r], o;
  i.forEach((s, c, l, u) => {
    o == null && (o = u);
  }), e.setSelection(Ie.near(e.doc.resolve(o), n));
}
const _0 = 1, Ds = 2, G0 = 4;
class G7 extends ik {
  /**
  @internal
  */
  constructor(t) {
    super(t.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = t.selection, this.storedMarks = t.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(t) {
    if (t.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = t, this.curSelectionFor = this.steps.length, this.updated = (this.updated | _0) & ~Ds, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & _0) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(t) {
    return this.storedMarks = t, this.updated |= Ds, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(t) {
    return qe.sameSet(this.storedMarks || this.selection.$from.marks(), t) || this.setStoredMarks(t), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(t) {
    return this.ensureMarks(t.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(t) {
    return this.ensureMarks(t.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & Ds) > 0;
  }
  /**
  @internal
  */
  addStep(t, n) {
    super.addStep(t, n), this.updated = this.updated & ~Ds, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(t) {
    return this.time = t, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(t) {
    return this.selection.replace(this, t), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(t, n = !0) {
    let r = this.selection;
    return n && (t = t.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || qe.none))), r.replaceWith(this, t), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(t, n, r) {
    let a = this.doc.type.schema;
    if (n == null)
      return t ? this.replaceSelectionWith(a.text(t), !0) : this.deleteSelection();
    {
      if (r == null && (r = n), r = r ?? n, !t)
        return this.deleteRange(n, r);
      let i = this.storedMarks;
      if (!i) {
        let o = this.doc.resolve(n);
        i = r == n ? o.marks() : o.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(n, r, a.text(t, i)), this.selection.empty || this.setSelection(Ie.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(t, n) {
    return this.meta[typeof t == "string" ? t : t.key] = n, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(t) {
    return this.meta[typeof t == "string" ? t : t.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let t in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= G0, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & G0) > 0;
  }
}
function Z0(e, t) {
  return !t || !e ? e : e.bind(t);
}
class Ui {
  constructor(t, n, r) {
    this.name = t, this.init = Z0(n.init, r), this.apply = Z0(n.apply, r);
  }
}
const Z7 = [
  new Ui("doc", {
    init(e) {
      return e.doc || e.schema.topNodeType.createAndFill();
    },
    apply(e) {
      return e.doc;
    }
  }),
  new Ui("selection", {
    init(e, t) {
      return e.selection || Ie.atStart(t.doc);
    },
    apply(e) {
      return e.selection;
    }
  }),
  new Ui("storedMarks", {
    init(e) {
      return e.storedMarks || null;
    },
    apply(e, t, n, r) {
      return r.selection.$cursor ? e.storedMarks : null;
    }
  }),
  new Ui("scrollToSelection", {
    init() {
      return 0;
    },
    apply(e, t) {
      return e.scrolledIntoView ? t + 1 : t;
    }
  })
];
class dd {
  constructor(t, n) {
    this.schema = t, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = Z7.slice(), n && n.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new Ui(r.key, r.spec.state, r));
    });
  }
}
class Ga {
  /**
  @internal
  */
  constructor(t) {
    this.config = t;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(t) {
    return this.applyTransaction(t).state;
  }
  /**
  @internal
  */
  filterTransaction(t, n = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != n) {
        let a = this.config.plugins[r];
        if (a.spec.filterTransaction && !a.spec.filterTransaction.call(a, t, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(t) {
    if (!this.filterTransaction(t))
      return { state: this, transactions: [] };
    let n = [t], r = this.applyInner(t), a = null;
    for (; ; ) {
      let i = !1;
      for (let o = 0; o < this.config.plugins.length; o++) {
        let s = this.config.plugins[o];
        if (s.spec.appendTransaction) {
          let c = a ? a[o].n : 0, l = a ? a[o].state : this, u = c < n.length && s.spec.appendTransaction.call(s, c ? n.slice(c) : n, l, r);
          if (u && r.filterTransaction(u, o)) {
            if (u.setMeta("appendedTransaction", t), !a) {
              a = [];
              for (let h = 0; h < this.config.plugins.length; h++)
                a.push(h < o ? { state: r, n: n.length } : { state: this, n: 0 });
            }
            n.push(u), r = r.applyInner(u), i = !0;
          }
          a && (a[o] = { state: r, n: n.length });
        }
      }
      if (!i)
        return { state: r, transactions: n };
    }
  }
  /**
  @internal
  */
  applyInner(t) {
    if (!t.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let n = new Ga(this.config), r = this.config.fields;
    for (let a = 0; a < r.length; a++) {
      let i = r[a];
      n[i.name] = i.apply(t, this[i.name], this, n);
    }
    return n;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new G7(this);
  }
  /**
  Create a new state.
  */
  static create(t) {
    let n = new dd(t.doc ? t.doc.type.schema : t.schema, t.plugins), r = new Ga(n);
    for (let a = 0; a < n.fields.length; a++)
      r[n.fields[a].name] = n.fields[a].init(t, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(t) {
    let n = new dd(this.schema, t.plugins), r = n.fields, a = new Ga(n);
    for (let i = 0; i < r.length; i++) {
      let o = r[i].name;
      a[o] = this.hasOwnProperty(o) ? this[o] : r[i].init(t, a);
    }
    return a;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(t) {
    let n = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (n.storedMarks = this.storedMarks.map((r) => r.toJSON())), t && typeof t == "object")
      for (let r in t) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let a = t[r], i = a.spec.state;
        i && i.toJSON && (n[r] = i.toJSON.call(a, this[a.key]));
      }
    return n;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(t, n, r) {
    if (!n)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!t.schema)
      throw new RangeError("Required config field 'schema' missing");
    let a = new dd(t.schema, t.plugins), i = new Ga(a);
    return a.fields.forEach((o) => {
      if (o.name == "doc")
        i.doc = aa.fromJSON(t.schema, n.doc);
      else if (o.name == "selection")
        i.selection = Ie.fromJSON(i.doc, n.selection);
      else if (o.name == "storedMarks")
        n.storedMarks && (i.storedMarks = n.storedMarks.map(t.schema.markFromJSON));
      else {
        if (r)
          for (let s in r) {
            let c = r[s], l = c.spec.state;
            if (c.key == o.name && l && l.fromJSON && Object.prototype.hasOwnProperty.call(n, s)) {
              i[o.name] = l.fromJSON.call(c, t, n[s], i);
              return;
            }
          }
        i[o.name] = o.init(t, i);
      }
    }), i;
  }
}
function ok(e, t, n) {
  for (let r in e) {
    let a = e[r];
    a instanceof Function ? a = a.bind(t) : r == "handleDOMEvents" && (a = ok(a, t, {})), n[r] = a;
  }
  return n;
}
class At {
  /**
  Create a plugin.
  */
  constructor(t) {
    this.spec = t, this.props = {}, t.props && ok(t.props, this, this.props), this.key = t.key ? t.key.key : sk("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
const ud = /* @__PURE__ */ Object.create(null);
function sk(e) {
  return e in ud ? e + "$" + ++ud[e] : (ud[e] = 0, e + "$");
}
class nn {
  /**
  Create a plugin key.
  */
  constructor(t = "key") {
    this.key = sk(t);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(t) {
    return t.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
const mt = function(e) {
  for (var t = 0; ; t++)
    if (e = e.previousSibling, !e)
      return t;
}, vo = function(e) {
  let t = e.assignedSlot || e.parentNode;
  return t && t.nodeType == 11 ? t.host : t;
};
let wu = null;
const Kn = function(e, t, n) {
  let r = wu || (wu = document.createRange());
  return r.setEnd(e, n ?? e.nodeValue.length), r.setStart(e, t || 0), r;
}, X7 = function() {
  wu = null;
}, pa = function(e, t, n, r) {
  return n && (X0(e, t, n, r, -1) || X0(e, t, n, r, 1));
}, U7 = /^(img|br|input|textarea|hr)$/i;
function X0(e, t, n, r, a) {
  for (; ; ) {
    if (e == n && t == r)
      return !0;
    if (t == (a < 0 ? 0 : Nn(e))) {
      let i = e.parentNode;
      if (!i || i.nodeType != 1 || es(e) || U7.test(e.nodeName) || e.contentEditable == "false")
        return !1;
      t = mt(e) + (a < 0 ? 0 : 1), e = i;
    } else if (e.nodeType == 1) {
      if (e = e.childNodes[t + (a < 0 ? -1 : 0)], e.contentEditable == "false")
        return !1;
      t = a < 0 ? Nn(e) : 0;
    } else
      return !1;
  }
}
function Nn(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function Y7(e, t) {
  for (; ; ) {
    if (e.nodeType == 3 && t)
      return e;
    if (e.nodeType == 1 && t > 0) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[t - 1], t = Nn(e);
    } else if (e.parentNode && !es(e))
      t = mt(e), e = e.parentNode;
    else
      return null;
  }
}
function J7(e, t) {
  for (; ; ) {
    if (e.nodeType == 3 && t < e.nodeValue.length)
      return e;
    if (e.nodeType == 1 && t < e.childNodes.length) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[t], t = 0;
    } else if (e.parentNode && !es(e))
      t = mt(e) + 1, e = e.parentNode;
    else
      return null;
  }
}
function K7(e, t, n) {
  for (let r = t == 0, a = t == Nn(e); r || a; ) {
    if (e == n)
      return !0;
    let i = mt(e);
    if (e = e.parentNode, !e)
      return !1;
    r = r && i == 0, a = a && i == Nn(e);
  }
}
function es(e) {
  let t;
  for (let n = e; n && !(t = n.pmViewDesc); n = n.parentNode)
    ;
  return t && t.node && t.node.isBlock && (t.dom == e || t.contentDOM == e);
}
const t1 = function(e) {
  return e.focusNode && pa(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset);
};
function Ur(e, t) {
  let n = document.createEvent("Event");
  return n.initEvent("keydown", !0, !0), n.keyCode = e, n.key = n.code = t, n;
}
function Q7(e) {
  let t = e.activeElement;
  for (; t && t.shadowRoot; )
    t = t.shadowRoot.activeElement;
  return t;
}
function ew(e, t, n) {
  if (e.caretPositionFromPoint)
    try {
      let r = e.caretPositionFromPoint(t, n);
      if (r)
        return { node: r.offsetNode, offset: r.offset };
    } catch {
    }
  if (e.caretRangeFromPoint) {
    let r = e.caretRangeFromPoint(t, n);
    if (r)
      return { node: r.startContainer, offset: r.startOffset };
  }
}
const jn = typeof navigator < "u" ? navigator : null, U0 = typeof document < "u" ? document : null, Rr = jn && jn.userAgent || "", Cu = /Edge\/(\d+)/.exec(Rr), ck = /MSIE \d/.exec(Rr), Su = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Rr), $t = !!(ck || Su || Cu), Cr = ck ? document.documentMode : Su ? +Su[1] : Cu ? +Cu[1] : 0, kn = !$t && /gecko\/(\d+)/i.test(Rr);
kn && +(/Firefox\/(\d+)/.exec(Rr) || [0, 0])[1];
const Au = !$t && /Chrome\/(\d+)/.exec(Rr), Tt = !!Au, tw = Au ? +Au[1] : 0, Nt = !$t && !!jn && /Apple Computer/.test(jn.vendor), li = Nt && (/Mobile\/\w+/.test(Rr) || !!jn && jn.maxTouchPoints > 2), cn = li || (jn ? /Mac/.test(jn.platform) : !1), nw = jn ? /Win/.test(jn.platform) : !1, mn = /Android \d/.test(Rr), ts = !!U0 && "webkitFontSmoothing" in U0.documentElement.style, rw = ts ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function aw(e) {
  let t = e.defaultView && e.defaultView.visualViewport;
  return t ? {
    left: 0,
    right: t.width,
    top: 0,
    bottom: t.height
  } : {
    left: 0,
    right: e.documentElement.clientWidth,
    top: 0,
    bottom: e.documentElement.clientHeight
  };
}
function Xn(e, t) {
  return typeof e == "number" ? e : e[t];
}
function iw(e) {
  let t = e.getBoundingClientRect(), n = t.width / e.offsetWidth || 1, r = t.height / e.offsetHeight || 1;
  return {
    left: t.left,
    right: t.left + e.clientWidth * n,
    top: t.top,
    bottom: t.top + e.clientHeight * r
  };
}
function Y0(e, t, n) {
  let r = e.someProp("scrollThreshold") || 0, a = e.someProp("scrollMargin") || 5, i = e.dom.ownerDocument;
  for (let o = n || e.dom; o; o = vo(o)) {
    if (o.nodeType != 1)
      continue;
    let s = o, c = s == i.body, l = c ? aw(i) : iw(s), u = 0, h = 0;
    if (t.top < l.top + Xn(r, "top") ? h = -(l.top - t.top + Xn(a, "top")) : t.bottom > l.bottom - Xn(r, "bottom") && (h = t.bottom - t.top > l.bottom - l.top ? t.top + Xn(a, "top") - l.top : t.bottom - l.bottom + Xn(a, "bottom")), t.left < l.left + Xn(r, "left") ? u = -(l.left - t.left + Xn(a, "left")) : t.right > l.right - Xn(r, "right") && (u = t.right - l.right + Xn(a, "right")), u || h)
      if (c)
        i.defaultView.scrollBy(u, h);
      else {
        let p = s.scrollLeft, f = s.scrollTop;
        h && (s.scrollTop += h), u && (s.scrollLeft += u);
        let y = s.scrollLeft - p, m = s.scrollTop - f;
        t = { left: t.left - y, top: t.top - m, right: t.right - y, bottom: t.bottom - m };
      }
    if (c || /^(fixed|sticky)$/.test(getComputedStyle(o).position))
      break;
  }
}
function ow(e) {
  let t = e.dom.getBoundingClientRect(), n = Math.max(0, t.top), r, a;
  for (let i = (t.left + t.right) / 2, o = n + 1; o < Math.min(innerHeight, t.bottom); o += 5) {
    let s = e.root.elementFromPoint(i, o);
    if (!s || s == e.dom || !e.dom.contains(s))
      continue;
    let c = s.getBoundingClientRect();
    if (c.top >= n - 20) {
      r = s, a = c.top;
      break;
    }
  }
  return { refDOM: r, refTop: a, stack: lk(e.dom) };
}
function lk(e) {
  let t = [], n = e.ownerDocument;
  for (let r = e; r && (t.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), e != n); r = vo(r))
    ;
  return t;
}
function sw({ refDOM: e, refTop: t, stack: n }) {
  let r = e ? e.getBoundingClientRect().top : 0;
  dk(n, r == 0 ? 0 : r - t);
}
function dk(e, t) {
  for (let n = 0; n < e.length; n++) {
    let { dom: r, top: a, left: i } = e[n];
    r.scrollTop != a + t && (r.scrollTop = a + t), r.scrollLeft != i && (r.scrollLeft = i);
  }
}
let Ea = null;
function cw(e) {
  if (e.setActive)
    return e.setActive();
  if (Ea)
    return e.focus(Ea);
  let t = lk(e);
  e.focus(Ea == null ? {
    get preventScroll() {
      return Ea = { preventScroll: !0 }, !0;
    }
  } : void 0), Ea || (Ea = !1, dk(t, 0));
}
function uk(e, t) {
  let n, r = 2e8, a, i = 0, o = t.top, s = t.top, c, l;
  for (let u = e.firstChild, h = 0; u; u = u.nextSibling, h++) {
    let p;
    if (u.nodeType == 1)
      p = u.getClientRects();
    else if (u.nodeType == 3)
      p = Kn(u).getClientRects();
    else
      continue;
    for (let f = 0; f < p.length; f++) {
      let y = p[f];
      if (y.top <= o && y.bottom >= s) {
        o = Math.max(y.bottom, o), s = Math.min(y.top, s);
        let m = y.left > t.left ? y.left - t.left : y.right < t.left ? t.left - y.right : 0;
        if (m < r) {
          n = u, r = m, a = m && n.nodeType == 3 ? {
            left: y.right < t.left ? y.right : y.left,
            top: t.top
          } : t, u.nodeType == 1 && m && (i = h + (t.left >= (y.left + y.right) / 2 ? 1 : 0));
          continue;
        }
      } else
        y.top > t.top && !c && y.left <= t.left && y.right >= t.left && (c = u, l = { left: Math.max(y.left, Math.min(y.right, t.left)), top: y.top });
      !n && (t.left >= y.right && t.top >= y.top || t.left >= y.left && t.top >= y.bottom) && (i = h + 1);
    }
  }
  return !n && c && (n = c, a = l, r = 0), n && n.nodeType == 3 ? lw(n, a) : !n || r && n.nodeType == 1 ? { node: e, offset: i } : uk(n, a);
}
function lw(e, t) {
  let n = e.nodeValue.length, r = document.createRange();
  for (let a = 0; a < n; a++) {
    r.setEnd(e, a + 1), r.setStart(e, a);
    let i = pr(r, 1);
    if (i.top != i.bottom && op(t, i))
      return { node: e, offset: a + (t.left >= (i.left + i.right) / 2 ? 1 : 0) };
  }
  return { node: e, offset: 0 };
}
function op(e, t) {
  return e.left >= t.left - 1 && e.left <= t.right + 1 && e.top >= t.top - 1 && e.top <= t.bottom + 1;
}
function dw(e, t) {
  let n = e.parentNode;
  return n && /^li$/i.test(n.nodeName) && t.left < e.getBoundingClientRect().left ? n : e;
}
function uw(e, t, n) {
  let { node: r, offset: a } = uk(t, n), i = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let o = r.getBoundingClientRect();
    i = o.left != o.right && n.left > (o.left + o.right) / 2 ? 1 : -1;
  }
  return e.docView.posFromDOM(r, a, i);
}
function hw(e, t, n, r) {
  let a = -1;
  for (let i = t, o = !1; i != e.dom; ) {
    let s = e.docView.nearestDesc(i, !0);
    if (!s)
      return null;
    if (s.dom.nodeType == 1 && (s.node.isBlock && s.parent || !s.contentDOM)) {
      let c = s.dom.getBoundingClientRect();
      if (s.node.isBlock && s.parent && (!o && c.left > r.left || c.top > r.top ? a = s.posBefore : (!o && c.right < r.left || c.bottom < r.top) && (a = s.posAfter), o = !0), !s.contentDOM && a < 0 && !s.node.isText)
        return (s.node.isBlock ? r.top < (c.top + c.bottom) / 2 : r.left < (c.left + c.right) / 2) ? s.posBefore : s.posAfter;
    }
    i = s.dom.parentNode;
  }
  return a > -1 ? a : e.docView.posFromDOM(t, n, -1);
}
function hk(e, t, n) {
  let r = e.childNodes.length;
  if (r && n.top < n.bottom)
    for (let a = Math.max(0, Math.min(r - 1, Math.floor(r * (t.top - n.top) / (n.bottom - n.top)) - 2)), i = a; ; ) {
      let o = e.childNodes[i];
      if (o.nodeType == 1) {
        let s = o.getClientRects();
        for (let c = 0; c < s.length; c++) {
          let l = s[c];
          if (op(t, l))
            return hk(o, t, l);
        }
      }
      if ((i = (i + 1) % r) == a)
        break;
    }
  return e;
}
function pw(e, t) {
  let n = e.dom.ownerDocument, r, a = 0, i = ew(n, t.left, t.top);
  i && ({ node: r, offset: a } = i);
  let o = (e.root.elementFromPoint ? e.root : n).elementFromPoint(t.left, t.top), s;
  if (!o || !e.dom.contains(o.nodeType != 1 ? o.parentNode : o)) {
    let l = e.dom.getBoundingClientRect();
    if (!op(t, l) || (o = hk(e.dom, t, l), !o))
      return null;
  }
  if (Nt)
    for (let l = o; r && l; l = vo(l))
      l.draggable && (r = void 0);
  if (o = dw(o, t), r) {
    if (kn && r.nodeType == 1 && (a = Math.min(a, r.childNodes.length), a < r.childNodes.length)) {
      let u = r.childNodes[a], h;
      u.nodeName == "IMG" && (h = u.getBoundingClientRect()).right <= t.left && h.bottom > t.top && a++;
    }
    let l;
    ts && a && r.nodeType == 1 && (l = r.childNodes[a - 1]).nodeType == 1 && l.contentEditable == "false" && l.getBoundingClientRect().top >= t.top && a--, r == e.dom && a == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && t.top > r.lastChild.getBoundingClientRect().bottom ? s = e.state.doc.content.size : (a == 0 || r.nodeType != 1 || r.childNodes[a - 1].nodeName != "BR") && (s = hw(e, r, a, t));
  }
  s == null && (s = uw(e, o, t));
  let c = e.docView.nearestDesc(o, !0);
  return { pos: s, inside: c ? c.posAtStart - c.border : -1 };
}
function J0(e) {
  return e.top < e.bottom || e.left < e.right;
}
function pr(e, t) {
  let n = e.getClientRects();
  if (n.length) {
    let r = n[t < 0 ? 0 : n.length - 1];
    if (J0(r))
      return r;
  }
  return Array.prototype.find.call(n, J0) || e.getBoundingClientRect();
}
const fw = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function pk(e, t, n) {
  let { node: r, offset: a, atom: i } = e.docView.domFromPos(t, n < 0 ? -1 : 1), o = ts || kn;
  if (r.nodeType == 3)
    if (o && (fw.test(r.nodeValue) || (n < 0 ? !a : a == r.nodeValue.length))) {
      let c = pr(Kn(r, a, a), n);
      if (kn && a && /\s/.test(r.nodeValue[a - 1]) && a < r.nodeValue.length) {
        let l = pr(Kn(r, a - 1, a - 1), -1);
        if (l.top == c.top) {
          let u = pr(Kn(r, a, a + 1), -1);
          if (u.top != c.top)
            return Hi(u, u.left < l.left);
        }
      }
      return c;
    } else {
      let c = a, l = a, u = n < 0 ? 1 : -1;
      return n < 0 && !a ? (l++, u = -1) : n >= 0 && a == r.nodeValue.length ? (c--, u = 1) : n < 0 ? c-- : l++, Hi(pr(Kn(r, c, l), u), u < 0);
    }
  if (!e.state.doc.resolve(t - (i || 0)).parent.inlineContent) {
    if (i == null && a && (n < 0 || a == Nn(r))) {
      let c = r.childNodes[a - 1];
      if (c.nodeType == 1)
        return hd(c.getBoundingClientRect(), !1);
    }
    if (i == null && a < Nn(r)) {
      let c = r.childNodes[a];
      if (c.nodeType == 1)
        return hd(c.getBoundingClientRect(), !0);
    }
    return hd(r.getBoundingClientRect(), n >= 0);
  }
  if (i == null && a && (n < 0 || a == Nn(r))) {
    let c = r.childNodes[a - 1], l = c.nodeType == 3 ? Kn(c, Nn(c) - (o ? 0 : 1)) : c.nodeType == 1 && (c.nodeName != "BR" || !c.nextSibling) ? c : null;
    if (l)
      return Hi(pr(l, 1), !1);
  }
  if (i == null && a < Nn(r)) {
    let c = r.childNodes[a];
    for (; c.pmViewDesc && c.pmViewDesc.ignoreForCoords; )
      c = c.nextSibling;
    let l = c ? c.nodeType == 3 ? Kn(c, 0, o ? 0 : 1) : c.nodeType == 1 ? c : null : null;
    if (l)
      return Hi(pr(l, -1), !0);
  }
  return Hi(pr(r.nodeType == 3 ? Kn(r) : r, -n), n >= 0);
}
function Hi(e, t) {
  if (e.width == 0)
    return e;
  let n = t ? e.left : e.right;
  return { top: e.top, bottom: e.bottom, left: n, right: n };
}
function hd(e, t) {
  if (e.height == 0)
    return e;
  let n = t ? e.top : e.bottom;
  return { top: n, bottom: n, left: e.left, right: e.right };
}
function fk(e, t, n) {
  let r = e.state, a = e.root.activeElement;
  r != t && e.updateState(t), a != e.dom && e.focus();
  try {
    return n();
  } finally {
    r != t && e.updateState(r), a != e.dom && a && a.focus();
  }
}
function yw(e, t, n) {
  let r = t.selection, a = n == "up" ? r.$from : r.$to;
  return fk(e, t, () => {
    let { node: i } = e.docView.domFromPos(a.pos, n == "up" ? -1 : 1);
    for (; ; ) {
      let s = e.docView.nearestDesc(i, !0);
      if (!s)
        break;
      if (s.node.isBlock) {
        i = s.contentDOM || s.dom;
        break;
      }
      i = s.dom.parentNode;
    }
    let o = pk(e, a.pos, 1);
    for (let s = i.firstChild; s; s = s.nextSibling) {
      let c;
      if (s.nodeType == 1)
        c = s.getClientRects();
      else if (s.nodeType == 3)
        c = Kn(s, 0, s.nodeValue.length).getClientRects();
      else
        continue;
      for (let l = 0; l < c.length; l++) {
        let u = c[l];
        if (u.bottom > u.top + 1 && (n == "up" ? o.top - u.top > (u.bottom - o.top) * 2 : u.bottom - o.bottom > (o.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const mw = /[\u0590-\u08ac]/;
function gw(e, t, n) {
  let { $head: r } = t.selection;
  if (!r.parent.isTextblock)
    return !1;
  let a = r.parentOffset, i = !a, o = a == r.parent.content.size, s = e.domSelection();
  return !mw.test(r.parent.textContent) || !s.modify ? n == "left" || n == "backward" ? i : o : fk(e, t, () => {
    let { focusNode: c, focusOffset: l, anchorNode: u, anchorOffset: h } = e.domSelectionRange(), p = s.caretBidiLevel;
    s.modify("move", n, "character");
    let f = r.depth ? e.docView.domAfterPos(r.before()) : e.dom, { focusNode: y, focusOffset: m } = e.domSelectionRange(), v = y && !f.contains(y.nodeType == 1 ? y : y.parentNode) || c == y && l == m;
    try {
      s.collapse(u, h), c && (c != u || l != h) && s.extend && s.extend(c, l);
    } catch {
    }
    return p != null && (s.caretBidiLevel = p), v;
  });
}
let K0 = null, Q0 = null, ef = !1;
function vw(e, t, n) {
  return K0 == t && Q0 == n ? ef : (K0 = t, Q0 = n, ef = n == "up" || n == "down" ? yw(e, t, n) : gw(e, t, n));
}
const ln = 0, tf = 1, Jr = 2, Fn = 3;
class ns {
  constructor(t, n, r, a) {
    this.parent = t, this.children = n, this.dom = r, this.contentDOM = a, this.dirty = ln, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(t) {
    return !1;
  }
  matchesMark(t) {
    return !1;
  }
  matchesNode(t, n, r) {
    return !1;
  }
  matchesHack(t) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(t) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let t = 0;
    for (let n = 0; n < this.children.length; n++)
      t += this.children[n].size;
    return t;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let t = 0; t < this.children.length; t++)
      this.children[t].destroy();
  }
  posBeforeChild(t) {
    for (let n = 0, r = this.posAtStart; ; n++) {
      let a = this.children[n];
      if (a == t)
        return r;
      r += a.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(t, n, r) {
    if (this.contentDOM && this.contentDOM.contains(t.nodeType == 1 ? t : t.parentNode))
      if (r < 0) {
        let i, o;
        if (t == this.contentDOM)
          i = t.childNodes[n - 1];
        else {
          for (; t.parentNode != this.contentDOM; )
            t = t.parentNode;
          i = t.previousSibling;
        }
        for (; i && !((o = i.pmViewDesc) && o.parent == this); )
          i = i.previousSibling;
        return i ? this.posBeforeChild(o) + o.size : this.posAtStart;
      } else {
        let i, o;
        if (t == this.contentDOM)
          i = t.childNodes[n];
        else {
          for (; t.parentNode != this.contentDOM; )
            t = t.parentNode;
          i = t.nextSibling;
        }
        for (; i && !((o = i.pmViewDesc) && o.parent == this); )
          i = i.nextSibling;
        return i ? this.posBeforeChild(o) : this.posAtEnd;
      }
    let a;
    if (t == this.dom && this.contentDOM)
      a = n > mt(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      a = t.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (n == 0)
        for (let i = t; ; i = i.parentNode) {
          if (i == this.dom) {
            a = !1;
            break;
          }
          if (i.previousSibling)
            break;
        }
      if (a == null && n == t.childNodes.length)
        for (let i = t; ; i = i.parentNode) {
          if (i == this.dom) {
            a = !0;
            break;
          }
          if (i.nextSibling)
            break;
        }
    }
    return a ?? r > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(t, n = !1) {
    for (let r = !0, a = t; a; a = a.parentNode) {
      let i = this.getDesc(a), o;
      if (i && (!n || i.node))
        if (r && (o = i.nodeDOM) && !(o.nodeType == 1 ? o.contains(t.nodeType == 1 ? t : t.parentNode) : o == t))
          r = !1;
        else
          return i;
    }
  }
  getDesc(t) {
    let n = t.pmViewDesc;
    for (let r = n; r; r = r.parent)
      if (r == this)
        return n;
  }
  posFromDOM(t, n, r) {
    for (let a = t; a; a = a.parentNode) {
      let i = this.getDesc(a);
      if (i)
        return i.localPosFromDOM(t, n, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(t) {
    for (let n = 0, r = 0; n < this.children.length; n++) {
      let a = this.children[n], i = r + a.size;
      if (r == t && i != r) {
        for (; !a.border && a.children.length; )
          a = a.children[0];
        return a;
      }
      if (t < i)
        return a.descAt(t - r - a.border);
      r = i;
    }
  }
  domFromPos(t, n) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: t + 1 };
    let r = 0, a = 0;
    for (let i = 0; r < this.children.length; r++) {
      let o = this.children[r], s = i + o.size;
      if (s > t || o instanceof mk) {
        a = t - i;
        break;
      }
      i = s;
    }
    if (a)
      return this.children[r].domFromPos(a - this.children[r].border, n);
    for (let i; r && !(i = this.children[r - 1]).size && i instanceof yk && i.side >= 0; r--)
      ;
    if (n <= 0) {
      let i, o = !0;
      for (; i = r ? this.children[r - 1] : null, !(!i || i.dom.parentNode == this.contentDOM); r--, o = !1)
        ;
      return i && n && o && !i.border && !i.domAtom ? i.domFromPos(i.size, n) : { node: this.contentDOM, offset: i ? mt(i.dom) + 1 : 0 };
    } else {
      let i, o = !0;
      for (; i = r < this.children.length ? this.children[r] : null, !(!i || i.dom.parentNode == this.contentDOM); r++, o = !1)
        ;
      return i && o && !i.border && !i.domAtom ? i.domFromPos(0, n) : { node: this.contentDOM, offset: i ? mt(i.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(t, n, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: t, to: n, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let a = -1, i = -1;
    for (let o = r, s = 0; ; s++) {
      let c = this.children[s], l = o + c.size;
      if (a == -1 && t <= l) {
        let u = o + c.border;
        if (t >= u && n <= l - c.border && c.node && c.contentDOM && this.contentDOM.contains(c.contentDOM))
          return c.parseRange(t, n, u);
        t = o;
        for (let h = s; h > 0; h--) {
          let p = this.children[h - 1];
          if (p.size && p.dom.parentNode == this.contentDOM && !p.emptyChildAt(1)) {
            a = mt(p.dom) + 1;
            break;
          }
          t -= p.size;
        }
        a == -1 && (a = 0);
      }
      if (a > -1 && (l > n || s == this.children.length - 1)) {
        n = l;
        for (let u = s + 1; u < this.children.length; u++) {
          let h = this.children[u];
          if (h.size && h.dom.parentNode == this.contentDOM && !h.emptyChildAt(-1)) {
            i = mt(h.dom);
            break;
          }
          n += h.size;
        }
        i == -1 && (i = this.contentDOM.childNodes.length);
        break;
      }
      o = l;
    }
    return { node: this.contentDOM, from: t, to: n, fromOffset: a, toOffset: i };
  }
  emptyChildAt(t) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let n = this.children[t < 0 ? 0 : this.children.length - 1];
    return n.size == 0 || n.emptyChildAt(t);
  }
  domAfterPos(t) {
    let { node: n, offset: r } = this.domFromPos(t, 0);
    if (n.nodeType != 1 || r == n.childNodes.length)
      throw new RangeError("No node after pos " + t);
    return n.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(t, n, r, a = !1) {
    let i = Math.min(t, n), o = Math.max(t, n);
    for (let p = 0, f = 0; p < this.children.length; p++) {
      let y = this.children[p], m = f + y.size;
      if (i > f && o < m)
        return y.setSelection(t - f - y.border, n - f - y.border, r, a);
      f = m;
    }
    let s = this.domFromPos(t, t ? -1 : 1), c = n == t ? s : this.domFromPos(n, n ? -1 : 1), l = r.getSelection(), u = !1;
    if ((kn || Nt) && t == n) {
      let { node: p, offset: f } = s;
      if (p.nodeType == 3) {
        if (u = !!(f && p.nodeValue[f - 1] == `
`), u && f == p.nodeValue.length)
          for (let y = p, m; y; y = y.parentNode) {
            if (m = y.nextSibling) {
              m.nodeName == "BR" && (s = c = { node: m.parentNode, offset: mt(m) + 1 });
              break;
            }
            let v = y.pmViewDesc;
            if (v && v.node && v.node.isBlock)
              break;
          }
      } else {
        let y = p.childNodes[f - 1];
        u = y && (y.nodeName == "BR" || y.contentEditable == "false");
      }
    }
    if (kn && l.focusNode && l.focusNode != c.node && l.focusNode.nodeType == 1) {
      let p = l.focusNode.childNodes[l.focusOffset];
      p && p.contentEditable == "false" && (a = !0);
    }
    if (!(a || u && Nt) && pa(s.node, s.offset, l.anchorNode, l.anchorOffset) && pa(c.node, c.offset, l.focusNode, l.focusOffset))
      return;
    let h = !1;
    if ((l.extend || t == n) && !u) {
      l.collapse(s.node, s.offset);
      try {
        t != n && l.extend(c.node, c.offset), h = !0;
      } catch {
      }
    }
    if (!h) {
      if (t > n) {
        let f = s;
        s = c, c = f;
      }
      let p = document.createRange();
      p.setEnd(c.node, c.offset), p.setStart(s.node, s.offset), l.removeAllRanges(), l.addRange(p);
    }
  }
  ignoreMutation(t) {
    return !this.contentDOM && t.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(t, n) {
    for (let r = 0, a = 0; a < this.children.length; a++) {
      let i = this.children[a], o = r + i.size;
      if (r == o ? t <= o && n >= r : t < o && n > r) {
        let s = r + i.border, c = o - i.border;
        if (t >= s && n <= c) {
          this.dirty = t == r || n == o ? Jr : tf, t == s && n == c && (i.contentLost || i.dom.parentNode != this.contentDOM) ? i.dirty = Fn : i.markDirty(t - s, n - s);
          return;
        } else
          i.dirty = i.dom == i.contentDOM && i.dom.parentNode == this.contentDOM && !i.children.length ? Jr : Fn;
      }
      r = o;
    }
    this.dirty = Jr;
  }
  markParentsDirty() {
    let t = 1;
    for (let n = this.parent; n; n = n.parent, t++) {
      let r = t == 1 ? Jr : tf;
      n.dirty < r && (n.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  isText(t) {
    return !1;
  }
}
class yk extends ns {
  constructor(t, n, r, a) {
    let i, o = n.type.toDOM;
    if (typeof o == "function" && (o = o(r, () => {
      if (!i)
        return a;
      if (i.parent)
        return i.parent.posBeforeChild(i);
    })), !n.type.spec.raw) {
      if (o.nodeType != 1) {
        let s = document.createElement("span");
        s.appendChild(o), o = s;
      }
      o.contentEditable = "false", o.classList.add("ProseMirror-widget");
    }
    super(t, [], o, null), this.widget = n, this.widget = n, i = this;
  }
  matchesWidget(t) {
    return this.dirty == ln && t.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(t) {
    let n = this.widget.spec.stopEvent;
    return n ? n(t) : !1;
  }
  ignoreMutation(t) {
    return t.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class kw extends ns {
  constructor(t, n, r, a) {
    super(t, [], n, null), this.textDOM = r, this.text = a;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(t, n) {
    return t != this.textDOM ? this.posAtStart + (n ? this.size : 0) : this.posAtStart + n;
  }
  domFromPos(t) {
    return { node: this.textDOM, offset: t };
  }
  ignoreMutation(t) {
    return t.type === "characterData" && t.target.nodeValue == t.oldValue;
  }
}
class fa extends ns {
  constructor(t, n, r, a) {
    super(t, [], r, a), this.mark = n;
  }
  static create(t, n, r, a) {
    let i = a.nodeViews[n.type.name], o = i && i(n, a, r);
    return (!o || !o.dom) && (o = Rn.renderSpec(document, n.type.spec.toDOM(n, r))), new fa(t, n, o.dom, o.contentDOM || o.dom);
  }
  parseRule() {
    return this.dirty & Fn || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(t) {
    return this.dirty != Fn && this.mark.eq(t);
  }
  markDirty(t, n) {
    if (super.markDirty(t, n), this.dirty != ln) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = ln;
    }
  }
  slice(t, n, r) {
    let a = fa.create(this.parent, this.mark, !0, r), i = this.children, o = this.size;
    n < o && (i = Iu(i, n, o, r)), t > 0 && (i = Iu(i, 0, t, r));
    for (let s = 0; s < i.length; s++)
      i[s].parent = a;
    return a.children = i, a;
  }
}
class Sr extends ns {
  constructor(t, n, r, a, i, o, s, c, l) {
    super(t, [], i, o), this.node = n, this.outerDeco = r, this.innerDeco = a, this.nodeDOM = s;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(t, n, r, a, i, o) {
    let s = i.nodeViews[n.type.name], c, l = s && s(n, i, () => {
      if (!c)
        return o;
      if (c.parent)
        return c.parent.posBeforeChild(c);
    }, r, a), u = l && l.dom, h = l && l.contentDOM;
    if (n.isText) {
      if (!u)
        u = document.createTextNode(n.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else
      u || ({ dom: u, contentDOM: h } = Rn.renderSpec(document, n.type.spec.toDOM(n)));
    !h && !n.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), n.type.spec.draggable && (u.draggable = !0));
    let p = u;
    return u = kk(u, r, n), l ? c = new bw(t, n, r, a, u, h || null, p, l, i, o + 1) : n.isText ? new n1(t, n, r, a, u, p, i) : new Sr(t, n, r, a, u, h || null, p, i, o + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let t = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (t.preserveWhitespace = "full"), !this.contentDOM)
      t.getContent = () => this.node.content;
    else if (!this.contentLost)
      t.contentElement = this.contentDOM;
    else {
      for (let n = this.children.length - 1; n >= 0; n--) {
        let r = this.children[n];
        if (this.dom.contains(r.dom.parentNode)) {
          t.contentElement = r.dom.parentNode;
          break;
        }
      }
      t.contentElement || (t.getContent = () => oe.empty);
    }
    return t;
  }
  matchesNode(t, n, r) {
    return this.dirty == ln && t.eq(this.node) && Eu(n, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(t, n) {
    let r = this.node.inlineContent, a = n, i = t.composing ? this.localCompositionInfo(t, n) : null, o = i && i.pos > -1 ? i : null, s = i && i.pos < 0, c = new Mw(this, o && o.node, t);
    Sw(this.node, this.innerDeco, (l, u, h) => {
      l.spec.marks ? c.syncToMarks(l.spec.marks, r, t) : l.type.side >= 0 && !h && c.syncToMarks(u == this.node.childCount ? qe.none : this.node.child(u).marks, r, t), c.placeWidget(l, t, a);
    }, (l, u, h, p) => {
      c.syncToMarks(l.marks, r, t);
      let f;
      c.findNodeMatch(l, u, h, p) || s && t.state.selection.from > a && t.state.selection.to < a + l.nodeSize && (f = c.findIndexWithChild(i.node)) > -1 && c.updateNodeAt(l, u, h, f, t) || c.updateNextNode(l, u, h, t, p, a) || c.addNode(l, u, h, t, a), a += l.nodeSize;
    }), c.syncToMarks([], r, t), this.node.isTextblock && c.addTextblockHacks(), c.destroyRest(), (c.changed || this.dirty == Jr) && (o && this.protectLocalComposition(t, o), gk(this.contentDOM, this.children, t), li && Aw(this.dom));
  }
  localCompositionInfo(t, n) {
    let { from: r, to: a } = t.state.selection;
    if (!(t.state.selection instanceof De) || r < n || a > n + this.node.content.size)
      return null;
    let i = t.input.compositionNode;
    if (!i || !this.dom.contains(i.parentNode))
      return null;
    if (this.node.inlineContent) {
      let o = i.nodeValue, s = Ow(this.node.content, o, r - n, a - n);
      return s < 0 ? null : { node: i, pos: s, text: o };
    } else
      return { node: i, pos: -1, text: "" };
  }
  protectLocalComposition(t, { node: n, pos: r, text: a }) {
    if (this.getDesc(n))
      return;
    let i = n;
    for (; i.parentNode != this.contentDOM; i = i.parentNode) {
      for (; i.previousSibling; )
        i.parentNode.removeChild(i.previousSibling);
      for (; i.nextSibling; )
        i.parentNode.removeChild(i.nextSibling);
      i.pmViewDesc && (i.pmViewDesc = void 0);
    }
    let o = new kw(this, i, n, a);
    t.input.compositionNodes.push(o), this.children = Iu(this.children, r, r + a.length, t, o);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(t, n, r, a) {
    return this.dirty == Fn || !t.sameMarkup(this.node) ? !1 : (this.updateInner(t, n, r, a), !0);
  }
  updateInner(t, n, r, a) {
    this.updateOuterDeco(n), this.node = t, this.innerDeco = r, this.contentDOM && this.updateChildren(a, this.posAtStart), this.dirty = ln;
  }
  updateOuterDeco(t) {
    if (Eu(t, this.outerDeco))
      return;
    let n = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = vk(this.dom, this.nodeDOM, Ou(this.outerDeco, this.node, n), Ou(t, this.node, n)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = t;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function nf(e, t, n, r, a) {
  kk(r, t, e);
  let i = new Sr(void 0, e, t, n, r, r, r, a, 0);
  return i.contentDOM && i.updateChildren(a, 0), i;
}
class n1 extends Sr {
  constructor(t, n, r, a, i, o, s) {
    super(t, n, r, a, i, null, o, s, 0);
  }
  parseRule() {
    let t = this.nodeDOM.parentNode;
    for (; t && t != this.dom && !t.pmIsDeco; )
      t = t.parentNode;
    return { skip: t || !0 };
  }
  update(t, n, r, a) {
    return this.dirty == Fn || this.dirty != ln && !this.inParent() || !t.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(n), (this.dirty != ln || t.text != this.node.text) && t.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = t.text, a.trackWrites == this.nodeDOM && (a.trackWrites = null)), this.node = t, this.dirty = ln, !0);
  }
  inParent() {
    let t = this.parent.contentDOM;
    for (let n = this.nodeDOM; n; n = n.parentNode)
      if (n == t)
        return !0;
    return !1;
  }
  domFromPos(t) {
    return { node: this.nodeDOM, offset: t };
  }
  localPosFromDOM(t, n, r) {
    return t == this.nodeDOM ? this.posAtStart + Math.min(n, this.node.text.length) : super.localPosFromDOM(t, n, r);
  }
  ignoreMutation(t) {
    return t.type != "characterData" && t.type != "selection";
  }
  slice(t, n, r) {
    let a = this.node.cut(t, n), i = document.createTextNode(a.text);
    return new n1(this.parent, a, this.outerDeco, this.innerDeco, i, i, r);
  }
  markDirty(t, n) {
    super.markDirty(t, n), this.dom != this.nodeDOM && (t == 0 || n == this.nodeDOM.nodeValue.length) && (this.dirty = Fn);
  }
  get domAtom() {
    return !1;
  }
  isText(t) {
    return this.node.text == t;
  }
}
class mk extends ns {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(t) {
    return this.dirty == ln && this.dom.nodeName == t;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class bw extends Sr {
  constructor(t, n, r, a, i, o, s, c, l, u) {
    super(t, n, r, a, i, o, s, l, u), this.spec = c;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(t, n, r, a) {
    if (this.dirty == Fn)
      return !1;
    if (this.spec.update) {
      let i = this.spec.update(t, n, r);
      return i && this.updateInner(t, n, r, a), i;
    } else
      return !this.contentDOM && !t.isLeaf ? !1 : super.update(t, n, r, a);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(t, n, r, a) {
    this.spec.setSelection ? this.spec.setSelection(t, n, r) : super.setSelection(t, n, r, a);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(t) {
    return this.spec.stopEvent ? this.spec.stopEvent(t) : !1;
  }
  ignoreMutation(t) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(t) : super.ignoreMutation(t);
  }
}
function gk(e, t, n) {
  let r = e.firstChild, a = !1;
  for (let i = 0; i < t.length; i++) {
    let o = t[i], s = o.dom;
    if (s.parentNode == e) {
      for (; s != r; )
        r = rf(r), a = !0;
      r = r.nextSibling;
    } else
      a = !0, e.insertBefore(s, r);
    if (o instanceof fa) {
      let c = r ? r.previousSibling : e.lastChild;
      gk(o.contentDOM, o.children, n), r = c ? c.nextSibling : e.firstChild;
    }
  }
  for (; r; )
    r = rf(r), a = !0;
  a && n.trackWrites == e && (n.trackWrites = null);
}
const no = function(e) {
  e && (this.nodeName = e);
};
no.prototype = /* @__PURE__ */ Object.create(null);
const Kr = [new no()];
function Ou(e, t, n) {
  if (e.length == 0)
    return Kr;
  let r = n ? Kr[0] : new no(), a = [r];
  for (let i = 0; i < e.length; i++) {
    let o = e[i].type.attrs;
    if (o) {
      o.nodeName && a.push(r = new no(o.nodeName));
      for (let s in o) {
        let c = o[s];
        c != null && (n && a.length == 1 && a.push(r = new no(t.isInline ? "span" : "div")), s == "class" ? r.class = (r.class ? r.class + " " : "") + c : s == "style" ? r.style = (r.style ? r.style + ";" : "") + c : s != "nodeName" && (r[s] = c));
      }
    }
  }
  return a;
}
function vk(e, t, n, r) {
  if (n == Kr && r == Kr)
    return t;
  let a = t;
  for (let i = 0; i < r.length; i++) {
    let o = r[i], s = n[i];
    if (i) {
      let c;
      s && s.nodeName == o.nodeName && a != e && (c = a.parentNode) && c.nodeName.toLowerCase() == o.nodeName || (c = document.createElement(o.nodeName), c.pmIsDeco = !0, c.appendChild(a), s = Kr[0]), a = c;
    }
    xw(a, s || Kr[0], o);
  }
  return a;
}
function xw(e, t, n) {
  for (let r in t)
    r != "class" && r != "style" && r != "nodeName" && !(r in n) && e.removeAttribute(r);
  for (let r in n)
    r != "class" && r != "style" && r != "nodeName" && n[r] != t[r] && e.setAttribute(r, n[r]);
  if (t.class != n.class) {
    let r = t.class ? t.class.split(" ").filter(Boolean) : [], a = n.class ? n.class.split(" ").filter(Boolean) : [];
    for (let i = 0; i < r.length; i++)
      a.indexOf(r[i]) == -1 && e.classList.remove(r[i]);
    for (let i = 0; i < a.length; i++)
      r.indexOf(a[i]) == -1 && e.classList.add(a[i]);
    e.classList.length == 0 && e.removeAttribute("class");
  }
  if (t.style != n.style) {
    if (t.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, a;
      for (; a = r.exec(t.style); )
        e.style.removeProperty(a[1]);
    }
    n.style && (e.style.cssText += n.style);
  }
}
function kk(e, t, n) {
  return vk(e, e, Kr, Ou(t, n, e.nodeType != 1));
}
function Eu(e, t) {
  if (e.length != t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (!e[n].type.eq(t[n].type))
      return !1;
  return !0;
}
function rf(e) {
  let t = e.nextSibling;
  return e.parentNode.removeChild(e), t;
}
class Mw {
  constructor(t, n, r) {
    this.lock = n, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = t, this.preMatch = ww(t.node.content, t);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(t, n) {
    if (t != n) {
      for (let r = t; r < n; r++)
        this.top.children[r].destroy();
      this.top.children.splice(t, n - t), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(t, n, r) {
    let a = 0, i = this.stack.length >> 1, o = Math.min(i, t.length);
    for (; a < o && (a == i - 1 ? this.top : this.stack[a + 1 << 1]).matchesMark(t[a]) && t[a].type.spec.spanning !== !1; )
      a++;
    for (; a < i; )
      this.destroyRest(), this.top.dirty = ln, this.index = this.stack.pop(), this.top = this.stack.pop(), i--;
    for (; i < t.length; ) {
      this.stack.push(this.top, this.index + 1);
      let s = -1;
      for (let c = this.index; c < Math.min(this.index + 3, this.top.children.length); c++) {
        let l = this.top.children[c];
        if (l.matchesMark(t[i]) && !this.isLocked(l.dom)) {
          s = c;
          break;
        }
      }
      if (s > -1)
        s > this.index && (this.changed = !0, this.destroyBetween(this.index, s)), this.top = this.top.children[this.index];
      else {
        let c = fa.create(this.top, t[i], n, r);
        this.top.children.splice(this.index, 0, c), this.top = c, this.changed = !0;
      }
      this.index = 0, i++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(t, n, r, a) {
    let i = -1, o;
    if (a >= this.preMatch.index && (o = this.preMatch.matches[a - this.preMatch.index]).parent == this.top && o.matchesNode(t, n, r))
      i = this.top.children.indexOf(o, this.index);
    else
      for (let s = this.index, c = Math.min(this.top.children.length, s + 5); s < c; s++) {
        let l = this.top.children[s];
        if (l.matchesNode(t, n, r) && !this.preMatch.matched.has(l)) {
          i = s;
          break;
        }
      }
    return i < 0 ? !1 : (this.destroyBetween(this.index, i), this.index++, !0);
  }
  updateNodeAt(t, n, r, a, i) {
    let o = this.top.children[a];
    return o.dirty == Fn && o.dom == o.contentDOM && (o.dirty = Jr), o.update(t, n, r, i) ? (this.destroyBetween(this.index, a), this.index++, !0) : !1;
  }
  findIndexWithChild(t) {
    for (; ; ) {
      let n = t.parentNode;
      if (!n)
        return -1;
      if (n == this.top.contentDOM) {
        let r = t.pmViewDesc;
        if (r) {
          for (let a = this.index; a < this.top.children.length; a++)
            if (this.top.children[a] == r)
              return a;
        }
        return -1;
      }
      t = n;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(t, n, r, a, i, o) {
    for (let s = this.index; s < this.top.children.length; s++) {
      let c = this.top.children[s];
      if (c instanceof Sr) {
        let l = this.preMatch.matched.get(c);
        if (l != null && l != i)
          return !1;
        let u = c.dom, h, p = this.isLocked(u) && !(t.isText && c.node && c.node.isText && c.nodeDOM.nodeValue == t.text && c.dirty != Fn && Eu(n, c.outerDeco));
        if (!p && c.update(t, n, r, a))
          return this.destroyBetween(this.index, s), c.dom != u && (this.changed = !0), this.index++, !0;
        if (!p && (h = this.recreateWrapper(c, t, n, r, a, o)))
          return this.top.children[this.index] = h, h.contentDOM && (h.dirty = Jr, h.updateChildren(a, o + 1), h.dirty = ln), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(t, n, r, a, i, o) {
    if (t.dirty || n.isAtom || !t.children.length || !t.node.content.eq(n.content))
      return null;
    let s = Sr.create(this.top, n, r, a, i, o);
    if (s.contentDOM) {
      s.children = t.children, t.children = [];
      for (let c of s.children)
        c.parent = s;
    }
    return t.destroy(), s;
  }
  // Insert the node as a newly created node desc.
  addNode(t, n, r, a, i) {
    let o = Sr.create(this.top, t, n, r, a, i);
    o.contentDOM && o.updateChildren(a, i + 1), this.top.children.splice(this.index++, 0, o), this.changed = !0;
  }
  placeWidget(t, n, r) {
    let a = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (a && a.matchesWidget(t) && (t == a.widget || !a.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let i = new yk(this.top, t, n, r);
      this.top.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let t = this.top.children[this.index - 1], n = this.top;
    for (; t instanceof fa; )
      n = t, t = n.children[n.children.length - 1];
    (!t || // Empty textblock
    !(t instanceof n1) || /\n$/.test(t.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(t.node.text)) && ((Nt || Tt) && t && t.dom.contentEditable == "false" && this.addHackNode("IMG", n), this.addHackNode("BR", this.top));
  }
  addHackNode(t, n) {
    if (n == this.top && this.index < n.children.length && n.children[this.index].matchesHack(t))
      this.index++;
    else {
      let r = document.createElement(t);
      t == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), t == "BR" && (r.className = "ProseMirror-trailingBreak");
      let a = new mk(this.top, [], r, null);
      n != this.top ? n.children.push(a) : n.children.splice(this.index++, 0, a), this.changed = !0;
    }
  }
  isLocked(t) {
    return this.lock && (t == this.lock || t.nodeType == 1 && t.contains(this.lock.parentNode));
  }
}
function ww(e, t) {
  let n = t, r = n.children.length, a = e.childCount, i = /* @__PURE__ */ new Map(), o = [];
  e:
    for (; a > 0; ) {
      let s;
      for (; ; )
        if (r) {
          let l = n.children[r - 1];
          if (l instanceof fa)
            n = l, r = l.children.length;
          else {
            s = l, r--;
            break;
          }
        } else {
          if (n == t)
            break e;
          r = n.parent.children.indexOf(n), n = n.parent;
        }
      let c = s.node;
      if (c) {
        if (c != e.child(a - 1))
          break;
        --a, i.set(s, a), o.push(s);
      }
    }
  return { index: a, matched: i, matches: o.reverse() };
}
function Cw(e, t) {
  return e.type.side - t.type.side;
}
function Sw(e, t, n, r) {
  let a = t.locals(e), i = 0;
  if (a.length == 0) {
    for (let l = 0; l < e.childCount; l++) {
      let u = e.child(l);
      r(u, a, t.forChild(i, u), l), i += u.nodeSize;
    }
    return;
  }
  let o = 0, s = [], c = null;
  for (let l = 0; ; ) {
    let u, h;
    for (; o < a.length && a[o].to == i; ) {
      let v = a[o++];
      v.widget && (u ? (h || (h = [u])).push(v) : u = v);
    }
    if (u)
      if (h) {
        h.sort(Cw);
        for (let v = 0; v < h.length; v++)
          n(h[v], l, !!c);
      } else
        n(u, l, !!c);
    let p, f;
    if (c)
      f = -1, p = c, c = null;
    else if (l < e.childCount)
      f = l, p = e.child(l++);
    else
      break;
    for (let v = 0; v < s.length; v++)
      s[v].to <= i && s.splice(v--, 1);
    for (; o < a.length && a[o].from <= i && a[o].to > i; )
      s.push(a[o++]);
    let y = i + p.nodeSize;
    if (p.isText) {
      let v = y;
      o < a.length && a[o].from < v && (v = a[o].from);
      for (let k = 0; k < s.length; k++)
        s[k].to < v && (v = s[k].to);
      v < y && (c = p.cut(v - i), p = p.cut(0, v - i), y = v, f = -1);
    } else
      for (; o < a.length && a[o].to < y; )
        o++;
    let m = p.isInline && !p.isLeaf ? s.filter((v) => !v.inline) : s.slice();
    r(p, m, t.forChild(i, p), f), i = y;
  }
}
function Aw(e) {
  if (e.nodeName == "UL" || e.nodeName == "OL") {
    let t = e.style.cssText;
    e.style.cssText = t + "; list-style: square !important", window.getComputedStyle(e).listStyle, e.style.cssText = t;
  }
}
function Ow(e, t, n, r) {
  for (let a = 0, i = 0; a < e.childCount && i <= r; ) {
    let o = e.child(a++), s = i;
    if (i += o.nodeSize, !o.isText)
      continue;
    let c = o.text;
    for (; a < e.childCount; ) {
      let l = e.child(a++);
      if (i += l.nodeSize, !l.isText)
        break;
      c += l.text;
    }
    if (i >= n) {
      if (i >= r && c.slice(r - t.length - s, r - s) == t)
        return r - t.length;
      let l = s < r ? c.lastIndexOf(t, r - s - 1) : -1;
      if (l >= 0 && l + t.length + s >= n)
        return s + l;
      if (n == r && c.length >= r + t.length - s && c.slice(r - s, r - s + t.length) == t)
        return r;
    }
  }
  return -1;
}
function Iu(e, t, n, r, a) {
  let i = [];
  for (let o = 0, s = 0; o < e.length; o++) {
    let c = e[o], l = s, u = s += c.size;
    l >= n || u <= t ? i.push(c) : (l < t && i.push(c.slice(0, t - l, r)), a && (i.push(a), a = void 0), u > n && i.push(c.slice(n - l, c.size, r)));
  }
  return i;
}
function sp(e, t = null) {
  let n = e.domSelectionRange(), r = e.state.doc;
  if (!n.focusNode)
    return null;
  let a = e.docView.nearestDesc(n.focusNode), i = a && a.size == 0, o = e.docView.posFromDOM(n.focusNode, n.focusOffset, 1);
  if (o < 0)
    return null;
  let s = r.resolve(o), c, l;
  if (t1(n)) {
    for (c = s; a && !a.node; )
      a = a.parent;
    let u = a.node;
    if (a && u.isAtom && xe.isSelectable(u) && a.parent && !(u.isInline && K7(n.focusNode, n.focusOffset, a.dom))) {
      let h = a.posBefore;
      l = new xe(o == h ? s : r.resolve(h));
    }
  } else {
    let u = e.docView.posFromDOM(n.anchorNode, n.anchorOffset, 1);
    if (u < 0)
      return null;
    c = r.resolve(u);
  }
  if (!l) {
    let u = t == "pointer" || e.state.selection.head < s.pos && !i ? 1 : -1;
    l = cp(e, c, s, u);
  }
  return l;
}
function bk(e) {
  return e.editable ? e.hasFocus() : Mk(e) && document.activeElement && document.activeElement.contains(e.dom);
}
function rr(e, t = !1) {
  let n = e.state.selection;
  if (xk(e, n), !!bk(e)) {
    if (!t && e.input.mouseDown && e.input.mouseDown.allowDefault && Tt) {
      let r = e.domSelectionRange(), a = e.domObserver.currentSelection;
      if (r.anchorNode && a.anchorNode && pa(r.anchorNode, r.anchorOffset, a.anchorNode, a.anchorOffset)) {
        e.input.mouseDown.delayedSelectionSync = !0, e.domObserver.setCurSelection();
        return;
      }
    }
    if (e.domObserver.disconnectSelection(), e.cursorWrapper)
      Iw(e);
    else {
      let { anchor: r, head: a } = n, i, o;
      af && !(n instanceof De) && (n.$from.parent.inlineContent || (i = of(e, n.from)), !n.empty && !n.$from.parent.inlineContent && (o = of(e, n.to))), e.docView.setSelection(r, a, e.root, t), af && (i && sf(i), o && sf(o)), n.visible ? e.dom.classList.remove("ProseMirror-hideselection") : (e.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && Ew(e));
    }
    e.domObserver.setCurSelection(), e.domObserver.connectSelection();
  }
}
const af = Nt || Tt && tw < 63;
function of(e, t) {
  let { node: n, offset: r } = e.docView.domFromPos(t, 0), a = r < n.childNodes.length ? n.childNodes[r] : null, i = r ? n.childNodes[r - 1] : null;
  if (Nt && a && a.contentEditable == "false")
    return pd(a);
  if ((!a || a.contentEditable == "false") && (!i || i.contentEditable == "false")) {
    if (a)
      return pd(a);
    if (i)
      return pd(i);
  }
}
function pd(e) {
  return e.contentEditable = "true", Nt && e.draggable && (e.draggable = !1, e.wasDraggable = !0), e;
}
function sf(e) {
  e.contentEditable = "false", e.wasDraggable && (e.draggable = !0, e.wasDraggable = null);
}
function Ew(e) {
  let t = e.dom.ownerDocument;
  t.removeEventListener("selectionchange", e.input.hideSelectionGuard);
  let n = e.domSelectionRange(), r = n.anchorNode, a = n.anchorOffset;
  t.addEventListener("selectionchange", e.input.hideSelectionGuard = () => {
    (n.anchorNode != r || n.anchorOffset != a) && (t.removeEventListener("selectionchange", e.input.hideSelectionGuard), setTimeout(() => {
      (!bk(e) || e.state.selection.visible) && e.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function Iw(e) {
  let t = e.domSelection(), n = document.createRange(), r = e.cursorWrapper.dom, a = r.nodeName == "IMG";
  a ? n.setEnd(r.parentNode, mt(r) + 1) : n.setEnd(r, 0), n.collapse(!1), t.removeAllRanges(), t.addRange(n), !a && !e.state.selection.visible && $t && Cr <= 11 && (r.disabled = !0, r.disabled = !1);
}
function xk(e, t) {
  if (t instanceof xe) {
    let n = e.docView.descAt(t.from);
    n != e.lastSelectedViewDesc && (cf(e), n && n.selectNode(), e.lastSelectedViewDesc = n);
  } else
    cf(e);
}
function cf(e) {
  e.lastSelectedViewDesc && (e.lastSelectedViewDesc.parent && e.lastSelectedViewDesc.deselectNode(), e.lastSelectedViewDesc = void 0);
}
function cp(e, t, n, r) {
  return e.someProp("createSelectionBetween", (a) => a(e, t, n)) || De.between(t, n, r);
}
function lf(e) {
  return e.editable && !e.hasFocus() ? !1 : Mk(e);
}
function Mk(e) {
  let t = e.domSelectionRange();
  if (!t.anchorNode)
    return !1;
  try {
    return e.dom.contains(t.anchorNode.nodeType == 3 ? t.anchorNode.parentNode : t.anchorNode) && (e.editable || e.dom.contains(t.focusNode.nodeType == 3 ? t.focusNode.parentNode : t.focusNode));
  } catch {
    return !1;
  }
}
function Dw(e) {
  let t = e.docView.domFromPos(e.state.selection.anchor, 0), n = e.domSelectionRange();
  return pa(t.node, t.offset, n.anchorNode, n.anchorOffset);
}
function Du(e, t) {
  let { $anchor: n, $head: r } = e.selection, a = t > 0 ? n.max(r) : n.min(r), i = a.parent.inlineContent ? a.depth ? e.doc.resolve(t > 0 ? a.after() : a.before()) : null : a;
  return i && Ie.findFrom(i, t);
}
function mr(e, t) {
  return e.dispatch(e.state.tr.setSelection(t).scrollIntoView()), !0;
}
function df(e, t, n) {
  let r = e.state.selection;
  if (r instanceof De)
    if (n.indexOf("s") > -1) {
      let { $head: a } = r, i = a.textOffset ? null : t < 0 ? a.nodeBefore : a.nodeAfter;
      if (!i || i.isText || !i.isLeaf)
        return !1;
      let o = e.state.doc.resolve(a.pos + i.nodeSize * (t < 0 ? -1 : 1));
      return mr(e, new De(r.$anchor, o));
    } else if (r.empty) {
      if (e.endOfTextblock(t > 0 ? "forward" : "backward")) {
        let a = Du(e.state, t);
        return a && a instanceof xe ? mr(e, a) : !1;
      } else if (!(cn && n.indexOf("m") > -1)) {
        let a = r.$head, i = a.textOffset ? null : t < 0 ? a.nodeBefore : a.nodeAfter, o;
        if (!i || i.isText)
          return !1;
        let s = t < 0 ? a.pos - i.nodeSize : a.pos;
        return i.isAtom || (o = e.docView.descAt(s)) && !o.contentDOM ? xe.isSelectable(i) ? mr(e, new xe(t < 0 ? e.state.doc.resolve(a.pos - i.nodeSize) : a)) : ts ? mr(e, new De(e.state.doc.resolve(t < 0 ? s : s + i.nodeSize))) : !1 : !1;
      }
    } else
      return !1;
  else {
    if (r instanceof xe && r.node.isInline)
      return mr(e, new De(t > 0 ? r.$to : r.$from));
    {
      let a = Du(e.state, t);
      return a ? mr(e, a) : !1;
    }
  }
}
function Rc(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function ro(e, t) {
  let n = e.pmViewDesc;
  return n && n.size == 0 && (t < 0 || e.nextSibling || e.nodeName != "BR");
}
function Ia(e, t) {
  return t < 0 ? Tw(e) : Nw(e);
}
function Tw(e) {
  let t = e.domSelectionRange(), n = t.focusNode, r = t.focusOffset;
  if (!n)
    return;
  let a, i, o = !1;
  for (kn && n.nodeType == 1 && r < Rc(n) && ro(n.childNodes[r], -1) && (o = !0); ; )
    if (r > 0) {
      if (n.nodeType != 1)
        break;
      {
        let s = n.childNodes[r - 1];
        if (ro(s, -1))
          a = n, i = --r;
        else if (s.nodeType == 3)
          n = s, r = n.nodeValue.length;
        else
          break;
      }
    } else {
      if (wk(n))
        break;
      {
        let s = n.previousSibling;
        for (; s && ro(s, -1); )
          a = n.parentNode, i = mt(s), s = s.previousSibling;
        if (s)
          n = s, r = Rc(n);
        else {
          if (n = n.parentNode, n == e.dom)
            break;
          r = 0;
        }
      }
    }
  o ? Tu(e, n, r) : a && Tu(e, a, i);
}
function Nw(e) {
  let t = e.domSelectionRange(), n = t.focusNode, r = t.focusOffset;
  if (!n)
    return;
  let a = Rc(n), i, o;
  for (; ; )
    if (r < a) {
      if (n.nodeType != 1)
        break;
      let s = n.childNodes[r];
      if (ro(s, 1))
        i = n, o = ++r;
      else
        break;
    } else {
      if (wk(n))
        break;
      {
        let s = n.nextSibling;
        for (; s && ro(s, 1); )
          i = s.parentNode, o = mt(s) + 1, s = s.nextSibling;
        if (s)
          n = s, r = 0, a = Rc(n);
        else {
          if (n = n.parentNode, n == e.dom)
            break;
          r = a = 0;
        }
      }
    }
  i && Tu(e, i, o);
}
function wk(e) {
  let t = e.pmViewDesc;
  return t && t.node && t.node.isBlock;
}
function Pw(e, t) {
  for (; e && t == e.childNodes.length && !es(e); )
    t = mt(e) + 1, e = e.parentNode;
  for (; e && t < e.childNodes.length; ) {
    let n = e.childNodes[t];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    e = n, t = 0;
  }
}
function Lw(e, t) {
  for (; e && !t && !es(e); )
    t = mt(e), e = e.parentNode;
  for (; e && t; ) {
    let n = e.childNodes[t - 1];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    e = n, t = e.childNodes.length;
  }
}
function Tu(e, t, n) {
  if (t.nodeType != 3) {
    let i, o;
    (o = Pw(t, n)) ? (t = o, n = 0) : (i = Lw(t, n)) && (t = i, n = i.nodeValue.length);
  }
  let r = e.domSelection();
  if (t1(r)) {
    let i = document.createRange();
    i.setEnd(t, n), i.setStart(t, n), r.removeAllRanges(), r.addRange(i);
  } else
    r.extend && r.extend(t, n);
  e.domObserver.setCurSelection();
  let { state: a } = e;
  setTimeout(() => {
    e.state == a && rr(e);
  }, 50);
}
function uf(e, t) {
  let n = e.state.doc.resolve(t);
  if (!(Tt || nw) && n.parent.inlineContent) {
    let a = e.coordsAtPos(t);
    if (t > n.start()) {
      let i = e.coordsAtPos(t - 1), o = (i.top + i.bottom) / 2;
      if (o > a.top && o < a.bottom && Math.abs(i.left - a.left) > 1)
        return i.left < a.left ? "ltr" : "rtl";
    }
    if (t < n.end()) {
      let i = e.coordsAtPos(t + 1), o = (i.top + i.bottom) / 2;
      if (o > a.top && o < a.bottom && Math.abs(i.left - a.left) > 1)
        return i.left > a.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(e.dom).direction == "rtl" ? "rtl" : "ltr";
}
function hf(e, t, n) {
  let r = e.state.selection;
  if (r instanceof De && !r.empty || n.indexOf("s") > -1 || cn && n.indexOf("m") > -1)
    return !1;
  let { $from: a, $to: i } = r;
  if (!a.parent.inlineContent || e.endOfTextblock(t < 0 ? "up" : "down")) {
    let o = Du(e.state, t);
    if (o && o instanceof xe)
      return mr(e, o);
  }
  if (!a.parent.inlineContent) {
    let o = t < 0 ? a : i, s = r instanceof vn ? Ie.near(o, t) : Ie.findFrom(o, t);
    return s ? mr(e, s) : !1;
  }
  return !1;
}
function pf(e, t) {
  if (!(e.state.selection instanceof De))
    return !0;
  let { $head: n, $anchor: r, empty: a } = e.state.selection;
  if (!n.sameParent(r))
    return !0;
  if (!a)
    return !1;
  if (e.endOfTextblock(t > 0 ? "forward" : "backward"))
    return !0;
  let i = !n.textOffset && (t < 0 ? n.nodeBefore : n.nodeAfter);
  if (i && !i.isText) {
    let o = e.state.tr;
    return t < 0 ? o.delete(n.pos - i.nodeSize, n.pos) : o.delete(n.pos, n.pos + i.nodeSize), e.dispatch(o), !0;
  }
  return !1;
}
function ff(e, t, n) {
  e.domObserver.stop(), t.contentEditable = n, e.domObserver.start();
}
function Rw(e) {
  if (!Nt || e.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: t, focusOffset: n } = e.domSelectionRange();
  if (t && t.nodeType == 1 && n == 0 && t.firstChild && t.firstChild.contentEditable == "false") {
    let r = t.firstChild;
    ff(e, r, "true"), setTimeout(() => ff(e, r, "false"), 20);
  }
  return !1;
}
function Vw(e) {
  let t = "";
  return e.ctrlKey && (t += "c"), e.metaKey && (t += "m"), e.altKey && (t += "a"), e.shiftKey && (t += "s"), t;
}
function zw(e, t) {
  let n = t.keyCode, r = Vw(t);
  if (n == 8 || cn && n == 72 && r == "c")
    return pf(e, -1) || Ia(e, -1);
  if (n == 46 && !t.shiftKey || cn && n == 68 && r == "c")
    return pf(e, 1) || Ia(e, 1);
  if (n == 13 || n == 27)
    return !0;
  if (n == 37 || cn && n == 66 && r == "c") {
    let a = n == 37 ? uf(e, e.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return df(e, a, r) || Ia(e, a);
  } else if (n == 39 || cn && n == 70 && r == "c") {
    let a = n == 39 ? uf(e, e.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return df(e, a, r) || Ia(e, a);
  } else {
    if (n == 38 || cn && n == 80 && r == "c")
      return hf(e, -1, r) || Ia(e, -1);
    if (n == 40 || cn && n == 78 && r == "c")
      return Rw(e) || hf(e, 1, r) || Ia(e, 1);
    if (r == (cn ? "m" : "c") && (n == 66 || n == 73 || n == 89 || n == 90))
      return !0;
  }
  return !1;
}
function Ck(e, t) {
  e.someProp("transformCopied", (f) => {
    t = f(t, e);
  });
  let n = [], { content: r, openStart: a, openEnd: i } = t;
  for (; a > 1 && i > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    a--, i--;
    let f = r.firstChild;
    n.push(f.type.name, f.attrs != f.type.defaultAttrs ? f.attrs : null), r = f.content;
  }
  let o = e.someProp("clipboardSerializer") || Rn.fromSchema(e.state.schema), s = Dk(), c = s.createElement("div");
  c.appendChild(o.serializeFragment(r, { document: s }));
  let l = c.firstChild, u, h = 0;
  for (; l && l.nodeType == 1 && (u = Ik[l.nodeName.toLowerCase()]); ) {
    for (let f = u.length - 1; f >= 0; f--) {
      let y = s.createElement(u[f]);
      for (; c.firstChild; )
        y.appendChild(c.firstChild);
      c.appendChild(y), h++;
    }
    l = c.firstChild;
  }
  l && l.nodeType == 1 && l.setAttribute("data-pm-slice", `${a} ${i}${h ? ` -${h}` : ""} ${JSON.stringify(n)}`);
  let p = e.someProp("clipboardTextSerializer", (f) => f(t, e)) || t.content.textBetween(0, t.content.size, `

`);
  return { dom: c, text: p, slice: t };
}
function Sk(e, t, n, r, a) {
  let i = a.parent.type.spec.code, o, s;
  if (!n && !t)
    return null;
  let c = t && (r || i || !n);
  if (c) {
    if (e.someProp("transformPastedText", (p) => {
      t = p(t, i || r, e);
    }), i)
      return t ? new ye(oe.from(e.state.schema.text(t.replace(/\r\n?/g, `
`))), 0, 0) : ye.empty;
    let h = e.someProp("clipboardTextParser", (p) => p(t, a, r, e));
    if (h)
      s = h;
    else {
      let p = a.marks(), { schema: f } = e.state, y = Rn.fromSchema(f);
      o = document.createElement("div"), t.split(/(?:\r\n?|\n)+/).forEach((m) => {
        let v = o.appendChild(document.createElement("p"));
        m && v.appendChild(y.serializeNode(f.text(m, p)));
      });
    }
  } else
    e.someProp("transformPastedHTML", (h) => {
      n = h(n, e);
    }), o = $w(n), ts && jw(o);
  let l = o && o.querySelector("[data-pm-slice]"), u = l && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(l.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let h = +u[3]; h > 0; h--) {
      let p = o.firstChild;
      for (; p && p.nodeType != 1; )
        p = p.nextSibling;
      if (!p)
        break;
      o = p;
    }
  if (s || (s = (e.someProp("clipboardParser") || e.someProp("domParser") || oi.fromSchema(e.state.schema)).parseSlice(o, {
    preserveWhitespace: !!(c || u),
    context: a,
    ruleFromNode(p) {
      return p.nodeName == "BR" && !p.nextSibling && p.parentNode && !Bw.test(p.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    s = Fw(yf(s, +u[1], +u[2]), u[4]);
  else if (s = ye.maxOpen(Hw(s.content, a), !0), s.openStart || s.openEnd) {
    let h = 0, p = 0;
    for (let f = s.content.firstChild; h < s.openStart && !f.type.spec.isolating; h++, f = f.firstChild)
      ;
    for (let f = s.content.lastChild; p < s.openEnd && !f.type.spec.isolating; p++, f = f.lastChild)
      ;
    s = yf(s, h, p);
  }
  return e.someProp("transformPasted", (h) => {
    s = h(s, e);
  }), s;
}
const Bw = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function Hw(e, t) {
  if (e.childCount < 2)
    return e;
  for (let n = t.depth; n >= 0; n--) {
    let a = t.node(n).contentMatchAt(t.index(n)), i, o = [];
    if (e.forEach((s) => {
      if (!o)
        return;
      let c = a.findWrapping(s.type), l;
      if (!c)
        return o = null;
      if (l = o.length && i.length && Ok(c, i, s, o[o.length - 1], 0))
        o[o.length - 1] = l;
      else {
        o.length && (o[o.length - 1] = Ek(o[o.length - 1], i.length));
        let u = Ak(s, c);
        o.push(u), a = a.matchType(u.type), i = c;
      }
    }), o)
      return oe.from(o);
  }
  return e;
}
function Ak(e, t, n = 0) {
  for (let r = t.length - 1; r >= n; r--)
    e = t[r].create(null, oe.from(e));
  return e;
}
function Ok(e, t, n, r, a) {
  if (a < e.length && a < t.length && e[a] == t[a]) {
    let i = Ok(e, t, n, r.lastChild, a + 1);
    if (i)
      return r.copy(r.content.replaceChild(r.childCount - 1, i));
    if (r.contentMatchAt(r.childCount).matchType(a == e.length - 1 ? n.type : e[a + 1]))
      return r.copy(r.content.append(oe.from(Ak(n, e, a + 1))));
  }
}
function Ek(e, t) {
  if (t == 0)
    return e;
  let n = e.content.replaceChild(e.childCount - 1, Ek(e.lastChild, t - 1)), r = e.contentMatchAt(e.childCount).fillBefore(oe.empty, !0);
  return e.copy(n.append(r));
}
function Nu(e, t, n, r, a, i) {
  let o = t < 0 ? e.firstChild : e.lastChild, s = o.content;
  return e.childCount > 1 && (i = 0), a < r - 1 && (s = Nu(s, t, n, r, a + 1, i)), a >= n && (s = t < 0 ? o.contentMatchAt(0).fillBefore(s, i <= a).append(s) : s.append(o.contentMatchAt(o.childCount).fillBefore(oe.empty, !0))), e.replaceChild(t < 0 ? 0 : e.childCount - 1, o.copy(s));
}
function yf(e, t, n) {
  return t < e.openStart && (e = new ye(Nu(e.content, -1, t, e.openStart, 0, e.openEnd), t, e.openEnd)), n < e.openEnd && (e = new ye(Nu(e.content, 1, n, e.openEnd, 0, 0), e.openStart, n)), e;
}
const Ik = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let mf = null;
function Dk() {
  return mf || (mf = document.implementation.createHTMLDocument("title"));
}
function $w(e) {
  let t = /^(\s*<meta [^>]*>)*/.exec(e);
  t && (e = e.slice(t[0].length));
  let n = Dk().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(e), a;
  if ((a = r && Ik[r[1].toLowerCase()]) && (e = a.map((i) => "<" + i + ">").join("") + e + a.map((i) => "</" + i + ">").reverse().join("")), n.innerHTML = e, a)
    for (let i = 0; i < a.length; i++)
      n = n.querySelector(a[i]) || n;
  return n;
}
function jw(e) {
  let t = e.querySelectorAll(Tt ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let n = 0; n < t.length; n++) {
    let r = t[n];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(e.ownerDocument.createTextNode(" "), r);
  }
}
function Fw(e, t) {
  if (!e.size)
    return e;
  let n = e.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(t);
  } catch {
    return e;
  }
  let { content: a, openStart: i, openEnd: o } = e;
  for (let s = r.length - 2; s >= 0; s -= 2) {
    let c = n.nodes[r[s]];
    if (!c || c.hasRequiredAttrs())
      break;
    a = oe.from(c.create(r[s + 1], a)), i++, o++;
  }
  return new ye(a, i, o);
}
const Pt = {}, Lt = {}, Ww = { touchstart: !0, touchmove: !0 };
class qw {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "" }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastAndroidDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function _w(e) {
  for (let t in Pt) {
    let n = Pt[t];
    e.dom.addEventListener(t, e.input.eventHandlers[t] = (r) => {
      Zw(e, r) && !lp(e, r) && (e.editable || !(r.type in Lt)) && n(e, r);
    }, Ww[t] ? { passive: !0 } : void 0);
  }
  Nt && e.dom.addEventListener("input", () => null), Pu(e);
}
function Mr(e, t) {
  e.input.lastSelectionOrigin = t, e.input.lastSelectionTime = Date.now();
}
function Gw(e) {
  e.domObserver.stop();
  for (let t in e.input.eventHandlers)
    e.dom.removeEventListener(t, e.input.eventHandlers[t]);
  clearTimeout(e.input.composingTimeout), clearTimeout(e.input.lastIOSEnterFallbackTimeout);
}
function Pu(e) {
  e.someProp("handleDOMEvents", (t) => {
    for (let n in t)
      e.input.eventHandlers[n] || e.dom.addEventListener(n, e.input.eventHandlers[n] = (r) => lp(e, r));
  });
}
function lp(e, t) {
  return e.someProp("handleDOMEvents", (n) => {
    let r = n[t.type];
    return r ? r(e, t) || t.defaultPrevented : !1;
  });
}
function Zw(e, t) {
  if (!t.bubbles)
    return !0;
  if (t.defaultPrevented)
    return !1;
  for (let n = t.target; n != e.dom; n = n.parentNode)
    if (!n || n.nodeType == 11 || n.pmViewDesc && n.pmViewDesc.stopEvent(t))
      return !1;
  return !0;
}
function Xw(e, t) {
  !lp(e, t) && Pt[t.type] && (e.editable || !(t.type in Lt)) && Pt[t.type](e, t);
}
Lt.keydown = (e, t) => {
  let n = t;
  if (e.input.shiftKey = n.keyCode == 16 || n.shiftKey, !Nk(e, n) && (e.input.lastKeyCode = n.keyCode, e.input.lastKeyCodeTime = Date.now(), !(mn && Tt && n.keyCode == 13)))
    if (n.keyCode != 229 && e.domObserver.forceFlush(), li && n.keyCode == 13 && !n.ctrlKey && !n.altKey && !n.metaKey) {
      let r = Date.now();
      e.input.lastIOSEnter = r, e.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        e.input.lastIOSEnter == r && (e.someProp("handleKeyDown", (a) => a(e, Ur(13, "Enter"))), e.input.lastIOSEnter = 0);
      }, 200);
    } else
      e.someProp("handleKeyDown", (r) => r(e, n)) || zw(e, n) ? n.preventDefault() : Mr(e, "key");
};
Lt.keyup = (e, t) => {
  t.keyCode == 16 && (e.input.shiftKey = !1);
};
Lt.keypress = (e, t) => {
  let n = t;
  if (Nk(e, n) || !n.charCode || n.ctrlKey && !n.altKey || cn && n.metaKey)
    return;
  if (e.someProp("handleKeyPress", (a) => a(e, n))) {
    n.preventDefault();
    return;
  }
  let r = e.state.selection;
  if (!(r instanceof De) || !r.$from.sameParent(r.$to)) {
    let a = String.fromCharCode(n.charCode);
    !/[\r\n]/.test(a) && !e.someProp("handleTextInput", (i) => i(e, r.$from.pos, r.$to.pos, a)) && e.dispatch(e.state.tr.insertText(a).scrollIntoView()), n.preventDefault();
  }
};
function r1(e) {
  return { left: e.clientX, top: e.clientY };
}
function Uw(e, t) {
  let n = t.x - e.clientX, r = t.y - e.clientY;
  return n * n + r * r < 100;
}
function dp(e, t, n, r, a) {
  if (r == -1)
    return !1;
  let i = e.state.doc.resolve(r);
  for (let o = i.depth + 1; o > 0; o--)
    if (e.someProp(t, (s) => o > i.depth ? s(e, n, i.nodeAfter, i.before(o), a, !0) : s(e, n, i.node(o), i.before(o), a, !1)))
      return !0;
  return !1;
}
function ei(e, t, n) {
  e.focused || e.focus();
  let r = e.state.tr.setSelection(t);
  n == "pointer" && r.setMeta("pointer", !0), e.dispatch(r);
}
function Yw(e, t) {
  if (t == -1)
    return !1;
  let n = e.state.doc.resolve(t), r = n.nodeAfter;
  return r && r.isAtom && xe.isSelectable(r) ? (ei(e, new xe(n), "pointer"), !0) : !1;
}
function Jw(e, t) {
  if (t == -1)
    return !1;
  let n = e.state.selection, r, a;
  n instanceof xe && (r = n.node);
  let i = e.state.doc.resolve(t);
  for (let o = i.depth + 1; o > 0; o--) {
    let s = o > i.depth ? i.nodeAfter : i.node(o);
    if (xe.isSelectable(s)) {
      r && n.$from.depth > 0 && o >= n.$from.depth && i.before(n.$from.depth + 1) == n.$from.pos ? a = i.before(n.$from.depth) : a = i.before(o);
      break;
    }
  }
  return a != null ? (ei(e, xe.create(e.state.doc, a), "pointer"), !0) : !1;
}
function Kw(e, t, n, r, a) {
  return dp(e, "handleClickOn", t, n, r) || e.someProp("handleClick", (i) => i(e, t, r)) || (a ? Jw(e, n) : Yw(e, n));
}
function Qw(e, t, n, r) {
  return dp(e, "handleDoubleClickOn", t, n, r) || e.someProp("handleDoubleClick", (a) => a(e, t, r));
}
function e9(e, t, n, r) {
  return dp(e, "handleTripleClickOn", t, n, r) || e.someProp("handleTripleClick", (a) => a(e, t, r)) || t9(e, n, r);
}
function t9(e, t, n) {
  if (n.button != 0)
    return !1;
  let r = e.state.doc;
  if (t == -1)
    return r.inlineContent ? (ei(e, De.create(r, 0, r.content.size), "pointer"), !0) : !1;
  let a = r.resolve(t);
  for (let i = a.depth + 1; i > 0; i--) {
    let o = i > a.depth ? a.nodeAfter : a.node(i), s = a.before(i);
    if (o.inlineContent)
      ei(e, De.create(r, s + 1, s + 1 + o.content.size), "pointer");
    else if (xe.isSelectable(o))
      ei(e, xe.create(r, s), "pointer");
    else
      continue;
    return !0;
  }
}
function up(e) {
  return Vc(e);
}
const Tk = cn ? "metaKey" : "ctrlKey";
Pt.mousedown = (e, t) => {
  let n = t;
  e.input.shiftKey = n.shiftKey;
  let r = up(e), a = Date.now(), i = "singleClick";
  a - e.input.lastClick.time < 500 && Uw(n, e.input.lastClick) && !n[Tk] && (e.input.lastClick.type == "singleClick" ? i = "doubleClick" : e.input.lastClick.type == "doubleClick" && (i = "tripleClick")), e.input.lastClick = { time: a, x: n.clientX, y: n.clientY, type: i };
  let o = e.posAtCoords(r1(n));
  o && (i == "singleClick" ? (e.input.mouseDown && e.input.mouseDown.done(), e.input.mouseDown = new n9(e, o, n, !!r)) : (i == "doubleClick" ? Qw : e9)(e, o.pos, o.inside, n) ? n.preventDefault() : Mr(e, "pointer"));
};
class n9 {
  constructor(t, n, r, a) {
    this.view = t, this.pos = n, this.event = r, this.flushed = a, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = t.state.doc, this.selectNode = !!r[Tk], this.allowDefault = r.shiftKey;
    let i, o;
    if (n.inside > -1)
      i = t.state.doc.nodeAt(n.inside), o = n.inside;
    else {
      let u = t.state.doc.resolve(n.pos);
      i = u.parent, o = u.depth ? u.before() : 0;
    }
    const s = a ? null : r.target, c = s ? t.docView.nearestDesc(s, !0) : null;
    this.target = c && c.dom.nodeType == 1 ? c.dom : null;
    let { selection: l } = t.state;
    (r.button == 0 && i.type.spec.draggable && i.type.spec.selectable !== !1 || l instanceof xe && l.from <= o && l.to > o) && (this.mightDrag = {
      node: i,
      pos: o,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && kn && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), t.root.addEventListener("mouseup", this.up = this.up.bind(this)), t.root.addEventListener("mousemove", this.move = this.move.bind(this)), Mr(t, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => rr(this.view)), this.view.input.mouseDown = null;
  }
  up(t) {
    if (this.done(), !this.view.dom.contains(t.target))
      return;
    let n = this.pos;
    this.view.state.doc != this.startDoc && (n = this.view.posAtCoords(r1(t))), this.updateAllowDefault(t), this.allowDefault || !n ? Mr(this.view, "pointer") : Kw(this.view, n.pos, n.inside, t, this.selectNode) ? t.preventDefault() : t.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Nt && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    Tt && !this.view.state.selection.visible && Math.min(Math.abs(n.pos - this.view.state.selection.from), Math.abs(n.pos - this.view.state.selection.to)) <= 2) ? (ei(this.view, Ie.near(this.view.state.doc.resolve(n.pos)), "pointer"), t.preventDefault()) : Mr(this.view, "pointer");
  }
  move(t) {
    this.updateAllowDefault(t), Mr(this.view, "pointer"), t.buttons == 0 && this.done();
  }
  updateAllowDefault(t) {
    !this.allowDefault && (Math.abs(this.event.x - t.clientX) > 4 || Math.abs(this.event.y - t.clientY) > 4) && (this.allowDefault = !0);
  }
}
Pt.touchstart = (e) => {
  e.input.lastTouch = Date.now(), up(e), Mr(e, "pointer");
};
Pt.touchmove = (e) => {
  e.input.lastTouch = Date.now(), Mr(e, "pointer");
};
Pt.contextmenu = (e) => up(e);
function Nk(e, t) {
  return e.composing ? !0 : Nt && Math.abs(t.timeStamp - e.input.compositionEndedAt) < 500 ? (e.input.compositionEndedAt = -2e8, !0) : !1;
}
const r9 = mn ? 5e3 : -1;
Lt.compositionstart = Lt.compositionupdate = (e) => {
  if (!e.composing) {
    e.domObserver.flush();
    let { state: t } = e, n = t.selection.$from;
    if (t.selection.empty && (t.storedMarks || !n.textOffset && n.parentOffset && n.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1)))
      e.markCursor = e.state.storedMarks || n.marks(), Vc(e, !0), e.markCursor = null;
    else if (Vc(e), kn && t.selection.empty && n.parentOffset && !n.textOffset && n.nodeBefore.marks.length) {
      let r = e.domSelectionRange();
      for (let a = r.focusNode, i = r.focusOffset; a && a.nodeType == 1 && i != 0; ) {
        let o = i < 0 ? a.lastChild : a.childNodes[i - 1];
        if (!o)
          break;
        if (o.nodeType == 3) {
          e.domSelection().collapse(o, o.nodeValue.length);
          break;
        } else
          a = o, i = -1;
      }
    }
    e.input.composing = !0;
  }
  Pk(e, r9);
};
Lt.compositionend = (e, t) => {
  e.composing && (e.input.composing = !1, e.input.compositionEndedAt = t.timeStamp, e.input.compositionPendingChanges = e.domObserver.pendingRecords().length ? e.input.compositionID : 0, e.input.compositionNode = null, e.input.compositionPendingChanges && Promise.resolve().then(() => e.domObserver.flush()), e.input.compositionID++, Pk(e, 20));
};
function Pk(e, t) {
  clearTimeout(e.input.composingTimeout), t > -1 && (e.input.composingTimeout = setTimeout(() => Vc(e), t));
}
function Lk(e) {
  for (e.composing && (e.input.composing = !1, e.input.compositionEndedAt = i9()); e.input.compositionNodes.length > 0; )
    e.input.compositionNodes.pop().markParentsDirty();
}
function a9(e) {
  let t = e.domSelectionRange();
  if (!t.focusNode)
    return null;
  let n = Y7(t.focusNode, t.focusOffset), r = J7(t.focusNode, t.focusOffset);
  if (n && r && n != r) {
    let a = r.pmViewDesc, i = e.domObserver.lastChangedTextNode;
    if (n == i || r == i)
      return i;
    if (!a || !a.isText(r.nodeValue))
      return r;
    if (e.input.compositionNode == r) {
      let o = n.pmViewDesc;
      if (!(!o || !o.isText(n.nodeValue)))
        return r;
    }
  }
  return n || r;
}
function i9() {
  let e = document.createEvent("Event");
  return e.initEvent("event", !0, !0), e.timeStamp;
}
function Vc(e, t = !1) {
  if (!(mn && e.domObserver.flushingSoon >= 0)) {
    if (e.domObserver.forceFlush(), Lk(e), t || e.docView && e.docView.dirty) {
      let n = sp(e);
      return n && !n.eq(e.state.selection) ? e.dispatch(e.state.tr.setSelection(n)) : e.updateState(e.state), !0;
    }
    return !1;
  }
}
function o9(e, t) {
  if (!e.dom.parentNode)
    return;
  let n = e.dom.parentNode.appendChild(document.createElement("div"));
  n.appendChild(t), n.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), a = document.createRange();
  a.selectNodeContents(t), e.dom.blur(), r.removeAllRanges(), r.addRange(a), setTimeout(() => {
    n.parentNode && n.parentNode.removeChild(n), e.focus();
  }, 50);
}
const ko = $t && Cr < 15 || li && rw < 604;
Pt.copy = Lt.cut = (e, t) => {
  let n = t, r = e.state.selection, a = n.type == "cut";
  if (r.empty)
    return;
  let i = ko ? null : n.clipboardData, o = r.content(), { dom: s, text: c } = Ck(e, o);
  i ? (n.preventDefault(), i.clearData(), i.setData("text/html", s.innerHTML), i.setData("text/plain", c)) : o9(e, s), a && e.dispatch(e.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function s9(e) {
  return e.openStart == 0 && e.openEnd == 0 && e.content.childCount == 1 ? e.content.firstChild : null;
}
function c9(e, t) {
  if (!e.dom.parentNode)
    return;
  let n = e.input.shiftKey || e.state.selection.$from.parent.type.spec.code, r = e.dom.parentNode.appendChild(document.createElement(n ? "textarea" : "div"));
  n || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let a = e.input.shiftKey && e.input.lastKeyCode != 45;
  setTimeout(() => {
    e.focus(), r.parentNode && r.parentNode.removeChild(r), n ? bo(e, r.value, null, a, t) : bo(e, r.textContent, r.innerHTML, a, t);
  }, 50);
}
function bo(e, t, n, r, a) {
  let i = Sk(e, t, n, r, e.state.selection.$from);
  if (e.someProp("handlePaste", (c) => c(e, a, i || ye.empty)))
    return !0;
  if (!i)
    return !1;
  let o = s9(i), s = o ? e.state.tr.replaceSelectionWith(o, r) : e.state.tr.replaceSelection(i);
  return e.dispatch(s.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function Rk(e) {
  let t = e.getData("text/plain") || e.getData("Text");
  if (t)
    return t;
  let n = e.getData("text/uri-list");
  return n ? n.replace(/\r?\n/g, " ") : "";
}
Lt.paste = (e, t) => {
  let n = t;
  if (e.composing && !mn)
    return;
  let r = ko ? null : n.clipboardData, a = e.input.shiftKey && e.input.lastKeyCode != 45;
  r && bo(e, Rk(r), r.getData("text/html"), a, n) ? n.preventDefault() : c9(e, n);
};
class Vk {
  constructor(t, n, r) {
    this.slice = t, this.move = n, this.node = r;
  }
}
const zk = cn ? "altKey" : "ctrlKey";
Pt.dragstart = (e, t) => {
  let n = t, r = e.input.mouseDown;
  if (r && r.done(), !n.dataTransfer)
    return;
  let a = e.state.selection, i = a.empty ? null : e.posAtCoords(r1(n)), o;
  if (!(i && i.pos >= a.from && i.pos <= (a instanceof xe ? a.to - 1 : a.to))) {
    if (r && r.mightDrag)
      o = xe.create(e.state.doc, r.mightDrag.pos);
    else if (n.target && n.target.nodeType == 1) {
      let h = e.docView.nearestDesc(n.target, !0);
      h && h.node.type.spec.draggable && h != e.docView && (o = xe.create(e.state.doc, h.posBefore));
    }
  }
  let s = (o || e.state.selection).content(), { dom: c, text: l, slice: u } = Ck(e, s);
  n.dataTransfer.clearData(), n.dataTransfer.setData(ko ? "Text" : "text/html", c.innerHTML), n.dataTransfer.effectAllowed = "copyMove", ko || n.dataTransfer.setData("text/plain", l), e.dragging = new Vk(u, !n[zk], o);
};
Pt.dragend = (e) => {
  let t = e.dragging;
  window.setTimeout(() => {
    e.dragging == t && (e.dragging = null);
  }, 50);
};
Lt.dragover = Lt.dragenter = (e, t) => t.preventDefault();
Lt.drop = (e, t) => {
  let n = t, r = e.dragging;
  if (e.dragging = null, !n.dataTransfer)
    return;
  let a = e.posAtCoords(r1(n));
  if (!a)
    return;
  let i = e.state.doc.resolve(a.pos), o = r && r.slice;
  o ? e.someProp("transformPasted", (y) => {
    o = y(o, e);
  }) : o = Sk(e, Rk(n.dataTransfer), ko ? null : n.dataTransfer.getData("text/html"), !1, i);
  let s = !!(r && !n[zk]);
  if (e.someProp("handleDrop", (y) => y(e, n, o || ye.empty, s))) {
    n.preventDefault();
    return;
  }
  if (!o)
    return;
  n.preventDefault();
  let c = o ? z7(e.state.doc, i.pos, o) : i.pos;
  c == null && (c = i.pos);
  let l = e.state.tr;
  if (s) {
    let { node: y } = r;
    y ? y.replace(l) : l.deleteSelection();
  }
  let u = l.mapping.map(c), h = o.openStart == 0 && o.openEnd == 0 && o.content.childCount == 1, p = l.doc;
  if (h ? l.replaceRangeWith(u, u, o.content.firstChild) : l.replaceRange(u, u, o), l.doc.eq(p))
    return;
  let f = l.doc.resolve(u);
  if (h && xe.isSelectable(o.content.firstChild) && f.nodeAfter && f.nodeAfter.sameMarkup(o.content.firstChild))
    l.setSelection(new xe(f));
  else {
    let y = l.mapping.map(c);
    l.mapping.maps[l.mapping.maps.length - 1].forEach((m, v, k, b) => y = b), l.setSelection(cp(e, f, l.doc.resolve(y)));
  }
  e.focus(), e.dispatch(l.setMeta("uiEvent", "drop"));
};
Pt.focus = (e) => {
  e.input.lastFocus = Date.now(), e.focused || (e.domObserver.stop(), e.dom.classList.add("ProseMirror-focused"), e.domObserver.start(), e.focused = !0, setTimeout(() => {
    e.docView && e.hasFocus() && !e.domObserver.currentSelection.eq(e.domSelectionRange()) && rr(e);
  }, 20));
};
Pt.blur = (e, t) => {
  let n = t;
  e.focused && (e.domObserver.stop(), e.dom.classList.remove("ProseMirror-focused"), e.domObserver.start(), n.relatedTarget && e.dom.contains(n.relatedTarget) && e.domObserver.currentSelection.clear(), e.focused = !1);
};
Pt.beforeinput = (e, t) => {
  if (Tt && mn && t.inputType == "deleteContentBackward") {
    e.domObserver.flushSoon();
    let { domChangeCount: r } = e.input;
    setTimeout(() => {
      if (e.input.domChangeCount != r || (e.dom.blur(), e.focus(), e.someProp("handleKeyDown", (i) => i(e, Ur(8, "Backspace")))))
        return;
      let { $cursor: a } = e.state.selection;
      a && a.pos > 0 && e.dispatch(e.state.tr.delete(a.pos - 1, a.pos).scrollIntoView());
    }, 50);
  }
};
for (let e in Lt)
  Pt[e] = Lt[e];
function xo(e, t) {
  if (e == t)
    return !0;
  for (let n in e)
    if (e[n] !== t[n])
      return !1;
  for (let n in t)
    if (!(n in e))
      return !1;
  return !0;
}
class zc {
  constructor(t, n) {
    this.toDOM = t, this.spec = n || ia, this.side = this.spec.side || 0;
  }
  map(t, n, r, a) {
    let { pos: i, deleted: o } = t.mapResult(n.from + a, this.side < 0 ? -1 : 1);
    return o ? null : new Ht(i - r, i - r, this);
  }
  valid() {
    return !0;
  }
  eq(t) {
    return this == t || t instanceof zc && (this.spec.key && this.spec.key == t.spec.key || this.toDOM == t.toDOM && xo(this.spec, t.spec));
  }
  destroy(t) {
    this.spec.destroy && this.spec.destroy(t);
  }
}
class Ar {
  constructor(t, n) {
    this.attrs = t, this.spec = n || ia;
  }
  map(t, n, r, a) {
    let i = t.map(n.from + a, this.spec.inclusiveStart ? -1 : 1) - r, o = t.map(n.to + a, this.spec.inclusiveEnd ? 1 : -1) - r;
    return i >= o ? null : new Ht(i, o, this);
  }
  valid(t, n) {
    return n.from < n.to;
  }
  eq(t) {
    return this == t || t instanceof Ar && xo(this.attrs, t.attrs) && xo(this.spec, t.spec);
  }
  static is(t) {
    return t.type instanceof Ar;
  }
  destroy() {
  }
}
class hp {
  constructor(t, n) {
    this.attrs = t, this.spec = n || ia;
  }
  map(t, n, r, a) {
    let i = t.mapResult(n.from + a, 1);
    if (i.deleted)
      return null;
    let o = t.mapResult(n.to + a, -1);
    return o.deleted || o.pos <= i.pos ? null : new Ht(i.pos - r, o.pos - r, this);
  }
  valid(t, n) {
    let { index: r, offset: a } = t.content.findIndex(n.from), i;
    return a == n.from && !(i = t.child(r)).isText && a + i.nodeSize == n.to;
  }
  eq(t) {
    return this == t || t instanceof hp && xo(this.attrs, t.attrs) && xo(this.spec, t.spec);
  }
  destroy() {
  }
}
class Ht {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.from = t, this.to = n, this.type = r;
  }
  /**
  @internal
  */
  copy(t, n) {
    return new Ht(t, n, this.type);
  }
  /**
  @internal
  */
  eq(t, n = 0) {
    return this.type.eq(t.type) && this.from + n == t.from && this.to + n == t.to;
  }
  /**
  @internal
  */
  map(t, n, r) {
    return this.type.map(t, this, n, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(t, n, r) {
    return new Ht(t, t, new zc(n, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(t, n, r, a) {
    return new Ht(t, n, new Ar(r, a));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(t, n, r, a) {
    return new Ht(t, n, new hp(r, a));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof Ar;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof zc;
  }
}
const Fa = [], ia = {};
class tt {
  /**
  @internal
  */
  constructor(t, n) {
    this.local = t.length ? t : Fa, this.children = n.length ? n : Fa;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(t, n) {
    return n.length ? Bc(n, t, 0, ia) : Mt;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(t, n, r) {
    let a = [];
    return this.findInner(t ?? 0, n ?? 1e9, a, 0, r), a;
  }
  findInner(t, n, r, a, i) {
    for (let o = 0; o < this.local.length; o++) {
      let s = this.local[o];
      s.from <= n && s.to >= t && (!i || i(s.spec)) && r.push(s.copy(s.from + a, s.to + a));
    }
    for (let o = 0; o < this.children.length; o += 3)
      if (this.children[o] < n && this.children[o + 1] > t) {
        let s = this.children[o] + 1;
        this.children[o + 2].findInner(t - s, n - s, r, a + s, i);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(t, n, r) {
    return this == Mt || t.maps.length == 0 ? this : this.mapInner(t, n, 0, 0, r || ia);
  }
  /**
  @internal
  */
  mapInner(t, n, r, a, i) {
    let o;
    for (let s = 0; s < this.local.length; s++) {
      let c = this.local[s].map(t, r, a);
      c && c.type.valid(n, c) ? (o || (o = [])).push(c) : i.onRemove && i.onRemove(this.local[s].spec);
    }
    return this.children.length ? l9(this.children, o || [], t, n, r, a, i) : o ? new tt(o.sort(oa), Fa) : Mt;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(t, n) {
    return n.length ? this == Mt ? tt.create(t, n) : this.addInner(t, n, 0) : this;
  }
  addInner(t, n, r) {
    let a, i = 0;
    t.forEach((s, c) => {
      let l = c + r, u;
      if (u = Hk(n, s, l)) {
        for (a || (a = this.children.slice()); i < a.length && a[i] < c; )
          i += 3;
        a[i] == c ? a[i + 2] = a[i + 2].addInner(s, u, l + 1) : a.splice(i, 0, c, c + s.nodeSize, Bc(u, s, l + 1, ia)), i += 3;
      }
    });
    let o = Bk(i ? $k(n) : n, -r);
    for (let s = 0; s < o.length; s++)
      o[s].type.valid(t, o[s]) || o.splice(s--, 1);
    return new tt(o.length ? this.local.concat(o).sort(oa) : this.local, a || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(t) {
    return t.length == 0 || this == Mt ? this : this.removeInner(t, 0);
  }
  removeInner(t, n) {
    let r = this.children, a = this.local;
    for (let i = 0; i < r.length; i += 3) {
      let o, s = r[i] + n, c = r[i + 1] + n;
      for (let u = 0, h; u < t.length; u++)
        (h = t[u]) && h.from > s && h.to < c && (t[u] = null, (o || (o = [])).push(h));
      if (!o)
        continue;
      r == this.children && (r = this.children.slice());
      let l = r[i + 2].removeInner(o, s + 1);
      l != Mt ? r[i + 2] = l : (r.splice(i, 3), i -= 3);
    }
    if (a.length) {
      for (let i = 0, o; i < t.length; i++)
        if (o = t[i])
          for (let s = 0; s < a.length; s++)
            a[s].eq(o, n) && (a == this.local && (a = this.local.slice()), a.splice(s--, 1));
    }
    return r == this.children && a == this.local ? this : a.length || r.length ? new tt(a, r) : Mt;
  }
  forChild(t, n) {
    if (this == Mt)
      return this;
    if (n.isLeaf)
      return tt.empty;
    let r, a;
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] >= t) {
        this.children[s] == t && (r = this.children[s + 2]);
        break;
      }
    let i = t + 1, o = i + n.content.size;
    for (let s = 0; s < this.local.length; s++) {
      let c = this.local[s];
      if (c.from < o && c.to > i && c.type instanceof Ar) {
        let l = Math.max(i, c.from) - i, u = Math.min(o, c.to) - i;
        l < u && (a || (a = [])).push(c.copy(l, u));
      }
    }
    if (a) {
      let s = new tt(a.sort(oa), Fa);
      return r ? new vr([s, r]) : s;
    }
    return r || Mt;
  }
  /**
  @internal
  */
  eq(t) {
    if (this == t)
      return !0;
    if (!(t instanceof tt) || this.local.length != t.local.length || this.children.length != t.children.length)
      return !1;
    for (let n = 0; n < this.local.length; n++)
      if (!this.local[n].eq(t.local[n]))
        return !1;
    for (let n = 0; n < this.children.length; n += 3)
      if (this.children[n] != t.children[n] || this.children[n + 1] != t.children[n + 1] || !this.children[n + 2].eq(t.children[n + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(t) {
    return pp(this.localsInner(t));
  }
  /**
  @internal
  */
  localsInner(t) {
    if (this == Mt)
      return Fa;
    if (t.inlineContent || !this.local.some(Ar.is))
      return this.local;
    let n = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof Ar || n.push(this.local[r]);
    return n;
  }
}
tt.empty = new tt([], []);
tt.removeOverlap = pp;
const Mt = tt.empty;
class vr {
  constructor(t) {
    this.members = t;
  }
  map(t, n) {
    const r = this.members.map((a) => a.map(t, n, ia));
    return vr.from(r);
  }
  forChild(t, n) {
    if (n.isLeaf)
      return tt.empty;
    let r = [];
    for (let a = 0; a < this.members.length; a++) {
      let i = this.members[a].forChild(t, n);
      i != Mt && (i instanceof vr ? r = r.concat(i.members) : r.push(i));
    }
    return vr.from(r);
  }
  eq(t) {
    if (!(t instanceof vr) || t.members.length != this.members.length)
      return !1;
    for (let n = 0; n < this.members.length; n++)
      if (!this.members[n].eq(t.members[n]))
        return !1;
    return !0;
  }
  locals(t) {
    let n, r = !0;
    for (let a = 0; a < this.members.length; a++) {
      let i = this.members[a].localsInner(t);
      if (i.length)
        if (!n)
          n = i;
        else {
          r && (n = n.slice(), r = !1);
          for (let o = 0; o < i.length; o++)
            n.push(i[o]);
        }
    }
    return n ? pp(r ? n : n.sort(oa)) : Fa;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(t) {
    switch (t.length) {
      case 0:
        return Mt;
      case 1:
        return t[0];
      default:
        return new vr(t.every((n) => n instanceof tt) ? t : t.reduce((n, r) => n.concat(r instanceof tt ? r : r.members), []));
    }
  }
}
function l9(e, t, n, r, a, i, o) {
  let s = e.slice();
  for (let l = 0, u = i; l < n.maps.length; l++) {
    let h = 0;
    n.maps[l].forEach((p, f, y, m) => {
      let v = m - y - (f - p);
      for (let k = 0; k < s.length; k += 3) {
        let b = s[k + 1];
        if (b < 0 || p > b + u - h)
          continue;
        let x = s[k] + u - h;
        f >= x ? s[k + 1] = p <= x ? -2 : -1 : p >= u && v && (s[k] += v, s[k + 1] += v);
      }
      h += v;
    }), u = n.maps[l].map(u, -1);
  }
  let c = !1;
  for (let l = 0; l < s.length; l += 3)
    if (s[l + 1] < 0) {
      if (s[l + 1] == -2) {
        c = !0, s[l + 1] = -1;
        continue;
      }
      let u = n.map(e[l] + i), h = u - a;
      if (h < 0 || h >= r.content.size) {
        c = !0;
        continue;
      }
      let p = n.map(e[l + 1] + i, -1), f = p - a, { index: y, offset: m } = r.content.findIndex(h), v = r.maybeChild(y);
      if (v && m == h && m + v.nodeSize == f) {
        let k = s[l + 2].mapInner(n, v, u + 1, e[l] + i + 1, o);
        k != Mt ? (s[l] = h, s[l + 1] = f, s[l + 2] = k) : (s[l + 1] = -2, c = !0);
      } else
        c = !0;
    }
  if (c) {
    let l = d9(s, e, t, n, a, i, o), u = Bc(l, r, 0, o);
    t = u.local;
    for (let h = 0; h < s.length; h += 3)
      s[h + 1] < 0 && (s.splice(h, 3), h -= 3);
    for (let h = 0, p = 0; h < u.children.length; h += 3) {
      let f = u.children[h];
      for (; p < s.length && s[p] < f; )
        p += 3;
      s.splice(p, 0, u.children[h], u.children[h + 1], u.children[h + 2]);
    }
  }
  return new tt(t.sort(oa), s);
}
function Bk(e, t) {
  if (!t || !e.length)
    return e;
  let n = [];
  for (let r = 0; r < e.length; r++) {
    let a = e[r];
    n.push(new Ht(a.from + t, a.to + t, a.type));
  }
  return n;
}
function d9(e, t, n, r, a, i, o) {
  function s(c, l) {
    for (let u = 0; u < c.local.length; u++) {
      let h = c.local[u].map(r, a, l);
      h ? n.push(h) : o.onRemove && o.onRemove(c.local[u].spec);
    }
    for (let u = 0; u < c.children.length; u += 3)
      s(c.children[u + 2], c.children[u] + l + 1);
  }
  for (let c = 0; c < e.length; c += 3)
    e[c + 1] == -1 && s(e[c + 2], t[c] + i + 1);
  return n;
}
function Hk(e, t, n) {
  if (t.isLeaf)
    return null;
  let r = n + t.nodeSize, a = null;
  for (let i = 0, o; i < e.length; i++)
    (o = e[i]) && o.from > n && o.to < r && ((a || (a = [])).push(o), e[i] = null);
  return a;
}
function $k(e) {
  let t = [];
  for (let n = 0; n < e.length; n++)
    e[n] != null && t.push(e[n]);
  return t;
}
function Bc(e, t, n, r) {
  let a = [], i = !1;
  t.forEach((s, c) => {
    let l = Hk(e, s, c + n);
    if (l) {
      i = !0;
      let u = Bc(l, s, n + c + 1, r);
      u != Mt && a.push(c, c + s.nodeSize, u);
    }
  });
  let o = Bk(i ? $k(e) : e, -n).sort(oa);
  for (let s = 0; s < o.length; s++)
    o[s].type.valid(t, o[s]) || (r.onRemove && r.onRemove(o[s].spec), o.splice(s--, 1));
  return o.length || a.length ? new tt(o, a) : Mt;
}
function oa(e, t) {
  return e.from - t.from || e.to - t.to;
}
function pp(e) {
  let t = e;
  for (let n = 0; n < t.length - 1; n++) {
    let r = t[n];
    if (r.from != r.to)
      for (let a = n + 1; a < t.length; a++) {
        let i = t[a];
        if (i.from == r.from) {
          i.to != r.to && (t == e && (t = e.slice()), t[a] = i.copy(i.from, r.to), gf(t, a + 1, i.copy(r.to, i.to)));
          continue;
        } else {
          i.from < r.to && (t == e && (t = e.slice()), t[n] = r.copy(r.from, i.from), gf(t, a, r.copy(i.from, r.to)));
          break;
        }
      }
  }
  return t;
}
function gf(e, t, n) {
  for (; t < e.length && oa(n, e[t]) > 0; )
    t++;
  e.splice(t, 0, n);
}
function fd(e) {
  let t = [];
  return e.someProp("decorations", (n) => {
    let r = n(e.state);
    r && r != Mt && t.push(r);
  }), e.cursorWrapper && t.push(tt.create(e.state.doc, [e.cursorWrapper.deco])), vr.from(t);
}
const u9 = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, h9 = $t && Cr <= 11;
class p9 {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(t) {
    this.anchorNode = t.anchorNode, this.anchorOffset = t.anchorOffset, this.focusNode = t.focusNode, this.focusOffset = t.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(t) {
    return t.anchorNode == this.anchorNode && t.anchorOffset == this.anchorOffset && t.focusNode == this.focusNode && t.focusOffset == this.focusOffset;
  }
}
class f9 {
  constructor(t, n) {
    this.view = t, this.handleDOMChange = n, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new p9(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let a = 0; a < r.length; a++)
        this.queue.push(r[a]);
      $t && Cr <= 11 && r.some((a) => a.type == "childList" && a.removedNodes.length || a.type == "characterData" && a.oldValue.length > a.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), h9 && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, u9)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let t = this.observer.takeRecords();
      if (t.length) {
        for (let n = 0; n < t.length; n++)
          this.queue.push(t[n]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (lf(this.view)) {
      if (this.suppressingSelectionUpdates)
        return rr(this.view);
      if ($t && Cr <= 11 && !this.view.state.selection.empty) {
        let t = this.view.domSelectionRange();
        if (t.focusNode && pa(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(t) {
    if (!t.focusNode)
      return !0;
    let n = /* @__PURE__ */ new Set(), r;
    for (let i = t.focusNode; i; i = vo(i))
      n.add(i);
    for (let i = t.anchorNode; i; i = vo(i))
      if (n.has(i)) {
        r = i;
        break;
      }
    let a = r && this.view.docView.nearestDesc(r);
    if (a && a.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let t of this.observer.takeRecords())
        this.queue.push(t);
    return this.queue;
  }
  flush() {
    let { view: t } = this;
    if (!t.docView || this.flushingSoon > -1)
      return;
    let n = this.pendingRecords();
    n.length && (this.queue = []);
    let r = t.domSelectionRange(), a = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && lf(t) && !this.ignoreSelectionChange(r), i = -1, o = -1, s = !1, c = [];
    if (t.editable)
      for (let u = 0; u < n.length; u++) {
        let h = this.registerMutation(n[u], c);
        h && (i = i < 0 ? h.from : Math.min(h.from, i), o = o < 0 ? h.to : Math.max(h.to, o), h.typeOver && (s = !0));
      }
    if (kn && c.length) {
      let u = c.filter((h) => h.nodeName == "BR");
      if (u.length == 2) {
        let [h, p] = u;
        h.parentNode && h.parentNode.parentNode == p.parentNode ? p.remove() : h.remove();
      } else {
        let { focusNode: h } = this.currentSelection;
        for (let p of u) {
          let f = p.parentNode;
          f && f.nodeName == "LI" && (!h || g9(t, h) != f) && p.remove();
        }
      }
    }
    let l = null;
    i < 0 && a && t.input.lastFocus > Date.now() - 200 && Math.max(t.input.lastTouch, t.input.lastClick.time) < Date.now() - 300 && t1(r) && (l = sp(t)) && l.eq(Ie.near(t.state.doc.resolve(0), 1)) ? (t.input.lastFocus = 0, rr(t), this.currentSelection.set(r), t.scrollToSelection()) : (i > -1 || a) && (i > -1 && (t.docView.markDirty(i, o), y9(t)), this.handleDOMChange(i, o, s, c), t.docView && t.docView.dirty ? t.updateState(t.state) : this.currentSelection.eq(r) || rr(t), this.currentSelection.set(r));
  }
  registerMutation(t, n) {
    if (n.indexOf(t.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(t.target);
    if (t.type == "attributes" && (r == this.view.docView || t.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    t.attributeName == "style" && !t.oldValue && !t.target.getAttribute("style")) || !r || r.ignoreMutation(t))
      return null;
    if (t.type == "childList") {
      for (let u = 0; u < t.addedNodes.length; u++) {
        let h = t.addedNodes[u];
        n.push(h), h.nodeType == 3 && (this.lastChangedTextNode = h);
      }
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(t.target))
        return { from: r.posBefore, to: r.posAfter };
      let a = t.previousSibling, i = t.nextSibling;
      if ($t && Cr <= 11 && t.addedNodes.length)
        for (let u = 0; u < t.addedNodes.length; u++) {
          let { previousSibling: h, nextSibling: p } = t.addedNodes[u];
          (!h || Array.prototype.indexOf.call(t.addedNodes, h) < 0) && (a = h), (!p || Array.prototype.indexOf.call(t.addedNodes, p) < 0) && (i = p);
        }
      let o = a && a.parentNode == t.target ? mt(a) + 1 : 0, s = r.localPosFromDOM(t.target, o, -1), c = i && i.parentNode == t.target ? mt(i) : t.target.childNodes.length, l = r.localPosFromDOM(t.target, c, 1);
      return { from: s, to: l };
    } else
      return t.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : (this.lastChangedTextNode = t.target, {
        from: r.posAtStart,
        to: r.posAtEnd,
        // An event was generated for a text change that didn't change
        // any text. Mark the dom change to fall back to assuming the
        // selection was typed over with an identical value if it can't
        // find another change.
        typeOver: t.target.nodeValue == t.oldValue
      });
  }
}
let vf = /* @__PURE__ */ new WeakMap(), kf = !1;
function y9(e) {
  if (!vf.has(e) && (vf.set(e, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(e.dom).whiteSpace) !== -1)) {
    if (e.requiresGeckoHackNode = kn, kf)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), kf = !0;
  }
}
function bf(e, t) {
  let n = t.startContainer, r = t.startOffset, a = t.endContainer, i = t.endOffset, o = e.domAtPos(e.state.selection.anchor);
  return pa(o.node, o.offset, a, i) && ([n, r, a, i] = [a, i, n, r]), { anchorNode: n, anchorOffset: r, focusNode: a, focusOffset: i };
}
function m9(e, t) {
  if (t.getComposedRanges) {
    let a = t.getComposedRanges(e.root)[0];
    if (a)
      return bf(e, a);
  }
  let n;
  function r(a) {
    a.preventDefault(), a.stopImmediatePropagation(), n = a.getTargetRanges()[0];
  }
  return e.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), e.dom.removeEventListener("beforeinput", r, !0), n ? bf(e, n) : null;
}
function g9(e, t) {
  for (let n = t.parentNode; n && n != e.dom; n = n.parentNode) {
    let r = e.docView.nearestDesc(n, !0);
    if (r && r.node.isBlock)
      return n;
  }
  return null;
}
function v9(e, t, n) {
  let { node: r, fromOffset: a, toOffset: i, from: o, to: s } = e.docView.parseRange(t, n), c = e.domSelectionRange(), l, u = c.anchorNode;
  if (u && e.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (l = [{ node: u, offset: c.anchorOffset }], t1(c) || l.push({ node: c.focusNode, offset: c.focusOffset })), Tt && e.input.lastKeyCode === 8)
    for (let v = i; v > a; v--) {
      let k = r.childNodes[v - 1], b = k.pmViewDesc;
      if (k.nodeName == "BR" && !b) {
        i = v;
        break;
      }
      if (!b || b.size)
        break;
    }
  let h = e.state.doc, p = e.someProp("domParser") || oi.fromSchema(e.state.schema), f = h.resolve(o), y = null, m = p.parse(r, {
    topNode: f.parent,
    topMatch: f.parent.contentMatchAt(f.index()),
    topOpen: !0,
    from: a,
    to: i,
    preserveWhitespace: f.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: l,
    ruleFromNode: k9,
    context: f
  });
  if (l && l[0].pos != null) {
    let v = l[0].pos, k = l[1] && l[1].pos;
    k == null && (k = v), y = { anchor: v + o, head: k + o };
  }
  return { doc: m, sel: y, from: o, to: s };
}
function k9(e) {
  let t = e.pmViewDesc;
  if (t)
    return t.parseRule();
  if (e.nodeName == "BR" && e.parentNode) {
    if (Nt && /^(ul|ol)$/i.test(e.parentNode.nodeName)) {
      let n = document.createElement("div");
      return n.appendChild(document.createElement("li")), { skip: n };
    } else if (e.parentNode.lastChild == e || Nt && /^(tr|table)$/i.test(e.parentNode.nodeName))
      return { ignore: !0 };
  } else if (e.nodeName == "IMG" && e.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const b9 = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function x9(e, t, n, r, a) {
  let i = e.input.compositionPendingChanges || (e.composing ? e.input.compositionID : 0);
  if (e.input.compositionPendingChanges = 0, t < 0) {
    let A = e.input.lastSelectionTime > Date.now() - 50 ? e.input.lastSelectionOrigin : null, $ = sp(e, A);
    if ($ && !e.state.selection.eq($)) {
      if (Tt && mn && e.input.lastKeyCode === 13 && Date.now() - 100 < e.input.lastKeyCodeTime && e.someProp("handleKeyDown", (Z) => Z(e, Ur(13, "Enter"))))
        return;
      let F = e.state.tr.setSelection($);
      A == "pointer" ? F.setMeta("pointer", !0) : A == "key" && F.scrollIntoView(), i && F.setMeta("composition", i), e.dispatch(F);
    }
    return;
  }
  let o = e.state.doc.resolve(t), s = o.sharedDepth(n);
  t = o.before(s + 1), n = e.state.doc.resolve(n).after(s + 1);
  let c = e.state.selection, l = v9(e, t, n), u = e.state.doc, h = u.slice(l.from, l.to), p, f;
  e.input.lastKeyCode === 8 && Date.now() - 100 < e.input.lastKeyCodeTime ? (p = e.state.selection.to, f = "end") : (p = e.state.selection.from, f = "start"), e.input.lastKeyCode = null;
  let y = C9(h.content, l.doc.content, l.from, p, f);
  if ((li && e.input.lastIOSEnter > Date.now() - 225 || mn) && a.some((A) => A.nodeType == 1 && !b9.test(A.nodeName)) && (!y || y.endA >= y.endB) && e.someProp("handleKeyDown", (A) => A(e, Ur(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (!y)
    if (r && c instanceof De && !c.empty && c.$head.sameParent(c.$anchor) && !e.composing && !(l.sel && l.sel.anchor != l.sel.head))
      y = { start: c.from, endA: c.to, endB: c.to };
    else {
      if (l.sel) {
        let A = xf(e, e.state.doc, l.sel);
        if (A && !A.eq(e.state.selection)) {
          let $ = e.state.tr.setSelection(A);
          i && $.setMeta("composition", i), e.dispatch($);
        }
      }
      return;
    }
  e.input.domChangeCount++, e.state.selection.from < e.state.selection.to && y.start == y.endB && e.state.selection instanceof De && (y.start > e.state.selection.from && y.start <= e.state.selection.from + 2 && e.state.selection.from >= l.from ? y.start = e.state.selection.from : y.endA < e.state.selection.to && y.endA >= e.state.selection.to - 2 && e.state.selection.to <= l.to && (y.endB += e.state.selection.to - y.endA, y.endA = e.state.selection.to)), $t && Cr <= 11 && y.endB == y.start + 1 && y.endA == y.start && y.start > l.from && l.doc.textBetween(y.start - l.from - 1, y.start - l.from + 1) == "  " && (y.start--, y.endA--, y.endB--);
  let m = l.doc.resolveNoCache(y.start - l.from), v = l.doc.resolveNoCache(y.endB - l.from), k = u.resolve(y.start), b = m.sameParent(v) && m.parent.inlineContent && k.end() >= y.endA, x;
  if ((li && e.input.lastIOSEnter > Date.now() - 225 && (!b || a.some((A) => A.nodeName == "DIV" || A.nodeName == "P")) || !b && m.pos < l.doc.content.size && !m.sameParent(v) && (x = Ie.findFrom(l.doc.resolve(m.pos + 1), 1, !0)) && x.head == v.pos) && e.someProp("handleKeyDown", (A) => A(e, Ur(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (e.state.selection.anchor > y.start && w9(u, y.start, y.endA, m, v) && e.someProp("handleKeyDown", (A) => A(e, Ur(8, "Backspace")))) {
    mn && Tt && e.domObserver.suppressSelectionUpdates();
    return;
  }
  Tt && mn && y.endB == y.start && (e.input.lastAndroidDelete = Date.now()), mn && !b && m.start() != v.start() && v.parentOffset == 0 && m.depth == v.depth && l.sel && l.sel.anchor == l.sel.head && l.sel.head == y.endA && (y.endB -= 2, v = l.doc.resolveNoCache(y.endB - l.from), setTimeout(() => {
    e.someProp("handleKeyDown", function(A) {
      return A(e, Ur(13, "Enter"));
    });
  }, 20));
  let g = y.start, w = y.endA, M, S, D;
  if (b) {
    if (m.pos == v.pos)
      $t && Cr <= 11 && m.parentOffset == 0 && (e.domObserver.suppressSelectionUpdates(), setTimeout(() => rr(e), 20)), M = e.state.tr.delete(g, w), S = u.resolve(y.start).marksAcross(u.resolve(y.endA));
    else if (
      // Adding or removing a mark
      y.endA == y.endB && (D = M9(m.parent.content.cut(m.parentOffset, v.parentOffset), k.parent.content.cut(k.parentOffset, y.endA - k.start())))
    )
      M = e.state.tr, D.type == "add" ? M.addMark(g, w, D.mark) : M.removeMark(g, w, D.mark);
    else if (m.parent.child(m.index()).isText && m.index() == v.index() - (v.textOffset ? 0 : 1)) {
      let A = m.parent.textBetween(m.parentOffset, v.parentOffset);
      if (e.someProp("handleTextInput", ($) => $(e, g, w, A)))
        return;
      M = e.state.tr.insertText(A, g, w);
    }
  }
  if (M || (M = e.state.tr.replace(g, w, l.doc.slice(y.start - l.from, y.endB - l.from))), l.sel) {
    let A = xf(e, M.doc, l.sel);
    A && !(Tt && mn && e.composing && A.empty && (y.start != y.endB || e.input.lastAndroidDelete < Date.now() - 100) && (A.head == g || A.head == M.mapping.map(w) - 1) || $t && A.empty && A.head == g) && M.setSelection(A);
  }
  S && M.ensureMarks(S), i && M.setMeta("composition", i), e.dispatch(M.scrollIntoView());
}
function xf(e, t, n) {
  return Math.max(n.anchor, n.head) > t.content.size ? null : cp(e, t.resolve(n.anchor), t.resolve(n.head));
}
function M9(e, t) {
  let n = e.firstChild.marks, r = t.firstChild.marks, a = n, i = r, o, s, c;
  for (let u = 0; u < r.length; u++)
    a = r[u].removeFromSet(a);
  for (let u = 0; u < n.length; u++)
    i = n[u].removeFromSet(i);
  if (a.length == 1 && i.length == 0)
    s = a[0], o = "add", c = (u) => u.mark(s.addToSet(u.marks));
  else if (a.length == 0 && i.length == 1)
    s = i[0], o = "remove", c = (u) => u.mark(s.removeFromSet(u.marks));
  else
    return null;
  let l = [];
  for (let u = 0; u < t.childCount; u++)
    l.push(c(t.child(u)));
  if (oe.from(l).eq(e))
    return { mark: s, type: o };
}
function w9(e, t, n, r, a) {
  if (
    // The content must have shrunk
    n - t <= a.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
    yd(r, !0, !1) < a.pos
  )
    return !1;
  let i = e.resolve(t);
  if (!r.parent.isTextblock) {
    let s = i.nodeAfter;
    return s != null && n == t + s.nodeSize;
  }
  if (i.parentOffset < i.parent.content.size || !i.parent.isTextblock)
    return !1;
  let o = e.resolve(yd(i, !0, !0));
  return !o.parent.isTextblock || o.pos > n || yd(o, !0, !1) < n ? !1 : r.parent.content.cut(r.parentOffset).eq(o.parent.content);
}
function yd(e, t, n) {
  let r = e.depth, a = t ? e.end() : e.pos;
  for (; r > 0 && (t || e.indexAfter(r) == e.node(r).childCount); )
    r--, a++, t = !1;
  if (n) {
    let i = e.node(r).maybeChild(e.indexAfter(r));
    for (; i && !i.isLeaf; )
      i = i.firstChild, a++;
  }
  return a;
}
function C9(e, t, n, r, a) {
  let i = e.findDiffStart(t, n);
  if (i == null)
    return null;
  let { a: o, b: s } = e.findDiffEnd(t, n + e.size, n + t.size);
  if (a == "end") {
    let c = Math.max(0, i - Math.min(o, s));
    r -= o + c - i;
  }
  if (o < i && e.size < t.size) {
    let c = r <= i && r >= o ? i - r : 0;
    i -= c, i && i < t.size && Mf(t.textBetween(i - 1, i + 1)) && (i += c ? 1 : -1), s = i + (s - o), o = i;
  } else if (s < i) {
    let c = r <= i && r >= s ? i - r : 0;
    i -= c, i && i < e.size && Mf(e.textBetween(i - 1, i + 1)) && (i += c ? 1 : -1), o = i + (o - s), s = i;
  }
  return { start: i, endA: o, endB: s };
}
function Mf(e) {
  if (e.length != 2)
    return !1;
  let t = e.charCodeAt(0), n = e.charCodeAt(1);
  return t >= 56320 && t <= 57343 && n >= 55296 && n <= 56319;
}
class S9 {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(t, n) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new qw(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = n, this.state = n.state, this.directPlugins = n.plugins || [], this.directPlugins.forEach(Of), this.dispatch = this.dispatch.bind(this), this.dom = t && t.mount || document.createElement("div"), t && (t.appendChild ? t.appendChild(this.dom) : typeof t == "function" ? t(this.dom) : t.mount && (this.mounted = !0)), this.editable = Sf(this), Cf(this), this.nodeViews = Af(this), this.docView = nf(this.state.doc, wf(this), fd(this), this.dom, this), this.domObserver = new f9(this, (r, a, i, o) => x9(this, r, a, i, o)), this.domObserver.start(), _w(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let t = this._props;
      this._props = {};
      for (let n in t)
        this._props[n] = t[n];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(t) {
    t.handleDOMEvents != this._props.handleDOMEvents && Pu(this);
    let n = this._props;
    this._props = t, t.plugins && (t.plugins.forEach(Of), this.directPlugins = t.plugins), this.updateStateInner(t.state, n);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(t) {
    let n = {};
    for (let r in this._props)
      n[r] = this._props[r];
    n.state = this.state;
    for (let r in t)
      n[r] = t[r];
    this.update(n);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(t) {
    this.updateStateInner(t, this._props);
  }
  updateStateInner(t, n) {
    var r;
    let a = this.state, i = !1, o = !1;
    t.storedMarks && this.composing && (Lk(this), o = !0), this.state = t;
    let s = a.plugins != t.plugins || this._props.plugins != n.plugins;
    if (s || this._props.plugins != n.plugins || this._props.nodeViews != n.nodeViews) {
      let f = Af(this);
      O9(f, this.nodeViews) && (this.nodeViews = f, i = !0);
    }
    (s || n.handleDOMEvents != this._props.handleDOMEvents) && Pu(this), this.editable = Sf(this), Cf(this);
    let c = fd(this), l = wf(this), u = a.plugins != t.plugins && !a.doc.eq(t.doc) ? "reset" : t.scrollToSelection > a.scrollToSelection ? "to selection" : "preserve", h = i || !this.docView.matchesNode(t.doc, l, c);
    (h || !t.selection.eq(a.selection)) && (o = !0);
    let p = u == "preserve" && o && this.dom.style.overflowAnchor == null && ow(this);
    if (o) {
      this.domObserver.stop();
      let f = h && ($t || Tt) && !this.composing && !a.selection.empty && !t.selection.empty && A9(a.selection, t.selection);
      if (h) {
        let y = Tt ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = a9(this)), (i || !this.docView.update(t.doc, l, c, this)) && (this.docView.updateOuterDeco(l), this.docView.destroy(), this.docView = nf(t.doc, l, c, this.dom, this)), y && !this.trackWrites && (f = !0);
      }
      f || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && Dw(this)) ? rr(this, f) : (xk(this, t.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(a), !((r = this.dragging) === null || r === void 0) && r.node && !a.doc.eq(t.doc) && this.updateDraggedNode(this.dragging, a), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : p && sw(p);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let t = this.domSelectionRange().focusNode;
    if (!this.someProp("handleScrollToSelection", (n) => n(this)))
      if (this.state.selection instanceof xe) {
        let n = this.docView.domAfterPos(this.state.selection.from);
        n.nodeType == 1 && Y0(this, n.getBoundingClientRect(), t);
      } else
        Y0(this, this.coordsAtPos(this.state.selection.head, 1), t);
  }
  destroyPluginViews() {
    let t;
    for (; t = this.pluginViews.pop(); )
      t.destroy && t.destroy();
  }
  updatePluginViews(t) {
    if (!t || t.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let n = 0; n < this.directPlugins.length; n++) {
        let r = this.directPlugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let n = 0; n < this.state.plugins.length; n++) {
        let r = this.state.plugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let n = 0; n < this.pluginViews.length; n++) {
        let r = this.pluginViews[n];
        r.update && r.update(this, t);
      }
  }
  updateDraggedNode(t, n) {
    let r = t.node, a = -1;
    if (this.state.doc.nodeAt(r.from) == r.node)
      a = r.from;
    else {
      let i = r.from + (this.state.doc.content.size - n.doc.content.size);
      (i > 0 && this.state.doc.nodeAt(i)) == r.node && (a = i);
    }
    this.dragging = new Vk(t.slice, t.move, a < 0 ? void 0 : xe.create(this.state.doc, a));
  }
  someProp(t, n) {
    let r = this._props && this._props[t], a;
    if (r != null && (a = n ? n(r) : r))
      return a;
    for (let o = 0; o < this.directPlugins.length; o++) {
      let s = this.directPlugins[o].props[t];
      if (s != null && (a = n ? n(s) : s))
        return a;
    }
    let i = this.state.plugins;
    if (i)
      for (let o = 0; o < i.length; o++) {
        let s = i[o].props[t];
        if (s != null && (a = n ? n(s) : s))
          return a;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if ($t) {
      let t = this.root.activeElement;
      if (t == this.dom)
        return !0;
      if (!t || !this.dom.contains(t))
        return !1;
      for (; t && this.dom != t && this.dom.contains(t); ) {
        if (t.contentEditable == "false")
          return !1;
        t = t.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && cw(this.dom), rr(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let t = this._root;
    if (t == null) {
      for (let n = this.dom.parentNode; n; n = n.parentNode)
        if (n.nodeType == 9 || n.nodeType == 11 && n.host)
          return n.getSelection || (Object.getPrototypeOf(n).getSelection = () => n.ownerDocument.getSelection()), this._root = n;
    }
    return t || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(t) {
    return pw(this, t);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(t, n = 1) {
    return pk(this, t, n);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(t, n = 0) {
    return this.docView.domFromPos(t, n);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(t) {
    let n = this.docView.descAt(t);
    return n ? n.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(t, n, r = -1) {
    let a = this.docView.posFromDOM(t, n, r);
    if (a == null)
      throw new RangeError("DOM position not inside the editor");
    return a;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(t, n) {
    return vw(this, n || this.state, t);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(t, n) {
    return bo(this, "", t, !1, n || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(t, n) {
    return bo(this, t, null, !0, n || new ClipboardEvent("paste"));
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (Gw(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], fd(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, X7());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(t) {
    return Xw(this, t);
  }
  /**
  Dispatch a transaction. Will call
  [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
  when given, and otherwise defaults to applying the transaction to
  the current state and calling
  [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
  This method is bound to the view instance, so that it can be
  easily passed around.
  */
  dispatch(t) {
    let n = this._props.dispatchTransaction;
    n ? n.call(this, t) : this.updateState(this.state.apply(t));
  }
  /**
  @internal
  */
  domSelectionRange() {
    let t = this.domSelection();
    return Nt && this.root.nodeType === 11 && Q7(this.dom.ownerDocument) == this.dom && m9(this, t) || t;
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
function wf(e) {
  let t = /* @__PURE__ */ Object.create(null);
  return t.class = "ProseMirror", t.contenteditable = String(e.editable), e.someProp("attributes", (n) => {
    if (typeof n == "function" && (n = n(e.state)), n)
      for (let r in n)
        r == "class" ? t.class += " " + n[r] : r == "style" ? t.style = (t.style ? t.style + ";" : "") + n[r] : !t[r] && r != "contenteditable" && r != "nodeName" && (t[r] = String(n[r]));
  }), t.translate || (t.translate = "no"), [Ht.node(0, e.state.doc.content.size, t)];
}
function Cf(e) {
  if (e.markCursor) {
    let t = document.createElement("img");
    t.className = "ProseMirror-separator", t.setAttribute("mark-placeholder", "true"), t.setAttribute("alt", ""), e.cursorWrapper = { dom: t, deco: Ht.widget(e.state.selection.head, t, { raw: !0, marks: e.markCursor }) };
  } else
    e.cursorWrapper = null;
}
function Sf(e) {
  return !e.someProp("editable", (t) => t(e.state) === !1);
}
function A9(e, t) {
  let n = Math.min(e.$anchor.sharedDepth(e.head), t.$anchor.sharedDepth(t.head));
  return e.$anchor.start(n) != t.$anchor.start(n);
}
function Af(e) {
  let t = /* @__PURE__ */ Object.create(null);
  function n(r) {
    for (let a in r)
      Object.prototype.hasOwnProperty.call(t, a) || (t[a] = r[a]);
  }
  return e.someProp("nodeViews", n), e.someProp("markViews", n), t;
}
function O9(e, t) {
  let n = 0, r = 0;
  for (let a in e) {
    if (e[a] != t[a])
      return !0;
    n++;
  }
  for (let a in t)
    r++;
  return n != r;
}
function Of(e) {
  if (e.spec.state || e.spec.filterTransaction || e.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var Ir = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Hc = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, E9 = typeof navigator < "u" && /Mac/.test(navigator.platform), I9 = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var gt = 0; gt < 10; gt++)
  Ir[48 + gt] = Ir[96 + gt] = String(gt);
for (var gt = 1; gt <= 24; gt++)
  Ir[gt + 111] = "F" + gt;
for (var gt = 65; gt <= 90; gt++)
  Ir[gt] = String.fromCharCode(gt + 32), Hc[gt] = String.fromCharCode(gt);
for (var md in Ir)
  Hc.hasOwnProperty(md) || (Hc[md] = Ir[md]);
function D9(e) {
  var t = E9 && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || I9 && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified", n = !t && e.key || (e.shiftKey ? Hc : Ir)[e.keyCode] || e.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
const T9 = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function N9(e) {
  let t = e.split(/-(?!$)/), n = t[t.length - 1];
  n == "Space" && (n = " ");
  let r, a, i, o;
  for (let s = 0; s < t.length - 1; s++) {
    let c = t[s];
    if (/^(cmd|meta|m)$/i.test(c))
      o = !0;
    else if (/^a(lt)?$/i.test(c))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      a = !0;
    else if (/^s(hift)?$/i.test(c))
      i = !0;
    else if (/^mod$/i.test(c))
      T9 ? o = !0 : a = !0;
    else
      throw new Error("Unrecognized modifier name: " + c);
  }
  return r && (n = "Alt-" + n), a && (n = "Ctrl-" + n), o && (n = "Meta-" + n), i && (n = "Shift-" + n), n;
}
function P9(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n in e)
    t[N9(n)] = e[n];
  return t;
}
function gd(e, t, n = !0) {
  return t.altKey && (e = "Alt-" + e), t.ctrlKey && (e = "Ctrl-" + e), t.metaKey && (e = "Meta-" + e), n && t.shiftKey && (e = "Shift-" + e), e;
}
function L9(e) {
  return new At({ props: { handleKeyDown: jk(e) } });
}
function jk(e) {
  let t = P9(e);
  return function(n, r) {
    let a = D9(r), i, o = t[gd(a, r)];
    if (o && o(n.state, n.dispatch, n))
      return !0;
    if (a.length == 1 && a != " ") {
      if (r.shiftKey) {
        let s = t[gd(a, r, !1)];
        if (s && s(n.state, n.dispatch, n))
          return !0;
      }
      if ((r.shiftKey || r.altKey || r.metaKey || a.charCodeAt(0) > 127) && (i = Ir[r.keyCode]) && i != a) {
        let s = t[gd(i, r)];
        if (s && s(n.state, n.dispatch, n))
          return !0;
      }
    }
    return !1;
  };
}
const R9 = (e, t) => e.selection.empty ? !1 : (t && t(e.tr.deleteSelection().scrollIntoView()), !0);
function Fk(e, t) {
  let { $cursor: n } = e.selection;
  return !n || (t ? !t.endOfTextblock("backward", e) : n.parentOffset > 0) ? null : n;
}
const V9 = (e, t, n) => {
  let r = Fk(e, n);
  if (!r)
    return !1;
  let a = fp(r);
  if (!a) {
    let o = r.blockRange(), s = o && Ei(o);
    return s == null ? !1 : (t && t(e.tr.lift(o, s).scrollIntoView()), !0);
  }
  let i = a.nodeBefore;
  if (!i.type.spec.isolating && Gk(e, a, t))
    return !0;
  if (r.parent.content.size == 0 && (di(i, "end") || xe.isSelectable(i))) {
    let o = Ql(e.doc, r.before(), r.after(), ye.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (t) {
        let s = e.tr.step(o);
        s.setSelection(di(i, "end") ? Ie.findFrom(s.doc.resolve(s.mapping.map(a.pos, -1)), -1) : xe.create(s.doc, a.pos - i.nodeSize)), t(s.scrollIntoView());
      }
      return !0;
    }
  }
  return i.isAtom && a.depth == r.depth - 1 ? (t && t(e.tr.delete(a.pos - i.nodeSize, a.pos).scrollIntoView()), !0) : !1;
}, z9 = (e, t, n) => {
  let r = Fk(e, n);
  if (!r)
    return !1;
  let a = fp(r);
  return a ? Wk(e, a, t) : !1;
}, B9 = (e, t, n) => {
  let r = qk(e, n);
  if (!r)
    return !1;
  let a = yp(r);
  return a ? Wk(e, a, t) : !1;
};
function Wk(e, t, n) {
  let r = t.nodeBefore, a = r, i = t.pos - 1;
  for (; !a.isTextblock; i--) {
    if (a.type.spec.isolating)
      return !1;
    let u = a.lastChild;
    if (!u)
      return !1;
    a = u;
  }
  let o = t.nodeAfter, s = o, c = t.pos + 1;
  for (; !s.isTextblock; c++) {
    if (s.type.spec.isolating)
      return !1;
    let u = s.firstChild;
    if (!u)
      return !1;
    s = u;
  }
  let l = Ql(e.doc, i, c, ye.empty);
  if (!l || l.from != i || l instanceof ct && l.slice.size >= c - i)
    return !1;
  if (n) {
    let u = e.tr.step(l);
    u.setSelection(De.create(u.doc, i)), n(u.scrollIntoView());
  }
  return !0;
}
function di(e, t, n = !1) {
  for (let r = e; r; r = t == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (n && r.childCount != 1)
      return !1;
  }
  return !1;
}
const H9 = (e, t, n) => {
  let { $head: r, empty: a } = e.selection, i = r;
  if (!a)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("backward", e) : r.parentOffset > 0)
      return !1;
    i = fp(r);
  }
  let o = i && i.nodeBefore;
  return !o || !xe.isSelectable(o) ? !1 : (t && t(e.tr.setSelection(xe.create(e.doc, i.pos - o.nodeSize)).scrollIntoView()), !0);
};
function fp(e) {
  if (!e.parent.type.spec.isolating)
    for (let t = e.depth - 1; t >= 0; t--) {
      if (e.index(t) > 0)
        return e.doc.resolve(e.before(t + 1));
      if (e.node(t).type.spec.isolating)
        break;
    }
  return null;
}
function qk(e, t) {
  let { $cursor: n } = e.selection;
  return !n || (t ? !t.endOfTextblock("forward", e) : n.parentOffset < n.parent.content.size) ? null : n;
}
const $9 = (e, t, n) => {
  let r = qk(e, n);
  if (!r)
    return !1;
  let a = yp(r);
  if (!a)
    return !1;
  let i = a.nodeAfter;
  if (Gk(e, a, t))
    return !0;
  if (r.parent.content.size == 0 && (di(i, "start") || xe.isSelectable(i))) {
    let o = Ql(e.doc, r.before(), r.after(), ye.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (t) {
        let s = e.tr.step(o);
        s.setSelection(di(i, "start") ? Ie.findFrom(s.doc.resolve(s.mapping.map(a.pos)), 1) : xe.create(s.doc, s.mapping.map(a.pos))), t(s.scrollIntoView());
      }
      return !0;
    }
  }
  return i.isAtom && a.depth == r.depth - 1 ? (t && t(e.tr.delete(a.pos, a.pos + i.nodeSize).scrollIntoView()), !0) : !1;
}, j9 = (e, t, n) => {
  let { $head: r, empty: a } = e.selection, i = r;
  if (!a)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("forward", e) : r.parentOffset < r.parent.content.size)
      return !1;
    i = yp(r);
  }
  let o = i && i.nodeAfter;
  return !o || !xe.isSelectable(o) ? !1 : (t && t(e.tr.setSelection(xe.create(e.doc, i.pos)).scrollIntoView()), !0);
};
function yp(e) {
  if (!e.parent.type.spec.isolating)
    for (let t = e.depth - 1; t >= 0; t--) {
      let n = e.node(t);
      if (e.index(t) + 1 < n.childCount)
        return e.doc.resolve(e.after(t + 1));
      if (n.type.spec.isolating)
        break;
    }
  return null;
}
const F9 = (e, t) => {
  let n = e.selection, r = n instanceof xe, a;
  if (r) {
    if (n.node.isTextblock || !Lr(e.doc, n.from))
      return !1;
    a = n.from;
  } else if (a = Kl(e.doc, n.from, -1), a == null)
    return !1;
  if (t) {
    let i = e.tr.join(a);
    r && i.setSelection(xe.create(i.doc, a - e.doc.resolve(a).nodeBefore.nodeSize)), t(i.scrollIntoView());
  }
  return !0;
}, W9 = (e, t) => {
  let n = e.selection, r;
  if (n instanceof xe) {
    if (n.node.isTextblock || !Lr(e.doc, n.to))
      return !1;
    r = n.to;
  } else if (r = Kl(e.doc, n.to, 1), r == null)
    return !1;
  return t && t(e.tr.join(r).scrollIntoView()), !0;
}, q9 = (e, t) => {
  let { $from: n, $to: r } = e.selection, a = n.blockRange(r), i = a && Ei(a);
  return i == null ? !1 : (t && t(e.tr.lift(a, i).scrollIntoView()), !0);
}, _9 = (e, t) => {
  let { $head: n, $anchor: r } = e.selection;
  return !n.parent.type.spec.code || !n.sameParent(r) ? !1 : (t && t(e.tr.insertText(`
`).scrollIntoView()), !0);
};
function _k(e) {
  for (let t = 0; t < e.edgeCount; t++) {
    let { type: n } = e.edge(t);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
const G9 = (e, t) => {
  let { $head: n, $anchor: r } = e.selection;
  if (!n.parent.type.spec.code || !n.sameParent(r))
    return !1;
  let a = n.node(-1), i = n.indexAfter(-1), o = _k(a.contentMatchAt(i));
  if (!o || !a.canReplaceWith(i, i, o))
    return !1;
  if (t) {
    let s = n.after(), c = e.tr.replaceWith(s, s, o.createAndFill());
    c.setSelection(Ie.near(c.doc.resolve(s), 1)), t(c.scrollIntoView());
  }
  return !0;
}, Z9 = (e, t) => {
  let n = e.selection, { $from: r, $to: a } = n;
  if (n instanceof vn || r.parent.inlineContent || a.parent.inlineContent)
    return !1;
  let i = _k(a.parent.contentMatchAt(a.indexAfter()));
  if (!i || !i.isTextblock)
    return !1;
  if (t) {
    let o = (!r.parentOffset && a.index() < a.parent.childCount ? r : a).pos, s = e.tr.insert(o, i.createAndFill());
    s.setSelection(De.create(s.doc, o + 1)), t(s.scrollIntoView());
  }
  return !0;
}, X9 = (e, t) => {
  let { $cursor: n } = e.selection;
  if (!n || n.parent.content.size)
    return !1;
  if (n.depth > 1 && n.after() != n.end(-1)) {
    let i = n.before();
    if (Ka(e.doc, i))
      return t && t(e.tr.split(i).scrollIntoView()), !0;
  }
  let r = n.blockRange(), a = r && Ei(r);
  return a == null ? !1 : (t && t(e.tr.lift(r, a).scrollIntoView()), !0);
}, U9 = (e, t) => {
  let { $from: n, to: r } = e.selection, a, i = n.sharedDepth(r);
  return i == 0 ? !1 : (a = n.before(i), t && t(e.tr.setSelection(xe.create(e.doc, a))), !0);
};
function Y9(e, t, n) {
  let r = t.nodeBefore, a = t.nodeAfter, i = t.index();
  return !r || !a || !r.type.compatibleContent(a.type) ? !1 : !r.content.size && t.parent.canReplace(i - 1, i) ? (n && n(e.tr.delete(t.pos - r.nodeSize, t.pos).scrollIntoView()), !0) : !t.parent.canReplace(i, i + 1) || !(a.isTextblock || Lr(e.doc, t.pos)) ? !1 : (n && n(e.tr.clearIncompatible(t.pos, r.type, r.contentMatchAt(r.childCount)).join(t.pos).scrollIntoView()), !0);
}
function Gk(e, t, n) {
  let r = t.nodeBefore, a = t.nodeAfter, i, o;
  if (r.type.spec.isolating || a.type.spec.isolating)
    return !1;
  if (Y9(e, t, n))
    return !0;
  let s = t.parent.canReplace(t.index(), t.index() + 1);
  if (s && (i = (o = r.contentMatchAt(r.childCount)).findWrapping(a.type)) && o.matchType(i[0] || a.type).validEnd) {
    if (n) {
      let h = t.pos + a.nodeSize, p = oe.empty;
      for (let m = i.length - 1; m >= 0; m--)
        p = oe.from(i[m].create(null, p));
      p = oe.from(r.copy(p));
      let f = e.tr.step(new lt(t.pos - 1, h, t.pos, h, new ye(p, 1, 0), i.length, !0)), y = h + 2 * i.length;
      Lr(f.doc, y) && f.join(y), n(f.scrollIntoView());
    }
    return !0;
  }
  let c = Ie.findFrom(t, 1), l = c && c.$from.blockRange(c.$to), u = l && Ei(l);
  if (u != null && u >= t.depth)
    return n && n(e.tr.lift(l, u).scrollIntoView()), !0;
  if (s && di(a, "start", !0) && di(r, "end")) {
    let h = r, p = [];
    for (; p.push(h), !h.isTextblock; )
      h = h.lastChild;
    let f = a, y = 1;
    for (; !f.isTextblock; f = f.firstChild)
      y++;
    if (h.canReplace(h.childCount, h.childCount, f.content)) {
      if (n) {
        let m = oe.empty;
        for (let k = p.length - 1; k >= 0; k--)
          m = oe.from(p[k].copy(m));
        let v = e.tr.step(new lt(t.pos - p.length, t.pos + a.nodeSize, t.pos + y, t.pos + a.nodeSize - y, new ye(m, p.length, 0), 0, !0));
        n(v.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function Zk(e) {
  return function(t, n) {
    let r = t.selection, a = e < 0 ? r.$from : r.$to, i = a.depth;
    for (; a.node(i).isInline; ) {
      if (!i)
        return !1;
      i--;
    }
    return a.node(i).isTextblock ? (n && n(t.tr.setSelection(De.create(t.doc, e < 0 ? a.start(i) : a.end(i)))), !0) : !1;
  };
}
const J9 = Zk(-1), K9 = Zk(1);
function Q9(e, t = null) {
  return function(n, r) {
    let { $from: a, $to: i } = n.selection, o = a.blockRange(i), s = o && ap(o, e, t);
    return s ? (r && r(n.tr.wrap(o, s).scrollIntoView()), !0) : !1;
  };
}
function Ef(e, t = null) {
  return function(n, r) {
    let a = !1;
    for (let i = 0; i < n.selection.ranges.length && !a; i++) {
      let { $from: { pos: o }, $to: { pos: s } } = n.selection.ranges[i];
      n.doc.nodesBetween(o, s, (c, l) => {
        if (a)
          return !1;
        if (!(!c.isTextblock || c.hasMarkup(e, t)))
          if (c.type == e)
            a = !0;
          else {
            let u = n.doc.resolve(l), h = u.index();
            a = u.parent.canReplaceWith(h, h + 1, e);
          }
      });
    }
    if (!a)
      return !1;
    if (r) {
      let i = n.tr;
      for (let o = 0; o < n.selection.ranges.length; o++) {
        let { $from: { pos: s }, $to: { pos: c } } = n.selection.ranges[o];
        i.setBlockType(s, c, e, t);
      }
      r(i.scrollIntoView());
    }
    return !0;
  };
}
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function eC(e, t = null) {
  return function(n, r) {
    let { $from: a, $to: i } = n.selection, o = a.blockRange(i), s = !1, c = o;
    if (!o)
      return !1;
    if (o.depth >= 2 && a.node(o.depth - 1).type.compatibleContent(e) && o.startIndex == 0) {
      if (a.index(o.depth - 1) == 0)
        return !1;
      let u = n.doc.resolve(o.start - 2);
      c = new Tc(u, u, o.depth), o.endIndex < o.parent.childCount && (o = new Tc(a, n.doc.resolve(i.end(o.depth)), o.depth)), s = !0;
    }
    let l = ap(c, e, t, o);
    return l ? (r && r(tC(n.tr, o, l, s, e).scrollIntoView()), !0) : !1;
  };
}
function tC(e, t, n, r, a) {
  let i = oe.empty;
  for (let u = n.length - 1; u >= 0; u--)
    i = oe.from(n[u].type.create(n[u].attrs, i));
  e.step(new lt(t.start - (r ? 2 : 0), t.end, t.start, t.end, new ye(i, 0, 0), n.length, !0));
  let o = 0;
  for (let u = 0; u < n.length; u++)
    n[u].type == a && (o = u + 1);
  let s = n.length - o, c = t.start + n.length - (r ? 2 : 0), l = t.parent;
  for (let u = t.startIndex, h = t.endIndex, p = !0; u < h; u++, p = !1)
    !p && Ka(e.doc, c, s) && (e.split(c, s), c += 2 * s), c += l.child(u).nodeSize;
  return e;
}
function nC(e) {
  return function(t, n) {
    let { $from: r, $to: a } = t.selection, i = r.blockRange(a, (o) => o.childCount > 0 && o.firstChild.type == e);
    return i ? n ? r.node(i.depth - 1).type == e ? rC(t, n, e, i) : aC(t, n, i) : !0 : !1;
  };
}
function rC(e, t, n, r) {
  let a = e.tr, i = r.end, o = r.$to.end(r.depth);
  i < o && (a.step(new lt(i - 1, o, i, o, new ye(oe.from(n.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new Tc(a.doc.resolve(r.$from.pos), a.doc.resolve(o), r.depth));
  const s = Ei(r);
  if (s == null)
    return !1;
  a.lift(r, s);
  let c = a.mapping.map(i, -1) - 1;
  return Lr(a.doc, c) && a.join(c), t(a.scrollIntoView()), !0;
}
function aC(e, t, n) {
  let r = e.tr, a = n.parent;
  for (let f = n.end, y = n.endIndex - 1, m = n.startIndex; y > m; y--)
    f -= a.child(y).nodeSize, r.delete(f - 1, f + 1);
  let i = r.doc.resolve(n.start), o = i.nodeAfter;
  if (r.mapping.map(n.end) != n.start + i.nodeAfter.nodeSize)
    return !1;
  let s = n.startIndex == 0, c = n.endIndex == a.childCount, l = i.node(-1), u = i.index(-1);
  if (!l.canReplace(u + (s ? 0 : 1), u + 1, o.content.append(c ? oe.empty : oe.from(a))))
    return !1;
  let h = i.pos, p = h + o.nodeSize;
  return r.step(new lt(h - (s ? 1 : 0), p + (c ? 1 : 0), h + 1, p - 1, new ye((s ? oe.empty : oe.from(a.copy(oe.empty))).append(c ? oe.empty : oe.from(a.copy(oe.empty))), s ? 0 : 1, c ? 0 : 1), s ? 0 : 1)), t(r.scrollIntoView()), !0;
}
function iC(e) {
  return function(t, n) {
    let { $from: r, $to: a } = t.selection, i = r.blockRange(a, (l) => l.childCount > 0 && l.firstChild.type == e);
    if (!i)
      return !1;
    let o = i.startIndex;
    if (o == 0)
      return !1;
    let s = i.parent, c = s.child(o - 1);
    if (c.type != e)
      return !1;
    if (n) {
      let l = c.lastChild && c.lastChild.type == s.type, u = oe.from(l ? e.create() : null), h = new ye(oe.from(e.create(null, oe.from(s.type.create(null, u)))), l ? 3 : 1, 0), p = i.start, f = i.end;
      n(t.tr.step(new lt(p - (l ? 3 : 1), f, p, f, h, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function a1(e) {
  const { state: t, transaction: n } = e;
  let { selection: r } = n, { doc: a } = n, { storedMarks: i } = n;
  return {
    ...t,
    apply: t.apply.bind(t),
    applyTransaction: t.applyTransaction.bind(t),
    plugins: t.plugins,
    schema: t.schema,
    reconfigure: t.reconfigure.bind(t),
    toJSON: t.toJSON.bind(t),
    get storedMarks() {
      return i;
    },
    get selection() {
      return r;
    },
    get doc() {
      return a;
    },
    get tr() {
      return r = n.selection, a = n.doc, i = n.storedMarks, n;
    }
  };
}
class i1 {
  constructor(t) {
    this.editor = t.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = t.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: t, editor: n, state: r } = this, { view: a } = n, { tr: i } = r, o = this.buildProps(i);
    return Object.fromEntries(Object.entries(t).map(([s, c]) => [s, (...u) => {
      const h = c(...u)(o);
      return !i.getMeta("preventDispatch") && !this.hasCustomState && a.dispatch(i), h;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(t, n = !0) {
    const { rawCommands: r, editor: a, state: i } = this, { view: o } = a, s = [], c = !!t, l = t || i.tr, u = () => (!c && n && !l.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(l), s.every((p) => p === !0)), h = {
      ...Object.fromEntries(Object.entries(r).map(([p, f]) => [p, (...m) => {
        const v = this.buildProps(l, n), k = f(...m)(v);
        return s.push(k), h;
      }])),
      run: u
    };
    return h;
  }
  createCan(t) {
    const { rawCommands: n, state: r } = this, a = !1, i = t || r.tr, o = this.buildProps(i, a);
    return {
      ...Object.fromEntries(Object.entries(n).map(([c, l]) => [c, (...u) => l(...u)({ ...o, dispatch: void 0 })])),
      chain: () => this.createChain(i, a)
    };
  }
  buildProps(t, n = !0) {
    const { rawCommands: r, editor: a, state: i } = this, { view: o } = a, s = {
      tr: t,
      editor: a,
      view: o,
      state: a1({
        state: i,
        transaction: t
      }),
      dispatch: n ? () => {
      } : void 0,
      chain: () => this.createChain(t, n),
      can: () => this.createCan(t),
      get commands() {
        return Object.fromEntries(Object.entries(r).map(([c, l]) => [c, (...u) => l(...u)(s)]));
      }
    };
    return s;
  }
}
class oC {
  constructor() {
    this.callbacks = {};
  }
  on(t, n) {
    return this.callbacks[t] || (this.callbacks[t] = []), this.callbacks[t].push(n), this;
  }
  emit(t, ...n) {
    const r = this.callbacks[t];
    return r && r.forEach((a) => a.apply(this, n)), this;
  }
  off(t, n) {
    const r = this.callbacks[t];
    return r && (n ? this.callbacks[t] = r.filter((a) => a !== n) : delete this.callbacks[t]), this;
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function ge(e, t, n) {
  return e.config[t] === void 0 && e.parent ? ge(e.parent, t, n) : typeof e.config[t] == "function" ? e.config[t].bind({
    ...n,
    parent: e.parent ? ge(e.parent, t, n) : null
  }) : e.config[t];
}
function o1(e) {
  const t = e.filter((a) => a.type === "extension"), n = e.filter((a) => a.type === "node"), r = e.filter((a) => a.type === "mark");
  return {
    baseExtensions: t,
    nodeExtensions: n,
    markExtensions: r
  };
}
function Xk(e) {
  const t = [], { nodeExtensions: n, markExtensions: r } = o1(e), a = [...n, ...r], i = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return e.forEach((o) => {
    const s = {
      name: o.name,
      options: o.options,
      storage: o.storage
    }, c = ge(o, "addGlobalAttributes", s);
    if (!c)
      return;
    c().forEach((u) => {
      u.types.forEach((h) => {
        Object.entries(u.attributes).forEach(([p, f]) => {
          t.push({
            type: h,
            name: p,
            attribute: {
              ...i,
              ...f
            }
          });
        });
      });
    });
  }), a.forEach((o) => {
    const s = {
      name: o.name,
      options: o.options,
      storage: o.storage
    }, c = ge(o, "addAttributes", s);
    if (!c)
      return;
    const l = c();
    Object.entries(l).forEach(([u, h]) => {
      const p = {
        ...i,
        ...h
      };
      typeof (p == null ? void 0 : p.default) == "function" && (p.default = p.default()), p != null && p.isRequired && (p == null ? void 0 : p.default) === void 0 && delete p.default, t.push({
        type: o.name,
        name: u,
        attribute: p
      });
    });
  }), t;
}
function dt(e, t) {
  if (typeof e == "string") {
    if (!t.nodes[e])
      throw Error(`There is no node type named '${e}'. Maybe you forgot to add the extension?`);
    return t.nodes[e];
  }
  return e;
}
function Ke(...e) {
  return e.filter((t) => !!t).reduce((t, n) => {
    const r = { ...t };
    return Object.entries(n).forEach(([a, i]) => {
      if (!r[a]) {
        r[a] = i;
        return;
      }
      if (a === "class") {
        const s = i ? i.split(" ") : [], c = r[a] ? r[a].split(" ") : [], l = s.filter((u) => !c.includes(u));
        r[a] = [...c, ...l].join(" ");
      } else
        a === "style" ? r[a] = [r[a], i].join("; ") : r[a] = i;
    }), r;
  }, {});
}
function Lu(e, t) {
  return t.filter((n) => n.attribute.rendered).map((n) => n.attribute.renderHTML ? n.attribute.renderHTML(e.attrs) || {} : {
    [n.name]: e.attrs[n.name]
  }).reduce((n, r) => Ke(n, r), {});
}
function Uk(e) {
  return typeof e == "function";
}
function Ee(e, t = void 0, ...n) {
  return Uk(e) ? t ? e.bind(t)(...n) : e(...n) : e;
}
function sC(e = {}) {
  return Object.keys(e).length === 0 && e.constructor === Object;
}
function cC(e) {
  return typeof e != "string" ? e : e.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(e) : e === "true" ? !0 : e === "false" ? !1 : e;
}
function If(e, t) {
  return e.style ? e : {
    ...e,
    getAttrs: (n) => {
      const r = e.getAttrs ? e.getAttrs(n) : e.attrs;
      if (r === !1)
        return !1;
      const a = t.reduce((i, o) => {
        const s = o.attribute.parseHTML ? o.attribute.parseHTML(n) : cC(n.getAttribute(o.name));
        return s == null ? i : {
          ...i,
          [o.name]: s
        };
      }, {});
      return { ...r, ...a };
    }
  };
}
function Df(e) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(e).filter(([t, n]) => t === "attrs" && sC(n) ? !1 : n != null)
  );
}
function lC(e, t) {
  var n;
  const r = Xk(e), { nodeExtensions: a, markExtensions: i } = o1(e), o = (n = a.find((l) => ge(l, "topNode"))) === null || n === void 0 ? void 0 : n.name, s = Object.fromEntries(a.map((l) => {
    const u = r.filter((k) => k.type === l.name), h = {
      name: l.name,
      options: l.options,
      storage: l.storage,
      editor: t
    }, p = e.reduce((k, b) => {
      const x = ge(b, "extendNodeSchema", h);
      return {
        ...k,
        ...x ? x(l) : {}
      };
    }, {}), f = Df({
      ...p,
      content: Ee(ge(l, "content", h)),
      marks: Ee(ge(l, "marks", h)),
      group: Ee(ge(l, "group", h)),
      inline: Ee(ge(l, "inline", h)),
      atom: Ee(ge(l, "atom", h)),
      selectable: Ee(ge(l, "selectable", h)),
      draggable: Ee(ge(l, "draggable", h)),
      code: Ee(ge(l, "code", h)),
      defining: Ee(ge(l, "defining", h)),
      isolating: Ee(ge(l, "isolating", h)),
      attrs: Object.fromEntries(u.map((k) => {
        var b;
        return [k.name, { default: (b = k == null ? void 0 : k.attribute) === null || b === void 0 ? void 0 : b.default }];
      }))
    }), y = Ee(ge(l, "parseHTML", h));
    y && (f.parseDOM = y.map((k) => If(k, u)));
    const m = ge(l, "renderHTML", h);
    m && (f.toDOM = (k) => m({
      node: k,
      HTMLAttributes: Lu(k, u)
    }));
    const v = ge(l, "renderText", h);
    return v && (f.toText = v), [l.name, f];
  })), c = Object.fromEntries(i.map((l) => {
    const u = r.filter((v) => v.type === l.name), h = {
      name: l.name,
      options: l.options,
      storage: l.storage,
      editor: t
    }, p = e.reduce((v, k) => {
      const b = ge(k, "extendMarkSchema", h);
      return {
        ...v,
        ...b ? b(l) : {}
      };
    }, {}), f = Df({
      ...p,
      inclusive: Ee(ge(l, "inclusive", h)),
      excludes: Ee(ge(l, "excludes", h)),
      group: Ee(ge(l, "group", h)),
      spanning: Ee(ge(l, "spanning", h)),
      code: Ee(ge(l, "code", h)),
      attrs: Object.fromEntries(u.map((v) => {
        var k;
        return [v.name, { default: (k = v == null ? void 0 : v.attribute) === null || k === void 0 ? void 0 : k.default }];
      }))
    }), y = Ee(ge(l, "parseHTML", h));
    y && (f.parseDOM = y.map((v) => If(v, u)));
    const m = ge(l, "renderHTML", h);
    return m && (f.toDOM = (v) => m({
      mark: v,
      HTMLAttributes: Lu(v, u)
    })), [l.name, f];
  }));
  return new h7({
    topNode: o,
    nodes: s,
    marks: c
  });
}
function vd(e, t) {
  return t.nodes[e] || t.marks[e] || null;
}
function Tf(e, t) {
  return Array.isArray(t) ? t.some((n) => (typeof n == "string" ? n : n.name) === e.name) : t;
}
const dC = (e, t = 500) => {
  let n = "";
  const r = e.parentOffset;
  return e.parent.nodesBetween(Math.max(0, r - t), r, (a, i, o, s) => {
    var c, l;
    const u = ((l = (c = a.type.spec).toText) === null || l === void 0 ? void 0 : l.call(c, {
      node: a,
      pos: i,
      parent: o,
      index: s
    })) || a.textContent || "%leaf%";
    n += u.slice(0, Math.max(0, r - i));
  }), n;
};
function mp(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
class s1 {
  constructor(t) {
    this.find = t.find, this.handler = t.handler;
  }
}
const uC = (e, t) => {
  if (mp(t))
    return t.exec(e);
  const n = t(e);
  if (!n)
    return null;
  const r = [n.text];
  return r.index = n.index, r.input = e, r.data = n.data, n.replaceWith && (n.text.includes(n.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(n.replaceWith)), r;
};
function Ts(e) {
  var t;
  const { editor: n, from: r, to: a, text: i, rules: o, plugin: s } = e, { view: c } = n;
  if (c.composing)
    return !1;
  const l = c.state.doc.resolve(r);
  if (
    // check for code node
    l.parent.type.spec.code || !((t = l.nodeBefore || l.nodeAfter) === null || t === void 0) && t.marks.find((p) => p.type.spec.code)
  )
    return !1;
  let u = !1;
  const h = dC(l) + i;
  return o.forEach((p) => {
    if (u)
      return;
    const f = uC(h, p.find);
    if (!f)
      return;
    const y = c.state.tr, m = a1({
      state: c.state,
      transaction: y
    }), v = {
      from: r - (f[0].length - i.length),
      to: a
    }, { commands: k, chain: b, can: x } = new i1({
      editor: n,
      state: m
    });
    p.handler({
      state: m,
      range: v,
      match: f,
      commands: k,
      chain: b,
      can: x
    }) === null || !y.steps.length || (y.setMeta(s, {
      transform: y,
      from: r,
      to: a,
      text: i
    }), c.dispatch(y), u = !0);
  }), u;
}
function hC(e) {
  const { editor: t, rules: n } = e, r = new At({
    state: {
      init() {
        return null;
      },
      apply(a, i) {
        const o = a.getMeta(r);
        if (o)
          return o;
        const s = a.getMeta("applyInputRules");
        return !!s && setTimeout(() => {
          const { from: l, text: u } = s, h = l + u.length;
          Ts({
            editor: t,
            from: l,
            to: h,
            text: u,
            rules: n,
            plugin: r
          });
        }), a.selectionSet || a.docChanged ? null : i;
      }
    },
    props: {
      handleTextInput(a, i, o, s) {
        return Ts({
          editor: t,
          from: i,
          to: o,
          text: s,
          rules: n,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (a) => (setTimeout(() => {
          const { $cursor: i } = a.state.selection;
          i && Ts({
            editor: t,
            from: i.pos,
            to: i.pos,
            text: "",
            rules: n,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(a, i) {
        if (i.key !== "Enter")
          return !1;
        const { $cursor: o } = a.state.selection;
        return o ? Ts({
          editor: t,
          from: o.pos,
          to: o.pos,
          text: `
`,
          rules: n,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function pC(e) {
  return typeof e == "number";
}
class fC {
  constructor(t) {
    this.find = t.find, this.handler = t.handler;
  }
}
const yC = (e, t, n) => {
  if (mp(t))
    return [...e.matchAll(t)];
  const r = t(e, n);
  return r ? r.map((a) => {
    const i = [a.text];
    return i.index = a.index, i.input = e, i.data = a.data, a.replaceWith && (a.text.includes(a.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), i.push(a.replaceWith)), i;
  }) : [];
};
function mC(e) {
  const { editor: t, state: n, from: r, to: a, rule: i, pasteEvent: o, dropEvent: s } = e, { commands: c, chain: l, can: u } = new i1({
    editor: t,
    state: n
  }), h = [];
  return n.doc.nodesBetween(r, a, (f, y) => {
    if (!f.isTextblock || f.type.spec.code)
      return;
    const m = Math.max(r, y), v = Math.min(a, y + f.content.size), k = f.textBetween(m - y, v - y, void 0, "￼");
    yC(k, i.find, o).forEach((x) => {
      if (x.index === void 0)
        return;
      const g = m + x.index + 1, w = g + x[0].length, M = {
        from: n.tr.mapping.map(g),
        to: n.tr.mapping.map(w)
      }, S = i.handler({
        state: n,
        range: M,
        match: x,
        commands: c,
        chain: l,
        can: u,
        pasteEvent: o,
        dropEvent: s
      });
      h.push(S);
    });
  }), h.every((f) => f !== null);
}
const gC = (e) => {
  var t;
  const n = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (t = n.clipboardData) === null || t === void 0 || t.setData("text/html", e), n;
};
function vC(e) {
  const { editor: t, rules: n } = e;
  let r = null, a = !1, i = !1, o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, s = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  const c = ({ state: u, from: h, to: p, rule: f, pasteEvt: y }) => {
    const m = u.tr, v = a1({
      state: u,
      transaction: m
    });
    if (!(!mC({
      editor: t,
      state: v,
      from: Math.max(h - 1, 0),
      to: p.b - 1,
      rule: f,
      pasteEvent: y,
      dropEvent: s
    }) || !m.steps.length))
      return s = typeof DragEvent < "u" ? new DragEvent("drop") : null, o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, m;
  };
  return n.map((u) => new At({
    // we register a global drag handler to track the current drag source element
    view(h) {
      const p = (f) => {
        var y;
        r = !((y = h.dom.parentElement) === null || y === void 0) && y.contains(f.target) ? h.dom.parentElement : null;
      };
      return window.addEventListener("dragstart", p), {
        destroy() {
          window.removeEventListener("dragstart", p);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (h, p) => (i = r === h.dom.parentElement, s = p, !1),
        paste: (h, p) => {
          var f;
          const y = (f = p.clipboardData) === null || f === void 0 ? void 0 : f.getData("text/html");
          return o = p, a = !!(y != null && y.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (h, p, f) => {
      const y = h[0], m = y.getMeta("uiEvent") === "paste" && !a, v = y.getMeta("uiEvent") === "drop" && !i, k = y.getMeta("applyPasteRules"), b = !!k;
      if (!m && !v && !b)
        return;
      if (b) {
        const { from: w, text: M } = k, S = w + M.length, D = gC(M);
        return c({
          rule: u,
          state: f,
          from: w,
          to: { b: S },
          pasteEvt: D
        });
      }
      const x = p.doc.content.findDiffStart(f.doc.content), g = p.doc.content.findDiffEnd(f.doc.content);
      if (!(!pC(x) || !g || x === g.b))
        return c({
          rule: u,
          state: f,
          from: x,
          to: g,
          pasteEvt: o
        });
    }
  }));
}
function kC(e) {
  const t = e.filter((n, r) => e.indexOf(n) !== r);
  return [...new Set(t)];
}
class Za {
  constructor(t, n) {
    this.splittableMarks = [], this.editor = n, this.extensions = Za.resolve(t), this.schema = lC(this.extensions, n), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(t) {
    const n = Za.sort(Za.flatten(t)), r = kC(n.map((a) => a.name));
    return r.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${r.map((a) => `'${a}'`).join(", ")}]. This can lead to issues.`), n;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(t) {
    return t.map((n) => {
      const r = {
        name: n.name,
        options: n.options,
        storage: n.storage
      }, a = ge(n, "addExtensions", r);
      return a ? [n, ...this.flatten(a())] : n;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(t) {
    return t.sort((r, a) => {
      const i = ge(r, "priority") || 100, o = ge(a, "priority") || 100;
      return i > o ? -1 : i < o ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((t, n) => {
      const r = {
        name: n.name,
        options: n.options,
        storage: n.storage,
        editor: this.editor,
        type: vd(n.name, this.schema)
      }, a = ge(n, "addCommands", r);
      return a ? {
        ...t,
        ...a()
      } : t;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: t } = this, n = Za.sort([...this.extensions].reverse()), r = [], a = [], i = n.map((o) => {
      const s = {
        name: o.name,
        options: o.options,
        storage: o.storage,
        editor: t,
        type: vd(o.name, this.schema)
      }, c = [], l = ge(o, "addKeyboardShortcuts", s);
      let u = {};
      if (o.type === "mark" && o.config.exitable && (u.ArrowRight = () => Qt.handleExit({ editor: t, mark: o })), l) {
        const m = Object.fromEntries(Object.entries(l()).map(([v, k]) => [v, () => k({ editor: t })]));
        u = { ...u, ...m };
      }
      const h = L9(u);
      c.push(h);
      const p = ge(o, "addInputRules", s);
      Tf(o, t.options.enableInputRules) && p && r.push(...p());
      const f = ge(o, "addPasteRules", s);
      Tf(o, t.options.enablePasteRules) && f && a.push(...f());
      const y = ge(o, "addProseMirrorPlugins", s);
      if (y) {
        const m = y();
        c.push(...m);
      }
      return c;
    }).flat();
    return [
      hC({
        editor: t,
        rules: r
      }),
      ...vC({
        editor: t,
        rules: a
      }),
      ...i
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return Xk(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: t } = this, { nodeExtensions: n } = o1(this.extensions);
    return Object.fromEntries(n.filter((r) => !!ge(r, "addNodeView")).map((r) => {
      const a = this.attributes.filter((c) => c.type === r.name), i = {
        name: r.name,
        options: r.options,
        storage: r.storage,
        editor: t,
        type: dt(r.name, this.schema)
      }, o = ge(r, "addNodeView", i);
      if (!o)
        return [];
      const s = (c, l, u, h) => {
        const p = Lu(c, a);
        return o()({
          editor: t,
          node: c,
          getPos: u,
          decorations: h,
          HTMLAttributes: p,
          extension: r
        });
      };
      return [r.name, s];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((t) => {
      var n;
      this.editor.extensionStorage[t.name] = t.storage;
      const r = {
        name: t.name,
        options: t.options,
        storage: t.storage,
        editor: this.editor,
        type: vd(t.name, this.schema)
      };
      t.type === "mark" && (!((n = Ee(ge(t, "keepOnSplit", r))) !== null && n !== void 0) || n) && this.splittableMarks.push(t.name);
      const a = ge(t, "onBeforeCreate", r), i = ge(t, "onCreate", r), o = ge(t, "onUpdate", r), s = ge(t, "onSelectionUpdate", r), c = ge(t, "onTransaction", r), l = ge(t, "onFocus", r), u = ge(t, "onBlur", r), h = ge(t, "onDestroy", r);
      a && this.editor.on("beforeCreate", a), i && this.editor.on("create", i), o && this.editor.on("update", o), s && this.editor.on("selectionUpdate", s), c && this.editor.on("transaction", c), l && this.editor.on("focus", l), u && this.editor.on("blur", u), h && this.editor.on("destroy", h);
    });
  }
}
function bC(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function kd(e) {
  return bC(e) !== "Object" ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
function c1(e, t) {
  const n = { ...e };
  return kd(e) && kd(t) && Object.keys(t).forEach((r) => {
    kd(t[r]) ? r in e ? n[r] = c1(e[r], t[r]) : Object.assign(n, { [r]: t[r] }) : Object.assign(n, { [r]: t[r] });
  }), n;
}
class kt {
  constructor(t = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ee(ge(this, "addOptions", {
      name: this.name
    }))), this.storage = Ee(ge(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new kt(t);
  }
  configure(t = {}) {
    const n = this.extend();
    return n.parent = this.parent, n.options = c1(this.options, t), n.storage = Ee(ge(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  extend(t = {}) {
    const n = new kt({ ...this.config, ...t });
    return n.parent = this, this.child = n, n.name = t.name ? t.name : n.parent.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Ee(ge(n, "addOptions", {
      name: n.name
    })), n.storage = Ee(ge(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
}
function Yk(e, t, n) {
  const { from: r, to: a } = t, { blockSeparator: i = `

`, textSerializers: o = {} } = n || {};
  let s = "";
  return e.nodesBetween(r, a, (c, l, u, h) => {
    var p;
    c.isBlock && l > r && (s += i);
    const f = o == null ? void 0 : o[c.type.name];
    if (f)
      return u && (s += f({
        node: c,
        pos: l,
        parent: u,
        index: h,
        range: t
      })), !1;
    c.isText && (s += (p = c == null ? void 0 : c.text) === null || p === void 0 ? void 0 : p.slice(Math.max(r, l) - l, a - l));
  }), s;
}
function Jk(e) {
  return Object.fromEntries(Object.entries(e.nodes).filter(([, t]) => t.spec.toText).map(([t, n]) => [t, n.spec.toText]));
}
const xC = kt.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new At({
        key: new nn("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: e } = this, { state: t, schema: n } = e, { doc: r, selection: a } = t, { ranges: i } = a, o = Math.min(...i.map((u) => u.$from.pos)), s = Math.max(...i.map((u) => u.$to.pos)), c = Jk(n);
            return Yk(r, { from: o, to: s }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: c
            });
          }
        }
      })
    ];
  }
}), MC = () => ({ editor: e, view: t }) => (requestAnimationFrame(() => {
  var n;
  e.isDestroyed || (t.dom.blur(), (n = window == null ? void 0 : window.getSelection()) === null || n === void 0 || n.removeAllRanges());
}), !0), wC = (e = !1) => ({ commands: t }) => t.setContent("", e), CC = () => ({ state: e, tr: t, dispatch: n }) => {
  const { selection: r } = t, { ranges: a } = r;
  return n && a.forEach(({ $from: i, $to: o }) => {
    e.doc.nodesBetween(i.pos, o.pos, (s, c) => {
      if (s.type.isText)
        return;
      const { doc: l, mapping: u } = t, h = l.resolve(u.map(c)), p = l.resolve(u.map(c + s.nodeSize)), f = h.blockRange(p);
      if (!f)
        return;
      const y = Ei(f);
      if (s.type.isTextblock) {
        const { defaultType: m } = h.parent.contentMatchAt(h.index());
        t.setNodeMarkup(f.start, m);
      }
      (y || y === 0) && t.lift(f, y);
    });
  }), !0;
}, SC = (e) => (t) => e(t), AC = () => ({ state: e, dispatch: t }) => Z9(e, t), OC = (e, t) => ({ editor: n, tr: r }) => {
  const { state: a } = n, i = a.doc.slice(e.from, e.to);
  r.deleteRange(e.from, e.to);
  const o = r.mapping.map(t);
  return r.insert(o, i.content), r.setSelection(new De(r.doc.resolve(o - 1))), !0;
}, EC = () => ({ tr: e, dispatch: t }) => {
  const { selection: n } = e, r = n.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const a = e.selection.$anchor;
  for (let i = a.depth; i > 0; i -= 1)
    if (a.node(i).type === r.type) {
      if (t) {
        const s = a.before(i), c = a.after(i);
        e.delete(s, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, IC = (e) => ({ tr: t, state: n, dispatch: r }) => {
  const a = dt(e, n.schema), i = t.selection.$anchor;
  for (let o = i.depth; o > 0; o -= 1)
    if (i.node(o).type === a) {
      if (r) {
        const c = i.before(o), l = i.after(o);
        t.delete(c, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, DC = (e) => ({ tr: t, dispatch: n }) => {
  const { from: r, to: a } = e;
  return n && t.delete(r, a), !0;
}, TC = () => ({ state: e, dispatch: t }) => R9(e, t), NC = () => ({ commands: e }) => e.keyboardShortcut("Enter"), PC = () => ({ state: e, dispatch: t }) => G9(e, t);
function $c(e, t, n = { strict: !0 }) {
  const r = Object.keys(t);
  return r.length ? r.every((a) => n.strict ? t[a] === e[a] : mp(t[a]) ? t[a].test(e[a]) : t[a] === e[a]) : !0;
}
function Ru(e, t, n = {}) {
  return e.find((r) => r.type === t && $c(r.attrs, n));
}
function LC(e, t, n = {}) {
  return !!Ru(e, t, n);
}
function gp(e, t, n = {}) {
  if (!e || !t)
    return;
  let r = e.parent.childAfter(e.parentOffset);
  if (e.parentOffset === r.offset && r.offset !== 0 && (r = e.parent.childBefore(e.parentOffset)), !r.node)
    return;
  const a = Ru([...r.node.marks], t, n);
  if (!a)
    return;
  let i = r.index, o = e.start() + r.offset, s = i + 1, c = o + r.node.nodeSize;
  for (Ru([...r.node.marks], t, n); i > 0 && a.isInSet(e.parent.child(i - 1).marks); )
    i -= 1, o -= e.parent.child(i).nodeSize;
  for (; s < e.parent.childCount && LC([...e.parent.child(s).marks], t, n); )
    c += e.parent.child(s).nodeSize, s += 1;
  return {
    from: o,
    to: c
  };
}
function Vr(e, t) {
  if (typeof e == "string") {
    if (!t.marks[e])
      throw Error(`There is no mark type named '${e}'. Maybe you forgot to add the extension?`);
    return t.marks[e];
  }
  return e;
}
const RC = (e, t = {}) => ({ tr: n, state: r, dispatch: a }) => {
  const i = Vr(e, r.schema), { doc: o, selection: s } = n, { $from: c, from: l, to: u } = s;
  if (a) {
    const h = gp(c, i, t);
    if (h && h.from <= l && h.to >= u) {
      const p = De.create(o, h.from, h.to);
      n.setSelection(p);
    }
  }
  return !0;
}, VC = (e) => (t) => {
  const n = typeof e == "function" ? e(t) : e;
  for (let r = 0; r < n.length; r += 1)
    if (n[r](t))
      return !0;
  return !1;
};
function l1(e) {
  return e instanceof De;
}
function tr(e = 0, t = 0, n = 0) {
  return Math.min(Math.max(e, t), n);
}
function Kk(e, t = null) {
  if (!t)
    return null;
  const n = Ie.atStart(e), r = Ie.atEnd(e);
  if (t === "start" || t === !0)
    return n;
  if (t === "end")
    return r;
  const a = n.from, i = r.to;
  return t === "all" ? De.create(e, tr(0, a, i), tr(e.content.size, a, i)) : De.create(e, tr(t, a, i), tr(t, a, i));
}
function d1() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const zC = (e = null, t = {}) => ({ editor: n, view: r, tr: a, dispatch: i }) => {
  t = {
    scrollIntoView: !0,
    ...t
  };
  const o = () => {
    d1() && r.dom.focus(), requestAnimationFrame(() => {
      n.isDestroyed || (r.focus(), t != null && t.scrollIntoView && n.commands.scrollIntoView());
    });
  };
  if (r.hasFocus() && e === null || e === !1)
    return !0;
  if (i && e === null && !l1(n.state.selection))
    return o(), !0;
  const s = Kk(a.doc, e) || n.state.selection, c = n.state.selection.eq(s);
  return i && (c || a.setSelection(s), c && a.storedMarks && a.setStoredMarks(a.storedMarks), o()), !0;
}, BC = (e, t) => (n) => e.every((r, a) => t(r, { ...n, index: a })), HC = (e, t) => ({ tr: n, commands: r }) => r.insertContentAt({ from: n.selection.from, to: n.selection.to }, e, t), Qk = (e) => {
  const t = e.childNodes;
  for (let n = t.length - 1; n >= 0; n -= 1) {
    const r = t[n];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? e.removeChild(r) : r.nodeType === 1 && Qk(r);
  }
  return e;
};
function Nf(e) {
  const t = `<body>${e}</body>`, n = new window.DOMParser().parseFromString(t, "text/html").body;
  return Qk(n);
}
function jc(e, t, n) {
  n = {
    slice: !0,
    parseOptions: {},
    ...n
  };
  const r = typeof e == "object" && e !== null, a = typeof e == "string";
  if (r)
    try {
      return Array.isArray(e) && e.length > 0 ? oe.fromArray(e.map((o) => t.nodeFromJSON(o))) : t.nodeFromJSON(e);
    } catch (i) {
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", e, "Error:", i), jc("", t, n);
    }
  if (a) {
    const i = oi.fromSchema(t);
    return n.slice ? i.parseSlice(Nf(e), n.parseOptions).content : i.parse(Nf(e), n.parseOptions);
  }
  return jc("", t, n);
}
function $C(e, t, n) {
  const r = e.steps.length - 1;
  if (r < t)
    return;
  const a = e.steps[r];
  if (!(a instanceof ct || a instanceof lt))
    return;
  const i = e.mapping.maps[r];
  let o = 0;
  i.forEach((s, c, l, u) => {
    o === 0 && (o = u);
  }), e.setSelection(Ie.near(e.doc.resolve(o), n));
}
const jC = (e) => e.toString().startsWith("<"), FC = (e, t, n) => ({ tr: r, dispatch: a, editor: i }) => {
  if (a) {
    n = {
      parseOptions: {},
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...n
    };
    const o = jc(t, i.schema, {
      parseOptions: {
        preserveWhitespace: "full",
        ...n.parseOptions
      }
    });
    if (o.toString() === "<>")
      return !0;
    let { from: s, to: c } = typeof e == "number" ? { from: e, to: e } : { from: e.from, to: e.to }, l = !0, u = !0;
    if ((jC(o) ? o : [o]).forEach((f) => {
      f.check(), l = l ? f.isText && f.marks.length === 0 : !1, u = u ? f.isBlock : !1;
    }), s === c && u) {
      const { parent: f } = r.doc.resolve(s);
      f.isTextblock && !f.type.spec.code && !f.childCount && (s -= 1, c += 1);
    }
    let p;
    l ? (Array.isArray(t) ? p = t.map((f) => f.text || "").join("") : typeof t == "object" && t && t.text ? p = t.text : p = t, r.insertText(p, s, c)) : (p = o, r.replaceWith(s, c, p)), n.updateSelection && $C(r, r.steps.length - 1, -1), n.applyInputRules && r.setMeta("applyInputRules", { from: s, text: p }), n.applyPasteRules && r.setMeta("applyPasteRules", { from: s, text: p });
  }
  return !0;
}, WC = () => ({ state: e, dispatch: t }) => F9(e, t), qC = () => ({ state: e, dispatch: t }) => W9(e, t), _C = () => ({ state: e, dispatch: t }) => V9(e, t), GC = () => ({ state: e, dispatch: t }) => $9(e, t), ZC = () => ({ tr: e, state: t, dispatch: n }) => {
  try {
    const r = Kl(t.doc, t.selection.$from.pos, -1);
    return r == null ? !1 : (e.join(r, 2), n && n(e), !0);
  } catch {
    return !1;
  }
}, XC = () => ({ state: e, dispatch: t, tr: n }) => {
  try {
    const r = Kl(e.doc, e.selection.$from.pos, 1);
    return r == null ? !1 : (n.join(r, 2), t && t(n), !0);
  } catch {
    return !1;
  }
}, UC = () => ({ state: e, dispatch: t }) => z9(e, t), YC = () => ({ state: e, dispatch: t }) => B9(e, t);
function e4() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function JC(e) {
  const t = e.split(/-(?!$)/);
  let n = t[t.length - 1];
  n === "Space" && (n = " ");
  let r, a, i, o;
  for (let s = 0; s < t.length - 1; s += 1) {
    const c = t[s];
    if (/^(cmd|meta|m)$/i.test(c))
      o = !0;
    else if (/^a(lt)?$/i.test(c))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      a = !0;
    else if (/^s(hift)?$/i.test(c))
      i = !0;
    else if (/^mod$/i.test(c))
      d1() || e4() ? o = !0 : a = !0;
    else
      throw new Error(`Unrecognized modifier name: ${c}`);
  }
  return r && (n = `Alt-${n}`), a && (n = `Ctrl-${n}`), o && (n = `Meta-${n}`), i && (n = `Shift-${n}`), n;
}
const KC = (e) => ({ editor: t, view: n, tr: r, dispatch: a }) => {
  const i = JC(e).split(/-(?!$)/), o = i.find((l) => !["Alt", "Ctrl", "Meta", "Shift"].includes(l)), s = new KeyboardEvent("keydown", {
    key: o === "Space" ? " " : o,
    altKey: i.includes("Alt"),
    ctrlKey: i.includes("Ctrl"),
    metaKey: i.includes("Meta"),
    shiftKey: i.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), c = t.captureTransaction(() => {
    n.someProp("handleKeyDown", (l) => l(n, s));
  });
  return c == null || c.steps.forEach((l) => {
    const u = l.map(r.mapping);
    u && a && r.maybeStep(u);
  }), !0;
};
function Mo(e, t, n = {}) {
  const { from: r, to: a, empty: i } = e.selection, o = t ? dt(t, e.schema) : null, s = [];
  e.doc.nodesBetween(r, a, (h, p) => {
    if (h.isText)
      return;
    const f = Math.max(r, p), y = Math.min(a, p + h.nodeSize);
    s.push({
      node: h,
      from: f,
      to: y
    });
  });
  const c = a - r, l = s.filter((h) => o ? o.name === h.node.type.name : !0).filter((h) => $c(h.node.attrs, n, { strict: !1 }));
  return i ? !!l.length : l.reduce((h, p) => h + p.to - p.from, 0) >= c;
}
const QC = (e, t = {}) => ({ state: n, dispatch: r }) => {
  const a = dt(e, n.schema);
  return Mo(n, a, t) ? q9(n, r) : !1;
}, eS = () => ({ state: e, dispatch: t }) => X9(e, t), tS = (e) => ({ state: t, dispatch: n }) => {
  const r = dt(e, t.schema);
  return nC(r)(t, n);
}, nS = () => ({ state: e, dispatch: t }) => _9(e, t);
function u1(e, t) {
  return t.nodes[e] ? "node" : t.marks[e] ? "mark" : null;
}
function Pf(e, t) {
  const n = typeof t == "string" ? [t] : t;
  return Object.keys(e).reduce((r, a) => (n.includes(a) || (r[a] = e[a]), r), {});
}
const rS = (e, t) => ({ tr: n, state: r, dispatch: a }) => {
  let i = null, o = null;
  const s = u1(typeof e == "string" ? e : e.name, r.schema);
  return s ? (s === "node" && (i = dt(e, r.schema)), s === "mark" && (o = Vr(e, r.schema)), a && n.selection.ranges.forEach((c) => {
    r.doc.nodesBetween(c.$from.pos, c.$to.pos, (l, u) => {
      i && i === l.type && n.setNodeMarkup(u, void 0, Pf(l.attrs, t)), o && l.marks.length && l.marks.forEach((h) => {
        o === h.type && n.addMark(u, u + l.nodeSize, o.create(Pf(h.attrs, t)));
      });
    });
  }), !0) : !1;
}, aS = () => ({ tr: e, dispatch: t }) => (t && e.scrollIntoView(), !0), iS = () => ({ tr: e, commands: t }) => t.setTextSelection({
  from: 0,
  to: e.doc.content.size
}), oS = () => ({ state: e, dispatch: t }) => H9(e, t), sS = () => ({ state: e, dispatch: t }) => j9(e, t), cS = () => ({ state: e, dispatch: t }) => U9(e, t), lS = () => ({ state: e, dispatch: t }) => K9(e, t), dS = () => ({ state: e, dispatch: t }) => J9(e, t);
function t4(e, t, n = {}) {
  return jc(e, t, { slice: !1, parseOptions: n });
}
const uS = (e, t = !1, n = {}) => ({ tr: r, editor: a, dispatch: i }) => {
  const { doc: o } = r, s = t4(e, a.schema, n);
  return i && r.replaceWith(0, o.content.size, s).setMeta("preventUpdate", !t), !0;
};
function rs(e, t) {
  const n = Vr(t, e.schema), { from: r, to: a, empty: i } = e.selection, o = [];
  i ? (e.storedMarks && o.push(...e.storedMarks), o.push(...e.selection.$head.marks())) : e.doc.nodesBetween(r, a, (c) => {
    o.push(...c.marks);
  });
  const s = o.find((c) => c.type.name === n.name);
  return s ? { ...s.attrs } : {};
}
function hS(e, t) {
  const n = new ik(e);
  return t.forEach((r) => {
    r.steps.forEach((a) => {
      n.step(a);
    });
  }), n;
}
function pS(e) {
  for (let t = 0; t < e.edgeCount; t += 1) {
    const { type: n } = e.edge(t);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
function fS(e, t, n) {
  const r = [];
  return e.nodesBetween(t.from, t.to, (a, i) => {
    n(a) && r.push({
      node: a,
      pos: i
    });
  }), r;
}
function yS(e, t) {
  for (let n = e.depth; n > 0; n -= 1) {
    const r = e.node(n);
    if (t(r))
      return {
        pos: n > 0 ? e.before(n) : 0,
        start: e.start(n),
        depth: n,
        node: r
      };
  }
}
function vp(e) {
  return (t) => yS(t.$from, e);
}
function mS(e, t) {
  const n = Rn.fromSchema(t).serializeFragment(e), a = document.implementation.createHTMLDocument().createElement("div");
  return a.appendChild(n), a.innerHTML;
}
function gS(e, t) {
  const n = {
    from: 0,
    to: e.content.size
  };
  return Yk(e, n, t);
}
function vS(e, t) {
  const n = dt(t, e.schema), { from: r, to: a } = e.selection, i = [];
  e.doc.nodesBetween(r, a, (s) => {
    i.push(s);
  });
  const o = i.reverse().find((s) => s.type.name === n.name);
  return o ? { ...o.attrs } : {};
}
function n4(e, t) {
  const n = u1(typeof t == "string" ? t : t.name, e.schema);
  return n === "node" ? vS(e, t) : n === "mark" ? rs(e, t) : {};
}
function kS(e, t = JSON.stringify) {
  const n = {};
  return e.filter((r) => {
    const a = t(r);
    return Object.prototype.hasOwnProperty.call(n, a) ? !1 : n[a] = !0;
  });
}
function bS(e) {
  const t = kS(e);
  return t.length === 1 ? t : t.filter((n, r) => !t.filter((i, o) => o !== r).some((i) => n.oldRange.from >= i.oldRange.from && n.oldRange.to <= i.oldRange.to && n.newRange.from >= i.newRange.from && n.newRange.to <= i.newRange.to));
}
function xS(e) {
  const { mapping: t, steps: n } = e, r = [];
  return t.maps.forEach((a, i) => {
    const o = [];
    if (a.ranges.length)
      a.forEach((s, c) => {
        o.push({ from: s, to: c });
      });
    else {
      const { from: s, to: c } = n[i];
      if (s === void 0 || c === void 0)
        return;
      o.push({ from: s, to: c });
    }
    o.forEach(({ from: s, to: c }) => {
      const l = t.slice(i).map(s, -1), u = t.slice(i).map(c), h = t.invert().map(l, -1), p = t.invert().map(u);
      r.push({
        oldRange: {
          from: h,
          to: p
        },
        newRange: {
          from: l,
          to: u
        }
      });
    });
  }), bS(r);
}
function kp(e, t, n) {
  const r = [];
  return e === t ? n.resolve(e).marks().forEach((a) => {
    const i = n.resolve(e - 1), o = gp(i, a.type);
    o && r.push({
      mark: a,
      ...o
    });
  }) : n.nodesBetween(e, t, (a, i) => {
    !a || (a == null ? void 0 : a.nodeSize) === void 0 || r.push(...a.marks.map((o) => ({
      from: i,
      to: i + a.nodeSize,
      mark: o
    })));
  }), r;
}
function ic(e, t, n) {
  return Object.fromEntries(Object.entries(n).filter(([r]) => {
    const a = e.find((i) => i.type === t && i.name === r);
    return a ? a.attribute.keepOnSplit : !1;
  }));
}
function Vu(e, t, n = {}) {
  const { empty: r, ranges: a } = e.selection, i = t ? Vr(t, e.schema) : null;
  if (r)
    return !!(e.storedMarks || e.selection.$from.marks()).filter((h) => i ? i.name === h.type.name : !0).find((h) => $c(h.attrs, n, { strict: !1 }));
  let o = 0;
  const s = [];
  if (a.forEach(({ $from: h, $to: p }) => {
    const f = h.pos, y = p.pos;
    e.doc.nodesBetween(f, y, (m, v) => {
      if (!m.isText && !m.marks.length)
        return;
      const k = Math.max(f, v), b = Math.min(y, v + m.nodeSize), x = b - k;
      o += x, s.push(...m.marks.map((g) => ({
        mark: g,
        from: k,
        to: b
      })));
    });
  }), o === 0)
    return !1;
  const c = s.filter((h) => i ? i.name === h.mark.type.name : !0).filter((h) => $c(h.mark.attrs, n, { strict: !1 })).reduce((h, p) => h + p.to - p.from, 0), l = s.filter((h) => i ? h.mark.type !== i && h.mark.type.excludes(i) : !0).reduce((h, p) => h + p.to - p.from, 0);
  return (c > 0 ? c + l : c) >= o;
}
function MS(e, t, n = {}) {
  if (!t)
    return Mo(e, null, n) || Vu(e, null, n);
  const r = u1(t, e.schema);
  return r === "node" ? Mo(e, t, n) : r === "mark" ? Vu(e, t, n) : !1;
}
function Lf(e, t) {
  const { nodeExtensions: n } = o1(t), r = n.find((o) => o.name === e);
  if (!r)
    return !1;
  const a = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, i = Ee(ge(r, "group", a));
  return typeof i != "string" ? !1 : i.split(" ").includes("list");
}
function wS(e) {
  var t;
  const n = (t = e.type.createAndFill()) === null || t === void 0 ? void 0 : t.toJSON(), r = e.toJSON();
  return JSON.stringify(n) === JSON.stringify(r);
}
function CS(e) {
  return e instanceof xe;
}
function SS(e, t, n) {
  const a = e.state.doc.content.size, i = tr(t, 0, a), o = tr(n, 0, a), s = e.coordsAtPos(i), c = e.coordsAtPos(o, -1), l = Math.min(s.top, c.top), u = Math.max(s.bottom, c.bottom), h = Math.min(s.left, c.left), p = Math.max(s.right, c.right), f = p - h, y = u - l, k = {
    top: l,
    bottom: u,
    left: h,
    right: p,
    width: f,
    height: y,
    x: h,
    y: l
  };
  return {
    ...k,
    toJSON: () => k
  };
}
function AS(e, t, n) {
  var r;
  const { selection: a } = t;
  let i = null;
  if (l1(a) && (i = a.$cursor), i) {
    const s = (r = e.storedMarks) !== null && r !== void 0 ? r : i.marks();
    return !!n.isInSet(s) || !s.some((c) => c.type.excludes(n));
  }
  const { ranges: o } = a;
  return o.some(({ $from: s, $to: c }) => {
    let l = s.depth === 0 ? e.doc.inlineContent && e.doc.type.allowsMarkType(n) : !1;
    return e.doc.nodesBetween(s.pos, c.pos, (u, h, p) => {
      if (l)
        return !1;
      if (u.isInline) {
        const f = !p || p.type.allowsMarkType(n), y = !!n.isInSet(u.marks) || !u.marks.some((m) => m.type.excludes(n));
        l = f && y;
      }
      return !l;
    }), l;
  });
}
const OS = (e, t = {}) => ({ tr: n, state: r, dispatch: a }) => {
  const { selection: i } = n, { empty: o, ranges: s } = i, c = Vr(e, r.schema);
  if (a)
    if (o) {
      const l = rs(r, c);
      n.addStoredMark(c.create({
        ...l,
        ...t
      }));
    } else
      s.forEach((l) => {
        const u = l.$from.pos, h = l.$to.pos;
        r.doc.nodesBetween(u, h, (p, f) => {
          const y = Math.max(f, u), m = Math.min(f + p.nodeSize, h);
          p.marks.find((k) => k.type === c) ? p.marks.forEach((k) => {
            c === k.type && n.addMark(y, m, c.create({
              ...k.attrs,
              ...t
            }));
          }) : n.addMark(y, m, c.create(t));
        });
      });
  return AS(r, n, c);
}, ES = (e, t) => ({ tr: n }) => (n.setMeta(e, t), !0), IS = (e, t = {}) => ({ state: n, dispatch: r, chain: a }) => {
  const i = dt(e, n.schema);
  return i.isTextblock ? a().command(({ commands: o }) => Ef(i, t)(n) ? !0 : o.clearNodes()).command(({ state: o }) => Ef(i, t)(o, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, DS = (e) => ({ tr: t, dispatch: n }) => {
  if (n) {
    const { doc: r } = t, a = tr(e, 0, r.content.size), i = xe.create(r, a);
    t.setSelection(i);
  }
  return !0;
}, TS = (e) => ({ tr: t, dispatch: n }) => {
  if (n) {
    const { doc: r } = t, { from: a, to: i } = typeof e == "number" ? { from: e, to: e } : e, o = De.atStart(r).from, s = De.atEnd(r).to, c = tr(a, o, s), l = tr(i, o, s), u = De.create(r, c, l);
    t.setSelection(u);
  }
  return !0;
}, NS = (e) => ({ state: t, dispatch: n }) => {
  const r = dt(e, t.schema);
  return iC(r)(t, n);
};
function Rf(e, t) {
  const n = e.storedMarks || e.selection.$to.parentOffset && e.selection.$from.marks();
  if (n) {
    const r = n.filter((a) => t == null ? void 0 : t.includes(a.type.name));
    e.tr.ensureMarks(r);
  }
}
const PS = ({ keepMarks: e = !0 } = {}) => ({ tr: t, state: n, dispatch: r, editor: a }) => {
  const { selection: i, doc: o } = t, { $from: s, $to: c } = i, l = a.extensionManager.attributes, u = ic(l, s.node().type.name, s.node().attrs);
  if (i instanceof xe && i.node.isBlock)
    return !s.parentOffset || !Ka(o, s.pos) ? !1 : (r && (e && Rf(n, a.extensionManager.splittableMarks), t.split(s.pos).scrollIntoView()), !0);
  if (!s.parent.isBlock)
    return !1;
  if (r) {
    const h = c.parentOffset === c.parent.content.size;
    i instanceof De && t.deleteSelection();
    const p = s.depth === 0 ? void 0 : pS(s.node(-1).contentMatchAt(s.indexAfter(-1)));
    let f = h && p ? [
      {
        type: p,
        attrs: u
      }
    ] : void 0, y = Ka(t.doc, t.mapping.map(s.pos), 1, f);
    if (!f && !y && Ka(t.doc, t.mapping.map(s.pos), 1, p ? [{ type: p }] : void 0) && (y = !0, f = p ? [
      {
        type: p,
        attrs: u
      }
    ] : void 0), y && (t.split(t.mapping.map(s.pos), 1, f), p && !h && !s.parentOffset && s.parent.type !== p)) {
      const m = t.mapping.map(s.before()), v = t.doc.resolve(m);
      s.node(-1).canReplaceWith(v.index(), v.index() + 1, p) && t.setNodeMarkup(t.mapping.map(s.before()), p);
    }
    e && Rf(n, a.extensionManager.splittableMarks), t.scrollIntoView();
  }
  return !0;
}, LS = (e) => ({ tr: t, state: n, dispatch: r, editor: a }) => {
  var i;
  const o = dt(e, n.schema), { $from: s, $to: c } = n.selection, l = n.selection.node;
  if (l && l.isBlock || s.depth < 2 || !s.sameParent(c))
    return !1;
  const u = s.node(-1);
  if (u.type !== o)
    return !1;
  const h = a.extensionManager.attributes;
  if (s.parent.content.size === 0 && s.node(-1).childCount === s.indexAfter(-1)) {
    if (s.depth === 2 || s.node(-3).type !== o || s.index(-2) !== s.node(-2).childCount - 1)
      return !1;
    if (r) {
      let v = oe.empty;
      const k = s.index(-1) ? 1 : s.index(-2) ? 2 : 3;
      for (let S = s.depth - k; S >= s.depth - 3; S -= 1)
        v = oe.from(s.node(S).copy(v));
      const b = s.indexAfter(-1) < s.node(-2).childCount ? 1 : s.indexAfter(-2) < s.node(-3).childCount ? 2 : 3, x = ic(h, s.node().type.name, s.node().attrs), g = ((i = o.contentMatch.defaultType) === null || i === void 0 ? void 0 : i.createAndFill(x)) || void 0;
      v = v.append(oe.from(o.createAndFill(null, g) || void 0));
      const w = s.before(s.depth - (k - 1));
      t.replace(w, s.after(-b), new ye(v, 4 - k, 0));
      let M = -1;
      t.doc.nodesBetween(w, t.doc.content.size, (S, D) => {
        if (M > -1)
          return !1;
        S.isTextblock && S.content.size === 0 && (M = D + 1);
      }), M > -1 && t.setSelection(De.near(t.doc.resolve(M))), t.scrollIntoView();
    }
    return !0;
  }
  const p = c.pos === s.end() ? u.contentMatchAt(0).defaultType : null, f = ic(h, u.type.name, u.attrs), y = ic(h, s.node().type.name, s.node().attrs);
  t.delete(s.pos, c.pos);
  const m = p ? [
    { type: o, attrs: f },
    { type: p, attrs: y }
  ] : [{ type: o, attrs: f }];
  if (!Ka(t.doc, s.pos, 2))
    return !1;
  if (r) {
    const { selection: v, storedMarks: k } = n, { splittableMarks: b } = a.extensionManager, x = k || v.$to.parentOffset && v.$from.marks();
    if (t.split(s.pos, 2, m).scrollIntoView(), !x || !r)
      return !0;
    const g = x.filter((w) => b.includes(w.type.name));
    t.ensureMarks(g);
  }
  return !0;
}, bd = (e, t) => {
  const n = vp((o) => o.type === t)(e.selection);
  if (!n)
    return !0;
  const r = e.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
  if (r === void 0)
    return !0;
  const a = e.doc.nodeAt(r);
  return n.node.type === (a == null ? void 0 : a.type) && Lr(e.doc, n.pos) && e.join(n.pos), !0;
}, xd = (e, t) => {
  const n = vp((o) => o.type === t)(e.selection);
  if (!n)
    return !0;
  const r = e.doc.resolve(n.start).after(n.depth);
  if (r === void 0)
    return !0;
  const a = e.doc.nodeAt(r);
  return n.node.type === (a == null ? void 0 : a.type) && Lr(e.doc, r) && e.join(r), !0;
}, RS = (e, t, n, r = {}) => ({ editor: a, tr: i, state: o, dispatch: s, chain: c, commands: l, can: u }) => {
  const { extensions: h, splittableMarks: p } = a.extensionManager, f = dt(e, o.schema), y = dt(t, o.schema), { selection: m, storedMarks: v } = o, { $from: k, $to: b } = m, x = k.blockRange(b), g = v || m.$to.parentOffset && m.$from.marks();
  if (!x)
    return !1;
  const w = vp((M) => Lf(M.type.name, h))(m);
  if (x.depth >= 1 && w && x.depth - w.depth <= 1) {
    if (w.node.type === f)
      return l.liftListItem(y);
    if (Lf(w.node.type.name, h) && f.validContent(w.node.content) && s)
      return c().command(() => (i.setNodeMarkup(w.pos, f), !0)).command(() => bd(i, f)).command(() => xd(i, f)).run();
  }
  return !n || !g || !s ? c().command(() => u().wrapInList(f, r) ? !0 : l.clearNodes()).wrapInList(f, r).command(() => bd(i, f)).command(() => xd(i, f)).run() : c().command(() => {
    const M = u().wrapInList(f, r), S = g.filter((D) => p.includes(D.type.name));
    return i.ensureMarks(S), M ? !0 : l.clearNodes();
  }).wrapInList(f, r).command(() => bd(i, f)).command(() => xd(i, f)).run();
}, VS = (e, t = {}, n = {}) => ({ state: r, commands: a }) => {
  const { extendEmptyMarkRange: i = !1 } = n, o = Vr(e, r.schema);
  return Vu(r, o, t) ? a.unsetMark(o, { extendEmptyMarkRange: i }) : a.setMark(o, t);
}, zS = (e, t, n = {}) => ({ state: r, commands: a }) => {
  const i = dt(e, r.schema), o = dt(t, r.schema);
  return Mo(r, i, n) ? a.setNode(o) : a.setNode(i, n);
}, BS = (e, t = {}) => ({ state: n, commands: r }) => {
  const a = dt(e, n.schema);
  return Mo(n, a, t) ? r.lift(a) : r.wrapIn(a, t);
}, HS = () => ({ state: e, dispatch: t }) => {
  const n = e.plugins;
  for (let r = 0; r < n.length; r += 1) {
    const a = n[r];
    let i;
    if (a.spec.isInputRules && (i = a.getState(e))) {
      if (t) {
        const o = e.tr, s = i.transform;
        for (let c = s.steps.length - 1; c >= 0; c -= 1)
          o.step(s.steps[c].invert(s.docs[c]));
        if (i.text) {
          const c = o.doc.resolve(i.from).marks();
          o.replaceWith(i.from, i.to, e.schema.text(i.text, c));
        } else
          o.delete(i.from, i.to);
      }
      return !0;
    }
  }
  return !1;
}, $S = () => ({ tr: e, dispatch: t }) => {
  const { selection: n } = e, { empty: r, ranges: a } = n;
  return r || t && a.forEach((i) => {
    e.removeMark(i.$from.pos, i.$to.pos);
  }), !0;
}, jS = (e, t = {}) => ({ tr: n, state: r, dispatch: a }) => {
  var i;
  const { extendEmptyMarkRange: o = !1 } = t, { selection: s } = n, c = Vr(e, r.schema), { $from: l, empty: u, ranges: h } = s;
  if (!a)
    return !0;
  if (u && o) {
    let { from: p, to: f } = s;
    const y = (i = l.marks().find((v) => v.type === c)) === null || i === void 0 ? void 0 : i.attrs, m = gp(l, c, y);
    m && (p = m.from, f = m.to), n.removeMark(p, f, c);
  } else
    h.forEach((p) => {
      n.removeMark(p.$from.pos, p.$to.pos, c);
    });
  return n.removeStoredMark(c), !0;
}, FS = (e, t = {}) => ({ tr: n, state: r, dispatch: a }) => {
  let i = null, o = null;
  const s = u1(typeof e == "string" ? e : e.name, r.schema);
  return s ? (s === "node" && (i = dt(e, r.schema)), s === "mark" && (o = Vr(e, r.schema)), a && n.selection.ranges.forEach((c) => {
    const l = c.$from.pos, u = c.$to.pos;
    r.doc.nodesBetween(l, u, (h, p) => {
      i && i === h.type && n.setNodeMarkup(p, void 0, {
        ...h.attrs,
        ...t
      }), o && h.marks.length && h.marks.forEach((f) => {
        if (o === f.type) {
          const y = Math.max(p, l), m = Math.min(p + h.nodeSize, u);
          n.addMark(y, m, o.create({
            ...f.attrs,
            ...t
          }));
        }
      });
    });
  }), !0) : !1;
}, WS = (e, t = {}) => ({ state: n, dispatch: r }) => {
  const a = dt(e, n.schema);
  return Q9(a, t)(n, r);
}, qS = (e, t = {}) => ({ state: n, dispatch: r }) => {
  const a = dt(e, n.schema);
  return eC(a, t)(n, r);
};
var _S = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: MC,
  clearContent: wC,
  clearNodes: CC,
  command: SC,
  createParagraphNear: AC,
  cut: OC,
  deleteCurrentNode: EC,
  deleteNode: IC,
  deleteRange: DC,
  deleteSelection: TC,
  enter: NC,
  exitCode: PC,
  extendMarkRange: RC,
  first: VC,
  focus: zC,
  forEach: BC,
  insertContent: HC,
  insertContentAt: FC,
  joinUp: WC,
  joinDown: qC,
  joinBackward: _C,
  joinForward: GC,
  joinItemBackward: ZC,
  joinItemForward: XC,
  joinTextblockBackward: UC,
  joinTextblockForward: YC,
  keyboardShortcut: KC,
  lift: QC,
  liftEmptyBlock: eS,
  liftListItem: tS,
  newlineInCode: nS,
  resetAttributes: rS,
  scrollIntoView: aS,
  selectAll: iS,
  selectNodeBackward: oS,
  selectNodeForward: sS,
  selectParentNode: cS,
  selectTextblockEnd: lS,
  selectTextblockStart: dS,
  setContent: uS,
  setMark: OS,
  setMeta: ES,
  setNode: IS,
  setNodeSelection: DS,
  setTextSelection: TS,
  sinkListItem: NS,
  splitBlock: PS,
  splitListItem: LS,
  toggleList: RS,
  toggleMark: VS,
  toggleNode: zS,
  toggleWrap: BS,
  undoInputRule: HS,
  unsetAllMarks: $S,
  unsetMark: jS,
  updateAttributes: FS,
  wrapIn: WS,
  wrapInList: qS
});
const GS = kt.create({
  name: "commands",
  addCommands() {
    return {
      ..._S
    };
  }
}), ZS = kt.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new At({
        key: new nn("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), XS = kt.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: e } = this;
    return [
      new At({
        key: new nn("focusEvents"),
        props: {
          handleDOMEvents: {
            focus: (t, n) => {
              e.isFocused = !0;
              const r = e.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
              return t.dispatch(r), !1;
            },
            blur: (t, n) => {
              e.isFocused = !1;
              const r = e.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
              return t.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), US = kt.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const e = () => this.editor.commands.first(({ commands: o }) => [
      () => o.undoInputRule(),
      // maybe convert first text block node to default node
      () => o.command(({ tr: s }) => {
        const { selection: c, doc: l } = s, { empty: u, $anchor: h } = c, { pos: p, parent: f } = h, y = h.parent.isTextblock && p > 0 ? s.doc.resolve(p - 1) : h, m = y.parent.type.spec.isolating, v = h.pos - h.parentOffset, k = m && y.parent.childCount === 1 ? v === h.pos : Ie.atStart(l).from === p;
        return !u || !f.type.isTextblock || f.textContent.length || !k || k && h.parent.type.name === "paragraph" ? !1 : o.clearNodes();
      }),
      () => o.deleteSelection(),
      () => o.joinBackward(),
      () => o.selectNodeBackward()
    ]), t = () => this.editor.commands.first(({ commands: o }) => [
      () => o.deleteSelection(),
      () => o.deleteCurrentNode(),
      () => o.joinForward(),
      () => o.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.newlineInCode(),
        () => o.createParagraphNear(),
        () => o.liftEmptyBlock(),
        () => o.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: e,
      "Mod-Backspace": e,
      "Shift-Backspace": e,
      Delete: t,
      "Mod-Delete": t,
      "Mod-a": () => this.editor.commands.selectAll()
    }, a = {
      ...r
    }, i = {
      ...r,
      "Ctrl-h": e,
      "Alt-Backspace": e,
      "Ctrl-d": t,
      "Ctrl-Alt-Backspace": t,
      "Alt-Delete": t,
      "Alt-d": t,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return d1() || e4() ? i : a;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new At({
        key: new nn("clearDocument"),
        appendTransaction: (e, t, n) => {
          if (!(e.some((y) => y.docChanged) && !t.doc.eq(n.doc)))
            return;
          const { empty: a, from: i, to: o } = t.selection, s = Ie.atStart(t.doc).from, c = Ie.atEnd(t.doc).to;
          if (a || !(i === s && o === c) || !(n.doc.textBetween(0, n.doc.content.size, " ", " ").length === 0))
            return;
          const h = n.tr, p = a1({
            state: n,
            transaction: h
          }), { commands: f } = new i1({
            editor: this.editor,
            state: p
          });
          if (f.clearNodes(), !!h.steps.length)
            return h;
        }
      })
    ];
  }
}), YS = kt.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new At({
        key: new nn("tabindex"),
        props: {
          attributes: this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class Yr {
  constructor(t, n, r = !1, a = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = t, this.editor = n, this.currentNode = a;
  }
  get name() {
    return this.node.type.name;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var t;
    return (t = this.actualDepth) !== null && t !== void 0 ? t : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(t) {
    let n = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      n = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: n, to: r }, t);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const t = this.resolvedPos.start(this.resolvedPos.depth - 1), n = this.resolvedPos.doc.resolve(t);
    return new Yr(n, this.editor);
  }
  get before() {
    let t = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return t.depth !== this.depth && (t = this.resolvedPos.doc.resolve(this.from - 3)), new Yr(t, this.editor);
  }
  get after() {
    let t = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return t.depth !== this.depth && (t = this.resolvedPos.doc.resolve(this.to + 3)), new Yr(t, this.editor);
  }
  get children() {
    const t = [];
    return this.node.content.forEach((n, r) => {
      const a = n.isBlock && !n.isTextblock, i = this.pos + r + 1, o = this.resolvedPos.doc.resolve(i);
      if (!a && o.depth <= this.depth)
        return;
      const s = new Yr(o, this.editor, a, a ? n : null);
      a && (s.actualDepth = this.depth + 1), t.push(new Yr(o, this.editor, a, a ? n : null));
    }), t;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const t = this.children;
    return t[t.length - 1] || null;
  }
  closest(t, n = {}) {
    let r = null, a = this.parent;
    for (; a && !r; ) {
      if (a.node.type.name === t)
        if (Object.keys(n).length > 0) {
          const i = a.node.attrs, o = Object.keys(n);
          for (let s = 0; s < o.length; s += 1) {
            const c = o[s];
            if (i[c] !== n[c])
              break;
          }
        } else
          r = a;
      a = a.parent;
    }
    return r;
  }
  querySelector(t, n = {}) {
    return this.querySelectorAll(t, n, !0)[0] || null;
  }
  querySelectorAll(t, n = {}, r = !1) {
    let a = [];
    if (!this.children || this.children.length === 0)
      return a;
    const i = Object.keys(n);
    return this.children.forEach((o) => {
      r && a.length > 0 || (o.node.type.name === t && i.every((c) => n[c] === o.node.attrs[c]) && a.push(o), !(r && a.length > 0) && (a = a.concat(o.querySelectorAll(t, n, r))));
    }), a;
  }
  setAttribute(t) {
    const n = this.editor.state.selection;
    this.editor.chain().setTextSelection(this.from).updateAttributes(this.node.type.name, t).setTextSelection(n.from).run();
  }
}
const JS = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 1px !important;
  height: 1px !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function KS(e, t, n) {
  const r = document.querySelector(`style[data-tiptap-style${n ? `-${n}` : ""}]`);
  if (r !== null)
    return r;
  const a = document.createElement("style");
  return t && a.setAttribute("nonce", t), a.setAttribute(`data-tiptap-style${n ? `-${n}` : ""}`, ""), a.innerHTML = e, document.getElementsByTagName("head")[0].appendChild(a), a;
}
let QS = class extends oC {
  constructor(t = {}) {
    super(), this.isFocused = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(t), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }));
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = KS(JS, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(t = {}) {
    this.options = {
      ...this.options,
      ...t
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(t, n = !0) {
    this.setOptions({ editable: t }), n && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   */
  registerPlugin(t, n) {
    const r = Uk(n) ? n(t, [...this.state.plugins]) : [...this.state.plugins, t], a = this.state.reconfigure({ plugins: r });
    this.view.updateState(a);
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKey The plugins name
   */
  unregisterPlugin(t) {
    if (this.isDestroyed)
      return;
    const n = typeof t == "string" ? `${t}$` : t.key, r = this.state.reconfigure({
      // @ts-ignore
      plugins: this.state.plugins.filter((a) => !a.key.startsWith(n))
    });
    this.view.updateState(r);
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var t, n;
    const a = [...this.options.enableCoreExtensions ? [
      ZS,
      xC.configure({
        blockSeparator: (n = (t = this.options.coreExtensionOptions) === null || t === void 0 ? void 0 : t.clipboardTextSerializer) === null || n === void 0 ? void 0 : n.blockSeparator
      }),
      GS,
      XS,
      US,
      YS
    ] : [], ...this.options.extensions].filter((i) => ["extension", "node", "mark"].includes(i == null ? void 0 : i.type));
    this.extensionManager = new Za(a, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new i1({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    const t = t4(this.options.content, this.schema, this.options.parseOptions), n = Kk(t, this.options.autofocus);
    this.view = new S9(this.options.element, {
      ...this.options.editorProps,
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: Ga.create({
        doc: t,
        selection: n || void 0
      })
    });
    const r = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(r), this.createNodeViews(), this.prependClass();
    const a = this.view.dom;
    a.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(t) {
    this.isCapturingTransaction = !0, t(), this.isCapturingTransaction = !1;
    const n = this.capturedTransaction;
    return this.capturedTransaction = null, n;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(t) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = t;
        return;
      }
      t.steps.forEach((o) => {
        var s;
        return (s = this.capturedTransaction) === null || s === void 0 ? void 0 : s.step(o);
      });
      return;
    }
    const n = this.state.apply(t), r = !this.state.selection.eq(n.selection);
    this.view.updateState(n), this.emit("transaction", {
      editor: this,
      transaction: t
    }), r && this.emit("selectionUpdate", {
      editor: this,
      transaction: t
    });
    const a = t.getMeta("focus"), i = t.getMeta("blur");
    a && this.emit("focus", {
      editor: this,
      event: a.event,
      transaction: t
    }), i && this.emit("blur", {
      editor: this,
      event: i.event,
      transaction: t
    }), !(!t.docChanged || t.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: t
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(t) {
    return n4(this.state, t);
  }
  isActive(t, n) {
    const r = typeof t == "string" ? t : null, a = typeof t == "string" ? n : t;
    return MS(this.state, r, a);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return mS(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(t) {
    const { blockSeparator: n = `

`, textSerializers: r = {} } = t || {};
    return gS(this.state.doc, {
      blockSeparator: n,
      textSerializers: {
        ...Jk(this.schema),
        ...r
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return wS(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.emit("destroy"), this.view && this.view.destroy(), this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var t;
    return !(!((t = this.view) === null || t === void 0) && t.docView);
  }
  $node(t, n) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelector(t, n)) || null;
  }
  $nodes(t, n) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelectorAll(t, n)) || null;
  }
  $pos(t) {
    const n = this.state.doc.resolve(t);
    return new Yr(n, this);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function ui(e) {
  return new s1({
    find: e.find,
    handler: ({ state: t, range: n, match: r }) => {
      const a = Ee(e.getAttributes, void 0, r);
      if (a === !1 || a === null)
        return null;
      const { tr: i } = t, o = r[r.length - 1], s = r[0];
      if (o) {
        const c = s.search(/\S/), l = n.from + s.indexOf(o), u = l + o.length;
        if (kp(n.from, n.to, t.doc).filter((f) => f.mark.type.excluded.find((m) => m === e.type && m !== f.mark.type)).filter((f) => f.to > l).length)
          return null;
        u < n.to && i.delete(u, n.to), l > n.from && i.delete(n.from + c, l);
        const p = n.from + c + o.length;
        i.addMark(n.from + c, p, e.type.create(a || {})), i.removeStoredMark(e.type);
      }
    }
  });
}
function eA(e) {
  return new s1({
    find: e.find,
    handler: ({ state: t, range: n, match: r }) => {
      const a = Ee(e.getAttributes, void 0, r) || {}, { tr: i } = t, o = n.from;
      let s = n.to;
      const c = e.type.create(a);
      if (r[1]) {
        const l = r[0].lastIndexOf(r[1]);
        let u = o + l;
        u > s ? u = s : s = u + r[1].length;
        const h = r[0][r[0].length - 1];
        i.insertText(h, o + r[0].length - 1), i.replaceWith(u, s, c);
      } else
        r[0] && i.insert(o - 1, e.type.create(a)).delete(i.mapping.map(o), i.mapping.map(s));
      i.scrollIntoView();
    }
  });
}
function zu(e) {
  return new s1({
    find: e.find,
    handler: ({ state: t, range: n, match: r }) => {
      const a = t.doc.resolve(n.from), i = Ee(e.getAttributes, void 0, r) || {};
      if (!a.node(-1).canReplaceWith(a.index(-1), a.indexAfter(-1), e.type))
        return null;
      t.tr.delete(n.from, n.to).setBlockType(n.from, n.from, e.type, i);
    }
  });
}
function wo(e) {
  return new s1({
    find: e.find,
    handler: ({ state: t, range: n, match: r, chain: a }) => {
      const i = Ee(e.getAttributes, void 0, r) || {}, o = t.tr.delete(n.from, n.to), c = o.doc.resolve(n.from).blockRange(), l = c && ap(c, e.type, i);
      if (!l)
        return null;
      if (o.wrap(c, l), e.keepMarks && e.editor) {
        const { selection: h, storedMarks: p } = t, { splittableMarks: f } = e.editor.extensionManager, y = p || h.$to.parentOffset && h.$from.marks();
        if (y) {
          const m = y.filter((v) => f.includes(v.type.name));
          o.ensureMarks(m);
        }
      }
      if (e.keepAttributes) {
        const h = e.type.name === "bulletList" || e.type.name === "orderedList" ? "listItem" : "taskList";
        a().updateAttributes(h, i).run();
      }
      const u = o.doc.resolve(n.from - 1).nodeBefore;
      u && u.type === e.type && Lr(o.doc, n.from - 1) && (!e.joinPredicate || e.joinPredicate(r, u)) && o.join(n.from - 1);
    }
  });
}
class Qt {
  constructor(t = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ee(ge(this, "addOptions", {
      name: this.name
    }))), this.storage = Ee(ge(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new Qt(t);
  }
  configure(t = {}) {
    const n = this.extend();
    return n.options = c1(this.options, t), n.storage = Ee(ge(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  extend(t = {}) {
    const n = new Qt({ ...this.config, ...t });
    return n.parent = this, this.child = n, n.name = t.name ? t.name : n.parent.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Ee(ge(n, "addOptions", {
      name: n.name
    })), n.storage = Ee(ge(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  static handleExit({ editor: t, mark: n }) {
    const { tr: r } = t.state, a = t.state.selection.$from;
    if (a.pos === a.end()) {
      const o = a.marks();
      if (!!!o.find((l) => (l == null ? void 0 : l.type.name) === n.name))
        return !1;
      const c = o.find((l) => (l == null ? void 0 : l.type.name) === n.name);
      return c && r.removeStoredMark(c), r.insertText(" ", a.pos), t.view.dispatch(r), !0;
    }
    return !1;
  }
}
let rn = class Bu {
  constructor(t = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ee(ge(this, "addOptions", {
      name: this.name
    }))), this.storage = Ee(ge(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new Bu(t);
  }
  configure(t = {}) {
    const n = this.extend();
    return n.options = c1(this.options, t), n.storage = Ee(ge(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  extend(t = {}) {
    const n = new Bu({ ...this.config, ...t });
    return n.parent = this, this.child = n, n.name = t.name ? t.name : n.parent.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Ee(ge(n, "addOptions", {
      name: n.name
    })), n.storage = Ee(ge(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
};
function tA() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
class nA {
  constructor(t, n, r) {
    this.isDragging = !1, this.component = t, this.editor = n.editor, this.options = {
      stopEvent: null,
      ignoreMutation: null,
      ...r
    }, this.extension = n.extension, this.node = n.node, this.decorations = n.decorations, this.getPos = n.getPos, this.mount();
  }
  mount() {
  }
  get dom() {
    return this.editor.view.dom;
  }
  get contentDOM() {
    return null;
  }
  onDragStart(t) {
    var n, r, a, i, o, s, c;
    const { view: l } = this.editor, u = t.target, h = u.nodeType === 3 ? (n = u.parentElement) === null || n === void 0 ? void 0 : n.closest("[data-drag-handle]") : u.closest("[data-drag-handle]");
    if (!this.dom || !((r = this.contentDOM) === null || r === void 0) && r.contains(u) || !h)
      return;
    let p = 0, f = 0;
    if (this.dom !== h) {
      const v = this.dom.getBoundingClientRect(), k = h.getBoundingClientRect(), b = (a = t.offsetX) !== null && a !== void 0 ? a : (i = t.nativeEvent) === null || i === void 0 ? void 0 : i.offsetX, x = (o = t.offsetY) !== null && o !== void 0 ? o : (s = t.nativeEvent) === null || s === void 0 ? void 0 : s.offsetY;
      p = k.x - v.x + b, f = k.y - v.y + x;
    }
    (c = t.dataTransfer) === null || c === void 0 || c.setDragImage(this.dom, p, f);
    const y = xe.create(l.state.doc, this.getPos()), m = l.state.tr.setSelection(y);
    l.dispatch(m);
  }
  stopEvent(t) {
    var n;
    if (!this.dom)
      return !1;
    if (typeof this.options.stopEvent == "function")
      return this.options.stopEvent({ event: t });
    const r = t.target;
    if (!(this.dom.contains(r) && !(!((n = this.contentDOM) === null || n === void 0) && n.contains(r))))
      return !1;
    const i = t.type.startsWith("drag"), o = t.type === "drop";
    if ((["INPUT", "BUTTON", "SELECT", "TEXTAREA"].includes(r.tagName) || r.isContentEditable) && !o && !i)
      return !0;
    const { isEditable: c } = this.editor, { isDragging: l } = this, u = !!this.node.type.spec.draggable, h = xe.isSelectable(this.node), p = t.type === "copy", f = t.type === "paste", y = t.type === "cut", m = t.type === "mousedown";
    if (!u && h && i && t.preventDefault(), u && i && !l)
      return t.preventDefault(), !1;
    if (u && c && !l && m) {
      const v = r.closest("[data-drag-handle]");
      v && (this.dom === v || this.dom.contains(v)) && (this.isDragging = !0, document.addEventListener("dragend", () => {
        this.isDragging = !1;
      }, { once: !0 }), document.addEventListener("drop", () => {
        this.isDragging = !1;
      }, { once: !0 }), document.addEventListener("mouseup", () => {
        this.isDragging = !1;
      }, { once: !0 }));
    }
    return !(l || o || p || f || y || m && h);
  }
  ignoreMutation(t) {
    return !this.dom || !this.contentDOM ? !0 : typeof this.options.ignoreMutation == "function" ? this.options.ignoreMutation({ mutation: t }) : this.node.isLeaf || this.node.isAtom ? !0 : t.type === "selection" || this.dom.contains(t.target) && t.type === "childList" && (d1() || tA()) && this.editor.isFocused && [
      ...Array.from(t.addedNodes),
      ...Array.from(t.removedNodes)
    ].every((r) => r.isContentEditable) ? !1 : this.contentDOM === t.target && t.type === "attributes" ? !0 : !this.contentDOM.contains(t.target);
  }
  updateAttributes(t) {
    this.editor.commands.command(({ tr: n }) => {
      const r = this.getPos();
      return n.setNodeMarkup(r, void 0, {
        ...this.node.attrs,
        ...t
      }), !0;
    });
  }
  deleteNode() {
    const t = this.getPos(), n = t + this.node.nodeSize;
    this.editor.commands.deleteRange({ from: t, to: n });
  }
}
function ya(e) {
  return new fC({
    find: e.find,
    handler: ({ state: t, range: n, match: r, pasteEvent: a }) => {
      const i = Ee(e.getAttributes, void 0, r, a);
      if (i === !1 || i === null)
        return null;
      const { tr: o } = t, s = r[r.length - 1], c = r[0];
      let l = n.to;
      if (s) {
        const u = c.search(/\S/), h = n.from + c.indexOf(s), p = h + s.length;
        if (kp(n.from, n.to, t.doc).filter((y) => y.mark.type.excluded.find((v) => v === e.type && v !== y.mark.type)).filter((y) => y.to > h).length)
          return null;
        p < n.to && o.delete(p, n.to), h > n.from && o.delete(n.from + u, h), l = n.from + u + s.length, o.addMark(n.from + u, l, e.type.create(i || {})), o.removeStoredMark(e.type);
      }
    }
  });
}
function rA(e) {
  return e.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var jt = "top", hn = "bottom", pn = "right", Ft = "left", bp = "auto", as = [jt, hn, pn, Ft], hi = "start", Co = "end", aA = "clippingParents", r4 = "viewport", $i = "popper", iA = "reference", Vf = /* @__PURE__ */ as.reduce(function(e, t) {
  return e.concat([t + "-" + hi, t + "-" + Co]);
}, []), a4 = /* @__PURE__ */ [].concat(as, [bp]).reduce(function(e, t) {
  return e.concat([t, t + "-" + hi, t + "-" + Co]);
}, []), oA = "beforeRead", sA = "read", cA = "afterRead", lA = "beforeMain", dA = "main", uA = "afterMain", hA = "beforeWrite", pA = "write", fA = "afterWrite", yA = [oA, sA, cA, lA, dA, uA, hA, pA, fA];
function Wn(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function en(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function ma(e) {
  var t = en(e).Element;
  return e instanceof t || e instanceof Element;
}
function dn(e) {
  var t = en(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function xp(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = en(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function mA(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, a = t.attributes[n] || {}, i = t.elements[n];
    !dn(i) || !Wn(i) || (Object.assign(i.style, r), Object.keys(a).forEach(function(o) {
      var s = a[o];
      s === !1 ? i.removeAttribute(o) : i.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function gA(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var a = t.elements[r], i = t.attributes[r] || {}, o = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), s = o.reduce(function(c, l) {
        return c[l] = "", c;
      }, {});
      !dn(a) || !Wn(a) || (Object.assign(a.style, s), Object.keys(i).forEach(function(c) {
        a.removeAttribute(c);
      }));
    });
  };
}
const Mp = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: mA,
  effect: gA,
  requires: ["computeStyles"]
};
function Bn(e) {
  return e.split("-")[0];
}
var sa = Math.max, Fc = Math.min, pi = Math.round;
function Hu() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function i4() {
  return !/^((?!chrome|android).)*safari/i.test(Hu());
}
function fi(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), a = 1, i = 1;
  t && dn(e) && (a = e.offsetWidth > 0 && pi(r.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && pi(r.height) / e.offsetHeight || 1);
  var o = ma(e) ? en(e) : window, s = o.visualViewport, c = !i4() && n, l = (r.left + (c && s ? s.offsetLeft : 0)) / a, u = (r.top + (c && s ? s.offsetTop : 0)) / i, h = r.width / a, p = r.height / i;
  return {
    width: h,
    height: p,
    top: u,
    right: l + h,
    bottom: u + p,
    left: l,
    x: l,
    y: u
  };
}
function wp(e) {
  var t = fi(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function o4(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && xp(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function ar(e) {
  return en(e).getComputedStyle(e);
}
function vA(e) {
  return ["table", "td", "th"].indexOf(Wn(e)) >= 0;
}
function zr(e) {
  return ((ma(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function h1(e) {
  return Wn(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (xp(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    zr(e)
  );
}
function zf(e) {
  return !dn(e) || // https://github.com/popperjs/popper-core/issues/837
  ar(e).position === "fixed" ? null : e.offsetParent;
}
function kA(e) {
  var t = /firefox/i.test(Hu()), n = /Trident/i.test(Hu());
  if (n && dn(e)) {
    var r = ar(e);
    if (r.position === "fixed")
      return null;
  }
  var a = h1(e);
  for (xp(a) && (a = a.host); dn(a) && ["html", "body"].indexOf(Wn(a)) < 0; ) {
    var i = ar(a);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function is(e) {
  for (var t = en(e), n = zf(e); n && vA(n) && ar(n).position === "static"; )
    n = zf(n);
  return n && (Wn(n) === "html" || Wn(n) === "body" && ar(n).position === "static") ? t : n || kA(e) || t;
}
function Cp(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function ao(e, t, n) {
  return sa(e, Fc(t, n));
}
function bA(e, t, n) {
  var r = ao(e, t, n);
  return r > n ? n : r;
}
function s4() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function c4(e) {
  return Object.assign({}, s4(), e);
}
function l4(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var xA = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, c4(typeof t != "number" ? t : l4(t, as));
};
function MA(e) {
  var t, n = e.state, r = e.name, a = e.options, i = n.elements.arrow, o = n.modifiersData.popperOffsets, s = Bn(n.placement), c = Cp(s), l = [Ft, pn].indexOf(s) >= 0, u = l ? "height" : "width";
  if (!(!i || !o)) {
    var h = xA(a.padding, n), p = wp(i), f = c === "y" ? jt : Ft, y = c === "y" ? hn : pn, m = n.rects.reference[u] + n.rects.reference[c] - o[c] - n.rects.popper[u], v = o[c] - n.rects.reference[c], k = is(i), b = k ? c === "y" ? k.clientHeight || 0 : k.clientWidth || 0 : 0, x = m / 2 - v / 2, g = h[f], w = b - p[u] - h[y], M = b / 2 - p[u] / 2 + x, S = ao(g, M, w), D = c;
    n.modifiersData[r] = (t = {}, t[D] = S, t.centerOffset = S - M, t);
  }
}
function wA(e) {
  var t = e.state, n = e.options, r = n.element, a = r === void 0 ? "[data-popper-arrow]" : r;
  a != null && (typeof a == "string" && (a = t.elements.popper.querySelector(a), !a) || o4(t.elements.popper, a) && (t.elements.arrow = a));
}
const CA = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: MA,
  effect: wA,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function yi(e) {
  return e.split("-")[1];
}
var SA = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function AA(e, t) {
  var n = e.x, r = e.y, a = t.devicePixelRatio || 1;
  return {
    x: pi(n * a) / a || 0,
    y: pi(r * a) / a || 0
  };
}
function Bf(e) {
  var t, n = e.popper, r = e.popperRect, a = e.placement, i = e.variation, o = e.offsets, s = e.position, c = e.gpuAcceleration, l = e.adaptive, u = e.roundOffsets, h = e.isFixed, p = o.x, f = p === void 0 ? 0 : p, y = o.y, m = y === void 0 ? 0 : y, v = typeof u == "function" ? u({
    x: f,
    y: m
  }) : {
    x: f,
    y: m
  };
  f = v.x, m = v.y;
  var k = o.hasOwnProperty("x"), b = o.hasOwnProperty("y"), x = Ft, g = jt, w = window;
  if (l) {
    var M = is(n), S = "clientHeight", D = "clientWidth";
    if (M === en(n) && (M = zr(n), ar(M).position !== "static" && s === "absolute" && (S = "scrollHeight", D = "scrollWidth")), M = M, a === jt || (a === Ft || a === pn) && i === Co) {
      g = hn;
      var A = h && M === w && w.visualViewport ? w.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        M[S]
      );
      m -= A - r.height, m *= c ? 1 : -1;
    }
    if (a === Ft || (a === jt || a === hn) && i === Co) {
      x = pn;
      var $ = h && M === w && w.visualViewport ? w.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        M[D]
      );
      f -= $ - r.width, f *= c ? 1 : -1;
    }
  }
  var F = Object.assign({
    position: s
  }, l && SA), Z = u === !0 ? AA({
    x: f,
    y: m
  }, en(n)) : {
    x: f,
    y: m
  };
  if (f = Z.x, m = Z.y, c) {
    var B;
    return Object.assign({}, F, (B = {}, B[g] = b ? "0" : "", B[x] = k ? "0" : "", B.transform = (w.devicePixelRatio || 1) <= 1 ? "translate(" + f + "px, " + m + "px)" : "translate3d(" + f + "px, " + m + "px, 0)", B));
  }
  return Object.assign({}, F, (t = {}, t[g] = b ? m + "px" : "", t[x] = k ? f + "px" : "", t.transform = "", t));
}
function OA(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, a = r === void 0 ? !0 : r, i = n.adaptive, o = i === void 0 ? !0 : i, s = n.roundOffsets, c = s === void 0 ? !0 : s, l = {
    placement: Bn(t.placement),
    variation: yi(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Bf(Object.assign({}, l, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Bf(Object.assign({}, l, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const EA = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: OA,
  data: {}
};
var Ns = {
  passive: !0
};
function IA(e) {
  var t = e.state, n = e.instance, r = e.options, a = r.scroll, i = a === void 0 ? !0 : a, o = r.resize, s = o === void 0 ? !0 : o, c = en(t.elements.popper), l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && l.forEach(function(u) {
    u.addEventListener("scroll", n.update, Ns);
  }), s && c.addEventListener("resize", n.update, Ns), function() {
    i && l.forEach(function(u) {
      u.removeEventListener("scroll", n.update, Ns);
    }), s && c.removeEventListener("resize", n.update, Ns);
  };
}
const DA = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: IA,
  data: {}
};
var TA = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function oc(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return TA[t];
  });
}
var NA = {
  start: "end",
  end: "start"
};
function Hf(e) {
  return e.replace(/start|end/g, function(t) {
    return NA[t];
  });
}
function Sp(e) {
  var t = en(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function Ap(e) {
  return fi(zr(e)).left + Sp(e).scrollLeft;
}
function PA(e, t) {
  var n = en(e), r = zr(e), a = n.visualViewport, i = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
  if (a) {
    i = a.width, o = a.height;
    var l = i4();
    (l || !l && t === "fixed") && (s = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s + Ap(e),
    y: c
  };
}
function LA(e) {
  var t, n = zr(e), r = Sp(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, i = sa(n.scrollWidth, n.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), o = sa(n.scrollHeight, n.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), s = -r.scrollLeft + Ap(e), c = -r.scrollTop;
  return ar(a || n).direction === "rtl" && (s += sa(n.clientWidth, a ? a.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: s,
    y: c
  };
}
function Op(e) {
  var t = ar(e), n = t.overflow, r = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + a + r);
}
function d4(e) {
  return ["html", "body", "#document"].indexOf(Wn(e)) >= 0 ? e.ownerDocument.body : dn(e) && Op(e) ? e : d4(h1(e));
}
function io(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = d4(e), a = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = en(r), o = a ? [i].concat(i.visualViewport || [], Op(r) ? r : []) : r, s = t.concat(o);
  return a ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(io(h1(o)))
  );
}
function $u(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function RA(e, t) {
  var n = fi(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function $f(e, t, n) {
  return t === r4 ? $u(PA(e, n)) : ma(t) ? RA(t, n) : $u(LA(zr(e)));
}
function VA(e) {
  var t = io(h1(e)), n = ["absolute", "fixed"].indexOf(ar(e).position) >= 0, r = n && dn(e) ? is(e) : e;
  return ma(r) ? t.filter(function(a) {
    return ma(a) && o4(a, r) && Wn(a) !== "body";
  }) : [];
}
function zA(e, t, n, r) {
  var a = t === "clippingParents" ? VA(e) : [].concat(t), i = [].concat(a, [n]), o = i[0], s = i.reduce(function(c, l) {
    var u = $f(e, l, r);
    return c.top = sa(u.top, c.top), c.right = Fc(u.right, c.right), c.bottom = Fc(u.bottom, c.bottom), c.left = sa(u.left, c.left), c;
  }, $f(e, o, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function u4(e) {
  var t = e.reference, n = e.element, r = e.placement, a = r ? Bn(r) : null, i = r ? yi(r) : null, o = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, c;
  switch (a) {
    case jt:
      c = {
        x: o,
        y: t.y - n.height
      };
      break;
    case hn:
      c = {
        x: o,
        y: t.y + t.height
      };
      break;
    case pn:
      c = {
        x: t.x + t.width,
        y: s
      };
      break;
    case Ft:
      c = {
        x: t.x - n.width,
        y: s
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var l = a ? Cp(a) : null;
  if (l != null) {
    var u = l === "y" ? "height" : "width";
    switch (i) {
      case hi:
        c[l] = c[l] - (t[u] / 2 - n[u] / 2);
        break;
      case Co:
        c[l] = c[l] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return c;
}
function So(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, a = r === void 0 ? e.placement : r, i = n.strategy, o = i === void 0 ? e.strategy : i, s = n.boundary, c = s === void 0 ? aA : s, l = n.rootBoundary, u = l === void 0 ? r4 : l, h = n.elementContext, p = h === void 0 ? $i : h, f = n.altBoundary, y = f === void 0 ? !1 : f, m = n.padding, v = m === void 0 ? 0 : m, k = c4(typeof v != "number" ? v : l4(v, as)), b = p === $i ? iA : $i, x = e.rects.popper, g = e.elements[y ? b : p], w = zA(ma(g) ? g : g.contextElement || zr(e.elements.popper), c, u, o), M = fi(e.elements.reference), S = u4({
    reference: M,
    element: x,
    strategy: "absolute",
    placement: a
  }), D = $u(Object.assign({}, x, S)), A = p === $i ? D : M, $ = {
    top: w.top - A.top + k.top,
    bottom: A.bottom - w.bottom + k.bottom,
    left: w.left - A.left + k.left,
    right: A.right - w.right + k.right
  }, F = e.modifiersData.offset;
  if (p === $i && F) {
    var Z = F[a];
    Object.keys($).forEach(function(B) {
      var O = [pn, hn].indexOf(B) >= 0 ? 1 : -1, I = [jt, hn].indexOf(B) >= 0 ? "y" : "x";
      $[B] += Z[I] * O;
    });
  }
  return $;
}
function BA(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, a = n.boundary, i = n.rootBoundary, o = n.padding, s = n.flipVariations, c = n.allowedAutoPlacements, l = c === void 0 ? a4 : c, u = yi(r), h = u ? s ? Vf : Vf.filter(function(y) {
    return yi(y) === u;
  }) : as, p = h.filter(function(y) {
    return l.indexOf(y) >= 0;
  });
  p.length === 0 && (p = h);
  var f = p.reduce(function(y, m) {
    return y[m] = So(e, {
      placement: m,
      boundary: a,
      rootBoundary: i,
      padding: o
    })[Bn(m)], y;
  }, {});
  return Object.keys(f).sort(function(y, m) {
    return f[y] - f[m];
  });
}
function HA(e) {
  if (Bn(e) === bp)
    return [];
  var t = oc(e);
  return [Hf(e), t, Hf(t)];
}
function $A(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var a = n.mainAxis, i = a === void 0 ? !0 : a, o = n.altAxis, s = o === void 0 ? !0 : o, c = n.fallbackPlacements, l = n.padding, u = n.boundary, h = n.rootBoundary, p = n.altBoundary, f = n.flipVariations, y = f === void 0 ? !0 : f, m = n.allowedAutoPlacements, v = t.options.placement, k = Bn(v), b = k === v, x = c || (b || !y ? [oc(v)] : HA(v)), g = [v].concat(x).reduce(function(_, X) {
      return _.concat(Bn(X) === bp ? BA(t, {
        placement: X,
        boundary: u,
        rootBoundary: h,
        padding: l,
        flipVariations: y,
        allowedAutoPlacements: m
      }) : X);
    }, []), w = t.rects.reference, M = t.rects.popper, S = /* @__PURE__ */ new Map(), D = !0, A = g[0], $ = 0; $ < g.length; $++) {
      var F = g[$], Z = Bn(F), B = yi(F) === hi, O = [jt, hn].indexOf(Z) >= 0, I = O ? "width" : "height", N = So(t, {
        placement: F,
        boundary: u,
        rootBoundary: h,
        altBoundary: p,
        padding: l
      }), R = O ? B ? pn : Ft : B ? hn : jt;
      w[I] > M[I] && (R = oc(R));
      var L = oc(R), W = [];
      if (i && W.push(N[Z] <= 0), s && W.push(N[R] <= 0, N[L] <= 0), W.every(function(_) {
        return _;
      })) {
        A = F, D = !1;
        break;
      }
      S.set(F, W);
    }
    if (D)
      for (var E = y ? 3 : 1, q = function(X) {
        var P = g.find(function(Q) {
          var U = S.get(Q);
          if (U)
            return U.slice(0, X).every(function(ae) {
              return ae;
            });
        });
        if (P)
          return A = P, "break";
      }, z = E; z > 0; z--) {
        var H = q(z);
        if (H === "break")
          break;
      }
    t.placement !== A && (t.modifiersData[r]._skip = !0, t.placement = A, t.reset = !0);
  }
}
const jA = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: $A,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function jf(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Ff(e) {
  return [jt, pn, hn, Ft].some(function(t) {
    return e[t] >= 0;
  });
}
function FA(e) {
  var t = e.state, n = e.name, r = t.rects.reference, a = t.rects.popper, i = t.modifiersData.preventOverflow, o = So(t, {
    elementContext: "reference"
  }), s = So(t, {
    altBoundary: !0
  }), c = jf(o, r), l = jf(s, a, i), u = Ff(c), h = Ff(l);
  t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: l,
    isReferenceHidden: u,
    hasPopperEscaped: h
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": h
  });
}
const WA = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: FA
};
function qA(e, t, n) {
  var r = Bn(e), a = [Ft, jt].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, o = i[0], s = i[1];
  return o = o || 0, s = (s || 0) * a, [Ft, pn].indexOf(r) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function _A(e) {
  var t = e.state, n = e.options, r = e.name, a = n.offset, i = a === void 0 ? [0, 0] : a, o = a4.reduce(function(u, h) {
    return u[h] = qA(h, t.rects, i), u;
  }, {}), s = o[t.placement], c = s.x, l = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += l), t.modifiersData[r] = o;
}
const GA = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: _A
};
function ZA(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = u4({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const XA = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: ZA,
  data: {}
};
function UA(e) {
  return e === "x" ? "y" : "x";
}
function YA(e) {
  var t = e.state, n = e.options, r = e.name, a = n.mainAxis, i = a === void 0 ? !0 : a, o = n.altAxis, s = o === void 0 ? !1 : o, c = n.boundary, l = n.rootBoundary, u = n.altBoundary, h = n.padding, p = n.tether, f = p === void 0 ? !0 : p, y = n.tetherOffset, m = y === void 0 ? 0 : y, v = So(t, {
    boundary: c,
    rootBoundary: l,
    padding: h,
    altBoundary: u
  }), k = Bn(t.placement), b = yi(t.placement), x = !b, g = Cp(k), w = UA(g), M = t.modifiersData.popperOffsets, S = t.rects.reference, D = t.rects.popper, A = typeof m == "function" ? m(Object.assign({}, t.rects, {
    placement: t.placement
  })) : m, $ = typeof A == "number" ? {
    mainAxis: A,
    altAxis: A
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, A), F = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, Z = {
    x: 0,
    y: 0
  };
  if (M) {
    if (i) {
      var B, O = g === "y" ? jt : Ft, I = g === "y" ? hn : pn, N = g === "y" ? "height" : "width", R = M[g], L = R + v[O], W = R - v[I], E = f ? -D[N] / 2 : 0, q = b === hi ? S[N] : D[N], z = b === hi ? -D[N] : -S[N], H = t.elements.arrow, _ = f && H ? wp(H) : {
        width: 0,
        height: 0
      }, X = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : s4(), P = X[O], Q = X[I], U = ao(0, S[N], _[N]), ae = x ? S[N] / 2 - E - U - P - $.mainAxis : q - U - P - $.mainAxis, ee = x ? -S[N] / 2 + E + U + Q + $.mainAxis : z + U + Q + $.mainAxis, de = t.elements.arrow && is(t.elements.arrow), Y = de ? g === "y" ? de.clientTop || 0 : de.clientLeft || 0 : 0, re = (B = F == null ? void 0 : F[g]) != null ? B : 0, te = R + ae - re - Y, me = R + ee - re, Pe = ao(f ? Fc(L, te) : L, R, f ? sa(W, me) : W);
      M[g] = Pe, Z[g] = Pe - R;
    }
    if (s) {
      var Se, _e = g === "x" ? jt : Ft, Ot = g === "x" ? hn : pn, Re = M[w], Qe = w === "y" ? "height" : "width", Rt = Re + v[_e], Xe = Re - v[Ot], Me = [jt, Ft].indexOf(k) !== -1, Fe = (Se = F == null ? void 0 : F[w]) != null ? Se : 0, xn = Me ? Rt : Re - S[Qe] - D[Qe] - Fe + $.altAxis, Mn = Me ? Re + S[Qe] + D[Qe] - Fe - $.altAxis : Xe, Et = f && Me ? bA(xn, Re, Mn) : ao(f ? xn : Rt, Re, f ? Mn : Xe);
      M[w] = Et, Z[w] = Et - Re;
    }
    t.modifiersData[r] = Z;
  }
}
const JA = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: YA,
  requiresIfExists: ["offset"]
};
function KA(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function QA(e) {
  return e === en(e) || !dn(e) ? Sp(e) : KA(e);
}
function eO(e) {
  var t = e.getBoundingClientRect(), n = pi(t.width) / e.offsetWidth || 1, r = pi(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function tO(e, t, n) {
  n === void 0 && (n = !1);
  var r = dn(t), a = dn(t) && eO(t), i = zr(t), o = fi(e, a, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Wn(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Op(i)) && (s = QA(t)), dn(t) ? (c = fi(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : i && (c.x = Ap(i))), {
    x: o.left + s.scrollLeft - c.x,
    y: o.top + s.scrollTop - c.y,
    width: o.width,
    height: o.height
  };
}
function nO(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function a(i) {
    n.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(s) {
      if (!n.has(s)) {
        var c = t.get(s);
        c && a(c);
      }
    }), r.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || a(i);
  }), r;
}
function rO(e) {
  var t = nO(e);
  return yA.reduce(function(n, r) {
    return n.concat(t.filter(function(a) {
      return a.phase === r;
    }));
  }, []);
}
function aO(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function iO(e) {
  var t = e.reduce(function(n, r) {
    var a = n[r.name];
    return n[r.name] = a ? Object.assign({}, a, r, {
      options: Object.assign({}, a.options, r.options),
      data: Object.assign({}, a.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var Wf = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function qf() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function oO(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, a = t.defaultOptions, i = a === void 0 ? Wf : a;
  return function(s, c, l) {
    l === void 0 && (l = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Wf, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: c
      },
      attributes: {},
      styles: {}
    }, h = [], p = !1, f = {
      state: u,
      setOptions: function(k) {
        var b = typeof k == "function" ? k(u.options) : k;
        m(), u.options = Object.assign({}, i, u.options, b), u.scrollParents = {
          reference: ma(s) ? io(s) : s.contextElement ? io(s.contextElement) : [],
          popper: io(c)
        };
        var x = rO(iO([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = x.filter(function(g) {
          return g.enabled;
        }), y(), f.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var k = u.elements, b = k.reference, x = k.popper;
          if (qf(b, x)) {
            u.rects = {
              reference: tO(b, is(x), u.options.strategy === "fixed"),
              popper: wp(x)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function($) {
              return u.modifiersData[$.name] = Object.assign({}, $.data);
            });
            for (var g = 0; g < u.orderedModifiers.length; g++) {
              if (u.reset === !0) {
                u.reset = !1, g = -1;
                continue;
              }
              var w = u.orderedModifiers[g], M = w.fn, S = w.options, D = S === void 0 ? {} : S, A = w.name;
              typeof M == "function" && (u = M({
                state: u,
                options: D,
                name: A,
                instance: f
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: aO(function() {
        return new Promise(function(v) {
          f.forceUpdate(), v(u);
        });
      }),
      destroy: function() {
        m(), p = !0;
      }
    };
    if (!qf(s, c))
      return f;
    f.setOptions(l).then(function(v) {
      !p && l.onFirstUpdate && l.onFirstUpdate(v);
    });
    function y() {
      u.orderedModifiers.forEach(function(v) {
        var k = v.name, b = v.options, x = b === void 0 ? {} : b, g = v.effect;
        if (typeof g == "function") {
          var w = g({
            state: u,
            name: k,
            instance: f,
            options: x
          }), M = function() {
          };
          h.push(w || M);
        }
      });
    }
    function m() {
      h.forEach(function(v) {
        return v();
      }), h = [];
    }
    return f;
  };
}
var sO = [DA, XA, EA, Mp, GA, jA, JA, CA, WA], h4 = /* @__PURE__ */ oO({
  defaultModifiers: sO
}), cO = "tippy-box", p4 = "tippy-content", lO = "tippy-backdrop", f4 = "tippy-arrow", y4 = "tippy-svg-arrow", Gr = {
  passive: !0,
  capture: !0
}, m4 = function() {
  return document.body;
};
function dO(e, t) {
  return {}.hasOwnProperty.call(e, t);
}
function Md(e, t, n) {
  if (Array.isArray(e)) {
    var r = e[t];
    return r ?? (Array.isArray(n) ? n[t] : n);
  }
  return e;
}
function Ep(e, t) {
  var n = {}.toString.call(e);
  return n.indexOf("[object") === 0 && n.indexOf(t + "]") > -1;
}
function g4(e, t) {
  return typeof e == "function" ? e.apply(void 0, t) : e;
}
function _f(e, t) {
  if (t === 0)
    return e;
  var n;
  return function(r) {
    clearTimeout(n), n = setTimeout(function() {
      e(r);
    }, t);
  };
}
function uO(e, t) {
  var n = Object.assign({}, e);
  return t.forEach(function(r) {
    delete n[r];
  }), n;
}
function hO(e) {
  return e.split(/\s+/).filter(Boolean);
}
function Wa(e) {
  return [].concat(e);
}
function Gf(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function pO(e) {
  return e.filter(function(t, n) {
    return e.indexOf(t) === n;
  });
}
function fO(e) {
  return e.split("-")[0];
}
function Wc(e) {
  return [].slice.call(e);
}
function Zf(e) {
  return Object.keys(e).reduce(function(t, n) {
    return e[n] !== void 0 && (t[n] = e[n]), t;
  }, {});
}
function oo() {
  return document.createElement("div");
}
function Ao(e) {
  return ["Element", "Fragment"].some(function(t) {
    return Ep(e, t);
  });
}
function yO(e) {
  return Ep(e, "NodeList");
}
function mO(e) {
  return Ep(e, "MouseEvent");
}
function gO(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function vO(e) {
  return Ao(e) ? [e] : yO(e) ? Wc(e) : Array.isArray(e) ? e : Wc(document.querySelectorAll(e));
}
function wd(e, t) {
  e.forEach(function(n) {
    n && (n.style.transitionDuration = t + "ms");
  });
}
function Xf(e, t) {
  e.forEach(function(n) {
    n && n.setAttribute("data-state", t);
  });
}
function kO(e) {
  var t, n = Wa(e), r = n[0];
  return r != null && (t = r.ownerDocument) != null && t.body ? r.ownerDocument : document;
}
function bO(e, t) {
  var n = t.clientX, r = t.clientY;
  return e.every(function(a) {
    var i = a.popperRect, o = a.popperState, s = a.props, c = s.interactiveBorder, l = fO(o.placement), u = o.modifiersData.offset;
    if (!u)
      return !0;
    var h = l === "bottom" ? u.top.y : 0, p = l === "top" ? u.bottom.y : 0, f = l === "right" ? u.left.x : 0, y = l === "left" ? u.right.x : 0, m = i.top - r + h > c, v = r - i.bottom - p > c, k = i.left - n + f > c, b = n - i.right - y > c;
    return m || v || k || b;
  });
}
function Cd(e, t, n) {
  var r = t + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(a) {
    e[r](a, n);
  });
}
function Uf(e, t) {
  for (var n = t; n; ) {
    var r;
    if (e.contains(n))
      return !0;
    n = n.getRootNode == null || (r = n.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var In = {
  isTouch: !1
}, Yf = 0;
function xO() {
  In.isTouch || (In.isTouch = !0, window.performance && document.addEventListener("mousemove", v4));
}
function v4() {
  var e = performance.now();
  e - Yf < 20 && (In.isTouch = !1, document.removeEventListener("mousemove", v4)), Yf = e;
}
function MO() {
  var e = document.activeElement;
  if (gO(e)) {
    var t = e._tippy;
    e.blur && !t.state.isVisible && e.blur();
  }
}
function wO() {
  document.addEventListener("touchstart", xO, Gr), window.addEventListener("blur", MO);
}
var CO = typeof window < "u" && typeof document < "u", SO = CO ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function Da(e) {
  var t = e === "destroy" ? "n already-" : " ";
  return [e + "() was called on a" + t + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function Jf(e) {
  var t = /[ \t]{2,}/g, n = /^[ \t]*/gm;
  return e.replace(t, " ").replace(n, "").trim();
}
function AO(e) {
  return Jf(`
  %ctippy.js

  %c` + Jf(e) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function k4(e) {
  return [
    AO(e),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var Oo;
process.env.NODE_ENV !== "production" && OO();
function OO() {
  Oo = /* @__PURE__ */ new Set();
}
function Qn(e, t) {
  if (e && !Oo.has(t)) {
    var n;
    Oo.add(t), (n = console).warn.apply(n, k4(t));
  }
}
function ju(e, t) {
  if (e && !Oo.has(t)) {
    var n;
    Oo.add(t), (n = console).error.apply(n, k4(t));
  }
}
function EO(e) {
  var t = !e, n = Object.prototype.toString.call(e) === "[object Object]" && !e.addEventListener;
  ju(t, ["tippy() was passed", "`" + String(e) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), ju(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var b4 = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, IO = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, Ut = Object.assign({
  appendTo: m4,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, b4, IO), DO = Object.keys(Ut), TO = function(t) {
  process.env.NODE_ENV !== "production" && M4(t, []);
  var n = Object.keys(t);
  n.forEach(function(r) {
    Ut[r] = t[r];
  });
};
function x4(e) {
  var t = e.plugins || [], n = t.reduce(function(r, a) {
    var i = a.name, o = a.defaultValue;
    if (i) {
      var s;
      r[i] = e[i] !== void 0 ? e[i] : (s = Ut[i]) != null ? s : o;
    }
    return r;
  }, {});
  return Object.assign({}, e, n);
}
function NO(e, t) {
  var n = t ? Object.keys(x4(Object.assign({}, Ut, {
    plugins: t
  }))) : DO, r = n.reduce(function(a, i) {
    var o = (e.getAttribute("data-tippy-" + i) || "").trim();
    if (!o)
      return a;
    if (i === "content")
      a[i] = o;
    else
      try {
        a[i] = JSON.parse(o);
      } catch {
        a[i] = o;
      }
    return a;
  }, {});
  return r;
}
function Kf(e, t) {
  var n = Object.assign({}, t, {
    content: g4(t.content, [e])
  }, t.ignoreAttributes ? {} : NO(e, t.plugins));
  return n.aria = Object.assign({}, Ut.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? t.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? t.interactive ? null : "describedby" : n.aria.content
  }, n;
}
function M4(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = []);
  var n = Object.keys(e);
  n.forEach(function(r) {
    var a = uO(Ut, Object.keys(b4)), i = !dO(a, r);
    i && (i = t.filter(function(o) {
      return o.name === r;
    }).length === 0), Qn(i, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var PO = function() {
  return "innerHTML";
};
function Fu(e, t) {
  e[PO()] = t;
}
function Qf(e) {
  var t = oo();
  return e === !0 ? t.className = f4 : (t.className = y4, Ao(e) ? t.appendChild(e) : Fu(t, e)), t;
}
function ey(e, t) {
  Ao(t.content) ? (Fu(e, ""), e.appendChild(t.content)) : typeof t.content != "function" && (t.allowHTML ? Fu(e, t.content) : e.textContent = t.content);
}
function Wu(e) {
  var t = e.firstElementChild, n = Wc(t.children);
  return {
    box: t,
    content: n.find(function(r) {
      return r.classList.contains(p4);
    }),
    arrow: n.find(function(r) {
      return r.classList.contains(f4) || r.classList.contains(y4);
    }),
    backdrop: n.find(function(r) {
      return r.classList.contains(lO);
    })
  };
}
function w4(e) {
  var t = oo(), n = oo();
  n.className = cO, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var r = oo();
  r.className = p4, r.setAttribute("data-state", "hidden"), ey(r, e.props), t.appendChild(n), n.appendChild(r), a(e.props, e.props);
  function a(i, o) {
    var s = Wu(t), c = s.box, l = s.content, u = s.arrow;
    o.theme ? c.setAttribute("data-theme", o.theme) : c.removeAttribute("data-theme"), typeof o.animation == "string" ? c.setAttribute("data-animation", o.animation) : c.removeAttribute("data-animation"), o.inertia ? c.setAttribute("data-inertia", "") : c.removeAttribute("data-inertia"), c.style.maxWidth = typeof o.maxWidth == "number" ? o.maxWidth + "px" : o.maxWidth, o.role ? c.setAttribute("role", o.role) : c.removeAttribute("role"), (i.content !== o.content || i.allowHTML !== o.allowHTML) && ey(l, e.props), o.arrow ? u ? i.arrow !== o.arrow && (c.removeChild(u), c.appendChild(Qf(o.arrow))) : c.appendChild(Qf(o.arrow)) : u && c.removeChild(u);
  }
  return {
    popper: t,
    onUpdate: a
  };
}
w4.$$tippy = !0;
var LO = 1, Ps = [], Sd = [];
function RO(e, t) {
  var n = Kf(e, Object.assign({}, Ut, x4(Zf(t)))), r, a, i, o = !1, s = !1, c = !1, l = !1, u, h, p, f = [], y = _f(te, n.interactiveDebounce), m, v = LO++, k = null, b = pO(n.plugins), x = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, g = {
    // properties
    id: v,
    reference: e,
    popper: oo(),
    popperInstance: k,
    props: n,
    state: x,
    plugins: b,
    // methods
    clearDelayTimeouts: xn,
    setProps: Mn,
    setContent: Et,
    show: $1,
    hide: j1,
    hideWithInteractivity: F1,
    enable: Me,
    disable: Fe,
    unmount: W1,
    destroy: q1
  };
  if (!n.render)
    return process.env.NODE_ENV !== "production" && ju(!0, "render() function has not been supplied."), g;
  var w = n.render(g), M = w.popper, S = w.onUpdate;
  M.setAttribute("data-tippy-root", ""), M.id = "tippy-" + g.id, g.popper = M, e._tippy = g, M._tippy = g;
  var D = b.map(function(T) {
    return T.fn(g);
  }), A = e.hasAttribute("aria-expanded");
  return de(), E(), R(), L("onCreate", [g]), n.showOnCreate && Rt(), M.addEventListener("mouseenter", function() {
    g.props.interactive && g.state.isVisible && g.clearDelayTimeouts();
  }), M.addEventListener("mouseleave", function() {
    g.props.interactive && g.props.trigger.indexOf("mouseenter") >= 0 && O().addEventListener("mousemove", y);
  }), g;
  function $() {
    var T = g.props.touch;
    return Array.isArray(T) ? T : [T, 0];
  }
  function F() {
    return $()[0] === "hold";
  }
  function Z() {
    var T;
    return !!((T = g.props.render) != null && T.$$tippy);
  }
  function B() {
    return m || e;
  }
  function O() {
    var T = B().parentNode;
    return T ? kO(T) : document;
  }
  function I() {
    return Wu(M);
  }
  function N(T) {
    return g.state.isMounted && !g.state.isVisible || In.isTouch || u && u.type === "focus" ? 0 : Md(g.props.delay, T ? 0 : 1, Ut.delay);
  }
  function R(T) {
    T === void 0 && (T = !1), M.style.pointerEvents = g.props.interactive && !T ? "" : "none", M.style.zIndex = "" + g.props.zIndex;
  }
  function L(T, K, se) {
    if (se === void 0 && (se = !0), D.forEach(function(pe) {
      pe[T] && pe[T].apply(pe, K);
    }), se) {
      var ve;
      (ve = g.props)[T].apply(ve, K);
    }
  }
  function W() {
    var T = g.props.aria;
    if (T.content) {
      var K = "aria-" + T.content, se = M.id, ve = Wa(g.props.triggerTarget || e);
      ve.forEach(function(pe) {
        var Ve = pe.getAttribute(K);
        if (g.state.isVisible)
          pe.setAttribute(K, Ve ? Ve + " " + se : se);
        else {
          var Ge = Ve && Ve.replace(se, "").trim();
          Ge ? pe.setAttribute(K, Ge) : pe.removeAttribute(K);
        }
      });
    }
  }
  function E() {
    if (!(A || !g.props.aria.expanded)) {
      var T = Wa(g.props.triggerTarget || e);
      T.forEach(function(K) {
        g.props.interactive ? K.setAttribute("aria-expanded", g.state.isVisible && K === B() ? "true" : "false") : K.removeAttribute("aria-expanded");
      });
    }
  }
  function q() {
    O().removeEventListener("mousemove", y), Ps = Ps.filter(function(T) {
      return T !== y;
    });
  }
  function z(T) {
    if (!(In.isTouch && (c || T.type === "mousedown"))) {
      var K = T.composedPath && T.composedPath()[0] || T.target;
      if (!(g.props.interactive && Uf(M, K))) {
        if (Wa(g.props.triggerTarget || e).some(function(se) {
          return Uf(se, K);
        })) {
          if (In.isTouch || g.state.isVisible && g.props.trigger.indexOf("click") >= 0)
            return;
        } else
          L("onClickOutside", [g, T]);
        g.props.hideOnClick === !0 && (g.clearDelayTimeouts(), g.hide(), s = !0, setTimeout(function() {
          s = !1;
        }), g.state.isMounted || P());
      }
    }
  }
  function H() {
    c = !0;
  }
  function _() {
    c = !1;
  }
  function X() {
    var T = O();
    T.addEventListener("mousedown", z, !0), T.addEventListener("touchend", z, Gr), T.addEventListener("touchstart", _, Gr), T.addEventListener("touchmove", H, Gr);
  }
  function P() {
    var T = O();
    T.removeEventListener("mousedown", z, !0), T.removeEventListener("touchend", z, Gr), T.removeEventListener("touchstart", _, Gr), T.removeEventListener("touchmove", H, Gr);
  }
  function Q(T, K) {
    ae(T, function() {
      !g.state.isVisible && M.parentNode && M.parentNode.contains(M) && K();
    });
  }
  function U(T, K) {
    ae(T, K);
  }
  function ae(T, K) {
    var se = I().box;
    function ve(pe) {
      pe.target === se && (Cd(se, "remove", ve), K());
    }
    if (T === 0)
      return K();
    Cd(se, "remove", h), Cd(se, "add", ve), h = ve;
  }
  function ee(T, K, se) {
    se === void 0 && (se = !1);
    var ve = Wa(g.props.triggerTarget || e);
    ve.forEach(function(pe) {
      pe.addEventListener(T, K, se), f.push({
        node: pe,
        eventType: T,
        handler: K,
        options: se
      });
    });
  }
  function de() {
    F() && (ee("touchstart", re, {
      passive: !0
    }), ee("touchend", me, {
      passive: !0
    })), hO(g.props.trigger).forEach(function(T) {
      if (T !== "manual")
        switch (ee(T, re), T) {
          case "mouseenter":
            ee("mouseleave", me);
            break;
          case "focus":
            ee(SO ? "focusout" : "blur", Pe);
            break;
          case "focusin":
            ee("focusout", Pe);
            break;
        }
    });
  }
  function Y() {
    f.forEach(function(T) {
      var K = T.node, se = T.eventType, ve = T.handler, pe = T.options;
      K.removeEventListener(se, ve, pe);
    }), f = [];
  }
  function re(T) {
    var K, se = !1;
    if (!(!g.state.isEnabled || Se(T) || s)) {
      var ve = ((K = u) == null ? void 0 : K.type) === "focus";
      u = T, m = T.currentTarget, E(), !g.state.isVisible && mO(T) && Ps.forEach(function(pe) {
        return pe(T);
      }), T.type === "click" && (g.props.trigger.indexOf("mouseenter") < 0 || o) && g.props.hideOnClick !== !1 && g.state.isVisible ? se = !0 : Rt(T), T.type === "click" && (o = !se), se && !ve && Xe(T);
    }
  }
  function te(T) {
    var K = T.target, se = B().contains(K) || M.contains(K);
    if (!(T.type === "mousemove" && se)) {
      var ve = Qe().concat(M).map(function(pe) {
        var Ve, Ge = pe._tippy, _t = (Ve = Ge.popperInstance) == null ? void 0 : Ve.state;
        return _t ? {
          popperRect: pe.getBoundingClientRect(),
          popperState: _t,
          props: n
        } : null;
      }).filter(Boolean);
      bO(ve, T) && (q(), Xe(T));
    }
  }
  function me(T) {
    var K = Se(T) || g.props.trigger.indexOf("click") >= 0 && o;
    if (!K) {
      if (g.props.interactive) {
        g.hideWithInteractivity(T);
        return;
      }
      Xe(T);
    }
  }
  function Pe(T) {
    g.props.trigger.indexOf("focusin") < 0 && T.target !== B() || g.props.interactive && T.relatedTarget && M.contains(T.relatedTarget) || Xe(T);
  }
  function Se(T) {
    return In.isTouch ? F() !== T.type.indexOf("touch") >= 0 : !1;
  }
  function _e() {
    Ot();
    var T = g.props, K = T.popperOptions, se = T.placement, ve = T.offset, pe = T.getReferenceClientRect, Ve = T.moveTransition, Ge = Z() ? Wu(M).arrow : null, _t = pe ? {
      getBoundingClientRect: pe,
      contextElement: pe.contextElement || B()
    } : e, zi = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Gn) {
        var Gt = Gn.state;
        if (Z()) {
          var _1 = I(), Fr = _1.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Zn) {
            Zn === "placement" ? Fr.setAttribute("data-placement", Gt.placement) : Gt.attributes.popper["data-popper-" + Zn] ? Fr.setAttribute("data-" + Zn, "") : Fr.removeAttribute("data-" + Zn);
          }), Gt.attributes.popper = {};
        }
      }
    }, It = [{
      name: "offset",
      options: {
        offset: ve
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !Ve
      }
    }, zi];
    Z() && Ge && It.push({
      name: "arrow",
      options: {
        element: Ge,
        padding: 3
      }
    }), It.push.apply(It, (K == null ? void 0 : K.modifiers) || []), g.popperInstance = h4(_t, M, Object.assign({}, K, {
      placement: se,
      onFirstUpdate: p,
      modifiers: It
    }));
  }
  function Ot() {
    g.popperInstance && (g.popperInstance.destroy(), g.popperInstance = null);
  }
  function Re() {
    var T = g.props.appendTo, K, se = B();
    g.props.interactive && T === m4 || T === "parent" ? K = se.parentNode : K = g4(T, [se]), K.contains(M) || K.appendChild(M), g.state.isMounted = !0, _e(), process.env.NODE_ENV !== "production" && Qn(g.props.interactive && T === Ut.appendTo && se.nextElementSibling !== M, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function Qe() {
    return Wc(M.querySelectorAll("[data-tippy-root]"));
  }
  function Rt(T) {
    g.clearDelayTimeouts(), T && L("onTrigger", [g, T]), X();
    var K = N(!0), se = $(), ve = se[0], pe = se[1];
    In.isTouch && ve === "hold" && pe && (K = pe), K ? r = setTimeout(function() {
      g.show();
    }, K) : g.show();
  }
  function Xe(T) {
    if (g.clearDelayTimeouts(), L("onUntrigger", [g, T]), !g.state.isVisible) {
      P();
      return;
    }
    if (!(g.props.trigger.indexOf("mouseenter") >= 0 && g.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(T.type) >= 0 && o)) {
      var K = N(!1);
      K ? a = setTimeout(function() {
        g.state.isVisible && g.hide();
      }, K) : i = requestAnimationFrame(function() {
        g.hide();
      });
    }
  }
  function Me() {
    g.state.isEnabled = !0;
  }
  function Fe() {
    g.hide(), g.state.isEnabled = !1;
  }
  function xn() {
    clearTimeout(r), clearTimeout(a), cancelAnimationFrame(i);
  }
  function Mn(T) {
    if (process.env.NODE_ENV !== "production" && Qn(g.state.isDestroyed, Da("setProps")), !g.state.isDestroyed) {
      L("onBeforeUpdate", [g, T]), Y();
      var K = g.props, se = Kf(e, Object.assign({}, K, Zf(T), {
        ignoreAttributes: !0
      }));
      g.props = se, de(), K.interactiveDebounce !== se.interactiveDebounce && (q(), y = _f(te, se.interactiveDebounce)), K.triggerTarget && !se.triggerTarget ? Wa(K.triggerTarget).forEach(function(ve) {
        ve.removeAttribute("aria-expanded");
      }) : se.triggerTarget && e.removeAttribute("aria-expanded"), E(), R(), S && S(K, se), g.popperInstance && (_e(), Qe().forEach(function(ve) {
        requestAnimationFrame(ve._tippy.popperInstance.forceUpdate);
      })), L("onAfterUpdate", [g, T]);
    }
  }
  function Et(T) {
    g.setProps({
      content: T
    });
  }
  function $1() {
    process.env.NODE_ENV !== "production" && Qn(g.state.isDestroyed, Da("show"));
    var T = g.state.isVisible, K = g.state.isDestroyed, se = !g.state.isEnabled, ve = In.isTouch && !g.props.touch, pe = Md(g.props.duration, 0, Ut.duration);
    if (!(T || K || se || ve) && !B().hasAttribute("disabled") && (L("onShow", [g], !1), g.props.onShow(g) !== !1)) {
      if (g.state.isVisible = !0, Z() && (M.style.visibility = "visible"), R(), X(), g.state.isMounted || (M.style.transition = "none"), Z()) {
        var Ve = I(), Ge = Ve.box, _t = Ve.content;
        wd([Ge, _t], 0);
      }
      p = function() {
        var It;
        if (!(!g.state.isVisible || l)) {
          if (l = !0, M.offsetHeight, M.style.transition = g.props.moveTransition, Z() && g.props.animation) {
            var jr = I(), Gn = jr.box, Gt = jr.content;
            wd([Gn, Gt], pe), Xf([Gn, Gt], "visible");
          }
          W(), E(), Gf(Sd, g), (It = g.popperInstance) == null || It.forceUpdate(), L("onMount", [g]), g.props.animation && Z() && U(pe, function() {
            g.state.isShown = !0, L("onShown", [g]);
          });
        }
      }, Re();
    }
  }
  function j1() {
    process.env.NODE_ENV !== "production" && Qn(g.state.isDestroyed, Da("hide"));
    var T = !g.state.isVisible, K = g.state.isDestroyed, se = !g.state.isEnabled, ve = Md(g.props.duration, 1, Ut.duration);
    if (!(T || K || se) && (L("onHide", [g], !1), g.props.onHide(g) !== !1)) {
      if (g.state.isVisible = !1, g.state.isShown = !1, l = !1, o = !1, Z() && (M.style.visibility = "hidden"), q(), P(), R(!0), Z()) {
        var pe = I(), Ve = pe.box, Ge = pe.content;
        g.props.animation && (wd([Ve, Ge], ve), Xf([Ve, Ge], "hidden"));
      }
      W(), E(), g.props.animation ? Z() && Q(ve, g.unmount) : g.unmount();
    }
  }
  function F1(T) {
    process.env.NODE_ENV !== "production" && Qn(g.state.isDestroyed, Da("hideWithInteractivity")), O().addEventListener("mousemove", y), Gf(Ps, y), y(T);
  }
  function W1() {
    process.env.NODE_ENV !== "production" && Qn(g.state.isDestroyed, Da("unmount")), g.state.isVisible && g.hide(), g.state.isMounted && (Ot(), Qe().forEach(function(T) {
      T._tippy.unmount();
    }), M.parentNode && M.parentNode.removeChild(M), Sd = Sd.filter(function(T) {
      return T !== g;
    }), g.state.isMounted = !1, L("onHidden", [g]));
  }
  function q1() {
    process.env.NODE_ENV !== "production" && Qn(g.state.isDestroyed, Da("destroy")), !g.state.isDestroyed && (g.clearDelayTimeouts(), g.unmount(), Y(), delete e._tippy, g.state.isDestroyed = !0, L("onDestroy", [g]));
  }
}
function Ii(e, t) {
  t === void 0 && (t = {});
  var n = Ut.plugins.concat(t.plugins || []);
  process.env.NODE_ENV !== "production" && (EO(e), M4(t, n)), wO();
  var r = Object.assign({}, t, {
    plugins: n
  }), a = vO(e);
  if (process.env.NODE_ENV !== "production") {
    var i = Ao(r.content), o = a.length > 1;
    Qn(i && o, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var s = a.reduce(function(c, l) {
    var u = l && RO(l, r);
    return u && c.push(u), c;
  }, []);
  return Ao(e) ? s[0] : s;
}
Ii.defaultProps = Ut;
Ii.setDefaultProps = TO;
Ii.currentInput = In;
Object.assign({}, Mp, {
  effect: function(t) {
    var n = t.state, r = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, r.popper), n.styles = r, n.elements.arrow && Object.assign(n.elements.arrow.style, r.arrow);
  }
});
Ii.setDefaultProps({
  render: w4
});
class VO {
  constructor({ editor: t, element: n, view: r, tippyOptions: a = {}, updateDelay: i = 250, shouldShow: o }) {
    this.preventHide = !1, this.shouldShow = ({ view: s, state: c, from: l, to: u }) => {
      const { doc: h, selection: p } = c, { empty: f } = p, y = !h.textBetween(l, u).length && l1(c.selection), m = this.element.contains(document.activeElement);
      return !(!(s.hasFocus() || m) || f || y || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: s }) => {
      var c;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      s != null && s.relatedTarget && (!((c = this.element.parentNode) === null || c === void 0) && c.contains(s.relatedTarget)) || this.hide();
    }, this.tippyBlurHandler = (s) => {
      this.blurHandler({ event: s });
    }, this.handleDebouncedUpdate = (s, c) => {
      const l = !(c != null && c.selection.eq(s.state.selection)), u = !(c != null && c.doc.eq(s.state.doc));
      !l && !u || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(s, l, u, c);
      }, this.updateDelay));
    }, this.updateHandler = (s, c, l, u) => {
      var h, p, f;
      const { state: y, composing: m } = s, { selection: v } = y;
      if (m || !c && !l)
        return;
      this.createTooltip();
      const { ranges: b } = v, x = Math.min(...b.map((M) => M.$from.pos)), g = Math.max(...b.map((M) => M.$to.pos));
      if (!((h = this.shouldShow) === null || h === void 0 ? void 0 : h.call(this, {
        editor: this.editor,
        view: s,
        state: y,
        oldState: u,
        from: x,
        to: g
      }))) {
        this.hide();
        return;
      }
      (p = this.tippy) === null || p === void 0 || p.setProps({
        getReferenceClientRect: ((f = this.tippyOptions) === null || f === void 0 ? void 0 : f.getReferenceClientRect) || (() => {
          if (CS(y.selection)) {
            let M = s.nodeDOM(x);
            const S = M.dataset.nodeViewWrapper ? M : M.querySelector("[data-node-view-wrapper]");
            if (S && (M = S.firstChild), M)
              return M.getBoundingClientRect();
          }
          return SS(s, x, g);
        })
      }), this.show();
    }, this.editor = t, this.element = n, this.view = r, this.updateDelay = i, o && (this.shouldShow = o), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = a, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: t } = this.editor.options, n = !!t.parentElement;
    this.tippy || !n || (this.tippy = Ii(t, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "top",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(t, n) {
    const { state: r } = t, a = r.selection.$from.pos !== r.selection.$to.pos;
    if (this.updateDelay > 0 && a) {
      this.handleDebouncedUpdate(t, n);
      return;
    }
    const i = !(n != null && n.selection.eq(t.state.selection)), o = !(n != null && n.doc.eq(t.state.doc));
    this.updateHandler(t, i, o, n);
  }
  show() {
    var t;
    (t = this.tippy) === null || t === void 0 || t.show();
  }
  hide() {
    var t;
    (t = this.tippy) === null || t === void 0 || t.hide();
  }
  destroy() {
    var t, n;
    !((t = this.tippy) === null || t === void 0) && t.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (n = this.tippy) === null || n === void 0 || n.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const C4 = (e) => new At({
  key: typeof e.pluginKey == "string" ? new nn(e.pluginKey) : e.pluginKey,
  view: (t) => new VO({ view: t, ...e })
}), zO = kt.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      C4({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        updateDelay: this.options.updateDelay,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
}), BO = (...e) => (t) => {
  e.forEach((n) => {
    typeof n == "function" ? n(t) : n && (n.current = t);
  });
}, HO = ({ renderers: e }) => V.createElement(V.Fragment, null, Object.entries(e).map(([t, n]) => qi.createPortal(n.reactElement, n.element, t)));
class $O extends V.Component {
  constructor(t) {
    super(t), this.editorContentRef = V.createRef(), this.initialized = !1, this.state = {
      renderers: {}
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    const { editor: t } = this.props;
    if (t && t.options.element) {
      if (t.contentComponent)
        return;
      const n = this.editorContentRef.current;
      n.append(...t.options.element.childNodes), t.setOptions({
        element: n
      }), t.contentComponent = this, t.createNodeViews(), this.initialized = !0;
    }
  }
  maybeFlushSync(t) {
    this.initialized ? jh(t) : t();
  }
  setRenderer(t, n) {
    this.maybeFlushSync(() => {
      this.setState(({ renderers: r }) => ({
        renderers: {
          ...r,
          [t]: n
        }
      }));
    });
  }
  removeRenderer(t) {
    this.maybeFlushSync(() => {
      this.setState(({ renderers: n }) => {
        const r = { ...n };
        return delete r[t], { renderers: r };
      });
    });
  }
  componentWillUnmount() {
    const { editor: t } = this.props;
    if (!t || (this.initialized = !1, t.isDestroyed || t.view.setProps({
      nodeViews: {}
    }), t.contentComponent = null, !t.options.element.firstChild))
      return;
    const n = document.createElement("div");
    n.append(...t.options.element.childNodes), t.setOptions({
      element: n
    });
  }
  render() {
    const { editor: t, innerRef: n, ...r } = this.props;
    return V.createElement(
      V.Fragment,
      null,
      V.createElement("div", { ref: BO(n, this.editorContentRef), ...r }),
      V.createElement(HO, { renderers: this.state.renderers })
    );
  }
}
const jO = Ae((e, t) => {
  const n = V.useMemo(() => Math.floor(Math.random() * 4294967295).toString(), [e.editor]);
  return V.createElement($O, {
    key: n,
    innerRef: t,
    ...e
  });
}), FO = V.memo(jO);
class WO extends QS {
  constructor() {
    super(...arguments), this.contentComponent = null;
  }
}
const qO = (e = {}, t = []) => {
  const n = he(null), [, r] = fe({}), { onBeforeCreate: a, onBlur: i, onCreate: o, onDestroy: s, onFocus: c, onSelectionUpdate: l, onTransaction: u, onUpdate: h } = e, p = he(a), f = he(i), y = he(o), m = he(s), v = he(c), k = he(l), b = he(u), x = he(h);
  return be(() => {
    n.current && (a && (n.current.off("beforeCreate", p.current), n.current.on("beforeCreate", a), p.current = a), i && (n.current.off("blur", f.current), n.current.on("blur", i), f.current = i), o && (n.current.off("create", y.current), n.current.on("create", o), y.current = o), s && (n.current.off("destroy", m.current), n.current.on("destroy", s), m.current = s), c && (n.current.off("focus", v.current), n.current.on("focus", c), v.current = c), l && (n.current.off("selectionUpdate", k.current), n.current.on("selectionUpdate", l), k.current = l), u && (n.current.off("transaction", b.current), n.current.on("transaction", u), b.current = u), h && (n.current.off("update", x.current), n.current.on("update", h), x.current = h));
  }, [a, i, o, s, c, l, u, h, n.current]), be(() => {
    let g = !0;
    const w = new WO(e);
    return n.current = w, n.current.on("transaction", () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          g && r({});
        });
      });
    }), () => {
      g = !1, w.destroy();
    };
  }, t), n.current;
}, S4 = $n({
  editor: null
});
S4.Consumer;
const _O = () => Ct(S4), GO = (e) => {
  const [t, n] = fe(null), { editor: r } = _O();
  return be(() => {
    var a;
    if (!t || !((a = e.editor) === null || a === void 0) && a.isDestroyed || r != null && r.isDestroyed)
      return;
    const { pluginKey: i = "bubbleMenu", editor: o, tippyOptions: s = {}, updateDelay: c, shouldShow: l = null } = e, u = o || r;
    if (!u) {
      console.warn("BubbleMenu component is not rendered inside of an editor component or does not have editor prop.");
      return;
    }
    const h = C4({
      updateDelay: c,
      editor: u,
      element: t,
      pluginKey: i,
      shouldShow: l,
      tippyOptions: s
    });
    return u.registerPlugin(h), () => u.unregisterPlugin(i);
  }, [e.editor, r, t]), V.createElement("div", { ref: n, className: e.className, style: { visibility: "hidden" } }, e.children);
}, A4 = $n({
  onDragStart: void 0
}), ZO = () => Ct(A4), O4 = V.forwardRef((e, t) => {
  const { onDragStart: n } = ZO(), r = e.as || "div";
  return V.createElement(r, { ...e, ref: t, "data-node-view-wrapper": "", onDragStart: n, style: {
    whiteSpace: "normal",
    ...e.style
  } });
});
function XO(e) {
  return !!(typeof e == "function" && e.prototype && e.prototype.isReactComponent);
}
function UO(e) {
  var t;
  return typeof e == "object" && ((t = e.$$typeof) === null || t === void 0 ? void 0 : t.toString()) === "Symbol(react.forward_ref)";
}
class E4 {
  constructor(t, { editor: n, props: r = {}, as: a = "div", className: i = "", attrs: o }) {
    this.ref = null, this.id = Math.floor(Math.random() * 4294967295).toString(), this.component = t, this.editor = n, this.props = r, this.element = document.createElement(a), this.element.classList.add("react-renderer"), i && this.element.classList.add(...i.split(" ")), o && Object.keys(o).forEach((s) => {
      this.element.setAttribute(s, o[s]);
    }), this.render();
  }
  render() {
    var t, n;
    const r = this.component, a = this.props;
    (XO(r) || UO(r)) && (a.ref = (i) => {
      this.ref = i;
    }), this.reactElement = V.createElement(r, { ...a }), (n = (t = this.editor) === null || t === void 0 ? void 0 : t.contentComponent) === null || n === void 0 || n.setRenderer(this.id, this);
  }
  updateProps(t = {}) {
    this.props = {
      ...this.props,
      ...t
    }, this.render();
  }
  destroy() {
    var t, n;
    (n = (t = this.editor) === null || t === void 0 ? void 0 : t.contentComponent) === null || n === void 0 || n.removeRenderer(this.id);
  }
}
class YO extends nA {
  mount() {
    const t = {
      editor: this.editor,
      node: this.node,
      decorations: this.decorations,
      selected: !1,
      extension: this.extension,
      getPos: () => this.getPos(),
      updateAttributes: (i = {}) => this.updateAttributes(i),
      deleteNode: () => this.deleteNode()
    };
    if (!this.component.displayName) {
      const i = (o) => o.charAt(0).toUpperCase() + o.substring(1);
      this.component.displayName = i(this.extension.name);
    }
    const n = (i) => {
      const o = this.component, s = this.onDragStart.bind(this), c = (l) => {
        l && this.contentDOMElement && l.firstChild !== this.contentDOMElement && l.appendChild(this.contentDOMElement);
      };
      return V.createElement(
        V.Fragment,
        null,
        V.createElement(
          A4.Provider,
          { value: { onDragStart: s, nodeViewContentRef: c } },
          V.createElement(o, { ...i })
        )
      );
    };
    n.displayName = "ReactNodeView", this.node.isLeaf ? this.contentDOMElement = null : this.options.contentDOMElementTag ? this.contentDOMElement = document.createElement(this.options.contentDOMElementTag) : this.contentDOMElement = document.createElement(this.node.isInline ? "span" : "div"), this.contentDOMElement && (this.contentDOMElement.style.whiteSpace = "inherit");
    let r = this.node.isInline ? "span" : "div";
    this.options.as && (r = this.options.as);
    const { className: a = "" } = this.options;
    this.handleSelectionUpdate = this.handleSelectionUpdate.bind(this), this.editor.on("selectionUpdate", this.handleSelectionUpdate), this.renderer = new E4(n, {
      editor: this.editor,
      props: t,
      as: r,
      className: `node-${this.node.type.name} ${a}`.trim(),
      attrs: this.options.attrs
    });
  }
  get dom() {
    var t;
    if (this.renderer.element.firstElementChild && !(!((t = this.renderer.element.firstElementChild) === null || t === void 0) && t.hasAttribute("data-node-view-wrapper")))
      throw Error("Please use the NodeViewWrapper component for your node view.");
    return this.renderer.element;
  }
  get contentDOM() {
    return this.node.isLeaf ? null : this.contentDOMElement;
  }
  handleSelectionUpdate() {
    const { from: t, to: n } = this.editor.state.selection;
    if (t <= this.getPos() && n >= this.getPos() + this.node.nodeSize) {
      if (this.renderer.props.selected)
        return;
      this.selectNode();
    } else {
      if (!this.renderer.props.selected)
        return;
      this.deselectNode();
    }
  }
  update(t, n) {
    const r = (a) => {
      this.renderer.updateProps(a);
    };
    if (t.type !== this.node.type)
      return !1;
    if (typeof this.options.update == "function") {
      const a = this.node, i = this.decorations;
      return this.node = t, this.decorations = n, this.options.update({
        oldNode: a,
        oldDecorations: i,
        newNode: t,
        newDecorations: n,
        updateProps: () => r({ node: t, decorations: n })
      });
    }
    return t === this.node && this.decorations === n || (this.node = t, this.decorations = n, r({ node: t, decorations: n })), !0;
  }
  selectNode() {
    this.renderer.updateProps({
      selected: !0
    }), this.renderer.element.classList.add("ProseMirror-selectednode");
  }
  deselectNode() {
    this.renderer.updateProps({
      selected: !1
    }), this.renderer.element.classList.remove("ProseMirror-selectednode");
  }
  destroy() {
    this.renderer.destroy(), this.editor.off("selectionUpdate", this.handleSelectionUpdate), this.contentDOMElement = null;
  }
}
function I4(e, t) {
  return (n) => n.editor.contentComponent ? new YO(e, n, t) : {};
}
const D4 = async (e) => URL.createObjectURL(e), T4 = (e) => {
}, N4 = $n({
  uploadImage: D4,
  onImageUploadError: T4
});
function at(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function JO(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Ip(...e) {
  return (t) => e.forEach(
    (n) => JO(n, t)
  );
}
function fn(...e) {
  return ue(Ip(...e), e);
}
function Di(e, t = []) {
  let n = [];
  function r(i, o) {
    const s = /* @__PURE__ */ $n(o), c = n.length;
    n = [
      ...n,
      o
    ];
    function l(h) {
      const { scope: p, children: f, ...y } = h, m = (p == null ? void 0 : p[e][c]) || s, v = wt(
        () => y,
        Object.values(y)
      );
      return /* @__PURE__ */ le(m.Provider, {
        value: v
      }, f);
    }
    function u(h, p) {
      const f = (p == null ? void 0 : p[e][c]) || s, y = Ct(f);
      if (y)
        return y;
      if (o !== void 0)
        return o;
      throw new Error(`\`${h}\` must be used within \`${i}\``);
    }
    return l.displayName = i + "Provider", [
      l,
      u
    ];
  }
  const a = () => {
    const i = n.map((o) => /* @__PURE__ */ $n(o));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || i;
      return wt(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return a.scopeName = e, [
    r,
    KO(a, ...t)
  ];
}
function KO(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (a) => ({
        useScope: a(),
        scopeName: a.scopeName
      })
    );
    return function(i) {
      const o = r.reduce((s, { useScope: c, scopeName: l }) => {
        const h = c(i)[`__scope${l}`];
        return {
          ...s,
          ...h
        };
      }, {});
      return wt(
        () => ({
          [`__scope${t.scopeName}`]: o
        }),
        [
          o
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const mi = /* @__PURE__ */ Ae((e, t) => {
  const { children: n, ...r } = e, a = Ya.toArray(n), i = a.find(eE);
  if (i) {
    const o = i.props.children, s = a.map((c) => c === i ? Ya.count(o) > 1 ? Ya.only(null) : /* @__PURE__ */ fo(o) ? o.props.children : null : c);
    return /* @__PURE__ */ le(qu, je({}, r, {
      ref: t
    }), /* @__PURE__ */ fo(o) ? /* @__PURE__ */ Ci(o, void 0, s) : null);
  }
  return /* @__PURE__ */ le(qu, je({}, r, {
    ref: t
  }), n);
});
mi.displayName = "Slot";
const qu = /* @__PURE__ */ Ae((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ fo(n) ? /* @__PURE__ */ Ci(n, {
    ...tE(r, n.props),
    ref: t ? Ip(t, n.ref) : n.ref
  }) : Ya.count(n) > 1 ? Ya.only(null) : null;
});
qu.displayName = "SlotClone";
const QO = ({ children: e }) => /* @__PURE__ */ le(ua, null, e);
function eE(e) {
  return /* @__PURE__ */ fo(e) && e.type === QO;
}
function tE(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...s) => {
      i(...s), a(...s);
    } : a && (n[r] = a) : r === "style" ? n[r] = {
      ...a,
      ...i
    } : r === "className" && (n[r] = [
      a,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const nE = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], xa = nE.reduce((e, t) => {
  const n = /* @__PURE__ */ Ae((r, a) => {
    const { asChild: i, ...o } = r, s = i ? mi : t;
    return be(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ le(s, je({}, o, {
      ref: a
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function rE(e, t) {
  e && jh(
    () => e.dispatchEvent(t)
  );
}
function qn(e) {
  const t = he(e);
  return be(() => {
    t.current = e;
  }), wt(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function aE(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = qn(e);
  be(() => {
    const r = (a) => {
      a.key === "Escape" && n(a);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const _u = "dismissableLayer.update", iE = "dismissableLayer.pointerDownOutside", oE = "dismissableLayer.focusOutside";
let ty;
const sE = /* @__PURE__ */ $n({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), P4 = /* @__PURE__ */ Ae((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: a, onPointerDownOutside: i, onFocusOutside: o, onInteractOutside: s, onDismiss: c, ...l } = e, u = Ct(sE), [h, p] = fe(null), f = (n = h == null ? void 0 : h.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, y] = fe({}), m = fn(
    t,
    (D) => p(D)
  ), v = Array.from(u.layers), [k] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), b = v.indexOf(k), x = h ? v.indexOf(h) : -1, g = u.layersWithOutsidePointerEventsDisabled.size > 0, w = x >= b, M = cE((D) => {
    const A = D.target, $ = [
      ...u.branches
    ].some(
      (F) => F.contains(A)
    );
    !w || $ || (i == null || i(D), s == null || s(D), D.defaultPrevented || c == null || c());
  }, f), S = lE((D) => {
    const A = D.target;
    [
      ...u.branches
    ].some(
      (F) => F.contains(A)
    ) || (o == null || o(D), s == null || s(D), D.defaultPrevented || c == null || c());
  }, f);
  return aE((D) => {
    x === u.layers.size - 1 && (a == null || a(D), !D.defaultPrevented && c && (D.preventDefault(), c()));
  }, f), be(() => {
    if (h)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (ty = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(h)), u.layers.add(h), ny(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = ty);
      };
  }, [
    h,
    f,
    r,
    u
  ]), be(() => () => {
    h && (u.layers.delete(h), u.layersWithOutsidePointerEventsDisabled.delete(h), ny());
  }, [
    h,
    u
  ]), be(() => {
    const D = () => y({});
    return document.addEventListener(_u, D), () => document.removeEventListener(_u, D);
  }, []), /* @__PURE__ */ le(xa.div, je({}, l, {
    ref: m,
    style: {
      pointerEvents: g ? w ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: at(e.onFocusCapture, S.onFocusCapture),
    onBlurCapture: at(e.onBlurCapture, S.onBlurCapture),
    onPointerDownCapture: at(e.onPointerDownCapture, M.onPointerDownCapture)
  }));
});
function cE(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = qn(e), r = he(!1), a = he(() => {
  });
  return be(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          L4(iE, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = l, t.addEventListener("click", a.current, {
          once: !0
        })) : l();
      } else
        t.removeEventListener("click", a.current);
      r.current = !1;
    }, o = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(o), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function lE(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = qn(e), r = he(!1);
  return be(() => {
    const a = (i) => {
      i.target && !r.current && L4(oE, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function ny() {
  const e = new CustomEvent(_u);
  document.dispatchEvent(e);
}
function L4(e, t, n, { discrete: r }) {
  const a = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && a.addEventListener(e, t, {
    once: !0
  }), r ? rE(a, i) : a.dispatchEvent(i);
}
let Ad = 0;
function R4() {
  be(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : ry()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : ry()), Ad++, () => {
      Ad === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), Ad--;
    };
  }, []);
}
function ry() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const Od = "focusScope.autoFocusOnMount", Ed = "focusScope.autoFocusOnUnmount", ay = {
  bubbles: !1,
  cancelable: !0
}, V4 = /* @__PURE__ */ Ae((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: a, onUnmountAutoFocus: i, ...o } = e, [s, c] = fe(null), l = qn(a), u = qn(i), h = he(null), p = fn(
    t,
    (m) => c(m)
  ), f = he({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  be(() => {
    if (r) {
      let m = function(x) {
        if (f.paused || !s)
          return;
        const g = x.target;
        s.contains(g) ? h.current = g : fr(h.current, {
          select: !0
        });
      }, v = function(x) {
        if (f.paused || !s)
          return;
        const g = x.relatedTarget;
        g !== null && (s.contains(g) || fr(h.current, {
          select: !0
        }));
      }, k = function(x) {
        if (document.activeElement === document.body)
          for (const w of x)
            w.removedNodes.length > 0 && fr(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", v);
      const b = new MutationObserver(k);
      return s && b.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", v), b.disconnect();
      };
    }
  }, [
    r,
    s,
    f.paused
  ]), be(() => {
    if (s) {
      oy.add(f);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const k = new CustomEvent(Od, ay);
        s.addEventListener(Od, l), s.dispatchEvent(k), k.defaultPrevented || (dE(yE(z4(s)), {
          select: !0
        }), document.activeElement === m && fr(s));
      }
      return () => {
        s.removeEventListener(Od, l), setTimeout(() => {
          const k = new CustomEvent(Ed, ay);
          s.addEventListener(Ed, u), s.dispatchEvent(k), k.defaultPrevented || fr(m ?? document.body, {
            select: !0
          }), s.removeEventListener(Ed, u), oy.remove(f);
        }, 0);
      };
    }
  }, [
    s,
    l,
    u,
    f
  ]);
  const y = ue((m) => {
    if (!n && !r || f.paused)
      return;
    const v = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, k = document.activeElement;
    if (v && k) {
      const b = m.currentTarget, [x, g] = uE(b);
      x && g ? !m.shiftKey && k === g ? (m.preventDefault(), n && fr(x, {
        select: !0
      })) : m.shiftKey && k === x && (m.preventDefault(), n && fr(g, {
        select: !0
      })) : k === b && m.preventDefault();
    }
  }, [
    n,
    r,
    f.paused
  ]);
  return /* @__PURE__ */ le(xa.div, je({
    tabIndex: -1
  }, o, {
    ref: p,
    onKeyDown: y
  }));
});
function dE(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (fr(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function uE(e) {
  const t = z4(e), n = iy(t, e), r = iy(t.reverse(), e);
  return [
    n,
    r
  ];
}
function z4(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const a = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || a ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function iy(e, t) {
  for (const n of e)
    if (!hE(n, {
      upTo: t
    }))
      return n;
}
function hE(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function pE(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function fr(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && pE(e) && t && e.select();
  }
}
const oy = fE();
function fE() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = sy(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = sy(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function sy(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function yE(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const gi = globalThis != null && globalThis.document ? Pl : () => {
}, mE = ne["useId".toString()] || (() => {
});
let gE = 0;
function Gu(e) {
  const [t, n] = ne.useState(mE());
  return gi(() => {
    e || n(
      (r) => r ?? String(gE++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const vE = ["top", "right", "bottom", "left"], Dr = Math.min, Zt = Math.max, qc = Math.round, Ls = Math.floor, Tr = (e) => ({
  x: e,
  y: e
}), kE = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, bE = {
  start: "end",
  end: "start"
};
function Zu(e, t, n) {
  return Zt(e, Dr(t, n));
}
function ir(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function or(e) {
  return e.split("-")[0];
}
function Ti(e) {
  return e.split("-")[1];
}
function Dp(e) {
  return e === "x" ? "y" : "x";
}
function Tp(e) {
  return e === "y" ? "height" : "width";
}
function Ni(e) {
  return ["top", "bottom"].includes(or(e)) ? "y" : "x";
}
function Np(e) {
  return Dp(Ni(e));
}
function xE(e, t, n) {
  n === void 0 && (n = !1);
  const r = Ti(e), a = Np(e), i = Tp(a);
  let o = a === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (o = _c(o)), [o, _c(o)];
}
function ME(e) {
  const t = _c(e);
  return [Xu(e), t, Xu(t)];
}
function Xu(e) {
  return e.replace(/start|end/g, (t) => bE[t]);
}
function wE(e, t, n) {
  const r = ["left", "right"], a = ["right", "left"], i = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? a : r : t ? r : a;
    case "left":
    case "right":
      return t ? i : o;
    default:
      return [];
  }
}
function CE(e, t, n, r) {
  const a = Ti(e);
  let i = wE(or(e), n === "start", r);
  return a && (i = i.map((o) => o + "-" + a), t && (i = i.concat(i.map(Xu)))), i;
}
function _c(e) {
  return e.replace(/left|right|bottom|top/g, (t) => kE[t]);
}
function SE(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function B4(e) {
  return typeof e != "number" ? SE(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Gc(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function cy(e, t, n) {
  let {
    reference: r,
    floating: a
  } = e;
  const i = Ni(t), o = Np(t), s = Tp(o), c = or(t), l = i === "y", u = r.x + r.width / 2 - a.width / 2, h = r.y + r.height / 2 - a.height / 2, p = r[s] / 2 - a[s] / 2;
  let f;
  switch (c) {
    case "top":
      f = {
        x: u,
        y: r.y - a.height
      };
      break;
    case "bottom":
      f = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      f = {
        x: r.x + r.width,
        y: h
      };
      break;
    case "left":
      f = {
        x: r.x - a.width,
        y: h
      };
      break;
    default:
      f = {
        x: r.x,
        y: r.y
      };
  }
  switch (Ti(t)) {
    case "start":
      f[o] -= p * (n && l ? -1 : 1);
      break;
    case "end":
      f[o] += p * (n && l ? -1 : 1);
      break;
  }
  return f;
}
const AE = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: a = "absolute",
    middleware: i = [],
    platform: o
  } = n, s = i.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let l = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: u,
    y: h
  } = cy(l, r, c), p = r, f = {}, y = 0;
  for (let m = 0; m < s.length; m++) {
    const {
      name: v,
      fn: k
    } = s[m], {
      x: b,
      y: x,
      data: g,
      reset: w
    } = await k({
      x: u,
      y: h,
      initialPlacement: r,
      placement: p,
      strategy: a,
      middlewareData: f,
      rects: l,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (u = b ?? u, h = x ?? h, f = {
      ...f,
      [v]: {
        ...f[v],
        ...g
      }
    }, w && y <= 50) {
      y++, typeof w == "object" && (w.placement && (p = w.placement), w.rects && (l = w.rects === !0 ? await o.getElementRects({
        reference: e,
        floating: t,
        strategy: a
      }) : w.rects), {
        x: u,
        y: h
      } = cy(l, p, c)), m = -1;
      continue;
    }
  }
  return {
    x: u,
    y: h,
    placement: p,
    strategy: a,
    middlewareData: f
  };
};
async function Eo(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: a,
    platform: i,
    rects: o,
    elements: s,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: h = "floating",
    altBoundary: p = !1,
    padding: f = 0
  } = ir(t, e), y = B4(f), v = s[p ? h === "floating" ? "reference" : "floating" : h], k = Gc(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(v))) == null || n ? v : v.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: l,
    rootBoundary: u,
    strategy: c
  })), b = h === "floating" ? {
    ...o.floating,
    x: r,
    y: a
  } : o.reference, x = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), g = await (i.isElement == null ? void 0 : i.isElement(x)) ? await (i.getScale == null ? void 0 : i.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, w = Gc(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: b,
    offsetParent: x,
    strategy: c
  }) : b);
  return {
    top: (k.top - w.top + y.top) / g.y,
    bottom: (w.bottom - k.bottom + y.bottom) / g.y,
    left: (k.left - w.left + y.left) / g.x,
    right: (w.right - k.right + y.right) / g.x
  };
}
const ly = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: a,
      rects: i,
      platform: o,
      elements: s,
      middlewareData: c
    } = t, {
      element: l,
      padding: u = 0
    } = ir(e, t) || {};
    if (l == null)
      return {};
    const h = B4(u), p = {
      x: n,
      y: r
    }, f = Np(a), y = Tp(f), m = await o.getDimensions(l), v = f === "y", k = v ? "top" : "left", b = v ? "bottom" : "right", x = v ? "clientHeight" : "clientWidth", g = i.reference[y] + i.reference[f] - p[f] - i.floating[y], w = p[f] - i.reference[f], M = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l));
    let S = M ? M[x] : 0;
    (!S || !await (o.isElement == null ? void 0 : o.isElement(M))) && (S = s.floating[x] || i.floating[y]);
    const D = g / 2 - w / 2, A = S / 2 - m[y] / 2 - 1, $ = Dr(h[k], A), F = Dr(h[b], A), Z = $, B = S - m[y] - F, O = S / 2 - m[y] / 2 + D, I = Zu(Z, O, B), N = !c.arrow && Ti(a) != null && O != I && i.reference[y] / 2 - (O < Z ? $ : F) - m[y] / 2 < 0, R = N ? O < Z ? O - Z : O - B : 0;
    return {
      [f]: p[f] + R,
      data: {
        [f]: I,
        centerOffset: O - I - R,
        ...N && {
          alignmentOffset: R
        }
      },
      reset: N
    };
  }
}), OE = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: a,
        middlewareData: i,
        rects: o,
        initialPlacement: s,
        platform: c,
        elements: l
      } = t, {
        mainAxis: u = !0,
        crossAxis: h = !0,
        fallbackPlacements: p,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: y = "none",
        flipAlignment: m = !0,
        ...v
      } = ir(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const k = or(a), b = or(s) === s, x = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), g = p || (b || !m ? [_c(s)] : ME(s));
      !p && y !== "none" && g.push(...CE(s, m, y, x));
      const w = [s, ...g], M = await Eo(t, v), S = [];
      let D = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (u && S.push(M[k]), h) {
        const Z = xE(a, o, x);
        S.push(M[Z[0]], M[Z[1]]);
      }
      if (D = [...D, {
        placement: a,
        overflows: S
      }], !S.every((Z) => Z <= 0)) {
        var A, $;
        const Z = (((A = i.flip) == null ? void 0 : A.index) || 0) + 1, B = w[Z];
        if (B)
          return {
            data: {
              index: Z,
              overflows: D
            },
            reset: {
              placement: B
            }
          };
        let O = ($ = D.filter((I) => I.overflows[0] <= 0).sort((I, N) => I.overflows[1] - N.overflows[1])[0]) == null ? void 0 : $.placement;
        if (!O)
          switch (f) {
            case "bestFit": {
              var F;
              const I = (F = D.map((N) => [N.placement, N.overflows.filter((R) => R > 0).reduce((R, L) => R + L, 0)]).sort((N, R) => N[1] - R[1])[0]) == null ? void 0 : F[0];
              I && (O = I);
              break;
            }
            case "initialPlacement":
              O = s;
              break;
          }
        if (a !== O)
          return {
            reset: {
              placement: O
            }
          };
      }
      return {};
    }
  };
};
function dy(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function uy(e) {
  return vE.some((t) => e[t] >= 0);
}
const EE = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...a
      } = ir(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await Eo(t, {
            ...a,
            elementContext: "reference"
          }), o = dy(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: uy(o)
            }
          };
        }
        case "escaped": {
          const i = await Eo(t, {
            ...a,
            altBoundary: !0
          }), o = dy(i, n.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: uy(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function IE(e, t) {
  const {
    placement: n,
    platform: r,
    elements: a
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(a.floating)), o = or(n), s = Ti(n), c = Ni(n) === "y", l = ["left", "top"].includes(o) ? -1 : 1, u = i && c ? -1 : 1, h = ir(t, e);
  let {
    mainAxis: p,
    crossAxis: f,
    alignmentAxis: y
  } = typeof h == "number" ? {
    mainAxis: h,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...h
  };
  return s && typeof y == "number" && (f = s === "end" ? y * -1 : y), c ? {
    x: f * u,
    y: p * l
  } : {
    x: p * l,
    y: f * u
  };
}
const DE = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r
      } = t, a = await IE(t, e);
      return {
        x: n + a.x,
        y: r + a.y,
        data: a
      };
    }
  };
}, TE = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (v) => {
            let {
              x: k,
              y: b
            } = v;
            return {
              x: k,
              y: b
            };
          }
        },
        ...c
      } = ir(e, t), l = {
        x: n,
        y: r
      }, u = await Eo(t, c), h = Ni(or(a)), p = Dp(h);
      let f = l[p], y = l[h];
      if (i) {
        const v = p === "y" ? "top" : "left", k = p === "y" ? "bottom" : "right", b = f + u[v], x = f - u[k];
        f = Zu(b, f, x);
      }
      if (o) {
        const v = h === "y" ? "top" : "left", k = h === "y" ? "bottom" : "right", b = y + u[v], x = y - u[k];
        y = Zu(b, y, x);
      }
      const m = s.fn({
        ...t,
        [p]: f,
        [h]: y
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r
        }
      };
    }
  };
}, NE = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: a,
        rects: i,
        middlewareData: o
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: l = !0
      } = ir(e, t), u = {
        x: n,
        y: r
      }, h = Ni(a), p = Dp(h);
      let f = u[p], y = u[h];
      const m = ir(s, t), v = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (c) {
        const x = p === "y" ? "height" : "width", g = i.reference[p] - i.floating[x] + v.mainAxis, w = i.reference[p] + i.reference[x] - v.mainAxis;
        f < g ? f = g : f > w && (f = w);
      }
      if (l) {
        var k, b;
        const x = p === "y" ? "width" : "height", g = ["top", "left"].includes(or(a)), w = i.reference[h] - i.floating[x] + (g && ((k = o.offset) == null ? void 0 : k[h]) || 0) + (g ? 0 : v.crossAxis), M = i.reference[h] + i.reference[x] + (g ? 0 : ((b = o.offset) == null ? void 0 : b[h]) || 0) - (g ? v.crossAxis : 0);
        y < w ? y = w : y > M && (y = M);
      }
      return {
        [p]: f,
        [h]: y
      };
    }
  };
}, PE = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: a,
        elements: i
      } = t, {
        apply: o = () => {
        },
        ...s
      } = ir(e, t), c = await Eo(t, s), l = or(n), u = Ti(n), h = Ni(n) === "y", {
        width: p,
        height: f
      } = r.floating;
      let y, m;
      l === "top" || l === "bottom" ? (y = l, m = u === (await (a.isRTL == null ? void 0 : a.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (m = l, y = u === "end" ? "top" : "bottom");
      const v = f - c[y], k = p - c[m], b = !t.middlewareData.shift;
      let x = v, g = k;
      if (h) {
        const M = p - c.left - c.right;
        g = u || b ? Dr(k, M) : M;
      } else {
        const M = f - c.top - c.bottom;
        x = u || b ? Dr(v, M) : M;
      }
      if (b && !u) {
        const M = Zt(c.left, 0), S = Zt(c.right, 0), D = Zt(c.top, 0), A = Zt(c.bottom, 0);
        h ? g = p - 2 * (M !== 0 || S !== 0 ? M + S : Zt(c.left, c.right)) : x = f - 2 * (D !== 0 || A !== 0 ? D + A : Zt(c.top, c.bottom));
      }
      await o({
        ...t,
        availableWidth: g,
        availableHeight: x
      });
      const w = await a.getDimensions(i.floating);
      return p !== w.width || f !== w.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Nr(e) {
  return H4(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Jt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function dr(e) {
  var t;
  return (t = (H4(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function H4(e) {
  return e instanceof Node || e instanceof Jt(e).Node;
}
function sr(e) {
  return e instanceof Element || e instanceof Jt(e).Element;
}
function _n(e) {
  return e instanceof HTMLElement || e instanceof Jt(e).HTMLElement;
}
function hy(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Jt(e).ShadowRoot;
}
function ss(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: a
  } = yn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(a);
}
function LE(e) {
  return ["table", "td", "th"].includes(Nr(e));
}
function Pp(e) {
  const t = Lp(), n = yn(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function RE(e) {
  let t = ki(e);
  for (; _n(t) && !p1(t); ) {
    if (Pp(t))
      return t;
    t = ki(t);
  }
  return null;
}
function Lp() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function p1(e) {
  return ["html", "body", "#document"].includes(Nr(e));
}
function yn(e) {
  return Jt(e).getComputedStyle(e);
}
function f1(e) {
  return sr(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function ki(e) {
  if (Nr(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    hy(e) && e.host || // Fallback.
    dr(e)
  );
  return hy(t) ? t.host : t;
}
function $4(e) {
  const t = ki(e);
  return p1(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : _n(t) && ss(t) ? t : $4(t);
}
function Io(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const a = $4(e), i = a === ((r = e.ownerDocument) == null ? void 0 : r.body), o = Jt(a);
  return i ? t.concat(o, o.visualViewport || [], ss(a) ? a : [], o.frameElement && n ? Io(o.frameElement) : []) : t.concat(a, Io(a, [], n));
}
function j4(e) {
  const t = yn(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const a = _n(e), i = a ? e.offsetWidth : n, o = a ? e.offsetHeight : r, s = qc(n) !== i || qc(r) !== o;
  return s && (n = i, r = o), {
    width: n,
    height: r,
    $: s
  };
}
function Rp(e) {
  return sr(e) ? e : e.contextElement;
}
function ti(e) {
  const t = Rp(e);
  if (!_n(t))
    return Tr(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: a,
    $: i
  } = j4(t);
  let o = (i ? qc(n.width) : n.width) / r, s = (i ? qc(n.height) : n.height) / a;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const VE = /* @__PURE__ */ Tr(0);
function F4(e) {
  const t = Jt(e);
  return !Lp() || !t.visualViewport ? VE : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function zE(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Jt(e) ? !1 : t;
}
function ga(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), i = Rp(e);
  let o = Tr(1);
  t && (r ? sr(r) && (o = ti(r)) : o = ti(e));
  const s = zE(i, n, r) ? F4(i) : Tr(0);
  let c = (a.left + s.x) / o.x, l = (a.top + s.y) / o.y, u = a.width / o.x, h = a.height / o.y;
  if (i) {
    const p = Jt(i), f = r && sr(r) ? Jt(r) : r;
    let y = p.frameElement;
    for (; y && r && f !== p; ) {
      const m = ti(y), v = y.getBoundingClientRect(), k = yn(y), b = v.left + (y.clientLeft + parseFloat(k.paddingLeft)) * m.x, x = v.top + (y.clientTop + parseFloat(k.paddingTop)) * m.y;
      c *= m.x, l *= m.y, u *= m.x, h *= m.y, c += b, l += x, y = Jt(y).frameElement;
    }
  }
  return Gc({
    width: u,
    height: h,
    x: c,
    y: l
  });
}
function BE(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const a = _n(n), i = dr(n);
  if (n === i)
    return t;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = Tr(1);
  const c = Tr(0);
  if ((a || !a && r !== "fixed") && ((Nr(n) !== "body" || ss(i)) && (o = f1(n)), _n(n))) {
    const l = ga(n);
    s = ti(n), c.x = l.x + n.clientLeft, c.y = l.y + n.clientTop;
  }
  return {
    width: t.width * s.x,
    height: t.height * s.y,
    x: t.x * s.x - o.scrollLeft * s.x + c.x,
    y: t.y * s.y - o.scrollTop * s.y + c.y
  };
}
function HE(e) {
  return Array.from(e.getClientRects());
}
function W4(e) {
  return ga(dr(e)).left + f1(e).scrollLeft;
}
function $E(e) {
  const t = dr(e), n = f1(e), r = e.ownerDocument.body, a = Zt(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = Zt(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -n.scrollLeft + W4(e);
  const s = -n.scrollTop;
  return yn(r).direction === "rtl" && (o += Zt(t.clientWidth, r.clientWidth) - a), {
    width: a,
    height: i,
    x: o,
    y: s
  };
}
function jE(e, t) {
  const n = Jt(e), r = dr(e), a = n.visualViewport;
  let i = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
  if (a) {
    i = a.width, o = a.height;
    const l = Lp();
    (!l || l && t === "fixed") && (s = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s,
    y: c
  };
}
function FE(e, t) {
  const n = ga(e, !0, t === "fixed"), r = n.top + e.clientTop, a = n.left + e.clientLeft, i = _n(e) ? ti(e) : Tr(1), o = e.clientWidth * i.x, s = e.clientHeight * i.y, c = a * i.x, l = r * i.y;
  return {
    width: o,
    height: s,
    x: c,
    y: l
  };
}
function py(e, t, n) {
  let r;
  if (t === "viewport")
    r = jE(e, n);
  else if (t === "document")
    r = $E(dr(e));
  else if (sr(t))
    r = FE(t, n);
  else {
    const a = F4(e);
    r = {
      ...t,
      x: t.x - a.x,
      y: t.y - a.y
    };
  }
  return Gc(r);
}
function q4(e, t) {
  const n = ki(e);
  return n === t || !sr(n) || p1(n) ? !1 : yn(n).position === "fixed" || q4(n, t);
}
function WE(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Io(e, [], !1).filter((s) => sr(s) && Nr(s) !== "body"), a = null;
  const i = yn(e).position === "fixed";
  let o = i ? ki(e) : e;
  for (; sr(o) && !p1(o); ) {
    const s = yn(o), c = Pp(o);
    !c && s.position === "fixed" && (a = null), (i ? !c && !a : !c && s.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || ss(o) && !c && q4(e, o)) ? r = r.filter((u) => u !== o) : a = s, o = ki(o);
  }
  return t.set(e, r), r;
}
function qE(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: a
  } = e;
  const o = [...n === "clippingAncestors" ? WE(t, this._c) : [].concat(n), r], s = o[0], c = o.reduce((l, u) => {
    const h = py(t, u, a);
    return l.top = Zt(h.top, l.top), l.right = Dr(h.right, l.right), l.bottom = Dr(h.bottom, l.bottom), l.left = Zt(h.left, l.left), l;
  }, py(t, s, a));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function _E(e) {
  return j4(e);
}
function GE(e, t, n) {
  const r = _n(t), a = dr(t), i = n === "fixed", o = ga(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Tr(0);
  if (r || !r && !i)
    if ((Nr(t) !== "body" || ss(a)) && (s = f1(t)), r) {
      const l = ga(t, !0, i, t);
      c.x = l.x + t.clientLeft, c.y = l.y + t.clientTop;
    } else
      a && (c.x = W4(a));
  return {
    x: o.left + s.scrollLeft - c.x,
    y: o.top + s.scrollTop - c.y,
    width: o.width,
    height: o.height
  };
}
function fy(e, t) {
  return !_n(e) || yn(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function _4(e, t) {
  const n = Jt(e);
  if (!_n(e))
    return n;
  let r = fy(e, t);
  for (; r && LE(r) && yn(r).position === "static"; )
    r = fy(r, t);
  return r && (Nr(r) === "html" || Nr(r) === "body" && yn(r).position === "static" && !Pp(r)) ? n : r || RE(e) || n;
}
const ZE = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: r
  } = e;
  const a = this.getOffsetParent || _4, i = this.getDimensions;
  return {
    reference: GE(t, await a(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await i(n)
    }
  };
};
function XE(e) {
  return yn(e).direction === "rtl";
}
const UE = {
  convertOffsetParentRelativeRectToViewportRelativeRect: BE,
  getDocumentElement: dr,
  getClippingRect: qE,
  getOffsetParent: _4,
  getElementRects: ZE,
  getClientRects: HE,
  getDimensions: _E,
  getScale: ti,
  isElement: sr,
  isRTL: XE
};
function YE(e, t) {
  let n = null, r;
  const a = dr(e);
  function i() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function o(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), i();
    const {
      left: l,
      top: u,
      width: h,
      height: p
    } = e.getBoundingClientRect();
    if (s || t(), !h || !p)
      return;
    const f = Ls(u), y = Ls(a.clientWidth - (l + h)), m = Ls(a.clientHeight - (u + p)), v = Ls(l), b = {
      rootMargin: -f + "px " + -y + "px " + -m + "px " + -v + "px",
      threshold: Zt(0, Dr(1, c)) || 1
    };
    let x = !0;
    function g(w) {
      const M = w[0].intersectionRatio;
      if (M !== c) {
        if (!x)
          return o();
        M ? o(!1, M) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 100);
      }
      x = !1;
    }
    try {
      n = new IntersectionObserver(g, {
        ...b,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(g, b);
    }
    n.observe(e);
  }
  return o(!0), i;
}
function JE(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, l = Rp(e), u = a || i ? [...l ? Io(l) : [], ...Io(t)] : [];
  u.forEach((k) => {
    a && k.addEventListener("scroll", n, {
      passive: !0
    }), i && k.addEventListener("resize", n);
  });
  const h = l && s ? YE(l, n) : null;
  let p = -1, f = null;
  o && (f = new ResizeObserver((k) => {
    let [b] = k;
    b && b.target === l && f && (f.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      f && f.observe(t);
    })), n();
  }), l && !c && f.observe(l), f.observe(t));
  let y, m = c ? ga(e) : null;
  c && v();
  function v() {
    const k = ga(e);
    m && (k.x !== m.x || k.y !== m.y || k.width !== m.width || k.height !== m.height) && n(), m = k, y = requestAnimationFrame(v);
  }
  return n(), () => {
    u.forEach((k) => {
      a && k.removeEventListener("scroll", n), i && k.removeEventListener("resize", n);
    }), h && h(), f && f.disconnect(), f = null, c && cancelAnimationFrame(y);
  };
}
const KE = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), a = {
    platform: UE,
    ...n
  }, i = {
    ...a.platform,
    _c: r
  };
  return AE(e, t, {
    ...a,
    platform: i
  });
}, QE = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: a
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? ly({
        element: r.current,
        padding: a
      }).fn(n) : {} : r ? ly({
        element: r,
        padding: a
      }).fn(n) : {};
    }
  };
};
var sc = typeof document < "u" ? Pl : be;
function Zc(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Zc(e[r], t[r]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = a[r];
      if (!(i === "_owner" && e.$$typeof) && !Zc(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function G4(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function yy(e, t) {
  const n = G4(e);
  return Math.round(t * n) / n;
}
function my(e) {
  const t = ne.useRef(e);
  return sc(() => {
    t.current = e;
  }), t;
}
function eI(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: a,
    elements: {
      reference: i,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: l
  } = e, [u, h] = ne.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, f] = ne.useState(r);
  Zc(p, r) || f(r);
  const [y, m] = ne.useState(null), [v, k] = ne.useState(null), b = ne.useCallback((N) => {
    N != M.current && (M.current = N, m(N));
  }, [m]), x = ne.useCallback((N) => {
    N !== S.current && (S.current = N, k(N));
  }, [k]), g = i || y, w = o || v, M = ne.useRef(null), S = ne.useRef(null), D = ne.useRef(u), A = my(c), $ = my(a), F = ne.useCallback(() => {
    if (!M.current || !S.current)
      return;
    const N = {
      placement: t,
      strategy: n,
      middleware: p
    };
    $.current && (N.platform = $.current), KE(M.current, S.current, N).then((R) => {
      const L = {
        ...R,
        isPositioned: !0
      };
      Z.current && !Zc(D.current, L) && (D.current = L, r6.flushSync(() => {
        h(L);
      }));
    });
  }, [p, t, n, $]);
  sc(() => {
    l === !1 && D.current.isPositioned && (D.current.isPositioned = !1, h((N) => ({
      ...N,
      isPositioned: !1
    })));
  }, [l]);
  const Z = ne.useRef(!1);
  sc(() => (Z.current = !0, () => {
    Z.current = !1;
  }), []), sc(() => {
    if (g && (M.current = g), w && (S.current = w), g && w) {
      if (A.current)
        return A.current(g, w, F);
      F();
    }
  }, [g, w, F, A]);
  const B = ne.useMemo(() => ({
    reference: M,
    floating: S,
    setReference: b,
    setFloating: x
  }), [b, x]), O = ne.useMemo(() => ({
    reference: g,
    floating: w
  }), [g, w]), I = ne.useMemo(() => {
    const N = {
      position: n,
      left: 0,
      top: 0
    };
    if (!O.floating)
      return N;
    const R = yy(O.floating, u.x), L = yy(O.floating, u.y);
    return s ? {
      ...N,
      transform: "translate(" + R + "px, " + L + "px)",
      ...G4(O.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: R,
      top: L
    };
  }, [n, s, O.floating, u.x, u.y]);
  return ne.useMemo(() => ({
    ...u,
    update: F,
    refs: B,
    elements: O,
    floatingStyles: I
  }), [u, F, B, O, I]);
}
function tI(e) {
  const [t, n] = fe(void 0);
  return gi(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length)
          return;
        const i = a[0];
        let o, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          o = l.inlineSize, s = l.blockSize;
        } else
          o = e.offsetWidth, s = e.offsetHeight;
        n({
          width: o,
          height: s
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const Z4 = "Popper", [X4, y1] = Di(Z4), [nI, U4] = X4(Z4), rI = (e) => {
  const { __scopePopper: t, children: n } = e, [r, a] = fe(null);
  return /* @__PURE__ */ le(nI, {
    scope: t,
    anchor: r,
    onAnchorChange: a
  }, n);
}, aI = "PopperAnchor", iI = /* @__PURE__ */ Ae((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...a } = e, i = U4(aI, n), o = he(null), s = fn(t, o);
  return be(() => {
    i.onAnchorChange((r == null ? void 0 : r.current) || o.current);
  }), r ? null : /* @__PURE__ */ le(xa.div, je({}, a, {
    ref: s
  }));
}), Y4 = "PopperContent", [oI, E4e] = X4(Y4), sI = /* @__PURE__ */ Ae((e, t) => {
  var n, r, a, i, o, s, c, l;
  const { __scopePopper: u, side: h = "bottom", sideOffset: p = 0, align: f = "center", alignOffset: y = 0, arrowPadding: m = 0, avoidCollisions: v = !0, collisionBoundary: k = [], collisionPadding: b = 0, sticky: x = "partial", hideWhenDetached: g = !1, updatePositionStrategy: w = "optimized", onPlaced: M, ...S } = e, D = U4(Y4, u), [A, $] = fe(null), F = fn(
    t,
    (me) => $(me)
  ), [Z, B] = fe(null), O = tI(Z), I = (n = O == null ? void 0 : O.width) !== null && n !== void 0 ? n : 0, N = (r = O == null ? void 0 : O.height) !== null && r !== void 0 ? r : 0, R = h + (f !== "center" ? "-" + f : ""), L = typeof b == "number" ? b : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...b
  }, W = Array.isArray(k) ? k : [
    k
  ], E = W.length > 0, q = {
    padding: L,
    boundary: W.filter(cI),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: E
  }, { refs: z, floatingStyles: H, placement: _, isPositioned: X, middlewareData: P } = eI({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: R,
    whileElementsMounted: (...me) => JE(...me, {
      animationFrame: w === "always"
    }),
    elements: {
      reference: D.anchor
    },
    middleware: [
      DE({
        mainAxis: p + N,
        alignmentAxis: y
      }),
      v && TE({
        mainAxis: !0,
        crossAxis: !1,
        limiter: x === "partial" ? NE() : void 0,
        ...q
      }),
      v && OE({
        ...q
      }),
      PE({
        ...q,
        apply: ({ elements: me, rects: Pe, availableWidth: Se, availableHeight: _e }) => {
          const { width: Ot, height: Re } = Pe.reference, Qe = me.floating.style;
          Qe.setProperty("--radix-popper-available-width", `${Se}px`), Qe.setProperty("--radix-popper-available-height", `${_e}px`), Qe.setProperty("--radix-popper-anchor-width", `${Ot}px`), Qe.setProperty("--radix-popper-anchor-height", `${Re}px`);
        }
      }),
      Z && QE({
        element: Z,
        padding: m
      }),
      lI({
        arrowWidth: I,
        arrowHeight: N
      }),
      g && EE({
        strategy: "referenceHidden",
        ...q
      })
    ]
  }), [Q, U] = J4(_), ae = qn(M);
  gi(() => {
    X && (ae == null || ae());
  }, [
    X,
    ae
  ]);
  const ee = (a = P.arrow) === null || a === void 0 ? void 0 : a.x, de = (i = P.arrow) === null || i === void 0 ? void 0 : i.y, Y = ((o = P.arrow) === null || o === void 0 ? void 0 : o.centerOffset) !== 0, [re, te] = fe();
  return gi(() => {
    A && te(window.getComputedStyle(A).zIndex);
  }, [
    A
  ]), /* @__PURE__ */ le("div", {
    ref: z.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...H,
      transform: X ? H.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: re,
      "--radix-popper-transform-origin": [
        (s = P.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = P.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ le(oI, {
    scope: u,
    placedSide: Q,
    onArrowChange: B,
    arrowX: ee,
    arrowY: de,
    shouldHideArrow: Y
  }, /* @__PURE__ */ le(xa.div, je({
    "data-side": Q,
    "data-align": U
  }, S, {
    ref: F,
    style: {
      ...S.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: X ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (l = P.hide) !== null && l !== void 0 && l.referenceHidden ? 0 : void 0
    }
  }))));
});
function cI(e) {
  return e !== null;
}
const lI = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, a, i, o;
    const { placement: s, rects: c, middlewareData: l } = t, h = ((n = l.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, p = h ? 0 : e.arrowWidth, f = h ? 0 : e.arrowHeight, [y, m] = J4(s), v = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[m], k = ((r = (a = l.arrow) === null || a === void 0 ? void 0 : a.x) !== null && r !== void 0 ? r : 0) + p / 2, b = ((i = (o = l.arrow) === null || o === void 0 ? void 0 : o.y) !== null && i !== void 0 ? i : 0) + f / 2;
    let x = "", g = "";
    return y === "bottom" ? (x = h ? v : `${k}px`, g = `${-f}px`) : y === "top" ? (x = h ? v : `${k}px`, g = `${c.floating.height + f}px`) : y === "right" ? (x = `${-f}px`, g = h ? v : `${b}px`) : y === "left" && (x = `${c.floating.width + f}px`, g = h ? v : `${b}px`), {
      data: {
        x,
        y: g
      }
    };
  }
});
function J4(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const K4 = rI, Q4 = iI, e5 = sI;
function dI(e, t) {
  return t6((n, r) => {
    const a = t[n][r];
    return a ?? n;
  }, e);
}
const Vp = (e) => {
  const { present: t, children: n } = e, r = uI(t), a = typeof n == "function" ? n({
    present: r.isPresent
  }) : Ya.only(n), i = fn(r.ref, a.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Ci(a, {
    ref: i
  }) : null;
};
Vp.displayName = "Presence";
function uI(e) {
  const [t, n] = fe(), r = he({}), a = he(e), i = he("none"), o = e ? "mounted" : "unmounted", [s, c] = dI(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return be(() => {
    const l = Rs(r.current);
    i.current = s === "mounted" ? l : "none";
  }, [
    s
  ]), gi(() => {
    const l = r.current, u = a.current;
    if (u !== e) {
      const p = i.current, f = Rs(l);
      e ? c("MOUNT") : f === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(u && p !== f ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [
    e,
    c
  ]), gi(() => {
    if (t) {
      const l = (h) => {
        const f = Rs(r.current).includes(h.animationName);
        h.target === t && f && jh(
          () => c("ANIMATION_END")
        );
      }, u = (h) => {
        h.target === t && (i.current = Rs(r.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: ue((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function Rs(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function zp({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, a] = hI({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, o = i ? e : r, s = qn(n), c = ue((l) => {
    if (i) {
      const h = typeof l == "function" ? l(e) : l;
      h !== e && s(h);
    } else
      a(l);
  }, [
    i,
    e,
    a,
    s
  ]);
  return [
    o,
    c
  ];
}
function hI({ defaultProp: e, onChange: t }) {
  const n = fe(e), [r] = n, a = he(r), i = qn(t);
  return be(() => {
    a.current !== r && (i(r), a.current = r);
  }, [
    r,
    a,
    i
  ]), n;
}
var pI = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Ta = /* @__PURE__ */ new WeakMap(), Vs = /* @__PURE__ */ new WeakMap(), zs = {}, Id = 0, t5 = function(e) {
  return e && (e.host || t5(e.parentNode));
}, fI = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = t5(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, yI = function(e, t, n, r) {
  var a = fI(t, Array.isArray(e) ? e : [e]);
  zs[n] || (zs[n] = /* @__PURE__ */ new WeakMap());
  var i = zs[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(a), l = function(h) {
    !h || s.has(h) || (s.add(h), l(h.parentNode));
  };
  a.forEach(l);
  var u = function(h) {
    !h || c.has(h) || Array.prototype.forEach.call(h.children, function(p) {
      if (s.has(p))
        u(p);
      else {
        var f = p.getAttribute(r), y = f !== null && f !== "false", m = (Ta.get(p) || 0) + 1, v = (i.get(p) || 0) + 1;
        Ta.set(p, m), i.set(p, v), o.push(p), m === 1 && y && Vs.set(p, !0), v === 1 && p.setAttribute(n, "true"), y || p.setAttribute(r, "true");
      }
    });
  };
  return u(t), s.clear(), Id++, function() {
    o.forEach(function(h) {
      var p = Ta.get(h) - 1, f = i.get(h) - 1;
      Ta.set(h, p), i.set(h, f), p || (Vs.has(h) || h.removeAttribute(r), Vs.delete(h)), f || h.removeAttribute(n);
    }), Id--, Id || (Ta = /* @__PURE__ */ new WeakMap(), Ta = /* @__PURE__ */ new WeakMap(), Vs = /* @__PURE__ */ new WeakMap(), zs = {});
  };
}, n5 = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), a = t || pI(e);
  return a ? (r.push.apply(r, Array.from(a.querySelectorAll("[aria-live]"))), yI(r, a, n, "aria-hidden")) : function() {
    return null;
  };
}, Pn = function() {
  return Pn = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Pn.apply(this, arguments);
};
function r5(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function mI(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, a = t.length, i; r < a; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var cc = "right-scroll-bar-position", lc = "width-before-scroll-bar", gI = "with-scroll-bars-hidden", vI = "--removed-body-scroll-bar-size";
function kI(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function bI(e, t) {
  var n = fe(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var a = n.value;
          a !== r && (n.value = r, n.callback(r, a));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
function xI(e, t) {
  return bI(t || null, function(n) {
    return e.forEach(function(r) {
      return kI(r, n);
    });
  });
}
function MI(e) {
  return e;
}
function wI(e, t) {
  t === void 0 && (t = MI);
  var n = [], r = !1, a = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var o = t(i, r);
      return n.push(o), function() {
        n = n.filter(function(s) {
          return s !== o;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var o = n;
        n = [], o.forEach(i);
      }
      n = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var o = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(i), o = n;
      }
      var c = function() {
        var u = o;
        o = [], u.forEach(i);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), n = {
        push: function(u) {
          o.push(u), l();
        },
        filter: function(u) {
          return o = o.filter(u), n;
        }
      };
    }
  };
  return a;
}
function CI(e) {
  e === void 0 && (e = {});
  var t = wI(null);
  return t.options = Pn({ async: !0, ssr: !1 }, e), t;
}
var a5 = function(e) {
  var t = e.sideCar, n = r5(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return ne.createElement(r, Pn({}, n));
};
a5.isSideCarExport = !0;
function SI(e, t) {
  return e.useMedium(t), a5;
}
var i5 = CI(), Dd = function() {
}, m1 = ne.forwardRef(function(e, t) {
  var n = ne.useRef(null), r = ne.useState({
    onScrollCapture: Dd,
    onWheelCapture: Dd,
    onTouchMoveCapture: Dd
  }), a = r[0], i = r[1], o = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, h = e.shards, p = e.sideCar, f = e.noIsolation, y = e.inert, m = e.allowPinchZoom, v = e.as, k = v === void 0 ? "div" : v, b = r5(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), x = p, g = xI([n, t]), w = Pn(Pn({}, b), a);
  return ne.createElement(
    ne.Fragment,
    null,
    u && ne.createElement(x, { sideCar: i5, removeScrollBar: l, shards: h, noIsolation: f, inert: y, setCallbacks: i, allowPinchZoom: !!m, lockRef: n }),
    o ? ne.cloneElement(ne.Children.only(s), Pn(Pn({}, w), { ref: g })) : ne.createElement(k, Pn({}, w, { className: c, ref: g }), s)
  );
});
m1.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
m1.classNames = {
  fullWidth: lc,
  zeroRight: cc
};
var gy, AI = function() {
  if (gy)
    return gy;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function OI() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = AI();
  return t && e.setAttribute("nonce", t), e;
}
function EI(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function II(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var DI = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = OI()) && (EI(t, n), II(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, TI = function() {
  var e = DI();
  return function(t, n) {
    ne.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, o5 = function() {
  var e = TI(), t = function(n) {
    var r = n.styles, a = n.dynamic;
    return e(r, a), null;
  };
  return t;
}, NI = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Td = function(e) {
  return parseInt(e || "", 10) || 0;
}, PI = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Td(n), Td(r), Td(a)];
}, LI = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return NI;
  var t = PI(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, RI = o5(), VI = function(e, t, n, r) {
  var a = e.left, i = e.top, o = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(gI, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(cc, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(lc, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(cc, " .").concat(cc, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(lc, " .").concat(lc, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat(vI, ": ").concat(s, `px;
  }
`);
}, zI = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, a = r === void 0 ? "margin" : r, i = ne.useMemo(function() {
    return LI(a);
  }, [a]);
  return ne.createElement(RI, { styles: VI(i, !t, a, n ? "" : "!important") });
}, Uu = !1;
if (typeof window < "u")
  try {
    var Bs = Object.defineProperty({}, "passive", {
      get: function() {
        return Uu = !0, !0;
      }
    });
    window.addEventListener("test", Bs, Bs), window.removeEventListener("test", Bs, Bs);
  } catch {
    Uu = !1;
  }
var Na = Uu ? { passive: !1 } : !1, BI = function(e) {
  return e.tagName === "TEXTAREA";
}, s5 = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !BI(e) && n[t] === "visible")
  );
}, HI = function(e) {
  return s5(e, "overflowY");
}, $I = function(e) {
  return s5(e, "overflowX");
}, vy = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = c5(e, n);
    if (r) {
      var a = l5(e, n), i = a[1], o = a[2];
      if (i > o)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, jI = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, FI = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, c5 = function(e, t) {
  return e === "v" ? HI(t) : $I(t);
}, l5 = function(e, t) {
  return e === "v" ? jI(t) : FI(t);
}, WI = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, qI = function(e, t, n, r, a) {
  var i = WI(e, window.getComputedStyle(t).direction), o = i * r, s = n.target, c = t.contains(s), l = !1, u = o > 0, h = 0, p = 0;
  do {
    var f = l5(e, s), y = f[0], m = f[1], v = f[2], k = m - v - i * y;
    (y || k) && c5(e, s) && (h += k, p += y), s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (u && (a && h === 0 || !a && o > h) || !u && (a && p === 0 || !a && -o > p)) && (l = !0), l;
}, Hs = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, ky = function(e) {
  return [e.deltaX, e.deltaY];
}, by = function(e) {
  return e && "current" in e ? e.current : e;
}, _I = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, GI = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, ZI = 0, Pa = [];
function XI(e) {
  var t = ne.useRef([]), n = ne.useRef([0, 0]), r = ne.useRef(), a = ne.useState(ZI++)[0], i = ne.useState(function() {
    return o5();
  })[0], o = ne.useRef(e);
  ne.useEffect(function() {
    o.current = e;
  }, [e]), ne.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var m = mI([e.lockRef.current], (e.shards || []).map(by), !0).filter(Boolean);
      return m.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), m.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = ne.useCallback(function(m, v) {
    if ("touches" in m && m.touches.length === 2)
      return !o.current.allowPinchZoom;
    var k = Hs(m), b = n.current, x = "deltaX" in m ? m.deltaX : b[0] - k[0], g = "deltaY" in m ? m.deltaY : b[1] - k[1], w, M = m.target, S = Math.abs(x) > Math.abs(g) ? "h" : "v";
    if ("touches" in m && S === "h" && M.type === "range")
      return !1;
    var D = vy(S, M);
    if (!D)
      return !0;
    if (D ? w = S : (w = S === "v" ? "h" : "v", D = vy(S, M)), !D)
      return !1;
    if (!r.current && "changedTouches" in m && (x || g) && (r.current = w), !w)
      return !0;
    var A = r.current || w;
    return qI(A, v, m, A === "h" ? x : g, !0);
  }, []), c = ne.useCallback(function(m) {
    var v = m;
    if (!(!Pa.length || Pa[Pa.length - 1] !== i)) {
      var k = "deltaY" in v ? ky(v) : Hs(v), b = t.current.filter(function(w) {
        return w.name === v.type && w.target === v.target && _I(w.delta, k);
      })[0];
      if (b && b.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!b) {
        var x = (o.current.shards || []).map(by).filter(Boolean).filter(function(w) {
          return w.contains(v.target);
        }), g = x.length > 0 ? s(v, x[0]) : !o.current.noIsolation;
        g && v.cancelable && v.preventDefault();
      }
    }
  }, []), l = ne.useCallback(function(m, v, k, b) {
    var x = { name: m, delta: v, target: k, should: b };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(g) {
        return g !== x;
      });
    }, 1);
  }, []), u = ne.useCallback(function(m) {
    n.current = Hs(m), r.current = void 0;
  }, []), h = ne.useCallback(function(m) {
    l(m.type, ky(m), m.target, s(m, e.lockRef.current));
  }, []), p = ne.useCallback(function(m) {
    l(m.type, Hs(m), m.target, s(m, e.lockRef.current));
  }, []);
  ne.useEffect(function() {
    return Pa.push(i), e.setCallbacks({
      onScrollCapture: h,
      onWheelCapture: h,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", c, Na), document.addEventListener("touchmove", c, Na), document.addEventListener("touchstart", u, Na), function() {
      Pa = Pa.filter(function(m) {
        return m !== i;
      }), document.removeEventListener("wheel", c, Na), document.removeEventListener("touchmove", c, Na), document.removeEventListener("touchstart", u, Na);
    };
  }, []);
  var f = e.removeScrollBar, y = e.inert;
  return ne.createElement(
    ne.Fragment,
    null,
    y ? ne.createElement(i, { styles: GI(a) }) : null,
    f ? ne.createElement(zI, { gapMode: "margin" }) : null
  );
}
const UI = SI(i5, XI);
var d5 = ne.forwardRef(function(e, t) {
  return ne.createElement(m1, Pn({}, e, { ref: t, sideCar: UI }));
});
d5.classNames = m1.classNames;
const u5 = d5, h5 = "Popover", [p5, I4e] = Di(h5, [
  y1
]), Bp = y1(), [YI, cs] = p5(h5), JI = (e) => {
  const { __scopePopover: t, children: n, open: r, defaultOpen: a, onOpenChange: i, modal: o = !1 } = e, s = Bp(t), c = he(null), [l, u] = fe(!1), [h = !1, p] = zp({
    prop: r,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ le(K4, s, /* @__PURE__ */ le(YI, {
    scope: t,
    contentId: Gu(),
    triggerRef: c,
    open: h,
    onOpenChange: p,
    onOpenToggle: ue(
      () => p(
        (f) => !f
      ),
      [
        p
      ]
    ),
    hasCustomAnchor: l,
    onCustomAnchorAdd: ue(
      () => u(!0),
      []
    ),
    onCustomAnchorRemove: ue(
      () => u(!1),
      []
    ),
    modal: o
  }, n));
}, KI = "PopoverTrigger", QI = /* @__PURE__ */ Ae((e, t) => {
  const { __scopePopover: n, ...r } = e, a = cs(KI, n), i = Bp(n), o = fn(t, a.triggerRef), s = /* @__PURE__ */ le(xa.button, je({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": a.open,
    "aria-controls": a.contentId,
    "data-state": y5(a.open)
  }, r, {
    ref: o,
    onClick: at(e.onClick, a.onOpenToggle)
  }));
  return a.hasCustomAnchor ? s : /* @__PURE__ */ le(Q4, je({
    asChild: !0
  }, i), s);
}), eD = "PopoverPortal", [D4e, tD] = p5(eD, {
  forceMount: void 0
}), Do = "PopoverContent", nD = /* @__PURE__ */ Ae((e, t) => {
  const n = tD(Do, e.__scopePopover), { forceMount: r = n.forceMount, ...a } = e, i = cs(Do, e.__scopePopover);
  return /* @__PURE__ */ le(Vp, {
    present: r || i.open
  }, i.modal ? /* @__PURE__ */ le(rD, je({}, a, {
    ref: t
  })) : /* @__PURE__ */ le(aD, je({}, a, {
    ref: t
  })));
}), rD = /* @__PURE__ */ Ae((e, t) => {
  const n = cs(Do, e.__scopePopover), r = he(null), a = fn(t, r), i = he(!1);
  return be(() => {
    const o = r.current;
    if (o)
      return n5(o);
  }, []), /* @__PURE__ */ le(u5, {
    as: mi,
    allowPinchZoom: !0
  }, /* @__PURE__ */ le(f5, je({}, e, {
    ref: a,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: at(e.onCloseAutoFocus, (o) => {
      var s;
      o.preventDefault(), i.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: at(e.onPointerDownOutside, (o) => {
      const s = o.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, l = s.button === 2 || c;
      i.current = l;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: at(
      e.onFocusOutside,
      (o) => o.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), aD = /* @__PURE__ */ Ae((e, t) => {
  const n = cs(Do, e.__scopePopover), r = he(!1), a = he(!1);
  return /* @__PURE__ */ le(f5, je({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var o;
      if ((o = e.onCloseAutoFocus) === null || o === void 0 || o.call(e, i), !i.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), i.preventDefault();
      }
      r.current = !1, a.current = !1;
    },
    onInteractOutside: (i) => {
      var o, s;
      (o = e.onInteractOutside) === null || o === void 0 || o.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (a.current = !0));
      const c = i.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && a.current && i.preventDefault();
    }
  }));
}), f5 = /* @__PURE__ */ Ae((e, t) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: a, onCloseAutoFocus: i, disableOutsidePointerEvents: o, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: l, onInteractOutside: u, ...h } = e, p = cs(Do, n), f = Bp(n);
  return R4(), /* @__PURE__ */ le(V4, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: a,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ le(P4, {
    asChild: !0,
    disableOutsidePointerEvents: o,
    onInteractOutside: u,
    onEscapeKeyDown: s,
    onPointerDownOutside: c,
    onFocusOutside: l,
    onDismiss: () => p.onOpenChange(!1)
  }, /* @__PURE__ */ le(e5, je({
    "data-state": y5(p.open),
    role: "dialog",
    id: p.contentId
  }, f, h, {
    ref: t,
    style: {
      ...h.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
});
function y5(e) {
  return e ? "open" : "closed";
}
const dc = JI, uc = QI, hc = nD, iD = G.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.375rem;
  border-radius: 0.25rem;
  border: transparent;
  background-color: ${({ active: e }) => e ? "#f3f4f6" : "transparent"};
  &:hover {
    background-color: ${({ active: e }) => "#f3f4f6"};
  }
`, oD = G.div`
  width: 1rem;
  height: 1rem;
  border-radius: 9999px;
  background-color: #f1f5f9;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  ${({ color: e }) => e && ke`
      background-color: ${e};
      color: ${e};
    `}
  ${({ active: e }) => e ? ke`
          ring: 1px;
        ` : ""}
  &:hover {
    ${({ active: e }) => e ? "" : ke`
            ring: 1px;
          `}
  }
`, m5 = ba(({ color: e, active: t, onColorChange: n }) => {
  const r = ue(() => {
    n && n(e || "");
  }, [n, e]);
  return /* @__PURE__ */ C(iD, { active: t, type: "button", onClick: r, children: /* @__PURE__ */ C(oD, { active: t, color: e }) });
});
m5.displayName = "ColorButton";
function g1() {
  return (g1 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function g5(e, t) {
  if (e == null)
    return {};
  var n, r, a = {}, i = Object.keys(e);
  for (r = 0; r < i.length; r++)
    t.indexOf(n = i[r]) >= 0 || (a[n] = e[n]);
  return a;
}
function Yu(e) {
  var t = he(e), n = he(function(r) {
    t.current && t.current(r);
  });
  return t.current = e, n.current;
}
var To = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 1), e > n ? n : e < t ? t : e;
}, so = function(e) {
  return "touches" in e;
}, Ju = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, xy = function(e, t, n) {
  var r = e.getBoundingClientRect(), a = so(t) ? function(i, o) {
    for (var s = 0; s < i.length; s++)
      if (i[s].identifier === o)
        return i[s];
    return i[0];
  }(t.touches, n) : t;
  return { left: To((a.pageX - (r.left + Ju(e).pageXOffset)) / r.width), top: To((a.pageY - (r.top + Ju(e).pageYOffset)) / r.height) };
}, My = function(e) {
  !so(e) && e.preventDefault();
}, v5 = V.memo(function(e) {
  var t = e.onMove, n = e.onKey, r = g5(e, ["onMove", "onKey"]), a = he(null), i = Yu(t), o = Yu(n), s = he(null), c = he(!1), l = wt(function() {
    var f = function(v) {
      My(v), (so(v) ? v.touches.length > 0 : v.buttons > 0) && a.current ? i(xy(a.current, v, s.current)) : m(!1);
    }, y = function() {
      return m(!1);
    };
    function m(v) {
      var k = c.current, b = Ju(a.current), x = v ? b.addEventListener : b.removeEventListener;
      x(k ? "touchmove" : "mousemove", f), x(k ? "touchend" : "mouseup", y);
    }
    return [function(v) {
      var k = v.nativeEvent, b = a.current;
      if (b && (My(k), !function(g, w) {
        return w && !so(g);
      }(k, c.current) && b)) {
        if (so(k)) {
          c.current = !0;
          var x = k.changedTouches || [];
          x.length && (s.current = x[0].identifier);
        }
        b.focus(), i(xy(b, k, s.current)), m(!0);
      }
    }, function(v) {
      var k = v.which || v.keyCode;
      k < 37 || k > 40 || (v.preventDefault(), o({ left: k === 39 ? 0.05 : k === 37 ? -0.05 : 0, top: k === 40 ? 0.05 : k === 38 ? -0.05 : 0 }));
    }, m];
  }, [o, i]), u = l[0], h = l[1], p = l[2];
  return be(function() {
    return p;
  }, [p]), V.createElement("div", g1({}, r, { onTouchStart: u, onMouseDown: u, className: "react-colorful__interactive", ref: a, onKeyDown: h, tabIndex: 0, role: "slider" }));
}), Hp = function(e) {
  return e.filter(Boolean).join(" ");
}, k5 = function(e) {
  var t = e.color, n = e.left, r = e.top, a = r === void 0 ? 0.5 : r, i = Hp(["react-colorful__pointer", e.className]);
  return V.createElement("div", { className: i, style: { top: 100 * a + "%", left: 100 * n + "%" } }, V.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, vt = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Math.pow(10, t)), Math.round(n * e) / n;
}, sD = function(e) {
  return hD(Ku(e));
}, Ku = function(e) {
  return e[0] === "#" && (e = e.substring(1)), e.length < 6 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? vt(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : { r: parseInt(e.substring(0, 2), 16), g: parseInt(e.substring(2, 4), 16), b: parseInt(e.substring(4, 6), 16), a: e.length === 8 ? vt(parseInt(e.substring(6, 8), 16) / 255, 2) : 1 };
}, cD = function(e) {
  return uD(dD(e));
}, lD = function(e) {
  var t = e.s, n = e.v, r = e.a, a = (200 - t) * n / 100;
  return { h: vt(e.h), s: vt(a > 0 && a < 200 ? t * n / 100 / (a <= 100 ? a : 200 - a) * 100 : 0), l: vt(a / 2), a: vt(r, 2) };
}, Qu = function(e) {
  var t = lD(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
}, dD = function(e) {
  var t = e.h, n = e.s, r = e.v, a = e.a;
  t = t / 360 * 6, n /= 100, r /= 100;
  var i = Math.floor(t), o = r * (1 - n), s = r * (1 - (t - i) * n), c = r * (1 - (1 - t + i) * n), l = i % 6;
  return { r: vt(255 * [r, s, o, o, c, r][l]), g: vt(255 * [c, r, r, s, o, o][l]), b: vt(255 * [o, o, c, r, r, s][l]), a: vt(a, 2) };
}, $s = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, uD = function(e) {
  var t = e.r, n = e.g, r = e.b, a = e.a, i = a < 1 ? $s(vt(255 * a)) : "";
  return "#" + $s(t) + $s(n) + $s(r) + i;
}, hD = function(e) {
  var t = e.r, n = e.g, r = e.b, a = e.a, i = Math.max(t, n, r), o = i - Math.min(t, n, r), s = o ? i === t ? (n - r) / o : i === n ? 2 + (r - t) / o : 4 + (t - n) / o : 0;
  return { h: vt(60 * (s < 0 ? s + 6 : s)), s: vt(i ? o / i * 100 : 0), v: vt(i / 255 * 100), a };
}, pD = V.memo(function(e) {
  var t = e.hue, n = e.onChange, r = Hp(["react-colorful__hue", e.className]);
  return V.createElement("div", { className: r }, V.createElement(v5, { onMove: function(a) {
    n({ h: 360 * a.left });
  }, onKey: function(a) {
    n({ h: To(t + 360 * a.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": vt(t), "aria-valuemax": "360", "aria-valuemin": "0" }, V.createElement(k5, { className: "react-colorful__hue-pointer", left: t / 360, color: Qu({ h: t, s: 100, v: 100, a: 1 }) })));
}), fD = V.memo(function(e) {
  var t = e.hsva, n = e.onChange, r = { backgroundColor: Qu({ h: t.h, s: 100, v: 100, a: 1 }) };
  return V.createElement("div", { className: "react-colorful__saturation", style: r }, V.createElement(v5, { onMove: function(a) {
    n({ s: 100 * a.left, v: 100 - 100 * a.top });
  }, onKey: function(a) {
    n({ s: To(t.s + 100 * a.left, 0, 100), v: To(t.v - 100 * a.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + vt(t.s) + "%, Brightness " + vt(t.v) + "%" }, V.createElement(k5, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: Qu(t) })));
}), b5 = function(e, t) {
  if (e === t)
    return !0;
  for (var n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}, yD = function(e, t) {
  return e.toLowerCase() === t.toLowerCase() || b5(Ku(e), Ku(t));
};
function mD(e, t, n) {
  var r = Yu(n), a = fe(function() {
    return e.toHsva(t);
  }), i = a[0], o = a[1], s = he({ color: t, hsva: i });
  be(function() {
    if (!e.equal(t, s.current.color)) {
      var l = e.toHsva(t);
      s.current = { hsva: l, color: t }, o(l);
    }
  }, [t, e]), be(function() {
    var l;
    b5(i, s.current.hsva) || e.equal(l = e.fromHsva(i), s.current.color) || (s.current = { hsva: i, color: l }, r(l));
  }, [i, e, r]);
  var c = ue(function(l) {
    o(function(u) {
      return Object.assign({}, u, l);
    });
  }, []);
  return [i, c];
}
var gD = typeof window < "u" ? Pl : be, vD = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, wy = /* @__PURE__ */ new Map(), kD = function(e) {
  gD(function() {
    var t = e.current ? e.current.ownerDocument : document;
    if (t !== void 0 && !wy.has(t)) {
      var n = t.createElement("style");
      n.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, wy.set(t, n);
      var r = vD();
      r && n.setAttribute("nonce", r), t.head.appendChild(n);
    }
  }, []);
}, bD = function(e) {
  var t = e.className, n = e.colorModel, r = e.color, a = r === void 0 ? n.defaultColor : r, i = e.onChange, o = g5(e, ["className", "colorModel", "color", "onChange"]), s = he(null);
  kD(s);
  var c = mD(n, a, i), l = c[0], u = c[1], h = Hp(["react-colorful", t]);
  return V.createElement("div", g1({}, o, { ref: s, className: h }), V.createElement(fD, { hsva: l, onChange: u }), V.createElement(pD, { hue: l.h, onChange: u, className: "react-colorful__last-control" }));
}, xD = { defaultColor: "000", toHsva: sD, fromHsva: function(e) {
  return cD({ h: e.h, s: e.s, v: e.v, a: 1 });
}, equal: yD }, MD = function(e) {
  return V.createElement(bD, g1({}, e, { colorModel: xD }));
};
const wD = G.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`, CD = G(MD)`
  width: 100%;
`, SD = G.input`
  width: 100%;
  padding: 8px;
  color: ${({ theme: e }) => e.darkMode ? "white" : "black"};
  background-color: ${({ theme: e }) => e.darkMode ? "black" : "white"};
  border: 1px solid ${({ theme: e }) => e.darkMode ? "#2d3748" : "#e2e8f0"};
  border-radius: 4px;
  outline: 1px solid transparent;
  outline-offset: 2px;

  &:focus {
    outline: 1px solid ${({ theme: e }) => e.darkMode ? "#4a5568" : "#cbd5e0"};
    box-shadow: inset 0 0 0 0 inherit;
  }
`, AD = G.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  max-width: 15rem;
`;
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OD = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), x5 = (...e) => e.filter((t, n, r) => !!t && r.indexOf(t) === n).join(" ");
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var ED = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ID = Ae(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: a = "",
    children: i,
    iconNode: o,
    ...s
  }, c) => le(
    "svg",
    {
      ref: c,
      ...ED,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: x5("lucide", a),
      ...s
    },
    [
      ...o.map(([l, u]) => le(l, u)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d = (e, t) => {
  const n = Ae(
    ({ className: r, ...a }, i) => le(ID, {
      ref: i,
      iconNode: t,
      className: x5(`lucide-${OD(e)}`, r),
      ...a
    })
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DD = d("AArrowDown", [
  ["path", { d: "M3.5 13h6", key: "p1my2r" }],
  ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
  ["path", { d: "M18 7v9", key: "pknjwm" }],
  ["path", { d: "m14 12 4 4 4-4", key: "buelq4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TD = d("AArrowUp", [
  ["path", { d: "M3.5 13h6", key: "p1my2r" }],
  ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
  ["path", { d: "M18 16V7", key: "ty0viw" }],
  ["path", { d: "m14 11 4-4 4 4", key: "1pu57t" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ND = d("ALargeSmall", [
  ["path", { d: "M21 14h-5", key: "1vh23k" }],
  ["path", { d: "M16 16v-3.5a2.5 2.5 0 0 1 5 0V16", key: "1wh10o" }],
  ["path", { d: "M4.5 13h6", key: "dfilno" }],
  ["path", { d: "m3 16 4.5-9 4.5 9", key: "2dxa0e" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PD = d("Accessibility", [
  ["circle", { cx: "16", cy: "4", r: "1", key: "1grugj" }],
  ["path", { d: "m18 19 1-7-6 1", key: "r0i19z" }],
  ["path", { d: "m5 8 3-3 5.5 3-2.36 3.5", key: "9ptxx2" }],
  ["path", { d: "M4.24 14.5a5 5 0 0 0 6.88 6", key: "10kmtu" }],
  ["path", { d: "M13.76 17.5a5 5 0 0 0-6.88-6", key: "2qq6rc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LD = d("Activity", [
  [
    "path",
    {
      d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
      key: "169zse"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RD = d("AirVent", [
  [
    "path",
    {
      d: "M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "larmp2"
    }
  ],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  ["path", { d: "M18.3 17.7a2.5 2.5 0 0 1-3.16 3.83 2.53 2.53 0 0 1-1.14-2V12", key: "1bo8pg" }],
  ["path", { d: "M6.6 15.6A2 2 0 1 0 10 17v-5", key: "t9h90c" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VD = d("Airplay", [
  [
    "path",
    {
      d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1",
      key: "ns4c3b"
    }
  ],
  ["path", { d: "m12 15 5 6H7Z", key: "14qnn2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zD = d("AlarmClockCheck", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BD = d("AlarmClockMinus", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HD = d("AlarmClockOff", [
  ["path", { d: "M6.87 6.87a8 8 0 1 0 11.26 11.26", key: "3on8tj" }],
  ["path", { d: "M19.9 14.25a8 8 0 0 0-9.15-9.15", key: "15ghsc" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.26 18.67 4 21", key: "yzmioq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M4 4 2 6", key: "1ycko6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $D = d("AlarmClockPlus", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jD = d("AlarmClock", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M12 9v4l2 2", key: "1c63tq" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FD = d("AlarmSmoke", [
  ["path", { d: "M11 21c0-2.5 2-2.5 2-5", key: "1sicvv" }],
  ["path", { d: "M16 21c0-2.5 2-2.5 2-5", key: "1o3eny" }],
  ["path", { d: "m19 8-.8 3a1.25 1.25 0 0 1-1.2 1H7a1.25 1.25 0 0 1-1.2-1L5 8", key: "1bvca4" }],
  [
    "path",
    { d: "M21 3a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a1 1 0 0 1 1-1z", key: "x3qr1j" }
  ],
  ["path", { d: "M6 21c0-2.5 2-2.5 2-5", key: "i3w1gp" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WD = d("Album", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["polyline", { points: "11 3 11 11 14 8 17 11 17 3", key: "1wcwz3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qD = d("AlignCenterHorizontal", [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4", key: "11f1s0" }],
  ["path", { d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4", key: "t14dx9" }],
  ["path", { d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1", key: "1w07xs" }],
  ["path", { d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1", key: "1apec2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _D = d("AlignCenterVertical", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4", key: "14d6g8" }],
  ["path", { d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4", key: "1e2lrw" }],
  ["path", { d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1", key: "1fkdwx" }],
  ["path", { d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1", key: "1euafb" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GD = d("AlignCenter", [
  ["line", { x1: "21", x2: "3", y1: "6", y2: "6", key: "1fp77t" }],
  ["line", { x1: "17", x2: "7", y1: "12", y2: "12", key: "rsh8ii" }],
  ["line", { x1: "19", x2: "5", y1: "18", y2: "18", key: "1t0tuv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZD = d("AlignEndHorizontal", [
  ["rect", { width: "6", height: "16", x: "4", y: "2", rx: "2", key: "z5wdxg" }],
  ["rect", { width: "6", height: "9", x: "14", y: "9", rx: "2", key: "um7a8w" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XD = d("AlignEndVertical", [
  ["rect", { width: "16", height: "6", x: "2", y: "4", rx: "2", key: "10wcwx" }],
  ["rect", { width: "9", height: "6", x: "9", y: "14", rx: "2", key: "4p5bwg" }],
  ["path", { d: "M22 22V2", key: "12ipfv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UD = d("AlignHorizontalDistributeCenter", [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M17 22v-5", key: "4b6g73" }],
  ["path", { d: "M17 7V2", key: "hnrr36" }],
  ["path", { d: "M7 22v-3", key: "1r4jpn" }],
  ["path", { d: "M7 5V2", key: "liy1u9" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YD = d("AlignHorizontalDistributeEnd", [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M10 2v20", key: "uyc634" }],
  ["path", { d: "M20 2v20", key: "1tx262" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JD = d("AlignHorizontalDistributeStart", [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M4 2v20", key: "gtpd5x" }],
  ["path", { d: "M14 2v20", key: "tg6bpw" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KD = d("AlignHorizontalJustifyCenter", [
  ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }],
  ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }],
  ["path", { d: "M12 2v20", key: "t6zp3m" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QD = d("AlignHorizontalJustifyEnd", [
  ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }],
  ["rect", { width: "6", height: "10", x: "12", y: "7", rx: "2", key: "1ht384" }],
  ["path", { d: "M22 2v20", key: "40qfg1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eT = d("AlignHorizontalJustifyStart", [
  ["rect", { width: "6", height: "14", x: "6", y: "5", rx: "2", key: "hsirpf" }],
  ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tT = d("AlignHorizontalSpaceAround", [
  ["rect", { width: "6", height: "10", x: "9", y: "7", rx: "2", key: "yn7j0q" }],
  ["path", { d: "M4 22V2", key: "tsjzd3" }],
  ["path", { d: "M20 22V2", key: "1bnhr8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nT = d("AlignHorizontalSpaceBetween", [
  ["rect", { width: "6", height: "14", x: "3", y: "5", rx: "2", key: "j77dae" }],
  ["rect", { width: "6", height: "10", x: "15", y: "7", rx: "2", key: "bq30hj" }],
  ["path", { d: "M3 2v20", key: "1d2pfg" }],
  ["path", { d: "M21 2v20", key: "p059bm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rT = d("AlignJustify", [
  ["line", { x1: "3", x2: "21", y1: "6", y2: "6", key: "4m8b97" }],
  ["line", { x1: "3", x2: "21", y1: "12", y2: "12", key: "10d38w" }],
  ["line", { x1: "3", x2: "21", y1: "18", y2: "18", key: "kwyyxn" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aT = d("AlignLeft", [
  ["line", { x1: "21", x2: "3", y1: "6", y2: "6", key: "1fp77t" }],
  ["line", { x1: "15", x2: "3", y1: "12", y2: "12", key: "v6grx8" }],
  ["line", { x1: "17", x2: "3", y1: "18", y2: "18", key: "1awlsn" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iT = d("AlignRight", [
  ["line", { x1: "21", x2: "3", y1: "6", y2: "6", key: "1fp77t" }],
  ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }],
  ["line", { x1: "21", x2: "7", y1: "18", y2: "18", key: "1g9eri" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oT = d("AlignStartHorizontal", [
  ["rect", { width: "6", height: "16", x: "4", y: "6", rx: "2", key: "1n4dg1" }],
  ["rect", { width: "6", height: "9", x: "14", y: "6", rx: "2", key: "17khns" }],
  ["path", { d: "M22 2H2", key: "fhrpnj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sT = d("AlignStartVertical", [
  ["rect", { width: "9", height: "6", x: "6", y: "14", rx: "2", key: "lpm2y7" }],
  ["rect", { width: "16", height: "6", x: "6", y: "4", rx: "2", key: "rdj6ps" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cT = d("AlignVerticalDistributeCenter", [
  ["path", { d: "M22 17h-3", key: "1lwga1" }],
  ["path", { d: "M22 7h-5", key: "o2endc" }],
  ["path", { d: "M5 17H2", key: "1gx9xc" }],
  ["path", { d: "M7 7H2", key: "6bq26l" }],
  ["rect", { x: "5", y: "14", width: "14", height: "6", rx: "2", key: "1qrzuf" }],
  ["rect", { x: "7", y: "4", width: "10", height: "6", rx: "2", key: "we8e9z" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lT = d("AlignVerticalDistributeEnd", [
  ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }],
  ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }],
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "M2 10h20", key: "1ir3d8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dT = d("AlignVerticalDistributeStart", [
  ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }],
  ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M2 4h20", key: "mda7wb" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uT = d("AlignVerticalJustifyCenter", [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hT = d("AlignVerticalJustifyEnd", [
  ["rect", { width: "14", height: "6", x: "5", y: "12", rx: "2", key: "4l4tp2" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 22h20", key: "272qi7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pT = d("AlignVerticalJustifyStart", [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "6", rx: "2", key: "13squh" }],
  ["path", { d: "M2 2h20", key: "1ennik" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fT = d("AlignVerticalSpaceAround", [
  ["rect", { width: "10", height: "6", x: "7", y: "9", rx: "2", key: "b1zbii" }],
  ["path", { d: "M22 20H2", key: "1p1f7z" }],
  ["path", { d: "M22 4H2", key: "1b7qnq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yT = d("AlignVerticalSpaceBetween", [
  ["rect", { width: "14", height: "6", x: "5", y: "15", rx: "2", key: "1w91an" }],
  ["rect", { width: "10", height: "6", x: "7", y: "3", rx: "2", key: "17wqzy" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ["path", { d: "M2 3h20", key: "91anmk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mT = d("Ambulance", [
  ["path", { d: "M10 10H6", key: "1bsnug" }],
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.28a1 1 0 0 0-.684-.948l-1.923-.641a1 1 0 0 1-.578-.502l-1.539-3.076A1 1 0 0 0 16.382 8H14",
      key: "lrkjwd"
    }
  ],
  ["path", { d: "M8 8v4", key: "1fwk8c" }],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gT = d("Ampersand", [
  [
    "path",
    {
      d: "M17.5 12c0 4.4-3.6 8-8 8A4.5 4.5 0 0 1 5 15.5c0-6 8-4 8-8.5a3 3 0 1 0-6 0c0 3 2.5 8.5 12 13",
      key: "1o9ehi"
    }
  ],
  ["path", { d: "M16 12h3", key: "4uvgyw" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vT = d("Ampersands", [
  [
    "path",
    {
      d: "M10 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "12lh1k"
    }
  ],
  [
    "path",
    {
      d: "M22 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "173c68"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kT = d("Anchor", [
  ["path", { d: "M12 22V8", key: "qkxhtm" }],
  ["path", { d: "M5 12H2a10 10 0 0 0 20 0h-3", key: "1hv3nh" }],
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bT = d("Angry", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["path", { d: "M7.5 8 10 9", key: "olxxln" }],
  ["path", { d: "m14 9 2.5-1", key: "1j6cij" }],
  ["path", { d: "M9 10h.01", key: "qbtxuw" }],
  ["path", { d: "M15 10h.01", key: "1qmjsl" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xT = d("Annoyed", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M14 9h2", key: "116p9w" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MT = d("Antenna", [
  ["path", { d: "M2 12 7 2", key: "117k30" }],
  ["path", { d: "m7 12 5-10", key: "1tvx22" }],
  ["path", { d: "m12 12 5-10", key: "ev1o1a" }],
  ["path", { d: "m17 12 5-10", key: "1e4ti3" }],
  ["path", { d: "M4.5 7h15", key: "vlsxkz" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wT = d("Anvil", [
  ["path", { d: "M7 10H6a4 4 0 0 1-4-4 1 1 0 0 1 1-1h4", key: "1hjpb6" }],
  [
    "path",
    { d: "M7 5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1 7 7 0 0 1-7 7H8a1 1 0 0 1-1-1z", key: "1qn45f" }
  ],
  ["path", { d: "M9 12v5", key: "3anwtq" }],
  ["path", { d: "M15 12v5", key: "5xh3zn" }],
  [
    "path",
    { d: "M5 20a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3 1 1 0 0 1-1 1H6a1 1 0 0 1-1-1", key: "1fi4x8" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CT = d("Aperture", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m14.31 8 5.74 9.94", key: "1y6ab4" }],
  ["path", { d: "M9.69 8h11.48", key: "1wxppr" }],
  ["path", { d: "m7.38 12 5.74-9.94", key: "1grp0k" }],
  ["path", { d: "M9.69 16 3.95 6.06", key: "libnyf" }],
  ["path", { d: "M14.31 16H2.83", key: "x5fava" }],
  ["path", { d: "m16.62 12-5.74 9.94", key: "1vwawt" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ST = d("AppWindowMac", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M10 8h.01", key: "1r9ogq" }],
  ["path", { d: "M14 8h.01", key: "1primd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AT = d("AppWindow", [
  ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" }],
  ["path", { d: "M10 4v4", key: "pp8u80" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["path", { d: "M6 4v4", key: "1svtjw" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OT = d("Apple", [
  [
    "path",
    {
      d: "M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-8 6-12.22A4.91 4.91 0 0 0 17 5c-2.22 0-4 1.44-5 2-1-.56-2.78-2-5-2a4.9 4.9 0 0 0-5 4.78C2 14 5 22 8 22c1.25 0 2.5-1.06 4-1.06Z",
      key: "3s7exb"
    }
  ],
  ["path", { d: "M10 2c1 .5 2 2 2 5", key: "fcco2y" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ET = d("ArchiveRestore", [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h2", key: "tvwodi" }],
  ["path", { d: "M20 8v11a2 2 0 0 1-2 2h-2", key: "1gkqxj" }],
  ["path", { d: "m9 15 3-3 3 3", key: "1pd0qc" }],
  ["path", { d: "M12 12v9", key: "192myk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IT = d("ArchiveX", [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "m9.5 17 5-5", key: "nakeu6" }],
  ["path", { d: "m9.5 12 5 5", key: "1hccrj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DT = d("Archive", [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "M10 12h4", key: "a56b0p" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TT = d("AreaChart", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["path", { d: "M7 12v5h12V8l-5 5-4-4Z", key: "zxz28u" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NT = d("Armchair", [
  ["path", { d: "M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3", key: "irtipd" }],
  [
    "path",
    {
      d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H7v-2a2 2 0 0 0-4 0Z",
      key: "1e01m0"
    }
  ],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PT = d("ArrowBigDownDash", [
  ["path", { d: "M15 5H9", key: "1tp3ed" }],
  ["path", { d: "M15 9v3h4l-7 7-7-7h4V9z", key: "ncdc4b" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LT = d("ArrowBigDown", [
  ["path", { d: "M15 6v6h4l-7 7-7-7h4V6h6z", key: "1thax2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RT = d("ArrowBigLeftDash", [
  ["path", { d: "M19 15V9", key: "1hci5f" }],
  ["path", { d: "M15 15h-3v4l-7-7 7-7v4h3v6z", key: "16tjna" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VT = d("ArrowBigLeft", [
  ["path", { d: "M18 15h-6v4l-7-7 7-7v4h6v6z", key: "lbrdak" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zT = d("ArrowBigRightDash", [
  ["path", { d: "M5 9v6", key: "158jrl" }],
  ["path", { d: "M9 9h3V5l7 7-7 7v-4H9V9z", key: "1sg2xn" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BT = d("ArrowBigRight", [
  ["path", { d: "M6 9h6V5l7 7-7 7v-4H6V9z", key: "7fvt9c" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HT = d("ArrowBigUpDash", [
  ["path", { d: "M9 19h6", key: "456am0" }],
  ["path", { d: "M9 15v-3H5l7-7 7 7h-4v3H9z", key: "1r2uve" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $T = d("ArrowBigUp", [
  ["path", { d: "M9 18v-6H5l7-7 7 7h-4v6H9z", key: "1x06kx" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jT = d("ArrowDown01", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FT = d("ArrowDown10", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WT = d("ArrowDownAZ", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qT = d("ArrowDownFromLine", [
  ["path", { d: "M19 3H5", key: "1236rx" }],
  ["path", { d: "M12 21V7", key: "gj6g52" }],
  ["path", { d: "m6 15 6 6 6-6", key: "h15q88" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _T = d("ArrowDownLeft", [
  ["path", { d: "M17 7 7 17", key: "15tmo1" }],
  ["path", { d: "M17 17H7V7", key: "1org7z" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GT = d("ArrowDownNarrowWide", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h4", key: "6d7r33" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h10", key: "1438ji" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZT = d("ArrowDownRight", [
  ["path", { d: "m7 7 10 10", key: "1fmybs" }],
  ["path", { d: "M17 7v10H7", key: "6fjiku" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XT = d("ArrowDownToDot", [
  ["path", { d: "M12 2v14", key: "jyx4ut" }],
  ["path", { d: "m19 9-7 7-7-7", key: "1oe3oy" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UT = d("ArrowDownToLine", [
  ["path", { d: "M12 17V3", key: "1cwfxf" }],
  ["path", { d: "m6 11 6 6 6-6", key: "12ii2o" }],
  ["path", { d: "M19 21H5", key: "150jfl" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YT = d("ArrowDownUp", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "m21 8-4-4-4 4", key: "1c9v7m" }],
  ["path", { d: "M17 4v16", key: "7dpous" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JT = d("ArrowDownWideNarrow", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h10", key: "1w87gc" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KT = d("ArrowDownZA", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QT = d("ArrowDown", [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eN = d("ArrowLeftFromLine", [
  ["path", { d: "m9 6-6 6 6 6", key: "7v63n9" }],
  ["path", { d: "M3 12h14", key: "13k4hi" }],
  ["path", { d: "M21 19V5", key: "b4bplr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tN = d("ArrowLeftRight", [
  ["path", { d: "M8 3 4 7l4 4", key: "9rb6wj" }],
  ["path", { d: "M4 7h16", key: "6tx8e3" }],
  ["path", { d: "m16 21 4-4-4-4", key: "siv7j2" }],
  ["path", { d: "M20 17H4", key: "h6l3hr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nN = d("ArrowLeftToLine", [
  ["path", { d: "M3 19V5", key: "rwsyhb" }],
  ["path", { d: "m13 6-6 6 6 6", key: "1yhaz7" }],
  ["path", { d: "M7 12h14", key: "uoisry" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rN = d("ArrowLeft", [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aN = d("ArrowRightFromLine", [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M21 12H7", key: "13ipq5" }],
  ["path", { d: "m15 18 6-6-6-6", key: "6tx3qv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iN = d("ArrowRightLeft", [
  ["path", { d: "m16 3 4 4-4 4", key: "1x1c3m" }],
  ["path", { d: "M20 7H4", key: "zbl0bi" }],
  ["path", { d: "m8 21-4-4 4-4", key: "h9nckh" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oN = d("ArrowRightToLine", [
  ["path", { d: "M17 12H3", key: "8awo09" }],
  ["path", { d: "m11 18 6-6-6-6", key: "8c2y43" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sN = d("ArrowRight", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cN = d("ArrowUp01", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lN = d("ArrowUp10", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dN = d("ArrowUpAZ", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uN = d("ArrowUpDown", [
  ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
  ["path", { d: "M17 20V4", key: "1ejh1v" }],
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hN = d("ArrowUpFromDot", [
  ["path", { d: "m5 9 7-7 7 7", key: "1hw5ic" }],
  ["path", { d: "M12 16V2", key: "ywoabb" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pN = d("ArrowUpFromLine", [
  ["path", { d: "m18 9-6-6-6 6", key: "kcunyi" }],
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fN = d("ArrowUpLeft", [
  ["path", { d: "M7 17V7h10", key: "11bw93" }],
  ["path", { d: "M17 17 7 7", key: "2786uv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yN = d("ArrowUpNarrowWide", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h10", key: "jvxblo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mN = d("ArrowUpRight", [
  ["path", { d: "M7 7h10v10", key: "1tivn9" }],
  ["path", { d: "M7 17 17 7", key: "1vkiza" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gN = d("ArrowUpToLine", [
  ["path", { d: "M5 3h14", key: "7usisc" }],
  ["path", { d: "m18 13-6-6-6 6", key: "1kf1n9" }],
  ["path", { d: "M12 7v14", key: "1akyts" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vN = d("ArrowUpWideNarrow", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h10", key: "1438ji" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h4", key: "1krc32" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kN = d("ArrowUpZA", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bN = d("ArrowUp", [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xN = d("ArrowsUpFromLine", [
  ["path", { d: "m4 6 3-3 3 3", key: "9aidw8" }],
  ["path", { d: "M7 17V3", key: "19qxw1" }],
  ["path", { d: "m14 6 3-3 3 3", key: "6iy689" }],
  ["path", { d: "M17 17V3", key: "o0fmgi" }],
  ["path", { d: "M4 21h16", key: "1h09gz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MN = d("Asterisk", [
  ["path", { d: "M12 6v12", key: "1vza4d" }],
  ["path", { d: "M17.196 9 6.804 15", key: "1ah31z" }],
  ["path", { d: "m6.804 9 10.392 6", key: "1b6pxd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wN = d("AtSign", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8", key: "7n84p3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CN = d("Atom", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9-4.54-4.52-9.87-6.54-11.9-4.5-2.04 2.03-.02 7.36 4.5 11.9 4.54 4.52 9.87 6.54 11.9 4.5Z",
      key: "1l2ple"
    }
  ],
  [
    "path",
    {
      d: "M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9-2.03-2.04-7.36-.02-11.9 4.5-4.52 4.54-6.54 9.87-4.5 11.9 2.03 2.04 7.36.02 11.9-4.5Z",
      key: "1wam0m"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SN = d("AudioLines", [
  ["path", { d: "M2 10v3", key: "1fnikh" }],
  ["path", { d: "M6 6v11", key: "11sgs0" }],
  ["path", { d: "M10 3v18", key: "yhl04a" }],
  ["path", { d: "M14 8v7", key: "3a1oy3" }],
  ["path", { d: "M18 5v13", key: "123xd1" }],
  ["path", { d: "M22 10v3", key: "154ddg" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AN = d("AudioWaveform", [
  [
    "path",
    {
      d: "M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2",
      key: "57tc96"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ON = d("Award", [
  [
    "path",
    {
      d: "m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526",
      key: "1yiouv"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "6", key: "1vp47v" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EN = d("Axe", [
  ["path", { d: "m14 12-8.5 8.5a2.12 2.12 0 1 1-3-3L11 9", key: "csbz4o" }],
  ["path", { d: "M15 13 9 7l4-4 6 6h3a8 8 0 0 1-7 7z", key: "113wfo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IN = d("Axis3d", [
  ["path", { d: "M4 4v16h16", key: "1s015l" }],
  ["path", { d: "m4 20 7-7", key: "17qe9y" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DN = d("Baby", [
  ["path", { d: "M9 12h.01", key: "157uk2" }],
  ["path", { d: "M15 12h.01", key: "1k8ypt" }],
  ["path", { d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5", key: "1u7htd" }],
  [
    "path",
    {
      d: "M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1",
      key: "5yv0yz"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TN = d("Backpack", [
  [
    "path",
    { d: "M4 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z", key: "wvr1b5" }
  ],
  ["path", { d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2", key: "donm21" }],
  ["path", { d: "M8 21v-5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v5", key: "xk3gvk" }],
  ["path", { d: "M8 10h8", key: "c7uz4u" }],
  ["path", { d: "M8 18h8", key: "1no2b1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NN = d("BadgeAlert", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PN = d("BadgeCent", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M15.4 10a4 4 0 1 0 0 4", key: "2eqtx8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LN = d("BadgeCheck", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RN = d("BadgeDollarSign", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VN = d("BadgeEuro", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M7 12h5", key: "gblrwe" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zN = d("BadgeHelp", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["line", { x1: "12", x2: "12.01", y1: "17", y2: "17", key: "io3f8k" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BN = d("BadgeIndianRupee", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 8h8", key: "1bis0t" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m13 17-5-1h1a4 4 0 0 0 0-8", key: "nu2bwa" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HN = d("BadgeInfo", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "12", key: "1y1yb1" }],
  ["line", { x1: "12", x2: "12.01", y1: "8", y2: "8", key: "110wyk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $N = d("BadgeJapaneseYen", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 8 3 3v7", key: "17yadx" }],
  ["path", { d: "m12 11 3-3", key: "p4cfq1" }],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M9 16h6", key: "8wimt3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jN = d("BadgeMinus", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FN = d("BadgePercent", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WN = d("BadgePlus", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "16", key: "10p56q" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qN = d("BadgePoundSterling", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 12h4", key: "qz6y1c" }],
  ["path", { d: "M10 16V9.5a2.5 2.5 0 0 1 5 0", key: "3mlbjk" }],
  ["path", { d: "M8 16h7", key: "sbedsn" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _N = d("BadgeRussianRuble", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9 16h5", key: "1syiyw" }],
  ["path", { d: "M9 12h5a2 2 0 1 0 0-4h-3v9", key: "1ge9c1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GN = d("BadgeSwissFranc", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M11 17V8h4", key: "1bfq6y" }],
  ["path", { d: "M11 12h3", key: "2eqnfz" }],
  ["path", { d: "M9 16h4", key: "1skf3a" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZN = d("BadgeX", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XN = d("Badge", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UN = d("BaggageClaim", [
  ["path", { d: "M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2", key: "4irg2o" }],
  ["path", { d: "M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10", key: "14fcyx" }],
  ["rect", { width: "13", height: "8", x: "8", y: "6", rx: "1", key: "o6oiis" }],
  ["circle", { cx: "18", cy: "20", r: "2", key: "t9985n" }],
  ["circle", { cx: "9", cy: "20", r: "2", key: "e5v82j" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YN = d("Ban", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.9 4.9 14.2 14.2", key: "1m5liu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JN = d("Banana", [
  ["path", { d: "M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5", key: "1cscit" }],
  [
    "path",
    {
      d: "M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z",
      key: "1y1nbv"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KN = d("Banknote", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M6 12h.01M18 12h.01", key: "113zkx" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QN = d("BarChart2", [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "10", key: "1xfpm4" }],
  ["line", { x1: "12", x2: "12", y1: "20", y2: "4", key: "be30l9" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "14", key: "1r4le6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eP = d("BarChart3", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["path", { d: "M18 17V9", key: "2bz60n" }],
  ["path", { d: "M13 17V5", key: "1frdt8" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tP = d("BarChart4", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["path", { d: "M13 17V9", key: "1fwyjl" }],
  ["path", { d: "M18 17V5", key: "sfb6ij" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nP = d("BarChartBig", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["rect", { width: "4", height: "7", x: "7", y: "10", rx: "1", key: "14u6mf" }],
  ["rect", { width: "4", height: "12", x: "15", y: "5", rx: "1", key: "b3pek6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rP = d("BarChartHorizontalBig", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["rect", { width: "12", height: "4", x: "7", y: "5", rx: "1", key: "936jl1" }],
  ["rect", { width: "7", height: "4", x: "7", y: "13", rx: "1", key: "jqfkpy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aP = d("BarChartHorizontal", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["path", { d: "M7 16h8", key: "srdodz" }],
  ["path", { d: "M7 11h12", key: "127s9w" }],
  ["path", { d: "M7 6h3", key: "w9rmul" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iP = d("BarChart", [
  ["line", { x1: "12", x2: "12", y1: "20", y2: "10", key: "1vz5eb" }],
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "16", key: "hq0ia6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oP = d("Barcode", [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M8 5v14", key: "1ybrkv" }],
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "M17 5v14", key: "ycjyhj" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sP = d("Baseline", [
  ["path", { d: "M4 20h16", key: "14thso" }],
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cP = d("Bath", [
  [
    "path",
    {
      d: "M9 6 6.5 3.5a1.5 1.5 0 0 0-1-.5C4.683 3 4 3.683 4 4.5V17a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5",
      key: "1r8yf5"
    }
  ],
  ["line", { x1: "10", x2: "8", y1: "5", y2: "7", key: "h5g8z4" }],
  ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }],
  ["line", { x1: "7", x2: "7", y1: "19", y2: "21", key: "16jp00" }],
  ["line", { x1: "17", x2: "17", y1: "19", y2: "21", key: "1pxrnk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lP = d("BatteryCharging", [
  ["path", { d: "M15 7h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2", key: "1sdynx" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1", key: "1gkd3k" }],
  ["path", { d: "m11 7-3 5h4l-3 5", key: "b4a64w" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dP = d("BatteryFull", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "13", key: "c6fn6x" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uP = d("BatteryLow", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hP = d("BatteryMedium", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pP = d("BatteryWarning", [
  ["path", { d: "M14 7h2a2 2 0 0 1 2 2v6c0 1-1 2-2 2h-2", key: "1if82c" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6c0 1 1 2 2 2h2", key: "2pdlyl" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "10", x2: "10", y1: "7", y2: "13", key: "1uzyus" }],
  ["line", { x1: "10", x2: "10", y1: "17", y2: "17.01", key: "1y8k4g" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fP = d("Battery", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yP = d("Beaker", [
  ["path", { d: "M4.5 3h15", key: "c7n0jr" }],
  ["path", { d: "M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3", key: "m1uhx7" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mP = d("BeanOff", [
  [
    "path",
    {
      d: "M9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22a13.96 13.96 0 0 0 9.9-4.1",
      key: "bq3udt"
    }
  ],
  ["path", { d: "M10.75 5.093A6 6 0 0 1 22 8c0 2.411-.61 4.68-1.683 6.66", key: "17ccse" }],
  [
    "path",
    {
      d: "M5.341 10.62a4 4 0 0 0 6.487 1.208M10.62 5.341a4.015 4.015 0 0 1 2.039 2.04",
      key: "18zqgq"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gP = d("Bean", [
  [
    "path",
    {
      d: "M10.165 6.598C9.954 7.478 9.64 8.36 9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22c7.732 0 14-6.268 14-14a6 6 0 0 0-11.835-1.402Z",
      key: "1tvzk7"
    }
  ],
  ["path", { d: "M5.341 10.62a4 4 0 1 0 5.279-5.28", key: "2cyri2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vP = d("BedDouble", [
  ["path", { d: "M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8", key: "1k78r4" }],
  ["path", { d: "M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "fb3tl2" }],
  ["path", { d: "M12 4v6", key: "1dcgq2" }],
  ["path", { d: "M2 18h20", key: "ajqnye" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kP = d("BedSingle", [
  ["path", { d: "M3 20v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8", key: "1wm6mi" }],
  ["path", { d: "M5 10V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4", key: "4k93s5" }],
  ["path", { d: "M3 18h18", key: "1h113x" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bP = d("Bed", [
  ["path", { d: "M2 4v16", key: "vw9hq8" }],
  ["path", { d: "M2 8h18a2 2 0 0 1 2 2v10", key: "1dgv2r" }],
  ["path", { d: "M2 17h20", key: "18nfp3" }],
  ["path", { d: "M6 8v9", key: "1yriud" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xP = d("Beef", [
  ["circle", { cx: "12.5", cy: "8.5", r: "2.5", key: "9738u8" }],
  [
    "path",
    {
      d: "M12.5 2a6.5 6.5 0 0 0-6.22 4.6c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 0 0 5 18c4 0 8.4-1.8 11.4-4.3A6.5 6.5 0 0 0 12.5 2Z",
      key: "o0f6za"
    }
  ],
  [
    "path",
    {
      d: "m18.5 6 2.19 4.5a6.48 6.48 0 0 1 .31 2 6.49 6.49 0 0 1-2.6 5.2C15.4 20.2 11 22 7 22a3 3 0 0 1-2.68-1.66L2.4 16.5",
      key: "k7p6i0"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MP = d("BeerOff", [
  ["path", { d: "M13 13v5", key: "igwfh0" }],
  ["path", { d: "M17 11.47V8", key: "16yw0g" }],
  ["path", { d: "M17 11h1a3 3 0 0 1 2.745 4.211", key: "1xbt65" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3", key: "c55o3e" }],
  [
    "path",
    { d: "M7.536 7.535C6.766 7.649 6.154 8 5.5 8a2.5 2.5 0 0 1-1.768-4.268", key: "1ydug7" }
  ],
  [
    "path",
    {
      d: "M8.727 3.204C9.306 2.767 9.885 2 11 2c1.56 0 2 1.5 3 1.5s1.72-.5 2.5-.5a1 1 0 1 1 0 5c-.78 0-1.5-.5-2.5-.5a3.149 3.149 0 0 0-.842.12",
      key: "q81o7q"
    }
  ],
  ["path", { d: "M9 14.6V18", key: "20ek98" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wP = d("Beer", [
  ["path", { d: "M17 11h1a3 3 0 0 1 0 6h-1", key: "1yp76v" }],
  ["path", { d: "M9 12v6", key: "1u1cab" }],
  ["path", { d: "M13 12v6", key: "1sugkk" }],
  [
    "path",
    {
      d: "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z",
      key: "1510fo"
    }
  ],
  ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8", key: "19jb7n" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CP = d("BellDot", [
  [
    "path",
    {
      d: "M19.4 14.9C20.2 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 .7 0 1.3.1 1.9.3",
      key: "xcehk"
    }
  ],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["circle", { cx: "18", cy: "8", r: "3", key: "1g0gzu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SP = d("BellElectric", [
  ["path", { d: "M18.8 4A6.3 8.7 0 0 1 20 9", key: "xve1fh" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
  ["rect", { width: "10", height: "6", x: "4", y: "16", rx: "2", key: "17f3te" }],
  ["path", { d: "M14 19c3 0 4.6-1.6 4.6-1.6", key: "n7odp6" }],
  ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AP = d("BellMinus", [
  [
    "path",
    { d: "M18.4 12c.8 3.8 2.6 5 2.6 5H3s3-2 3-9c0-3.3 2.7-6 6-6 1.8 0 3.4.8 4.5 2", key: "eck70s" }
  ],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OP = d("BellOff", [
  ["path", { d: "M8.7 3A6 6 0 0 1 18 8a21.3 21.3 0 0 0 .6 5", key: "o7mx20" }],
  ["path", { d: "M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7", key: "16f1lm" }],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EP = d("BellPlus", [
  [
    "path",
    {
      d: "M19.3 14.8C20.1 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 1 0 1.9.2 2.8.7",
      key: "guizqy"
    }
  ],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }],
  ["path", { d: "M18 5v6", key: "g5ayrv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IP = d("BellRing", [
  ["path", { d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9", key: "1qo2s2" }],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["path", { d: "M4 2C2.8 3.7 2 5.7 2 8", key: "tap9e0" }],
  ["path", { d: "M22 8c0-2.3-.8-4.3-2-6", key: "5bb3ad" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DP = d("Bell", [
  ["path", { d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9", key: "1qo2s2" }],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TP = d("BetweenHorizontalEnd", [
  ["rect", { width: "13", height: "7", x: "3", y: "3", rx: "1", key: "11xb64" }],
  ["path", { d: "m22 15-3-3 3-3", key: "26chmm" }],
  ["rect", { width: "13", height: "7", x: "3", y: "14", rx: "1", key: "k6ky7n" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NP = d("BetweenHorizontalStart", [
  ["rect", { width: "13", height: "7", x: "8", y: "3", rx: "1", key: "pkso9a" }],
  ["path", { d: "m2 9 3 3-3 3", key: "1agib5" }],
  ["rect", { width: "13", height: "7", x: "8", y: "14", rx: "1", key: "1q5fc1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PP = d("BetweenVerticalEnd", [
  ["rect", { width: "7", height: "13", x: "3", y: "3", rx: "1", key: "1fdu0f" }],
  ["path", { d: "m9 22 3-3 3 3", key: "17z65a" }],
  ["rect", { width: "7", height: "13", x: "14", y: "3", rx: "1", key: "1squn4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LP = d("BetweenVerticalStart", [
  ["rect", { width: "7", height: "13", x: "3", y: "8", rx: "1", key: "1fjrkv" }],
  ["path", { d: "m15 2-3 3-3-3", key: "1uh6eb" }],
  ["rect", { width: "7", height: "13", x: "14", y: "8", rx: "1", key: "w3fjg8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RP = d("BicepsFlexed", [
  [
    "path",
    {
      d: "M12.409 13.017A5 5 0 0 1 22 15c0 3.866-4 7-9 7-4.077 0-8.153-.82-10.371-2.462-.426-.316-.631-.832-.62-1.362C2.118 12.723 2.627 2 10 2a3 3 0 0 1 3 3 2 2 0 0 1-2 2c-1.105 0-1.64-.444-2-1",
      key: "1pmlyh"
    }
  ],
  ["path", { d: "M15 14a5 5 0 0 0-7.584 2", key: "5rb254" }],
  ["path", { d: "M9.964 6.825C8.019 7.977 9.5 13 8 15", key: "kbvsx9" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VP = d("Bike", [
  ["circle", { cx: "18.5", cy: "17.5", r: "3.5", key: "15x4ox" }],
  ["circle", { cx: "5.5", cy: "17.5", r: "3.5", key: "1noe27" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["path", { d: "M12 17.5V14l-3-3 4-3 2 3h2", key: "1npguv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zP = d("Binary", [
  ["rect", { x: "14", y: "14", width: "4", height: "6", rx: "2", key: "p02svl" }],
  ["rect", { x: "6", y: "4", width: "4", height: "6", rx: "2", key: "xm4xkj" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 10h4", key: "ru81e7" }],
  ["path", { d: "M6 14h2v6", key: "16z9wg" }],
  ["path", { d: "M14 4h2v6", key: "1idq9u" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BP = d("Biohazard", [
  ["circle", { cx: "12", cy: "11.9", r: "2", key: "e8h31w" }],
  ["path", { d: "M6.7 3.4c-.9 2.5 0 5.2 2.2 6.7C6.5 9 3.7 9.6 2 11.6", key: "17bolr" }],
  ["path", { d: "m8.9 10.1 1.4.8", key: "15ezny" }],
  ["path", { d: "M17.3 3.4c.9 2.5 0 5.2-2.2 6.7 2.4-1.2 5.2-.6 6.9 1.5", key: "wtwa5u" }],
  ["path", { d: "m15.1 10.1-1.4.8", key: "1r0b28" }],
  ["path", { d: "M16.7 20.8c-2.6-.4-4.6-2.6-4.7-5.3-.2 2.6-2.1 4.8-4.7 5.2", key: "m7qszh" }],
  ["path", { d: "M12 13.9v1.6", key: "zfyyim" }],
  ["path", { d: "M13.5 5.4c-1-.2-2-.2-3 0", key: "1bi9q0" }],
  ["path", { d: "M17 16.4c.7-.7 1.2-1.6 1.5-2.5", key: "1rhjqw" }],
  ["path", { d: "M5.5 13.9c.3.9.8 1.8 1.5 2.5", key: "8gsud3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HP = d("Bird", [
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  ["path", { d: "M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20", key: "oj1oa8" }],
  ["path", { d: "m20 7 2 .5-2 .5", key: "12nv4d" }],
  ["path", { d: "M10 18v3", key: "1yea0a" }],
  ["path", { d: "M14 17.75V21", key: "1pymcb" }],
  ["path", { d: "M7 18a6 6 0 0 0 3.84-10.61", key: "1npnn0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $P = d("Bitcoin", [
  [
    "path",
    {
      d: "M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727",
      key: "yr8idg"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jP = d("Blend", [
  ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
  ["circle", { cx: "15", cy: "15", r: "7", key: "19ennj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FP = d("Blinds", [
  ["path", { d: "M3 3h18", key: "o7r712" }],
  ["path", { d: "M20 7H8", key: "gd2fo2" }],
  ["path", { d: "M20 11H8", key: "1ynp89" }],
  ["path", { d: "M10 19h10", key: "19hjk5" }],
  ["path", { d: "M8 15h12", key: "1yqzne" }],
  ["path", { d: "M4 3v14", key: "fggqzn" }],
  ["circle", { cx: "4", cy: "19", r: "2", key: "p3m9r0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WP = d("Blocks", [
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  [
    "path",
    {
      d: "M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3",
      key: "1fpvtg"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qP = d("BluetoothConnected", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "12", key: "1rsjjs" }],
  ["line", { x1: "3", x2: "6", y1: "12", y2: "12", key: "11yl8c" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _P = d("BluetoothOff", [
  ["path", { d: "m17 17-5 5V12l-5 5", key: "v5aci6" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M14.5 9.5 17 7l-5-5v4.5", key: "1kddfz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GP = d("BluetoothSearching", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["path", { d: "M20.83 14.83a4 4 0 0 0 0-5.66", key: "k8tn1j" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZP = d("Bluetooth", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XP = d("Bold", [
  [
    "path",
    { d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8", key: "mg9rjx" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UP = d("Bolt", [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YP = d("Bomb", [
  ["circle", { cx: "11", cy: "13", r: "9", key: "hd149" }],
  [
    "path",
    {
      d: "M14.35 4.65 16.3 2.7a2.41 2.41 0 0 1 3.4 0l1.6 1.6a2.4 2.4 0 0 1 0 3.4l-1.95 1.95",
      key: "jp4j1b"
    }
  ],
  ["path", { d: "m22 2-1.5 1.5", key: "ay92ug" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JP = d("Bone", [
  [
    "path",
    {
      d: "M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z",
      key: "w610uw"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KP = d("BookA", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "m8 13 4-7 4 7", key: "4rari8" }],
  ["path", { d: "M9.1 11h5.7", key: "1gkovt" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QP = d("BookAudio", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "M8 8v3", key: "1qzp49" }],
  ["path", { d: "M12 6v7", key: "1f6ttz" }],
  ["path", { d: "M16 8v3", key: "gejaml" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eL = d("BookCheck", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "m9 9.5 2 2 4-4", key: "1dth82" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tL = d("BookCopy", [
  ["path", { d: "M2 16V4a2 2 0 0 1 2-2h11", key: "spzkk5" }],
  ["path", { d: "M5 14H4a2 2 0 1 0 0 4h1", key: "16gqf9" }],
  ["path", { d: "M22 18H11a2 2 0 1 0 0 4h11V6H11a2 2 0 0 0-2 2v12", key: "1owzki" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nL = d("BookDashed", [
  ["path", { d: "M20 22h-2", key: "1rpnb6" }],
  ["path", { d: "M20 15v2h-2", key: "fph276" }],
  ["path", { d: "M4 19.5V15", key: "6gr39e" }],
  ["path", { d: "M20 8v3", key: "deu0bs" }],
  ["path", { d: "M18 2h2v2", key: "180o53" }],
  ["path", { d: "M4 11V9", key: "v3xsx8" }],
  ["path", { d: "M12 2h2", key: "cvn524" }],
  ["path", { d: "M12 22h2", key: "kn7ki6" }],
  ["path", { d: "M12 17h2", key: "13u4lk" }],
  ["path", { d: "M8 22H6.5a2.5 2.5 0 0 1 0-5H8", key: "fiseg2" }],
  ["path", { d: "M4 5v-.5A2.5 2.5 0 0 1 6.5 2H8", key: "wywhs9" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rL = d("BookDown", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m9 10 3 3 3-3", key: "zt5b4y" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aL = d("BookHeadphones", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["path", { d: "M8 12v-2a4 4 0 0 1 8 0v2", key: "1vsqkj" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iL = d("BookHeart", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  [
    "path",
    {
      d: "M16 8.2C16 7 15 6 13.8 6c-.8 0-1.4.3-1.8.9-.4-.6-1-.9-1.8-.9C9 6 8 7 8 8.2c0 .6.3 1.2.7 1.6C10 11.1 12 13 12 13s2-1.9 3.3-3.1c.4-.4.7-1 .7-1.7z",
      key: "109ejj"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oL = d("BookImage", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["circle", { cx: "10", cy: "8", r: "2", key: "2qkj4p" }],
  ["path", { d: "m20 13.7-2.1-2.1c-.8-.8-2-.8-2.8 0L9.7 17", key: "160say" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sL = d("BookKey", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H14", key: "1gfsgw" }],
  ["path", { d: "M20 8v14H6.5a2.5 2.5 0 0 1 0-5H20", key: "zb0ngp" }],
  ["circle", { cx: "14", cy: "8", r: "2", key: "u49eql" }],
  ["path", { d: "m20 2-4.5 4.5", key: "1sppr8" }],
  ["path", { d: "m19 3 1 1", key: "ze14oc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cL = d("BookLock", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10", key: "18wgow" }],
  ["path", { d: "M20 15v7H6.5a2.5 2.5 0 0 1 0-5H20", key: "dpch1j" }],
  ["rect", { width: "8", height: "5", x: "12", y: "6", rx: "1", key: "9nqwug" }],
  ["path", { d: "M18 6V4a2 2 0 1 0-4 0v2", key: "1aquzs" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lL = d("BookMarked", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["polyline", { points: "10 2 10 10 13 7 16 10 16 2", key: "13o6vz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dL = d("BookMinus", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uL = d("BookOpenCheck", [
  ["path", { d: "M8 3H2v15h7c1.7 0 3 1.3 3 3V7c0-2.2-1.8-4-4-4Z", key: "1i8u0n" }],
  ["path", { d: "m16 12 2 2 4-4", key: "mdajum" }],
  ["path", { d: "M22 6V3h-6c-2.2 0-4 1.8-4 4v14c0-1.7 1.3-3 3-3h7v-2.3", key: "jb5l51" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hL = d("BookOpenText", [
  ["path", { d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z", key: "vv98re" }],
  ["path", { d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z", key: "1cyq3y" }],
  ["path", { d: "M6 8h2", key: "30oboj" }],
  ["path", { d: "M6 12h2", key: "32wvfc" }],
  ["path", { d: "M16 8h2", key: "msurwy" }],
  ["path", { d: "M16 12h2", key: "7q9ll5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pL = d("BookOpen", [
  ["path", { d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z", key: "vv98re" }],
  ["path", { d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z", key: "1cyq3y" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fL = d("BookPlus", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yL = d("BookText", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "M8 7h6", key: "1f0q6e" }],
  ["path", { d: "M8 11h8", key: "vwpz6n" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mL = d("BookType", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "M16 8V6H8v2", key: "x8j6u4" }],
  ["path", { d: "M12 6v7", key: "1f6ttz" }],
  ["path", { d: "M10 13h4", key: "ytezjc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gL = d("BookUp2", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2", key: "1lorq7" }],
  ["path", { d: "M18 2h2v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "1nfm9i" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vL = d("BookUp", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kL = d("BookUser", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["path", { d: "M15 13a3 3 0 1 0-6 0", key: "10j68g" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bL = d("BookX", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }],
  ["path", { d: "m14.5 7-5 5", key: "dy991v" }],
  ["path", { d: "m9.5 7 5 5", key: "s45iea" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xL = d("Book", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "t4utmx" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ML = d("BookmarkCheck", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wL = d("BookmarkMinus", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CL = d("BookmarkPlus", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }],
  ["line", { x1: "12", x2: "12", y1: "7", y2: "13", key: "1cppfj" }],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SL = d("BookmarkX", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AL = d("Bookmark", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OL = d("BoomBox", [
  ["path", { d: "M4 9V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "vvzvr1" }],
  ["path", { d: "M8 8v1", key: "xcqmfk" }],
  ["path", { d: "M12 8v1", key: "1rj8u4" }],
  ["path", { d: "M16 8v1", key: "1q12zr" }],
  ["rect", { width: "20", height: "12", x: "2", y: "9", rx: "2", key: "igpb89" }],
  ["circle", { cx: "8", cy: "15", r: "2", key: "fa4a8s" }],
  ["circle", { cx: "16", cy: "15", r: "2", key: "14c3ya" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EL = d("BotMessageSquare", [
  ["path", { d: "M12 6V2H8", key: "1155em" }],
  ["path", { d: "m8 18-4 4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z", key: "w2lp3e" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M9 11v2", key: "1ueba0" }],
  ["path", { d: "M15 11v2", key: "i11awn" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IL = d("BotOff", [
  ["path", { d: "M13.67 8H18a2 2 0 0 1 2 2v4.33", key: "7az073" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }],
  ["path", { d: "M8 8H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 1.414-.586", key: "s09a7a" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }],
  ["path", { d: "M9.67 4H12v2.33", key: "110xot" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DL = d("Bot", [
  ["path", { d: "M12 8V4H8", key: "hb8ula" }],
  ["rect", { width: "16", height: "12", x: "4", y: "8", rx: "2", key: "enze0r" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M15 13v2", key: "1xurst" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TL = d("BoxSelect", [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NL = d("Box", [
  [
    "path",
    {
      d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
      key: "hh9hay"
    }
  ],
  ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
  ["path", { d: "M12 22V12", key: "d0xqtd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PL = d("Boxes", [
  [
    "path",
    {
      d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z",
      key: "lc1i9w"
    }
  ],
  ["path", { d: "m7 16.5-4.74-2.85", key: "1o9zyk" }],
  ["path", { d: "m7 16.5 5-3", key: "va8pkn" }],
  ["path", { d: "M7 16.5v5.17", key: "jnp8gn" }],
  [
    "path",
    {
      d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z",
      key: "8zsnat"
    }
  ],
  ["path", { d: "m17 16.5-5-3", key: "8arw3v" }],
  ["path", { d: "m17 16.5 4.74-2.85", key: "8rfmw" }],
  ["path", { d: "M17 16.5v5.17", key: "k6z78m" }],
  [
    "path",
    {
      d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z",
      key: "1xygjf"
    }
  ],
  ["path", { d: "M12 8 7.26 5.15", key: "1vbdud" }],
  ["path", { d: "m12 8 4.74-2.85", key: "3rx089" }],
  ["path", { d: "M12 13.5V8", key: "1io7kd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LL = d("Braces", [
  [
    "path",
    { d: "M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1", key: "ezmyqa" }
  ],
  [
    "path",
    {
      d: "M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1",
      key: "e1hn23"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RL = d("Brackets", [
  ["path", { d: "M16 3h3v18h-3", key: "1yor1f" }],
  ["path", { d: "M8 21H5V3h3", key: "1qrfwo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VL = d("BrainCircuit", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
      key: "l5xja"
    }
  ],
  ["path", { d: "M9 13a4.5 4.5 0 0 0 3-4", key: "10igwf" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M12 13h4", key: "1ku699" }],
  ["path", { d: "M12 18h6a2 2 0 0 1 2 2v1", key: "105ag5" }],
  ["path", { d: "M12 8h8", key: "1lhi5i" }],
  ["path", { d: "M16 8V5a2 2 0 0 1 2-2", key: "u6izg6" }],
  ["circle", { cx: "16", cy: "13", r: ".5", key: "ry7gng" }],
  ["circle", { cx: "18", cy: "3", r: ".5", key: "1aiba7" }],
  ["circle", { cx: "20", cy: "21", r: ".5", key: "yhc1fs" }],
  ["circle", { cx: "20", cy: "8", r: ".5", key: "1e43v0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zL = d("BrainCog", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.142 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588 4 4 0 0 0 7.636 2.106 3.2 3.2 0 0 0 .164-.546c.028-.13.306-.13.335 0a3.2 3.2 0 0 0 .163.546 4 4 0 0 0 7.636-2.106 4 4 0 0 0 .556-6.588 4 4 0 0 0-2.526-5.77A3 3 0 1 0 12 5",
      key: "1kgmhc"
    }
  ],
  ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m15.7 10.4-.9.4", key: "ayzo6p" }],
  ["path", { d: "m9.2 13.2-.9.4", key: "1uzb3g" }],
  ["path", { d: "m13.6 15.7-.4-.9", key: "11ifqf" }],
  ["path", { d: "m10.8 9.2-.4-.9", key: "1pmk2v" }],
  ["path", { d: "m15.7 13.5-.9-.4", key: "7ng02m" }],
  ["path", { d: "m9.2 10.9-.9-.4", key: "1x66zd" }],
  ["path", { d: "m10.5 15.7.4-.9", key: "3js94g" }],
  ["path", { d: "m13.1 9.2.4-.9", key: "18n7mc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BL = d("Brain", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
      key: "l5xja"
    }
  ],
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z",
      key: "ep3f8r"
    }
  ],
  ["path", { d: "M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4", key: "1p4c4q" }],
  ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HL = d("BrickWall", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 9v6", key: "199k2o" }],
  ["path", { d: "M16 15v6", key: "8rj2es" }],
  ["path", { d: "M16 3v6", key: "1j6rpj" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M8 15v6", key: "1stoo3" }],
  ["path", { d: "M8 3v6", key: "vlvjmk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $L = d("BriefcaseBusiness", [
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2", key: "1ksdt3" }],
  ["path", { d: "M22 13a18.15 18.15 0 0 1-20 0", key: "12hx5q" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jL = d("BriefcaseMedical", [
  ["path", { d: "M12 11v4", key: "a6ujw6" }],
  ["path", { d: "M14 13h-4", key: "1pl8zg" }],
  ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2", key: "1ksdt3" }],
  ["path", { d: "M18 6v14", key: "1mu4gy" }],
  ["path", { d: "M6 6v14", key: "1s15cj" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FL = d("Briefcase", [
  ["path", { d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16", key: "jecpp" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WL = d("BringToFront", [
  ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "2", key: "yj20xf" }],
  ["path", { d: "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2", key: "1ltk23" }],
  ["path", { d: "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2", key: "1q24h9" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qL = d("Brush", [
  ["path", { d: "m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08", key: "1styjt" }],
  [
    "path",
    {
      d: "M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z",
      key: "z0l1mu"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _L = d("BugOff", [
  ["path", { d: "M15 7.13V6a3 3 0 0 0-5.14-2.1L8 2", key: "vl8zik" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M22 13h-4v-2a4 4 0 0 0-4-4h-1.3", key: "1ou0bd" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M7.7 7.7A4 4 0 0 0 6 11v3a6 6 0 0 0 11.13 3.13", key: "1njkjs" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GL = d("BugPlay", [
  [
    "path",
    {
      d: "M12.765 21.522a.5.5 0 0 1-.765-.424v-8.196a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z",
      key: "17shqo"
    }
  ],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M18 11a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v3a6.1 6.1 0 0 0 2 4.5", key: "1tjixy" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZL = d("Bug", [
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }],
  [
    "path",
    {
      d: "M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6",
      key: "xs1cw7"
    }
  ],
  ["path", { d: "M12 20v-9", key: "1qisl0" }],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "M22 13h-4", key: "1jl80f" }],
  ["path", { d: "M17.2 17c2.1.1 3.8 1.9 3.8 4", key: "k3fwyw" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XL = d("Building2", [
  ["path", { d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z", key: "1b4qmf" }],
  ["path", { d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", key: "i71pzd" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2", key: "10jefs" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "M10 10h4", key: "tcdvrf" }],
  ["path", { d: "M10 14h4", key: "kelpxr" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UL = d("Building", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2", key: "76otgf" }],
  ["path", { d: "M9 22v-4h6v4", key: "r93iot" }],
  ["path", { d: "M8 6h.01", key: "1dz90k" }],
  ["path", { d: "M16 6h.01", key: "1x0f13" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YL = d("BusFront", [
  ["path", { d: "M4 6 2 7", key: "1mqr15" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "m22 7-2-1", key: "1umjhc" }],
  ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 21v-2", key: "sqyl04" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JL = d("Bus", [
  ["path", { d: "M8 6v6", key: "18i7km" }],
  ["path", { d: "M15 6v6", key: "1sg6z9" }],
  ["path", { d: "M2 12h19.6", key: "de5uta" }],
  [
    "path",
    {
      d: "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3",
      key: "1wwztk"
    }
  ],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }],
  ["path", { d: "M9 18h5", key: "lrx6i" }],
  ["circle", { cx: "16", cy: "18", r: "2", key: "1v4tcr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KL = d("CableCar", [
  ["path", { d: "M10 3h.01", key: "lbucoy" }],
  ["path", { d: "M14 2h.01", key: "1k8aa1" }],
  ["path", { d: "m2 9 20-5", key: "1kz0j5" }],
  ["path", { d: "M12 12V6.5", key: "1vbrij" }],
  ["rect", { width: "16", height: "10", x: "4", y: "12", rx: "3", key: "if91er" }],
  ["path", { d: "M9 12v5", key: "3anwtq" }],
  ["path", { d: "M15 12v5", key: "5xh3zn" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QL = d("Cable", [
  [
    "path",
    {
      d: "M17 21v-2a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1",
      key: "10bnsj"
    }
  ],
  ["path", { d: "M19 15V6.5a1 1 0 0 0-7 0v11a1 1 0 0 1-7 0V9", key: "1eqmu1" }],
  ["path", { d: "M21 21v-2h-4", key: "14zm7j" }],
  ["path", { d: "M3 5h4V3", key: "z442eg" }],
  [
    "path",
    { d: "M7 5a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a1 1 0 0 1 1-1V3", key: "ebdjd7" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eR = d("CakeSlice", [
  ["circle", { cx: "9", cy: "7", r: "2", key: "1305pl" }],
  [
    "path",
    { d: "M7.2 7.9 3 11v9c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-9c0-2-3-6-7-8l-3.6 2.6", key: "xle13f" }
  ],
  ["path", { d: "M16 13H3", key: "1wpj08" }],
  ["path", { d: "M16 17H3", key: "3lvfcd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tR = d("Cake", [
  ["path", { d: "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8", key: "1w3rig" }],
  ["path", { d: "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1", key: "n2jgmb" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ["path", { d: "M7 8v3", key: "1qtyvj" }],
  ["path", { d: "M12 8v3", key: "hwp4zt" }],
  ["path", { d: "M17 8v3", key: "1i6e5u" }],
  ["path", { d: "M7 4h.01", key: "1bh4kh" }],
  ["path", { d: "M12 4h.01", key: "1ujb9j" }],
  ["path", { d: "M17 4h.01", key: "1upcoc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nR = d("Calculator", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["line", { x1: "8", x2: "16", y1: "6", y2: "6", key: "x4nwl0" }],
  ["line", { x1: "16", x2: "16", y1: "14", y2: "18", key: "wjye3r" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rR = d("CalendarCheck2", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 14V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "bce9hv" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aR = d("CalendarCheck", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m9 16 2 2 4-4", key: "19s6y9" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iR = d("CalendarClock", [
  ["path", { d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5", key: "1osxxc" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M3 10h5", key: "r794hk" }],
  ["path", { d: "M17.5 17.5 16 16.3V14", key: "akvzfd" }],
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oR = d("CalendarCog", [
  ["path", { d: "m15.2 16.9-.9-.4", key: "1r0w5f" }],
  ["path", { d: "m15.2 19.1-.9.4", key: "j188fs" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "m16.9 15.2-.4-.9", key: "699xu" }],
  ["path", { d: "m16.9 20.8-.4.9", key: "dfjc4z" }],
  ["path", { d: "m19.5 14.3-.4.9", key: "1eb35c" }],
  ["path", { d: "m19.5 21.7-.4-.9", key: "1tonu5" }],
  ["path", { d: "M21 10.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "11kmuh" }],
  ["path", { d: "m21.7 16.5-.9.4", key: "1knoei" }],
  ["path", { d: "m21.7 19.5-.9-.4", key: "q4dx6b" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sR = d("CalendarDays", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M16 18h.01", key: "kzsmim" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cR = d("CalendarFold", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 17V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11Z", key: "kg77oy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M15 22v-4a2 2 0 0 1 2-2h4", key: "1gnbqr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lR = d("CalendarHeart", [
  ["path", { d: "M3 10h18V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7", key: "136lmk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  [
    "path",
    {
      d: "M21.29 14.7a2.43 2.43 0 0 0-2.65-.52c-.3.12-.57.3-.8.53l-.34.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L17.5 22l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1t7hil"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dR = d("CalendarMinus2", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M10 16h4", key: "17e571" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uR = d("CalendarMinus", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hR = d("CalendarOff", [
  ["path", { d: "M4.2 4.2A2 2 0 0 0 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 1.82-1.18", key: "16swn3" }],
  ["path", { d: "M21 15.5V6a2 2 0 0 0-2-2H9.5", key: "yhw86o" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h7", key: "1wap6i" }],
  ["path", { d: "M21 10h-5.5", key: "quycpq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pR = d("CalendarPlus2", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M10 16h4", key: "17e571" }],
  ["path", { d: "M12 14v4", key: "1thi36" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fR = d("CalendarPlus", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yR = d("CalendarRange", [
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M17 14h-6", key: "bkmgh3" }],
  ["path", { d: "M13 18H7", key: "bb0bb7" }],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 18h.01", key: "1bdyru" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mR = d("CalendarSearch", [
  ["path", { d: "M21 12V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.5", key: "1e09qw" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.5-1.5", key: "1x83k4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gR = d("CalendarX2", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m17 22 5-5", key: "1k6ppv" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vR = d("CalendarX", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m14 14-4 4", key: "rymu2i" }],
  ["path", { d: "m10 14 4 4", key: "3sz06r" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kR = d("Calendar", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bR = d("CameraOff", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16", key: "qmtpty" }],
  ["path", { d: "M9.5 4h5L17 7h3a2 2 0 0 1 2 2v7.5", key: "1ufyfc" }],
  ["path", { d: "M14.121 15.121A3 3 0 1 1 9.88 10.88", key: "11zox6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xR = d("Camera", [
  [
    "path",
    {
      d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z",
      key: "1tc9qg"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "3", key: "1vg3eu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MR = d("CandlestickChart", [
  ["path", { d: "M9 5v4", key: "14uxtq" }],
  ["rect", { width: "4", height: "6", x: "7", y: "9", rx: "1", key: "f4fvz0" }],
  ["path", { d: "M9 15v2", key: "r5rk32" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  ["rect", { width: "4", height: "8", x: "15", y: "5", rx: "1", key: "z38je5" }],
  ["path", { d: "M17 13v3", key: "5l0wba" }],
  ["path", { d: "M3 3v18h18", key: "1s2lah" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wR = d("CandyCane", [
  [
    "path",
    {
      d: "M5.7 21a2 2 0 0 1-3.5-2l8.6-14a6 6 0 0 1 10.4 6 2 2 0 1 1-3.464-2 2 2 0 1 0-3.464-2Z",
      key: "isaq8g"
    }
  ],
  ["path", { d: "M17.75 7 15 2.1", key: "12x7e8" }],
  ["path", { d: "M10.9 4.8 13 9", key: "100a87" }],
  ["path", { d: "m7.9 9.7 2 4.4", key: "ntfhaj" }],
  ["path", { d: "M4.9 14.7 7 18.9", key: "1x43jy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CR = d("CandyOff", [
  ["path", { d: "m8.5 8.5-1 1a4.95 4.95 0 0 0 7 7l1-1", key: "1ff4ui" }],
  [
    "path",
    { d: "M11.843 6.187A4.947 4.947 0 0 1 16.5 7.5a4.947 4.947 0 0 1 1.313 4.657", key: "1sbrv4" }
  ],
  ["path", { d: "M14 16.5V14", key: "1maf8j" }],
  ["path", { d: "M14 6.5v1.843", key: "1a6u6t" }],
  ["path", { d: "M10 10v7.5", key: "80pj65" }],
  [
    "path",
    {
      d: "m16 7 1-5 1.367.683A3 3 0 0 0 19.708 3H21v1.292a3 3 0 0 0 .317 1.341L22 7l-5 1",
      key: "11a9mt"
    }
  ],
  [
    "path",
    {
      d: "m8 17-1 5-1.367-.683A3 3 0 0 0 4.292 21H3v-1.292a3 3 0 0 0-.317-1.341L2 17l5-1",
      key: "3mjmon"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SR = d("Candy", [
  ["path", { d: "m9.5 7.5-2 2a4.95 4.95 0 1 0 7 7l2-2a4.95 4.95 0 1 0-7-7Z", key: "ue6khb" }],
  ["path", { d: "M14 6.5v10", key: "5xnk7c" }],
  ["path", { d: "M10 7.5v10", key: "1uew51" }],
  [
    "path",
    { d: "m16 7 1-5 1.37.68A3 3 0 0 0 19.7 3H21v1.3c0 .46.1.92.32 1.33L22 7l-5 1", key: "b9cp6k" }
  ],
  [
    "path",
    { d: "m8 17-1 5-1.37-.68A3 3 0 0 0 4.3 21H3v-1.3a3 3 0 0 0-.32-1.33L2 17l5-1", key: "5lney8" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AR = d("Cannabis", [
  ["path", { d: "M12 22v-4", key: "1utk9m" }],
  [
    "path",
    {
      d: "M7 12c-1.5 0-4.5 1.5-5 3 3.5 1.5 6 1 6 1-1.5 1.5-2 3.5-2 5 2.5 0 4.5-1.5 6-3 1.5 1.5 3.5 3 6 3 0-1.5-.5-3.5-2-5 0 0 2.5.5 6-1-.5-1.5-3.5-3-5-3 1.5-1 4-4 4-6-2.5 0-5.5 1.5-7 3 0-2.5-.5-5-2-7-1.5 2-2 4.5-2 7-1.5-1.5-4.5-3-7-3 0 2 2.5 5 4 6",
      key: "1mezod"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OR = d("CaptionsOff", [
  ["path", { d: "M10.5 5H19a2 2 0 0 1 2 2v8.5", key: "jqtk4d" }],
  ["path", { d: "M17 11h-.5", key: "1961ue" }],
  ["path", { d: "M19 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2", key: "1keqsi" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M7 11h4", key: "1o1z6v" }],
  ["path", { d: "M7 15h2.5", key: "1ina1g" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ER = d("Captions", [
  ["rect", { width: "18", height: "14", x: "3", y: "5", rx: "2", ry: "2", key: "12ruh7" }],
  ["path", { d: "M7 15h4M15 15h2M7 11h2M13 11h4", key: "1ueiar" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IR = d("CarFront", [
  [
    "path",
    { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8", key: "1imjwt" }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DR = d("CarTaxiFront", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  [
    "path",
    { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8", key: "1imjwt" }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TR = d("Car", [
  [
    "path",
    {
      d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2",
      key: "5owen"
    }
  ],
  ["circle", { cx: "7", cy: "17", r: "2", key: "u2ysq9" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }],
  ["circle", { cx: "17", cy: "17", r: "2", key: "axvx0g" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NR = d("Caravan", [
  ["rect", { width: "4", height: "4", x: "2", y: "9", key: "1vcvhd" }],
  ["rect", { width: "4", height: "10", x: "10", y: "9", key: "1b7ev2" }],
  ["path", { d: "M18 19V9a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a2 2 0 0 0 2 2h2", key: "19jm3t" }],
  ["circle", { cx: "8", cy: "19", r: "2", key: "t8fc5s" }],
  ["path", { d: "M10 19h12v-2", key: "1yu2qx" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PR = d("Carrot", [
  [
    "path",
    {
      d: "M2.27 21.7s9.87-3.5 12.73-6.36a4.5 4.5 0 0 0-6.36-6.37C5.77 11.84 2.27 21.7 2.27 21.7zM8.64 14l-2.05-2.04M15.34 15l-2.46-2.46",
      key: "rfqxbe"
    }
  ],
  ["path", { d: "M22 9s-1.33-2-3.5-2C16.86 7 15 9 15 9s1.33 2 3.5 2S22 9 22 9z", key: "6b25w4" }],
  ["path", { d: "M15 2s-2 1.33-2 3.5S15 9 15 9s2-1.84 2-3.5C17 3.33 15 2 15 2z", key: "fn65lo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LR = d("CaseLower", [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RR = d("CaseSensitive", [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  ["circle", { cx: "18", cy: "12", r: "3", key: "1kchzo" }],
  ["path", { d: "M21 9v6", key: "anns31" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VR = d("CaseUpper", [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  ["path", { d: "M15 11h4.5a2 2 0 0 1 0 4H15V7h4a2 2 0 0 1 0 4", key: "1sqfas" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zR = d("CassetteTape", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["circle", { cx: "8", cy: "10", r: "2", key: "1xl4ub" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "10", r: "2", key: "r14t7q" }],
  ["path", { d: "m6 20 .7-2.9A1.4 1.4 0 0 1 8.1 16h7.8a1.4 1.4 0 0 1 1.4 1l.7 3", key: "l01ucn" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BR = d("Cast", [
  ["path", { d: "M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6", key: "3zrzxg" }],
  ["path", { d: "M2 12a9 9 0 0 1 8 8", key: "g6cvee" }],
  ["path", { d: "M2 16a5 5 0 0 1 4 4", key: "1y1dii" }],
  ["line", { x1: "2", x2: "2.01", y1: "20", y2: "20", key: "xu2jvo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HR = d("Castle", [
  ["path", { d: "M22 20v-9H2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z", key: "109fe4" }],
  ["path", { d: "M18 11V4H6v7", key: "mon5oj" }],
  ["path", { d: "M15 22v-4a3 3 0 0 0-3-3a3 3 0 0 0-3 3v4", key: "1k4jtn" }],
  ["path", { d: "M22 11V9", key: "3zbp94" }],
  ["path", { d: "M2 11V9", key: "1x5rnq" }],
  ["path", { d: "M6 4V2", key: "1rsq15" }],
  ["path", { d: "M18 4V2", key: "1jsdo1" }],
  ["path", { d: "M10 4V2", key: "75d9ly" }],
  ["path", { d: "M14 4V2", key: "8nj3z6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $R = d("Cat", [
  [
    "path",
    {
      d: "M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z",
      key: "x6xyqk"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  ["path", { d: "M11.25 16.25h1.5L12 17l-.75-.75Z", key: "12kq1m" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jR = d("Cctv", [
  [
    "path",
    {
      d: "M16.75 12h3.632a1 1 0 0 1 .894 1.447l-2.034 4.069a1 1 0 0 1-1.708.134l-2.124-2.97",
      key: "ir91b5"
    }
  ],
  [
    "path",
    {
      d: "M17.106 9.053a1 1 0 0 1 .447 1.341l-3.106 6.211a1 1 0 0 1-1.342.447L3.61 12.3a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3z",
      key: "jlp8i1"
    }
  ],
  ["path", { d: "M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15", key: "19bib8" }],
  ["path", { d: "M2 21v-4", key: "l40lih" }],
  ["path", { d: "M7 9h.01", key: "19b3jx" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FR = d("CheckCheck", [
  ["path", { d: "M18 6 7 17l-5-5", key: "116fxf" }],
  ["path", { d: "m22 10-7.5 7.5L13 16", key: "ke71qq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WR = d("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qR = d("ChefHat", [
  [
    "path",
    {
      d: "M17 21a1 1 0 0 0 1-1v-5.35c0-.457.316-.844.727-1.041a4 4 0 0 0-2.134-7.589 5 5 0 0 0-9.186 0 4 4 0 0 0-2.134 7.588c.411.198.727.585.727 1.041V20a1 1 0 0 0 1 1Z",
      key: "1qvrer"
    }
  ],
  ["path", { d: "M6 17h12", key: "1jwigz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _R = d("Cherry", [
  ["path", { d: "M2 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z", key: "cvxqlc" }],
  ["path", { d: "M12 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z", key: "1ostrc" }],
  ["path", { d: "M7 14c3.22-2.91 4.29-8.75 5-12 1.66 2.38 4.94 9 5 12", key: "hqx58h" }],
  ["path", { d: "M22 9c-4.29 0-7.14-2.33-10-7 5.71 0 10 4.67 10 7Z", key: "eykp1o" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GR = d("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZR = d("ChevronFirst", [
  ["path", { d: "m17 18-6-6 6-6", key: "1yerx2" }],
  ["path", { d: "M7 6v12", key: "1p53r6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XR = d("ChevronLast", [
  ["path", { d: "m7 18 6-6-6-6", key: "lwmzdw" }],
  ["path", { d: "M17 6v12", key: "1o0aio" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UR = d("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YR = d("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JR = d("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KR = d("ChevronsDownUp", [
  ["path", { d: "m7 20 5-5 5 5", key: "13a0gw" }],
  ["path", { d: "m7 4 5 5 5-5", key: "1kwcof" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QR = d("ChevronsDown", [
  ["path", { d: "m7 6 5 5 5-5", key: "1lc07p" }],
  ["path", { d: "m7 13 5 5 5-5", key: "1d48rs" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eV = d("ChevronsLeftRight", [
  ["path", { d: "m9 7-5 5 5 5", key: "j5w590" }],
  ["path", { d: "m15 7 5 5-5 5", key: "1bl6da" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tV = d("ChevronsLeft", [
  ["path", { d: "m11 17-5-5 5-5", key: "13zhaf" }],
  ["path", { d: "m18 17-5-5 5-5", key: "h8a8et" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nV = d("ChevronsRightLeft", [
  ["path", { d: "m20 17-5-5 5-5", key: "30x0n2" }],
  ["path", { d: "m4 17 5-5-5-5", key: "16spf4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rV = d("ChevronsRight", [
  ["path", { d: "m6 17 5-5-5-5", key: "xnjwq" }],
  ["path", { d: "m13 17 5-5-5-5", key: "17xmmf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aV = d("ChevronsUpDown", [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iV = d("ChevronsUp", [
  ["path", { d: "m17 11-5-5-5 5", key: "e8nh98" }],
  ["path", { d: "m17 18-5-5-5 5", key: "2avn1x" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oV = d("Chrome", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["line", { x1: "21.17", x2: "12", y1: "8", y2: "8", key: "a0cw5f" }],
  ["line", { x1: "3.95", x2: "8.54", y1: "6.06", y2: "14", key: "1kftof" }],
  ["line", { x1: "10.88", x2: "15.46", y1: "21.94", y2: "14", key: "1ymyh8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sV = d("Church", [
  ["path", { d: "m18 7 4 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9l4-2", key: "gy5gyo" }],
  ["path", { d: "M14 22v-4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v4", key: "tdb53m" }],
  ["path", { d: "M18 22V5l-6-3-6 3v17", key: "1hsnhq" }],
  ["path", { d: "M12 7v5", key: "ma6bk" }],
  ["path", { d: "M10 9h4", key: "u4k05v" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cV = d("CigaretteOff", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M12 12H2v4h14", key: "91gsaq" }],
  ["path", { d: "M22 12v4", key: "142cbu" }],
  ["path", { d: "M18 12h-.5", key: "12ymji" }],
  ["path", { d: "M7 12v4", key: "jqww69" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lV = d("Cigarette", [
  ["path", { d: "M18 12H2v4h16", key: "2rt1hm" }],
  ["path", { d: "M22 12v4", key: "142cbu" }],
  ["path", { d: "M7 12v4", key: "jqww69" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dV = d("CircleAlert", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uV = d("CircleArrowDown", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hV = d("CircleArrowLeft", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pV = d("CircleArrowOutDownLeft", [
  ["path", { d: "M2 12a10 10 0 1 1 10 10", key: "1yn6ov" }],
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "M8 22H2v-6", key: "sulq54" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fV = d("CircleArrowOutDownRight", [
  ["path", { d: "M12 22a10 10 0 1 1 10-10", key: "130bv5" }],
  ["path", { d: "M22 22 12 12", key: "131aw7" }],
  ["path", { d: "M22 16v6h-6", key: "1gvm70" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yV = d("CircleArrowOutUpLeft", [
  ["path", { d: "M2 8V2h6", key: "hiwtdz" }],
  ["path", { d: "m2 2 10 10", key: "1oh8rs" }],
  ["path", { d: "M12 2A10 10 0 1 1 2 12", key: "rrk4fa" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mV = d("CircleArrowOutUpRight", [
  ["path", { d: "M22 12A10 10 0 1 1 12 2", key: "1fm58d" }],
  ["path", { d: "M22 2 12 12", key: "yg2myt" }],
  ["path", { d: "M16 2h6v6", key: "zan5cs" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gV = d("CircleArrowRight", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vV = d("CircleArrowUp", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kV = d("CircleCheckBig", [
  ["path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14", key: "g774vq" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bV = d("CircleCheck", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xV = d("CircleChevronDown", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MV = d("CircleChevronLeft", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wV = d("CircleChevronRight", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CV = d("CircleChevronUp", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SV = d("CircleDashed", [
  ["path", { d: "M10.1 2.182a10 10 0 0 1 3.8 0", key: "5ilxe3" }],
  ["path", { d: "M13.9 21.818a10 10 0 0 1-3.8 0", key: "11zvb9" }],
  ["path", { d: "M17.609 3.721a10 10 0 0 1 2.69 2.7", key: "1iw5b2" }],
  ["path", { d: "M2.182 13.9a10 10 0 0 1 0-3.8", key: "c0bmvh" }],
  ["path", { d: "M20.279 17.609a10 10 0 0 1-2.7 2.69", key: "1ruxm7" }],
  ["path", { d: "M21.818 10.1a10 10 0 0 1 0 3.8", key: "qkgqxc" }],
  ["path", { d: "M3.721 6.391a10 10 0 0 1 2.7-2.69", key: "1mcia2" }],
  ["path", { d: "M6.391 20.279a10 10 0 0 1-2.69-2.7", key: "1fvljs" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AV = d("CircleDivide", [
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OV = d("CircleDollarSign", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EV = d("CircleDotDashed", [
  ["path", { d: "M10.1 2.18a9.93 9.93 0 0 1 3.8 0", key: "1qdqn0" }],
  ["path", { d: "M17.6 3.71a9.95 9.95 0 0 1 2.69 2.7", key: "1bq7p6" }],
  ["path", { d: "M21.82 10.1a9.93 9.93 0 0 1 0 3.8", key: "1rlaqf" }],
  ["path", { d: "M20.29 17.6a9.95 9.95 0 0 1-2.7 2.69", key: "1xk03u" }],
  ["path", { d: "M13.9 21.82a9.94 9.94 0 0 1-3.8 0", key: "l7re25" }],
  ["path", { d: "M6.4 20.29a9.95 9.95 0 0 1-2.69-2.7", key: "1v18p6" }],
  ["path", { d: "M2.18 13.9a9.93 9.93 0 0 1 0-3.8", key: "xdo6bj" }],
  ["path", { d: "M3.71 6.4a9.95 9.95 0 0 1 2.7-2.69", key: "1jjmaz" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IV = d("CircleDot", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DV = d("CircleEllipsis", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TV = d("CircleEqual", [
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NV = d("CircleFadingPlus", [
  ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75", key: "175t95" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3", key: "1vce0s" }],
  ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4", key: "o3fkw4" }],
  ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857", key: "1szpfk" }],
  ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38", key: "9yhvd4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PV = d("CircleGauge", [
  ["path", { d: "M15.6 2.7a10 10 0 1 0 5.7 5.7", key: "1e0p6d" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M13.4 10.6 19 5", key: "1kr7tw" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LV = d("CircleHelp", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RV = d("CircleMinus", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VV = d("CircleOff", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.35 2.69A10 10 0 0 1 21.3 15.65", key: "1pfsoa" }],
  ["path", { d: "M19.08 19.08A10 10 0 1 1 4.92 4.92", key: "1ablyi" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zV = d("CircleParkingOff", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m5 5 14 14", key: "11anup" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.34", key: "a9qo08" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BV = d("CircleParking", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HV = d("CirclePause", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "10", x2: "10", y1: "15", y2: "9", key: "c1nkhi" }],
  ["line", { x1: "14", x2: "14", y1: "15", y2: "9", key: "h65svq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $V = d("CirclePercent", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jV = d("CirclePlay", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polygon", { points: "10 8 16 12 10 16 10 8", key: "1cimsy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FV = d("CirclePlus", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WV = d("CirclePower", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 12V7", key: "1tf3mz" }],
  ["path", { d: "M16 9a5 5 0 1 1-8 0", key: "174bae" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qV = d("CircleSlash2", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M22 2 2 22", key: "y4kqgn" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _V = d("CircleSlash", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GV = d("CircleStop", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["rect", { width: "6", height: "6", x: "9", y: "9", key: "1wrtvo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZV = d("CircleUserRound", [
  ["path", { d: "M18 20a6 6 0 0 0-12 0", key: "1qehca" }],
  ["circle", { cx: "12", cy: "10", r: "4", key: "1h16sb" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XV = d("CircleUser", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662", key: "154egf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UV = d("CircleX", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YV = d("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JV = d("CircuitBoard", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M11 9h4a2 2 0 0 0 2-2V3", key: "1ve2rv" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "M7 21v-4a2 2 0 0 1 2-2h4", key: "1fwkro" }],
  ["circle", { cx: "15", cy: "15", r: "2", key: "3i40o0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KV = d("Citrus", [
  [
    "path",
    {
      d: "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z",
      key: "4ite01"
    }
  ],
  ["path", { d: "M19.65 15.66A8 8 0 0 1 8.35 4.34", key: "1gxipu" }],
  ["path", { d: "m14 10-5.5 5.5", key: "92pfem" }],
  ["path", { d: "M14 17.85V10H6.15", key: "xqmtsk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QV = d("Clapperboard", [
  [
    "path",
    { d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z", key: "1tn4o7" }
  ],
  ["path", { d: "m6.2 5.3 3.1 3.9", key: "iuk76l" }],
  ["path", { d: "m12.4 3.4 3.1 4", key: "6hsd6n" }],
  ["path", { d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z", key: "ltgou9" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ez = d("ClipboardCheck", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m9 14 2 2 4-4", key: "df797q" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tz = d("ClipboardCopy", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2", key: "4jdomd" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v4", key: "3hqy98" }],
  ["path", { d: "M21 14H11", key: "1bme5i" }],
  ["path", { d: "m15 10-4 4 4 4", key: "5dvupr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nz = d("ClipboardList", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M12 11h4", key: "1jrz19" }],
  ["path", { d: "M12 16h4", key: "n85exb" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rz = d("ClipboardMinus", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 14h6", key: "159ibu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const az = d("ClipboardPaste", [
  [
    "path",
    { d: "M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z", key: "1pp7kr" }
  ],
  [
    "path",
    {
      d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10",
      key: "2ik1ml"
    }
  ],
  ["path", { d: "m17 10 4 4-4 4", key: "vp2hj1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iz = d("ClipboardPenLine", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" }],
  ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-.5", key: "1but9f" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 1.73 1", key: "1p8n7l" }],
  ["path", { d: "M8 18h1", key: "13wk12" }],
  [
    "path",
    {
      d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "2t3380"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oz = d("ClipboardPen", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5.5", key: "cereej" }],
  ["path", { d: "M4 13.5V6a2 2 0 0 1 2-2h2", key: "5ua5vh" }],
  [
    "path",
    {
      d: "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1y4qbx"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sz = d("ClipboardPlus", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 14h6", key: "159ibu" }],
  ["path", { d: "M12 17v-6", key: "1y8rbf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cz = d("ClipboardType", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 12v-1h6v1", key: "iehl6m" }],
  ["path", { d: "M11 17h2", key: "12w5me" }],
  ["path", { d: "M12 11v6", key: "1bwqyc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lz = d("ClipboardX", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m15 11-6 6", key: "1toa9n" }],
  ["path", { d: "m9 11 6 6", key: "wlibny" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dz = d("Clipboard", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uz = d("Clock1", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 8", key: "12zbmj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hz = d("Clock10", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 10", key: "atfzqc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pz = d("Clock11", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 8", key: "l5bg6f" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fz = d("Clock12", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12", key: "1fub01" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yz = d("Clock2", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 10", key: "1g230d" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mz = d("Clock3", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16.5 12", key: "1aq6pp" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gz = d("Clock4", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vz = d("Clock5", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 16", key: "1pcbox" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kz = d("Clock6", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 12 16.5", key: "hb2qv6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bz = d("Clock7", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 16", key: "ka3394" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xz = d("Clock8", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 14", key: "tmc9b4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mz = d("Clock9", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 7.5 12", key: "1k60p0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wz = d("Clock", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cz = d("CloudCog", [
  ["circle", { cx: "12", cy: "17", r: "3", key: "1spfwm" }],
  ["path", { d: "M4.2 15.1A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.2", key: "zaobp" }],
  ["path", { d: "m15.7 18.4-.9-.3", key: "4qxpbn" }],
  ["path", { d: "m9.2 15.9-.9-.3", key: "17q7o2" }],
  ["path", { d: "m10.6 20.7.3-.9", key: "1pf4s2" }],
  ["path", { d: "m13.1 14.2.3-.9", key: "1mnuqm" }],
  ["path", { d: "m13.6 20.7-.4-1", key: "1jpd1m" }],
  ["path", { d: "m10.8 14.3-.4-1", key: "17ugyy" }],
  ["path", { d: "m8.3 18.6 1-.4", key: "s42vdx" }],
  ["path", { d: "m14.7 15.8 1-.4", key: "2wizun" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sz = d("CloudDownload", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M12 12v9", key: "192myk" }],
  ["path", { d: "m8 17 4 4 4-4", key: "1ul180" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Az = d("CloudDrizzle", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M8 19v1", key: "1dk2by" }],
  ["path", { d: "M8 14v1", key: "84yxot" }],
  ["path", { d: "M16 19v1", key: "v220m7" }],
  ["path", { d: "M16 14v1", key: "g12gj6" }],
  ["path", { d: "M12 21v1", key: "q8vafk" }],
  ["path", { d: "M12 16v1", key: "1mx6rx" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oz = d("CloudFog", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 17H7", key: "pygtm1" }],
  ["path", { d: "M17 21H9", key: "1u2q02" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ez = d("CloudHail", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v2", key: "a1is7l" }],
  ["path", { d: "M8 14v2", key: "1e9m6t" }],
  ["path", { d: "M16 20h.01", key: "xwek51" }],
  ["path", { d: "M8 20h.01", key: "1vjney" }],
  ["path", { d: "M12 16v2", key: "z66u1j" }],
  ["path", { d: "M12 22h.01", key: "1urd7a" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iz = d("CloudLightning", [
  ["path", { d: "M6 16.326A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 .5 8.973", key: "1cez44" }],
  ["path", { d: "m13 12-3 5h4l-3 5", key: "1t22er" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dz = d("CloudMoonRain", [
  [
    "path",
    {
      d: "M10.083 9A6.002 6.002 0 0 1 16 4a4.243 4.243 0 0 0 6 6c0 2.22-1.206 4.16-3 5.197",
      key: "u82z8m"
    }
  ],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tz = d("CloudMoon", [
  ["path", { d: "M13 16a3 3 0 1 1 0 6H7a5 5 0 1 1 4.9-6Z", key: "p44pc9" }],
  ["path", { d: "M10.1 9A6 6 0 0 1 16 4a4.24 4.24 0 0 0 6 6 6 6 0 0 1-3 5.197", key: "16nha0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nz = d("CloudOff", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193", key: "yfwify" }],
  [
    "path",
    { d: "M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07", key: "jlfiyv" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pz = d("CloudRainWind", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "m9.2 22 3-7", key: "sb5f6j" }],
  ["path", { d: "m9 13-3 7", key: "500co5" }],
  ["path", { d: "m17 13-3 7", key: "8t2fiy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lz = d("CloudRain", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v6", key: "1j4efv" }],
  ["path", { d: "M8 14v6", key: "17c4r9" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rz = d("CloudSnow", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M8 19h.01", key: "puxtts" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  ["path", { d: "M12 21h.01", key: "h35vbk" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M16 19h.01", key: "1vcnzz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vz = d("CloudSunRain", [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zz = d("CloudSun", [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z", key: "s09mg5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bz = d("CloudUpload", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M12 12v9", key: "192myk" }],
  ["path", { d: "m16 16-4-4-4 4", key: "119tzi" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hz = d("Cloud", [
  ["path", { d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "p7xjir" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $z = d("Cloudy", [
  ["path", { d: "M17.5 21H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "gqqjvc" }],
  ["path", { d: "M22 10a3 3 0 0 0-3-3h-2.207a5.502 5.502 0 0 0-10.702.5", key: "1p2s76" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jz = d("Clover", [
  ["path", { d: "M16.17 7.83 2 22", key: "t58vo8" }],
  [
    "path",
    {
      d: "M4.02 12a2.827 2.827 0 1 1 3.81-4.17A2.827 2.827 0 1 1 12 4.02a2.827 2.827 0 1 1 4.17 3.81A2.827 2.827 0 1 1 19.98 12a2.827 2.827 0 1 1-3.81 4.17A2.827 2.827 0 1 1 12 19.98a2.827 2.827 0 1 1-4.17-3.81A1 1 0 1 1 4 12",
      key: "17k36q"
    }
  ],
  ["path", { d: "m7.83 7.83 8.34 8.34", key: "1d7sxk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fz = d("Club", [
  [
    "path",
    {
      d: "M17.28 9.05a5.5 5.5 0 1 0-10.56 0A5.5 5.5 0 1 0 12 17.66a5.5 5.5 0 1 0 5.28-8.6Z",
      key: "27yuqz"
    }
  ],
  ["path", { d: "M12 17.66L12 22", key: "ogfahf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wz = d("CodeXml", [
  ["path", { d: "m18 16 4-4-4-4", key: "1inbqp" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }],
  ["path", { d: "m14.5 4-5 16", key: "e7oirm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qz = d("Code", [
  ["polyline", { points: "16 18 22 12 16 6", key: "z7tu5w" }],
  ["polyline", { points: "8 6 2 12 8 18", key: "1eg1df" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _z = d("Codepen", [
  ["polygon", { points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2", key: "srzb37" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "15.5", key: "1t73f2" }],
  ["polyline", { points: "22 8.5 12 15.5 2 8.5", key: "ajlxae" }],
  ["polyline", { points: "2 15.5 12 8.5 22 15.5", key: "susrui" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "8.5", key: "2cldga" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gz = d("Codesandbox", [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ],
  ["polyline", { points: "7.5 4.21 12 6.81 16.5 4.21", key: "fabo96" }],
  ["polyline", { points: "7.5 19.79 7.5 14.6 3 12", key: "z377f1" }],
  ["polyline", { points: "21 12 16.5 14.6 16.5 19.79", key: "9nrev1" }],
  ["polyline", { points: "3.27 6.96 12 12.01 20.73 6.96", key: "1180pa" }],
  ["line", { x1: "12", x2: "12", y1: "22.08", y2: "12", key: "3z3uq6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zz = d("Coffee", [
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M14 2v2", key: "6buw04" }],
  [
    "path",
    {
      d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
      key: "pwadti"
    }
  ],
  ["path", { d: "M6 2v2", key: "colzsn" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xz = d("Cog", [
  ["path", { d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z", key: "sobvz5" }],
  ["path", { d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", key: "11i496" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 22v-2", key: "1osdcq" }],
  ["path", { d: "m17 20.66-1-1.73", key: "eq3orb" }],
  ["path", { d: "M11 10.27 7 3.34", key: "16pf9h" }],
  ["path", { d: "m20.66 17-1.73-1", key: "sg0v6f" }],
  ["path", { d: "m3.34 7 1.73 1", key: "1ulond" }],
  ["path", { d: "M14 12h8", key: "4f43i9" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "m20.66 7-1.73 1", key: "1ow05n" }],
  ["path", { d: "m3.34 17 1.73-1", key: "nuk764" }],
  ["path", { d: "m17 3.34-1 1.73", key: "2wel8s" }],
  ["path", { d: "m11 13.73-4 6.93", key: "794ttg" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uz = d("Coins", [
  ["circle", { cx: "8", cy: "8", r: "6", key: "3yglwk" }],
  ["path", { d: "M18.09 10.37A6 6 0 1 1 10.34 18", key: "t5s6rm" }],
  ["path", { d: "M7 6h1v4", key: "1obek4" }],
  ["path", { d: "m16.71 13.88.7.71-2.82 2.82", key: "1rbuyh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yz = d("Columns2", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 3v18", key: "108xh3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jz = d("Columns3", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kz = d("Columns4", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7.5 3v18", key: "w0wo6v" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M16.5 3v18", key: "10tjh1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qz = d("Combine", [
  ["rect", { width: "8", height: "8", x: "2", y: "2", rx: "2", key: "z1hh3n" }],
  ["path", { d: "M14 2c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2", key: "83orz6" }],
  ["path", { d: "M20 2c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2", key: "k86dmt" }],
  ["path", { d: "M10 18H5c-1.7 0-3-1.3-3-3v-1", key: "6vokjl" }],
  ["polyline", { points: "7 21 10 18 7 15", key: "1k02g0" }],
  ["rect", { width: "8", height: "8", x: "14", y: "14", rx: "2", key: "1fa9i4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eB = d("Command", [
  [
    "path",
    { d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3", key: "11bfej" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tB = d("Compass", [
  [
    "path",
    {
      d: "m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z",
      key: "9ktpf1"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nB = d("Component", [
  ["path", { d: "M5.5 8.5 9 12l-3.5 3.5L2 12l3.5-3.5Z", key: "1kciei" }],
  ["path", { d: "m12 2 3.5 3.5L12 9 8.5 5.5 12 2Z", key: "1ome0g" }],
  ["path", { d: "M18.5 8.5 22 12l-3.5 3.5L15 12l3.5-3.5Z", key: "vbupec" }],
  ["path", { d: "m12 15 3.5 3.5L12 22l-3.5-3.5L12 15Z", key: "16csic" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rB = d("Computer", [
  ["rect", { width: "14", height: "8", x: "5", y: "2", rx: "2", key: "wc9tft" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h2", key: "rwmk9e" }],
  ["path", { d: "M12 18h6", key: "aqd8w3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aB = d("ConciergeBell", [
  [
    "path",
    { d: "M3 20a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1Z", key: "1pvr1r" }
  ],
  ["path", { d: "M20 16a8 8 0 1 0-16 0", key: "1pa543" }],
  ["path", { d: "M12 4v4", key: "1bq03y" }],
  ["path", { d: "M10 4h4", key: "1xpv9s" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iB = d("Cone", [
  ["path", { d: "m20.9 18.55-8-15.98a1 1 0 0 0-1.8 0l-8 15.98", key: "53pte7" }],
  ["ellipse", { cx: "12", cy: "19", rx: "9", ry: "3", key: "1ji25f" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oB = d("Construction", [
  ["rect", { x: "2", y: "6", width: "20", height: "8", rx: "1", key: "1estib" }],
  ["path", { d: "M17 14v7", key: "7m2elx" }],
  ["path", { d: "M7 14v7", key: "1cm7wv" }],
  ["path", { d: "M17 3v3", key: "1v4jwn" }],
  ["path", { d: "M7 3v3", key: "7o6guu" }],
  ["path", { d: "M10 14 2.3 6.3", key: "1023jk" }],
  ["path", { d: "m14 6 7.7 7.7", key: "1s8pl2" }],
  ["path", { d: "m8 6 8 8", key: "hl96qh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sB = d("ContactRound", [
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }],
  ["circle", { cx: "12", cy: "11", r: "3", key: "itu57m" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "4", key: "1ff9gb" }],
  ["line", { x1: "16", x2: "16", y1: "2", y2: "4", key: "1ufoma" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cB = d("Contact", [
  ["path", { d: "M17 18a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2", key: "1mghuy" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["circle", { cx: "12", cy: "10", r: "2", key: "1yojzk" }],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "4", key: "1ff9gb" }],
  ["line", { x1: "16", x2: "16", y1: "2", y2: "4", key: "1ufoma" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lB = d("Container", [
  [
    "path",
    {
      d: "M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z",
      key: "1t2lqe"
    }
  ],
  ["path", { d: "M10 21.9V14L2.1 9.1", key: "o7czzq" }],
  ["path", { d: "m10 14 11.9-6.9", key: "zm5e20" }],
  ["path", { d: "M14 19.8v-8.1", key: "159ecu" }],
  ["path", { d: "M18 17.5V9.4", key: "11uown" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dB = d("Contrast", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 18a6 6 0 0 0 0-12v12z", key: "j4l70d" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uB = d("Cookie", [
  ["path", { d: "M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5", key: "laymnq" }],
  ["path", { d: "M8.5 8.5v.01", key: "ue8clq" }],
  ["path", { d: "M16 15.5v.01", key: "14dtrp" }],
  ["path", { d: "M12 12v.01", key: "u5ubse" }],
  ["path", { d: "M11 17v.01", key: "1hyl5a" }],
  ["path", { d: "M7 14v.01", key: "uct60s" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hB = d("CookingPot", [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8", key: "u0tga0" }],
  ["path", { d: "m4 8 16-4", key: "16g0ng" }],
  [
    "path",
    {
      d: "m8.86 6.78-.45-1.81a2 2 0 0 1 1.45-2.43l1.94-.48a2 2 0 0 1 2.43 1.46l.45 1.8",
      key: "12cejc"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pB = d("CopyCheck", [
  ["path", { d: "m12 15 2 2 4-4", key: "2c609p" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fB = d("CopyMinus", [
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yB = d("CopyPlus", [
  ["line", { x1: "15", x2: "15", y1: "12", y2: "18", key: "1p7wdc" }],
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mB = d("CopySlash", [
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gB = d("CopyX", [
  ["line", { x1: "12", x2: "18", y1: "12", y2: "18", key: "1rg63v" }],
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vB = d("Copy", [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kB = d("Copyleft", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.17 14.83a4 4 0 1 0 0-5.66", key: "1sveal" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bB = d("Copyright", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M14.83 14.83a4 4 0 1 1 0-5.66", key: "1i56pz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xB = d("CornerDownLeft", [
  ["polyline", { points: "9 10 4 15 9 20", key: "r3jprv" }],
  ["path", { d: "M20 4v7a4 4 0 0 1-4 4H4", key: "6o5b7l" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MB = d("CornerDownRight", [
  ["polyline", { points: "15 10 20 15 15 20", key: "1q7qjw" }],
  ["path", { d: "M4 4v7a4 4 0 0 0 4 4h12", key: "z08zvw" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wB = d("CornerLeftDown", [
  ["polyline", { points: "14 15 9 20 4 15", key: "nkc4i" }],
  ["path", { d: "M20 4h-7a4 4 0 0 0-4 4v12", key: "nbpdq2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CB = d("CornerLeftUp", [
  ["polyline", { points: "14 9 9 4 4 9", key: "m9oyvo" }],
  ["path", { d: "M20 20h-7a4 4 0 0 1-4-4V4", key: "1blwi3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SB = d("CornerRightDown", [
  ["polyline", { points: "10 15 15 20 20 15", key: "axus6l" }],
  ["path", { d: "M4 4h7a4 4 0 0 1 4 4v12", key: "wcbgct" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AB = d("CornerRightUp", [
  ["polyline", { points: "10 9 15 4 20 9", key: "1lr6px" }],
  ["path", { d: "M4 20h7a4 4 0 0 0 4-4V4", key: "1plgdj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OB = d("CornerUpLeft", [
  ["polyline", { points: "9 14 4 9 9 4", key: "881910" }],
  ["path", { d: "M20 20v-7a4 4 0 0 0-4-4H4", key: "1nkjon" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EB = d("CornerUpRight", [
  ["polyline", { points: "15 14 20 9 15 4", key: "1tbx3s" }],
  ["path", { d: "M4 20v-7a4 4 0 0 1 4-4h12", key: "1lu4f8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IB = d("Cpu", [
  ["rect", { width: "16", height: "16", x: "4", y: "4", rx: "2", key: "14l7u7" }],
  ["rect", { width: "6", height: "6", x: "9", y: "9", rx: "1", key: "5aljv4" }],
  ["path", { d: "M15 2v2", key: "13l42r" }],
  ["path", { d: "M15 20v2", key: "15mkzm" }],
  ["path", { d: "M2 15h2", key: "1gxd5l" }],
  ["path", { d: "M2 9h2", key: "1bbxkp" }],
  ["path", { d: "M20 15h2", key: "19e6y8" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M9 2v2", key: "165o2o" }],
  ["path", { d: "M9 20v2", key: "i2bqo8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DB = d("CreativeCommons", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  [
    "path",
    { d: "M10 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1", key: "1ss3eq" }
  ],
  [
    "path",
    { d: "M17 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1", key: "1od56t" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TB = d("CreditCard", [
  ["rect", { width: "20", height: "14", x: "2", y: "5", rx: "2", key: "ynyp8z" }],
  ["line", { x1: "2", x2: "22", y1: "10", y2: "10", key: "1b3vmo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NB = d("Croissant", [
  [
    "path",
    {
      d: "m4.6 13.11 5.79-3.21c1.89-1.05 4.79 1.78 3.71 3.71l-3.22 5.81C8.8 23.16.79 15.23 4.6 13.11Z",
      key: "1ozxlb"
    }
  ],
  [
    "path",
    {
      d: "m10.5 9.5-1-2.29C9.2 6.48 8.8 6 8 6H4.5C2.79 6 2 6.5 2 8.5a7.71 7.71 0 0 0 2 4.83",
      key: "ffuyb5"
    }
  ],
  ["path", { d: "M8 6c0-1.55.24-4-2-4-2 0-2.5 2.17-2.5 4", key: "osnpzi" }],
  [
    "path",
    {
      d: "m14.5 13.5 2.29 1c.73.3 1.21.7 1.21 1.5v3.5c0 1.71-.5 2.5-2.5 2.5a7.71 7.71 0 0 1-4.83-2",
      key: "1vubaw"
    }
  ],
  ["path", { d: "M18 16c1.55 0 4-.24 4 2 0 2-2.17 2.5-4 2.5", key: "wxr772" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PB = d("Crop", [
  ["path", { d: "M6 2v14a2 2 0 0 0 2 2h14", key: "ron5a4" }],
  ["path", { d: "M18 22V8a2 2 0 0 0-2-2H2", key: "7s9ehn" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LB = d("Cross", [
  [
    "path",
    {
      d: "M11 2a2 2 0 0 0-2 2v5H4a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h5v5c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2v-5h5a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-5V4a2 2 0 0 0-2-2h-2z",
      key: "1t5g7j"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RB = d("Crosshair", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "22", x2: "18", y1: "12", y2: "12", key: "l9bcsi" }],
  ["line", { x1: "6", x2: "2", y1: "12", y2: "12", key: "13hhkx" }],
  ["line", { x1: "12", x2: "12", y1: "6", y2: "2", key: "10w3f3" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "18", key: "15g9kq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VB = d("Crown", [
  [
    "path",
    {
      d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
      key: "1vdc57"
    }
  ],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zB = d("Cuboid", [
  [
    "path",
    {
      d: "m21.12 6.4-6.05-4.06a2 2 0 0 0-2.17-.05L2.95 8.41a2 2 0 0 0-.95 1.7v5.82a2 2 0 0 0 .88 1.66l6.05 4.07a2 2 0 0 0 2.17.05l9.95-6.12a2 2 0 0 0 .95-1.7V8.06a2 2 0 0 0-.88-1.66Z",
      key: "1u2ovd"
    }
  ],
  ["path", { d: "M10 22v-8L2.25 9.15", key: "11pn4q" }],
  ["path", { d: "m10 14 11.77-6.87", key: "1kt1wh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BB = d("CupSoda", [
  ["path", { d: "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8", key: "8166m8" }],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "yjz344" }],
  ["path", { d: "m12 8 1-6h2", key: "3ybfa4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HB = d("Currency", [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["line", { x1: "3", x2: "6", y1: "3", y2: "6", key: "1jkytn" }],
  ["line", { x1: "21", x2: "18", y1: "3", y2: "6", key: "14zfjt" }],
  ["line", { x1: "3", x2: "6", y1: "21", y2: "18", key: "iusuec" }],
  ["line", { x1: "21", x2: "18", y1: "21", y2: "18", key: "yj2dd7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $B = d("Cylinder", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 18 0V5", key: "aqi0yr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jB = d("DatabaseBackup", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 12a9 3 0 0 0 5 2.69", key: "1ui2ym" }],
  ["path", { d: "M21 9.3V5", key: "6k6cib" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 6.47 2.88", key: "i62tjy" }],
  ["path", { d: "M12 12v4h4", key: "1bxaet" }],
  [
    "path",
    {
      d: "M13 20a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L12 16",
      key: "1f4ei9"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FB = d("DatabaseZap", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 15 21.84", key: "14ibmq" }],
  ["path", { d: "M21 5V8", key: "1marbg" }],
  ["path", { d: "M21 12L18 17H22L19 22", key: "zafso" }],
  ["path", { d: "M3 12A9 3 0 0 0 14.59 14.87", key: "1y4wr8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WB = d("Database", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 21 19V5", key: "1wlel7" }],
  ["path", { d: "M3 12A9 3 0 0 0 21 12", key: "mv7ke4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qB = d("Delete", [
  ["path", { d: "M20 5H9l-7 7 7 7h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Z", key: "1oy587" }],
  ["line", { x1: "18", x2: "12", y1: "9", y2: "15", key: "1olkx5" }],
  ["line", { x1: "12", x2: "18", y1: "9", y2: "15", key: "1n50pc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _B = d("Dessert", [
  ["circle", { cx: "12", cy: "4", r: "2", key: "muu5ef" }],
  [
    "path",
    {
      d: "M10.2 3.2C5.5 4 2 8.1 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4 0c0-4.9-3.5-9-8.2-9.8",
      key: "lfo06j"
    }
  ],
  ["path", { d: "M3.2 14.8a9 9 0 0 0 17.6 0", key: "12xarc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GB = d("Diameter", [
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }],
  ["path", { d: "M6.48 3.66a10 10 0 0 1 13.86 13.86", key: "xr8kdq" }],
  ["path", { d: "m6.41 6.41 11.18 11.18", key: "uhpjw7" }],
  ["path", { d: "M3.66 6.48a10 10 0 0 0 13.86 13.86", key: "cldpwv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZB = d("DiamondMinus", [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
      key: "1ey20j"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XB = d("DiamondPercent", [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0Z",
      key: "1tpxz2"
    }
  ],
  ["path", { d: "M9.2 9.2h.01", key: "1b7bvt" }],
  ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
  ["path", { d: "M14.7 14.8h.01", key: "17nsh4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UB = d("DiamondPlus", [
  ["path", { d: "M12 8v8", key: "napkw2" }],
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
      key: "1ey20j"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YB = d("Diamond", [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41l-7.59-7.59a2.41 2.41 0 0 0-3.41 0Z",
      key: "1f1r0c"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JB = d("Dice1", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KB = d("Dice2", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }],
  ["path", { d: "M9 15h.01", key: "fzyn71" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QB = d("Dice3", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eH = d("Dice4", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tH = d("Dice5", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nH = d("Dice6", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rH = d("Dices", [
  ["rect", { width: "12", height: "12", x: "2", y: "10", rx: "2", ry: "2", key: "6agr2n" }],
  [
    "path",
    { d: "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6", key: "1o487t" }
  ],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 14h.01", key: "ssrbsk" }],
  ["path", { d: "M15 6h.01", key: "cblpky" }],
  ["path", { d: "M18 9h.01", key: "2061c0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aH = d("Diff", [
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iH = d("Disc2", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oH = d("Disc3", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M6 12c0-1.7.7-3.2 1.8-4.2", key: "oqkarx" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M18 12c0 1.7-.7 3.2-1.8 4.2", key: "1eah9h" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sH = d("DiscAlbum", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "12", r: "5", key: "nd82uf" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cH = d("Disc", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lH = d("Divide", [
  ["circle", { cx: "12", cy: "6", r: "1", key: "1bh7o1" }],
  ["line", { x1: "5", x2: "19", y1: "12", y2: "12", key: "13b5wn" }],
  ["circle", { cx: "12", cy: "18", r: "1", key: "lqb9t5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dH = d("DnaOff", [
  ["path", { d: "M15 2c-1.35 1.5-2.092 3-2.5 4.5L14 8", key: "1bivrr" }],
  ["path", { d: "m17 6-2.891-2.891", key: "xu6p2f" }],
  ["path", { d: "M2 15c3.333-3 6.667-3 10-3", key: "nxix30" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "m20 9 .891.891", key: "3xwk7g" }],
  ["path", { d: "M22 9c-1.5 1.35-3 2.092-4.5 2.5l-1-1", key: "18cutr" }],
  ["path", { d: "M3.109 14.109 4 15", key: "q76aoh" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m7 18 2.891 2.891", key: "1sisit" }],
  ["path", { d: "M9 22c1.35-1.5 2.092-3 2.5-4.5L10 16", key: "rlvei3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uH = d("Dna", [
  ["path", { d: "m10 16 1.5 1.5", key: "11lckj" }],
  ["path", { d: "m14 8-1.5-1.5", key: "1ohn8i" }],
  ["path", { d: "M15 2c-1.798 1.998-2.518 3.995-2.807 5.993", key: "80uv8i" }],
  ["path", { d: "m16.5 10.5 1 1", key: "696xn5" }],
  ["path", { d: "m17 6-2.891-2.891", key: "xu6p2f" }],
  ["path", { d: "M2 15c6.667-6 13.333 0 20-6", key: "1pyr53" }],
  ["path", { d: "m20 9 .891.891", key: "3xwk7g" }],
  ["path", { d: "M3.109 14.109 4 15", key: "q76aoh" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m7 18 2.891 2.891", key: "1sisit" }],
  ["path", { d: "M9 22c1.798-1.998 2.518-3.995 2.807-5.993", key: "q3hbxp" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hH = d("Dock", [
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 16h12", key: "u522kt" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pH = d("Dog", [
  [
    "path",
    {
      d: "M10 5.172C10 3.782 8.423 2.679 6.5 3c-2.823.47-4.113 6.006-4 7 .08.703 1.725 1.722 3.656 1 1.261-.472 1.96-1.45 2.344-2.5",
      key: "19br0u"
    }
  ],
  [
    "path",
    {
      d: "M14.267 5.172c0-1.39 1.577-2.493 3.5-2.172 2.823.47 4.113 6.006 4 7-.08.703-1.725 1.722-3.656 1-1.261-.472-1.855-1.45-2.239-2.5",
      key: "11n1an"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  ["path", { d: "M11.25 16.25h1.5L12 17l-.75-.75Z", key: "12kq1m" }],
  [
    "path",
    {
      d: "M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444c0-1.061-.162-2.2-.493-3.309m-9.243-6.082A8.801 8.801 0 0 1 12 5c.78 0 1.5.108 2.161.306",
      key: "wsu29d"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fH = d("DollarSign", [
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
  ["path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6", key: "1b0p4s" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yH = d("Donut", [
  [
    "path",
    {
      d: "M20.5 10a2.5 2.5 0 0 1-2.4-3H18a2.95 2.95 0 0 1-2.6-4.4 10 10 0 1 0 6.3 7.1c-.3.2-.8.3-1.2.3",
      key: "19sr3x"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mH = d("DoorClosed", [
  ["path", { d: "M18 20V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14", key: "36qu9e" }],
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "M14 12v.01", key: "xfcn54" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gH = d("DoorOpen", [
  ["path", { d: "M13 4h3a2 2 0 0 1 2 2v14", key: "hrm0s9" }],
  ["path", { d: "M2 20h3", key: "1gaodv" }],
  ["path", { d: "M13 20h9", key: "s90cdi" }],
  ["path", { d: "M10 12v.01", key: "vx6srw" }],
  [
    "path",
    {
      d: "M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4-1A2 2 0 0 1 13 4.561Z",
      key: "199qr4"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vH = d("Dot", [
  ["circle", { cx: "12.1", cy: "12.1", r: "1", key: "18d7e5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kH = d("Download", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "7 10 12 15 17 10", key: "2ggqvy" }],
  ["line", { x1: "12", x2: "12", y1: "15", y2: "3", key: "1vk2je" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bH = d("DraftingCompass", [
  ["circle", { cx: "12", cy: "5", r: "2", key: "f1ur92" }],
  ["path", { d: "m3 21 8.02-14.26", key: "1ssaw4" }],
  ["path", { d: "m12.99 6.74 1.93 3.44", key: "iwagvd" }],
  ["path", { d: "M19 12c-3.87 4-10.13 4-14 0", key: "1tsu18" }],
  ["path", { d: "m21 21-2.16-3.84", key: "vylbct" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xH = d("Drama", [
  ["path", { d: "M10 11h.01", key: "d2at3l" }],
  ["path", { d: "M14 6h.01", key: "k028ub" }],
  ["path", { d: "M18 6h.01", key: "1v4wsw" }],
  ["path", { d: "M6.5 13.1h.01", key: "1748ia" }],
  ["path", { d: "M22 5c0 9-4 12-6 12s-6-3-6-12c0-2 2-3 6-3s6 1 6 3", key: "172yzv" }],
  ["path", { d: "M17.4 9.9c-.8.8-2 .8-2.8 0", key: "1obv0w" }],
  [
    "path",
    {
      d: "M10.1 7.1C9 7.2 7.7 7.7 6 8.6c-3.5 2-4.7 3.9-3.7 5.6 4.5 7.8 9.5 8.4 11.2 7.4.9-.5 1.9-2.1 1.9-4.7",
      key: "rqjl8i"
    }
  ],
  ["path", { d: "M9.1 16.5c.3-1.1 1.4-1.7 2.4-1.4", key: "1mr6wy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MH = d("Dribbble", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M19.13 5.09C15.22 9.14 10 10.44 2.25 10.94", key: "hpej1" }],
  ["path", { d: "M21.75 12.84c-6.62-1.41-12.14 1-16.38 6.32", key: "1tr44o" }],
  ["path", { d: "M8.56 2.75c4.37 6 6 9.42 8 17.72", key: "kbh691" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wH = d("Drill", [
  [
    "path",
    { d: "M14 9c0 .6-.4 1-1 1H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9c.6 0 1 .4 1 1Z", key: "b6nnkj" }
  ],
  ["path", { d: "M18 6h4", key: "66u95g" }],
  ["path", { d: "M14 4h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3", key: "105ega" }],
  ["path", { d: "m5 10-2 8", key: "xt2lic" }],
  ["path", { d: "M12 10v3c0 .6-.4 1-1 1H8", key: "mwpjnk" }],
  ["path", { d: "m7 18 2-8", key: "1bzku2" }],
  [
    "path",
    { d: "M5 22c-1.7 0-3-1.3-3-3 0-.6.4-1 1-1h7c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1Z", key: "117add" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CH = d("Droplet", [
  [
    "path",
    {
      d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
      key: "c7niix"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SH = d("Droplets", [
  [
    "path",
    {
      d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z",
      key: "1ptgy4"
    }
  ],
  [
    "path",
    {
      d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97",
      key: "1sl1rz"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AH = d("Drum", [
  ["path", { d: "m2 2 8 8", key: "1v6059" }],
  ["path", { d: "m22 2-8 8", key: "173r8a" }],
  ["ellipse", { cx: "12", cy: "9", rx: "10", ry: "5", key: "liohsx" }],
  ["path", { d: "M7 13.4v7.9", key: "1yi6u9" }],
  ["path", { d: "M12 14v8", key: "1tn2tj" }],
  ["path", { d: "M17 13.4v7.9", key: "eqz2v3" }],
  ["path", { d: "M2 9v8a10 5 0 0 0 20 0V9", key: "1750ul" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OH = d("Drumstick", [
  [
    "path",
    { d: "M15.4 15.63a7.875 6 135 1 1 6.23-6.23 4.5 3.43 135 0 0-6.23 6.23", key: "1dtqwm" }
  ],
  [
    "path",
    {
      d: "m8.29 12.71-2.6 2.6a2.5 2.5 0 1 0-1.65 4.65A2.5 2.5 0 1 0 8.7 18.3l2.59-2.59",
      key: "1oq1fw"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EH = d("Dumbbell", [
  ["path", { d: "M14.4 14.4 9.6 9.6", key: "ic80wn" }],
  [
    "path",
    {
      d: "M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z",
      key: "nnl7wr"
    }
  ],
  ["path", { d: "m21.5 21.5-1.4-1.4", key: "1f1ice" }],
  ["path", { d: "M3.9 3.9 2.5 2.5", key: "1evmna" }],
  [
    "path",
    {
      d: "M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z",
      key: "yhosts"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IH = d("EarOff", [
  ["path", { d: "M6 18.5a3.5 3.5 0 1 0 7 0c0-1.57.92-2.52 2.04-3.46", key: "1qngmn" }],
  ["path", { d: "M6 8.5c0-.75.13-1.47.36-2.14", key: "b06bma" }],
  ["path", { d: "M8.8 3.15A6.5 6.5 0 0 1 19 8.5c0 1.63-.44 2.81-1.09 3.76", key: "g10hsz" }],
  ["path", { d: "M12.5 6A2.5 2.5 0 0 1 15 8.5M10 13a2 2 0 0 0 1.82-1.18", key: "ygzou7" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DH = d("Ear", [
  ["path", { d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0", key: "1dfaln" }],
  ["path", { d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4", key: "1qnva7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TH = d("EarthLock", [
  ["path", { d: "M7 3.34V5a3 3 0 0 0 3 3", key: "w732o8" }],
  ["path", { d: "M11 21.95V18a2 2 0 0 0-2-2 2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05", key: "f02343" }],
  ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
  ["path", { d: "M12 2a10 10 0 1 0 9.54 13", key: "zjsr6q" }],
  ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
  ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NH = d("Earth", [
  ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
  [
    "path",
    {
      d: "M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17",
      key: "1tzkfa"
    }
  ],
  ["path", { d: "M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05", key: "14pb5j" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PH = d("Eclipse", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a7 7 0 1 0 10 10", key: "1yuj32" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LH = d("EggFried", [
  ["circle", { cx: "11.5", cy: "12.5", r: "3.5", key: "1cl1mi" }],
  [
    "path",
    {
      d: "M3 8c0-3.5 2.5-6 6.5-6 5 0 4.83 3 7.5 5s5 2 5 6c0 4.5-2.5 6.5-7 6.5-2.5 0-2.5 2.5-6 2.5s-7-2-7-5.5c0-3 1.5-3 1.5-5C3.5 10 3 9 3 8Z",
      key: "165ef9"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RH = d("EggOff", [
  [
    "path",
    {
      d: "M6.399 6.399C5.362 8.157 4.65 10.189 4.5 12c-.37 4.43 1.27 9.95 7.5 10 3.256-.026 5.259-1.547 6.375-3.625",
      key: "6et380"
    }
  ],
  [
    "path",
    {
      d: "M19.532 13.875A14.07 14.07 0 0 0 19.5 12c-.36-4.34-3.95-9.96-7.5-10-1.04.012-2.082.502-3.046 1.297",
      key: "gcdc3f"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VH = d("Egg", [
  [
    "path",
    {
      d: "M12 22c6.23-.05 7.87-5.57 7.5-10-.36-4.34-3.95-9.96-7.5-10-3.55.04-7.14 5.66-7.5 10-.37 4.43 1.27 9.95 7.5 10z",
      key: "1c39pg"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zH = d("EllipsisVertical", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BH = d("Ellipsis", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HH = d("EqualNot", [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }],
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $H = d("Equal", [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jH = d("Eraser", [
  [
    "path",
    {
      d: "m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21",
      key: "182aya"
    }
  ],
  ["path", { d: "M22 21H7", key: "t4ddhn" }],
  ["path", { d: "m5 11 9 9", key: "1mo9qw" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FH = d("Euro", [
  ["path", { d: "M4 10h12", key: "1y6xl8" }],
  ["path", { d: "M4 14h9", key: "1loblj" }],
  [
    "path",
    {
      d: "M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2",
      key: "1j6lzo"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WH = d("Expand", [
  ["path", { d: "m21 21-6-6m6 6v-4.8m0 4.8h-4.8", key: "1c15vz" }],
  ["path", { d: "M3 16.2V21m0 0h4.8M3 21l6-6", key: "1fsnz2" }],
  ["path", { d: "M21 7.8V3m0 0h-4.8M21 3l-6 6", key: "hawz9i" }],
  ["path", { d: "M3 7.8V3m0 0h4.8M3 3l6 6", key: "u9ee12" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qH = d("ExternalLink", [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _H = d("EyeOff", [
  ["path", { d: "M9.88 9.88a3 3 0 1 0 4.24 4.24", key: "1jxqfv" }],
  [
    "path",
    {
      d: "M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68",
      key: "9wicm4"
    }
  ],
  [
    "path",
    { d: "M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61", key: "1jreej" }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GH = d("Eye", [
  ["path", { d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z", key: "rwhkz3" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZH = d("Facebook", [
  [
    "path",
    { d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z", key: "1jg4f8" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XH = d("Factory", [
  [
    "path",
    {
      d: "M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "159hny"
    }
  ],
  ["path", { d: "M17 18h1", key: "uldtlt" }],
  ["path", { d: "M12 18h1", key: "s9uhes" }],
  ["path", { d: "M7 18h1", key: "1neino" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UH = d("Fan", [
  [
    "path",
    {
      d: "M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z",
      key: "484a7f"
    }
  ],
  ["path", { d: "M12 12v.01", key: "u5ubse" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YH = d("FastForward", [
  ["polygon", { points: "13 19 22 12 13 5 13 19", key: "587y9g" }],
  ["polygon", { points: "2 19 11 12 2 5 2 19", key: "3pweh0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JH = d("Feather", [
  [
    "path",
    {
      d: "M12.67 19a2 2 0 0 0 1.416-.588l6.154-6.172a6 6 0 0 0-8.49-8.49L5.586 9.914A2 2 0 0 0 5 11.328V18a1 1 0 0 0 1 1z",
      key: "18jl4k"
    }
  ],
  ["path", { d: "M16 8 2 22", key: "vp34q" }],
  ["path", { d: "M17.5 15H9", key: "1oz8nu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KH = d("Fence", [
  ["path", { d: "M4 3 2 5v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "1n2rgs" }],
  ["path", { d: "M6 8h4", key: "utf9t1" }],
  ["path", { d: "M6 18h4", key: "12yh4b" }],
  ["path", { d: "m12 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "3ha7mj" }],
  ["path", { d: "M14 8h4", key: "1r8wg2" }],
  ["path", { d: "M14 18h4", key: "1t3kbu" }],
  ["path", { d: "m20 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "dfd4e2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QH = d("FerrisWheel", [
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m6.8 15-3.5 2", key: "hjy98k" }],
  ["path", { d: "m20.7 7-3.5 2", key: "f08gto" }],
  ["path", { d: "M6.8 9 3.3 7", key: "1aevh4" }],
  ["path", { d: "m20.7 17-3.5-2", key: "1liqo3" }],
  ["path", { d: "m9 22 3-8 3 8", key: "wees03" }],
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M18 18.7a9 9 0 1 0-12 0", key: "dhzg4g" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e$ = d("Figma", [
  ["path", { d: "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z", key: "1340ok" }],
  ["path", { d: "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z", key: "1hz3m3" }],
  ["path", { d: "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z", key: "1oz8n2" }],
  ["path", { d: "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z", key: "1ff65i" }],
  ["path", { d: "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z", key: "pdip6e" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t$ = d("FileArchive", [
  ["path", { d: "M10 12v-1", key: "v7bkov" }],
  ["path", { d: "M10 18v-2", key: "1cjy8d" }],
  ["path", { d: "M10 7V6", key: "dljcrl" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M15.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 .274 1.01", key: "gkbcor" }
  ],
  ["circle", { cx: "10", cy: "20", r: "2", key: "1xzdoj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n$ = d("FileAudio2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "3", cy: "17", r: "1", key: "vo6nti" }],
  ["path", { d: "M2 17v-3a4 4 0 0 1 8 0v3", key: "1ggdre" }],
  ["circle", { cx: "9", cy: "17", r: "1", key: "bc1fq4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r$ = d("FileAudio", [
  ["path", { d: "M17.5 22h.5a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "rslqgf" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M2 19a2 2 0 1 1 4 0v1a2 2 0 1 1-4 0v-4a6 6 0 0 1 12 0v4a2 2 0 1 1-4 0v-1a2 2 0 1 1 4 0",
      key: "9f7x3i"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a$ = d("FileAxis3d", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 18 4-4", key: "12zab0" }],
  ["path", { d: "M8 10v8h8", key: "tlaukw" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i$ = d("FileBadge2", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14 12.5 1 5.5-3-1-3 1 1-5.5", key: "14xlky" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o$ = d("FileBadge", [
  ["path", { d: "M12 22h6a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "12ixgl" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M5 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "u0c8gj" }],
  ["path", { d: "M7 16.5 8 22l-3-1-3 1 1-5.5", key: "5gm2nr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s$ = d("FileBarChart2", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 18v-1", key: "zg0ygc" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "M16 18v-3", key: "j5jt4h" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c$ = d("FileBarChart", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 18v-2", key: "qcmpov" }],
  ["path", { d: "M12 18v-4", key: "q1q25u" }],
  ["path", { d: "M16 18v-6", key: "15y0np" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l$ = d("FileBox", [
  ["path", { d: "M14.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "16lz6z" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M3 13.1a2 2 0 0 0-1 1.76v3.24a2 2 0 0 0 .97 1.78L6 21.7a2 2 0 0 0 2.03.01L11 19.9a2 2 0 0 0 1-1.76V14.9a2 2 0 0 0-.97-1.78L8 11.3a2 2 0 0 0-2.03-.01Z",
      key: "99pj1s"
    }
  ],
  ["path", { d: "M7 17v5", key: "1yj1jh" }],
  ["path", { d: "M11.7 14.2 7 17l-4.7-2.8", key: "1yk8tc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d$ = d("FileCheck2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m3 15 2 2 4-4", key: "1lhrkk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u$ = d("FileCheck", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m9 15 2 2 4-4", key: "1grp1n" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h$ = d("FileClock", [
  ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "37hlfg" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "8", cy: "16", r: "6", key: "10v15b" }],
  ["path", { d: "M9.5 17.5 8 16.25V14", key: "1o80t2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p$ = d("FileCode2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m5 12-3 3 3 3", key: "oke12k" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f$ = d("FileCode", [
  ["path", { d: "M10 12.5 8 15l2 2.5", key: "1tg20x" }],
  ["path", { d: "m14 12.5 2 2.5-2 2.5", key: "yinavb" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y$ = d("FileCog", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m3.2 12.9-.9-.4", key: "1i3dj5" }],
  ["path", { d: "m3.2 15.1-.9.4", key: "1fvgj0" }],
  [
    "path",
    {
      d: "M4.677 21.5a2 2 0 0 0 1.313.5H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2.5",
      key: "1yo3oz"
    }
  ],
  ["path", { d: "m4.9 11.2-.4-.9", key: "otmhb9" }],
  ["path", { d: "m4.9 16.8-.4.9", key: "1b8z07" }],
  ["path", { d: "m7.5 10.3-.4.9", key: "11k65u" }],
  ["path", { d: "m7.5 17.7-.4-.9", key: "431x55" }],
  ["path", { d: "m9.7 12.5-.9.4", key: "87sjan" }],
  ["path", { d: "m9.7 15.5-.9-.4", key: "khqm91" }],
  ["circle", { cx: "6", cy: "14", r: "3", key: "a1xfv6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m$ = d("FileDiff", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g$ = d("FileDigit", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "4", height: "6", x: "2", y: "12", rx: "2", key: "jm304g" }],
  ["path", { d: "M10 12h2v6", key: "12zw74" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v$ = d("FileDown", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "m9 15 3 3 3-3", key: "1npd3o" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k$ = d("FileHeart", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M10.29 10.7a2.43 2.43 0 0 0-2.66-.52c-.29.12-.56.3-.78.53l-.35.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L6.5 18l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1c1fso"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b$ = d("FileImage", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "10", cy: "12", r: "2", key: "737tya" }],
  ["path", { d: "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22", key: "wt3hpn" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x$ = d("FileInput", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M2 15h10", key: "jfw4w8" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M$ = d("FileJson2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "fq0c9t" }
  ],
  [
    "path",
    { d: "M8 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "4gibmv" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w$ = d("FileJson", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "1oajmo" }
  ],
  [
    "path",
    { d: "M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "mpwhp6" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C$ = d("FileKey2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v6", key: "rc0qvx" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "m10 10-4.5 4.5", key: "7fwrp6" }],
  ["path", { d: "m9 11 1 1", key: "wa6s5q" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S$ = d("FileKey", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["circle", { cx: "10", cy: "16", r: "2", key: "4ckbqe" }],
  ["path", { d: "m16 10-4.5 4.5", key: "7p3ebg" }],
  ["path", { d: "m15 11 1 1", key: "1bsyx3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A$ = d("FileLineChart", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m16 13-3.5 3.5-2-2L8 17", key: "zz7yod" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O$ = d("FileLock2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v1", key: "jmtmu2" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "8", height: "5", x: "2", y: "13", rx: "1", key: "10y5wo" }],
  ["path", { d: "M8 13v-2a2 2 0 1 0-4 0v2", key: "1pdxzg" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E$ = d("FileLock", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["rect", { width: "8", height: "6", x: "8", y: "12", rx: "1", key: "3yr8at" }],
  ["path", { d: "M10 12v-2a2 2 0 1 1 4 0v2", key: "j4i8d" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I$ = d("FileMinus2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D$ = d("FileMinus", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T$ = d("FileMusic", [
  ["circle", { cx: "14", cy: "16", r: "2", key: "1bzzi3" }],
  ["circle", { cx: "6", cy: "18", r: "2", key: "1fncim" }],
  ["path", { d: "M4 12.4V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2h-7.5", key: "skc018" }],
  ["path", { d: "M8 18v-7.7L16 9v7", key: "1oie6o" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N$ = d("FileOutput", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M4 7V4a2 2 0 0 1 2-2 2 2 0 0 0-2 2", key: "1vk7w2" }],
  ["path", { d: "M4.063 20.999a2 2 0 0 0 2 1L18 22a2 2 0 0 0 2-2V7l-5-5H6", key: "1jink5" }],
  ["path", { d: "m5 11-3 3", key: "1dgrs4" }],
  ["path", { d: "m5 17-3-3h10", key: "1mvvaf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P$ = d("FilePenLine", [
  [
    "path",
    {
      d: "m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2",
      key: "142zxg"
    }
  ],
  [
    "path",
    {
      d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "2t3380"
    }
  ],
  ["path", { d: "M8 18h1", key: "13wk12" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L$ = d("FilePen", [
  ["path", { d: "M12.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v9.5", key: "1couwa" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1y4qbx"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R$ = d("FilePieChart", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3.5", key: "13ddob" }],
  ["path", { d: "M4.017 11.512a6 6 0 1 0 8.466 8.475", key: "s6vs5t" }],
  ["path", { d: "M8 16v-6a6 6 0 0 1 6 6z", key: "zfixgv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V$ = d("FilePlus2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }],
  ["path", { d: "M6 12v6", key: "1u72j0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z$ = d("FilePlus", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B$ = d("FileQuestion", [
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }],
  ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H$ = d("FileScan", [
  ["path", { d: "M20 10V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4", key: "1rdf37" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M16 14a2 2 0 0 0-2 2", key: "ceaadl" }],
  ["path", { d: "M20 14a2 2 0 0 1 2 2", key: "1ny6zw" }],
  ["path", { d: "M20 22a2 2 0 0 0 2-2", key: "1l9q4k" }],
  ["path", { d: "M16 22a2 2 0 0 1-2-2", key: "1wqh5n" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $$ = d("FileSearch2", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "11.5", cy: "14.5", r: "2.5", key: "1bq0ko" }],
  ["path", { d: "M13.3 16.3 15 18", key: "2quom7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j$ = d("FileSearch", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4.268 21a2 2 0 0 0 1.727 1H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "ms7g94" }
  ],
  ["path", { d: "m9 18-1.5-1.5", key: "1j6qii" }],
  ["circle", { cx: "5", cy: "14", r: "3", key: "ufru5t" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F$ = d("FileSliders", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M10 11v2", key: "1s651w" }],
  ["path", { d: "M8 17h8", key: "wh5c61" }],
  ["path", { d: "M14 16v2", key: "12fp5e" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W$ = d("FileSpreadsheet", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 13h2", key: "yr2amv" }],
  ["path", { d: "M14 13h2", key: "un5t4a" }],
  ["path", { d: "M8 17h2", key: "2yhykz" }],
  ["path", { d: "M14 17h2", key: "10kma7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q$ = d("FileStack", [
  ["path", { d: "M21 7h-3a2 2 0 0 1-2-2V2", key: "9rb54x" }],
  [
    "path",
    {
      d: "M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17Z",
      key: "1059l0"
    }
  ],
  ["path", { d: "M7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15", key: "16874u" }],
  ["path", { d: "M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11", key: "k2ox98" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _$ = d("FileSymlink", [
  ["path", { d: "m10 18 3-3-3-3", key: "18f6ys" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M4 11V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
      key: "50q2rw"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G$ = d("FileTerminal", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 16 2-2-2-2", key: "10vzyd" }],
  ["path", { d: "M12 18h4", key: "1wd2n7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z$ = d("FileText", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X$ = d("FileType2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M2 13v-1h6v1", key: "1dh9dg" }],
  ["path", { d: "M5 12v6", key: "150t9c" }],
  ["path", { d: "M4 18h2", key: "1xrofg" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U$ = d("FileType", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 13v-1h6v1", key: "1bb014" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "M11 18h2", key: "12mj7e" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y$ = d("FileUp", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "m15 15-3-3-3 3", key: "15xj92" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J$ = d("FileVideo2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "8", height: "6", x: "2", y: "12", rx: "1", key: "1a6c1e" }],
  ["path", { d: "m10 15.5 4 2.5v-6l-4 2.5", key: "t7cp39" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K$ = d("FileVideo", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m10 11 5 3-5 3v-6Z", key: "7ntvm4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q$ = d("FileVolume2", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M11.5 13.5a2.5 2.5 0 0 1 0 3", key: "1fccat" }],
  ["path", { d: "M15 12a5 5 0 0 1 0 6", key: "ps46cm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ej = d("FileVolume", [
  ["path", { d: "M11 11a5 5 0 0 1 0 6", key: "193qb2" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4.268 21A2 2 0 0 0 6 22h12a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "1x9xgf" }
  ],
  ["path", { d: "m7 10-3 2H2v4h2l3 2z", key: "1ln807" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tj = d("FileWarning", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nj = d("FileX2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 12.5-5 5", key: "b853mi" }],
  ["path", { d: "m3 12.5 5 5", key: "1qls4r" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rj = d("FileX", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14.5 12.5-5 5", key: "b62r18" }],
  ["path", { d: "m9.5 12.5 5 5", key: "1rk7el" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aj = d("File", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ij = d("Files", [
  ["path", { d: "M20 7h-3a2 2 0 0 1-2-2V2", key: "x099mo" }],
  ["path", { d: "M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z", key: "18t6ie" }],
  ["path", { d: "M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8", key: "1nja0z" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oj = d("Film", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  ["path", { d: "M3 7.5h4", key: "zfgn84" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 16.5h4", key: "1230mu" }],
  ["path", { d: "M17 3v18", key: "in4fa5" }],
  ["path", { d: "M17 7.5h4", key: "myr1c1" }],
  ["path", { d: "M17 16.5h4", key: "go4c1d" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sj = d("FilterX", [
  ["path", { d: "M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055", key: "1fi1da" }],
  ["path", { d: "m22 3-5 5", key: "12jva0" }],
  ["path", { d: "m17 3 5 5", key: "k36vhe" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cj = d("Filter", [
  ["polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3", key: "1yg77f" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lj = d("Fingerprint", [
  ["path", { d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4", key: "1nerag" }],
  ["path", { d: "M14 13.12c0 2.38 0 6.38-1 8.88", key: "o46ks0" }],
  ["path", { d: "M17.29 21.02c.12-.6.43-2.3.5-3.02", key: "ptglia" }],
  ["path", { d: "M2 12a10 10 0 0 1 18-6", key: "ydlgp0" }],
  ["path", { d: "M2 16h.01", key: "1gqxmh" }],
  ["path", { d: "M21.8 16c.2-2 .131-5.354 0-6", key: "drycrb" }],
  ["path", { d: "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2", key: "1tidbn" }],
  ["path", { d: "M8.65 22c.21-.66.45-1.32.57-2", key: "13wd9y" }],
  ["path", { d: "M9 6.8a6 6 0 0 1 9 5.2v2", key: "1fr1j5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dj = d("FireExtinguisher", [
  ["path", { d: "M15 6.5V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3.5", key: "sqyvz" }],
  ["path", { d: "M9 18h8", key: "i7pszb" }],
  ["path", { d: "M18 3h-3", key: "7idoqj" }],
  ["path", { d: "M11 3a6 6 0 0 0-6 6v11", key: "1v5je3" }],
  ["path", { d: "M5 13h4", key: "svpcxo" }],
  ["path", { d: "M17 10a4 4 0 0 0-8 0v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2Z", key: "vsjego" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uj = d("FishOff", [
  [
    "path",
    {
      d: "M18 12.47v.03m0-.5v.47m-.475 5.056A6.744 6.744 0 0 1 15 18c-3.56 0-7.56-2.53-8.5-6 .348-1.28 1.114-2.433 2.121-3.38m3.444-2.088A8.802 8.802 0 0 1 15 6c3.56 0 6.06 2.54 7 6-.309 1.14-.786 2.177-1.413 3.058",
      key: "1j1hse"
    }
  ],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33m7.48-4.372A9.77 9.77 0 0 1 16 6.07m0 11.86a9.77 9.77 0 0 1-1.728-3.618",
      key: "1q46z8"
    }
  ],
  [
    "path",
    {
      d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98M8.53 3h5.27a2 2 0 0 1 1.98 1.67l.23 1.4M2 2l20 20",
      key: "1407gh"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hj = d("FishSymbol", [
  ["path", { d: "M2 16s9-15 20-4C11 23 2 8 2 8", key: "h4oh4o" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pj = d("Fish", [
  [
    "path",
    {
      d: "M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z",
      key: "15baut"
    }
  ],
  ["path", { d: "M18 12v.5", key: "18hhni" }],
  ["path", { d: "M16 17.93a9.77 9.77 0 0 1 0-11.86", key: "16dt7o" }],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33",
      key: "l9di03"
    }
  ],
  [
    "path",
    { d: "M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 0 1 1.98 1.67l.23 1.4", key: "1kjonw" }
  ],
  [
    "path",
    { d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98", key: "1zlm23" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fj = d("FlagOff", [
  ["path", { d: "M8 2c3 0 5 2 8 2s4-1 4-1v11", key: "9rwyz9" }],
  ["path", { d: "M4 22V4", key: "1plyxx" }],
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2", key: "1myooe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yj = d("FlagTriangleLeft", [
  ["path", { d: "M17 22V2L7 7l10 5", key: "1rmf0r" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mj = d("FlagTriangleRight", [
  ["path", { d: "M7 22V2l10 5-10 5", key: "17n18y" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gj = d("Flag", [
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z", key: "i9b6wo" }],
  ["line", { x1: "4", x2: "4", y1: "22", y2: "15", key: "1cm3nv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vj = d("FlameKindling", [
  [
    "path",
    {
      d: "M12 2c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 17 10a5 5 0 1 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C8 4.5 11 2 12 2Z",
      key: "1ir223"
    }
  ],
  ["path", { d: "m5 22 14-4", key: "1brv4h" }],
  ["path", { d: "m5 18 14 4", key: "lgyyje" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kj = d("Flame", [
  [
    "path",
    {
      d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z",
      key: "96xj49"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bj = d("FlashlightOff", [
  ["path", { d: "M16 16v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4", key: "1r120k" }],
  ["path", { d: "M7 2h11v4c0 2-2 2-2 4v1", key: "dz1920" }],
  ["line", { x1: "11", x2: "18", y1: "6", y2: "6", key: "bi1vpe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xj = d("Flashlight", [
  [
    "path",
    {
      d: "M18 6c0 2-2 2-2 4v10a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4V2h12z",
      key: "1orkel"
    }
  ],
  ["line", { x1: "6", x2: "18", y1: "6", y2: "6", key: "1z11jq" }],
  ["line", { x1: "12", x2: "12", y1: "12", y2: "12", key: "1f4yc1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mj = d("FlaskConicalOff", [
  [
    "path",
    {
      d: "M10 10 4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-1.272-2.542",
      key: "59ek9y"
    }
  ],
  ["path", { d: "M10 2v2.343", key: "15t272" }],
  ["path", { d: "M14 2v6.343", key: "sxr80q" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M7 16h9", key: "t5njau" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wj = d("FlaskConical", [
  [
    "path",
    {
      d: "M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2",
      key: "pzvekw"
    }
  ],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M7 16h10", key: "wp8him" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cj = d("FlaskRound", [
  ["path", { d: "M10 2v7.31", key: "5d1hyh" }],
  ["path", { d: "M14 9.3V1.99", key: "14k4l0" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M14 9.3a6.5 6.5 0 1 1-4 0", key: "1r8fvy" }],
  ["path", { d: "M5.52 16h12.96", key: "46hh1i" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sj = d("FlipHorizontal2", [
  ["path", { d: "m3 7 5 5-5 5V7", key: "couhi7" }],
  ["path", { d: "m21 7-5 5 5 5V7", key: "6ouia7" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aj = d("FlipHorizontal", [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3", key: "1i73f7" }],
  ["path", { d: "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3", key: "saxlbk" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oj = d("FlipVertical2", [
  ["path", { d: "m17 3-5 5-5-5h10", key: "1ftt6x" }],
  ["path", { d: "m17 21-5-5-5 5h10", key: "1m0wmu" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ej = d("FlipVertical", [
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3", key: "14bfxa" }],
  ["path", { d: "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3", key: "14rx03" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ij = d("Flower2", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1",
      key: "3pnvol"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["path", { d: "M12 10v12", key: "6ubwww" }],
  ["path", { d: "M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z", key: "9hd38g" }],
  ["path", { d: "M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z", key: "ufn41s" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dj = d("Flower", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M12 16.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 1 1 4.5 4.5 4.5 4.5 0 1 1-4.5 4.5",
      key: "14wa3c"
    }
  ],
  ["path", { d: "M12 7.5V9", key: "1oy5b0" }],
  ["path", { d: "M7.5 12H9", key: "eltsq1" }],
  ["path", { d: "M16.5 12H15", key: "vk5kw4" }],
  ["path", { d: "M12 16.5V15", key: "k7eayi" }],
  ["path", { d: "m8 8 1.88 1.88", key: "nxy4qf" }],
  ["path", { d: "M14.12 9.88 16 8", key: "1lst6k" }],
  ["path", { d: "m8 16 1.88-1.88", key: "h2eex1" }],
  ["path", { d: "M14.12 14.12 16 16", key: "uqkrx3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tj = d("Focus", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nj = d("FoldHorizontal", [
  ["path", { d: "M2 12h6", key: "1wqiqv" }],
  ["path", { d: "M22 12h-6", key: "1eg9hc" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 9-3 3 3 3", key: "12ol22" }],
  ["path", { d: "m5 15 3-3-3-3", key: "1kdhjc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pj = d("FoldVertical", [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3-3-3 3", key: "e37ymu" }],
  ["path", { d: "m15 5-3 3-3-3", key: "19d6lf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lj = d("FolderArchive", [
  ["circle", { cx: "15", cy: "19", r: "2", key: "u2pros" }],
  [
    "path",
    {
      d: "M20.9 19.8A2 2 0 0 0 22 18V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h5.1",
      key: "1jj40k"
    }
  ],
  ["path", { d: "M15 11v-1", key: "cntcp" }],
  ["path", { d: "M15 17v-2", key: "1279jj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rj = d("FolderCheck", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vj = d("FolderClock", [
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
  [
    "path",
    {
      d: "M7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2",
      key: "1urifu"
    }
  ],
  ["path", { d: "M16 14v2l1 1", key: "xth2jh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zj = d("FolderClosed", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M2 10h20", key: "1ir3d8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bj = d("FolderCog", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  [
    "path",
    {
      d: "M10.3 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v3.3",
      key: "1k8050"
    }
  ],
  ["path", { d: "m21.7 19.4-.9-.3", key: "1qgwi9" }],
  ["path", { d: "m15.2 16.9-.9-.3", key: "1t7mvx" }],
  ["path", { d: "m16.6 21.7.3-.9", key: "1j67ps" }],
  ["path", { d: "m19.1 15.2.3-.9", key: "18r7jp" }],
  ["path", { d: "m19.6 21.7-.4-1", key: "z2vh2" }],
  ["path", { d: "m16.8 15.3-.4-1", key: "1ei7r6" }],
  ["path", { d: "m14.3 19.6 1-.4", key: "11sv9r" }],
  ["path", { d: "m20.7 16.8 1-.4", key: "19m87a" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hj = d("FolderDot", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "1", key: "49l61u" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $j = d("FolderDown", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m15 13-3 3-3-3", key: "6j2sf0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jj = d("FolderGit2", [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v5",
      key: "1w6njk"
    }
  ],
  ["circle", { cx: "13", cy: "12", r: "2", key: "1j92g6" }],
  ["path", { d: "M18 19c-2.8 0-5-2.2-5-5v8", key: "pkpw2h" }],
  ["circle", { cx: "20", cy: "19", r: "2", key: "1obnsp" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fj = d("FolderGit", [
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M14 13h3", key: "1dgedf" }],
  ["path", { d: "M7 13h3", key: "1pygq7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wj = d("FolderHeart", [
  [
    "path",
    {
      d: "M11 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v1.5",
      key: "6hud8k"
    }
  ],
  [
    "path",
    {
      d: "M13.9 17.45c-1.2-1.2-1.14-2.8-.2-3.73a2.43 2.43 0 0 1 3.44 0l.36.34.34-.34a2.43 2.43 0 0 1 3.45-.01c.95.95 1 2.53-.2 3.74L17.5 21Z",
      key: "wpff58"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qj = d("FolderInput", [
  [
    "path",
    {
      d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1",
      key: "fm4g5t"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m9 16 3-3-3-3", key: "6m91ic" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _j = d("FolderKanban", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["path", { d: "M8 10v4", key: "tgpxqk" }],
  ["path", { d: "M12 10v2", key: "hh53o1" }],
  ["path", { d: "M16 10v6", key: "1d6xys" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gj = d("FolderKey", [
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2",
      key: "3hgo9p"
    }
  ],
  ["path", { d: "m22 14-4.5 4.5", key: "1ef6z8" }],
  ["path", { d: "m21 15 1 1", key: "1ejcpy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zj = d("FolderLock", [
  ["rect", { width: "8", height: "5", x: "14", y: "17", rx: "1", key: "19aais" }],
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2.5",
      key: "1w6v7t"
    }
  ],
  ["path", { d: "M20 17v-2a2 2 0 1 0-4 0v2", key: "pwaxnr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xj = d("FolderMinus", [
  ["path", { d: "M9 13h6", key: "1uhe8q" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uj = d("FolderOpenDot", [
  [
    "path",
    {
      d: "m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2",
      key: "1nmvlm"
    }
  ],
  ["circle", { cx: "14", cy: "15", r: "1", key: "1gm4qj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yj = d("FolderOpen", [
  [
    "path",
    {
      d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
      key: "usdka0"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jj = d("FolderOutput", [
  [
    "path",
    {
      d: "M2 7.5V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-1.5",
      key: "1yk7aj"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m5 10-3 3 3 3", key: "1r8ie0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kj = d("FolderPen", [
  [
    "path",
    {
      d: "M2 11.5V5a2 2 0 0 1 2-2h3.9c.7 0 1.3.3 1.7.9l.8 1.2c.4.6 1 .9 1.7.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.5",
      key: "a8xqs0"
    }
  ],
  [
    "path",
    {
      d: "M11.378 13.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1saktj"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qj = d("FolderPlus", [
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eF = d("FolderRoot", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  ["path", { d: "M12 15v5", key: "11xva1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tF = d("FolderSearch2", [
  ["circle", { cx: "11.5", cy: "12.5", r: "2.5", key: "1ea5ju" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M13.3 14.3 15 16", key: "1y4v1n" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nF = d("FolderSearch", [
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  [
    "path",
    {
      d: "M10.7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v4.1",
      key: "1bw5m7"
    }
  ],
  ["path", { d: "m21 21-1.5-1.5", key: "3sg1j" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rF = d("FolderSymlink", [
  [
    "path",
    {
      d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
      key: "x1c07l"
    }
  ],
  ["path", { d: "m8 16 3-3-3-3", key: "rlqrt1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aF = d("FolderSync", [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v.5",
      key: "1dkoa9"
    }
  ],
  ["path", { d: "M12 10v4h4", key: "1czhmt" }],
  ["path", { d: "m12 14 1.535-1.605a5 5 0 0 1 8 1.5", key: "lvuxfi" }],
  ["path", { d: "M22 22v-4h-4", key: "1ewp4q" }],
  ["path", { d: "m22 18-1.535 1.605a5 5 0 0 1-8-1.5", key: "14ync0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iF = d("FolderTree", [
  [
    "path",
    {
      d: "M20 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a1 1 0 0 1-.8-.4l-.9-1.2A1 1 0 0 0 15 3h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "hod4my"
    }
  ],
  [
    "path",
    {
      d: "M20 21a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2.9a1 1 0 0 1-.88-.55l-.42-.85a1 1 0 0 0-.92-.6H13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "w4yl2u"
    }
  ],
  ["path", { d: "M3 5a2 2 0 0 0 2 2h3", key: "f2jnh7" }],
  ["path", { d: "M3 3v13a2 2 0 0 0 2 2h3", key: "k8epm1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oF = d("FolderUp", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m9 13 3-3 3 3", key: "1pxg3c" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sF = d("FolderX", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "m9.5 10.5 5 5", key: "ra9qjz" }],
  ["path", { d: "m14.5 10.5-5 5", key: "l2rkpq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cF = d("Folder", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lF = d("Folders", [
  [
    "path",
    {
      d: "M20 17a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.9a2 2 0 0 1-1.69-.9l-.81-1.2a2 2 0 0 0-1.67-.9H8a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2Z",
      key: "4u7rpt"
    }
  ],
  ["path", { d: "M2 8v11a2 2 0 0 0 2 2h14", key: "1eicx1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dF = d("Footprints", [
  [
    "path",
    {
      d: "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z",
      key: "1dudjm"
    }
  ],
  [
    "path",
    {
      d: "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z",
      key: "l2t8xc"
    }
  ],
  ["path", { d: "M16 17h4", key: "1dejxt" }],
  ["path", { d: "M4 13h4", key: "1bwh8b" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uF = d("Forklift", [
  ["path", { d: "M12 12H5a2 2 0 0 0-2 2v5", key: "7zsz91" }],
  ["circle", { cx: "13", cy: "19", r: "2", key: "wjnkru" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M8 19h3m5-17v17h6M6 12V7c0-1.1.9-2 2-2h3l5 5", key: "13bk1p" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hF = d("Forward", [
  ["polyline", { points: "15 17 20 12 15 7", key: "1w3sku" }],
  ["path", { d: "M4 18v-2a4 4 0 0 1 4-4h12", key: "jmiej9" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pF = d("Frame", [
  ["line", { x1: "22", x2: "2", y1: "6", y2: "6", key: "15w7dq" }],
  ["line", { x1: "22", x2: "2", y1: "18", y2: "18", key: "1ip48p" }],
  ["line", { x1: "6", x2: "6", y1: "2", y2: "22", key: "a2lnyx" }],
  ["line", { x1: "18", x2: "18", y1: "2", y2: "22", key: "8vb6jd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fF = d("Framer", [
  ["path", { d: "M5 16V9h14V2H5l14 14h-7m-7 0 7 7v-7m-7 0h7", key: "1a2nng" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yF = d("Frown", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mF = d("Fuel", [
  ["line", { x1: "3", x2: "15", y1: "22", y2: "22", key: "xegly4" }],
  ["line", { x1: "4", x2: "14", y1: "9", y2: "9", key: "xcnuvu" }],
  ["path", { d: "M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18", key: "16j0yd" }],
  [
    "path",
    {
      d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5",
      key: "7cu91f"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gF = d("Fullscreen", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["rect", { width: "10", height: "8", x: "7", y: "8", rx: "1", key: "vys8me" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vF = d("GalleryHorizontalEnd", [
  ["path", { d: "M2 7v10", key: "a2pl2d" }],
  ["path", { d: "M6 5v14", key: "1kq3d7" }],
  ["rect", { width: "12", height: "18", x: "10", y: "3", rx: "2", key: "13i7bc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kF = d("GalleryHorizontal", [
  ["path", { d: "M2 3v18", key: "pzttux" }],
  ["rect", { width: "12", height: "18", x: "6", y: "3", rx: "2", key: "btr8bg" }],
  ["path", { d: "M22 3v18", key: "6jf3v" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bF = d("GalleryThumbnails", [
  ["rect", { width: "18", height: "14", x: "3", y: "3", rx: "2", key: "74y24f" }],
  ["path", { d: "M4 21h1", key: "16zlid" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M19 21h1", key: "edywat" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xF = d("GalleryVerticalEnd", [
  ["path", { d: "M7 2h10", key: "nczekb" }],
  ["path", { d: "M5 6h14", key: "u2x4p" }],
  ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MF = d("GalleryVertical", [
  ["path", { d: "M3 2h18", key: "15qxfx" }],
  ["rect", { width: "18", height: "12", x: "3", y: "6", rx: "2", key: "1439r6" }],
  ["path", { d: "M3 22h18", key: "8prr45" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wF = d("Gamepad2", [
  ["line", { x1: "6", x2: "10", y1: "11", y2: "11", key: "1gktln" }],
  ["line", { x1: "8", x2: "8", y1: "9", y2: "13", key: "qnk9ow" }],
  ["line", { x1: "15", x2: "15.01", y1: "12", y2: "12", key: "krot7o" }],
  ["line", { x1: "18", x2: "18.01", y1: "10", y2: "10", key: "1lcuu1" }],
  [
    "path",
    {
      d: "M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z",
      key: "mfqc10"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CF = d("Gamepad", [
  ["line", { x1: "6", x2: "10", y1: "12", y2: "12", key: "161bw2" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "15", x2: "15.01", y1: "13", y2: "13", key: "dqpgro" }],
  ["line", { x1: "18", x2: "18.01", y1: "11", y2: "11", key: "meh2c" }],
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SF = d("GanttChart", [
  ["path", { d: "M8 6h10", key: "9lnwnk" }],
  ["path", { d: "M6 12h9", key: "1g9pqf" }],
  ["path", { d: "M11 18h7", key: "c8dzvl" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AF = d("Gauge", [
  ["path", { d: "m12 14 4-4", key: "9kzdfg" }],
  ["path", { d: "M3.34 19a10 10 0 1 1 17.32 0", key: "19p75a" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OF = d("Gavel", [
  ["path", { d: "m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8", key: "15492f" }],
  ["path", { d: "m16 16 6-6", key: "vzrcl6" }],
  ["path", { d: "m8 8 6-6", key: "18bi4p" }],
  ["path", { d: "m9 7 8 8", key: "5jnvq1" }],
  ["path", { d: "m21 11-8-8", key: "z4y7zo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EF = d("Gem", [
  ["path", { d: "M6 3h12l4 6-10 13L2 9Z", key: "1pcd5k" }],
  ["path", { d: "M11 3 8 9l4 13 4-13-3-6", key: "1fcu3u" }],
  ["path", { d: "M2 9h20", key: "16fsjt" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IF = d("Ghost", [
  ["path", { d: "M9 10h.01", key: "qbtxuw" }],
  ["path", { d: "M15 10h.01", key: "1qmjsl" }],
  [
    "path",
    {
      d: "M12 2a8 8 0 0 0-8 8v12l3-3 2.5 2.5L12 19l2.5 2.5L17 19l3 3V10a8 8 0 0 0-8-8z",
      key: "uwwb07"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DF = d("Gift", [
  ["rect", { x: "3", y: "8", width: "18", height: "4", rx: "1", key: "bkv52" }],
  ["path", { d: "M12 8v13", key: "1c76mn" }],
  ["path", { d: "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7", key: "6wjy6b" }],
  [
    "path",
    {
      d: "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5",
      key: "1ihvrl"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TF = d("GitBranchPlus", [
  ["path", { d: "M6 3v12", key: "qpgusn" }],
  ["path", { d: "M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "1d02ji" }],
  ["path", { d: "M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "chk6ph" }],
  ["path", { d: "M15 6a9 9 0 0 0-9 9", key: "or332x" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NF = d("GitBranch", [
  ["line", { x1: "6", x2: "6", y1: "3", y2: "15", key: "17qcm7" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M18 9a9 9 0 0 1-9 9", key: "n2h4wq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PF = d("GitCommitHorizontal", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["line", { x1: "3", x2: "9", y1: "12", y2: "12", key: "1dyftd" }],
  ["line", { x1: "15", x2: "21", y1: "12", y2: "12", key: "oup4p8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LF = d("GitCommitVertical", [
  ["path", { d: "M12 3v6", key: "1holv5" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "M12 15v6", key: "a9ows0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RF = d("GitCompareArrows", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
  ["path", { d: "M12 18H7a2 2 0 0 1-2-2V9", key: "16sdep" }],
  ["path", { d: "m9 15 3 3-3 3", key: "1m3kbl" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VF = d("GitCompare", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["path", { d: "M11 18H8a2 2 0 0 1-2-2V9", key: "19pyzm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zF = d("GitFork", [
  ["circle", { cx: "12", cy: "18", r: "3", key: "1mpf1b" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["path", { d: "M18 9v2c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9", key: "1uq4wg" }],
  ["path", { d: "M12 12v3", key: "158kv8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BF = d("GitGraph", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v6", key: "158jrl" }],
  ["circle", { cx: "5", cy: "18", r: "3", key: "104gr9" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
  ["path", { d: "M16 15.7A9 9 0 0 0 19 9", key: "1e3vqb" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HF = d("GitMerge", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 21V9a9 9 0 0 0 9 9", key: "7kw0sc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $F = d("GitPullRequestArrow", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v12", key: "ih889a" }],
  ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jF = d("GitPullRequestClosed", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 9v12", key: "1sc30k" }],
  ["path", { d: "m21 3-6 6", key: "16nqsk" }],
  ["path", { d: "m21 9-6-6", key: "9j17rh" }],
  ["path", { d: "M18 11.5V15", key: "65xf6f" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FF = d("GitPullRequestCreateArrow", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v12", key: "ih889a" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v3", key: "1rbwk6" }],
  ["path", { d: "M19 15v6", key: "10aioa" }],
  ["path", { d: "M22 18h-6", key: "1d5gi5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WF = d("GitPullRequestCreate", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 9v12", key: "1sc30k" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v3", key: "1jb6z3" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qF = d("GitPullRequestDraft", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M18 6V5", key: "1oao2s" }],
  ["path", { d: "M18 11v-1", key: "11c8tz" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _F = d("GitPullRequest", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GF = d("Github", [
  [
    "path",
    {
      d: "M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4",
      key: "tonef"
    }
  ],
  ["path", { d: "M9 18c-4.51 2-5-2-7-2", key: "9comsn" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZF = d("Gitlab", [
  [
    "path",
    {
      d: "m22 13.29-3.33-10a.42.42 0 0 0-.14-.18.38.38 0 0 0-.22-.11.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18l-2.26 6.67H8.32L6.1 3.26a.42.42 0 0 0-.1-.18.38.38 0 0 0-.26-.08.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18L2 13.29a.74.74 0 0 0 .27.83L12 21l9.69-6.88a.71.71 0 0 0 .31-.83Z",
      key: "148pdi"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XF = d("GlassWater", [
  [
    "path",
    { d: "M15.2 22H8.8a2 2 0 0 1-2-1.79L5 3h14l-1.81 17.21A2 2 0 0 1 15.2 22Z", key: "48rfw3" }
  ],
  ["path", { d: "M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0", key: "mjntcy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UF = d("Glasses", [
  ["circle", { cx: "6", cy: "15", r: "4", key: "vux9w4" }],
  ["circle", { cx: "18", cy: "15", r: "4", key: "18o8ve" }],
  ["path", { d: "M14 15a2 2 0 0 0-2-2 2 2 0 0 0-2 2", key: "1ag4bs" }],
  ["path", { d: "M2.5 13 5 7c.7-1.3 1.4-2 3-2", key: "1hm1gs" }],
  ["path", { d: "M21.5 13 19 7c-.7-1.3-1.5-2-3-2", key: "1r31ai" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YF = d("GlobeLock", [
  [
    "path",
    {
      d: "M15.686 15A14.5 14.5 0 0 1 12 22a14.5 14.5 0 0 1 0-20 10 10 0 1 0 9.542 13",
      key: "qkt0x6"
    }
  ],
  ["path", { d: "M2 12h8.5", key: "ovaggd" }],
  ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
  ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JF = d("Globe", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KF = d("Goal", [
  ["path", { d: "M12 13V2l8 4-8 4", key: "5wlwwj" }],
  ["path", { d: "M20.561 10.222a9 9 0 1 1-12.55-5.29", key: "1c0wjv" }],
  ["path", { d: "M8.002 9.997a5 5 0 1 0 8.9 2.02", key: "gb1g7m" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QF = d("Grab", [
  ["path", { d: "M18 11.5V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4", key: "edstyy" }],
  ["path", { d: "M14 10V8a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "19wdwo" }],
  ["path", { d: "M10 9.9V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5", key: "1lugqo" }],
  ["path", { d: "M6 14a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1hbeus" }],
  [
    "path",
    { d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0", key: "1etffm" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eW = d("GraduationCap", [
  [
    "path",
    {
      d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z",
      key: "j76jl0"
    }
  ],
  ["path", { d: "M22 10v6", key: "1lu8f3" }],
  ["path", { d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5", key: "1r8lef" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tW = d("Grape", [
  ["path", { d: "M22 5V2l-5.89 5.89", key: "1eenpo" }],
  ["circle", { cx: "16.6", cy: "15.89", r: "3", key: "xjtalx" }],
  ["circle", { cx: "8.11", cy: "7.4", r: "3", key: "u2fv6i" }],
  ["circle", { cx: "12.35", cy: "11.65", r: "3", key: "i6i8g7" }],
  ["circle", { cx: "13.91", cy: "5.85", r: "3", key: "6ye0dv" }],
  ["circle", { cx: "18.15", cy: "10.09", r: "3", key: "snx9no" }],
  ["circle", { cx: "6.56", cy: "13.2", r: "3", key: "17x4xg" }],
  ["circle", { cx: "10.8", cy: "17.44", r: "3", key: "1hogw9" }],
  ["circle", { cx: "5", cy: "19", r: "3", key: "1sn6vo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nW = d("Grid2x2Check", [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rW = d("Grid2x2X", [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "m16 16 5 5", key: "8tpb07" }],
  ["path", { d: "m16 21 5-5", key: "193jll" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aW = d("Grid2x2", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M12 3v18", key: "108xh3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iW = d("Grid3x3", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oW = d("GripHorizontal", [
  ["circle", { cx: "12", cy: "9", r: "1", key: "124mty" }],
  ["circle", { cx: "19", cy: "9", r: "1", key: "1ruzo2" }],
  ["circle", { cx: "5", cy: "9", r: "1", key: "1a8b28" }],
  ["circle", { cx: "12", cy: "15", r: "1", key: "1e56xg" }],
  ["circle", { cx: "19", cy: "15", r: "1", key: "1a92ep" }],
  ["circle", { cx: "5", cy: "15", r: "1", key: "5r1jwy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sW = d("GripVertical", [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "9", cy: "5", r: "1", key: "hp0tcf" }],
  ["circle", { cx: "9", cy: "19", r: "1", key: "fkjjf6" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["circle", { cx: "15", cy: "19", r: "1", key: "f4zoj3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cW = d("Grip", [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "19", cy: "5", r: "1", key: "w8mnmm" }],
  ["circle", { cx: "5", cy: "5", r: "1", key: "lttvr7" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }],
  ["circle", { cx: "19", cy: "19", r: "1", key: "shf9b7" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lW = d("Group", [
  ["path", { d: "M3 7V5c0-1.1.9-2 2-2h2", key: "adw53z" }],
  ["path", { d: "M17 3h2c1.1 0 2 .9 2 2v2", key: "an4l38" }],
  ["path", { d: "M21 17v2c0 1.1-.9 2-2 2h-2", key: "144t0e" }],
  ["path", { d: "M7 21H5c-1.1 0-2-.9-2-2v-2", key: "rtnfgi" }],
  ["rect", { width: "7", height: "5", x: "7", y: "7", rx: "1", key: "1eyiv7" }],
  ["rect", { width: "7", height: "5", x: "10", y: "12", rx: "1", key: "1qlmkx" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dW = d("Guitar", [
  ["path", { d: "m11.9 12.1 4.514-4.514", key: "109xqo" }],
  [
    "path",
    {
      d: "M20.1 2.3a1 1 0 0 0-1.4 0l-1.114 1.114A2 2 0 0 0 17 4.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 17.828 7h1.344a2 2 0 0 0 1.414-.586L21.7 5.3a1 1 0 0 0 0-1.4z",
      key: "txyc8t"
    }
  ],
  ["path", { d: "m6 16 2 2", key: "16qmzd" }],
  [
    "path",
    {
      d: "M8.2 9.9C8.7 8.8 9.8 8 11 8c2.8 0 5 2.2 5 5 0 1.2-.8 2.3-1.9 2.8l-.9.4A2 2 0 0 0 12 18a4 4 0 0 1-4 4c-3.3 0-6-2.7-6-6a4 4 0 0 1 4-4 2 2 0 0 0 1.8-1.2z",
      key: "1u8q3z"
    }
  ],
  ["circle", { cx: "11.5", cy: "12.5", r: ".5", fill: "currentColor", key: "16onso" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uW = d("Ham", [
  ["path", { d: "M13.144 21.144A7.274 10.445 45 1 0 2.856 10.856", key: "1k1t7q" }],
  [
    "path",
    {
      d: "M13.144 21.144A7.274 4.365 45 0 0 2.856 10.856a7.274 4.365 45 0 0 10.288 10.288",
      key: "153t1g"
    }
  ],
  [
    "path",
    {
      d: "M16.565 10.435 18.6 8.4a2.501 2.501 0 1 0 1.65-4.65 2.5 2.5 0 1 0-4.66 1.66l-2.024 2.025",
      key: "gzrt0n"
    }
  ],
  ["path", { d: "m8.5 16.5-1-1", key: "otr954" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hW = d("Hammer", [
  ["path", { d: "m15 12-8.373 8.373a1 1 0 1 1-3-3L12 9", key: "eefl8a" }],
  ["path", { d: "m18 15 4-4", key: "16gjal" }],
  [
    "path",
    {
      d: "m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172V7l-2.26-2.26a6 6 0 0 0-4.202-1.756L9 2.96l.92.82A6.18 6.18 0 0 1 12 8.4V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5",
      key: "b7pghm"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pW = d("HandCoins", [
  ["path", { d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17", key: "geh8rc" }],
  [
    "path",
    {
      d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "1fto5m"
    }
  ],
  ["path", { d: "m2 16 6 6", key: "1pfhp9" }],
  ["circle", { cx: "16", cy: "9", r: "2.9", key: "1n0dlu" }],
  ["circle", { cx: "6", cy: "5", r: "3", key: "151irh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fW = d("HandHeart", [
  ["path", { d: "M11 14h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16", key: "1ifwr1" }],
  [
    "path",
    {
      d: "m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "17abbs"
    }
  ],
  ["path", { d: "m2 15 6 6", key: "10dquu" }],
  [
    "path",
    {
      d: "M19.5 8.5c.7-.7 1.5-1.6 1.5-2.7A2.73 2.73 0 0 0 16 4a2.78 2.78 0 0 0-5 1.8c0 1.2.8 2 1.5 2.8L16 12Z",
      key: "1h3036"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yW = d("HandHelping", [
  ["path", { d: "M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14", key: "1j4xps" }],
  [
    "path",
    {
      d: "m7 18 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "uospg8"
    }
  ],
  ["path", { d: "m2 13 6 6", key: "16e5sb" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mW = d("HandMetal", [
  ["path", { d: "M18 12.5V10a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4", key: "wc6myp" }],
  ["path", { d: "M14 11V9a2 2 0 1 0-4 0v2", key: "94qvcw" }],
  ["path", { d: "M10 10.5V5a2 2 0 1 0-4 0v9", key: "m1ah89" }],
  [
    "path",
    {
      d: "m7 15-1.76-1.76a2 2 0 0 0-2.83 2.82l3.6 3.6C7.5 21.14 9.2 22 12 22h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v5",
      key: "t1skq1"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gW = d("HandPlatter", [
  ["path", { d: "M12 3V2", key: "ar7q03" }],
  ["path", { d: "M5 10a7.1 7.1 0 0 1 14 0", key: "1t9y3n" }],
  ["path", { d: "M4 10h16", key: "img6z1" }],
  ["path", { d: "M2 14h12a2 2 0 1 1 0 4h-2", key: "loyjft" }],
  [
    "path",
    {
      d: "m15.4 17.4 3.2-2.8a2 2 0 0 1 2.8 2.9l-3.6 3.3c-.7.8-1.7 1.2-2.8 1.2h-4c-1.1 0-2.1-.4-2.8-1.2L5 18",
      key: "1rixiy"
    }
  ],
  ["path", { d: "M5 14v7H2", key: "3mujks" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vW = d("Hand", [
  ["path", { d: "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1fvzgz" }],
  ["path", { d: "M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "1kc0my" }],
  ["path", { d: "M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8", key: "10h0bg" }],
  [
    "path",
    {
      d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "1s1gnw"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kW = d("Handshake", [
  ["path", { d: "m11 17 2 2a1 1 0 1 0 3-3", key: "efffak" }],
  [
    "path",
    {
      d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4",
      key: "9pr0kb"
    }
  ],
  ["path", { d: "m21 3 1 11h-2", key: "1tisrp" }],
  ["path", { d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3", key: "1uvwmv" }],
  ["path", { d: "M3 4h8", key: "1ep09j" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bW = d("HardDriveDownload", [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xW = d("HardDriveUpload", [
  ["path", { d: "m16 6-4-4-4 4", key: "13yo43" }],
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MW = d("HardDrive", [
  ["line", { x1: "22", x2: "2", y1: "12", y2: "12", key: "1y58io" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ],
  ["line", { x1: "6", x2: "6.01", y1: "16", y2: "16", key: "sgf278" }],
  ["line", { x1: "10", x2: "10.01", y1: "16", y2: "16", key: "1l4acy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wW = d("HardHat", [
  [
    "path",
    {
      d: "M2 18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v2z",
      key: "1dej2m"
    }
  ],
  ["path", { d: "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5", key: "1p9q5i" }],
  ["path", { d: "M4 15v-3a6 6 0 0 1 6-6", key: "9ciidu" }],
  ["path", { d: "M14 6a6 6 0 0 1 6 6v3", key: "1hnv84" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CW = d("Hash", [
  ["line", { x1: "4", x2: "20", y1: "9", y2: "9", key: "4lhtct" }],
  ["line", { x1: "4", x2: "20", y1: "15", y2: "15", key: "vyu0kd" }],
  ["line", { x1: "10", x2: "8", y1: "3", y2: "21", key: "1ggp8o" }],
  ["line", { x1: "16", x2: "14", y1: "3", y2: "21", key: "weycgp" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SW = d("Haze", [
  ["path", { d: "m5.2 6.2 1.4 1.4", key: "17imol" }],
  ["path", { d: "M2 13h2", key: "13gyu8" }],
  ["path", { d: "M20 13h2", key: "16rner" }],
  ["path", { d: "m17.4 7.6 1.4-1.4", key: "t4xlah" }],
  ["path", { d: "M22 17H2", key: "1gtaj3" }],
  ["path", { d: "M22 21H2", key: "1gy6en" }],
  ["path", { d: "M16 13a4 4 0 0 0-8 0", key: "1dyczq" }],
  ["path", { d: "M12 5V2.5", key: "1vytko" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AW = d("HdmiPort", [
  [
    "path",
    {
      d: "M22 9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1l2 2h12l2-2h1a1 1 0 0 0 1-1Z",
      key: "2128wb"
    }
  ],
  ["path", { d: "M7.5 12h9", key: "1t0ckc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OW = d("Heading1", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "m17 12 3-2v8", key: "1hhhft" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EW = d("Heading2", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1", key: "9jr5yi" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IW = d("Heading3", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2", key: "68ncm8" }],
  ["path", { d: "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2", key: "1ejuhz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DW = d("Heading4", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 10v4h4", key: "13sv97" }],
  ["path", { d: "M21 10v8", key: "1kdml4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TW = d("Heading5", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 13v-3h4", key: "1nvgqp" }],
  [
    "path",
    { d: "M17 17.7c.4.2.8.3 1.3.3 1.5 0 2.7-1.1 2.7-2.5S19.8 13 18.3 13H17", key: "2nebdn" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NW = d("Heading6", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["circle", { cx: "19", cy: "16", r: "2", key: "15mx69" }],
  ["path", { d: "M20 10c-2 2-3 3.5-3 6", key: "f35dl0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PW = d("Heading", [
  ["path", { d: "M6 12h12", key: "8npq4p" }],
  ["path", { d: "M6 20V4", key: "1w1bmo" }],
  ["path", { d: "M18 20V4", key: "o2hl4u" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LW = d("Headphones", [
  [
    "path",
    {
      d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3",
      key: "1xhozi"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RW = d("Headset", [
  [
    "path",
    {
      d: "M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z",
      key: "12oyoe"
    }
  ],
  ["path", { d: "M21 16v2a4 4 0 0 1-4 4h-5", key: "1x7m43" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VW = d("HeartCrack", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "m12 13-1-1 2-2-3-3 2-2", key: "xjdxli" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zW = d("HeartHandshake", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  [
    "path",
    {
      d: "M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66",
      key: "4oyue0"
    }
  ],
  ["path", { d: "m18 15-2-2", key: "60u0ii" }],
  ["path", { d: "m15 18-2-2", key: "6p76be" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BW = d("HeartOff", [
  ["line", { x1: "2", y1: "2", x2: "22", y2: "22", key: "1w4vcy" }],
  [
    "path",
    { d: "M16.5 16.5 12 21l-7-7c-1.5-1.45-3-3.2-3-5.5a5.5 5.5 0 0 1 2.14-4.35", key: "3mpagl" }
  ],
  [
    "path",
    {
      d: "M8.76 3.1c1.15.22 2.13.78 3.24 1.9 1.5-1.5 2.74-2 4.5-2A5.5 5.5 0 0 1 22 8.5c0 2.12-1.3 3.78-2.67 5.17",
      key: "1gh3v3"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HW = d("HeartPulse", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27", key: "1uw2ng" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $W = d("Heart", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jW = d("Heater", [
  ["path", { d: "M11 8c2-3-2-3 0-6", key: "1ldv5m" }],
  ["path", { d: "M15.5 8c2-3-2-3 0-6", key: "1otqoz" }],
  ["path", { d: "M6 10h.01", key: "1lbq93" }],
  ["path", { d: "M6 14h.01", key: "zudwn7" }],
  ["path", { d: "M10 16v-4", key: "1c25yv" }],
  ["path", { d: "M14 16v-4", key: "1dkbt8" }],
  ["path", { d: "M18 16v-4", key: "1yg9me" }],
  [
    "path",
    { d: "M20 6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3", key: "1ubg90" }
  ],
  ["path", { d: "M5 20v2", key: "1abpe8" }],
  ["path", { d: "M19 20v2", key: "kqn6ft" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FW = d("Hexagon", [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WW = d("Highlighter", [
  ["path", { d: "m9 11-6 6v3h9l3-3", key: "1a3l36" }],
  ["path", { d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4", key: "14a9rk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qW = d("History", [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _W = d("Home", [
  ["path", { d: "m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z", key: "y5dka4" }],
  ["polyline", { points: "9 22 9 12 15 12 15 22", key: "e2us08" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GW = d("HopOff", [
  ["path", { d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.28.01.53-.09.7-.27", key: "qyzcap" }],
  [
    "path",
    {
      d: "M11.14 20.57c.52.24 2.44 1.12 4.08 1.37.46.06.86-.25.9-.71.12-1.52-.3-3.43-.5-4.28",
      key: "y078lb"
    }
  ],
  ["path", { d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .7-.26", key: "1utre3" }],
  [
    "path",
    {
      d: "M17.99 5.52a20.83 20.83 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-1.17.1-2.5.02-3.9-.25",
      key: "17o9hm"
    }
  ],
  ["path", { d: "M20.57 11.14c.24.52 1.12 2.44 1.37 4.08.04.3-.08.59-.31.75", key: "1d1n4p" }],
  [
    "path",
    {
      d: "M4.93 4.93a10 10 0 0 0-.67 13.4c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.85.85 0 0 0 .48-.24",
      key: "9uv3tt"
    }
  ],
  [
    "path",
    {
      d: "M5.52 17.99c1.05.95 2.91 2.42 4.5 3.15a.8.8 0 0 0 1.13-.68c.2-2.34-.33-5.3-1.57-8.28",
      key: "1292wz"
    }
  ],
  [
    "path",
    {
      d: "M8.35 2.68a10 10 0 0 1 9.98 1.58c.43.35.4.96-.12 1.17-1.5.6-4.3.98-6.07 1.05",
      key: "7ozu9p"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZW = d("Hop", [
  [
    "path",
    {
      d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.55.03 1-.42.97-.97-.06-1.27-.26-3.5-.85-5.18",
      key: "18lxf1"
    }
  ],
  [
    "path",
    {
      d: "M11.5 6.5c1.64 0 5-.38 6.71-1.07.52-.2.55-.82.12-1.17A10 10 0 0 0 4.26 18.33c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.88.88 0 0 0 .73-.74c.3-2.14-.15-3.5-.61-4.88",
      key: "vtfxrw"
    }
  ],
  [
    "path",
    {
      d: "M15.62 16.95c.2.85.62 2.76.5 4.28a.77.77 0 0 1-.9.7 16.64 16.64 0 0 1-4.08-1.36",
      key: "13hl71"
    }
  ],
  [
    "path",
    {
      d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .96-.96 17.68 17.68 0 0 0-.9-4.87",
      key: "1sl8oj"
    }
  ],
  [
    "path",
    {
      d: "M16.94 15.62c.86.2 2.77.62 4.29.5a.77.77 0 0 0 .7-.9 16.64 16.64 0 0 0-1.36-4.08",
      key: "19c6kt"
    }
  ],
  [
    "path",
    {
      d: "M17.99 5.52a20.82 20.82 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-2.33.2-5.3-.32-8.27-1.57",
      key: "85ghs3"
    }
  ],
  ["path", { d: "M4.93 4.93 3 3a.7.7 0 0 1 0-1", key: "x087yj" }],
  [
    "path",
    {
      d: "M9.58 12.18c1.24 2.98 1.77 5.95 1.57 8.28a.8.8 0 0 1-1.13.68 20.82 20.82 0 0 1-4.5-3.15",
      key: "11xdqo"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XW = d("Hospital", [
  ["path", { d: "M12 6v4", key: "16clxf" }],
  ["path", { d: "M14 14h-4", key: "esezmu" }],
  ["path", { d: "M14 18h-4", key: "16mqa2" }],
  ["path", { d: "M14 8h-4", key: "z8ypaz" }],
  [
    "path",
    {
      d: "M18 12h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2",
      key: "b1k337"
    }
  ],
  ["path", { d: "M18 22V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v18", key: "16g51d" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UW = d("Hotel", [
  ["path", { d: "M10 22v-6.57", key: "1wmca3" }],
  ["path", { d: "M12 11h.01", key: "z322tv" }],
  ["path", { d: "M12 7h.01", key: "1ivr5q" }],
  ["path", { d: "M14 15.43V22", key: "1q2vjd" }],
  ["path", { d: "M15 16a5 5 0 0 0-6 0", key: "o9wqvi" }],
  ["path", { d: "M16 11h.01", key: "xkw8gn" }],
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 7h.01", key: "1vti4s" }],
  ["rect", { x: "4", y: "2", width: "16", height: "20", rx: "2", key: "1uxh74" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YW = d("Hourglass", [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  ["path", { d: "M5 2h14", key: "pdyrp9" }],
  [
    "path",
    {
      d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22",
      key: "1d314k"
    }
  ],
  [
    "path",
    { d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2", key: "1vvvr6" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JW = d("IceCreamBowl", [
  [
    "path",
    {
      d: "M12 17c5 0 8-2.69 8-6H4c0 3.31 3 6 8 6m-4 4h8m-4-3v3M5.14 11a3.5 3.5 0 1 1 6.71 0",
      key: "1uxfcu"
    }
  ],
  ["path", { d: "M12.14 11a3.5 3.5 0 1 1 6.71 0", key: "4k3m1s" }],
  ["path", { d: "M15.5 6.5a3.5 3.5 0 1 0-7 0", key: "zmuahr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KW = d("IceCreamCone", [
  ["path", { d: "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11", key: "1v6356" }],
  ["path", { d: "M17 7A5 5 0 0 0 7 7", key: "151p3v" }],
  ["path", { d: "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4", key: "1sdaij" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QW = d("ImageDown", [
  [
    "path",
    {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
      key: "9csbqa"
    }
  ],
  ["path", { d: "m14 19 3 3v-5.5", key: "9ldu5r" }],
  ["path", { d: "m17 22 3-3", key: "1nkfve" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eq = d("ImageMinus", [
  ["path", { d: "M21 9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7", key: "m87ecr" }],
  ["line", { x1: "16", x2: "22", y1: "5", y2: "5", key: "ez7e4s" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tq = d("ImageOff", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83", key: "1bzlo9" }],
  ["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21", key: "1q0aeu" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "15", key: "5mozeu" }],
  [
    "path",
    {
      d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
      key: "mmje98"
    }
  ],
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nq = d("ImagePlay", [
  ["path", { d: "m11 16-5 5", key: "j5f7ct" }],
  ["path", { d: "M11 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6.5", key: "7s81lt" }],
  [
    "path",
    {
      d: "M15.765 22a.5.5 0 0 1-.765-.424V13.38a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z",
      key: "1omb6s"
    }
  ],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rq = d("ImagePlus", [
  ["path", { d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7", key: "31hg93" }],
  ["line", { x1: "16", x2: "22", y1: "5", y2: "5", key: "ez7e4s" }],
  ["line", { x1: "19", x2: "19", y1: "2", y2: "8", key: "1gkr8c" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aq = d("ImageUp", [
  [
    "path",
    {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
      key: "9csbqa"
    }
  ],
  ["path", { d: "m14 19.5 3-3 3 3", key: "9vmjn0" }],
  ["path", { d: "M17 22v-5.5", key: "1aa6fl" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iq = d("Image", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oq = d("Images", [
  ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }],
  ["path", { d: "m22 13-1.296-1.296a2.41 2.41 0 0 0-3.408 0L11 18", key: "nf6bnh" }],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["rect", { width: "16", height: "16", x: "6", y: "2", rx: "2", key: "12espp" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sq = d("Import", [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m8 11 4 4 4-4", key: "1dohi6" }],
  [
    "path",
    {
      d: "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4",
      key: "1ywtjm"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cq = d("Inbox", [
  ["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12", key: "o97t9d" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lq = d("IndentDecrease", [
  ["polyline", { points: "7 8 3 12 7 16", key: "2j60jr" }],
  ["line", { x1: "21", x2: "11", y1: "12", y2: "12", key: "1fxxak" }],
  ["line", { x1: "21", x2: "11", y1: "6", y2: "6", key: "asgu94" }],
  ["line", { x1: "21", x2: "11", y1: "18", y2: "18", key: "13dsj7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dq = d("IndentIncrease", [
  ["polyline", { points: "3 8 7 12 3 16", key: "f3rxhf" }],
  ["line", { x1: "21", x2: "11", y1: "12", y2: "12", key: "1fxxak" }],
  ["line", { x1: "21", x2: "11", y1: "6", y2: "6", key: "asgu94" }],
  ["line", { x1: "21", x2: "11", y1: "18", y2: "18", key: "13dsj7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uq = d("IndianRupee", [
  ["path", { d: "M6 3h12", key: "ggurg9" }],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  ["path", { d: "m6 13 8.5 8", key: "u1kupk" }],
  ["path", { d: "M6 13h3", key: "wdp6ag" }],
  ["path", { d: "M9 13c6.667 0 6.667-10 0-10", key: "1nkvk2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hq = d("Infinity", [
  [
    "path",
    {
      d: "M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z",
      key: "1z0uae"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pq = d("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fq = d("InspectionPanel", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7h.01", key: "7u93v4" }],
  ["path", { d: "M17 7h.01", key: "14a9sn" }],
  ["path", { d: "M7 17h.01", key: "19xn7k" }],
  ["path", { d: "M17 17h.01", key: "1sd3ek" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yq = d("Instagram", [
  ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "5", ry: "5", key: "2e1cvw" }],
  ["path", { d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z", key: "9exkf1" }],
  ["line", { x1: "17.5", x2: "17.51", y1: "6.5", y2: "6.5", key: "r4j83e" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mq = d("Italic", [
  ["line", { x1: "19", x2: "10", y1: "4", y2: "4", key: "15jd3p" }],
  ["line", { x1: "14", x2: "5", y1: "20", y2: "20", key: "bu0au3" }],
  ["line", { x1: "15", x2: "9", y1: "4", y2: "20", key: "uljnxc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gq = d("IterationCcw", [
  ["path", { d: "M20 10c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8h8", key: "4znkd0" }],
  ["polyline", { points: "16 14 20 18 16 22", key: "11njsm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vq = d("IterationCw", [
  ["path", { d: "M4 10c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8H4", key: "tuf4su" }],
  ["polyline", { points: "8 22 4 18 8 14", key: "evkj9s" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kq = d("JapaneseYen", [
  ["path", { d: "M12 9.5V21m0-11.5L6 3m6 6.5L18 3", key: "2ej80x" }],
  ["path", { d: "M6 15h12", key: "1hwgt5" }],
  ["path", { d: "M6 11h12", key: "wf4gp6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bq = d("Joystick", [
  [
    "path",
    {
      d: "M21 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2Z",
      key: "jg2n2t"
    }
  ],
  ["path", { d: "M6 15v-2", key: "gd6mvg" }],
  ["path", { d: "M12 15V9", key: "8c7uyn" }],
  ["circle", { cx: "12", cy: "6", r: "3", key: "1gm2ql" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xq = d("Kanban", [
  ["path", { d: "M6 5v11", key: "mdvv1e" }],
  ["path", { d: "M12 5v6", key: "14ar3b" }],
  ["path", { d: "M18 5v14", key: "7ji314" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mq = d("KeyRound", [
  ["path", { d: "M2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4a6.5 6.5 0 1 0-4-4Z", key: "167ctg" }],
  ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wq = d("KeySquare", [
  [
    "path",
    {
      d: "M12.4 2.7c.9-.9 2.5-.9 3.4 0l5.5 5.5c.9.9.9 2.5 0 3.4l-3.7 3.7c-.9.9-2.5.9-3.4 0L8.7 9.8c-.9-.9-.9-2.5 0-3.4Z",
      key: "9li5bk"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  ["path", { d: "M9.4 10.6 2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4", key: "1ym3zm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cq = d("Key", [
  ["path", { d: "m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4", key: "g0fldk" }],
  ["path", { d: "m21 2-9.6 9.6", key: "1j0ho8" }],
  ["circle", { cx: "7.5", cy: "15.5", r: "5.5", key: "yqb3hr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sq = d("KeyboardMusic", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 8h4", key: "utf9t1" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M6 12v4", key: "dy92yo" }],
  ["path", { d: "M10 12v4", key: "1fxnav" }],
  ["path", { d: "M14 12v4", key: "1hft58" }],
  ["path", { d: "M18 12v4", key: "tjjnbz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aq = d("KeyboardOff", [
  ["path", { d: "M 20 4 A2 2 0 0 1 22 6", key: "1g1fkt" }],
  ["path", { d: "M 22 6 L 22 16.41", key: "1qjg3w" }],
  ["path", { d: "M 7 16 L 16 16", key: "n0yqwb" }],
  ["path", { d: "M 9.69 4 L 20 4", key: "kbpcgx" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2", key: "s23sx2" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oq = d("Keyboard", [
  ["path", { d: "M10 8h.01", key: "1r9ogq" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M7 16h10", key: "wp8him" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eq = d("LampCeiling", [
  ["path", { d: "M12 2v5", key: "nd4vlx" }],
  ["path", { d: "M6 7h12l4 9H2l4-9Z", key: "123d64" }],
  ["path", { d: "M9.17 16a3 3 0 1 0 5.66 0", key: "1061mw" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iq = d("LampDesk", [
  ["path", { d: "m14 5-3 3 2 7 8-8-7-2Z", key: "1b0msb" }],
  ["path", { d: "m14 5-3 3-3-3 3-3 3 3Z", key: "1uemms" }],
  ["path", { d: "M9.5 6.5 4 12l3 6", key: "1bx08v" }],
  ["path", { d: "M3 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H3Z", key: "wap775" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dq = d("LampFloor", [
  ["path", { d: "M9 2h6l3 7H6l3-7Z", key: "wcx6mj" }],
  ["path", { d: "M12 9v13", key: "3n1su1" }],
  ["path", { d: "M9 22h6", key: "1rlq3v" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tq = d("LampWallDown", [
  ["path", { d: "M11 13h6l3 7H8l3-7Z", key: "9n3qlo" }],
  ["path", { d: "M14 13V8a2 2 0 0 0-2-2H8", key: "1hu4hb" }],
  ["path", { d: "M4 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4v6Z", key: "s053bc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nq = d("LampWallUp", [
  ["path", { d: "M11 4h6l3 7H8l3-7Z", key: "11x1ee" }],
  ["path", { d: "M14 11v5a2 2 0 0 1-2 2H8", key: "eutp5o" }],
  ["path", { d: "M4 15h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4v-6Z", key: "1iuthr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pq = d("Lamp", [
  ["path", { d: "M8 2h8l4 10H4L8 2Z", key: "9dma5w" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "M8 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H8Z", key: "mwf4oh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lq = d("LandPlot", [
  ["path", { d: "m12 8 6-3-6-3v10", key: "mvpnpy" }],
  [
    "path",
    {
      d: "m8 11.99-5.5 3.14a1 1 0 0 0 0 1.74l8.5 4.86a2 2 0 0 0 2 0l8.5-4.86a1 1 0 0 0 0-1.74L16 12",
      key: "ek95tt"
    }
  ],
  ["path", { d: "m6.49 12.85 11.02 6.3", key: "1kt42w" }],
  ["path", { d: "M17.51 12.85 6.5 19.15", key: "v55bdg" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rq = d("Landmark", [
  ["line", { x1: "3", x2: "21", y1: "22", y2: "22", key: "j8o0r" }],
  ["line", { x1: "6", x2: "6", y1: "18", y2: "11", key: "10tf0k" }],
  ["line", { x1: "10", x2: "10", y1: "18", y2: "11", key: "54lgf6" }],
  ["line", { x1: "14", x2: "14", y1: "18", y2: "11", key: "380y" }],
  ["line", { x1: "18", x2: "18", y1: "18", y2: "11", key: "1kevvc" }],
  ["polygon", { points: "12 2 20 7 4 7", key: "jkujk7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vq = d("Languages", [
  ["path", { d: "m5 8 6 6", key: "1wu5hv" }],
  ["path", { d: "m4 14 6-6 2-3", key: "1k1g8d" }],
  ["path", { d: "M2 5h12", key: "or177f" }],
  ["path", { d: "M7 2h1", key: "1t2jsx" }],
  ["path", { d: "m22 22-5-10-5 10", key: "don7ne" }],
  ["path", { d: "M14 18h6", key: "1m8k6r" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zq = d("LaptopMinimal", [
  ["rect", { width: "18", height: "12", x: "3", y: "4", rx: "2", ry: "2", key: "1qhy41" }],
  ["line", { x1: "2", x2: "22", y1: "20", y2: "20", key: "ni3hll" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bq = d("Laptop", [
  [
    "path",
    {
      d: "M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16",
      key: "tarvll"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hq = d("LassoSelect", [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  ["path", { d: "M7 16.93c.96.43 1.96.74 2.99.91", key: "ybbtv3" }],
  [
    "path",
    {
      d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2",
      key: "gt5e1w"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }],
  [
    "path",
    {
      d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14z",
      key: "72q637"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $q = d("Lasso", [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  [
    "path",
    {
      d: "M3.3 14A6.8 6.8 0 0 1 2 10c0-4.4 4.5-8 10-8s10 3.6 10 8-4.5 8-10 8a12 12 0 0 1-5-1",
      key: "146dds"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jq = d("Laugh", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M18 13a6 6 0 0 1-6 5 6 6 0 0 1-6-5h12Z", key: "b2q4dd" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fq = d("Layers2", [
  [
    "path",
    {
      d: "m16.02 12 5.48 3.13a1 1 0 0 1 0 1.74L13 21.74a2 2 0 0 1-2 0l-8.5-4.87a1 1 0 0 1 0-1.74L7.98 12",
      key: "1cuww1"
    }
  ],
  [
    "path",
    {
      d: "M13 13.74a2 2 0 0 1-2 0L2.5 8.87a1 1 0 0 1 0-1.74L11 2.26a2 2 0 0 1 2 0l8.5 4.87a1 1 0 0 1 0 1.74Z",
      key: "pdlvxu"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wq = d("Layers3", [
  [
    "path",
    {
      d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z",
      key: "8b97xw"
    }
  ],
  [
    "path",
    {
      d: "m6.08 9.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59",
      key: "1e5n1m"
    }
  ],
  [
    "path",
    {
      d: "m6.08 14.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59",
      key: "1iwflc"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qq = d("Layers", [
  [
    "path",
    {
      d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z",
      key: "8b97xw"
    }
  ],
  ["path", { d: "m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65", key: "dd6zsq" }],
  ["path", { d: "m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65", key: "ep9fru" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _q = d("LayoutDashboard", [
  ["rect", { width: "7", height: "9", x: "3", y: "3", rx: "1", key: "10lvy0" }],
  ["rect", { width: "7", height: "5", x: "14", y: "3", rx: "1", key: "16une8" }],
  ["rect", { width: "7", height: "9", x: "14", y: "12", rx: "1", key: "1hutg5" }],
  ["rect", { width: "7", height: "5", x: "3", y: "16", rx: "1", key: "ldoo1y" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gq = d("LayoutGrid", [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zq = d("LayoutList", [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["path", { d: "M14 4h7", key: "3xa0d5" }],
  ["path", { d: "M14 9h7", key: "1icrd9" }],
  ["path", { d: "M14 15h7", key: "1mj8o2" }],
  ["path", { d: "M14 20h7", key: "11slyb" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xq = d("LayoutPanelLeft", [
  ["rect", { width: "7", height: "18", x: "3", y: "3", rx: "1", key: "2obqm" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uq = d("LayoutPanelTop", [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yq = d("LayoutTemplate", [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "9", height: "7", x: "3", y: "14", rx: "1", key: "jqznyg" }],
  ["rect", { width: "5", height: "7", x: "16", y: "14", rx: "1", key: "q5h2i8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jq = d("Leaf", [
  [
    "path",
    {
      d: "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z",
      key: "nnexq3"
    }
  ],
  ["path", { d: "M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12", key: "mt58a7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kq = d("LeafyGreen", [
  [
    "path",
    {
      d: "M2 22c1.25-.987 2.27-1.975 3.9-2.2a5.56 5.56 0 0 1 3.8 1.5 4 4 0 0 0 6.187-2.353 3.5 3.5 0 0 0 3.69-5.116A3.5 3.5 0 0 0 20.95 8 3.5 3.5 0 1 0 16 3.05a3.5 3.5 0 0 0-5.831 1.373 3.5 3.5 0 0 0-5.116 3.69 4 4 0 0 0-2.348 6.155C3.499 15.42 4.409 16.712 4.2 18.1 3.926 19.743 3.014 20.732 2 22",
      key: "1134nt"
    }
  ],
  ["path", { d: "M2 22 17 7", key: "1q7jp2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qq = d("Lectern", [
  [
    "path",
    {
      d: "M16 12h3a2 2 0 0 0 1.902-1.38l1.056-3.333A1 1 0 0 0 21 6H3a1 1 0 0 0-.958 1.287l1.056 3.334A2 2 0 0 0 5 12h3",
      key: "13jjxg"
    }
  ],
  ["path", { d: "M18 6V3a1 1 0 0 0-1-1h-3", key: "1550fe" }],
  ["rect", { width: "8", height: "12", x: "8", y: "10", rx: "1", key: "qmu8b6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e_ = d("LibraryBig", [
  ["rect", { width: "8", height: "18", x: "3", y: "3", rx: "1", key: "oynpb5" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  [
    "path",
    {
      d: "M20.4 18.9c.2.5-.1 1.1-.6 1.3l-1.9.7c-.5.2-1.1-.1-1.3-.6L11.1 5.1c-.2-.5.1-1.1.6-1.3l1.9-.7c.5-.2 1.1.1 1.3.6Z",
      key: "1qboyk"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t_ = d("Library", [
  ["path", { d: "m16 6 4 14", key: "ji33uf" }],
  ["path", { d: "M12 6v14", key: "1n7gus" }],
  ["path", { d: "M8 8v12", key: "1gg7y9" }],
  ["path", { d: "M4 4v16", key: "6qkkli" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n_ = d("LifeBuoy", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.93 4.93 4.24 4.24", key: "1ymg45" }],
  ["path", { d: "m14.83 9.17 4.24-4.24", key: "1cb5xl" }],
  ["path", { d: "m14.83 14.83 4.24 4.24", key: "q42g0n" }],
  ["path", { d: "m9.17 14.83-4.24 4.24", key: "bqpfvv" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r_ = d("Ligature", [
  ["path", { d: "M8 20V8c0-2.2 1.8-4 4-4 1.5 0 2.8.8 3.5 2", key: "1rtphz" }],
  ["path", { d: "M6 12h4", key: "a4o3ry" }],
  ["path", { d: "M14 12h2v8", key: "c1fccl" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 20h4", key: "lzx1xo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a_ = d("LightbulbOff", [
  ["path", { d: "M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5", key: "1fkcox" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5", key: "10m8kw" }],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i_ = d("Lightbulb", [
  [
    "path",
    {
      d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
      key: "1gvzjb"
    }
  ],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o_ = d("LineChart", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["path", { d: "m19 9-5 5-4-4-3 3", key: "2osh9i" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s_ = d("Link2Off", [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7", key: "10o201" }],
  ["path", { d: "M15 7h2a5 5 0 0 1 4 8", key: "1d3206" }],
  ["line", { x1: "8", x2: "12", y1: "12", y2: "12", key: "rvw6j4" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c_ = d("Link2", [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
  ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l_ = d("Link", [
  ["path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71", key: "1cjeqo" }],
  ["path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71", key: "19qd67" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d_ = d("Linkedin", [
  [
    "path",
    {
      d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z",
      key: "c2jq9f"
    }
  ],
  ["rect", { width: "4", height: "12", x: "2", y: "9", key: "mk3on5" }],
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u_ = d("ListChecks", [
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "m3 7 2 2 4-4", key: "1obspn" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h_ = d("ListCollapse", [
  ["path", { d: "m3 10 2.5-2.5L3 5", key: "i6eama" }],
  ["path", { d: "m3 19 2.5-2.5L3 14", key: "w2gmor" }],
  ["path", { d: "M10 6h11", key: "c7qv1k" }],
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "M10 18h11", key: "11hvi2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p_ = d("ListEnd", [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M10 18H3", key: "13769t" }],
  ["path", { d: "M21 6v10a2 2 0 0 1-2 2h-5", key: "ilrcs8" }],
  ["path", { d: "m16 16-2 2 2 2", key: "kkc6pm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f_ = d("ListFilter", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y_ = d("ListMinus", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m_ = d("ListMusic", [
  ["path", { d: "M21 15V6", key: "h1cx4g" }],
  ["path", { d: "M18.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", key: "8saifv" }],
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g_ = d("ListOrdered", [
  ["line", { x1: "10", x2: "21", y1: "6", y2: "6", key: "76qw6h" }],
  ["line", { x1: "10", x2: "21", y1: "12", y2: "12", key: "16nom4" }],
  ["line", { x1: "10", x2: "21", y1: "18", y2: "18", key: "u3jurt" }],
  ["path", { d: "M4 6h1v4", key: "cnovpq" }],
  ["path", { d: "M4 10h2", key: "16xx2s" }],
  ["path", { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1", key: "m9a95d" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v_ = d("ListPlus", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M18 9v6", key: "1twb98" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k_ = d("ListRestart", [
  ["path", { d: "M21 6H3", key: "1jwq7v" }],
  ["path", { d: "M7 12H3", key: "13ou7f" }],
  ["path", { d: "M7 18H3", key: "1sijw9" }],
  [
    "path",
    {
      d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14",
      key: "qth677"
    }
  ],
  ["path", { d: "M11 10v4h4", key: "172dkj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b_ = d("ListStart", [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M10 6H3", key: "lf8lx7" }],
  ["path", { d: "M21 18V8a2 2 0 0 0-2-2h-5", key: "1hghli" }],
  ["path", { d: "m16 8-2-2 2-2", key: "160uvd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x_ = d("ListTodo", [
  ["rect", { x: "3", y: "5", width: "6", height: "6", rx: "1", key: "1defrl" }],
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M_ = d("ListTree", [
  ["path", { d: "M21 12h-8", key: "1bmf0i" }],
  ["path", { d: "M21 6H8", key: "1pqkrb" }],
  ["path", { d: "M21 18h-8", key: "1tm79t" }],
  ["path", { d: "M3 6v4c0 1.1.9 2 2 2h3", key: "1ywdgy" }],
  ["path", { d: "M3 10v6c0 1.1.9 2 2 2h3", key: "2wc746" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w_ = d("ListVideo", [
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }],
  ["path", { d: "m16 12 5 3-5 3v-6Z", key: "zpskkp" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C_ = d("ListX", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "m19 10-4 4", key: "1tz659" }],
  ["path", { d: "m15 10 4 4", key: "1n7nei" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S_ = d("List", [
  ["line", { x1: "8", x2: "21", y1: "6", y2: "6", key: "7ey8pc" }],
  ["line", { x1: "8", x2: "21", y1: "12", y2: "12", key: "rjfblc" }],
  ["line", { x1: "8", x2: "21", y1: "18", y2: "18", key: "c3b1m8" }],
  ["line", { x1: "3", x2: "3.01", y1: "6", y2: "6", key: "1g7gq3" }],
  ["line", { x1: "3", x2: "3.01", y1: "12", y2: "12", key: "1pjlvk" }],
  ["line", { x1: "3", x2: "3.01", y1: "18", y2: "18", key: "28t2mc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A_ = d("LoaderCircle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O_ = d("LoaderPinwheel", [
  ["path", { d: "M2 12c0-2.8 2.2-5 5-5s5 2.2 5 5 2.2 5 5 5 5-2.2 5-5", key: "1cg5zf" }],
  ["path", { d: "M7 20.7a1 1 0 1 1 5-8.7 1 1 0 1 0 5-8.6", key: "1gnrpi" }],
  ["path", { d: "M7 3.3a1 1 0 1 1 5 8.6 1 1 0 1 0 5 8.6", key: "u9yy5q" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E_ = d("Loader", [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I_ = d("LocateFixed", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D_ = d("LocateOff", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  [
    "path",
    {
      d: "M7.11 7.11C5.83 8.39 5 10.1 5 12c0 3.87 3.13 7 7 7 1.9 0 3.61-.83 4.89-2.11",
      key: "1oh7ia"
    }
  ],
  [
    "path",
    {
      d: "M18.71 13.96c.19-.63.29-1.29.29-1.96 0-3.87-3.13-7-7-7-.67 0-1.33.1-1.96.29",
      key: "3qdecy"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T_ = d("Locate", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N_ = d("LockKeyholeOpen", [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }],
  ["path", { d: "M7 10V7a5 5 0 0 1 9.33-2.5", key: "car5b7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P_ = d("LockKeyhole", [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  ["rect", { x: "3", y: "10", width: "18", height: "12", rx: "2", key: "6s8ecr" }],
  ["path", { d: "M7 10V7a5 5 0 0 1 10 0v3", key: "1pqi11" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L_ = d("LockOpen", [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 9.9-1", key: "1mm8w8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R_ = d("Lock", [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V_ = d("LogIn", [
  ["path", { d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4", key: "u53s6r" }],
  ["polyline", { points: "10 17 15 12 10 7", key: "1ail0h" }],
  ["line", { x1: "15", x2: "3", y1: "12", y2: "12", key: "v6grx8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z_ = d("LogOut", [
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }],
  ["polyline", { points: "16 17 21 12 16 7", key: "1gabdz" }],
  ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B_ = d("Lollipop", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ["path", { d: "M11 11a2 2 0 0 0 4 0 4 4 0 0 0-8 0 6 6 0 0 0 12 0", key: "107gwy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H_ = d("Luggage", [
  [
    "path",
    { d: "M6 20a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2", key: "1m57jg" }
  ],
  ["path", { d: "M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14", key: "1l99gc" }],
  ["path", { d: "M10 20h4", key: "ni2waw" }],
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  ["circle", { cx: "8", cy: "20", r: "2", key: "ckkr5m" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $_ = d("Magnet", [
  [
    "path",
    {
      d: "m6 15-4-4 6.75-6.77a7.79 7.79 0 0 1 11 11L13 22l-4-4 6.39-6.36a2.14 2.14 0 0 0-3-3L6 15",
      key: "1i3lhw"
    }
  ],
  ["path", { d: "m5 8 4 4", key: "j6kj7e" }],
  ["path", { d: "m12 15 4 4", key: "lnac28" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j_ = d("MailCheck", [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "12jkf8" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F_ = d("MailMinus", [
  ["path", { d: "M22 15V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "fuxbkv" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W_ = d("MailOpen", [
  [
    "path",
    {
      d: "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z",
      key: "1jhwl8"
    }
  ],
  ["path", { d: "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10", key: "1qfld7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q_ = d("MailPlus", [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "12jkf8" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __ = d("MailQuestion", [
  ["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5", key: "e61zoh" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  [
    "path",
    {
      d: "M18 15.28c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2",
      key: "7z9rxb"
    }
  ],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G_ = d("MailSearch", [
  ["path", { d: "M22 12.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7.5", key: "w80f2v" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "8lzu5m" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.5-1.5", key: "1x83k4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z_ = d("MailWarning", [
  ["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5", key: "e61zoh" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M20 14v4", key: "1hm744" }],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X_ = d("MailX", [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9", key: "1j9vog" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m17 17 4 4", key: "1b3523" }],
  ["path", { d: "m21 17-4 4", key: "uinynz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U_ = d("Mail", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y_ = d("Mailbox", [
  [
    "path",
    {
      d: "M22 17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5C2 7 4 5 6.5 5H18c2.2 0 4 1.8 4 4v8Z",
      key: "1lbycx"
    }
  ],
  ["polyline", { points: "15,9 18,9 18,11", key: "1pm9c0" }],
  ["path", { d: "M6.5 5C9 5 11 7 11 9.5V17a2 2 0 0 1-2 2", key: "15i455" }],
  ["line", { x1: "6", x2: "7", y1: "10", y2: "10", key: "1e2scm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J_ = d("Mails", [
  ["rect", { width: "16", height: "13", x: "6", y: "4", rx: "2", key: "1drq3f" }],
  ["path", { d: "m22 7-7.1 3.78c-.57.3-1.23.3-1.8 0L6 7", key: "xn252p" }],
  ["path", { d: "M2 8v11c0 1.1.9 2 2 2h14", key: "n13cji" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K_ = d("MapPinOff", [
  [
    "path",
    { d: "M5.43 5.43A8.06 8.06 0 0 0 4 10c0 6 8 12 8 12a29.94 29.94 0 0 0 5-5", key: "12a8pk" }
  ],
  [
    "path",
    {
      d: "M19.18 13.52A8.66 8.66 0 0 0 20 10a8 8 0 0 0-8-8 7.88 7.88 0 0 0-3.52.82",
      key: "1r9f6y"
    }
  ],
  [
    "path",
    { d: "M9.13 9.13A2.78 2.78 0 0 0 9 10a3 3 0 0 0 3 3 2.78 2.78 0 0 0 .87-.13", key: "erynq7" }
  ],
  ["path", { d: "M14.9 9.25a3 3 0 0 0-2.15-2.16", key: "1hwwmx" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q_ = d("MapPin", [
  ["path", { d: "M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z", key: "2oe9fu" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eG = d("MapPinned", [
  ["path", { d: "M18 8c0 4.5-6 9-6 9s-6-4.5-6-9a6 6 0 0 1 12 0", key: "yrbn30" }],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  [
    "path",
    {
      d: "M8.835 14H5a1 1 0 0 0-.9.7l-2 6c-.1.1-.1.2-.1.3 0 .6.4 1 1 1h18c.6 0 1-.4 1-1 0-.1 0-.2-.1-.3l-2-6a1 1 0 0 0-.9-.7h-3.835",
      key: "112zkj"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tG = d("Map", [
  [
    "path",
    {
      d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
      key: "169xi5"
    }
  ],
  ["path", { d: "M15 5.764v15", key: "1pn4in" }],
  ["path", { d: "M9 3.236v15", key: "1uimfh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nG = d("Martini", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M12 11v11", key: "ur9y6a" }],
  ["path", { d: "m19 3-7 8-7-8Z", key: "1sgpiw" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rG = d("Maximize2", [
  ["polyline", { points: "15 3 21 3 21 9", key: "mznyad" }],
  ["polyline", { points: "9 21 3 21 3 15", key: "1avn1i" }],
  ["line", { x1: "21", x2: "14", y1: "3", y2: "10", key: "ota7mn" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aG = d("Maximize", [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v3", key: "1dcmit" }],
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2h-3", key: "1e4gt3" }],
  ["path", { d: "M3 16v3a2 2 0 0 0 2 2h3", key: "wsl5sc" }],
  ["path", { d: "M16 21h3a2 2 0 0 0 2-2v-3", key: "18trek" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iG = d("Medal", [
  [
    "path",
    {
      d: "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15",
      key: "143lza"
    }
  ],
  ["path", { d: "M11 12 5.12 2.2", key: "qhuxz6" }],
  ["path", { d: "m13 12 5.88-9.8", key: "hbye0f" }],
  ["path", { d: "M8 7h8", key: "i86dvs" }],
  ["circle", { cx: "12", cy: "17", r: "5", key: "qbz8iq" }],
  ["path", { d: "M12 18v-2h-.5", key: "fawc4q" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oG = d("MegaphoneOff", [
  ["path", { d: "M9.26 9.26 3 11v3l14.14 3.14", key: "3429n" }],
  ["path", { d: "M21 15.34V6l-7.31 2.03", key: "4o1dh8" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sG = d("Megaphone", [
  ["path", { d: "m3 11 18-5v12L3 14v-3z", key: "n962bs" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cG = d("Meh", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "8", x2: "16", y1: "15", y2: "15", key: "1xb1d9" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lG = d("MemoryStick", [
  ["path", { d: "M6 19v-3", key: "1nvgqn" }],
  ["path", { d: "M10 19v-3", key: "iu8nkm" }],
  ["path", { d: "M14 19v-3", key: "kcehxu" }],
  ["path", { d: "M18 19v-3", key: "1vh91z" }],
  ["path", { d: "M8 11V9", key: "63erz4" }],
  ["path", { d: "M16 11V9", key: "fru6f3" }],
  ["path", { d: "M12 11V9", key: "ha00sb" }],
  ["path", { d: "M2 15h20", key: "16ne18" }],
  [
    "path",
    {
      d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.1a2 2 0 0 0 0 3.837V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.1a2 2 0 0 0 0-3.837Z",
      key: "lhddv3"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dG = d("Menu", [
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
  ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uG = d("Merge", [
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22", key: "1hyw0i" }],
  ["path", { d: "m20 22-5-5", key: "1m27yz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hG = d("MessageCircleCode", [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22z", key: "k85zhp" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pG = d("MessageCircleDashed", [
  ["path", { d: "M13.5 3.1c-.5 0-1-.1-1.5-.1s-1 .1-1.5.1", key: "16ll65" }],
  ["path", { d: "M19.3 6.8a10.45 10.45 0 0 0-2.1-2.1", key: "1nq77a" }],
  ["path", { d: "M20.9 13.5c.1-.5.1-1 .1-1.5s-.1-1-.1-1.5", key: "1sf7wn" }],
  ["path", { d: "M17.2 19.3a10.45 10.45 0 0 0 2.1-2.1", key: "x1hs5g" }],
  ["path", { d: "M10.5 20.9c.5.1 1 .1 1.5.1s1-.1 1.5-.1", key: "19m18z" }],
  ["path", { d: "M3.5 17.5 2 22l4.5-1.5", key: "1f36qi" }],
  ["path", { d: "M3.1 10.5c0 .5-.1 1-.1 1.5s.1 1 .1 1.5", key: "1vz3ju" }],
  ["path", { d: "M6.8 4.7a10.45 10.45 0 0 0-2.1 2.1", key: "19f9do" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fG = d("MessageCircleHeart", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  [
    "path",
    {
      d: "M15.8 9.2a2.5 2.5 0 0 0-3.5 0l-.3.4-.35-.3a2.42 2.42 0 1 0-3.2 3.6l3.6 3.5 3.6-3.5c1.2-1.2 1.1-2.7.2-3.7",
      key: "43lnbm"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yG = d("MessageCircleMore", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mG = d("MessageCircleOff", [
  ["path", { d: "M20.5 14.9A9 9 0 0 0 9.1 3.5", key: "1iebmn" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5.6 5.6C3 8.3 2.2 12.5 4 16l-2 6 6-2c3.4 1.8 7.6 1.1 10.3-1.7", key: "1ov8ce" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gG = d("MessageCirclePlus", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vG = d("MessageCircleQuestion", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kG = d("MessageCircleReply", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }],
  ["path", { d: "M7 12h7a2 2 0 0 1 2 2v1", key: "1gheu4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bG = d("MessageCircleWarning", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xG = d("MessageCircleX", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MG = d("MessageCircle", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wG = d("MessageSquareCode", [
  ["path", { d: "M10 7.5 8 10l2 2.5", key: "xb17xw" }],
  ["path", { d: "m14 7.5 2 2.5-2 2.5", key: "5rap1v" }],
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CG = d("MessageSquareDashed", [
  ["path", { d: "M3 6V5c0-1.1.9-2 2-2h2", key: "9usibi" }],
  ["path", { d: "M11 3h3", key: "1c3ji7" }],
  ["path", { d: "M18 3h1c1.1 0 2 .9 2 2", key: "19esxn" }],
  ["path", { d: "M21 9v2", key: "p14lih" }],
  ["path", { d: "M21 15c0 1.1-.9 2-2 2h-1", key: "1fo1j8" }],
  ["path", { d: "M14 17h-3", key: "1w4p2m" }],
  ["path", { d: "m7 17-4 4v-5", key: "ph9x1h" }],
  ["path", { d: "M3 12v-2", key: "856n1q" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SG = d("MessageSquareDiff", [
  ["path", { d: "m5 19-2 2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2", key: "1xuzuj" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AG = d("MessageSquareDot", [
  ["path", { d: "M11.7 3H5a2 2 0 0 0-2 2v16l4-4h12a2 2 0 0 0 2-2v-2.7", key: "uodpkb" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OG = d("MessageSquareHeart", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  [
    "path",
    {
      d: "M14.8 7.5a1.84 1.84 0 0 0-2.6 0l-.2.3-.3-.3a1.84 1.84 0 1 0-2.4 2.8L12 13l2.7-2.7c.9-.9.8-2.1.1-2.8",
      key: "1blaws"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EG = d("MessageSquareMore", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IG = d("MessageSquareOff", [
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M3.6 3.6c-.4.3-.6.8-.6 1.4v16l4-4h10", key: "pwpm4a" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DG = d("MessageSquarePlus", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TG = d("MessageSquareQuote", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M8 12a2 2 0 0 0 2-2V8H8", key: "1jfesj" }],
  ["path", { d: "M14 12a2 2 0 0 0 2-2V8h-2", key: "1dq9mh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NG = d("MessageSquareReply", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "m10 7-3 3 3 3", key: "1eugdv" }],
  ["path", { d: "M17 13v-1a2 2 0 0 0-2-2H7", key: "ernfh3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PG = d("MessageSquareShare", [
  ["path", { d: "M21 12v3a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h7", key: "tqtdkg" }],
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "m16 8 5-5", key: "15mbrl" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LG = d("MessageSquareText", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M13 8H7", key: "14i4kc" }],
  ["path", { d: "M17 12H7", key: "16if0g" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RG = d("MessageSquareWarning", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M12 7v2", key: "stiyo7" }],
  ["path", { d: "M12 13h.01", key: "y0uutt" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VG = d("MessageSquareX", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zG = d("MessageSquare", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BG = d("MessagesSquare", [
  ["path", { d: "M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2z", key: "jj09z8" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1", key: "1cx29u" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HG = d("MicOff", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2", key: "80xlxr" }],
  ["path", { d: "M5 10v2a7 7 0 0 0 12 5", key: "p2k8kg" }],
  ["path", { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33", key: "1gzdoj" }],
  ["path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12", key: "r2i35w" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $G = d("MicVocal", [
  [
    "path",
    {
      d: "m11 7.601-5.994 8.19a1 1 0 0 0 .1 1.298l.817.818a1 1 0 0 0 1.314.087L15.09 12",
      key: "80a601"
    }
  ],
  [
    "path",
    {
      d: "M16.5 21.174C15.5 20.5 14.372 20 13 20c-2.058 0-3.928 2.356-6 2-2.072-.356-2.775-3.369-1.5-4.5",
      key: "j0ngtp"
    }
  ],
  ["circle", { cx: "16", cy: "7", r: "5", key: "d08jfb" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jG = d("Mic", [
  ["path", { d: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z", key: "131961" }],
  ["path", { d: "M19 10v2a7 7 0 0 1-14 0v-2", key: "1vc78b" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FG = d("Microscope", [
  ["path", { d: "M6 18h8", key: "1borvv" }],
  ["path", { d: "M3 22h18", key: "8prr45" }],
  ["path", { d: "M14 22a7 7 0 1 0 0-14h-1", key: "1jwaiy" }],
  ["path", { d: "M9 14h2", key: "197e7h" }],
  ["path", { d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z", key: "1bmzmy" }],
  ["path", { d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3", key: "1drr47" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WG = d("Microwave", [
  ["rect", { width: "20", height: "15", x: "2", y: "4", rx: "2", key: "2no95f" }],
  ["rect", { width: "8", height: "7", x: "6", y: "8", rx: "1", key: "zh9wx" }],
  ["path", { d: "M18 8v7", key: "o5zi4n" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 19v2", key: "1dawf0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qG = d("Milestone", [
  ["path", { d: "M18 6H5a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h13l4-3.5L18 6Z", key: "1mp5s7" }],
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M12 3v3", key: "1n5kay" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _G = d("MilkOff", [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v1.343M15 2v2.789a4 4 0 0 0 .672 2.219l.656.984a4 4 0 0 1 .672 2.22v1.131M7.8 7.8l-.128.192A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3",
      key: "y0ejgx"
    }
  ],
  ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.472 6.472 0 0 0 3.435.435", key: "iaxqsy" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GG = d("Milk", [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2",
      key: "qtp12x"
    }
  ],
  ["path", { d: "M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "ygeh44" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZG = d("Minimize2", [
  ["polyline", { points: "4 14 10 14 10 20", key: "11kfnr" }],
  ["polyline", { points: "20 10 14 10 14 4", key: "rlmsce" }],
  ["line", { x1: "14", x2: "21", y1: "10", y2: "3", key: "o5lafz" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XG = d("Minimize", [
  ["path", { d: "M8 3v3a2 2 0 0 1-2 2H3", key: "hohbtr" }],
  ["path", { d: "M21 8h-3a2 2 0 0 1-2-2V3", key: "5jw1f3" }],
  ["path", { d: "M3 16h3a2 2 0 0 1 2 2v3", key: "198tvr" }],
  ["path", { d: "M16 21v-3a2 2 0 0 1 2-2h3", key: "ph8mxp" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UG = d("Minus", [["path", { d: "M5 12h14", key: "1ays0h" }]]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YG = d("MonitorCheck", [
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JG = d("MonitorDot", [
  ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
  ["path", { d: "M22 12v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9", key: "1fet9y" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KG = d("MonitorDown", [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m15 10-3 3-3-3", key: "lzhmyn" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QG = d("MonitorOff", [
  ["path", { d: "M17 17H4a2 2 0 0 1-2-2V5c0-1.5 1-2 1-2", key: "k0q8oc" }],
  ["path", { d: "M22 15V5a2 2 0 0 0-2-2H9", key: "cp1ac0" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eZ = d("MonitorPause", [
  ["path", { d: "M10 13V7", key: "1u13u9" }],
  ["path", { d: "M14 13V7", key: "1vj9om" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tZ = d("MonitorPlay", [
  [
    "path",
    {
      d: "M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z",
      key: "1pctta"
    }
  ],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2", key: "x3v2xh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nZ = d("MonitorSmartphone", [
  ["path", { d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8", key: "10dyio" }],
  ["path", { d: "M10 19v-3.96 3.15", key: "1irgej" }],
  ["path", { d: "M7 19h5", key: "qswx4l" }],
  ["rect", { width: "6", height: "10", x: "16", y: "12", rx: "2", key: "1egngj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rZ = d("MonitorSpeaker", [
  ["path", { d: "M5.5 20H8", key: "1k40s5" }],
  ["path", { d: "M17 9h.01", key: "1j24nn" }],
  ["rect", { width: "10", height: "16", x: "12", y: "4", rx: "2", key: "ixliua" }],
  ["path", { d: "M8 6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4", key: "1mp6e1" }],
  ["circle", { cx: "17", cy: "15", r: "1", key: "tqvash" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aZ = d("MonitorStop", [
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2", key: "x3v2xh" }],
  ["rect", { x: "9", y: "7", width: "6", height: "6", rx: "1", key: "5m2oou" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iZ = d("MonitorUp", [
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oZ = d("MonitorX", [
  ["path", { d: "m14.5 12.5-5-5", key: "1jahn5" }],
  ["path", { d: "m9.5 12.5 5-5", key: "1k2t7b" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sZ = d("Monitor", [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cZ = d("MoonStar", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9", key: "4ay0iu" }],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lZ = d("Moon", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dZ = d("MountainSnow", [
  ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }],
  [
    "path",
    { d: "M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19", key: "1pvmmp" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uZ = d("Mountain", [
  ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hZ = d("MouseOff", [
  ["path", { d: "M12 6v.343", key: "1gyhex" }],
  ["path", { d: "M18.218 18.218A7 7 0 0 1 5 15V9a7 7 0 0 1 .782-3.218", key: "ukzz01" }],
  ["path", { d: "M19 13.343V9A7 7 0 0 0 8.56 2.902", key: "104jy9" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pZ = d("MousePointer2", [
  ["path", { d: "m4 4 7.07 17 2.51-7.39L21 11.07z", key: "1vqm48" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fZ = d("MousePointerBan", [
  ["path", { d: "m2 2 4 11 2-5 5-2Z", key: "i586l5" }],
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
  ["path", { d: "m11.8 11.8 8.4 8.4", key: "oogvdj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yZ = d("MousePointerClick", [
  ["path", { d: "m9 9 5 12 1.8-5.2L21 14Z", key: "1b76lo" }],
  ["path", { d: "M7.2 2.2 8 5.1", key: "1cfko1" }],
  ["path", { d: "m5.1 8-2.9-.8", key: "1go3kf" }],
  ["path", { d: "M14 4.1 12 6", key: "ita8i4" }],
  ["path", { d: "m6 12-1.9 2", key: "mnht97" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mZ = d("MousePointer", [
  ["path", { d: "m3 3 7.07 16.97 2.51-7.39 7.39-2.51L3 3z", key: "y2ucgo" }],
  ["path", { d: "m13 13 6 6", key: "1nhxnf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gZ = d("Mouse", [
  ["rect", { x: "5", y: "2", width: "14", height: "20", rx: "7", key: "11ol66" }],
  ["path", { d: "M12 6v4", key: "16clxf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vZ = d("Move3d", [
  ["path", { d: "M5 3v16h16", key: "1mqmf9" }],
  ["path", { d: "m5 19 6-6", key: "jh6hbb" }],
  ["path", { d: "m2 6 3-3 3 3", key: "tkyvxa" }],
  ["path", { d: "m18 16 3 3-3 3", key: "1d4glt" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kZ = d("MoveDiagonal2", [
  ["polyline", { points: "5 11 5 5 11 5", key: "ncfzxk" }],
  ["polyline", { points: "19 13 19 19 13 19", key: "1mk7hk" }],
  ["line", { x1: "5", x2: "19", y1: "5", y2: "19", key: "mcyte3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bZ = d("MoveDiagonal", [
  ["polyline", { points: "13 5 19 5 19 11", key: "11219e" }],
  ["polyline", { points: "11 19 5 19 5 13", key: "sfq3wq" }],
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xZ = d("MoveDownLeft", [
  ["path", { d: "M11 19H5V13", key: "1akmht" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MZ = d("MoveDownRight", [
  ["path", { d: "M19 13V19H13", key: "10vkzq" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wZ = d("MoveDown", [
  ["path", { d: "M8 18L12 22L16 18", key: "cskvfv" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CZ = d("MoveHorizontal", [
  ["polyline", { points: "18 8 22 12 18 16", key: "1hqrds" }],
  ["polyline", { points: "6 8 2 12 6 16", key: "f0ernq" }],
  ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SZ = d("MoveLeft", [
  ["path", { d: "M6 8L2 12L6 16", key: "kyvwex" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AZ = d("MoveRight", [
  ["path", { d: "M18 8L22 12L18 16", key: "1r0oui" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OZ = d("MoveUpLeft", [
  ["path", { d: "M5 11V5H11", key: "3q78g9" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EZ = d("MoveUpRight", [
  ["path", { d: "M13 5H19V11", key: "1n1gyv" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IZ = d("MoveUp", [
  ["path", { d: "M8 6L12 2L16 6", key: "1yvkyx" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DZ = d("MoveVertical", [
  ["polyline", { points: "8 18 12 22 16 18", key: "1uutw3" }],
  ["polyline", { points: "8 6 12 2 16 6", key: "d60sxy" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TZ = d("Move", [
  ["polyline", { points: "5 9 2 12 5 15", key: "1r5uj5" }],
  ["polyline", { points: "9 5 12 2 15 5", key: "5v383o" }],
  ["polyline", { points: "15 19 12 22 9 19", key: "g7qi8m" }],
  ["polyline", { points: "19 9 22 12 19 15", key: "tpp73q" }],
  ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NZ = d("Music2", [
  ["circle", { cx: "8", cy: "18", r: "4", key: "1fc0mg" }],
  ["path", { d: "M12 18V2l7 4", key: "g04rme" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PZ = d("Music3", [
  ["circle", { cx: "12", cy: "18", r: "4", key: "m3r9ws" }],
  ["path", { d: "M16 18V2", key: "40x2m5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LZ = d("Music4", [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["path", { d: "m9 9 12-2", key: "1e64n2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RZ = d("Music", [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VZ = d("Navigation2Off", [
  ["path", { d: "M9.31 9.31 5 21l7-4 7 4-1.17-3.17", key: "qoq2o2" }],
  ["path", { d: "M14.53 8.88 12 2l-1.17 3.17", key: "k3sjzy" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zZ = d("Navigation2", [
  ["polygon", { points: "12 2 19 21 12 17 5 21 12 2", key: "x8c0qg" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BZ = d("NavigationOff", [
  ["path", { d: "M8.43 8.43 3 11l8 2 2 8 2.57-5.43", key: "1vdtb7" }],
  ["path", { d: "M17.39 11.73 22 2l-9.73 4.61", key: "tya3r6" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HZ = d("Navigation", [
  ["polygon", { points: "3 11 22 2 13 21 11 13 3 11", key: "1ltx0t" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $Z = d("Network", [
  ["rect", { x: "16", y: "16", width: "6", height: "6", rx: "1", key: "4q2zg0" }],
  ["rect", { x: "2", y: "16", width: "6", height: "6", rx: "1", key: "8cvhb9" }],
  ["rect", { x: "9", y: "2", width: "6", height: "6", rx: "1", key: "1egb70" }],
  ["path", { d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3", key: "1jsf9p" }],
  ["path", { d: "M12 12V8", key: "2874zd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jZ = d("Newspaper", [
  [
    "path",
    {
      d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2",
      key: "7pis2x"
    }
  ],
  ["path", { d: "M18 14h-8", key: "sponae" }],
  ["path", { d: "M15 18h-5", key: "95g1m2" }],
  ["path", { d: "M10 6h8v4h-8V6Z", key: "smlsk5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FZ = d("Nfc", [
  ["path", { d: "M6 8.32a7.43 7.43 0 0 1 0 7.36", key: "9iaqei" }],
  ["path", { d: "M9.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "1yha7l" }],
  ["path", { d: "M12.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "4iu2gk" }],
  ["path", { d: "M16.37 2a20.16 20.16 0 0 1 0 20", key: "sap9u2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WZ = d("NotebookPen", [
  ["path", { d: "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4", key: "re6nr2" }],
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  [
    "path",
    {
      d: "M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "pqwjuv"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qZ = d("NotebookTabs", [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M15 2v20", key: "dcj49h" }],
  ["path", { d: "M15 7h5", key: "1xj5lc" }],
  ["path", { d: "M15 12h5", key: "w5shd9" }],
  ["path", { d: "M15 17h5", key: "1qaofu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Z = d("NotebookText", [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M9.5 8h5", key: "11mslq" }],
  ["path", { d: "M9.5 12H16", key: "ktog6x" }],
  ["path", { d: "M9.5 16H14", key: "p1seyn" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GZ = d("Notebook", [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M16 2v20", key: "rotuqe" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZZ = d("NotepadTextDashed", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v2", key: "j91f56" }],
  ["path", { d: "M20 12v2", key: "w8o0tu" }],
  ["path", { d: "M20 18v2a2 2 0 0 1-2 2h-1", key: "1c9ggx" }],
  ["path", { d: "M13 22h-2", key: "191ugt" }],
  ["path", { d: "M7 22H6a2 2 0 0 1-2-2v-2", key: "1rt9px" }],
  ["path", { d: "M4 14v-2", key: "1v0sqh" }],
  ["path", { d: "M4 8V6a2 2 0 0 1 2-2h2", key: "1mwabg" }],
  ["path", { d: "M8 10h6", key: "3oa6kw" }],
  ["path", { d: "M8 14h8", key: "1fgep2" }],
  ["path", { d: "M8 18h5", key: "17enja" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XZ = d("NotepadText", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "16", height: "18", x: "4", y: "4", rx: "2", key: "1u9h20" }],
  ["path", { d: "M8 10h6", key: "3oa6kw" }],
  ["path", { d: "M8 14h8", key: "1fgep2" }],
  ["path", { d: "M8 18h5", key: "17enja" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UZ = d("NutOff", [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592a7.01 7.01 0 0 0 4.125-2.939",
      key: "1xcvy9"
    }
  ],
  ["path", { d: "M19 10v3.343", key: "163tfc" }],
  [
    "path",
    {
      d: "M12 12c-1.349-.573-1.905-1.005-2.5-2-.546.902-1.048 1.353-2.5 2-1.018-.644-1.46-1.08-2-2-1.028.71-1.69.918-3 1 1.081-1.048 1.757-2.03 2-3 .194-.776.84-1.551 1.79-2.21m11.654 5.997c.887-.457 1.28-.891 1.556-1.787 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4-.74 0-1.461.068-2.15.192",
      key: "17914v"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YZ = d("Nut", [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592A7.003 7.003 0 0 0 19 14v-4",
      key: "1tgyif"
    }
  ],
  [
    "path",
    {
      d: "M12 4C8 4 4.5 6 4 8c-.243.97-.919 1.952-2 3 1.31-.082 1.972-.29 3-1 .54.92.982 1.356 2 2 1.452-.647 1.954-1.098 2.5-2 .595.995 1.151 1.427 2.5 2 1.31-.621 1.862-1.058 2.5-2 .629.977 1.162 1.423 2.5 2 1.209-.548 1.68-.967 2-2 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4Z",
      key: "tnsqj"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JZ = d("OctagonAlert", [
  [
    "polygon",
    {
      points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2",
      key: "h1p8hx"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KZ = d("OctagonPause", [
  ["path", { d: "M10 15V9", key: "1lckn7" }],
  ["path", { d: "M14 15V9", key: "1muqhk" }],
  ["path", { d: "M7.714 2h8.572L22 7.714v8.572L16.286 22H7.714L2 16.286V7.714z", key: "p5imkh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QZ = d("OctagonX", [
  [
    "polygon",
    {
      points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2",
      key: "h1p8hx"
    }
  ],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eX = d("Octagon", [
  [
    "polygon",
    {
      points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2",
      key: "h1p8hx"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tX = d("Option", [
  ["path", { d: "M3 3h6l6 18h6", key: "ph9rgk" }],
  ["path", { d: "M14 3h7", key: "16f0ms" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nX = d("Orbit", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M10.4 21.9a10 10 0 0 0 9.941-15.416", key: "eohfx2" }],
  ["path", { d: "M13.5 2.1a10 10 0 0 0-9.841 15.416", key: "19pvbm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rX = d("Origami", [
  ["path", { d: "M12 12V4a1 1 0 0 1 1-1h6.297a1 1 0 0 1 .651 1.759l-4.696 4.025", key: "1bx4vc" }],
  [
    "path",
    {
      d: "m12 21-7.414-7.414A2 2 0 0 1 4 12.172V6.415a1.002 1.002 0 0 1 1.707-.707L20 20.009",
      key: "1h3km6"
    }
  ],
  [
    "path",
    {
      d: "m12.214 3.381 8.414 14.966a1 1 0 0 1-.167 1.199l-1.168 1.163a1 1 0 0 1-.706.291H6.351a1 1 0 0 1-.625-.219L3.25 18.8a1 1 0 0 1 .631-1.781l4.165.027",
      key: "1hj4wg"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aX = d("Package2", [
  ["path", { d: "M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z", key: "1ront0" }],
  ["path", { d: "m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9", key: "19h2x1" }],
  ["path", { d: "M12 3v6", key: "1holv5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iX = d("PackageCheck", [
  ["path", { d: "m16 16 2 2 4-4", key: "gfu2re" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oX = d("PackageMinus", [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sX = d("PackageOpen", [
  ["path", { d: "M12 22v-9", key: "x3hkom" }],
  [
    "path",
    {
      d: "M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z",
      key: "2ntwy6"
    }
  ],
  [
    "path",
    {
      d: "M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13",
      key: "1pmm1c"
    }
  ],
  [
    "path",
    {
      d: "M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z",
      key: "12ttoo"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cX = d("PackagePlus", [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  ["path", { d: "M19 13v6", key: "85cyf1" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lX = d("PackageSearch", [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["circle", { cx: "18.5", cy: "15.5", r: "2.5", key: "b5zd12" }],
  ["path", { d: "M20.27 17.27 22 19", key: "1l4muz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dX = d("PackageX", [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["path", { d: "m17 13 5 5m-5 0 5-5", key: "im3w4b" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uX = d("Package", [
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  [
    "path",
    {
      d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
      key: "hh9hay"
    }
  ],
  ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
  ["path", { d: "M12 22V12", key: "d0xqtd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hX = d("PaintBucket", [
  [
    "path",
    { d: "m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z", key: "irua1i" }
  ],
  ["path", { d: "m5 2 5 5", key: "1lls2c" }],
  ["path", { d: "M2 13h15", key: "1hkzvu" }],
  ["path", { d: "M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z", key: "xk76lq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pX = d("PaintRoller", [
  ["rect", { width: "16", height: "6", x: "2", y: "2", rx: "2", key: "jcyz7m" }],
  ["path", { d: "M10 16v-2a2 2 0 0 1 2-2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", key: "1b9h7c" }],
  ["rect", { width: "4", height: "6", x: "8", y: "16", rx: "1", key: "d6e7yl" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fX = d("PaintbrushVertical", [
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M14 2v4", key: "qmzblu" }],
  ["path", { d: "M17 2a1 1 0 0 1 1 1v9H6V3a1 1 0 0 1 1-1z", key: "ycvu00" }],
  [
    "path",
    {
      d: "M6 12a1 1 0 0 0-1 1v1a2 2 0 0 0 2 2h2a1 1 0 0 1 1 1v2.9a2 2 0 1 0 4 0V17a1 1 0 0 1 1-1h2a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1",
      key: "iw4wnp"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yX = d("Paintbrush", [
  ["path", { d: "m14.622 17.897-10.68-2.913", key: "vj2p1u" }],
  [
    "path",
    {
      d: "M18.376 2.622a1 1 0 1 1 3.002 3.002L17.36 9.643a.5.5 0 0 0 0 .707l.944.944a2.41 2.41 0 0 1 0 3.408l-.944.944a.5.5 0 0 1-.707 0L8.354 7.348a.5.5 0 0 1 0-.707l.944-.944a2.41 2.41 0 0 1 3.408 0l.944.944a.5.5 0 0 0 .707 0z",
      key: "18tc5c"
    }
  ],
  [
    "path",
    {
      d: "M9 8c-1.804 2.71-3.97 3.46-6.583 3.948a.507.507 0 0 0-.302.819l7.32 8.883a1 1 0 0 0 1.185.204C12.735 20.405 16 16.792 16 15",
      key: "ytzfxy"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mX = d("Palette", [
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  [
    "path",
    {
      d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z",
      key: "12rzf8"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gX = d("PanelBottomClose", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "m15 8-3 3-3-3", key: "1oxy1z" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vX = d("PanelBottomDashed", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M14 15h1", key: "171nev" }],
  ["path", { d: "M19 15h2", key: "1vnucp" }],
  ["path", { d: "M3 15h2", key: "8bym0q" }],
  ["path", { d: "M9 15h1", key: "1tg3ks" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kX = d("PanelBottomOpen", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bX = d("PanelBottom", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xX = d("PanelLeftClose", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m16 15-3-3 3-3", key: "14y99z" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MX = d("PanelLeftDashed", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 14v1", key: "askpd8" }],
  ["path", { d: "M9 19v2", key: "16tejx" }],
  ["path", { d: "M9 3v2", key: "1noubl" }],
  ["path", { d: "M9 9v1", key: "19ebxg" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wX = d("PanelLeftOpen", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m14 9 3 3-3 3", key: "8010ee" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CX = d("PanelLeft", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SX = d("PanelRightClose", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["path", { d: "m8 9 3 3-3 3", key: "12hl5m" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AX = d("PanelRightDashed", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 14v1", key: "ilsfch" }],
  ["path", { d: "M15 19v2", key: "1fst2f" }],
  ["path", { d: "M15 3v2", key: "z204g4" }],
  ["path", { d: "M15 9v1", key: "z2a8b1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OX = d("PanelRightOpen", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EX = d("PanelRight", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IX = d("PanelTopClose", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "m9 16 3-3 3 3", key: "1idcnm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DX = d("PanelTopDashed", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M14 9h1", key: "l0svgy" }],
  ["path", { d: "M19 9h2", key: "te2zfg" }],
  ["path", { d: "M3 9h2", key: "1h4ldw" }],
  ["path", { d: "M9 9h1", key: "15jzuz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TX = d("PanelTopOpen", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "m15 14-3 3-3-3", key: "g215vf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NX = d("PanelTop", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PX = d("PanelsLeftBottom", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M9 15h12", key: "5ijen5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LX = d("PanelsRightBottom", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h12", key: "1wkqb3" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RX = d("PanelsTopLeft", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M9 21V9", key: "1oto5p" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VX = d("Paperclip", [
  [
    "path",
    {
      d: "m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48",
      key: "1u3ebp"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zX = d("Parentheses", [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BX = d("ParkingMeter", [
  ["path", { d: "M9 9a3 3 0 1 1 6 0", key: "jdoeu8" }],
  ["path", { d: "M12 12v3", key: "158kv8" }],
  ["path", { d: "M11 15h2", key: "199qp6" }],
  [
    "path",
    {
      d: "M19 9a7 7 0 1 0-13.6 2.3C6.4 14.4 8 19 8 19h8s1.6-4.6 2.6-7.7c.3-.8.4-1.5.4-2.3",
      key: "1l50wn"
    }
  ],
  ["path", { d: "M12 19v3", key: "npa21l" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HX = d("PartyPopper", [
  ["path", { d: "M5.8 11.3 2 22l10.7-3.79", key: "gwxi1d" }],
  ["path", { d: "M4 3h.01", key: "1vcuye" }],
  ["path", { d: "M22 8h.01", key: "1mrtc2" }],
  ["path", { d: "M15 2h.01", key: "1cjtqr" }],
  ["path", { d: "M22 20h.01", key: "1mrys2" }],
  [
    "path",
    {
      d: "m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10",
      key: "hbicv8"
    }
  ],
  [
    "path",
    { d: "m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17", key: "1i94pl" }
  ],
  ["path", { d: "m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7", key: "1cofks" }],
  [
    "path",
    {
      d: "M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z",
      key: "4kbmks"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $X = d("Pause", [
  ["rect", { x: "14", y: "4", width: "4", height: "16", rx: "1", key: "zuxfzm" }],
  ["rect", { x: "6", y: "4", width: "4", height: "16", rx: "1", key: "1okwgv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jX = d("PawPrint", [
  ["circle", { cx: "11", cy: "4", r: "2", key: "vol9p0" }],
  ["circle", { cx: "18", cy: "8", r: "2", key: "17gozi" }],
  ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }],
  [
    "path",
    {
      d: "M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z",
      key: "1ydw1z"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FX = d("PcCase", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", key: "1uq1d7" }],
  ["path", { d: "M15 14h.01", key: "1kp3bh" }],
  ["path", { d: "M9 6h6", key: "dgm16u" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WX = d("PenLine", [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  [
    "path",
    {
      d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z",
      key: "1ykcvy"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qX = d("PenOff", [
  [
    "path",
    {
      d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
      key: "bjo8r8"
    }
  ],
  ["path", { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353", key: "16h5ne" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _X = d("PenTool", [
  [
    "path",
    {
      d: "M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z",
      key: "nt11vn"
    }
  ],
  [
    "path",
    {
      d: "m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18",
      key: "15qc1e"
    }
  ],
  ["path", { d: "m2.3 2.3 7.286 7.286", key: "1wuzzi" }],
  ["circle", { cx: "11", cy: "11", r: "2", key: "xmgehs" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GX = d("Pen", [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZX = d("PencilLine", [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  [
    "path",
    {
      d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z",
      key: "1ykcvy"
    }
  ],
  ["path", { d: "m15 5 3 3", key: "1w25hb" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XX = d("PencilOff", [
  [
    "path",
    {
      d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
      key: "bjo8r8"
    }
  ],
  ["path", { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353", key: "16h5ne" }],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UX = d("PencilRuler", [
  [
    "path",
    { d: "M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13", key: "orapub" }
  ],
  ["path", { d: "m8 6 2-2", key: "115y1s" }],
  ["path", { d: "m18 16 2-2", key: "ee94s4" }],
  [
    "path",
    {
      d: "m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17",
      key: "cfq27r"
    }
  ],
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YX = d("Pencil", [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JX = d("Pentagon", [
  [
    "path",
    {
      d: "M3.5 8.7c-.7.5-1 1.4-.7 2.2l2.8 8.7c.3.8 1 1.4 1.9 1.4h9.1c.9 0 1.6-.6 1.9-1.4l2.8-8.7c.3-.8 0-1.7-.7-2.2l-7.4-5.3a2.1 2.1 0 0 0-2.4 0Z",
      key: "hsj90r"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KX = d("Percent", [
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }],
  ["circle", { cx: "6.5", cy: "6.5", r: "2.5", key: "4mh3h7" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "2.5", key: "1mdrzq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QX = d("PersonStanding", [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["path", { d: "m9 20 3-6 3 6", key: "se2kox" }],
  ["path", { d: "m6 8 6 2 6-2", key: "4o3us4" }],
  ["path", { d: "M12 10v4", key: "1kjpxc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eU = d("PhoneCall", [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ],
  ["path", { d: "M14.05 2a9 9 0 0 1 8 7.94", key: "vmijpz" }],
  ["path", { d: "M14.05 6A5 5 0 0 1 18 10", key: "13nbpp" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tU = d("PhoneForwarded", [
  ["polyline", { points: "18 2 22 6 18 10", key: "6vjanh" }],
  ["line", { x1: "14", x2: "22", y1: "6", y2: "6", key: "1jsywh" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nU = d("PhoneIncoming", [
  ["polyline", { points: "16 2 16 8 22 8", key: "1ygljm" }],
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rU = d("PhoneMissed", [
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  ["line", { x1: "16", x2: "22", y1: "2", y2: "8", key: "13zxdn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aU = d("PhoneOff", [
  [
    "path",
    {
      d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91",
      key: "z86iuo"
    }
  ],
  ["line", { x1: "22", x2: "2", y1: "2", y2: "22", key: "11kh81" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iU = d("PhoneOutgoing", [
  ["polyline", { points: "22 8 22 2 16 2", key: "1g204g" }],
  ["line", { x1: "16", x2: "22", y1: "8", y2: "2", key: "1ggias" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oU = d("Phone", [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sU = d("Pi", [
  ["line", { x1: "9", x2: "9", y1: "4", y2: "20", key: "ovs5a5" }],
  ["path", { d: "M4 7c0-1.7 1.3-3 3-3h13", key: "10pag4" }],
  ["path", { d: "M18 20c-1.7 0-3-1.3-3-3V4", key: "1gaosr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cU = d("Piano", [
  [
    "path",
    {
      d: "M18.5 8c-1.4 0-2.6-.8-3.2-2A6.87 6.87 0 0 0 2 9v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8.5C22 9.6 20.4 8 18.5 8",
      key: "lag0yf"
    }
  ],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M6 14v4", key: "9ng0ue" }],
  ["path", { d: "M10 14v4", key: "1v8uk5" }],
  ["path", { d: "M14 14v4", key: "1tqops" }],
  ["path", { d: "M18 14v4", key: "18uqwm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lU = d("Pickaxe", [
  ["path", { d: "M14.531 12.469 6.619 20.38a1 1 0 1 1-3-3l7.912-7.912", key: "we99rg" }],
  [
    "path",
    {
      d: "M15.686 4.314A12.5 12.5 0 0 0 5.461 2.958 1 1 0 0 0 5.58 4.71a22 22 0 0 1 6.318 3.393",
      key: "1w6hck"
    }
  ],
  [
    "path",
    {
      d: "M17.7 3.7a1 1 0 0 0-1.4 0l-4.6 4.6a1 1 0 0 0 0 1.4l2.6 2.6a1 1 0 0 0 1.4 0l4.6-4.6a1 1 0 0 0 0-1.4z",
      key: "15hgfx"
    }
  ],
  [
    "path",
    {
      d: "M19.686 8.314a12.501 12.501 0 0 1 1.356 10.225 1 1 0 0 1-1.751-.119 22 22 0 0 0-3.393-6.319",
      key: "452b4h"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dU = d("PictureInPicture2", [
  ["path", { d: "M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4", key: "daa4of" }],
  ["rect", { width: "10", height: "7", x: "12", y: "13", rx: "2", key: "1nb8gs" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uU = d("PictureInPicture", [
  [
    "path",
    {
      d: "M8 4.5v5H3m-1-6 6 6m13 0v-3c0-1.16-.84-2-2-2h-7m-9 9v2c0 1.05.95 2 2 2h3",
      key: "bcd8fb"
    }
  ],
  ["rect", { width: "10", height: "7", x: "12", y: "13.5", ry: "2", key: "136fx3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hU = d("PieChart", [
  ["path", { d: "M21.21 15.89A10 10 0 1 1 8 2.83", key: "k2fpak" }],
  ["path", { d: "M22 12A10 10 0 0 0 12 2v10z", key: "1rfc4y" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pU = d("PiggyBank", [
  [
    "path",
    {
      d: "M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2V5z",
      key: "1ivx2i"
    }
  ],
  ["path", { d: "M2 9v1c0 1.1.9 2 2 2h1", key: "nm575m" }],
  ["path", { d: "M16 11h.01", key: "xkw8gn" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fU = d("PilcrowLeft", [
  ["path", { d: "M14 3v11", key: "mlfb7b" }],
  ["path", { d: "M14 9h-3a3 3 0 0 1 0-6h9", key: "1ulc19" }],
  ["path", { d: "M18 3v11", key: "1phi0r" }],
  ["path", { d: "M22 18H2l4-4", key: "yt65j9" }],
  ["path", { d: "m6 22-4-4", key: "6jgyf5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yU = d("PilcrowRight", [
  ["path", { d: "M10 3v11", key: "o3l5kj" }],
  ["path", { d: "M10 9H7a1 1 0 0 1 0-6h8", key: "1wb1nc" }],
  ["path", { d: "M14 3v11", key: "mlfb7b" }],
  ["path", { d: "m18 14 4 4H2", key: "4r8io1" }],
  ["path", { d: "m22 18-4 4", key: "1hjjrd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mU = d("Pilcrow", [
  ["path", { d: "M13 4v16", key: "8vvj80" }],
  ["path", { d: "M17 4v16", key: "7dpous" }],
  ["path", { d: "M19 4H9.5a4.5 4.5 0 0 0 0 9H13", key: "sh4n9v" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gU = d("PillBottle", [
  ["path", { d: "M18 11h-4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4", key: "17ldeb" }],
  ["path", { d: "M6 7v13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7", key: "nc37y6" }],
  ["rect", { width: "16", height: "5", x: "4", y: "2", rx: "1", key: "3jeezo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vU = d("Pill", [
  [
    "path",
    { d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z", key: "wa1lgi" }
  ],
  ["path", { d: "m8.5 8.5 7 7", key: "rvfmvr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kU = d("PinOff", [
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  ["path", { d: "M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89", key: "znwnzq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h11",
      key: "c9qhm2"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bU = d("Pin", [
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  [
    "path",
    {
      d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
      key: "1nkz8b"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xU = d("Pipette", [
  ["path", { d: "m2 22 1-1h3l9-9", key: "1sre89" }],
  ["path", { d: "M3 21v-3l9-9", key: "hpe2y6" }],
  [
    "path",
    {
      d: "m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z",
      key: "196du1"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MU = d("Pizza", [
  ["path", { d: "M15 11h.01", key: "rns66s" }],
  ["path", { d: "M11 15h.01", key: "k85uqc" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "m2 16 20 6-6-20A20 20 0 0 0 2 16", key: "e4slt2" }],
  ["path", { d: "M5.71 17.11a17.04 17.04 0 0 1 11.4-11.4", key: "rerf8f" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wU = d("PlaneLanding", [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M3.77 10.77 2 9l2-4.5 1.1.55c.55.28.9.84.9 1.45s.35 1.17.9 1.45L8 8.5l3-6 1.05.53a2 2 0 0 1 1.09 1.52l.72 5.4a2 2 0 0 0 1.09 1.52l4.4 2.2c.42.22.78.55 1.01.96l.6 1.03c.49.88-.06 1.98-1.06 2.1l-1.18.15c-.47.06-.95-.02-1.37-.24L4.29 11.15a2 2 0 0 1-.52-.38Z",
      key: "1ma21e"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CU = d("PlaneTakeoff", [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12 5 6l.9-.45a2 2 0 0 1 2.09.2l4.02 3a2 2 0 0 0 2.1.2l4.19-2.06a2.41 2.41 0 0 1 1.73-.17L21 7a1.4 1.4 0 0 1 .87 1.99l-.38.76c-.23.46-.6.84-1.07 1.08L7.58 17.2a2 2 0 0 1-1.22.18Z",
      key: "fkigj9"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SU = d("Plane", [
  [
    "path",
    {
      d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z",
      key: "1v9wt8"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AU = d("Play", [
  ["polygon", { points: "6 3 20 12 6 21 6 3", key: "1oa8hb" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OU = d("Plug2", [
  ["path", { d: "M9 2v6", key: "17ngun" }],
  ["path", { d: "M15 2v6", key: "s7yy2p" }],
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  ["path", { d: "M6 11V8h12v3a6 6 0 1 1-12 0Z", key: "wtfw2c" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EU = d("PlugZap2", [
  ["path", { d: "m13 2-2 2.5h3L12 7", key: "1me98u" }],
  ["path", { d: "M10 14v-3", key: "1mllf3" }],
  ["path", { d: "M14 14v-3", key: "1l3fkq" }],
  ["path", { d: "M11 19c-1.7 0-3-1.3-3-3v-2h8v2c0 1.7-1.3 3-3 3Z", key: "jd5pat" }],
  ["path", { d: "M12 22v-3", key: "kmzjlo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IU = d("PlugZap", [
  [
    "path",
    { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z", key: "goz73y" }
  ],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  ["path", { d: "m18 3-4 4h6l-4 4", key: "16psg9" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DU = d("Plug", [
  ["path", { d: "M12 22v-5", key: "1ega77" }],
  ["path", { d: "M9 8V2", key: "14iosj" }],
  ["path", { d: "M15 8V2", key: "18g5xt" }],
  ["path", { d: "M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z", key: "osxo6l" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TU = d("Plus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NU = d("PocketKnife", [
  ["path", { d: "M3 2v1c0 1 2 1 2 2S3 6 3 7s2 1 2 2-2 1-2 2 2 1 2 2", key: "19w3oe" }],
  ["path", { d: "M18 6h.01", key: "1v4wsw" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M20.83 8.83a4 4 0 0 0-5.66-5.66l-12 12a4 4 0 1 0 5.66 5.66Z", key: "6fykxj" }],
  ["path", { d: "M18 11.66V22a4 4 0 0 0 4-4V6", key: "1utzek" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PU = d("Pocket", [
  [
    "path",
    {
      d: "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z",
      key: "1mz881"
    }
  ],
  ["polyline", { points: "8 10 12 14 16 10", key: "w4mbv5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LU = d("Podcast", [
  ["path", { d: "M16.85 18.58a9 9 0 1 0-9.7 0", key: "d71mpg" }],
  ["path", { d: "M8 14a5 5 0 1 1 8 0", key: "fc81rn" }],
  ["circle", { cx: "12", cy: "11", r: "1", key: "1gvufo" }],
  ["path", { d: "M13 17a1 1 0 1 0-2 0l.5 4.5a.5.5 0 1 0 1 0Z", key: "za5kbj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RU = d("PointerOff", [
  ["path", { d: "M10 4.5V4a2 2 0 0 0-2.41-1.957", key: "jsi14n" }],
  ["path", { d: "M13.9 8.4a2 2 0 0 0-1.26-1.295", key: "hirc7f" }],
  [
    "path",
    { d: "M21.7 16.2A8 8 0 0 0 22 14v-3a2 2 0 1 0-4 0v-1a2 2 0 0 0-3.63-1.158", key: "1jxb2e" }
  ],
  [
    "path",
    {
      d: "m7 15-1.8-1.8a2 2 0 0 0-2.79 2.86L6 19.7a7.74 7.74 0 0 0 6 2.3h2a8 8 0 0 0 5.657-2.343",
      key: "10r7hm"
    }
  ],
  ["path", { d: "M6 6v8", key: "tv5xkp" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VU = d("Pointer", [
  ["path", { d: "M22 14a8 8 0 0 1-8 8", key: "56vcr3" }],
  ["path", { d: "M18 11v-1a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1agjmk" }],
  ["path", { d: "M14 10V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1", key: "wdbh2u" }],
  ["path", { d: "M10 9.5V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v10", key: "1ibuk9" }],
  [
    "path",
    {
      d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "g6ys72"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zU = d("Popcorn", [
  [
    "path",
    {
      d: "M18 8a2 2 0 0 0 0-4 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0 0 4",
      key: "10td1f"
    }
  ],
  ["path", { d: "M10 22 9 8", key: "yjptiv" }],
  ["path", { d: "m14 22 1-14", key: "8jwc8b" }],
  [
    "path",
    {
      d: "M20 8c.5 0 .9.4.8 1l-2.6 12c-.1.5-.7 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L3.2 9c-.1-.6.3-1 .8-1Z",
      key: "1qo33t"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BU = d("Popsicle", [
  [
    "path",
    {
      d: "M18.6 14.4c.8-.8.8-2 0-2.8l-8.1-8.1a4.95 4.95 0 1 0-7.1 7.1l8.1 8.1c.9.7 2.1.7 2.9-.1Z",
      key: "1o68ps"
    }
  ],
  ["path", { d: "m22 22-5.5-5.5", key: "17o70y" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HU = d("PoundSterling", [
  ["path", { d: "M18 7c0-5.333-8-5.333-8 0", key: "1prm2n" }],
  ["path", { d: "M10 7v14", key: "18tmcs" }],
  ["path", { d: "M6 21h12", key: "4dkmi1" }],
  ["path", { d: "M6 13h10", key: "ybwr4a" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $U = d("PowerOff", [
  ["path", { d: "M18.36 6.64A9 9 0 0 1 20.77 15", key: "dxknvb" }],
  ["path", { d: "M6.16 6.16a9 9 0 1 0 12.68 12.68", key: "1x7qb5" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jU = d("Power", [
  ["path", { d: "M12 2v10", key: "mnfbl" }],
  ["path", { d: "M18.4 6.6a9 9 0 1 1-12.77.04", key: "obofu9" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FU = d("Presentation", [
  ["path", { d: "M2 3h20", key: "91anmk" }],
  ["path", { d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3", key: "2k9sn8" }],
  ["path", { d: "m7 21 5-5 5 5", key: "bip4we" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WU = d("Printer", [
  [
    "path",
    {
      d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "143wyd"
    }
  ],
  ["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6", key: "1itne7" }],
  ["rect", { x: "6", y: "14", width: "12", height: "8", rx: "1", key: "1ue0tg" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qU = d("Projector", [
  ["path", { d: "M5 7 3 5", key: "1yys58" }],
  ["path", { d: "M9 6V3", key: "1ptz9u" }],
  ["path", { d: "m13 7 2-2", key: "1w3vmq" }],
  ["circle", { cx: "9", cy: "13", r: "3", key: "1mma13" }],
  [
    "path",
    {
      d: "M11.83 12H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.17",
      key: "2frwzc"
    }
  ],
  ["path", { d: "M16 16h2", key: "dnq2od" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _U = d("Proportions", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M12 9v11", key: "1fnkrn" }],
  ["path", { d: "M2 9h13a2 2 0 0 1 2 2v9", key: "11z3ex" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GU = d("Puzzle", [
  [
    "path",
    {
      d: "M19.439 7.85c-.049.322.059.648.289.878l1.568 1.568c.47.47.706 1.087.706 1.704s-.235 1.233-.706 1.704l-1.611 1.611a.98.98 0 0 1-.837.276c-.47-.07-.802-.48-.968-.925a2.501 2.501 0 1 0-3.214 3.214c.446.166.855.497.925.968a.979.979 0 0 1-.276.837l-1.61 1.61a2.404 2.404 0 0 1-1.705.707 2.402 2.402 0 0 1-1.704-.706l-1.568-1.568a1.026 1.026 0 0 0-.877-.29c-.493.074-.84.504-1.02.968a2.5 2.5 0 1 1-3.237-3.237c.464-.18.894-.527.967-1.02a1.026 1.026 0 0 0-.289-.877l-1.568-1.568A2.402 2.402 0 0 1 1.998 12c0-.617.236-1.234.706-1.704L4.23 8.77c.24-.24.581-.353.917-.303.515.077.877.528 1.073 1.01a2.5 2.5 0 1 0 3.259-3.259c-.482-.196-.933-.558-1.01-1.073-.05-.336.062-.676.303-.917l1.525-1.525A2.402 2.402 0 0 1 12 1.998c.617 0 1.234.236 1.704.706l1.568 1.568c.23.23.556.338.877.29.493-.074.84-.504 1.02-.968a2.5 2.5 0 1 1 3.237 3.237c-.464.18-.894.527-.967 1.02Z",
      key: "i0oyt7"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZU = d("Pyramid", [
  [
    "path",
    {
      d: "M2.5 16.88a1 1 0 0 1-.32-1.43l9-13.02a1 1 0 0 1 1.64 0l9 13.01a1 1 0 0 1-.32 1.44l-8.51 4.86a2 2 0 0 1-1.98 0Z",
      key: "aenxs0"
    }
  ],
  ["path", { d: "M12 2v20", key: "t6zp3m" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XU = d("QrCode", [
  ["rect", { width: "5", height: "5", x: "3", y: "3", rx: "1", key: "1tu5fj" }],
  ["rect", { width: "5", height: "5", x: "16", y: "3", rx: "1", key: "1v8r4q" }],
  ["rect", { width: "5", height: "5", x: "3", y: "16", rx: "1", key: "1x03jg" }],
  ["path", { d: "M21 16h-3a2 2 0 0 0-2 2v3", key: "177gqh" }],
  ["path", { d: "M21 21v.01", key: "ents32" }],
  ["path", { d: "M12 7v3a2 2 0 0 1-2 2H7", key: "8crl2c" }],
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M12 3h.01", key: "n36tog" }],
  ["path", { d: "M12 16v.01", key: "133mhm" }],
  ["path", { d: "M16 12h1", key: "1slzba" }],
  ["path", { d: "M21 12v.01", key: "1lwtk9" }],
  ["path", { d: "M12 21v-1", key: "1880an" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UU = d("Quote", [
  [
    "path",
    {
      d: "M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
      key: "rib7q0"
    }
  ],
  [
    "path",
    {
      d: "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
      key: "1ymkrd"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YU = d("Rabbit", [
  ["path", { d: "M13 16a3 3 0 0 1 2.24 5", key: "1epib5" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }],
  [
    "path",
    {
      d: "M18 21h-8a4 4 0 0 1-4-4 7 7 0 0 1 7-7h.2L9.6 6.4a1 1 0 1 1 2.8-2.8L15.8 7h.2c3.3 0 6 2.7 6 6v1a2 2 0 0 1-2 2h-1a3 3 0 0 0-3 3",
      key: "ue9ozu"
    }
  ],
  ["path", { d: "M20 8.54V4a2 2 0 1 0-4 0v3", key: "49iql8" }],
  ["path", { d: "M7.612 12.524a3 3 0 1 0-1.6 4.3", key: "1e33i0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JU = d("Radar", [
  ["path", { d: "M19.07 4.93A10 10 0 0 0 6.99 3.34", key: "z3du51" }],
  ["path", { d: "M4 6h.01", key: "oypzma" }],
  ["path", { d: "M2.29 9.62A10 10 0 1 0 21.31 8.35", key: "qzzz0" }],
  ["path", { d: "M16.24 7.76A6 6 0 1 0 8.23 16.67", key: "1yjesh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M17.99 11.66A6 6 0 0 1 15.77 16.67", key: "1u2y91" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "m13.41 10.59 5.66-5.66", key: "mhq4k0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KU = d("Radiation", [
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  [
    "path",
    {
      d: "M7.5 4.2c-.3-.5-.9-.7-1.3-.4C3.9 5.5 2.3 8.1 2 11c-.1.5.4 1 1 1h5c0-1.5.8-2.8 2-3.4-1.1-1.9-2-3.5-2.5-4.4z",
      key: "wy49g3"
    }
  ],
  [
    "path",
    {
      d: "M21 12c.6 0 1-.4 1-1-.3-2.9-1.8-5.5-4.1-7.1-.4-.3-1.1-.2-1.3.3-.6.9-1.5 2.5-2.6 4.3 1.2.7 2 2 2 3.5h5z",
      key: "vklnvr"
    }
  ],
  [
    "path",
    {
      d: "M7.5 19.8c-.3.5-.1 1.1.4 1.3 2.6 1.2 5.6 1.2 8.2 0 .5-.2.7-.8.4-1.3-.5-.9-1.4-2.5-2.5-4.3-1.2.7-2.8.7-4 0-1.1 1.8-2 3.4-2.5 4.3z",
      key: "wkdf1o"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QU = d("Radical", [
  [
    "path",
    {
      d: "M3 12h3.28a1 1 0 0 1 .948.684l2.298 7.934a.5.5 0 0 0 .96-.044L13.82 4.771A1 1 0 0 1 14.792 4H21",
      key: "1mqj8i"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eY = d("RadioReceiver", [
  ["path", { d: "M5 16v2", key: "g5qcv5" }],
  ["path", { d: "M19 16v2", key: "1gbaio" }],
  ["rect", { width: "20", height: "8", x: "2", y: "8", rx: "2", key: "vjsjur" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tY = d("RadioTower", [
  ["path", { d: "M4.9 16.1C1 12.2 1 5.8 4.9 1.9", key: "s0qx1y" }],
  ["path", { d: "M7.8 4.7a6.14 6.14 0 0 0-.8 7.5", key: "1idnkw" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }],
  ["path", { d: "M16.2 4.8c2 2 2.26 5.11.8 7.47", key: "ojru2q" }],
  ["path", { d: "M19.1 1.9a9.96 9.96 0 0 1 0 14.1", key: "rhi7fg" }],
  ["path", { d: "M9.5 18h5", key: "mfy3pd" }],
  ["path", { d: "m8 22 4-11 4 11", key: "25yftu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nY = d("Radio", [
  ["path", { d: "M4.9 19.1C1 15.2 1 8.8 4.9 4.9", key: "1vaf9d" }],
  ["path", { d: "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5", key: "u1ii0m" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5", key: "1j5fej" }],
  ["path", { d: "M19.1 4.9C23 8.8 23 15.1 19.1 19", key: "10b0cb" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rY = d("Radius", [
  ["path", { d: "M20.34 17.52a10 10 0 1 0-2.82 2.82", key: "fydyku" }],
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["path", { d: "m13.41 13.41 4.18 4.18", key: "1gqbwc" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aY = d("RailSymbol", [
  ["path", { d: "M5 15h14", key: "m0yey3" }],
  ["path", { d: "M5 9h14", key: "7tsvo6" }],
  ["path", { d: "m14 20-5-5 6-6-5-5", key: "1jo42i" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iY = d("Rainbow", [
  ["path", { d: "M22 17a10 10 0 0 0-20 0", key: "ozegv" }],
  ["path", { d: "M6 17a6 6 0 0 1 12 0", key: "5giftw" }],
  ["path", { d: "M10 17a2 2 0 0 1 4 0", key: "gnsikk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oY = d("Rat", [
  [
    "path",
    {
      d: "M17 5c0-1.7-1.3-3-3-3s-3 1.3-3 3c0 .8.3 1.5.8 2H11c-3.9 0-7 3.1-7 7c0 2.2 1.8 4 4 4",
      key: "1wq71c"
    }
  ],
  [
    "path",
    {
      d: "M16.8 3.9c.3-.3.6-.5 1-.7 1.5-.6 3.3.1 3.9 1.6.6 1.5-.1 3.3-1.6 3.9l1.6 2.8c.2.3.2.7.2 1-.2.8-.9 1.2-1.7 1.1 0 0-1.6-.3-2.7-.6H17c-1.7 0-3 1.3-3 3",
      key: "1crdmb"
    }
  ],
  ["path", { d: "M13.2 18a3 3 0 0 0-2.2-5", key: "1ol3lk" }],
  ["path", { d: "M13 22H4a2 2 0 0 1 0-4h12", key: "bt3f23" }],
  ["path", { d: "M16 9h.01", key: "1bdo4e" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sY = d("Ratio", [
  ["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }],
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cY = d("ReceiptCent", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M12 6.5v11", key: "ecfhkf" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lY = d("ReceiptEuro", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 12h5", key: "1g6qi8" }],
  ["path", { d: "M16 9.5a4 4 0 1 0 0 5.2", key: "b2px4r" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dY = d("ReceiptIndianRupee", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 7h8", key: "i86dvs" }],
  ["path", { d: "M12 17.5 8 15h1a4 4 0 0 0 0-8", key: "grpkl4" }],
  ["path", { d: "M8 11h8", key: "vwpz6n" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uY = d("ReceiptJapaneseYen", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "m12 10 3-3", key: "1mc12w" }],
  ["path", { d: "m9 7 3 3v7.5", key: "39i0xv" }],
  ["path", { d: "M9 11h6", key: "1fldmi" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hY = d("ReceiptPoundSterling", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 13h5", key: "1k9z8w" }],
  ["path", { d: "M10 17V9.5a2.5 2.5 0 0 1 5 0", key: "1dzgp0" }],
  ["path", { d: "M8 17h7", key: "8mjdqu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pY = d("ReceiptRussianRuble", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 15h5", key: "vxg57a" }],
  ["path", { d: "M8 11h5a2 2 0 1 0 0-4h-3v10", key: "1usi5u" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fY = d("ReceiptSwissFranc", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M10 17V7h5", key: "k7jq18" }],
  ["path", { d: "M10 11h4", key: "1i0mka" }],
  ["path", { d: "M8 15h5", key: "vxg57a" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yY = d("ReceiptText", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M14 8H8", key: "1l3xfs" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "M13 16H8", key: "wsln4y" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mY = d("Receipt", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 17.5v-11", key: "1jc1ny" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gY = d("RectangleEllipsis", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vY = d("RectangleHorizontal", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kY = d("RectangleVertical", [
  ["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bY = d("Recycle", [
  [
    "path",
    {
      d: "M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5",
      key: "x6z5xu"
    }
  ],
  [
    "path",
    {
      d: "M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12",
      key: "1x4zh5"
    }
  ],
  ["path", { d: "m14 16-3 3 3 3", key: "f6jyew" }],
  ["path", { d: "M8.293 13.596 7.196 9.5 3.1 10.598", key: "wf1obh" }],
  [
    "path",
    {
      d: "m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843",
      key: "9tzpgr"
    }
  ],
  ["path", { d: "m13.378 9.633 4.096 1.098 1.097-4.096", key: "1oe83g" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xY = d("Redo2", [
  ["path", { d: "m15 14 5-5-5-5", key: "12vg1m" }],
  ["path", { d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13", key: "6uklza" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MY = d("RedoDot", [
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }],
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wY = d("Redo", [
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CY = d("RefreshCcwDot", [
  ["path", { d: "M3 2v6h6", key: "18ldww" }],
  ["path", { d: "M21 12A9 9 0 0 0 6 5.3L3 8", key: "1pbrqz" }],
  ["path", { d: "M21 22v-6h-6", key: "usdfbe" }],
  ["path", { d: "M3 12a9 9 0 0 0 15 6.7l3-2.7", key: "1hosoe" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SY = d("RefreshCcw", [
  ["path", { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "14sxne" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16", key: "1hlbsb" }],
  ["path", { d: "M16 16h5v5", key: "ccwih5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AY = d("RefreshCwOff", [
  ["path", { d: "M21 8L18.74 5.74A9.75 9.75 0 0 0 12 3C11 3 10.03 3.16 9.13 3.47", key: "1krf6h" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }],
  ["path", { d: "M3 12C3 9.51 4 7.26 5.64 5.64", key: "ruvoct" }],
  ["path", { d: "m3 16 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64", key: "19q130" }],
  ["path", { d: "M21 12c0 1-.16 1.97-.47 2.87", key: "4w8emr" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OY = d("RefreshCw", [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EY = d("Refrigerator", [
  [
    "path",
    { d: "M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z", key: "fpq118" }
  ],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M15 7v6", key: "1nx30x" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IY = d("Regex", [
  ["path", { d: "M17 3v10", key: "15fgeh" }],
  ["path", { d: "m12.67 5.5 8.66 5", key: "1gpheq" }],
  ["path", { d: "m12.67 10.5 8.66-5", key: "1dkfa6" }],
  [
    "path",
    { d: "M9 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2z", key: "swwfx4" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DY = d("RemoveFormatting", [
  ["path", { d: "M4 7V4h16v3", key: "9msm58" }],
  ["path", { d: "M5 20h6", key: "1h6pxn" }],
  ["path", { d: "M13 4 8 20", key: "kqq6aj" }],
  ["path", { d: "m15 15 5 5", key: "me55sn" }],
  ["path", { d: "m20 15-5 5", key: "11p7ol" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TY = d("Repeat1", [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }],
  ["path", { d: "M11 10h1v4", key: "70cz1p" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NY = d("Repeat2", [
  ["path", { d: "m2 9 3-3 3 3", key: "1ltn5i" }],
  ["path", { d: "M13 18H7a2 2 0 0 1-2-2V6", key: "1r6tfw" }],
  ["path", { d: "m22 15-3 3-3-3", key: "4rnwn2" }],
  ["path", { d: "M11 6h6a2 2 0 0 1 2 2v10", key: "2f72bc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PY = d("Repeat", [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LY = d("ReplaceAll", [
  ["path", { d: "M14 4c0-1.1.9-2 2-2", key: "1mvvbw" }],
  ["path", { d: "M20 2c1.1 0 2 .9 2 2", key: "1mj6oe" }],
  ["path", { d: "M22 8c0 1.1-.9 2-2 2", key: "v1wql3" }],
  ["path", { d: "M16 10c-1.1 0-2-.9-2-2", key: "821ux0" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5c0-1.7 1.3-3 3-3h1", key: "13af7h" }],
  ["rect", { width: "8", height: "8", x: "2", y: "14", rx: "2", key: "17ihk4" }],
  ["path", { d: "M14 14c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2", key: "1w9p8c" }],
  ["path", { d: "M20 14c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2", key: "m45eaa" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RY = d("Replace", [
  ["path", { d: "M14 4c0-1.1.9-2 2-2", key: "1mvvbw" }],
  ["path", { d: "M20 2c1.1 0 2 .9 2 2", key: "1mj6oe" }],
  ["path", { d: "M22 8c0 1.1-.9 2-2 2", key: "v1wql3" }],
  ["path", { d: "M16 10c-1.1 0-2-.9-2-2", key: "821ux0" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5c0-1.7 1.3-3 3-3h1", key: "13af7h" }],
  ["rect", { width: "8", height: "8", x: "2", y: "14", rx: "2", key: "17ihk4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VY = d("ReplyAll", [
  ["polyline", { points: "7 17 2 12 7 7", key: "t83bqg" }],
  ["polyline", { points: "12 17 7 12 12 7", key: "1g4ajm" }],
  ["path", { d: "M22 18v-2a4 4 0 0 0-4-4H7", key: "1fcyog" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zY = d("Reply", [
  ["polyline", { points: "9 17 4 12 9 7", key: "hvgpf2" }],
  ["path", { d: "M20 18v-2a4 4 0 0 0-4-4H4", key: "5vmcpk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BY = d("Rewind", [
  ["polygon", { points: "11 19 2 12 11 5 11 19", key: "14yba5" }],
  ["polygon", { points: "22 19 13 12 22 5 22 19", key: "1pi1cj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HY = d("Ribbon", [
  [
    "path",
    {
      d: "M17.75 9.01c-.52 2.08-1.83 3.64-3.18 5.49l-2.6 3.54-2.97 4-3.5-2.54 3.85-4.97c-1.86-2.61-2.8-3.77-3.16-5.44",
      key: "1njedg"
    }
  ],
  [
    "path",
    {
      d: "M17.75 9.01A7 7 0 0 0 6.2 9.1C6.06 8.5 6 7.82 6 7c0-3.5 2.83-5 5.98-5C15.24 2 18 3.5 18 7c0 .73-.09 1.4-.25 2.01Z",
      key: "10len7"
    }
  ],
  ["path", { d: "m9.35 14.53 2.64-3.31", key: "1wfi09" }],
  ["path", { d: "m11.97 18.04 2.99 4 3.54-2.54-3.93-5", key: "1ezyge" }],
  ["path", { d: "M14 8c0 1-1 2-2.01 3.22C11 10 10 9 10 8a2 2 0 1 1 4 0", key: "aw0zq5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $Y = d("Rocket", [
  [
    "path",
    {
      d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
      key: "m3kijz"
    }
  ],
  [
    "path",
    {
      d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
      key: "1fmvmk"
    }
  ],
  ["path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0", key: "1f8sc4" }],
  ["path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5", key: "qeys4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jY = d("RockingChair", [
  ["polyline", { points: "3.5 2 6.5 12.5 18 12.5", key: "y3iy52" }],
  ["line", { x1: "9.5", x2: "5.5", y1: "12.5", y2: "20", key: "19vg5i" }],
  ["line", { x1: "15", x2: "18.5", y1: "12.5", y2: "20", key: "1inpmv" }],
  ["path", { d: "M2.75 18a13 13 0 0 0 18.5 0", key: "1nquas" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FY = d("RollerCoaster", [
  ["path", { d: "M6 19V5", key: "1r845m" }],
  ["path", { d: "M10 19V6.8", key: "9j2tfs" }],
  ["path", { d: "M14 19v-7.8", key: "10s8qv" }],
  ["path", { d: "M18 5v4", key: "1tajlv" }],
  ["path", { d: "M18 19v-6", key: "ielfq3" }],
  ["path", { d: "M22 19V9", key: "158nzp" }],
  ["path", { d: "M2 19V9a4 4 0 0 1 4-4c2 0 4 1.33 6 4s4 4 6 4a4 4 0 1 0-3-6.65", key: "1930oh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WY = d("Rotate3d", [
  [
    "path",
    {
      d: "M16.466 7.5C15.643 4.237 13.952 2 12 2 9.239 2 7 6.477 7 12s2.239 10 5 10c.342 0 .677-.069 1-.2",
      key: "10n0gc"
    }
  ],
  ["path", { d: "m15.194 13.707 3.814 1.86-1.86 3.814", key: "16shm9" }],
  [
    "path",
    {
      d: "M19 15.57c-1.804.885-4.274 1.43-7 1.43-5.523 0-10-2.239-10-5s4.477-5 10-5c4.838 0 8.873 1.718 9.8 4",
      key: "1lxi77"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qY = d("RotateCcwSquare", [
  ["path", { d: "M20 9V7a2 2 0 0 0-2-2h-6", key: "19z8uc" }],
  ["path", { d: "m15 2-3 3 3 3", key: "177bxs" }],
  ["path", { d: "M20 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2", key: "d36hnl" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Y = d("RotateCcw", [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GY = d("RotateCwSquare", [
  ["path", { d: "M12 5H6a2 2 0 0 0-2 2v3", key: "l96uqu" }],
  ["path", { d: "m9 8 3-3-3-3", key: "1gzgc3" }],
  ["path", { d: "M4 14v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", key: "1w2k5h" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZY = d("RotateCw", [
  ["path", { d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8", key: "1p45f6" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XY = d("RouteOff", [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5c.4 0 .9-.1 1.3-.2", key: "1effex" }],
  ["path", { d: "M5.2 5.2A3.5 3.53 0 0 0 6.5 12H12", key: "k9y2ds" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M21 15.3a3.5 3.5 0 0 0-3.3-3.3", key: "11nlu2" }],
  ["path", { d: "M15 5h-4.3", key: "6537je" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UY = d("Route", [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15", key: "1d8sl" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YY = d("Router", [
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6.01 18H6", key: "19vcac" }],
  ["path", { d: "M10.01 18H10", key: "uamcmx" }],
  ["path", { d: "M15 10v4", key: "qjz1xs" }],
  ["path", { d: "M17.84 7.17a4 4 0 0 0-5.66 0", key: "1rif40" }],
  ["path", { d: "M20.66 4.34a8 8 0 0 0-11.31 0", key: "6a5xfq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JY = d("Rows2", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KY = d("Rows3", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QY = d("Rows4", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 7.5H3", key: "1hm9pq" }],
  ["path", { d: "M21 12H3", key: "2avoz0" }],
  ["path", { d: "M21 16.5H3", key: "n7jzkj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eJ = d("Rss", [
  ["path", { d: "M4 11a9 9 0 0 1 9 9", key: "pv89mb" }],
  ["path", { d: "M4 4a16 16 0 0 1 16 16", key: "k0647b" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tJ = d("Ruler", [
  [
    "path",
    {
      d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z",
      key: "icamh8"
    }
  ],
  ["path", { d: "m14.5 12.5 2-2", key: "inckbg" }],
  ["path", { d: "m11.5 9.5 2-2", key: "fmmyf7" }],
  ["path", { d: "m8.5 6.5 2-2", key: "vc6u1g" }],
  ["path", { d: "m17.5 15.5 2-2", key: "wo5hmg" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nJ = d("RussianRuble", [
  ["path", { d: "M6 11h8a4 4 0 0 0 0-8H9v18", key: "18ai8t" }],
  ["path", { d: "M6 15h8", key: "1y8f6l" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rJ = d("Sailboat", [
  ["path", { d: "M22 18H2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z", key: "1404fh" }],
  ["path", { d: "M21 14 10 2 3 14h18Z", key: "1nzg7v" }],
  ["path", { d: "M10 2v16", key: "1labyt" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aJ = d("Salad", [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  [
    "path",
    {
      d: "M11.38 12a2.4 2.4 0 0 1-.4-4.77 2.4 2.4 0 0 1 3.2-2.77 2.4 2.4 0 0 1 3.47-.63 2.4 2.4 0 0 1 3.37 3.37 2.4 2.4 0 0 1-1.1 3.7 2.51 2.51 0 0 1 .03 1.1",
      key: "10xrj0"
    }
  ],
  ["path", { d: "m13 12 4-4", key: "1hckqy" }],
  ["path", { d: "M10.9 7.25A3.99 3.99 0 0 0 4 10c0 .73.2 1.41.54 2", key: "1p4srx" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iJ = d("Sandwich", [
  ["path", { d: "M3 11v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3", key: "34v9d7" }],
  [
    "path",
    {
      d: "M12 19H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3.83",
      key: "1k5vfb"
    }
  ],
  ["path", { d: "m3 11 7.77-6.04a2 2 0 0 1 2.46 0L21 11H3Z", key: "1oe7l6" }],
  ["path", { d: "M12.97 19.77 7 15h12.5l-3.75 4.5a2 2 0 0 1-2.78.27Z", key: "1ts2ri" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oJ = d("SatelliteDish", [
  ["path", { d: "M4 10a7.31 7.31 0 0 0 10 10Z", key: "1fzpp3" }],
  ["path", { d: "m9 15 3-3", key: "88sc13" }],
  ["path", { d: "M17 13a6 6 0 0 0-6-6", key: "15cc6u" }],
  ["path", { d: "M21 13A10 10 0 0 0 11 3", key: "11nf8s" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sJ = d("Satellite", [
  ["path", { d: "M13 7 9 3 5 7l4 4", key: "vyckw6" }],
  ["path", { d: "m17 11 4 4-4 4-4-4", key: "rchckc" }],
  ["path", { d: "m8 12 4 4 6-6-4-4Z", key: "1sshf7" }],
  ["path", { d: "m16 8 3-3", key: "x428zp" }],
  ["path", { d: "M9 21a6 6 0 0 0-6-6", key: "1iajcf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cJ = d("SaveAll", [
  ["path", { d: "M10 2v3a1 1 0 0 0 1 1h5", key: "1xspal" }],
  ["path", { d: "M18 18v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6", key: "1ra60u" }],
  ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }],
  [
    "path",
    {
      d: "M8 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9.172a2 2 0 0 1 1.414.586l2.828 2.828A2 2 0 0 1 22 6.828V16a2 2 0 0 1-2.01 2z",
      key: "1yve0x"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lJ = d("Save", [
  [
    "path",
    {
      d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
      key: "1c8476"
    }
  ],
  ["path", { d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7", key: "1ydtos" }],
  ["path", { d: "M7 3v4a1 1 0 0 0 1 1h7", key: "t51u73" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dJ = d("Scale3d", [
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }],
  ["path", { d: "M5 7v12h12", key: "vtaa4r" }],
  ["path", { d: "m5 19 6-6", key: "jh6hbb" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uJ = d("Scale", [
  ["path", { d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "7g6ntu" }],
  ["path", { d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "ijws7r" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2", key: "3gwbw2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hJ = d("Scaling", [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  ["path", { d: "M14 15H9v-5", key: "pi4jk9" }],
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M21 3 9 15", key: "15kdhq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pJ = d("ScanBarcode", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 7v10", key: "23sfjj" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M17 7v10", key: "578dap" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fJ = d("ScanEye", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["path", { d: "M5 12s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5", key: "nhuolu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yJ = d("ScanFace", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mJ = d("ScanLine", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gJ = d("ScanSearch", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m16 16-1.9-1.9", key: "1dq9hf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vJ = d("ScanText", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 8h8", key: "1jbsf9" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h6", key: "1vyc9m" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kJ = d("Scan", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bJ = d("ScatterChart", [
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }],
  ["circle", { cx: "18.5", cy: "5.5", r: ".5", fill: "currentColor", key: "lysivs" }],
  ["circle", { cx: "11.5", cy: "11.5", r: ".5", fill: "currentColor", key: "byv1b8" }],
  ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" }],
  ["circle", { cx: "17.5", cy: "14.5", r: ".5", fill: "currentColor", key: "1gjh6j" }],
  ["path", { d: "M3 3v18h18", key: "1s2lah" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xJ = d("School", [
  ["path", { d: "M14 22v-4a2 2 0 1 0-4 0v4", key: "hhkicm" }],
  ["path", { d: "m18 10 4 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8l4-2", key: "1vwozw" }],
  ["path", { d: "M18 5v17", key: "1sw6gf" }],
  ["path", { d: "m4 6 8-4 8 4", key: "1q0ilc" }],
  ["path", { d: "M6 5v17", key: "1xfsm0" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MJ = d("ScissorsLineDashed", [
  ["path", { d: "M5.42 9.42 8 12", key: "12pkuq" }],
  ["circle", { cx: "4", cy: "8", r: "2", key: "107mxr" }],
  ["path", { d: "m14 6-8.58 8.58", key: "gvzu5l" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "M10.8 14.8 14 18", key: "ax7m9r" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wJ = d("Scissors", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M8.12 8.12 12 12", key: "1alkpv" }],
  ["path", { d: "M20 4 8.12 15.88", key: "xgtan2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M14.8 14.8 20 20", key: "ptml3r" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CJ = d("ScreenShareOff", [
  ["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3", key: "i8wdob" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m22 3-5 5", key: "12jva0" }],
  ["path", { d: "m17 3 5 5", key: "k36vhe" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SJ = d("ScreenShare", [
  ["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3", key: "i8wdob" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m17 8 5-5", key: "fqif7o" }],
  ["path", { d: "M17 3h5v5", key: "1o3tu8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AJ = d("ScrollText", [
  ["path", { d: "M15 12h-5", key: "r7krc0" }],
  ["path", { d: "M15 8h-5", key: "1khuty" }],
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  [
    "path",
    {
      d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
      key: "1ph1d7"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OJ = d("Scroll", [
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  [
    "path",
    {
      d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
      key: "1ph1d7"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EJ = d("SearchCheck", [
  ["path", { d: "m8 11 2 2 4-4", key: "1sed1v" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IJ = d("SearchCode", [
  ["path", { d: "m13 13.5 2-2.5-2-2.5", key: "1rvxrh" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ["path", { d: "M9 8.5 7 11l2 2.5", key: "6ffwbx" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DJ = d("SearchSlash", [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TJ = d("SearchX", [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["path", { d: "m8.5 8.5 5 5", key: "a8mexj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NJ = d("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PJ = d("Section", [
  ["path", { d: "M16 5a4 3 0 0 0-8 0c0 4 8 3 8 7a4 3 0 0 1-8 0", key: "vqan6v" }],
  ["path", { d: "M8 19a4 3 0 0 0 8 0c0-4-8-3-8-7a4 3 0 0 1 8 0", key: "wdjd8o" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LJ = d("SendHorizontal", [
  ["path", { d: "m3 3 3 9-3 9 19-9Z", key: "1aobqy" }],
  ["path", { d: "M6 12h16", key: "s4cdu5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RJ = d("SendToBack", [
  ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }],
  ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }],
  ["path", { d: "M7 14v1a2 2 0 0 0 2 2h1", key: "pao6x6" }],
  ["path", { d: "M14 7h1a2 2 0 0 1 2 2v1", key: "19tdru" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VJ = d("Send", [
  ["path", { d: "m22 2-7 20-4-9-9-4Z", key: "1q3vgg" }],
  ["path", { d: "M22 2 11 13", key: "nzbqef" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zJ = d("SeparatorHorizontal", [
  ["line", { x1: "3", x2: "21", y1: "12", y2: "12", key: "10d38w" }],
  ["polyline", { points: "8 8 12 4 16 8", key: "zo8t4w" }],
  ["polyline", { points: "16 16 12 20 8 16", key: "1oyrid" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BJ = d("SeparatorVertical", [
  ["line", { x1: "12", x2: "12", y1: "3", y2: "21", key: "1efggb" }],
  ["polyline", { points: "8 8 4 12 8 16", key: "bnfmv4" }],
  ["polyline", { points: "16 16 20 12 16 8", key: "u90052" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HJ = d("ServerCog", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M4.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-.5",
      key: "tn8das"
    }
  ],
  [
    "path",
    {
      d: "M4.5 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.5",
      key: "1g2pve"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m15.7 13.4-.9-.3", key: "1jwmzr" }],
  ["path", { d: "m9.2 10.9-.9-.3", key: "qapnim" }],
  ["path", { d: "m10.6 15.7.3-.9", key: "quwk0k" }],
  ["path", { d: "m13.6 15.7-.4-1", key: "cb9xp7" }],
  ["path", { d: "m10.8 9.3-.4-1", key: "1uaiz5" }],
  ["path", { d: "m8.3 13.6 1-.4", key: "s6srou" }],
  ["path", { d: "m14.7 10.8 1-.4", key: "4d31cq" }],
  ["path", { d: "m13.4 8.3-.3.9", key: "1bm987" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $J = d("ServerCrash", [
  [
    "path",
    {
      d: "M6 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2",
      key: "4b9dqc"
    }
  ],
  [
    "path",
    {
      d: "M6 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2",
      key: "22nnkd"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m13 6-4 6h6l-4 6", key: "14hqih" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jJ = d("ServerOff", [
  ["path", { d: "M7 2h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5", key: "bt2siv" }],
  ["path", { d: "M10 10 2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 0 0 2 2h6z", key: "1hjrv1" }],
  ["path", { d: "M22 17v-1a2 2 0 0 0-2-2h-1", key: "1iynyr" }],
  ["path", { d: "M4 14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16.5l1-.5.5.5-8-8H4z", key: "161ggg" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FJ = d("Server", [
  ["rect", { width: "20", height: "8", x: "2", y: "2", rx: "2", ry: "2", key: "ngkwjq" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", ry: "2", key: "iecqi9" }],
  ["line", { x1: "6", x2: "6.01", y1: "6", y2: "6", key: "16zg32" }],
  ["line", { x1: "6", x2: "6.01", y1: "18", y2: "18", key: "nzw8ys" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WJ = d("Settings2", [
  ["path", { d: "M20 7h-9", key: "3s1dr2" }],
  ["path", { d: "M14 17H5", key: "gfn3mx" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["circle", { cx: "7", cy: "7", r: "3", key: "dfmy0x" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qJ = d("Settings", [
  [
    "path",
    {
      d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
      key: "1qme2f"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _J = d("Shapes", [
  [
    "path",
    {
      d: "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z",
      key: "1bo67w"
    }
  ],
  ["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1", key: "1bkyp8" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "3.5", key: "w3z12y" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GJ = d("Share2", [
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
  ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
  ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
  ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
  ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZJ = d("Share", [
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["polyline", { points: "16 6 12 2 8 6", key: "m901s6" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "15", key: "1p0rca" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XJ = d("Sheet", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["line", { x1: "3", x2: "21", y1: "9", y2: "9", key: "1vqk6q" }],
  ["line", { x1: "3", x2: "21", y1: "15", y2: "15", key: "o2sbyz" }],
  ["line", { x1: "9", x2: "9", y1: "9", y2: "21", key: "1ib60c" }],
  ["line", { x1: "15", x2: "15", y1: "9", y2: "21", key: "1n26ft" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UJ = d("Shell", [
  [
    "path",
    {
      d: "M14 11a2 2 0 1 1-4 0 4 4 0 0 1 8 0 6 6 0 0 1-12 0 8 8 0 0 1 16 0 10 10 0 1 1-20 0 11.93 11.93 0 0 1 2.42-7.22 2 2 0 1 1 3.16 2.44",
      key: "1cn552"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YJ = d("ShieldAlert", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JJ = d("ShieldBan", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m4.243 5.21 14.39 12.472", key: "1c9a7c" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KJ = d("ShieldCheck", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QJ = d("ShieldEllipsis", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eK = d("ShieldHalf", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 22V2", key: "zs6s6o" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tK = d("ShieldMinus", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nK = d("ShieldOff", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71",
      key: "1jlk70"
    }
  ],
  [
    "path",
    {
      d: "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264",
      key: "18rp1v"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rK = d("ShieldPlus", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M12 9v6", key: "199k2o" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aK = d("ShieldQuestion", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iK = d("ShieldX", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
  ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oK = d("Shield", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sK = d("ShipWheel", [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["path", { d: "M12 2v7.5", key: "1e5rl5" }],
  ["path", { d: "m19 5-5.23 5.23", key: "1ezxxf" }],
  ["path", { d: "M22 12h-7.5", key: "le1719" }],
  ["path", { d: "m19 19-5.23-5.23", key: "p3fmgn" }],
  ["path", { d: "M12 14.5V22", key: "dgcmos" }],
  ["path", { d: "M10.23 13.77 5 19", key: "qwopd4" }],
  ["path", { d: "M9.5 12H2", key: "r7bup8" }],
  ["path", { d: "M10.23 10.23 5 5", key: "k2y7lj" }],
  ["circle", { cx: "12", cy: "12", r: "2.5", key: "ix0uyj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cK = d("Ship", [
  [
    "path",
    {
      d: "M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1 .6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "iegodh"
    }
  ],
  [
    "path",
    { d: "M19.38 20A11.6 11.6 0 0 0 21 14l-9-4-9 4c0 2.9.94 5.34 2.81 7.76", key: "fp8vka" }
  ],
  ["path", { d: "M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6", key: "qpkstq" }],
  ["path", { d: "M12 10v4", key: "1kjpxc" }],
  ["path", { d: "M12 2v3", key: "qbqxhf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lK = d("Shirt", [
  [
    "path",
    {
      d: "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z",
      key: "1wgbhj"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dK = d("ShoppingBag", [
  ["path", { d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z", key: "hou9p0" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M16 10a4 4 0 0 1-8 0", key: "1ltviw" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uK = d("ShoppingBasket", [
  ["path", { d: "m15 11-1 9", key: "5wnq3a" }],
  ["path", { d: "m19 11-4-7", key: "cnml18" }],
  ["path", { d: "M2 11h20", key: "3eubbj" }],
  ["path", { d: "m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4", key: "yiazzp" }],
  ["path", { d: "M4.5 15.5h15", key: "13mye1" }],
  ["path", { d: "m5 11 4-7", key: "116ra9" }],
  ["path", { d: "m9 11 1 9", key: "1ojof7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hK = d("ShoppingCart", [
  ["circle", { cx: "8", cy: "21", r: "1", key: "jimo8o" }],
  ["circle", { cx: "19", cy: "21", r: "1", key: "13723u" }],
  [
    "path",
    {
      d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
      key: "9zh506"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pK = d("Shovel", [
  ["path", { d: "M2 22v-5l5-5 5 5-5 5z", key: "1fh25c" }],
  ["path", { d: "M9.5 14.5 16 8", key: "1smz5x" }],
  [
    "path",
    { d: "m17 2 5 5-.5.5a3.53 3.53 0 0 1-5 0s0 0 0 0a3.53 3.53 0 0 1 0-5L17 2", key: "1q8uv5" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fK = d("ShowerHead", [
  ["path", { d: "m4 4 2.5 2.5", key: "uv2vmf" }],
  ["path", { d: "M13.5 6.5a4.95 4.95 0 0 0-7 7", key: "frdkwv" }],
  ["path", { d: "M15 5 5 15", key: "1ag8rq" }],
  ["path", { d: "M14 17v.01", key: "eokfpp" }],
  ["path", { d: "M10 16v.01", key: "14uyyl" }],
  ["path", { d: "M13 13v.01", key: "1v1k97" }],
  ["path", { d: "M16 10v.01", key: "5169yg" }],
  ["path", { d: "M11 20v.01", key: "cj92p8" }],
  ["path", { d: "M17 14v.01", key: "11cswd" }],
  ["path", { d: "M20 11v.01", key: "19e0od" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yK = d("Shrink", [
  ["path", { d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8", key: "17vawe" }],
  ["path", { d: "M9 19.8V15m0 0H4.2M9 15l-6 6", key: "chjx8e" }],
  ["path", { d: "M15 4.2V9m0 0h4.8M15 9l6-6", key: "lav6yq" }],
  ["path", { d: "M9 4.2V9m0 0H4.2M9 9 3 3", key: "1pxi2q" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mK = d("Shrub", [
  ["path", { d: "M12 22v-7l-2-2", key: "eqv9mc" }],
  ["path", { d: "M17 8v.8A6 6 0 0 1 13.8 20H10A6.5 6.5 0 0 1 7 8a5 5 0 0 1 10 0Z", key: "ubcgy" }],
  ["path", { d: "m14 14-2 2", key: "847xa2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gK = d("Shuffle", [
  ["path", { d: "M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.1-8.6c.7-1.1 2-1.7 3.3-1.7H22", key: "1wmou1" }],
  ["path", { d: "m18 2 4 4-4 4", key: "pucp1d" }],
  ["path", { d: "M2 6h1.9c1.5 0 2.9.9 3.6 2.2", key: "10bdb2" }],
  ["path", { d: "M22 18h-5.9c-1.3 0-2.6-.7-3.3-1.8l-.5-.8", key: "vgxac0" }],
  ["path", { d: "m18 14 4 4-4 4", key: "10pe0f" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vK = d("Sigma", [
  [
    "path",
    {
      d: "M18 7V5a1 1 0 0 0-1-1H6.5a.5.5 0 0 0-.4.8l4.5 6a2 2 0 0 1 0 2.4l-4.5 6a.5.5 0 0 0 .4.8H17a1 1 0 0 0 1-1v-2",
      key: "wuwx1p"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kK = d("SignalHigh", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bK = d("SignalLow", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xK = d("SignalMedium", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MK = d("SignalZero", [["path", { d: "M2 20h.01", key: "4haj6o" }]]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wK = d("Signal", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }],
  ["path", { d: "M22 4v16", key: "sih9yq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CK = d("SignpostBig", [
  ["path", { d: "M10 9H4L2 7l2-2h6", key: "1hq7x2" }],
  ["path", { d: "M14 5h6l2 2-2 2h-6", key: "bv62ej" }],
  ["path", { d: "M10 22V4a2 2 0 1 1 4 0v18", key: "eqpcf2" }],
  ["path", { d: "M8 22h8", key: "rmew8v" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SK = d("Signpost", [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M12 3v3", key: "1n5kay" }],
  [
    "path",
    {
      d: "M18 6a2 2 0 0 1 1.414.586l2.293 2.207a1 1 0 0 1 0 1.414l-2.27 2.184a2 2 0 0 1-1.742.586L6 13a2 2 0 0 1-1.414-.586l-2.293-2.207a1 1 0 0 1 0-1.414l2.293-2.207A2 2 0 0 1 6 6z",
      key: "rb0lus"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AK = d("Siren", [
  ["path", { d: "M7 18v-6a5 5 0 1 1 10 0v6", key: "pcx96s" }],
  [
    "path",
    { d: "M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z", key: "1b4s83" }
  ],
  ["path", { d: "M21 12h1", key: "jtio3y" }],
  ["path", { d: "M18.5 4.5 18 5", key: "g5sp9y" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "m4.929 4.929.707.707", key: "1i51kw" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OK = d("SkipBack", [
  ["polygon", { points: "19 20 9 12 19 4 19 20", key: "o2sva" }],
  ["line", { x1: "5", x2: "5", y1: "19", y2: "5", key: "1ocqjk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EK = d("SkipForward", [
  ["polygon", { points: "5 4 15 12 5 20 5 4", key: "16p6eg" }],
  ["line", { x1: "19", x2: "19", y1: "5", y2: "19", key: "futhcm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IK = d("Skull", [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["path", { d: "M8 20v2h8v-2", key: "ded4og" }],
  ["path", { d: "m12.5 17-.5-1-.5 1h1z", key: "3me087" }],
  ["path", { d: "M16 20a2 2 0 0 0 1.56-3.25 8 8 0 1 0-11.12 0A2 2 0 0 0 8 20", key: "xq9p5u" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DK = d("Slack", [
  ["rect", { width: "3", height: "8", x: "13", y: "2", rx: "1.5", key: "diqz80" }],
  ["path", { d: "M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5", key: "183iwg" }],
  ["rect", { width: "3", height: "8", x: "8", y: "14", rx: "1.5", key: "hqg7r1" }],
  ["path", { d: "M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5", key: "76g71w" }],
  ["rect", { width: "8", height: "3", x: "14", y: "13", rx: "1.5", key: "1kmz0a" }],
  ["path", { d: "M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5", key: "jc4sz0" }],
  ["rect", { width: "8", height: "3", x: "2", y: "8", rx: "1.5", key: "1omvl4" }],
  ["path", { d: "M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5", key: "16f3cl" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TK = d("Slash", [["path", { d: "M22 2 2 22", key: "y4kqgn" }]]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NK = d("Slice", [
  ["path", { d: "m8 14-6 6h9v-3", key: "zo3j9a" }],
  ["path", { d: "M18.37 3.63 8 14l3 3L21.37 6.63a2.12 2.12 0 1 0-3-3Z", key: "1dzx0j" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PK = d("SlidersHorizontal", [
  ["line", { x1: "21", x2: "14", y1: "4", y2: "4", key: "obuewd" }],
  ["line", { x1: "10", x2: "3", y1: "4", y2: "4", key: "1q6298" }],
  ["line", { x1: "21", x2: "12", y1: "12", y2: "12", key: "1iu8h1" }],
  ["line", { x1: "8", x2: "3", y1: "12", y2: "12", key: "ntss68" }],
  ["line", { x1: "21", x2: "16", y1: "20", y2: "20", key: "14d8ph" }],
  ["line", { x1: "12", x2: "3", y1: "20", y2: "20", key: "m0wm8r" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "6", key: "14e1ph" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "16", x2: "16", y1: "18", y2: "22", key: "1lctlv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LK = d("SlidersVertical", [
  ["line", { x1: "4", x2: "4", y1: "21", y2: "14", key: "1p332r" }],
  ["line", { x1: "4", x2: "4", y1: "10", y2: "3", key: "gb41h5" }],
  ["line", { x1: "12", x2: "12", y1: "21", y2: "12", key: "hf2csr" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "3", key: "1kfi7u" }],
  ["line", { x1: "20", x2: "20", y1: "21", y2: "16", key: "1lhrwl" }],
  ["line", { x1: "20", x2: "20", y1: "12", y2: "3", key: "16vvfq" }],
  ["line", { x1: "2", x2: "6", y1: "14", y2: "14", key: "1uebub" }],
  ["line", { x1: "10", x2: "14", y1: "8", y2: "8", key: "1yglbp" }],
  ["line", { x1: "18", x2: "22", y1: "16", y2: "16", key: "1jxqpz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RK = d("SmartphoneCharging", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12.667 8 10 12h4l-2.667 4", key: "h9lk2d" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VK = d("SmartphoneNfc", [
  ["rect", { width: "7", height: "12", x: "2", y: "6", rx: "1", key: "5nje8w" }],
  ["path", { d: "M13 8.32a7.43 7.43 0 0 1 0 7.36", key: "1g306n" }],
  ["path", { d: "M16.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "uqvjvo" }],
  ["path", { d: "M19.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "ujntz3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zK = d("Smartphone", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BK = d("SmilePlus", [
  ["path", { d: "M22 11v1a10 10 0 1 1-9-10", key: "ew0xw9" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }],
  ["path", { d: "M16 5h6", key: "1vod17" }],
  ["path", { d: "M19 2v6", key: "4bpg5p" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HK = d("Smile", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $K = d("Snail", [
  ["path", { d: "M2 13a6 6 0 1 0 12 0 4 4 0 1 0-8 0 2 2 0 0 0 4 0", key: "hneq2s" }],
  ["circle", { cx: "10", cy: "13", r: "8", key: "194lz3" }],
  ["path", { d: "M2 21h12c4.4 0 8-3.6 8-8V7a2 2 0 1 0-4 0v6", key: "ixqyt7" }],
  ["path", { d: "M18 3 19.1 5.2", key: "9tjm43" }],
  ["path", { d: "M22 3 20.9 5.2", key: "j3odrs" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jK = d("Snowflake", [
  ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
  ["path", { d: "m20 16-4-4 4-4", key: "rquw4f" }],
  ["path", { d: "m4 8 4 4-4 4", key: "12s3z9" }],
  ["path", { d: "m16 4-4 4-4-4", key: "1tumq1" }],
  ["path", { d: "m8 20 4-4 4 4", key: "9p200w" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FK = d("Sofa", [
  ["path", { d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3", key: "1dgpiv" }],
  [
    "path",
    {
      d: "M2 11v5a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H6v-2a2 2 0 0 0-4 0Z",
      key: "u5qfb7"
    }
  ],
  ["path", { d: "M4 18v2", key: "jwo5n2" }],
  ["path", { d: "M20 18v2", key: "1ar1qi" }],
  ["path", { d: "M12 4v9", key: "oqhhn3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WK = d("Soup", [
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M19.5 12 22 6", key: "shfsr5" }],
  [
    "path",
    {
      d: "M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62",
      key: "rpc6vp"
    }
  ],
  [
    "path",
    {
      d: "M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62",
      key: "1lf63m"
    }
  ],
  [
    "path",
    { d: "M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62", key: "97tijn" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qK = d("Space", [
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _K = d("Spade", [
  [
    "path",
    {
      d: "M5 9c-1.5 1.5-3 3.2-3 5.5A5.5 5.5 0 0 0 7.5 20c1.8 0 3-.5 4.5-2 1.5 1.5 2.7 2 4.5 2a5.5 5.5 0 0 0 5.5-5.5c0-2.3-1.5-4-3-5.5l-7-7-7 7Z",
      key: "40bo9n"
    }
  ],
  ["path", { d: "M12 18v4", key: "jadmvz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GK = d("Sparkle", [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZK = d("Sparkles", [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }],
  ["path", { d: "M4 17v2", key: "vumght" }],
  ["path", { d: "M5 18H3", key: "zchphs" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XK = d("Speaker", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["circle", { cx: "12", cy: "14", r: "4", key: "1jruaj" }],
  ["path", { d: "M12 14h.01", key: "1etili" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UK = d("Speech", [
  [
    "path",
    {
      d: "M8.8 20v-4.1l1.9.2a2.3 2.3 0 0 0 2.164-2.1V8.3A5.37 5.37 0 0 0 2 8.25c0 2.8.656 3.054 1 4.55a5.77 5.77 0 0 1 .029 2.758L2 20",
      key: "11atix"
    }
  ],
  ["path", { d: "M19.8 17.8a7.5 7.5 0 0 0 .003-10.603", key: "yol142" }],
  ["path", { d: "M17 15a3.5 3.5 0 0 0-.025-4.975", key: "ssbmkc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YK = d("SpellCheck2", [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  [
    "path",
    {
      d: "M4 21c1.1 0 1.1-1 2.3-1s1.1 1 2.3 1c1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1",
      key: "8mdmtu"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JK = d("SpellCheck", [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KK = d("Spline", [
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M5 17A12 12 0 0 1 17 5", key: "1okkup" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QK = d("Split", [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M8 3H3v5", key: "15dfkv" }],
  ["path", { d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3", key: "1qrqzj" }],
  ["path", { d: "m15 9 6-6", key: "ko1vev" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eQ = d("SprayCan", [
  ["path", { d: "M3 3h.01", key: "159qn6" }],
  ["path", { d: "M7 5h.01", key: "1hq22a" }],
  ["path", { d: "M11 7h.01", key: "1osv80" }],
  ["path", { d: "M3 7h.01", key: "1xzrh3" }],
  ["path", { d: "M7 9h.01", key: "19b3jx" }],
  ["path", { d: "M3 11h.01", key: "1eifu7" }],
  ["rect", { width: "4", height: "4", x: "15", y: "5", key: "mri9e4" }],
  ["path", { d: "m19 9 2 2v10c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V11l2-2", key: "aib6hk" }],
  ["path", { d: "m13 14 8-2", key: "1d7bmk" }],
  ["path", { d: "m13 19 8-2", key: "1y2vml" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tQ = d("Sprout", [
  ["path", { d: "M7 20h10", key: "e6iznv" }],
  ["path", { d: "M10 20c5.5-2.5.8-6.4 3-10", key: "161w41" }],
  [
    "path",
    {
      d: "M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z",
      key: "9gtqwd"
    }
  ],
  [
    "path",
    {
      d: "M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z",
      key: "bkxnd2"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nQ = d("SquareActivity", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M17 12h-2l-2 5-2-10-2 5H7", key: "15hlnc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rQ = d("SquareArrowDownLeft", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 8-8 8", key: "166keh" }],
  ["path", { d: "M16 16H8V8", key: "1w2ppm" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aQ = d("SquareArrowDownRight", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "M16 8v8H8", key: "1lbpgo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iQ = d("SquareArrowDown", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oQ = d("SquareArrowLeft", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sQ = d("SquareArrowOutDownLeft", [
  ["path", { d: "M13 21h6a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6", key: "14qz4y" }],
  ["path", { d: "m3 21 9-9", key: "1jfql5" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cQ = d("SquareArrowOutDownRight", [
  ["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "14rsvq" }],
  ["path", { d: "m21 21-9-9", key: "1et2py" }],
  ["path", { d: "M21 15v6h-6", key: "1jko0i" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lQ = d("SquareArrowOutUpLeft", [
  ["path", { d: "M13 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6", key: "14mv1t" }],
  ["path", { d: "m3 3 9 9", key: "rks13r" }],
  ["path", { d: "M3 9V3h6", key: "ira0h2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dQ = d("SquareArrowOutUpRight", [
  ["path", { d: "M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6", key: "y09zxi" }],
  ["path", { d: "m21 3-9 9", key: "mpx6sq" }],
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uQ = d("SquareArrowRight", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hQ = d("SquareArrowUpLeft", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 16V8h8", key: "19xb1h" }],
  ["path", { d: "M16 16 8 8", key: "1qdy8n" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pQ = d("SquareArrowUpRight", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 8h8v8", key: "b65dnt" }],
  ["path", { d: "m8 16 8-8", key: "13b9ih" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fQ = d("SquareArrowUp", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yQ = d("SquareAsterisk", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8.5 14 7-4", key: "12hpby" }],
  ["path", { d: "m8.5 10 7 4", key: "wwy2dy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mQ = d("SquareBottomDashedScissors", [
  [
    "path",
    { d: "M4 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2", key: "1vzg26" }
  ],
  ["path", { d: "M10 22H8", key: "euku7a" }],
  ["path", { d: "M16 22h-2", key: "18d249" }],
  ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
  ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
  ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
  ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
  ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gQ = d("SquareCheckBig", [
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }],
  ["path", { d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11", key: "1jnkn4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vQ = d("SquareCheck", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kQ = d("SquareChevronDown", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bQ = d("SquareChevronLeft", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xQ = d("SquareChevronRight", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MQ = d("SquareChevronUp", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wQ = d("SquareCode", [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CQ = d("SquareDashedBottomCode", [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  [
    "path",
    { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2", key: "as5y1o" }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SQ = d("SquareDashedBottom", [
  [
    "path",
    { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2", key: "as5y1o" }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AQ = d("SquareDashedKanban", [
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OQ = d("SquareDashedMousePointer", [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "m12 12 4 10 1.7-4.3L22 16Z", key: "64ilsv" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h2", key: "1qve2z" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v2", key: "p14lih" }],
  ["path", { d: "M3 14v1", key: "vnatye" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EQ = d("SquareDivide", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IQ = d("SquareDot", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DQ = d("SquareEqual", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TQ = d("SquareFunction", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M9 17c2 0 2.8-1 2.8-2.8V10c0-2 1-3.3 3.2-3", key: "m1af9g" }],
  ["path", { d: "M9 11.2h5.7", key: "3zgcl2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NQ = d("SquareGanttChart", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 8h7", key: "kbo1nt" }],
  ["path", { d: "M8 12h6", key: "ikassy" }],
  ["path", { d: "M11 16h5", key: "oq65wt" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PQ = d("SquareKanban", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LQ = d("SquareLibrary", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7v10", key: "d5nglc" }],
  ["path", { d: "M11 7v10", key: "pptsnr" }],
  ["path", { d: "m15 7 2 10", key: "1m7qm5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RQ = d("SquareM", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 16V8l4 4 4-4v8", key: "141u4e" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VQ = d("SquareMenu", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 8h10", key: "1jw688" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h10", key: "wp8him" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zQ = d("SquareMinus", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BQ = d("SquareMousePointer", [
  ["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "14rsvq" }],
  ["path", { d: "m12 12 4 10 1.7-4.3L22 16Z", key: "64ilsv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HQ = d("SquareParkingOff", [
  ["path", { d: "M3.6 3.6A2 2 0 0 1 5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-.59 1.41", key: "9l1ft6" }],
  ["path", { d: "M3 8.7V19a2 2 0 0 0 2 2h10.3", key: "17knke" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.3", key: "1jxgo2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $Q = d("SquareParking", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jQ = d("SquarePen", [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  [
    "path",
    {
      d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
      key: "ohrbg2"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FQ = d("SquarePercent", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WQ = d("SquarePi", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7h10", key: "udp07y" }],
  ["path", { d: "M10 7v10", key: "i1d9ee" }],
  ["path", { d: "M16 17a2 2 0 0 1-2-2V7", key: "ftwdc7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qQ = d("SquarePilcrow", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 12H9.5a2.5 2.5 0 0 1 0-5H17", key: "1l9586" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M16 7v10", key: "lavkr4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Q = d("SquarePlay", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m9 8 6 4-6 4Z", key: "f1r3lt" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GQ = d("SquarePlus", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZQ = d("SquarePower", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 7v5", key: "ma6bk" }],
  ["path", { d: "M8 9a5.14 5.14 0 0 0 4 8 4.95 4.95 0 0 0 4-8", key: "15eubv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XQ = d("SquareRadical", [
  ["path", { d: "M7 12h2l2 5 2-10h4", key: "1fxv6h" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UQ = d("SquareScissors", [
  ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "2", key: "1btzen" }],
  ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
  ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
  ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
  ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
  ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YQ = d("SquareSigma", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M16 8.9V7H8l4 5-4 5h8v-1.9", key: "9nih0i" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JQ = d("SquareSlash", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KQ = d("SquareSplitHorizontal", [
  ["path", { d: "M8 19H5c-1 0-2-1-2-2V7c0-1 1-2 2-2h3", key: "lubmu8" }],
  ["path", { d: "M16 5h3c1 0 2 1 2 2v10c0 1-1 2-2 2h-3", key: "1ag34g" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QQ = d("SquareSplitVertical", [
  ["path", { d: "M5 8V5c0-1 1-2 2-2h10c1 0 2 1 2 2v3", key: "1pi83i" }],
  ["path", { d: "M19 16v3c0 1-1 2-2 2H7c-1 0-2-1-2-2v-3", key: "ido5k7" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eee = d("SquareStack", [
  ["path", { d: "M4 10c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2", key: "4i38lg" }],
  ["path", { d: "M10 16c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2", key: "mlte4a" }],
  ["rect", { width: "8", height: "8", x: "14", y: "14", rx: "2", key: "1fa9i4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tee = d("SquareTerminal", [
  ["path", { d: "m7 11 2-2-2-2", key: "1lz0vl" }],
  ["path", { d: "M11 13h4", key: "1p7l4v" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nee = d("SquareUserRound", [
  ["path", { d: "M18 21a6 6 0 0 0-12 0", key: "kaz2du" }],
  ["circle", { cx: "12", cy: "11", r: "4", key: "1gt34v" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ree = d("SquareUser", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2", key: "1m6ac2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aee = d("SquareX", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iee = d("Square", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oee = d("Squircle", [
  ["path", { d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9-9 9-9-1.8-9-9 1.8-9 9-9", key: "garfkc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const see = d("Squirrel", [
  ["path", { d: "M15.236 22a3 3 0 0 0-2.2-5", key: "21bitc" }],
  ["path", { d: "M16 20a3 3 0 0 1 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4", key: "oh0fg0" }],
  ["path", { d: "M18 13h.01", key: "9veqaj" }],
  [
    "path",
    {
      d: "M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 1 0-9 0 2.5 2.5 0 0 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10",
      key: "980v8a"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cee = d("Stamp", [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  [
    "path",
    {
      d: "M19.27 13.73A2.5 2.5 0 0 0 17.5 13h-11A2.5 2.5 0 0 0 4 15.5V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.5c0-.66-.26-1.3-.73-1.77Z",
      key: "1sy9ra"
    }
  ],
  [
    "path",
    { d: "M14 13V8.5C14 7 15 7 15 5a3 3 0 0 0-3-3c-1.66 0-3 1-3 3s1 2 1 3.5V13", key: "cnxgux" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lee = d("StarHalf", [
  ["path", { d: "M12 17.8 5.8 21 7 14.1 2 9.3l7-1L12 2", key: "nare05" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dee = d("StarOff", [
  ["path", { d: "M8.34 8.34 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-.59-3.43", key: "16m0ql" }],
  ["path", { d: "M18.42 12.76 22 9.27l-6.91-1L12 2l-1.44 2.91", key: "1vt8nq" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uee = d("Star", [
  [
    "polygon",
    {
      points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2",
      key: "8f66p6"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hee = d("StepBack", [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["polygon", { points: "14,20 4,12 14,4", key: "ypakod" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pee = d("StepForward", [
  ["line", { x1: "6", x2: "6", y1: "4", y2: "20", key: "fy8qot" }],
  ["polygon", { points: "10,4 20,12 10,20", key: "1mc1pf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fee = d("Stethoscope", [
  [
    "path",
    {
      d: "M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3",
      key: "10lez9"
    }
  ],
  ["path", { d: "M8 15v1a6 6 0 0 0 6 6a6 6 0 0 0 6-6v-4", key: "ce9bce" }],
  ["circle", { cx: "20", cy: "10", r: "2", key: "ts1r5v" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yee = d("Sticker", [
  [
    "path",
    { d: "M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z", key: "1wis1t" }
  ],
  ["path", { d: "M14 3v4a2 2 0 0 0 2 2h4", key: "36rjfy" }],
  ["path", { d: "M8 13h.01", key: "1sbv64" }],
  ["path", { d: "M16 13h.01", key: "wip0gl" }],
  ["path", { d: "M10 16s.8 1 2 1c1.3 0 2-1 2-1", key: "1vvgv3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mee = d("StickyNote", [
  ["path", { d: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z", key: "qazsjp" }],
  ["path", { d: "M15 3v4a2 2 0 0 0 2 2h4", key: "40519r" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gee = d("Store", [
  ["path", { d: "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7", key: "ztvudi" }],
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["path", { d: "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4", key: "2ebpfo" }],
  ["path", { d: "M2 7h20", key: "1fcdvo" }],
  [
    "path",
    {
      d: "M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7",
      key: "6c3vgh"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vee = d("StretchHorizontal", [
  ["rect", { width: "20", height: "6", x: "2", y: "4", rx: "2", key: "qdearl" }],
  ["rect", { width: "20", height: "6", x: "2", y: "14", rx: "2", key: "1xrn6j" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kee = d("StretchVertical", [
  ["rect", { width: "6", height: "20", x: "4", y: "2", rx: "2", key: "19qu7m" }],
  ["rect", { width: "6", height: "20", x: "14", y: "2", rx: "2", key: "24v0nk" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bee = d("Strikethrough", [
  ["path", { d: "M16 4H9a3 3 0 0 0-2.83 4", key: "43sutm" }],
  ["path", { d: "M14 12a4 4 0 0 1 0 8H6", key: "nlfj13" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xee = d("Subscript", [
  ["path", { d: "m4 5 8 8", key: "1eunvl" }],
  ["path", { d: "m12 5-8 8", key: "1ah0jp" }],
  [
    "path",
    {
      d: "M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07",
      key: "e8ta8j"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mee = d("SunDim", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 4h.01", key: "1ujb9j" }],
  ["path", { d: "M20 12h.01", key: "1ykeid" }],
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M4 12h.01", key: "158zrr" }],
  ["path", { d: "M17.657 6.343h.01", key: "31pqzk" }],
  ["path", { d: "M17.657 17.657h.01", key: "jehnf4" }],
  ["path", { d: "M6.343 17.657h.01", key: "gdk6ow" }],
  ["path", { d: "M6.343 6.343h.01", key: "1uurf0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wee = d("SunMedium", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 3v1", key: "1asbbs" }],
  ["path", { d: "M12 20v1", key: "1wcdkc" }],
  ["path", { d: "M3 12h1", key: "lp3yf2" }],
  ["path", { d: "M20 12h1", key: "1vloll" }],
  ["path", { d: "m18.364 5.636-.707.707", key: "1hakh0" }],
  ["path", { d: "m6.343 17.657-.707.707", key: "18m9nf" }],
  ["path", { d: "m5.636 5.636.707.707", key: "1xv1c5" }],
  ["path", { d: "m17.657 17.657.707.707", key: "vl76zb" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cee = d("SunMoon", [
  ["path", { d: "M12 8a2.83 2.83 0 0 0 4 4 4 4 0 1 1-4-4", key: "1fu5g2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.9 4.9 1.4 1.4", key: "b9915j" }],
  ["path", { d: "m17.7 17.7 1.4 1.4", key: "qc3ed3" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.3 17.7-1.4 1.4", key: "5gca6" }],
  ["path", { d: "m19.1 4.9-1.4 1.4", key: "wpu9u6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const See = d("SunSnow", [
  ["path", { d: "M10 9a3 3 0 1 0 0 6", key: "6zmtdl" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "M14 21V3", key: "1llu3z" }],
  ["path", { d: "M10 4V3", key: "pkzwkn" }],
  ["path", { d: "M10 21v-1", key: "1u8rkd" }],
  ["path", { d: "m3.64 18.36.7-.7", key: "105rm9" }],
  ["path", { d: "m4.34 6.34-.7-.7", key: "d3unjp" }],
  ["path", { d: "M14 12h8", key: "4f43i9" }],
  ["path", { d: "m17 4-3 3", key: "15jcng" }],
  ["path", { d: "m14 17 3 3", key: "6tlq38" }],
  ["path", { d: "m21 15-3-3 3-3", key: "1nlnje" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aee = d("Sun", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oee = d("Sunrise", [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eee = d("Sunset", [
  ["path", { d: "M12 10V2", key: "16sf7g" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iee = d("Superscript", [
  ["path", { d: "m4 19 8-8", key: "hr47gm" }],
  ["path", { d: "m12 19-8-8", key: "1dhhmo" }],
  [
    "path",
    {
      d: "M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 0 0-2.617-.436c-.42.239-.738.614-.899 1.06",
      key: "1dfcux"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dee = d("SwatchBook", [
  ["path", { d: "M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z", key: "1ldrpk" }],
  ["path", { d: "M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7", key: "11i5po" }],
  ["path", { d: "M 7 17h.01", key: "1euzgo" }],
  [
    "path",
    {
      d: "m11 8 2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8",
      key: "o2gii7"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tee = d("SwissFranc", [
  ["path", { d: "M10 21V3h8", key: "br2l0g" }],
  ["path", { d: "M6 16h9", key: "2py0wn" }],
  ["path", { d: "M10 9.5h7", key: "13dmhz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nee = d("SwitchCamera", [
  ["path", { d: "M11 19H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5", key: "mtk2lu" }],
  ["path", { d: "M13 5h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5", key: "120jsl" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m18 22-3-3 3-3", key: "kgdoj7" }],
  ["path", { d: "m6 2 3 3-3 3", key: "1fnbkv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pee = d("Sword", [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lee = d("Swords", [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }],
  ["polyline", { points: "14.5 6.5 18 3 21 3 21 6 17.5 9.5", key: "hbey2j" }],
  ["line", { x1: "5", x2: "9", y1: "14", y2: "18", key: "1hf58s" }],
  ["line", { x1: "7", x2: "4", y1: "17", y2: "20", key: "pidxm4" }],
  ["line", { x1: "3", x2: "5", y1: "19", y2: "21", key: "1pehsh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ree = d("Syringe", [
  ["path", { d: "m18 2 4 4", key: "22kx64" }],
  ["path", { d: "m17 7 3-3", key: "1w1zoj" }],
  ["path", { d: "M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5", key: "1exhtz" }],
  ["path", { d: "m9 11 4 4", key: "rovt3i" }],
  ["path", { d: "m5 19-3 3", key: "59f2uf" }],
  ["path", { d: "m14 4 6 6", key: "yqp9t2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vee = d("Table2", [
  [
    "path",
    {
      d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18",
      key: "gugj83"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zee = d("TableCellsMerge", [
  ["path", { d: "M12 21v-6", key: "lihzve" }],
  ["path", { d: "M12 9V3", key: "da5inc" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bee = d("TableCellsSplit", [
  ["path", { d: "M12 15V9", key: "8c7uyn" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hee = d("TableColumnsSplit", [
  ["path", { d: "M14 14v2", key: "w2a1xv" }],
  ["path", { d: "M14 20v2", key: "1lq872" }],
  ["path", { d: "M14 2v2", key: "6buw04" }],
  ["path", { d: "M14 8v2", key: "i67w9a" }],
  ["path", { d: "M2 15h8", key: "82wtch" }],
  ["path", { d: "M2 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2", key: "up0l64" }],
  ["path", { d: "M2 9h8", key: "yelfik" }],
  ["path", { d: "M22 15h-4", key: "1es58f" }],
  ["path", { d: "M22 3h-2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2", key: "pdjoqf" }],
  ["path", { d: "M22 9h-4", key: "1luja7" }],
  ["path", { d: "M5 3v18", key: "14hmio" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $ee = d("TableProperties", [
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jee = d("TableRowsSplit", [
  ["path", { d: "M14 10h2", key: "1lstlu" }],
  ["path", { d: "M15 22v-8", key: "1fwwgm" }],
  ["path", { d: "M15 2v4", key: "1044rn" }],
  ["path", { d: "M2 10h2", key: "1r8dkt" }],
  ["path", { d: "M20 10h2", key: "1ug425" }],
  ["path", { d: "M3 19h18", key: "awlh7x" }],
  ["path", { d: "M3 22v-6a2 2 135 0 1 2-2h14a2 2 45 0 1 2 2v6", key: "ibqhof" }],
  ["path", { d: "M3 2v2a2 2 45 0 0 2 2h14a2 2 135 0 0 2-2V2", key: "1uenja" }],
  ["path", { d: "M8 10h2", key: "66od0" }],
  ["path", { d: "M9 22v-8", key: "fmnu31" }],
  ["path", { d: "M9 2v4", key: "j1yeou" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fee = d("Table", [
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wee = d("TabletSmartphone", [
  ["rect", { width: "10", height: "14", x: "3", y: "8", rx: "2", key: "1vrsiq" }],
  ["path", { d: "M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4", key: "1j4zmg" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qee = d("Tablet", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2", key: "76otgf" }],
  ["line", { x1: "12", x2: "12.01", y1: "18", y2: "18", key: "1dp563" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ee = d("Tablets", [
  ["circle", { cx: "7", cy: "7", r: "5", key: "x29byf" }],
  ["circle", { cx: "17", cy: "17", r: "5", key: "1op1d2" }],
  ["path", { d: "M12 17h10", key: "ls21zv" }],
  ["path", { d: "m3.46 10.54 7.08-7.08", key: "1rehiu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gee = d("Tag", [
  [
    "path",
    {
      d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
      key: "vktsd0"
    }
  ],
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zee = d("Tags", [
  ["path", { d: "m15 5 6.3 6.3a2.4 2.4 0 0 1 0 3.4L17 19", key: "1cbfv1" }],
  [
    "path",
    {
      d: "M9.586 5.586A2 2 0 0 0 8.172 5H3a1 1 0 0 0-1 1v5.172a2 2 0 0 0 .586 1.414L8.29 18.29a2.426 2.426 0 0 0 3.42 0l3.58-3.58a2.426 2.426 0 0 0 0-3.42z",
      key: "135mg7"
    }
  ],
  ["circle", { cx: "6.5", cy: "9.5", r: ".5", fill: "currentColor", key: "5pm5xn" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xee = d("Tally1", [["path", { d: "M4 4v16", key: "6qkkli" }]]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uee = d("Tally2", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yee = d("Tally3", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jee = d("Tally4", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kee = d("Tally5", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }],
  ["path", { d: "M22 6 2 18", key: "h9moai" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qee = d("Tangent", [
  ["circle", { cx: "17", cy: "4", r: "2", key: "y5j2s2" }],
  ["path", { d: "M15.59 5.41 5.41 15.59", key: "l0vprr" }],
  ["circle", { cx: "4", cy: "17", r: "2", key: "9p4efm" }],
  ["path", { d: "M12 22s-4-9-1.5-11.5S22 12 22 12", key: "1twk4o" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ete = d("Target", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tte = d("Telescope", [
  [
    "path",
    {
      d: "m10.065 12.493-6.18 1.318a.934.934 0 0 1-1.108-.702l-.537-2.15a1.07 1.07 0 0 1 .691-1.265l13.504-4.44",
      key: "k4qptu"
    }
  ],
  ["path", { d: "m13.56 11.747 4.332-.924", key: "19l80z" }],
  ["path", { d: "m16 21-3.105-6.21", key: "7oh9d" }],
  [
    "path",
    {
      d: "M16.485 5.94a2 2 0 0 1 1.455-2.425l1.09-.272a1 1 0 0 1 1.212.727l1.515 6.06a1 1 0 0 1-.727 1.213l-1.09.272a2 2 0 0 1-2.425-1.455z",
      key: "m7xp4m"
    }
  ],
  ["path", { d: "m6.158 8.633 1.114 4.456", key: "74o979" }],
  ["path", { d: "m8 21 3.105-6.21", key: "1fvxut" }],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nte = d("TentTree", [
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }],
  ["path", { d: "m14 5 3-3 3 3", key: "1sorif" }],
  ["path", { d: "m14 10 3-3 3 3", key: "1jyi9h" }],
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  ["path", { d: "M17 14H7l-5 8h20Z", key: "13ar7p" }],
  ["path", { d: "M8 14v8", key: "1ghmqk" }],
  ["path", { d: "m9 14 5 8", key: "13pgi6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rte = d("Tent", [
  ["path", { d: "M3.5 21 14 3", key: "1szst5" }],
  ["path", { d: "M20.5 21 10 3", key: "1310c3" }],
  ["path", { d: "M15.5 21 12 15l-3.5 6", key: "1ddtfw" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ate = d("Terminal", [
  ["polyline", { points: "4 17 10 11 4 5", key: "akl6gq" }],
  ["line", { x1: "12", x2: "20", y1: "19", y2: "19", key: "q2wloq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ite = d("TestTubeDiagonal", [
  [
    "path",
    { d: "M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01a2.83 2.83 0 0 1 0-4L17 3", key: "1ub6xw" }
  ],
  ["path", { d: "m16 2 6 6", key: "1gw87d" }],
  ["path", { d: "M12 16H4", key: "1cjfip" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ote = d("TestTube", [
  ["path", { d: "M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5c-1.4 0-2.5-1.1-2.5-2.5V2", key: "125lnx" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M14.5 16h-5", key: "1ox875" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ste = d("TestTubes", [
  ["path", { d: "M9 2v17.5A2.5 2.5 0 0 1 6.5 22A2.5 2.5 0 0 1 4 19.5V2", key: "1hjrqt" }],
  ["path", { d: "M20 2v17.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5V2", key: "16lc8n" }],
  ["path", { d: "M3 2h7", key: "7s29d5" }],
  ["path", { d: "M14 2h7", key: "7sicin" }],
  ["path", { d: "M9 16H4", key: "1bfye3" }],
  ["path", { d: "M20 16h-5", key: "ddnjpe" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cte = d("TextCursorInput", [
  ["path", { d: "M5 4h1a3 3 0 0 1 3 3 3 3 0 0 1 3-3h1", key: "18xjzo" }],
  ["path", { d: "M13 20h-1a3 3 0 0 1-3-3 3 3 0 0 1-3 3H5", key: "fj48gi" }],
  ["path", { d: "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1", key: "1n9rhb" }],
  ["path", { d: "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7", key: "13ksps" }],
  ["path", { d: "M9 7v10", key: "1vc8ob" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lte = d("TextCursor", [
  ["path", { d: "M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1", key: "uvaxm9" }],
  ["path", { d: "M7 22h1a4 4 0 0 0 4-4v-1", key: "11xy8d" }],
  ["path", { d: "M7 2h1a4 4 0 0 1 4 4v1", key: "1uw06m" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dte = d("TextQuote", [
  ["path", { d: "M17 6H3", key: "16j9eg" }],
  ["path", { d: "M21 12H8", key: "scolzb" }],
  ["path", { d: "M21 18H8", key: "1wfozv" }],
  ["path", { d: "M3 12v6", key: "fv4c87" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ute = d("TextSearch", [
  ["path", { d: "M21 6H3", key: "1jwq7v" }],
  ["path", { d: "M10 12H3", key: "1ulcyk" }],
  ["path", { d: "M10 18H3", key: "13769t" }],
  ["circle", { cx: "17", cy: "15", r: "3", key: "1upz2a" }],
  ["path", { d: "m21 19-1.9-1.9", key: "dwi7p8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hte = d("TextSelect", [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["line", { x1: "7", x2: "15", y1: "8", y2: "8", key: "1758g8" }],
  ["line", { x1: "7", x2: "17", y1: "12", y2: "12", key: "197423" }],
  ["line", { x1: "7", x2: "13", y1: "16", y2: "16", key: "37cgm6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pte = d("Text", [
  ["path", { d: "M17 6.1H3", key: "wptmhv" }],
  ["path", { d: "M21 12.1H3", key: "1j38uz" }],
  ["path", { d: "M15.1 18H3", key: "1nb16a" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fte = d("Theater", [
  ["path", { d: "M2 10s3-3 3-8", key: "3xiif0" }],
  ["path", { d: "M22 10s-3-3-3-8", key: "ioaa5q" }],
  ["path", { d: "M10 2c0 4.4-3.6 8-8 8", key: "16fkpi" }],
  ["path", { d: "M14 2c0 4.4 3.6 8 8 8", key: "b9eulq" }],
  ["path", { d: "M2 10s2 2 2 5", key: "1au1lb" }],
  ["path", { d: "M22 10s-2 2-2 5", key: "qi2y5e" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M2 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "1vsc2m" }],
  ["path", { d: "M14 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "hrha4u" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yte = d("ThermometerSnowflake", [
  ["path", { d: "M2 12h10", key: "19562f" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "m3 9 3 3-3 3", key: "1sas0l" }],
  ["path", { d: "M12 6 9 9 6 6", key: "pfrgxu" }],
  ["path", { d: "m6 18 3-3 1.5 1.5", key: "1e277p" }],
  ["path", { d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "iof6y5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mte = d("ThermometerSun", [
  ["path", { d: "M12 9a4 4 0 0 0-2 7.5", key: "1jvsq6" }],
  ["path", { d: "M12 3v2", key: "1w22ol" }],
  ["path", { d: "m6.6 18.4-1.4 1.4", key: "w2yidj" }],
  ["path", { d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "iof6y5" }],
  ["path", { d: "M4 13H2", key: "118le4" }],
  ["path", { d: "M6.34 7.34 4.93 5.93", key: "1brd51" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gte = d("Thermometer", [
  ["path", { d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "17jzev" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vte = d("ThumbsDown", [
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  [
    "path",
    {
      d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
      key: "m61m77"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kte = d("ThumbsUp", [
  ["path", { d: "M7 10v12", key: "1qc93n" }],
  [
    "path",
    {
      d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
      key: "emmmcr"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bte = d("TicketCheck", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xte = d("TicketMinus", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mte = d("TicketPercent", [
  [
    "path",
    {
      d: "M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "1l48ns"
    }
  ],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wte = d("TicketPlus", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M12 9v6", key: "199k2o" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cte = d("TicketSlash", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ste = d("TicketX", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }],
  ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ate = d("Ticket", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M13 5v2", key: "dyzc3o" }],
  ["path", { d: "M13 17v2", key: "1ont0d" }],
  ["path", { d: "M13 11v2", key: "1wjjxi" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ote = d("TimerOff", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M4.6 11a8 8 0 0 0 1.7 8.7 8 8 0 0 0 8.7 1.7", key: "10he05" }],
  ["path", { d: "M7.4 7.4a8 8 0 0 1 10.3 1 8 8 0 0 1 .9 10.2", key: "15f7sh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M12 12v-2", key: "fwoke6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ete = d("TimerReset", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M12 14v-4", key: "1evpnu" }],
  ["path", { d: "M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6", key: "1ts96g" }],
  ["path", { d: "M9 17H4v5", key: "8t5av" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ite = d("Timer", [
  ["line", { x1: "10", x2: "14", y1: "2", y2: "2", key: "14vaq8" }],
  ["line", { x1: "12", x2: "15", y1: "14", y2: "11", key: "17fdiu" }],
  ["circle", { cx: "12", cy: "14", r: "8", key: "1e1u0o" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dte = d("ToggleLeft", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "8", cy: "12", r: "2", key: "1nvbw3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tte = d("ToggleRight", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "16", cy: "12", r: "2", key: "4ma0v8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nte = d("Tornado", [
  ["path", { d: "M21 4H3", key: "1hwok0" }],
  ["path", { d: "M18 8H6", key: "41n648" }],
  ["path", { d: "M19 12H9", key: "1g4lpz" }],
  ["path", { d: "M16 16h-6", key: "1j5d54" }],
  ["path", { d: "M11 20H9", key: "39obr8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pte = d("Torus", [
  ["ellipse", { cx: "12", cy: "11", rx: "3", ry: "2", key: "1b2qxu" }],
  ["ellipse", { cx: "12", cy: "12.5", rx: "10", ry: "8.5", key: "h8emeu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lte = d("TouchpadOff", [
  ["path", { d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16", key: "lnt0bk" }],
  ["path", { d: "M2 14h12", key: "d8icqz" }],
  ["path", { d: "M22 14h-2", key: "jrx26d" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M22 16V6a2 2 0 0 0-2-2H10", key: "11y8e4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rte = d("Touchpad", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vte = d("TowerControl", [
  [
    "path",
    { d: "M18.2 12.27 20 6H4l1.8 6.27a1 1 0 0 0 .95.73h10.5a1 1 0 0 0 .96-.73Z", key: "1pledb" }
  ],
  ["path", { d: "M8 13v9", key: "hmv0ci" }],
  ["path", { d: "M16 22v-9", key: "ylnf1u" }],
  ["path", { d: "m9 6 1 7", key: "dpdgam" }],
  ["path", { d: "m15 6-1 7", key: "ls7zgu" }],
  ["path", { d: "M12 6V2", key: "1pj48d" }],
  ["path", { d: "M13 2h-2", key: "mj6ths" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zte = d("ToyBrick", [
  ["rect", { width: "18", height: "12", x: "3", y: "8", rx: "1", key: "158fvp" }],
  ["path", { d: "M10 8V5c0-.6-.4-1-1-1H6a1 1 0 0 0-1 1v3", key: "s0042v" }],
  ["path", { d: "M19 8V5c0-.6-.4-1-1-1h-3a1 1 0 0 0-1 1v3", key: "9wmeh2" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bte = d("Tractor", [
  ["path", { d: "m10 11 11 .9a1 1 0 0 1 .8 1.1l-.665 4.158a1 1 0 0 1-.988.842H20", key: "she1j9" }],
  ["path", { d: "M16 18h-5", key: "bq60fd" }],
  ["path", { d: "M18 5a1 1 0 0 0-1 1v5.573", key: "1kv8ia" }],
  ["path", { d: "M3 4h8.129a1 1 0 0 1 .99.863L13 11.246", key: "1q1ert" }],
  ["path", { d: "M4 11V4", key: "9ft8pt" }],
  ["path", { d: "M7 15h.01", key: "k5ht0j" }],
  ["path", { d: "M8 10.1V4", key: "1jgyzo" }],
  ["circle", { cx: "18", cy: "18", r: "2", key: "1emm8v" }],
  ["circle", { cx: "7", cy: "15", r: "5", key: "ddtuc" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hte = d("TrafficCone", [
  ["path", { d: "M9.3 6.2a4.55 4.55 0 0 0 5.4 0", key: "flyxqv" }],
  ["path", { d: "M7.9 10.7c.9.8 2.4 1.3 4.1 1.3s3.2-.5 4.1-1.3", key: "1nlxxg" }],
  [
    "path",
    {
      d: "M13.9 3.5a1.93 1.93 0 0 0-3.8-.1l-3 10c-.1.2-.1.4-.1.6 0 1.7 2.2 3 5 3s5-1.3 5-3c0-.2 0-.4-.1-.5Z",
      key: "vz7x1l"
    }
  ],
  [
    "path",
    {
      d: "m7.5 12.2-4.7 2.7c-.5.3-.8.7-.8 1.1s.3.8.8 1.1l7.6 4.5c.9.5 2.1.5 3 0l7.6-4.5c.7-.3 1-.7 1-1.1s-.3-.8-.8-1.1l-4.7-2.8",
      key: "1xfzlw"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $te = d("TrainFrontTunnel", [
  ["path", { d: "M2 22V12a10 10 0 1 1 20 0v10", key: "o0fyp0" }],
  ["path", { d: "M15 6.8v1.4a3 2.8 0 1 1-6 0V6.8", key: "m8q3n9" }],
  ["path", { d: "M10 15h.01", key: "44in9x" }],
  ["path", { d: "M14 15h.01", key: "5mohn5" }],
  ["path", { d: "M10 19a4 4 0 0 1-4-4v-3a6 6 0 1 1 12 0v3a4 4 0 0 1-4 4Z", key: "hckbmu" }],
  ["path", { d: "m9 19-2 3", key: "iij7hm" }],
  ["path", { d: "m15 19 2 3", key: "npx8sa" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jte = d("TrainFront", [
  ["path", { d: "M8 3.1V7a4 4 0 0 0 8 0V3.1", key: "1v71zp" }],
  ["path", { d: "m9 15-1-1", key: "1yrq24" }],
  ["path", { d: "m15 15 1-1", key: "1t0d6s" }],
  ["path", { d: "M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z", key: "1p0hjs" }],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m16 19 2 3", key: "xo31yx" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fte = d("TrainTrack", [
  ["path", { d: "M2 17 17 2", key: "18b09t" }],
  ["path", { d: "m2 14 8 8", key: "1gv9hu" }],
  ["path", { d: "m5 11 8 8", key: "189pqp" }],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "m11 5 8 8", key: "ummqn6" }],
  ["path", { d: "m14 2 8 8", key: "1vk7dn" }],
  ["path", { d: "M7 22 22 7", key: "15mb1i" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wte = d("TramFront", [
  ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M12 3v8", key: "1h2ygw" }],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m18 22-2-3", key: "1p0ohu" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qte = d("Trash2", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _te = d("Trash", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gte = d("TreeDeciduous", [
  [
    "path",
    {
      d: "M8 19a4 4 0 0 1-2.24-7.32A3.5 3.5 0 0 1 9 6.03V6a3 3 0 1 1 6 0v.04a3.5 3.5 0 0 1 3.24 5.65A4 4 0 0 1 16 19Z",
      key: "oadzkq"
    }
  ],
  ["path", { d: "M12 19v3", key: "npa21l" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zte = d("TreePalm", [
  ["path", { d: "M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4", key: "foxbe7" }],
  [
    "path",
    { d: "M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3", key: "18arnh" }
  ],
  [
    "path",
    {
      d: "M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35",
      key: "ywahnh"
    }
  ],
  ["path", { d: "M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14", key: "ft0feo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xte = d("TreePine", [
  [
    "path",
    {
      d: "m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z",
      key: "cpyugq"
    }
  ],
  ["path", { d: "M12 22v-3", key: "kmzjlo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ute = d("Trees", [
  ["path", { d: "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z", key: "1l6gj6" }],
  ["path", { d: "M7 16v6", key: "1a82de" }],
  ["path", { d: "M13 19v3", key: "13sx9i" }],
  [
    "path",
    {
      d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
      key: "1sj9kv"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yte = d("Trello", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["rect", { width: "3", height: "9", x: "7", y: "7", key: "14n3xi" }],
  ["rect", { width: "3", height: "5", x: "14", y: "7", key: "s4azjd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jte = d("TrendingDown", [
  ["polyline", { points: "22 17 13.5 8.5 8.5 13.5 2 7", key: "1r2t7k" }],
  ["polyline", { points: "16 17 22 17 22 11", key: "11uiuu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kte = d("TrendingUp", [
  ["polyline", { points: "22 7 13.5 15.5 8.5 10.5 2 17", key: "126l90" }],
  ["polyline", { points: "16 7 22 7 22 13", key: "kwv8wd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qte = d("TriangleAlert", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ene = d("TriangleRight", [
  [
    "path",
    {
      d: "M22 18a2 2 0 0 1-2 2H3c-1.1 0-1.3-.6-.4-1.3L20.4 4.3c.9-.7 1.6-.4 1.6.7Z",
      key: "183wce"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tne = d("Triangle", [
  [
    "path",
    { d: "M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z", key: "14u9p9" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nne = d("Trophy", [
  ["path", { d: "M6 9H4.5a2.5 2.5 0 0 1 0-5H6", key: "17hqa7" }],
  ["path", { d: "M18 9h1.5a2.5 2.5 0 0 0 0-5H18", key: "lmptdp" }],
  ["path", { d: "M4 22h16", key: "57wxv0" }],
  ["path", { d: "M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22", key: "1nw9bq" }],
  ["path", { d: "M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22", key: "1np0yb" }],
  ["path", { d: "M18 2H6v7a6 6 0 0 0 12 0V2Z", key: "u46fv3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rne = d("Truck", [
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  ["path", { d: "M15 18H9", key: "1lyqi6" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
      key: "lysw3i"
    }
  ],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ane = d("Turtle", [
  [
    "path",
    {
      d: "m12 10 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a8 8 0 1 0-16 0v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3l2-4h4Z",
      key: "1lbbv7"
    }
  ],
  ["path", { d: "M4.82 7.9 8 10", key: "m9wose" }],
  ["path", { d: "M15.18 7.9 12 10", key: "p8dp2u" }],
  ["path", { d: "M16.93 10H20a2 2 0 0 1 0 4H2", key: "12nsm7" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ine = d("TvMinimalPlay", [
  [
    "path",
    {
      d: "M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z",
      key: "1pctta"
    }
  ],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const one = d("TvMinimal", [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sne = d("Tv", [
  ["rect", { width: "20", height: "15", x: "2", y: "7", rx: "2", ry: "2", key: "10ag99" }],
  ["polyline", { points: "17 2 12 7 7 2", key: "11pgbg" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cne = d("Twitch", [
  ["path", { d: "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7", key: "c0yzno" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lne = d("Twitter", [
  [
    "path",
    {
      d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z",
      key: "pff0z6"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dne = d("Type", [
  ["polyline", { points: "4 7 4 4 20 4 20 7", key: "1nosan" }],
  ["line", { x1: "9", x2: "15", y1: "20", y2: "20", key: "swin9y" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const une = d("UmbrellaOff", [
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "M15.5 21a1.85 1.85 0 0 1-3.5-1v-8H2a10 10 0 0 1 3.428-6.575", key: "eki10q" }],
  ["path", { d: "M17.5 12H22A10 10 0 0 0 9.004 3.455", key: "n2ayka" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hne = d("Umbrella", [
  ["path", { d: "M22 12a10.06 10.06 1 0 0-20 0Z", key: "1teyop" }],
  ["path", { d: "M12 12v8a2 2 0 0 0 4 0", key: "ulpmoc" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pne = d("Underline", [
  ["path", { d: "M6 4v6a6 6 0 0 0 12 0V4", key: "9kb039" }],
  ["line", { x1: "4", x2: "20", y1: "20", y2: "20", key: "nun2al" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fne = d("Undo2", [
  ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
  ["path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11", key: "f3b9sd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yne = d("UndoDot", [
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }],
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["path", { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13", key: "1r6uu6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mne = d("Undo", [
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["path", { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13", key: "1r6uu6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gne = d("UnfoldHorizontal", [
  ["path", { d: "M16 12h6", key: "15xry1" }],
  ["path", { d: "M8 12H2", key: "1jqql6" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 15 3-3-3-3", key: "wjy7rq" }],
  ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vne = d("UnfoldVertical", [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
  ["path", { d: "m15 5-3-3-3 3", key: "itvq4r" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kne = d("Ungroup", [
  ["rect", { width: "8", height: "6", x: "5", y: "4", rx: "1", key: "nzclkv" }],
  ["rect", { width: "8", height: "6", x: "11", y: "14", rx: "1", key: "4tytwb" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bne = d("University", [
  ["circle", { cx: "12", cy: "10", r: "1", key: "1gnqs8" }],
  ["path", { d: "M22 20V8h-4l-6-4-6 4H2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2", key: "1qj5sn" }],
  ["path", { d: "M6 17v.01", key: "roodi6" }],
  ["path", { d: "M6 13v.01", key: "67c122" }],
  ["path", { d: "M18 17v.01", key: "12ktxm" }],
  ["path", { d: "M18 13v.01", key: "tn1rt1" }],
  ["path", { d: "M14 22v-5a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5", key: "11g7fi" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xne = d("Unlink2", [
  ["path", { d: "M15 7h2a5 5 0 0 1 0 10h-2m-6 0H7A5 5 0 0 1 7 7h2", key: "1re2ne" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mne = d("Unlink", [
  [
    "path",
    {
      d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
      key: "yqzxt4"
    }
  ],
  [
    "path",
    {
      d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71",
      key: "4qinb0"
    }
  ],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "5", key: "1041cp" }],
  ["line", { x1: "2", x2: "5", y1: "8", y2: "8", key: "14m1p5" }],
  ["line", { x1: "16", x2: "16", y1: "19", y2: "22", key: "rzdirn" }],
  ["line", { x1: "19", x2: "22", y1: "16", y2: "16", key: "ox905f" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wne = d("Unplug", [
  ["path", { d: "m19 5 3-3", key: "yk6iyv" }],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  [
    "path",
    { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z", key: "goz73y" }
  ],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  [
    "path",
    { d: "m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z", key: "1snsnr" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cne = d("Upload", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "17 8 12 3 7 8", key: "t8dd8p" }],
  ["line", { x1: "12", x2: "12", y1: "3", y2: "15", key: "widbto" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sne = d("Usb", [
  ["circle", { cx: "10", cy: "7", r: "1", key: "dypaad" }],
  ["circle", { cx: "4", cy: "20", r: "1", key: "22iqad" }],
  ["path", { d: "M4.7 19.3 19 5", key: "1enqfc" }],
  ["path", { d: "m21 3-3 1 2 2Z", key: "d3ov82" }],
  ["path", { d: "M9.26 7.68 5 12l2 5", key: "1esawj" }],
  ["path", { d: "m10 14 5 2 3.5-3.5", key: "v8oal5" }],
  ["path", { d: "m18 12 1-1 1 1-1 1Z", key: "1bh22v" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ane = d("UserCheck", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["polyline", { points: "16 11 18 13 22 9", key: "1pwet4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const One = d("UserCog", [
  ["circle", { cx: "18", cy: "15", r: "3", key: "gjjjvw" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M10 15H6a4 4 0 0 0-4 4v2", key: "1nfge6" }],
  ["path", { d: "m21.7 16.4-.9-.3", key: "12j9ji" }],
  ["path", { d: "m15.2 13.9-.9-.3", key: "1fdjdi" }],
  ["path", { d: "m16.6 18.7.3-.9", key: "heedtr" }],
  ["path", { d: "m19.1 12.2.3-.9", key: "1af3ki" }],
  ["path", { d: "m19.6 18.7-.4-1", key: "1x9vze" }],
  ["path", { d: "m16.8 12.3-.4-1", key: "vqeiwj" }],
  ["path", { d: "m14.3 16.6 1-.4", key: "1qlj63" }],
  ["path", { d: "m20.7 13.8 1-.4", key: "1v5t8k" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ene = d("UserMinus", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ine = d("UserPlus", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "19", x2: "19", y1: "8", y2: "14", key: "1bvyxn" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dne = d("UserRoundCheck", [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tne = d("UserRoundCog", [
  ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m19.5 14.3-.4.9", key: "1eb35c" }],
  ["path", { d: "m16.9 20.8-.4.9", key: "dfjc4z" }],
  ["path", { d: "m21.7 19.5-.9-.4", key: "q4dx6b" }],
  ["path", { d: "m15.2 16.9-.9-.4", key: "1r0w5f" }],
  ["path", { d: "m21.7 16.5-.9.4", key: "1knoei" }],
  ["path", { d: "m15.2 19.1-.9.4", key: "j188fs" }],
  ["path", { d: "m19.5 21.7-.4-.9", key: "1tonu5" }],
  ["path", { d: "m16.9 15.2-.4-.9", key: "699xu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nne = d("UserRoundMinus", [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M22 19h-6", key: "vcuq98" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pne = d("UserRoundPlus", [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M22 19h-6", key: "vcuq98" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lne = d("UserRoundSearch", [
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.9-1.9", key: "1e5ubv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rne = d("UserRoundX", [
  ["path", { d: "M2 21a8 8 0 0 1 11.873-7", key: "74fkxq" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }],
  ["path", { d: "m22 17-5 5", key: "gqnmv0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vne = d("UserRound", [
  ["circle", { cx: "12", cy: "8", r: "5", key: "1hypcn" }],
  ["path", { d: "M20 21a8 8 0 0 0-16 0", key: "rfgkzh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zne = d("UserSearch", [
  ["circle", { cx: "10", cy: "7", r: "4", key: "e45bow" }],
  ["path", { d: "M10.3 15H7a4 4 0 0 0-4 4v2", key: "3bnktk" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["path", { d: "m21 21-1.9-1.9", key: "1g2n9r" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bne = d("UserX", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "17", x2: "22", y1: "8", y2: "13", key: "3nzzx3" }],
  ["line", { x1: "22", x2: "17", y1: "8", y2: "13", key: "1swrse" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hne = d("User", [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $ne = d("UsersRound", [
  ["path", { d: "M18 21a8 8 0 0 0-16 0", key: "3ypg7q" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3", key: "10s06x" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jne = d("Users", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["path", { d: "M16 3.13a4 4 0 0 1 0 7.75", key: "1da9ce" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fne = d("UtensilsCrossed", [
  ["path", { d: "m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8", key: "n7qcjb" }],
  [
    "path",
    { d: "M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7", key: "d0u48b" }
  ],
  ["path", { d: "m2.1 21.8 6.4-6.3", key: "yn04lh" }],
  ["path", { d: "m19 5-7 7", key: "194lzd" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wne = d("Utensils", [
  ["path", { d: "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2", key: "cjf0a3" }],
  ["path", { d: "M7 2v20", key: "1473qp" }],
  ["path", { d: "M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7", key: "j28e5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qne = d("UtilityPole", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M2 5h20", key: "1fs1ex" }],
  ["path", { d: "M3 3v2", key: "9imdir" }],
  ["path", { d: "M7 3v2", key: "n0os7" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  ["path", { d: "M21 3v2", key: "1duuac" }],
  ["path", { d: "m19 5-7 7-7-7", key: "133zxf" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ne = d("Variable", [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gne = d("Vault", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }],
  ["path", { d: "m7.9 7.9 2.7 2.7", key: "hpeyl3" }],
  ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" }],
  ["path", { d: "m13.4 10.6 2.7-2.7", key: "264c1n" }],
  ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" }],
  ["path", { d: "m7.9 16.1 2.7-2.7", key: "p81g5e" }],
  ["circle", { cx: "16.5", cy: "16.5", r: ".5", fill: "currentColor", key: "fubopw" }],
  ["path", { d: "m13.4 13.4 2.7 2.7", key: "abhel3" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zne = d("Vegan", [
  ["path", { d: "M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14", key: "qiv7li" }],
  ["path", { d: "M16 8c4 0 6-2 6-6-4 0-6 2-6 6", key: "n7eohy" }],
  ["path", { d: "M17.41 3.6a10 10 0 1 0 3 3", key: "1dion0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xne = d("VenetianMask", [
  [
    "path",
    {
      d: "M2 12a5 5 0 0 0 5 5 8 8 0 0 1 5 2 8 8 0 0 1 5-2 5 5 0 0 0 5-5V7h-5a8 8 0 0 0-5 2 8 8 0 0 0-5-2H2Z",
      key: "1g6z3j"
    }
  ],
  ["path", { d: "M6 11c1.5 0 3 .5 3 2-2 0-3 0-3-2Z", key: "c2lwnf" }],
  ["path", { d: "M18 11c-1.5 0-3 .5-3 2 2 0 3 0 3-2Z", key: "njd9zo" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Une = d("VibrateOff", [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  ["path", { d: "M8 8v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2", key: "1hbad5" }],
  ["path", { d: "M16 10.34V6c0-.55-.45-1-1-1h-4.34", key: "1x5tf0" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yne = d("Vibrate", [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  ["rect", { width: "8", height: "14", x: "8", y: "5", rx: "1", key: "1oyrl4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jne = d("VideoOff", [
  [
    "path",
    { d: "M10.66 6H14a2 2 0 0 1 2 2v2.5l5.248-3.062A.5.5 0 0 1 22 7.87v8.196", key: "w8jjjt" }
  ],
  ["path", { d: "M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2", key: "1xawa7" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kne = d("Video", [
  [
    "path",
    {
      d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
      key: "ftymec"
    }
  ],
  ["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2", key: "158x01" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qne = d("Videotape", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["circle", { cx: "8", cy: "14", r: "2", key: "1k2qr5" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "14", r: "2", key: "14k7lr" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ere = d("View", [
  [
    "path",
    { d: "M5 12s2.545-5 7-5c4.454 0 7 5 7 5s-2.546 5-7 5c-4.455 0-7-5-7-5z", key: "vptub8" }
  ],
  ["path", { d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z", key: "10lhjs" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2", key: "mrq65r" }],
  ["path", { d: "M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2", key: "be3xqs" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tre = d("Voicemail", [
  ["circle", { cx: "6", cy: "12", r: "4", key: "1ehtga" }],
  ["circle", { cx: "18", cy: "12", r: "4", key: "4vafl8" }],
  ["line", { x1: "6", x2: "18", y1: "16", y2: "16", key: "pmt8us" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nre = d("Volume1", [
  ["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", key: "16drj5" }],
  ["path", { d: "M15.54 8.46a5 5 0 0 1 0 7.07", key: "ltjumu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rre = d("Volume2", [
  ["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", key: "16drj5" }],
  ["path", { d: "M15.54 8.46a5 5 0 0 1 0 7.07", key: "ltjumu" }],
  ["path", { d: "M19.07 4.93a10 10 0 0 1 0 14.14", key: "1kegas" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const are = d("VolumeX", [
  ["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", key: "16drj5" }],
  ["line", { x1: "22", x2: "16", y1: "9", y2: "15", key: "1ewh16" }],
  ["line", { x1: "16", x2: "22", y1: "9", y2: "15", key: "5ykzw1" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ire = d("Volume", [
  ["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", key: "16drj5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ore = d("Vote", [
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }],
  ["path", { d: "M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z", key: "1ezoue" }],
  ["path", { d: "M22 19H2", key: "nuriw5" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sre = d("WalletCards", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2", key: "4125el" }],
  [
    "path",
    {
      d: "M3 11h3c.8 0 1.6.3 2.1.9l1.1.9c1.6 1.6 4.1 1.6 5.7 0l1.1-.9c.5-.5 1.3-.9 2.1-.9H21",
      key: "1dpki6"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cre = d("WalletMinimal", [
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  [
    "path",
    {
      d: "M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14",
      key: "u1rqew"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lre = d("Wallet", [
  [
    "path",
    {
      d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
      key: "18etb6"
    }
  ],
  ["path", { d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4", key: "xoc0q4" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dre = d("Wallpaper", [
  ["circle", { cx: "8", cy: "9", r: "2", key: "gjzl9d" }],
  [
    "path",
    {
      d: "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2",
      key: "69xh40"
    }
  ],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ure = d("WandSparkles", [
  [
    "path",
    {
      d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
      key: "ul74o6"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  ["path", { d: "M5 6v4", key: "ilb8ba" }],
  ["path", { d: "M19 14v4", key: "blhpug" }],
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M7 8H3", key: "zfb6yr" }],
  ["path", { d: "M21 16h-4", key: "1cnmox" }],
  ["path", { d: "M11 3H9", key: "1obp7u" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hre = d("Wand", [
  ["path", { d: "M15 4V2", key: "z1p9b7" }],
  ["path", { d: "M15 16v-2", key: "px0unx" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M17.8 11.8 19 13", key: "yihg8r" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }],
  ["path", { d: "M17.8 6.2 19 5", key: "fd4us0" }],
  ["path", { d: "m3 21 9-9", key: "1jfql5" }],
  ["path", { d: "M12.2 6.2 11 5", key: "i3da3b" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pre = d("Warehouse", [
  [
    "path",
    {
      d: "M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z",
      key: "gksnxg"
    }
  ],
  ["path", { d: "M6 18h12", key: "9pbo8z" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }],
  ["rect", { width: "12", height: "12", x: "6", y: "10", key: "apd30q" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fre = d("WashingMachine", [
  ["path", { d: "M3 6h3", key: "155dbl" }],
  ["path", { d: "M17 6h.01", key: "e2y6kg" }],
  ["rect", { width: "18", height: "20", x: "3", y: "2", rx: "2", key: "od3kk9" }],
  ["circle", { cx: "12", cy: "13", r: "5", key: "nlbqau" }],
  ["path", { d: "M12 18a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 1 0-5", key: "17lach" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yre = d("Watch", [
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["polyline", { points: "12 10 12 12 13 13", key: "19dquz" }],
  [
    "path",
    { d: "m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05", key: "18k57s" }
  ],
  ["path", { d: "m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05", key: "16ny36" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mre = d("Waves", [
  [
    "path",
    {
      d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "knzxuh"
    }
  ],
  [
    "path",
    {
      d: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "2jd2cc"
    }
  ],
  [
    "path",
    {
      d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "rd2r6e"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gre = d("Waypoints", [
  ["circle", { cx: "12", cy: "4.5", r: "2.5", key: "r5ysbb" }],
  ["path", { d: "m10.2 6.3-3.9 3.9", key: "1nzqf6" }],
  ["circle", { cx: "4.5", cy: "12", r: "2.5", key: "jydg6v" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["circle", { cx: "19.5", cy: "12", r: "2.5", key: "1piiel" }],
  ["path", { d: "m13.8 17.7 3.9-3.9", key: "1wyg1y" }],
  ["circle", { cx: "12", cy: "19.5", r: "2.5", key: "13o1pw" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vre = d("Webcam", [
  ["circle", { cx: "12", cy: "10", r: "8", key: "1gshiw" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 22h10", key: "10w4w3" }],
  ["path", { d: "M12 22v-4", key: "1utk9m" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kre = d("WebhookOff", [
  ["path", { d: "M17 17h-5c-1.09-.02-1.94.92-2.5 1.9A3 3 0 1 1 2.57 15", key: "1tvl6x" }],
  ["path", { d: "M9 3.4a4 4 0 0 1 6.52.66", key: "q04jfq" }],
  ["path", { d: "m6 17 3.1-5.8a2.5 2.5 0 0 0 .057-2.05", key: "azowf0" }],
  ["path", { d: "M20.3 20.3a4 4 0 0 1-2.3.7", key: "5joiws" }],
  ["path", { d: "M18.6 13a4 4 0 0 1 3.357 3.414", key: "cangb8" }],
  ["path", { d: "m12 6 .6 1", key: "tpjl1n" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bre = d("Webhook", [
  [
    "path",
    {
      d: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2",
      key: "q3hayz"
    }
  ],
  ["path", { d: "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06", key: "1go1hn" }],
  ["path", { d: "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8", key: "qlwsc0" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xre = d("Weight", [
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }],
  [
    "path",
    {
      d: "M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z",
      key: "56o5sh"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mre = d("WheatOff", [
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "m16 8-1.17 1.17", key: "1qqm82" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    { d: "m8 8-.53.53a3.5 3.5 0 0 0 0 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97", key: "4wz8re" }
  ],
  [
    "path",
    { d: "M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62", key: "rves66" }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "m16 16-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.49 3.49 0 0 1 1.97-.98",
      key: "ak46r"
    }
  ],
  [
    "path",
    {
      d: "M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28",
      key: "1tw520"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wre = d("Wheat", [
  ["path", { d: "M2 22 16 8", key: "60hf96" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    {
      d: "M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1sdzmb"
    }
  ],
  [
    "path",
    {
      d: "M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "eoatbi"
    }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "2m8kc5"
    }
  ],
  [
    "path",
    {
      d: "M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "vex3ng"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cre = d("WholeWord", [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }],
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sre = d("WifiOff", [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 5.17-2.69", key: "1dl1wf" }],
  ["path", { d: "M19 12.859a10 10 0 0 0-2.007-1.523", key: "4k23kn" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 4.177-2.643", key: "1grhjp" }],
  ["path", { d: "M22 8.82a15 15 0 0 0-11.288-3.764", key: "z3jwby" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Are = d("Wifi", [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 20 0", key: "dnpr2z" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 14 0", key: "1x1e6c" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ore = d("Wind", [
  ["path", { d: "M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2", key: "1k4u03" }],
  ["path", { d: "M9.6 4.6A2 2 0 1 1 11 8H2", key: "b7d0fd" }],
  ["path", { d: "M12.6 19.4A2 2 0 1 0 14 16H2", key: "1p5cb3" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ere = d("WineOff", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h3m7 0h-1.343", key: "v48bem" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    {
      d: "M7.307 7.307A12.33 12.33 0 0 0 7 10a5 5 0 0 0 7.391 4.391M8.638 2.981C8.75 2.668 8.872 2.34 9 2h6c1.5 4 2 6 2 8 0 .407-.05.809-.145 1.198",
      key: "1ymjlu"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ire = d("Wine", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    { d: "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z", key: "10ffi3" }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dre = d("Workflow", [
  ["rect", { width: "8", height: "8", x: "3", y: "3", rx: "2", key: "by2w9f" }],
  ["path", { d: "M7 11v4a2 2 0 0 0 2 2h4", key: "xkn7yn" }],
  ["rect", { width: "8", height: "8", x: "13", y: "13", rx: "2", key: "1cgmvn" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tre = d("Worm", [
  ["path", { d: "m19 12-1.5 3", key: "9bcu4o" }],
  ["path", { d: "M19.63 18.81 22 20", key: "121v98" }],
  [
    "path",
    {
      d: "M6.47 8.23a1.68 1.68 0 0 1 2.44 1.93l-.64 2.08a6.76 6.76 0 0 0 10.16 7.67l.42-.27a1 1 0 1 0-2.73-4.21l-.42.27a1.76 1.76 0 0 1-2.63-1.99l.64-2.08A6.66 6.66 0 0 0 3.94 3.9l-.7.4a1 1 0 1 0 2.55 4.34z",
      key: "1tij6q"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nre = d("WrapText", [
  ["line", { x1: "3", x2: "21", y1: "6", y2: "6", key: "4m8b97" }],
  ["path", { d: "M3 12h15a3 3 0 1 1 0 6h-4", key: "1cl7v7" }],
  ["polyline", { points: "16 16 14 18 16 20", key: "1jznyi" }],
  ["line", { x1: "3", x2: "10", y1: "18", y2: "18", key: "1h33wv" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pre = d("Wrench", [
  [
    "path",
    {
      d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z",
      key: "cbrjhi"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lre = d("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rre = d("Youtube", [
  [
    "path",
    {
      d: "M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17",
      key: "1q2vi4"
    }
  ],
  ["path", { d: "m10 15 5-3-5-3z", key: "1jp15x" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vre = d("ZapOff", [
  ["path", { d: "M10.513 4.856 13.12 2.17a.5.5 0 0 1 .86.46l-1.377 4.317", key: "193nxd" }],
  ["path", { d: "M15.656 10H20a1 1 0 0 1 .78 1.63l-1.72 1.773", key: "27a7lr" }],
  [
    "path",
    {
      d: "M16.273 16.273 10.88 21.83a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14H4a1 1 0 0 1-.78-1.63l4.507-4.643",
      key: "1e0qe9"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zre = d("Zap", [
  [
    "path",
    {
      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
      key: "1xq2db"
    }
  ]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bre = d("ZoomIn", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "11", x2: "11", y1: "8", y2: "14", key: "1vmskp" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hre = d("ZoomOut", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
]);
/**
 * @license lucide-react v0.395.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $re = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AArrowDown: DD,
  AArrowUp: TD,
  ALargeSmall: ND,
  Accessibility: PD,
  Activity: LD,
  AirVent: RD,
  Airplay: VD,
  AlarmClock: jD,
  AlarmClockCheck: zD,
  AlarmClockMinus: BD,
  AlarmClockOff: HD,
  AlarmClockPlus: $D,
  AlarmSmoke: FD,
  Album: WD,
  AlignCenter: GD,
  AlignCenterHorizontal: qD,
  AlignCenterVertical: _D,
  AlignEndHorizontal: ZD,
  AlignEndVertical: XD,
  AlignHorizontalDistributeCenter: UD,
  AlignHorizontalDistributeEnd: YD,
  AlignHorizontalDistributeStart: JD,
  AlignHorizontalJustifyCenter: KD,
  AlignHorizontalJustifyEnd: QD,
  AlignHorizontalJustifyStart: eT,
  AlignHorizontalSpaceAround: tT,
  AlignHorizontalSpaceBetween: nT,
  AlignJustify: rT,
  AlignLeft: aT,
  AlignRight: iT,
  AlignStartHorizontal: oT,
  AlignStartVertical: sT,
  AlignVerticalDistributeCenter: cT,
  AlignVerticalDistributeEnd: lT,
  AlignVerticalDistributeStart: dT,
  AlignVerticalJustifyCenter: uT,
  AlignVerticalJustifyEnd: hT,
  AlignVerticalJustifyStart: pT,
  AlignVerticalSpaceAround: fT,
  AlignVerticalSpaceBetween: yT,
  Ambulance: mT,
  Ampersand: gT,
  Ampersands: vT,
  Anchor: kT,
  Angry: bT,
  Annoyed: xT,
  Antenna: MT,
  Anvil: wT,
  Aperture: CT,
  AppWindow: AT,
  AppWindowMac: ST,
  Apple: OT,
  Archive: DT,
  ArchiveRestore: ET,
  ArchiveX: IT,
  AreaChart: TT,
  Armchair: NT,
  ArrowBigDown: LT,
  ArrowBigDownDash: PT,
  ArrowBigLeft: VT,
  ArrowBigLeftDash: RT,
  ArrowBigRight: BT,
  ArrowBigRightDash: zT,
  ArrowBigUp: $T,
  ArrowBigUpDash: HT,
  ArrowDown: QT,
  ArrowDown01: jT,
  ArrowDown10: FT,
  ArrowDownAZ: WT,
  ArrowDownFromLine: qT,
  ArrowDownLeft: _T,
  ArrowDownNarrowWide: GT,
  ArrowDownRight: ZT,
  ArrowDownToDot: XT,
  ArrowDownToLine: UT,
  ArrowDownUp: YT,
  ArrowDownWideNarrow: JT,
  ArrowDownZA: KT,
  ArrowLeft: rN,
  ArrowLeftFromLine: eN,
  ArrowLeftRight: tN,
  ArrowLeftToLine: nN,
  ArrowRight: sN,
  ArrowRightFromLine: aN,
  ArrowRightLeft: iN,
  ArrowRightToLine: oN,
  ArrowUp: bN,
  ArrowUp01: cN,
  ArrowUp10: lN,
  ArrowUpAZ: dN,
  ArrowUpDown: uN,
  ArrowUpFromDot: hN,
  ArrowUpFromLine: pN,
  ArrowUpLeft: fN,
  ArrowUpNarrowWide: yN,
  ArrowUpRight: mN,
  ArrowUpToLine: gN,
  ArrowUpWideNarrow: vN,
  ArrowUpZA: kN,
  ArrowsUpFromLine: xN,
  Asterisk: MN,
  AtSign: wN,
  Atom: CN,
  AudioLines: SN,
  AudioWaveform: AN,
  Award: ON,
  Axe: EN,
  Axis3d: IN,
  Baby: DN,
  Backpack: TN,
  Badge: XN,
  BadgeAlert: NN,
  BadgeCent: PN,
  BadgeCheck: LN,
  BadgeDollarSign: RN,
  BadgeEuro: VN,
  BadgeHelp: zN,
  BadgeIndianRupee: BN,
  BadgeInfo: HN,
  BadgeJapaneseYen: $N,
  BadgeMinus: jN,
  BadgePercent: FN,
  BadgePlus: WN,
  BadgePoundSterling: qN,
  BadgeRussianRuble: _N,
  BadgeSwissFranc: GN,
  BadgeX: ZN,
  BaggageClaim: UN,
  Ban: YN,
  Banana: JN,
  Banknote: KN,
  BarChart: iP,
  BarChart2: QN,
  BarChart3: eP,
  BarChart4: tP,
  BarChartBig: nP,
  BarChartHorizontal: aP,
  BarChartHorizontalBig: rP,
  Barcode: oP,
  Baseline: sP,
  Bath: cP,
  Battery: fP,
  BatteryCharging: lP,
  BatteryFull: dP,
  BatteryLow: uP,
  BatteryMedium: hP,
  BatteryWarning: pP,
  Beaker: yP,
  Bean: gP,
  BeanOff: mP,
  Bed: bP,
  BedDouble: vP,
  BedSingle: kP,
  Beef: xP,
  Beer: wP,
  BeerOff: MP,
  Bell: DP,
  BellDot: CP,
  BellElectric: SP,
  BellMinus: AP,
  BellOff: OP,
  BellPlus: EP,
  BellRing: IP,
  BetweenHorizontalEnd: TP,
  BetweenHorizontalStart: NP,
  BetweenVerticalEnd: PP,
  BetweenVerticalStart: LP,
  BicepsFlexed: RP,
  Bike: VP,
  Binary: zP,
  Biohazard: BP,
  Bird: HP,
  Bitcoin: $P,
  Blend: jP,
  Blinds: FP,
  Blocks: WP,
  Bluetooth: ZP,
  BluetoothConnected: qP,
  BluetoothOff: _P,
  BluetoothSearching: GP,
  Bold: XP,
  Bolt: UP,
  Bomb: YP,
  Bone: JP,
  Book: xL,
  BookA: KP,
  BookAudio: QP,
  BookCheck: eL,
  BookCopy: tL,
  BookDashed: nL,
  BookDown: rL,
  BookHeadphones: aL,
  BookHeart: iL,
  BookImage: oL,
  BookKey: sL,
  BookLock: cL,
  BookMarked: lL,
  BookMinus: dL,
  BookOpen: pL,
  BookOpenCheck: uL,
  BookOpenText: hL,
  BookPlus: fL,
  BookText: yL,
  BookType: mL,
  BookUp: vL,
  BookUp2: gL,
  BookUser: kL,
  BookX: bL,
  Bookmark: AL,
  BookmarkCheck: ML,
  BookmarkMinus: wL,
  BookmarkPlus: CL,
  BookmarkX: SL,
  BoomBox: OL,
  Bot: DL,
  BotMessageSquare: EL,
  BotOff: IL,
  Box: NL,
  BoxSelect: TL,
  Boxes: PL,
  Braces: LL,
  Brackets: RL,
  Brain: BL,
  BrainCircuit: VL,
  BrainCog: zL,
  BrickWall: HL,
  Briefcase: FL,
  BriefcaseBusiness: $L,
  BriefcaseMedical: jL,
  BringToFront: WL,
  Brush: qL,
  Bug: ZL,
  BugOff: _L,
  BugPlay: GL,
  Building: UL,
  Building2: XL,
  Bus: JL,
  BusFront: YL,
  Cable: QL,
  CableCar: KL,
  Cake: tR,
  CakeSlice: eR,
  Calculator: nR,
  Calendar: kR,
  CalendarCheck: aR,
  CalendarCheck2: rR,
  CalendarClock: iR,
  CalendarCog: oR,
  CalendarDays: sR,
  CalendarFold: cR,
  CalendarHeart: lR,
  CalendarMinus: uR,
  CalendarMinus2: dR,
  CalendarOff: hR,
  CalendarPlus: fR,
  CalendarPlus2: pR,
  CalendarRange: yR,
  CalendarSearch: mR,
  CalendarX: vR,
  CalendarX2: gR,
  Camera: xR,
  CameraOff: bR,
  CandlestickChart: MR,
  Candy: SR,
  CandyCane: wR,
  CandyOff: CR,
  Cannabis: AR,
  Captions: ER,
  CaptionsOff: OR,
  Car: TR,
  CarFront: IR,
  CarTaxiFront: DR,
  Caravan: NR,
  Carrot: PR,
  CaseLower: LR,
  CaseSensitive: RR,
  CaseUpper: VR,
  CassetteTape: zR,
  Cast: BR,
  Castle: HR,
  Cat: $R,
  Cctv: jR,
  Check: WR,
  CheckCheck: FR,
  ChefHat: qR,
  Cherry: _R,
  ChevronDown: GR,
  ChevronFirst: ZR,
  ChevronLast: XR,
  ChevronLeft: UR,
  ChevronRight: YR,
  ChevronUp: JR,
  ChevronsDown: QR,
  ChevronsDownUp: KR,
  ChevronsLeft: tV,
  ChevronsLeftRight: eV,
  ChevronsRight: rV,
  ChevronsRightLeft: nV,
  ChevronsUp: iV,
  ChevronsUpDown: aV,
  Chrome: oV,
  Church: sV,
  Cigarette: lV,
  CigaretteOff: cV,
  Circle: YV,
  CircleAlert: dV,
  CircleArrowDown: uV,
  CircleArrowLeft: hV,
  CircleArrowOutDownLeft: pV,
  CircleArrowOutDownRight: fV,
  CircleArrowOutUpLeft: yV,
  CircleArrowOutUpRight: mV,
  CircleArrowRight: gV,
  CircleArrowUp: vV,
  CircleCheck: bV,
  CircleCheckBig: kV,
  CircleChevronDown: xV,
  CircleChevronLeft: MV,
  CircleChevronRight: wV,
  CircleChevronUp: CV,
  CircleDashed: SV,
  CircleDivide: AV,
  CircleDollarSign: OV,
  CircleDot: IV,
  CircleDotDashed: EV,
  CircleEllipsis: DV,
  CircleEqual: TV,
  CircleFadingPlus: NV,
  CircleGauge: PV,
  CircleHelp: LV,
  CircleMinus: RV,
  CircleOff: VV,
  CircleParking: BV,
  CircleParkingOff: zV,
  CirclePause: HV,
  CirclePercent: $V,
  CirclePlay: jV,
  CirclePlus: FV,
  CirclePower: WV,
  CircleSlash: _V,
  CircleSlash2: qV,
  CircleStop: GV,
  CircleUser: XV,
  CircleUserRound: ZV,
  CircleX: UV,
  CircuitBoard: JV,
  Citrus: KV,
  Clapperboard: QV,
  Clipboard: dz,
  ClipboardCheck: ez,
  ClipboardCopy: tz,
  ClipboardList: nz,
  ClipboardMinus: rz,
  ClipboardPaste: az,
  ClipboardPen: oz,
  ClipboardPenLine: iz,
  ClipboardPlus: sz,
  ClipboardType: cz,
  ClipboardX: lz,
  Clock: wz,
  Clock1: uz,
  Clock10: hz,
  Clock11: pz,
  Clock12: fz,
  Clock2: yz,
  Clock3: mz,
  Clock4: gz,
  Clock5: vz,
  Clock6: kz,
  Clock7: bz,
  Clock8: xz,
  Clock9: Mz,
  Cloud: Hz,
  CloudCog: Cz,
  CloudDownload: Sz,
  CloudDrizzle: Az,
  CloudFog: Oz,
  CloudHail: Ez,
  CloudLightning: Iz,
  CloudMoon: Tz,
  CloudMoonRain: Dz,
  CloudOff: Nz,
  CloudRain: Lz,
  CloudRainWind: Pz,
  CloudSnow: Rz,
  CloudSun: zz,
  CloudSunRain: Vz,
  CloudUpload: Bz,
  Cloudy: $z,
  Clover: jz,
  Club: Fz,
  Code: qz,
  CodeXml: Wz,
  Codepen: _z,
  Codesandbox: Gz,
  Coffee: Zz,
  Cog: Xz,
  Coins: Uz,
  Columns2: Yz,
  Columns3: Jz,
  Columns4: Kz,
  Combine: Qz,
  Command: eB,
  Compass: tB,
  Component: nB,
  Computer: rB,
  ConciergeBell: aB,
  Cone: iB,
  Construction: oB,
  Contact: cB,
  ContactRound: sB,
  Container: lB,
  Contrast: dB,
  Cookie: uB,
  CookingPot: hB,
  Copy: vB,
  CopyCheck: pB,
  CopyMinus: fB,
  CopyPlus: yB,
  CopySlash: mB,
  CopyX: gB,
  Copyleft: kB,
  Copyright: bB,
  CornerDownLeft: xB,
  CornerDownRight: MB,
  CornerLeftDown: wB,
  CornerLeftUp: CB,
  CornerRightDown: SB,
  CornerRightUp: AB,
  CornerUpLeft: OB,
  CornerUpRight: EB,
  Cpu: IB,
  CreativeCommons: DB,
  CreditCard: TB,
  Croissant: NB,
  Crop: PB,
  Cross: LB,
  Crosshair: RB,
  Crown: VB,
  Cuboid: zB,
  CupSoda: BB,
  Currency: HB,
  Cylinder: $B,
  Database: WB,
  DatabaseBackup: jB,
  DatabaseZap: FB,
  Delete: qB,
  Dessert: _B,
  Diameter: GB,
  Diamond: YB,
  DiamondMinus: ZB,
  DiamondPercent: XB,
  DiamondPlus: UB,
  Dice1: JB,
  Dice2: KB,
  Dice3: QB,
  Dice4: eH,
  Dice5: tH,
  Dice6: nH,
  Dices: rH,
  Diff: aH,
  Disc: cH,
  Disc2: iH,
  Disc3: oH,
  DiscAlbum: sH,
  Divide: lH,
  Dna: uH,
  DnaOff: dH,
  Dock: hH,
  Dog: pH,
  DollarSign: fH,
  Donut: yH,
  DoorClosed: mH,
  DoorOpen: gH,
  Dot: vH,
  Download: kH,
  DraftingCompass: bH,
  Drama: xH,
  Dribbble: MH,
  Drill: wH,
  Droplet: CH,
  Droplets: SH,
  Drum: AH,
  Drumstick: OH,
  Dumbbell: EH,
  Ear: DH,
  EarOff: IH,
  Earth: NH,
  EarthLock: TH,
  Eclipse: PH,
  Egg: VH,
  EggFried: LH,
  EggOff: RH,
  Ellipsis: BH,
  EllipsisVertical: zH,
  Equal: $H,
  EqualNot: HH,
  Eraser: jH,
  Euro: FH,
  Expand: WH,
  ExternalLink: qH,
  Eye: GH,
  EyeOff: _H,
  Facebook: ZH,
  Factory: XH,
  Fan: UH,
  FastForward: YH,
  Feather: JH,
  Fence: KH,
  FerrisWheel: QH,
  Figma: e$,
  File: aj,
  FileArchive: t$,
  FileAudio: r$,
  FileAudio2: n$,
  FileAxis3d: a$,
  FileBadge: o$,
  FileBadge2: i$,
  FileBarChart: c$,
  FileBarChart2: s$,
  FileBox: l$,
  FileCheck: u$,
  FileCheck2: d$,
  FileClock: h$,
  FileCode: f$,
  FileCode2: p$,
  FileCog: y$,
  FileDiff: m$,
  FileDigit: g$,
  FileDown: v$,
  FileHeart: k$,
  FileImage: b$,
  FileInput: x$,
  FileJson: w$,
  FileJson2: M$,
  FileKey: S$,
  FileKey2: C$,
  FileLineChart: A$,
  FileLock: E$,
  FileLock2: O$,
  FileMinus: D$,
  FileMinus2: I$,
  FileMusic: T$,
  FileOutput: N$,
  FilePen: L$,
  FilePenLine: P$,
  FilePieChart: R$,
  FilePlus: z$,
  FilePlus2: V$,
  FileQuestion: B$,
  FileScan: H$,
  FileSearch: j$,
  FileSearch2: $$,
  FileSliders: F$,
  FileSpreadsheet: W$,
  FileStack: q$,
  FileSymlink: _$,
  FileTerminal: G$,
  FileText: Z$,
  FileType: U$,
  FileType2: X$,
  FileUp: Y$,
  FileVideo: K$,
  FileVideo2: J$,
  FileVolume: ej,
  FileVolume2: Q$,
  FileWarning: tj,
  FileX: rj,
  FileX2: nj,
  Files: ij,
  Film: oj,
  Filter: cj,
  FilterX: sj,
  Fingerprint: lj,
  FireExtinguisher: dj,
  Fish: pj,
  FishOff: uj,
  FishSymbol: hj,
  Flag: gj,
  FlagOff: fj,
  FlagTriangleLeft: yj,
  FlagTriangleRight: mj,
  Flame: kj,
  FlameKindling: vj,
  Flashlight: xj,
  FlashlightOff: bj,
  FlaskConical: wj,
  FlaskConicalOff: Mj,
  FlaskRound: Cj,
  FlipHorizontal: Aj,
  FlipHorizontal2: Sj,
  FlipVertical: Ej,
  FlipVertical2: Oj,
  Flower: Dj,
  Flower2: Ij,
  Focus: Tj,
  FoldHorizontal: Nj,
  FoldVertical: Pj,
  Folder: cF,
  FolderArchive: Lj,
  FolderCheck: Rj,
  FolderClock: Vj,
  FolderClosed: zj,
  FolderCog: Bj,
  FolderDot: Hj,
  FolderDown: $j,
  FolderGit: Fj,
  FolderGit2: jj,
  FolderHeart: Wj,
  FolderInput: qj,
  FolderKanban: _j,
  FolderKey: Gj,
  FolderLock: Zj,
  FolderMinus: Xj,
  FolderOpen: Yj,
  FolderOpenDot: Uj,
  FolderOutput: Jj,
  FolderPen: Kj,
  FolderPlus: Qj,
  FolderRoot: eF,
  FolderSearch: nF,
  FolderSearch2: tF,
  FolderSymlink: rF,
  FolderSync: aF,
  FolderTree: iF,
  FolderUp: oF,
  FolderX: sF,
  Folders: lF,
  Footprints: dF,
  Forklift: uF,
  Forward: hF,
  Frame: pF,
  Framer: fF,
  Frown: yF,
  Fuel: mF,
  Fullscreen: gF,
  GalleryHorizontal: kF,
  GalleryHorizontalEnd: vF,
  GalleryThumbnails: bF,
  GalleryVertical: MF,
  GalleryVerticalEnd: xF,
  Gamepad: CF,
  Gamepad2: wF,
  GanttChart: SF,
  Gauge: AF,
  Gavel: OF,
  Gem: EF,
  Ghost: IF,
  Gift: DF,
  GitBranch: NF,
  GitBranchPlus: TF,
  GitCommitHorizontal: PF,
  GitCommitVertical: LF,
  GitCompare: VF,
  GitCompareArrows: RF,
  GitFork: zF,
  GitGraph: BF,
  GitMerge: HF,
  GitPullRequest: _F,
  GitPullRequestArrow: $F,
  GitPullRequestClosed: jF,
  GitPullRequestCreate: WF,
  GitPullRequestCreateArrow: FF,
  GitPullRequestDraft: qF,
  Github: GF,
  Gitlab: ZF,
  GlassWater: XF,
  Glasses: UF,
  Globe: JF,
  GlobeLock: YF,
  Goal: KF,
  Grab: QF,
  GraduationCap: eW,
  Grape: tW,
  Grid2x2: aW,
  Grid2x2Check: nW,
  Grid2x2X: rW,
  Grid3x3: iW,
  Grip: cW,
  GripHorizontal: oW,
  GripVertical: sW,
  Group: lW,
  Guitar: dW,
  Ham: uW,
  Hammer: hW,
  Hand: vW,
  HandCoins: pW,
  HandHeart: fW,
  HandHelping: yW,
  HandMetal: mW,
  HandPlatter: gW,
  Handshake: kW,
  HardDrive: MW,
  HardDriveDownload: bW,
  HardDriveUpload: xW,
  HardHat: wW,
  Hash: CW,
  Haze: SW,
  HdmiPort: AW,
  Heading: PW,
  Heading1: OW,
  Heading2: EW,
  Heading3: IW,
  Heading4: DW,
  Heading5: TW,
  Heading6: NW,
  Headphones: LW,
  Headset: RW,
  Heart: $W,
  HeartCrack: VW,
  HeartHandshake: zW,
  HeartOff: BW,
  HeartPulse: HW,
  Heater: jW,
  Hexagon: FW,
  Highlighter: WW,
  History: qW,
  Home: _W,
  Hop: ZW,
  HopOff: GW,
  Hospital: XW,
  Hotel: UW,
  Hourglass: YW,
  IceCreamBowl: JW,
  IceCreamCone: KW,
  Image: iq,
  ImageDown: QW,
  ImageMinus: eq,
  ImageOff: tq,
  ImagePlay: nq,
  ImagePlus: rq,
  ImageUp: aq,
  Images: oq,
  Import: sq,
  Inbox: cq,
  IndentDecrease: lq,
  IndentIncrease: dq,
  IndianRupee: uq,
  Infinity: hq,
  Info: pq,
  InspectionPanel: fq,
  Instagram: yq,
  Italic: mq,
  IterationCcw: gq,
  IterationCw: vq,
  JapaneseYen: kq,
  Joystick: bq,
  Kanban: xq,
  Key: Cq,
  KeyRound: Mq,
  KeySquare: wq,
  Keyboard: Oq,
  KeyboardMusic: Sq,
  KeyboardOff: Aq,
  Lamp: Pq,
  LampCeiling: Eq,
  LampDesk: Iq,
  LampFloor: Dq,
  LampWallDown: Tq,
  LampWallUp: Nq,
  LandPlot: Lq,
  Landmark: Rq,
  Languages: Vq,
  Laptop: Bq,
  LaptopMinimal: zq,
  Lasso: $q,
  LassoSelect: Hq,
  Laugh: jq,
  Layers: qq,
  Layers2: Fq,
  Layers3: Wq,
  LayoutDashboard: _q,
  LayoutGrid: Gq,
  LayoutList: Zq,
  LayoutPanelLeft: Xq,
  LayoutPanelTop: Uq,
  LayoutTemplate: Yq,
  Leaf: Jq,
  LeafyGreen: Kq,
  Lectern: Qq,
  Library: t_,
  LibraryBig: e_,
  LifeBuoy: n_,
  Ligature: r_,
  Lightbulb: i_,
  LightbulbOff: a_,
  LineChart: o_,
  Link: l_,
  Link2: c_,
  Link2Off: s_,
  Linkedin: d_,
  List: S_,
  ListChecks: u_,
  ListCollapse: h_,
  ListEnd: p_,
  ListFilter: f_,
  ListMinus: y_,
  ListMusic: m_,
  ListOrdered: g_,
  ListPlus: v_,
  ListRestart: k_,
  ListStart: b_,
  ListTodo: x_,
  ListTree: M_,
  ListVideo: w_,
  ListX: C_,
  Loader: E_,
  LoaderCircle: A_,
  LoaderPinwheel: O_,
  Locate: T_,
  LocateFixed: I_,
  LocateOff: D_,
  Lock: R_,
  LockKeyhole: P_,
  LockKeyholeOpen: N_,
  LockOpen: L_,
  LogIn: V_,
  LogOut: z_,
  Lollipop: B_,
  Luggage: H_,
  Magnet: $_,
  Mail: U_,
  MailCheck: j_,
  MailMinus: F_,
  MailOpen: W_,
  MailPlus: q_,
  MailQuestion: __,
  MailSearch: G_,
  MailWarning: Z_,
  MailX: X_,
  Mailbox: Y_,
  Mails: J_,
  Map: tG,
  MapPin: Q_,
  MapPinOff: K_,
  MapPinned: eG,
  Martini: nG,
  Maximize: aG,
  Maximize2: rG,
  Medal: iG,
  Megaphone: sG,
  MegaphoneOff: oG,
  Meh: cG,
  MemoryStick: lG,
  Menu: dG,
  Merge: uG,
  MessageCircle: MG,
  MessageCircleCode: hG,
  MessageCircleDashed: pG,
  MessageCircleHeart: fG,
  MessageCircleMore: yG,
  MessageCircleOff: mG,
  MessageCirclePlus: gG,
  MessageCircleQuestion: vG,
  MessageCircleReply: kG,
  MessageCircleWarning: bG,
  MessageCircleX: xG,
  MessageSquare: zG,
  MessageSquareCode: wG,
  MessageSquareDashed: CG,
  MessageSquareDiff: SG,
  MessageSquareDot: AG,
  MessageSquareHeart: OG,
  MessageSquareMore: EG,
  MessageSquareOff: IG,
  MessageSquarePlus: DG,
  MessageSquareQuote: TG,
  MessageSquareReply: NG,
  MessageSquareShare: PG,
  MessageSquareText: LG,
  MessageSquareWarning: RG,
  MessageSquareX: VG,
  MessagesSquare: BG,
  Mic: jG,
  MicOff: HG,
  MicVocal: $G,
  Microscope: FG,
  Microwave: WG,
  Milestone: qG,
  Milk: GG,
  MilkOff: _G,
  Minimize: XG,
  Minimize2: ZG,
  Minus: UG,
  Monitor: sZ,
  MonitorCheck: YG,
  MonitorDot: JG,
  MonitorDown: KG,
  MonitorOff: QG,
  MonitorPause: eZ,
  MonitorPlay: tZ,
  MonitorSmartphone: nZ,
  MonitorSpeaker: rZ,
  MonitorStop: aZ,
  MonitorUp: iZ,
  MonitorX: oZ,
  Moon: lZ,
  MoonStar: cZ,
  Mountain: uZ,
  MountainSnow: dZ,
  Mouse: gZ,
  MouseOff: hZ,
  MousePointer: mZ,
  MousePointer2: pZ,
  MousePointerBan: fZ,
  MousePointerClick: yZ,
  Move: TZ,
  Move3d: vZ,
  MoveDiagonal: bZ,
  MoveDiagonal2: kZ,
  MoveDown: wZ,
  MoveDownLeft: xZ,
  MoveDownRight: MZ,
  MoveHorizontal: CZ,
  MoveLeft: SZ,
  MoveRight: AZ,
  MoveUp: IZ,
  MoveUpLeft: OZ,
  MoveUpRight: EZ,
  MoveVertical: DZ,
  Music: RZ,
  Music2: NZ,
  Music3: PZ,
  Music4: LZ,
  Navigation: HZ,
  Navigation2: zZ,
  Navigation2Off: VZ,
  NavigationOff: BZ,
  Network: $Z,
  Newspaper: jZ,
  Nfc: FZ,
  Notebook: GZ,
  NotebookPen: WZ,
  NotebookTabs: qZ,
  NotebookText: _Z,
  NotepadText: XZ,
  NotepadTextDashed: ZZ,
  Nut: YZ,
  NutOff: UZ,
  Octagon: eX,
  OctagonAlert: JZ,
  OctagonPause: KZ,
  OctagonX: QZ,
  Option: tX,
  Orbit: nX,
  Origami: rX,
  Package: uX,
  Package2: aX,
  PackageCheck: iX,
  PackageMinus: oX,
  PackageOpen: sX,
  PackagePlus: cX,
  PackageSearch: lX,
  PackageX: dX,
  PaintBucket: hX,
  PaintRoller: pX,
  Paintbrush: yX,
  PaintbrushVertical: fX,
  Palette: mX,
  PanelBottom: bX,
  PanelBottomClose: gX,
  PanelBottomDashed: vX,
  PanelBottomOpen: kX,
  PanelLeft: CX,
  PanelLeftClose: xX,
  PanelLeftDashed: MX,
  PanelLeftOpen: wX,
  PanelRight: EX,
  PanelRightClose: SX,
  PanelRightDashed: AX,
  PanelRightOpen: OX,
  PanelTop: NX,
  PanelTopClose: IX,
  PanelTopDashed: DX,
  PanelTopOpen: TX,
  PanelsLeftBottom: PX,
  PanelsRightBottom: LX,
  PanelsTopLeft: RX,
  Paperclip: VX,
  Parentheses: zX,
  ParkingMeter: BX,
  PartyPopper: HX,
  Pause: $X,
  PawPrint: jX,
  PcCase: FX,
  Pen: GX,
  PenLine: WX,
  PenOff: qX,
  PenTool: _X,
  Pencil: YX,
  PencilLine: ZX,
  PencilOff: XX,
  PencilRuler: UX,
  Pentagon: JX,
  Percent: KX,
  PersonStanding: QX,
  Phone: oU,
  PhoneCall: eU,
  PhoneForwarded: tU,
  PhoneIncoming: nU,
  PhoneMissed: rU,
  PhoneOff: aU,
  PhoneOutgoing: iU,
  Pi: sU,
  Piano: cU,
  Pickaxe: lU,
  PictureInPicture: uU,
  PictureInPicture2: dU,
  PieChart: hU,
  PiggyBank: pU,
  Pilcrow: mU,
  PilcrowLeft: fU,
  PilcrowRight: yU,
  Pill: vU,
  PillBottle: gU,
  Pin: bU,
  PinOff: kU,
  Pipette: xU,
  Pizza: MU,
  Plane: SU,
  PlaneLanding: wU,
  PlaneTakeoff: CU,
  Play: AU,
  Plug: DU,
  Plug2: OU,
  PlugZap: IU,
  PlugZap2: EU,
  Plus: TU,
  Pocket: PU,
  PocketKnife: NU,
  Podcast: LU,
  Pointer: VU,
  PointerOff: RU,
  Popcorn: zU,
  Popsicle: BU,
  PoundSterling: HU,
  Power: jU,
  PowerOff: $U,
  Presentation: FU,
  Printer: WU,
  Projector: qU,
  Proportions: _U,
  Puzzle: GU,
  Pyramid: ZU,
  QrCode: XU,
  Quote: UU,
  Rabbit: YU,
  Radar: JU,
  Radiation: KU,
  Radical: QU,
  Radio: nY,
  RadioReceiver: eY,
  RadioTower: tY,
  Radius: rY,
  RailSymbol: aY,
  Rainbow: iY,
  Rat: oY,
  Ratio: sY,
  Receipt: mY,
  ReceiptCent: cY,
  ReceiptEuro: lY,
  ReceiptIndianRupee: dY,
  ReceiptJapaneseYen: uY,
  ReceiptPoundSterling: hY,
  ReceiptRussianRuble: pY,
  ReceiptSwissFranc: fY,
  ReceiptText: yY,
  RectangleEllipsis: gY,
  RectangleHorizontal: vY,
  RectangleVertical: kY,
  Recycle: bY,
  Redo: wY,
  Redo2: xY,
  RedoDot: MY,
  RefreshCcw: SY,
  RefreshCcwDot: CY,
  RefreshCw: OY,
  RefreshCwOff: AY,
  Refrigerator: EY,
  Regex: IY,
  RemoveFormatting: DY,
  Repeat: PY,
  Repeat1: TY,
  Repeat2: NY,
  Replace: RY,
  ReplaceAll: LY,
  Reply: zY,
  ReplyAll: VY,
  Rewind: BY,
  Ribbon: HY,
  Rocket: $Y,
  RockingChair: jY,
  RollerCoaster: FY,
  Rotate3d: WY,
  RotateCcw: _Y,
  RotateCcwSquare: qY,
  RotateCw: ZY,
  RotateCwSquare: GY,
  Route: UY,
  RouteOff: XY,
  Router: YY,
  Rows2: JY,
  Rows3: KY,
  Rows4: QY,
  Rss: eJ,
  Ruler: tJ,
  RussianRuble: nJ,
  Sailboat: rJ,
  Salad: aJ,
  Sandwich: iJ,
  Satellite: sJ,
  SatelliteDish: oJ,
  Save: lJ,
  SaveAll: cJ,
  Scale: uJ,
  Scale3d: dJ,
  Scaling: hJ,
  Scan: kJ,
  ScanBarcode: pJ,
  ScanEye: fJ,
  ScanFace: yJ,
  ScanLine: mJ,
  ScanSearch: gJ,
  ScanText: vJ,
  ScatterChart: bJ,
  School: xJ,
  Scissors: wJ,
  ScissorsLineDashed: MJ,
  ScreenShare: SJ,
  ScreenShareOff: CJ,
  Scroll: OJ,
  ScrollText: AJ,
  Search: NJ,
  SearchCheck: EJ,
  SearchCode: IJ,
  SearchSlash: DJ,
  SearchX: TJ,
  Section: PJ,
  Send: VJ,
  SendHorizontal: LJ,
  SendToBack: RJ,
  SeparatorHorizontal: zJ,
  SeparatorVertical: BJ,
  Server: FJ,
  ServerCog: HJ,
  ServerCrash: $J,
  ServerOff: jJ,
  Settings: qJ,
  Settings2: WJ,
  Shapes: _J,
  Share: ZJ,
  Share2: GJ,
  Sheet: XJ,
  Shell: UJ,
  Shield: oK,
  ShieldAlert: YJ,
  ShieldBan: JJ,
  ShieldCheck: KJ,
  ShieldEllipsis: QJ,
  ShieldHalf: eK,
  ShieldMinus: tK,
  ShieldOff: nK,
  ShieldPlus: rK,
  ShieldQuestion: aK,
  ShieldX: iK,
  Ship: cK,
  ShipWheel: sK,
  Shirt: lK,
  ShoppingBag: dK,
  ShoppingBasket: uK,
  ShoppingCart: hK,
  Shovel: pK,
  ShowerHead: fK,
  Shrink: yK,
  Shrub: mK,
  Shuffle: gK,
  Sigma: vK,
  Signal: wK,
  SignalHigh: kK,
  SignalLow: bK,
  SignalMedium: xK,
  SignalZero: MK,
  Signpost: SK,
  SignpostBig: CK,
  Siren: AK,
  SkipBack: OK,
  SkipForward: EK,
  Skull: IK,
  Slack: DK,
  Slash: TK,
  Slice: NK,
  SlidersHorizontal: PK,
  SlidersVertical: LK,
  Smartphone: zK,
  SmartphoneCharging: RK,
  SmartphoneNfc: VK,
  Smile: HK,
  SmilePlus: BK,
  Snail: $K,
  Snowflake: jK,
  Sofa: FK,
  Soup: WK,
  Space: qK,
  Spade: _K,
  Sparkle: GK,
  Sparkles: ZK,
  Speaker: XK,
  Speech: UK,
  SpellCheck: JK,
  SpellCheck2: YK,
  Spline: KK,
  Split: QK,
  SprayCan: eQ,
  Sprout: tQ,
  Square: iee,
  SquareActivity: nQ,
  SquareArrowDown: iQ,
  SquareArrowDownLeft: rQ,
  SquareArrowDownRight: aQ,
  SquareArrowLeft: oQ,
  SquareArrowOutDownLeft: sQ,
  SquareArrowOutDownRight: cQ,
  SquareArrowOutUpLeft: lQ,
  SquareArrowOutUpRight: dQ,
  SquareArrowRight: uQ,
  SquareArrowUp: fQ,
  SquareArrowUpLeft: hQ,
  SquareArrowUpRight: pQ,
  SquareAsterisk: yQ,
  SquareBottomDashedScissors: mQ,
  SquareCheck: vQ,
  SquareCheckBig: gQ,
  SquareChevronDown: kQ,
  SquareChevronLeft: bQ,
  SquareChevronRight: xQ,
  SquareChevronUp: MQ,
  SquareCode: wQ,
  SquareDashedBottom: SQ,
  SquareDashedBottomCode: CQ,
  SquareDashedKanban: AQ,
  SquareDashedMousePointer: OQ,
  SquareDivide: EQ,
  SquareDot: IQ,
  SquareEqual: DQ,
  SquareFunction: TQ,
  SquareGanttChart: NQ,
  SquareKanban: PQ,
  SquareLibrary: LQ,
  SquareM: RQ,
  SquareMenu: VQ,
  SquareMinus: zQ,
  SquareMousePointer: BQ,
  SquareParking: $Q,
  SquareParkingOff: HQ,
  SquarePen: jQ,
  SquarePercent: FQ,
  SquarePi: WQ,
  SquarePilcrow: qQ,
  SquarePlay: _Q,
  SquarePlus: GQ,
  SquarePower: ZQ,
  SquareRadical: XQ,
  SquareScissors: UQ,
  SquareSigma: YQ,
  SquareSlash: JQ,
  SquareSplitHorizontal: KQ,
  SquareSplitVertical: QQ,
  SquareStack: eee,
  SquareTerminal: tee,
  SquareUser: ree,
  SquareUserRound: nee,
  SquareX: aee,
  Squircle: oee,
  Squirrel: see,
  Stamp: cee,
  Star: uee,
  StarHalf: lee,
  StarOff: dee,
  StepBack: hee,
  StepForward: pee,
  Stethoscope: fee,
  Sticker: yee,
  StickyNote: mee,
  Store: gee,
  StretchHorizontal: vee,
  StretchVertical: kee,
  Strikethrough: bee,
  Subscript: xee,
  Sun: Aee,
  SunDim: Mee,
  SunMedium: wee,
  SunMoon: Cee,
  SunSnow: See,
  Sunrise: Oee,
  Sunset: Eee,
  Superscript: Iee,
  SwatchBook: Dee,
  SwissFranc: Tee,
  SwitchCamera: Nee,
  Sword: Pee,
  Swords: Lee,
  Syringe: Ree,
  Table: Fee,
  Table2: Vee,
  TableCellsMerge: zee,
  TableCellsSplit: Bee,
  TableColumnsSplit: Hee,
  TableProperties: $ee,
  TableRowsSplit: jee,
  Tablet: qee,
  TabletSmartphone: Wee,
  Tablets: _ee,
  Tag: Gee,
  Tags: Zee,
  Tally1: Xee,
  Tally2: Uee,
  Tally3: Yee,
  Tally4: Jee,
  Tally5: Kee,
  Tangent: Qee,
  Target: ete,
  Telescope: tte,
  Tent: rte,
  TentTree: nte,
  Terminal: ate,
  TestTube: ote,
  TestTubeDiagonal: ite,
  TestTubes: ste,
  Text: pte,
  TextCursor: lte,
  TextCursorInput: cte,
  TextQuote: dte,
  TextSearch: ute,
  TextSelect: hte,
  Theater: fte,
  Thermometer: gte,
  ThermometerSnowflake: yte,
  ThermometerSun: mte,
  ThumbsDown: vte,
  ThumbsUp: kte,
  Ticket: Ate,
  TicketCheck: bte,
  TicketMinus: xte,
  TicketPercent: Mte,
  TicketPlus: wte,
  TicketSlash: Cte,
  TicketX: Ste,
  Timer: Ite,
  TimerOff: Ote,
  TimerReset: Ete,
  ToggleLeft: Dte,
  ToggleRight: Tte,
  Tornado: Nte,
  Torus: Pte,
  Touchpad: Rte,
  TouchpadOff: Lte,
  TowerControl: Vte,
  ToyBrick: zte,
  Tractor: Bte,
  TrafficCone: Hte,
  TrainFront: jte,
  TrainFrontTunnel: $te,
  TrainTrack: Fte,
  TramFront: Wte,
  Trash: _te,
  Trash2: qte,
  TreeDeciduous: Gte,
  TreePalm: Zte,
  TreePine: Xte,
  Trees: Ute,
  Trello: Yte,
  TrendingDown: Jte,
  TrendingUp: Kte,
  Triangle: tne,
  TriangleAlert: Qte,
  TriangleRight: ene,
  Trophy: nne,
  Truck: rne,
  Turtle: ane,
  Tv: sne,
  TvMinimal: one,
  TvMinimalPlay: ine,
  Twitch: cne,
  Twitter: lne,
  Type: dne,
  Umbrella: hne,
  UmbrellaOff: une,
  Underline: pne,
  Undo: mne,
  Undo2: fne,
  UndoDot: yne,
  UnfoldHorizontal: gne,
  UnfoldVertical: vne,
  Ungroup: kne,
  University: bne,
  Unlink: Mne,
  Unlink2: xne,
  Unplug: wne,
  Upload: Cne,
  Usb: Sne,
  User: Hne,
  UserCheck: Ane,
  UserCog: One,
  UserMinus: Ene,
  UserPlus: Ine,
  UserRound: Vne,
  UserRoundCheck: Dne,
  UserRoundCog: Tne,
  UserRoundMinus: Nne,
  UserRoundPlus: Pne,
  UserRoundSearch: Lne,
  UserRoundX: Rne,
  UserSearch: zne,
  UserX: Bne,
  Users: jne,
  UsersRound: $ne,
  Utensils: Wne,
  UtensilsCrossed: Fne,
  UtilityPole: qne,
  Variable: _ne,
  Vault: Gne,
  Vegan: Zne,
  VenetianMask: Xne,
  Vibrate: Yne,
  VibrateOff: Une,
  Video: Kne,
  VideoOff: Jne,
  Videotape: Qne,
  View: ere,
  Voicemail: tre,
  Volume: ire,
  Volume1: nre,
  Volume2: rre,
  VolumeX: are,
  Vote: ore,
  Wallet: lre,
  WalletCards: sre,
  WalletMinimal: cre,
  Wallpaper: dre,
  Wand: hre,
  WandSparkles: ure,
  Warehouse: pre,
  WashingMachine: fre,
  Watch: yre,
  Waves: mre,
  Waypoints: gre,
  Webcam: vre,
  Webhook: bre,
  WebhookOff: kre,
  Weight: xre,
  Wheat: wre,
  WheatOff: Mre,
  WholeWord: Cre,
  Wifi: Are,
  WifiOff: Sre,
  Wind: Ore,
  Wine: Ire,
  WineOff: Ere,
  Workflow: Dre,
  Worm: Tre,
  WrapText: Nre,
  Wrench: Pre,
  X: Lre,
  Youtube: Rre,
  Zap: zre,
  ZapOff: Vre,
  ZoomIn: Bre,
  ZoomOut: Hre
}, Symbol.toStringTag, { value: "Module" })), Ue = ba(({ name: e, size: t = 15, strokeWidth: n }) => {
  const r = $re[e];
  return r ? /* @__PURE__ */ C(r, { className: "icon", size: t, strokeWidth: n || 2.5 }) : null;
});
Ue.displayName = "Icon";
const jre = G.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 0.375rem;
  opacity: ${({ disabled: e }) => e ? 0.5 : 1};
  white-space: nowrap;

  ${({ variant: e, active: t, disabled: n }) => {
  switch (e) {
    case "primary":
      return ke`
          color: #fff;
          background-color: ${t ? "#374151" : "#000"};
          border-color: #000;

          &:hover {
            background-color: ${!n && !t ? "#4b5563" : void 0};
          }

          &:active {
            background-color: ${n ? void 0 : "#1f2937"};
          }
        `;
    case "secondary":
      return ke`
          color: #374151;
          background-color: ${t ? "#e5e7eb" : "transparent"};

          &:hover {
            background-color: ${!n && !t ? "#f3f4f6" : void 0};
          }

          &:active {
            background-color: ${n ? void 0 : "#e5e7eb"};
          }
        `;
    case "tertiary":
      return ke`
          background-color: ${t ? "#e5e7eb" : "#f9fafb"};
          color: #374151;

          &:hover {
            background-color: ${!n && !t ? "#f3f4f6" : void 0};
          }

          &:active {
            background-color: ${n ? void 0 : "#e5e7eb"};
          }
        `;
    case "ghost":
      return ke`
          background-color: ${t ? "#f3f4f6" : "transparent"};
          border-color: transparent;
          color: #9ca3af;

          &:hover {
            background-color: ${!n && !t ? "#f9fafb" : void 0};
            color: ${!n && !t ? "#6b7280" : void 0};
          }

          &:active {
            background-color: ${n ? void 0 : "#f3f4f6"};
            color: ${n ? void 0 : "#374151"};
          }
        `;
    default:
      return "";
  }
}}

  ${({ buttonSize: e }) => {
  switch (e) {
    case "medium":
      return ke`
          padding: 0.5rem 0.75rem;
        `;
    case "small":
      return ke`
          padding: 0.25rem 0.5rem;
        `;
    case "icon":
      return ke`
          width: 2rem;
          height: 2rem;
        `;
    case "iconSmall":
      return ke`
          width: 1.5rem;
          height: 1.5rem;
        `;
    default:
      return "";
  }
}}
`, v1 = V.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ C(jre, { ref: n, ...t, children: e }));
v1.displayName = "Button";
const Fre = G.div`
  background-color: #ffffff;
  border-radius: 0.5rem;

  ${({ withShadow: e }) => e && ke`
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    `}
  ${({ withBorder: e }) => e && ke`
      border: 1px solid #e5e7eb;
    `}
`, Br = Ae(
  ({ children: e, withShadow: t = !0, withBorder: n = !0, ...r }, a) => /* @__PURE__ */ C(Fre, { withBorder: n, withShadow: t, ...r, ref: a, children: e })
);
Br.displayName = "Surface";
const Wre = G(Br)`
  color: black;
  display: inline-flex;
  height: 100%;
  align-items: center;
  gap: 0.5rem;
  ${({ isVertical: e }) => e ? `
        flex-direction: column;
        padding: 0.5rem;
      ` : `
        flex-direction: row;
        padding: 0.25rem;
        align-items: center;
      `}
`, qre = G.div`
  background-color: var(--bg-neutral-200);

  ${({ horizontal: e }) => e ? `
        width: 100%;
        min-width: 1.5rem;
        height: 1px;
        margin-top: 1px;
        margin-bottom: 1px;
        &:first-child {
          margin-top: 0;
        }
        &:last-child {
          margin-bottom: 0;
        }
      ` : `
        height: 100%;
        min-height: 1.5rem;
        width: 1px;
        margin-left: 1px;
        margin-right: 1px;
        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          margin-right: 0;
        }
      `}
`, _re = G(v1)`
  display: flex;
  gap: 0.25rem;
  min-width: 2rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  width: auto;
`, js = G.kbd`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  padding: 0.25rem;
  font-size: 0.625rem;
  border-radius: 0.375rem;
  font-weight: 600;
  line-height: 1;
  border: 1px solid var(--border-neutral-200);
  color: var(--text-neutral-500);
  border-bottom-width: 2px;
`, Gre = G.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.625rem;
  background-color: white;
  border: 1px solid var(--border-neutral-100);
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 999;
`, Zre = G.span`
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--text-neutral-500);
`, Xre = G.span`
  display: flex;
  align-items: center;
  gap: 0.125rem;
`;
var Ure = "tippy-content", Yre = "tippy-backdrop", Jre = "tippy-arrow", Kre = "tippy-svg-arrow", Zr = {
  passive: !0,
  capture: !0
}, M5 = function() {
  return document.body;
};
function Qre(e, t) {
  return {}.hasOwnProperty.call(e, t);
}
function Nd(e, t, n) {
  if (Array.isArray(e)) {
    var r = e[t];
    return r ?? (Array.isArray(n) ? n[t] : n);
  }
  return e;
}
function $p(e, t) {
  var n = {}.toString.call(e);
  return n.indexOf("[object") === 0 && n.indexOf(t + "]") > -1;
}
function w5(e, t) {
  return typeof e == "function" ? e.apply(void 0, t) : e;
}
function Cy(e, t) {
  if (t === 0)
    return e;
  var n;
  return function(r) {
    clearTimeout(n), n = setTimeout(function() {
      e(r);
    }, t);
  };
}
function eae(e, t) {
  var n = Object.assign({}, e);
  return t.forEach(function(r) {
    delete n[r];
  }), n;
}
function tae(e) {
  return e.split(/\s+/).filter(Boolean);
}
function qa(e) {
  return [].concat(e);
}
function Sy(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function nae(e) {
  return e.filter(function(t, n) {
    return e.indexOf(t) === n;
  });
}
function rae(e) {
  return e.split("-")[0];
}
function Xc(e) {
  return [].slice.call(e);
}
function Ay(e) {
  return Object.keys(e).reduce(function(t, n) {
    return e[n] !== void 0 && (t[n] = e[n]), t;
  }, {});
}
function aae() {
  return document.createElement("div");
}
function eh(e) {
  return ["Element", "Fragment"].some(function(t) {
    return $p(e, t);
  });
}
function iae(e) {
  return $p(e, "NodeList");
}
function oae(e) {
  return $p(e, "MouseEvent");
}
function sae(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function cae(e) {
  return eh(e) ? [e] : iae(e) ? Xc(e) : Array.isArray(e) ? e : Xc(document.querySelectorAll(e));
}
function Pd(e, t) {
  e.forEach(function(n) {
    n && (n.style.transitionDuration = t + "ms");
  });
}
function Oy(e, t) {
  e.forEach(function(n) {
    n && n.setAttribute("data-state", t);
  });
}
function lae(e) {
  var t, n = qa(e), r = n[0];
  return r != null && (t = r.ownerDocument) != null && t.body ? r.ownerDocument : document;
}
function dae(e, t) {
  var n = t.clientX, r = t.clientY;
  return e.every(function(a) {
    var i = a.popperRect, o = a.popperState, s = a.props, c = s.interactiveBorder, l = rae(o.placement), u = o.modifiersData.offset;
    if (!u)
      return !0;
    var h = l === "bottom" ? u.top.y : 0, p = l === "top" ? u.bottom.y : 0, f = l === "right" ? u.left.x : 0, y = l === "left" ? u.right.x : 0, m = i.top - r + h > c, v = r - i.bottom - p > c, k = i.left - n + f > c, b = n - i.right - y > c;
    return m || v || k || b;
  });
}
function Ld(e, t, n) {
  var r = t + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(a) {
    e[r](a, n);
  });
}
function Ey(e, t) {
  for (var n = t; n; ) {
    var r;
    if (e.contains(n))
      return !0;
    n = n.getRootNode == null || (r = n.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var Dn = {
  isTouch: !1
}, Iy = 0;
function uae() {
  Dn.isTouch || (Dn.isTouch = !0, window.performance && document.addEventListener("mousemove", C5));
}
function C5() {
  var e = performance.now();
  e - Iy < 20 && (Dn.isTouch = !1, document.removeEventListener("mousemove", C5)), Iy = e;
}
function hae() {
  var e = document.activeElement;
  if (sae(e)) {
    var t = e._tippy;
    e.blur && !t.state.isVisible && e.blur();
  }
}
function pae() {
  document.addEventListener("touchstart", uae, Zr), window.addEventListener("blur", hae);
}
var fae = typeof window < "u" && typeof document < "u", yae = fae ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function La(e) {
  var t = e === "destroy" ? "n already-" : " ";
  return [e + "() was called on a" + t + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function Dy(e) {
  var t = /[ \t]{2,}/g, n = /^[ \t]*/gm;
  return e.replace(t, " ").replace(n, "").trim();
}
function mae(e) {
  return Dy(`
  %ctippy.js

  %c` + Dy(e) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function S5(e) {
  return [
    mae(e),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var No;
process.env.NODE_ENV !== "production" && gae();
function gae() {
  No = /* @__PURE__ */ new Set();
}
function er(e, t) {
  if (e && !No.has(t)) {
    var n;
    No.add(t), (n = console).warn.apply(n, S5(t));
  }
}
function th(e, t) {
  if (e && !No.has(t)) {
    var n;
    No.add(t), (n = console).error.apply(n, S5(t));
  }
}
function vae(e) {
  var t = !e, n = Object.prototype.toString.call(e) === "[object Object]" && !e.addEventListener;
  th(t, ["tippy() was passed", "`" + String(e) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), th(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var A5 = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, kae = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, Yt = Object.assign({
  appendTo: M5,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, A5, kae), bae = Object.keys(Yt), xae = function(t) {
  process.env.NODE_ENV !== "production" && E5(t, []);
  var n = Object.keys(t);
  n.forEach(function(r) {
    Yt[r] = t[r];
  });
};
function O5(e) {
  var t = e.plugins || [], n = t.reduce(function(r, a) {
    var i = a.name, o = a.defaultValue;
    if (i) {
      var s;
      r[i] = e[i] !== void 0 ? e[i] : (s = Yt[i]) != null ? s : o;
    }
    return r;
  }, {});
  return Object.assign({}, e, n);
}
function Mae(e, t) {
  var n = t ? Object.keys(O5(Object.assign({}, Yt, {
    plugins: t
  }))) : bae, r = n.reduce(function(a, i) {
    var o = (e.getAttribute("data-tippy-" + i) || "").trim();
    if (!o)
      return a;
    if (i === "content")
      a[i] = o;
    else
      try {
        a[i] = JSON.parse(o);
      } catch {
        a[i] = o;
      }
    return a;
  }, {});
  return r;
}
function Ty(e, t) {
  var n = Object.assign({}, t, {
    content: w5(t.content, [e])
  }, t.ignoreAttributes ? {} : Mae(e, t.plugins));
  return n.aria = Object.assign({}, Yt.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? t.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? t.interactive ? null : "describedby" : n.aria.content
  }, n;
}
function E5(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = []);
  var n = Object.keys(e);
  n.forEach(function(r) {
    var a = eae(Yt, Object.keys(A5)), i = !Qre(a, r);
    i && (i = t.filter(function(o) {
      return o.name === r;
    }).length === 0), er(i, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
function Ny(e) {
  var t = e.firstElementChild, n = Xc(t.children);
  return {
    box: t,
    content: n.find(function(r) {
      return r.classList.contains(Ure);
    }),
    arrow: n.find(function(r) {
      return r.classList.contains(Jre) || r.classList.contains(Kre);
    }),
    backdrop: n.find(function(r) {
      return r.classList.contains(Yre);
    })
  };
}
var wae = 1, Fs = [], Rd = [];
function Cae(e, t) {
  var n = Ty(e, Object.assign({}, Yt, O5(Ay(t)))), r, a, i, o = !1, s = !1, c = !1, l = !1, u, h, p, f = [], y = Cy(te, n.interactiveDebounce), m, v = wae++, k = null, b = nae(n.plugins), x = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, g = {
    // properties
    id: v,
    reference: e,
    popper: aae(),
    popperInstance: k,
    props: n,
    state: x,
    plugins: b,
    // methods
    clearDelayTimeouts: xn,
    setProps: Mn,
    setContent: Et,
    show: $1,
    hide: j1,
    hideWithInteractivity: F1,
    enable: Me,
    disable: Fe,
    unmount: W1,
    destroy: q1
  };
  if (!n.render)
    return process.env.NODE_ENV !== "production" && th(!0, "render() function has not been supplied."), g;
  var w = n.render(g), M = w.popper, S = w.onUpdate;
  M.setAttribute("data-tippy-root", ""), M.id = "tippy-" + g.id, g.popper = M, e._tippy = g, M._tippy = g;
  var D = b.map(function(T) {
    return T.fn(g);
  }), A = e.hasAttribute("aria-expanded");
  return de(), E(), R(), L("onCreate", [g]), n.showOnCreate && Rt(), M.addEventListener("mouseenter", function() {
    g.props.interactive && g.state.isVisible && g.clearDelayTimeouts();
  }), M.addEventListener("mouseleave", function() {
    g.props.interactive && g.props.trigger.indexOf("mouseenter") >= 0 && O().addEventListener("mousemove", y);
  }), g;
  function $() {
    var T = g.props.touch;
    return Array.isArray(T) ? T : [T, 0];
  }
  function F() {
    return $()[0] === "hold";
  }
  function Z() {
    var T;
    return !!((T = g.props.render) != null && T.$$tippy);
  }
  function B() {
    return m || e;
  }
  function O() {
    var T = B().parentNode;
    return T ? lae(T) : document;
  }
  function I() {
    return Ny(M);
  }
  function N(T) {
    return g.state.isMounted && !g.state.isVisible || Dn.isTouch || u && u.type === "focus" ? 0 : Nd(g.props.delay, T ? 0 : 1, Yt.delay);
  }
  function R(T) {
    T === void 0 && (T = !1), M.style.pointerEvents = g.props.interactive && !T ? "" : "none", M.style.zIndex = "" + g.props.zIndex;
  }
  function L(T, K, se) {
    if (se === void 0 && (se = !0), D.forEach(function(pe) {
      pe[T] && pe[T].apply(pe, K);
    }), se) {
      var ve;
      (ve = g.props)[T].apply(ve, K);
    }
  }
  function W() {
    var T = g.props.aria;
    if (T.content) {
      var K = "aria-" + T.content, se = M.id, ve = qa(g.props.triggerTarget || e);
      ve.forEach(function(pe) {
        var Ve = pe.getAttribute(K);
        if (g.state.isVisible)
          pe.setAttribute(K, Ve ? Ve + " " + se : se);
        else {
          var Ge = Ve && Ve.replace(se, "").trim();
          Ge ? pe.setAttribute(K, Ge) : pe.removeAttribute(K);
        }
      });
    }
  }
  function E() {
    if (!(A || !g.props.aria.expanded)) {
      var T = qa(g.props.triggerTarget || e);
      T.forEach(function(K) {
        g.props.interactive ? K.setAttribute("aria-expanded", g.state.isVisible && K === B() ? "true" : "false") : K.removeAttribute("aria-expanded");
      });
    }
  }
  function q() {
    O().removeEventListener("mousemove", y), Fs = Fs.filter(function(T) {
      return T !== y;
    });
  }
  function z(T) {
    if (!(Dn.isTouch && (c || T.type === "mousedown"))) {
      var K = T.composedPath && T.composedPath()[0] || T.target;
      if (!(g.props.interactive && Ey(M, K))) {
        if (qa(g.props.triggerTarget || e).some(function(se) {
          return Ey(se, K);
        })) {
          if (Dn.isTouch || g.state.isVisible && g.props.trigger.indexOf("click") >= 0)
            return;
        } else
          L("onClickOutside", [g, T]);
        g.props.hideOnClick === !0 && (g.clearDelayTimeouts(), g.hide(), s = !0, setTimeout(function() {
          s = !1;
        }), g.state.isMounted || P());
      }
    }
  }
  function H() {
    c = !0;
  }
  function _() {
    c = !1;
  }
  function X() {
    var T = O();
    T.addEventListener("mousedown", z, !0), T.addEventListener("touchend", z, Zr), T.addEventListener("touchstart", _, Zr), T.addEventListener("touchmove", H, Zr);
  }
  function P() {
    var T = O();
    T.removeEventListener("mousedown", z, !0), T.removeEventListener("touchend", z, Zr), T.removeEventListener("touchstart", _, Zr), T.removeEventListener("touchmove", H, Zr);
  }
  function Q(T, K) {
    ae(T, function() {
      !g.state.isVisible && M.parentNode && M.parentNode.contains(M) && K();
    });
  }
  function U(T, K) {
    ae(T, K);
  }
  function ae(T, K) {
    var se = I().box;
    function ve(pe) {
      pe.target === se && (Ld(se, "remove", ve), K());
    }
    if (T === 0)
      return K();
    Ld(se, "remove", h), Ld(se, "add", ve), h = ve;
  }
  function ee(T, K, se) {
    se === void 0 && (se = !1);
    var ve = qa(g.props.triggerTarget || e);
    ve.forEach(function(pe) {
      pe.addEventListener(T, K, se), f.push({
        node: pe,
        eventType: T,
        handler: K,
        options: se
      });
    });
  }
  function de() {
    F() && (ee("touchstart", re, {
      passive: !0
    }), ee("touchend", me, {
      passive: !0
    })), tae(g.props.trigger).forEach(function(T) {
      if (T !== "manual")
        switch (ee(T, re), T) {
          case "mouseenter":
            ee("mouseleave", me);
            break;
          case "focus":
            ee(yae ? "focusout" : "blur", Pe);
            break;
          case "focusin":
            ee("focusout", Pe);
            break;
        }
    });
  }
  function Y() {
    f.forEach(function(T) {
      var K = T.node, se = T.eventType, ve = T.handler, pe = T.options;
      K.removeEventListener(se, ve, pe);
    }), f = [];
  }
  function re(T) {
    var K, se = !1;
    if (!(!g.state.isEnabled || Se(T) || s)) {
      var ve = ((K = u) == null ? void 0 : K.type) === "focus";
      u = T, m = T.currentTarget, E(), !g.state.isVisible && oae(T) && Fs.forEach(function(pe) {
        return pe(T);
      }), T.type === "click" && (g.props.trigger.indexOf("mouseenter") < 0 || o) && g.props.hideOnClick !== !1 && g.state.isVisible ? se = !0 : Rt(T), T.type === "click" && (o = !se), se && !ve && Xe(T);
    }
  }
  function te(T) {
    var K = T.target, se = B().contains(K) || M.contains(K);
    if (!(T.type === "mousemove" && se)) {
      var ve = Qe().concat(M).map(function(pe) {
        var Ve, Ge = pe._tippy, _t = (Ve = Ge.popperInstance) == null ? void 0 : Ve.state;
        return _t ? {
          popperRect: pe.getBoundingClientRect(),
          popperState: _t,
          props: n
        } : null;
      }).filter(Boolean);
      dae(ve, T) && (q(), Xe(T));
    }
  }
  function me(T) {
    var K = Se(T) || g.props.trigger.indexOf("click") >= 0 && o;
    if (!K) {
      if (g.props.interactive) {
        g.hideWithInteractivity(T);
        return;
      }
      Xe(T);
    }
  }
  function Pe(T) {
    g.props.trigger.indexOf("focusin") < 0 && T.target !== B() || g.props.interactive && T.relatedTarget && M.contains(T.relatedTarget) || Xe(T);
  }
  function Se(T) {
    return Dn.isTouch ? F() !== T.type.indexOf("touch") >= 0 : !1;
  }
  function _e() {
    Ot();
    var T = g.props, K = T.popperOptions, se = T.placement, ve = T.offset, pe = T.getReferenceClientRect, Ve = T.moveTransition, Ge = Z() ? Ny(M).arrow : null, _t = pe ? {
      getBoundingClientRect: pe,
      contextElement: pe.contextElement || B()
    } : e, zi = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Gn) {
        var Gt = Gn.state;
        if (Z()) {
          var _1 = I(), Fr = _1.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Zn) {
            Zn === "placement" ? Fr.setAttribute("data-placement", Gt.placement) : Gt.attributes.popper["data-popper-" + Zn] ? Fr.setAttribute("data-" + Zn, "") : Fr.removeAttribute("data-" + Zn);
          }), Gt.attributes.popper = {};
        }
      }
    }, It = [{
      name: "offset",
      options: {
        offset: ve
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !Ve
      }
    }, zi];
    Z() && Ge && It.push({
      name: "arrow",
      options: {
        element: Ge,
        padding: 3
      }
    }), It.push.apply(It, (K == null ? void 0 : K.modifiers) || []), g.popperInstance = h4(_t, M, Object.assign({}, K, {
      placement: se,
      onFirstUpdate: p,
      modifiers: It
    }));
  }
  function Ot() {
    g.popperInstance && (g.popperInstance.destroy(), g.popperInstance = null);
  }
  function Re() {
    var T = g.props.appendTo, K, se = B();
    g.props.interactive && T === M5 || T === "parent" ? K = se.parentNode : K = w5(T, [se]), K.contains(M) || K.appendChild(M), g.state.isMounted = !0, _e(), process.env.NODE_ENV !== "production" && er(g.props.interactive && T === Yt.appendTo && se.nextElementSibling !== M, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function Qe() {
    return Xc(M.querySelectorAll("[data-tippy-root]"));
  }
  function Rt(T) {
    g.clearDelayTimeouts(), T && L("onTrigger", [g, T]), X();
    var K = N(!0), se = $(), ve = se[0], pe = se[1];
    Dn.isTouch && ve === "hold" && pe && (K = pe), K ? r = setTimeout(function() {
      g.show();
    }, K) : g.show();
  }
  function Xe(T) {
    if (g.clearDelayTimeouts(), L("onUntrigger", [g, T]), !g.state.isVisible) {
      P();
      return;
    }
    if (!(g.props.trigger.indexOf("mouseenter") >= 0 && g.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(T.type) >= 0 && o)) {
      var K = N(!1);
      K ? a = setTimeout(function() {
        g.state.isVisible && g.hide();
      }, K) : i = requestAnimationFrame(function() {
        g.hide();
      });
    }
  }
  function Me() {
    g.state.isEnabled = !0;
  }
  function Fe() {
    g.hide(), g.state.isEnabled = !1;
  }
  function xn() {
    clearTimeout(r), clearTimeout(a), cancelAnimationFrame(i);
  }
  function Mn(T) {
    if (process.env.NODE_ENV !== "production" && er(g.state.isDestroyed, La("setProps")), !g.state.isDestroyed) {
      L("onBeforeUpdate", [g, T]), Y();
      var K = g.props, se = Ty(e, Object.assign({}, K, Ay(T), {
        ignoreAttributes: !0
      }));
      g.props = se, de(), K.interactiveDebounce !== se.interactiveDebounce && (q(), y = Cy(te, se.interactiveDebounce)), K.triggerTarget && !se.triggerTarget ? qa(K.triggerTarget).forEach(function(ve) {
        ve.removeAttribute("aria-expanded");
      }) : se.triggerTarget && e.removeAttribute("aria-expanded"), E(), R(), S && S(K, se), g.popperInstance && (_e(), Qe().forEach(function(ve) {
        requestAnimationFrame(ve._tippy.popperInstance.forceUpdate);
      })), L("onAfterUpdate", [g, T]);
    }
  }
  function Et(T) {
    g.setProps({
      content: T
    });
  }
  function $1() {
    process.env.NODE_ENV !== "production" && er(g.state.isDestroyed, La("show"));
    var T = g.state.isVisible, K = g.state.isDestroyed, se = !g.state.isEnabled, ve = Dn.isTouch && !g.props.touch, pe = Nd(g.props.duration, 0, Yt.duration);
    if (!(T || K || se || ve) && !B().hasAttribute("disabled") && (L("onShow", [g], !1), g.props.onShow(g) !== !1)) {
      if (g.state.isVisible = !0, Z() && (M.style.visibility = "visible"), R(), X(), g.state.isMounted || (M.style.transition = "none"), Z()) {
        var Ve = I(), Ge = Ve.box, _t = Ve.content;
        Pd([Ge, _t], 0);
      }
      p = function() {
        var It;
        if (!(!g.state.isVisible || l)) {
          if (l = !0, M.offsetHeight, M.style.transition = g.props.moveTransition, Z() && g.props.animation) {
            var jr = I(), Gn = jr.box, Gt = jr.content;
            Pd([Gn, Gt], pe), Oy([Gn, Gt], "visible");
          }
          W(), E(), Sy(Rd, g), (It = g.popperInstance) == null || It.forceUpdate(), L("onMount", [g]), g.props.animation && Z() && U(pe, function() {
            g.state.isShown = !0, L("onShown", [g]);
          });
        }
      }, Re();
    }
  }
  function j1() {
    process.env.NODE_ENV !== "production" && er(g.state.isDestroyed, La("hide"));
    var T = !g.state.isVisible, K = g.state.isDestroyed, se = !g.state.isEnabled, ve = Nd(g.props.duration, 1, Yt.duration);
    if (!(T || K || se) && (L("onHide", [g], !1), g.props.onHide(g) !== !1)) {
      if (g.state.isVisible = !1, g.state.isShown = !1, l = !1, o = !1, Z() && (M.style.visibility = "hidden"), q(), P(), R(!0), Z()) {
        var pe = I(), Ve = pe.box, Ge = pe.content;
        g.props.animation && (Pd([Ve, Ge], ve), Oy([Ve, Ge], "hidden"));
      }
      W(), E(), g.props.animation ? Z() && Q(ve, g.unmount) : g.unmount();
    }
  }
  function F1(T) {
    process.env.NODE_ENV !== "production" && er(g.state.isDestroyed, La("hideWithInteractivity")), O().addEventListener("mousemove", y), Sy(Fs, y), y(T);
  }
  function W1() {
    process.env.NODE_ENV !== "production" && er(g.state.isDestroyed, La("unmount")), g.state.isVisible && g.hide(), g.state.isMounted && (Ot(), Qe().forEach(function(T) {
      T._tippy.unmount();
    }), M.parentNode && M.parentNode.removeChild(M), Rd = Rd.filter(function(T) {
      return T !== g;
    }), g.state.isMounted = !1, L("onHidden", [g]));
  }
  function q1() {
    process.env.NODE_ENV !== "production" && er(g.state.isDestroyed, La("destroy")), !g.state.isDestroyed && (g.clearDelayTimeouts(), g.unmount(), Y(), delete e._tippy, g.state.isDestroyed = !0, L("onDestroy", [g]));
  }
}
function ls(e, t) {
  t === void 0 && (t = {});
  var n = Yt.plugins.concat(t.plugins || []);
  process.env.NODE_ENV !== "production" && (vae(e), E5(t, n)), pae();
  var r = Object.assign({}, t, {
    plugins: n
  }), a = cae(e);
  if (process.env.NODE_ENV !== "production") {
    var i = eh(r.content), o = a.length > 1;
    er(i && o, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var s = a.reduce(function(c, l) {
    var u = l && Cae(l, r);
    return u && c.push(u), c;
  }, []);
  return eh(e) ? s[0] : s;
}
ls.defaultProps = Yt;
ls.setDefaultProps = xae;
ls.currentInput = Dn;
Object.assign({}, Mp, {
  effect: function(t) {
    var n = t.state, r = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, r.popper), n.styles = r, n.elements.arrow && Object.assign(n.elements.arrow.style, r.arrow);
  }
});
ls.setDefaultProps({
  animation: !1
});
function I5(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var D5 = typeof window < "u" && typeof document < "u";
function nh(e, t) {
  e && (typeof e == "function" && e(t), {}.hasOwnProperty.call(e, "current") && (e.current = t));
}
function Py() {
  return D5 && document.createElement("div");
}
function Sae(e) {
  var t = {
    "data-placement": e.placement
  };
  return e.referenceHidden && (t["data-reference-hidden"] = ""), e.escaped && (t["data-escaped"] = ""), t;
}
function T5(e, t) {
  if (e === t)
    return !0;
  if (typeof e == "object" && e != null && typeof t == "object" && t != null) {
    if (Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (var n in e)
      if (t.hasOwnProperty(n)) {
        if (!T5(e[n], t[n]))
          return !1;
      } else
        return !1;
    return !0;
  } else
    return !1;
}
function Aae(e) {
  var t = [];
  return e.forEach(function(n) {
    t.find(function(r) {
      return T5(n, r);
    }) || t.push(n);
  }), t;
}
function Oae(e, t) {
  var n, r;
  return Object.assign({}, t, {
    popperOptions: Object.assign({}, e.popperOptions, t.popperOptions, {
      modifiers: Aae([].concat(((n = e.popperOptions) == null ? void 0 : n.modifiers) || [], ((r = t.popperOptions) == null ? void 0 : r.modifiers) || []))
    })
  });
}
var Vd = D5 ? Pl : be;
function Eae(e) {
  var t = he();
  return t.current || (t.current = typeof e == "function" ? e() : e), t.current;
}
function Ly(e, t, n) {
  n.split(/\s+/).forEach(function(r) {
    r && e.classList[t](r);
  });
}
var Iae = {
  name: "className",
  defaultValue: "",
  fn: function(t) {
    var n = t.popper.firstElementChild, r = function() {
      var s;
      return !!((s = t.props.render) != null && s.$$tippy);
    };
    function a() {
      if (t.props.className && !r()) {
        process.env.NODE_ENV !== "production" && console.warn(["@tippyjs/react: Cannot use `className` prop in conjunction with", "`render` prop. Place the className on the element you are", "rendering."].join(" "));
        return;
      }
      Ly(n, "add", t.props.className);
    }
    function i() {
      r() && Ly(n, "remove", t.props.className);
    }
    return {
      onCreate: a,
      onBeforeUpdate: i,
      onAfterUpdate: a
    };
  }
};
function Dae(e) {
  function t(n) {
    var r = n.children, a = n.content, i = n.visible, o = n.singleton, s = n.render, c = n.reference, l = n.disabled, u = l === void 0 ? !1 : l, h = n.ignoreAttributes, p = h === void 0 ? !0 : h;
    n.__source, n.__self;
    var f = I5(n, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]), y = i !== void 0, m = o !== void 0, v = fe(!1), k = v[0], b = v[1], x = fe({}), g = x[0], w = x[1], M = fe(), S = M[0], D = M[1], A = Eae(function() {
      return {
        container: Py(),
        renders: 1
      };
    }), $ = Object.assign({
      ignoreAttributes: p
    }, f, {
      content: A.container
    });
    y && (process.env.NODE_ENV !== "production" && ["trigger", "hideOnClick", "showOnCreate"].forEach(function(O) {
      $[O] !== void 0 && console.warn(["@tippyjs/react: Cannot specify `" + O + "` prop in", "controlled mode (`visible` prop)"].join(" "));
    }), $.trigger = "manual", $.hideOnClick = !1), m && (u = !0);
    var F = $, Z = $.plugins || [];
    s && (F = Object.assign({}, $, {
      plugins: m && o.data != null ? [].concat(Z, [{
        fn: function() {
          return {
            onTrigger: function(N, R) {
              var L = o.data.children.find(function(W) {
                var E = W.instance;
                return E.reference === R.currentTarget;
              });
              N.state.$$activeSingletonInstance = L.instance, D(L.content);
            }
          };
        }
      }]) : Z,
      render: function() {
        return {
          popper: A.container
        };
      }
    }));
    var B = [c].concat(r ? [r.type] : []);
    return Vd(function() {
      var O = c;
      c && c.hasOwnProperty("current") && (O = c.current);
      var I = e(O || A.ref || Py(), Object.assign({}, F, {
        plugins: [Iae].concat($.plugins || [])
      }));
      return A.instance = I, u && I.disable(), i && I.show(), m && o.hook({
        instance: I,
        content: a,
        props: F,
        setSingletonContent: D
      }), b(!0), function() {
        I.destroy(), o == null || o.cleanup(I);
      };
    }, B), Vd(function() {
      var O;
      if (A.renders === 1) {
        A.renders++;
        return;
      }
      var I = A.instance;
      I.setProps(Oae(I.props, F)), (O = I.popperInstance) == null || O.forceUpdate(), u ? I.disable() : I.enable(), y && (i ? I.show() : I.hide()), m && o.hook({
        instance: I,
        content: a,
        props: F,
        setSingletonContent: D
      });
    }), Vd(function() {
      var O;
      if (s) {
        var I = A.instance;
        I.setProps({
          popperOptions: Object.assign({}, I.props.popperOptions, {
            modifiers: [].concat((((O = I.props.popperOptions) == null ? void 0 : O.modifiers) || []).filter(function(N) {
              var R = N.name;
              return R !== "$$tippyReact";
            }), [{
              name: "$$tippyReact",
              enabled: !0,
              phase: "beforeWrite",
              requires: ["computeStyles"],
              fn: function(R) {
                var L, W = R.state, E = (L = W.modifiersData) == null ? void 0 : L.hide;
                (g.placement !== W.placement || g.referenceHidden !== (E == null ? void 0 : E.isReferenceHidden) || g.escaped !== (E == null ? void 0 : E.hasPopperEscaped)) && w({
                  placement: W.placement,
                  referenceHidden: E == null ? void 0 : E.isReferenceHidden,
                  escaped: E == null ? void 0 : E.hasPopperEscaped
                }), W.attributes.popper = {};
              }
            }])
          })
        });
      }
    }, [g.placement, g.referenceHidden, g.escaped].concat(B)), /* @__PURE__ */ V.createElement(V.Fragment, null, r ? /* @__PURE__ */ Ci(r, {
      ref: function(I) {
        A.ref = I, nh(r.ref, I);
      }
    }) : null, k && /* @__PURE__ */ Eg(s ? s(Sae(g), S, A.instance) : a, A.container));
  }
  return t;
}
var Tae = function(e, t) {
  return /* @__PURE__ */ Ae(function(r, a) {
    var i = r.children, o = I5(r, ["children"]);
    return (
      // If I spread them separately here, Babel adds the _extends ponyfill for
      // some reason
      /* @__PURE__ */ V.createElement(e, Object.assign({}, t, o), i ? /* @__PURE__ */ Ci(i, {
        ref: function(c) {
          nh(a, c), nh(i.ref, c);
        }
      }) : null)
    );
  });
}, Nae = /* @__PURE__ */ Tae(/* @__PURE__ */ Dae(ls), {
  render: function() {
    return "";
  }
});
const Pae = Nae, Lae = ({ children: e }) => e === "Mod" ? /* @__PURE__ */ C(js, { children: v0 ? "⌘" : "Ctrl" }) : e === "Shift" ? /* @__PURE__ */ C(js, { children: "⇧" }) : e === "Alt" ? /* @__PURE__ */ C(js, { children: v0 ? "⌥" : "Alt" }) : /* @__PURE__ */ C(js, { children: e }), Rae = ({
  children: e,
  enabled: t = !0,
  title: n,
  shortcut: r,
  tippyOptions: a = {}
}) => {
  const i = ue(
    (o) => /* @__PURE__ */ ie(
      Gre,
      {
        tabIndex: -1,
        "data-placement": o["data-placement"],
        "data-reference-hidden": o["data-reference-hidden"],
        "data-escaped": o["data-escaped"],
        children: [
          n && /* @__PURE__ */ C(Zre, { children: n }),
          r && /* @__PURE__ */ C(Xre, { children: r.map((s) => /* @__PURE__ */ C(Lae, { children: s }, s)) })
        ]
      }
    ),
    [r, n]
  );
  return t ? /* @__PURE__ */ C(
    Pae,
    {
      delay: 500,
      offset: [0, 8],
      touch: !1,
      zIndex: 99999,
      appendTo: document.body,
      ...a,
      render: i,
      children: /* @__PURE__ */ C("span", { children: e })
    }
  ) : /* @__PURE__ */ C(da, { children: e });
}, N5 = Ae(
  ({ shouldShowContent: e = !0, children: t, isVertical: n = !1, ...r }, a) => e ? e && /* @__PURE__ */ C(Wre, { isVertical: n, ...r, ref: a, children: t }) : null
);
N5.displayName = "Toolbar";
const P5 = Ae(({ horizontal: e, ...t }, n) => /* @__PURE__ */ C(qre, { horizontal: e, ref: n, ...t }));
P5.displayName = "Toolbar.Divider";
const L5 = Ae(
  ({ children: e, buttonSize: t = "icon", variant: n = "ghost", tooltip: r, tooltipShortcut: a, ...i }, o) => {
    const s = /* @__PURE__ */ C(_re, { variant: n, buttonSize: t, ref: o, ...i, children: e });
    return r ? /* @__PURE__ */ C(Rae, { title: r, shortcut: a, children: s }) : s;
  }
);
L5.displayName = "ToolbarButton";
const zn = {
  Wrapper: N5,
  Divider: P5,
  Button: L5
}, Vae = ["#fb7185", "#fdba74", "#d9f99d", "#a7f3d0", "#a5f3fc", "#a5b4fc"], zae = ({ color: e, onChange: t, onClear: n }) => {
  const [r, a] = fe(e || ""), i = ue((s) => {
    a(s.target.value);
  }, []), o = ue(() => {
    if (!/^#([0-9A-F]{3}){1,2}$/i.test(r)) {
      t && t("");
      return;
    }
    t && t(r);
  }, [r, t]);
  return /* @__PURE__ */ ie(wD, { children: [
    /* @__PURE__ */ C(CD, { color: e || "", onChange: t }),
    /* @__PURE__ */ C(
      SD,
      {
        type: "text",
        placeholder: "#000000",
        value: r,
        onChange: i,
        onBlur: o
      }
    ),
    /* @__PURE__ */ ie(AD, { children: [
      Vae.map((s) => /* @__PURE__ */ C(
        m5,
        {
          active: s === e,
          color: s,
          onColorChange: t
        },
        s
      )),
      /* @__PURE__ */ C(zn.Button, { tooltip: "Reset color to default", onClick: n, children: /* @__PURE__ */ C(Ue, { name: "Undo" }) })
    ] })
  ] });
};
function R5(e) {
  const t = e + "CollectionProvider", [n, r] = Di(t), [a, i] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), o = (f) => {
    const { scope: y, children: m } = f, v = V.useRef(null), k = V.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ V.createElement(a, {
      scope: y,
      itemMap: k,
      collectionRef: v
    }, m);
  }, s = e + "CollectionSlot", c = /* @__PURE__ */ V.forwardRef((f, y) => {
    const { scope: m, children: v } = f, k = i(s, m), b = fn(y, k.collectionRef);
    return /* @__PURE__ */ V.createElement(mi, {
      ref: b
    }, v);
  }), l = e + "CollectionItemSlot", u = "data-radix-collection-item", h = /* @__PURE__ */ V.forwardRef((f, y) => {
    const { scope: m, children: v, ...k } = f, b = V.useRef(null), x = fn(y, b), g = i(l, m);
    return V.useEffect(() => (g.itemMap.set(b, {
      ref: b,
      ...k
    }), () => void g.itemMap.delete(b))), /* @__PURE__ */ V.createElement(mi, {
      [u]: "",
      ref: x
    }, v);
  });
  function p(f) {
    const y = i(e + "CollectionConsumer", f);
    return V.useCallback(() => {
      const v = y.collectionRef.current;
      if (!v)
        return [];
      const k = Array.from(v.querySelectorAll(`[${u}]`));
      return Array.from(y.itemMap.values()).sort(
        (g, w) => k.indexOf(g.ref.current) - k.indexOf(w.ref.current)
      );
    }, [
      y.collectionRef,
      y.itemMap
    ]);
  }
  return [
    {
      Provider: o,
      Slot: c,
      ItemSlot: h
    },
    p,
    r
  ];
}
const Bae = /* @__PURE__ */ $n(void 0);
function V5(e) {
  const t = Ct(Bae);
  return e || t || "ltr";
}
const zd = "rovingFocusGroup.onEntryFocus", Hae = {
  bubbles: !1,
  cancelable: !0
}, jp = "RovingFocusGroup", [Ry, $ae, jae] = R5(jp), [Fae, z5] = Di(jp, [
  jae
]), [Wae, T4e] = Fae(jp), qae = /* @__PURE__ */ Ae((e, t) => /* @__PURE__ */ le(Ry.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ le(Ry.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ le(_ae, je({}, e, {
  ref: t
}))))), _ae = /* @__PURE__ */ Ae((e, t) => {
  const { __scopeRovingFocusGroup: n, orientation: r, loop: a = !1, dir: i, currentTabStopId: o, defaultCurrentTabStopId: s, onCurrentTabStopIdChange: c, onEntryFocus: l, ...u } = e, h = he(null), p = fn(t, h), f = V5(i), [y = null, m] = zp({
    prop: o,
    defaultProp: s,
    onChange: c
  }), [v, k] = fe(!1), b = qn(l), x = $ae(n), g = he(!1), [w, M] = fe(0);
  return be(() => {
    const S = h.current;
    if (S)
      return S.addEventListener(zd, b), () => S.removeEventListener(zd, b);
  }, [
    b
  ]), /* @__PURE__ */ le(Wae, {
    scope: n,
    orientation: r,
    dir: f,
    loop: a,
    currentTabStopId: y,
    onItemFocus: ue(
      (S) => m(S),
      [
        m
      ]
    ),
    onItemShiftTab: ue(
      () => k(!0),
      []
    ),
    onFocusableItemAdd: ue(
      () => M(
        (S) => S + 1
      ),
      []
    ),
    onFocusableItemRemove: ue(
      () => M(
        (S) => S - 1
      ),
      []
    )
  }, /* @__PURE__ */ le(xa.div, je({
    tabIndex: v || w === 0 ? -1 : 0,
    "data-orientation": r
  }, u, {
    ref: p,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: at(e.onMouseDown, () => {
      g.current = !0;
    }),
    onFocus: at(e.onFocus, (S) => {
      const D = !g.current;
      if (S.target === S.currentTarget && D && !v) {
        const A = new CustomEvent(zd, Hae);
        if (S.currentTarget.dispatchEvent(A), !A.defaultPrevented) {
          const $ = x().filter(
            (I) => I.focusable
          ), F = $.find(
            (I) => I.active
          ), Z = $.find(
            (I) => I.id === y
          ), O = [
            F,
            Z,
            ...$
          ].filter(Boolean).map(
            (I) => I.ref.current
          );
          Gae(O);
        }
      }
      g.current = !1;
    }),
    onBlur: at(
      e.onBlur,
      () => k(!1)
    )
  })));
});
function Gae(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
const Zae = qae, Xae = [
  "ArrowDown",
  "PageUp",
  "Home"
], B5 = [
  "ArrowUp",
  "PageDown",
  "End"
], Uae = [
  ...Xae,
  ...B5
], k1 = "Menu", [Vy, Yae, Jae] = R5(k1), [Ma, H5] = Di(k1, [
  Jae,
  y1,
  z5
]), Fp = y1(), Kae = z5(), [Qae, b1] = Ma(k1), [eie, $5] = Ma(k1), tie = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: a, onOpenChange: i, modal: o = !0 } = e, s = Fp(t), [c, l] = fe(null), u = he(!1), h = qn(i), p = V5(a);
  return be(() => {
    const f = () => {
      u.current = !0, document.addEventListener("pointerdown", y, {
        capture: !0,
        once: !0
      }), document.addEventListener("pointermove", y, {
        capture: !0,
        once: !0
      });
    }, y = () => u.current = !1;
    return document.addEventListener("keydown", f, {
      capture: !0
    }), () => {
      document.removeEventListener("keydown", f, {
        capture: !0
      }), document.removeEventListener("pointerdown", y, {
        capture: !0
      }), document.removeEventListener("pointermove", y, {
        capture: !0
      });
    };
  }, []), /* @__PURE__ */ le(K4, s, /* @__PURE__ */ le(Qae, {
    scope: t,
    open: n,
    onOpenChange: h,
    content: c,
    onContentChange: l
  }, /* @__PURE__ */ le(eie, {
    scope: t,
    onClose: ue(
      () => h(!1),
      [
        h
      ]
    ),
    isUsingKeyboardRef: u,
    dir: p,
    modal: o
  }, r)));
}, nie = /* @__PURE__ */ Ae((e, t) => {
  const { __scopeMenu: n, ...r } = e, a = Fp(n);
  return /* @__PURE__ */ le(Q4, je({}, a, r, {
    ref: t
  }));
}), rie = "MenuPortal", [N4e, aie] = Ma(rie, {
  forceMount: void 0
}), Or = "MenuContent", [iie, P4e] = Ma(Or), oie = /* @__PURE__ */ Ae((e, t) => {
  const n = aie(Or, e.__scopeMenu), { forceMount: r = n.forceMount, ...a } = e, i = b1(Or, e.__scopeMenu), o = $5(Or, e.__scopeMenu);
  return /* @__PURE__ */ le(Vy.Provider, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ le(Vp, {
    present: r || i.open
  }, /* @__PURE__ */ le(Vy.Slot, {
    scope: e.__scopeMenu
  }, o.modal ? /* @__PURE__ */ le(sie, je({}, a, {
    ref: t
  })) : /* @__PURE__ */ le(cie, je({}, a, {
    ref: t
  })))));
}), sie = /* @__PURE__ */ Ae((e, t) => {
  const n = b1(Or, e.__scopeMenu), r = he(null), a = fn(t, r);
  return be(() => {
    const i = r.current;
    if (i)
      return n5(i);
  }, []), /* @__PURE__ */ le(j5, je({}, e, {
    ref: a,
    trapFocus: n.open,
    disableOutsidePointerEvents: n.open,
    disableOutsideScroll: !0,
    onFocusOutside: at(
      e.onFocusOutside,
      (i) => i.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    ),
    onDismiss: () => n.onOpenChange(!1)
  }));
}), cie = /* @__PURE__ */ Ae((e, t) => {
  const n = b1(Or, e.__scopeMenu);
  return /* @__PURE__ */ le(j5, je({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    onDismiss: () => n.onOpenChange(!1)
  }));
}), j5 = /* @__PURE__ */ Ae((e, t) => {
  const { __scopeMenu: n, loop: r = !1, trapFocus: a, onOpenAutoFocus: i, onCloseAutoFocus: o, disableOutsidePointerEvents: s, onEntryFocus: c, onEscapeKeyDown: l, onPointerDownOutside: u, onFocusOutside: h, onInteractOutside: p, onDismiss: f, disableOutsideScroll: y, ...m } = e, v = b1(Or, n), k = $5(Or, n), b = Fp(n), x = Kae(n), g = Yae(n), [w, M] = fe(null), S = he(null), D = fn(t, S, v.onContentChange), A = he(0), $ = he(""), F = he(0), Z = he(null), B = he("right"), O = he(0), I = y ? u5 : ua, N = y ? {
    as: mi,
    allowPinchZoom: !0
  } : void 0, R = (W) => {
    var E, q;
    const z = $.current + W, H = g().filter(
      (ae) => !ae.disabled
    ), _ = document.activeElement, X = (E = H.find(
      (ae) => ae.ref.current === _
    )) === null || E === void 0 ? void 0 : E.textValue, P = H.map(
      (ae) => ae.textValue
    ), Q = yie(P, z, X), U = (q = H.find(
      (ae) => ae.textValue === Q
    )) === null || q === void 0 ? void 0 : q.ref.current;
    (function ae(ee) {
      $.current = ee, window.clearTimeout(A.current), ee !== "" && (A.current = window.setTimeout(
        () => ae(""),
        1e3
      ));
    })(z), U && setTimeout(
      () => U.focus()
    );
  };
  be(() => () => window.clearTimeout(A.current), []), R4();
  const L = ue((W) => {
    var E, q;
    return B.current === ((E = Z.current) === null || E === void 0 ? void 0 : E.side) && gie(W, (q = Z.current) === null || q === void 0 ? void 0 : q.area);
  }, []);
  return /* @__PURE__ */ le(iie, {
    scope: n,
    searchRef: $,
    onItemEnter: ue((W) => {
      L(W) && W.preventDefault();
    }, [
      L
    ]),
    onItemLeave: ue((W) => {
      var E;
      L(W) || ((E = S.current) === null || E === void 0 || E.focus(), M(null));
    }, [
      L
    ]),
    onTriggerLeave: ue((W) => {
      L(W) && W.preventDefault();
    }, [
      L
    ]),
    pointerGraceTimerRef: F,
    onPointerGraceIntentChange: ue((W) => {
      Z.current = W;
    }, [])
  }, /* @__PURE__ */ le(I, N, /* @__PURE__ */ le(V4, {
    asChild: !0,
    trapped: a,
    onMountAutoFocus: at(i, (W) => {
      var E;
      W.preventDefault(), (E = S.current) === null || E === void 0 || E.focus();
    }),
    onUnmountAutoFocus: o
  }, /* @__PURE__ */ le(P4, {
    asChild: !0,
    disableOutsidePointerEvents: s,
    onEscapeKeyDown: l,
    onPointerDownOutside: u,
    onFocusOutside: h,
    onInteractOutside: p,
    onDismiss: f
  }, /* @__PURE__ */ le(Zae, je({
    asChild: !0
  }, x, {
    dir: k.dir,
    orientation: "vertical",
    loop: r,
    currentTabStopId: w,
    onCurrentTabStopIdChange: M,
    onEntryFocus: at(c, (W) => {
      k.isUsingKeyboardRef.current || W.preventDefault();
    })
  }), /* @__PURE__ */ le(e5, je({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": hie(v.open),
    "data-radix-menu-content": "",
    dir: k.dir
  }, b, m, {
    ref: D,
    style: {
      outline: "none",
      ...m.style
    },
    onKeyDown: at(m.onKeyDown, (W) => {
      const q = W.target.closest("[data-radix-menu-content]") === W.currentTarget, z = W.ctrlKey || W.altKey || W.metaKey, H = W.key.length === 1;
      q && (W.key === "Tab" && W.preventDefault(), !z && H && R(W.key));
      const _ = S.current;
      if (W.target !== _ || !Uae.includes(W.key))
        return;
      W.preventDefault();
      const P = g().filter(
        (Q) => !Q.disabled
      ).map(
        (Q) => Q.ref.current
      );
      B5.includes(W.key) && P.reverse(), pie(P);
    }),
    onBlur: at(e.onBlur, (W) => {
      W.currentTarget.contains(W.target) || (window.clearTimeout(A.current), $.current = "");
    }),
    onPointerMove: at(e.onPointerMove, vie((W) => {
      const E = W.target, q = O.current !== W.clientX;
      if (W.currentTarget.contains(E) && q) {
        const z = W.clientX > O.current ? "right" : "left";
        B.current = z, O.current = W.clientX;
      }
    }))
  })))))));
}), lie = "MenuRadioGroup";
Ma(lie, {
  value: void 0,
  onValueChange: () => {
  }
});
const die = "MenuItemIndicator";
Ma(die, {
  checked: !1
});
const uie = "MenuSub";
Ma(uie);
function hie(e) {
  return e ? "open" : "closed";
}
function pie(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function fie(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
function yie(e, t, n) {
  const a = t.length > 1 && Array.from(t).every(
    (l) => l === t[0]
  ) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let o = fie(e, Math.max(i, 0));
  a.length === 1 && (o = o.filter(
    (l) => l !== n
  ));
  const c = o.find(
    (l) => l.toLowerCase().startsWith(a.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function mie(e, t) {
  const { x: n, y: r } = e;
  let a = !1;
  for (let i = 0, o = t.length - 1; i < t.length; o = i++) {
    const s = t[i].x, c = t[i].y, l = t[o].x, u = t[o].y;
    c > r != u > r && n < (l - s) * (r - c) / (u - c) + s && (a = !a);
  }
  return a;
}
function gie(e, t) {
  if (!t)
    return !1;
  const n = {
    x: e.clientX,
    y: e.clientY
  };
  return mie(n, t);
}
function vie(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
const kie = tie, bie = nie, xie = oie, F5 = "DropdownMenu", [Mie, L4e] = Di(F5, [
  H5
]), Wp = H5(), [wie, W5] = Mie(F5), Cie = (e) => {
  const { __scopeDropdownMenu: t, children: n, dir: r, open: a, defaultOpen: i, onOpenChange: o, modal: s = !0 } = e, c = Wp(t), l = he(null), [u = !1, h] = zp({
    prop: a,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ le(wie, {
    scope: t,
    triggerId: Gu(),
    triggerRef: l,
    contentId: Gu(),
    open: u,
    onOpenChange: h,
    onOpenToggle: ue(
      () => h(
        (p) => !p
      ),
      [
        h
      ]
    ),
    modal: s
  }, /* @__PURE__ */ le(kie, je({}, c, {
    open: u,
    onOpenChange: h,
    dir: r,
    modal: s
  }), n));
}, Sie = "DropdownMenuTrigger", Aie = /* @__PURE__ */ Ae((e, t) => {
  const { __scopeDropdownMenu: n, disabled: r = !1, ...a } = e, i = W5(Sie, n), o = Wp(n);
  return /* @__PURE__ */ le(bie, je({
    asChild: !0
  }, o), /* @__PURE__ */ le(xa.button, je({
    type: "button",
    id: i.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": i.open,
    "aria-controls": i.open ? i.contentId : void 0,
    "data-state": i.open ? "open" : "closed",
    "data-disabled": r ? "" : void 0,
    disabled: r
  }, a, {
    ref: Ip(t, i.triggerRef),
    onPointerDown: at(e.onPointerDown, (s) => {
      !r && s.button === 0 && s.ctrlKey === !1 && (i.onOpenToggle(), i.open || s.preventDefault());
    }),
    onKeyDown: at(e.onKeyDown, (s) => {
      r || ([
        "Enter",
        " "
      ].includes(s.key) && i.onOpenToggle(), s.key === "ArrowDown" && i.onOpenChange(!0), [
        "Enter",
        " ",
        "ArrowDown"
      ].includes(s.key) && s.preventDefault());
    })
  })));
}), Oie = "DropdownMenuContent", Eie = /* @__PURE__ */ Ae((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = W5(Oie, n), i = Wp(n), o = he(!1);
  return /* @__PURE__ */ le(xie, je({
    id: a.contentId,
    "aria-labelledby": a.triggerId
  }, i, r, {
    ref: t,
    onCloseAutoFocus: at(e.onCloseAutoFocus, (s) => {
      var c;
      o.current || (c = a.triggerRef.current) === null || c === void 0 || c.focus(), o.current = !1, s.preventDefault();
    }),
    onInteractOutside: at(e.onInteractOutside, (s) => {
      const c = s.detail.originalEvent, l = c.button === 0 && c.ctrlKey === !0, u = c.button === 2 || l;
      (!a.modal || u) && (o.current = !0);
    }),
    style: {
      ...e.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), qp = Cie, _p = Aie, Gp = Eie, Iie = G.div`
  font-size: 0.65rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
  text-transform: uppercase;
  color: #718096;
  padding: 0 0.375rem;
`, Die = G.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem;
  font-size: 0.875rem;
  font-weight: regular;
  text-align: left;
  background-color: transparent;
  width: 100%;
  border-radius: 0.25rem;
  color: #6b7280;
  cursor: pointer;
  border-color: transparent;

  ${({ isActive: e, disabled: t }) => !e && !t && ke`
      &:hover {
        background-color: #f3f4f6;
        color: #1f2937;
      }
    `}
  ${({ isActive: e, disabled: t }) => e && !t && ke`
      background-color: #f3f4f6;
      color: #1f2937;
    `}
  ${({ disabled: e }) => e && ke`
      color: #9ca3af;
      cursor: not-allowed;

      &:hover {
        background-color: transparent;
      }
    `};
`, q5 = ({ children: e }) => /* @__PURE__ */ C(Iie, { children: e }), x1 = ({ children: e, isActive: t, onClick: n, disabled: r }) => /* @__PURE__ */ C(Die, { type: "button", isActive: t, disabled: r, onClick: n, children: e }), Tie = (e) => e.type === "option", Nie = (e) => e.type === "category", Pie = G(Ue)`
  width: 0.5rem;
  height: 0.5rem;
`, Lie = G(Ue)`
  width: 1rem;
  height: 1rem;
  margin-right: 0.25rem;
`, Rie = G(Br)`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 1rem 0.5rem;
`, Vie = G.div`
  margin-top: 0.5rem;
  &:first-child {
    margin-top: 0;
  }
`, zie = ({ options: e }) => {
  const t = wt(() => e.find((n) => n.type === "option" && n.isActive()), [e]);
  return /* @__PURE__ */ ie(qp, { children: [
    /* @__PURE__ */ C(_p, { asChild: !0, children: /* @__PURE__ */ ie(zn.Button, { active: (t == null ? void 0 : t.id) !== "paragraph" && !!(t != null && t.type), children: [
      /* @__PURE__ */ C(Ue, { name: (t == null ? void 0 : t.type) === "option" && t.icon || "Pilcrow" }),
      /* @__PURE__ */ C(Pie, { name: "ChevronDown", size: 10 })
    ] }) }),
    /* @__PURE__ */ C(Gp, { asChild: !0, children: /* @__PURE__ */ C(Rie, { children: e.map((n) => /* @__PURE__ */ ie(da, { children: [
      Tie(n) && /* @__PURE__ */ ie(x1, { onClick: n.onClick, isActive: n.isActive(), children: [
        /* @__PURE__ */ C(Lie, { name: n.icon }),
        n.label
      ] }, n.id),
      Nie(n) && /* @__PURE__ */ C(Vie, { children: /* @__PURE__ */ C(q5, { children: n.label }, n.id) }, n.id)
    ] })) }) })
  ] });
}, Bie = ({ initialUrl: e, initialOpenInNewTab: t, onSetLink: n }) => {
  const [r, a] = fe(e || ""), [i, o] = fe(t || !0), s = ue((u) => {
    a(u.target.value);
  }, []), c = wt(() => /^(\S+):(\/\/)?\S+$/.test(r), [r]), l = ue(
    (u) => {
      u.preventDefault(), c && n(r, i);
    },
    [r, c, i, n]
  );
  return {
    url: r,
    setUrl: a,
    openInNewTab: i,
    setOpenInNewTab: o,
    onChange: s,
    isValidUrl: c,
    handleClick: l
  };
}, Hie = G(Br)`
  padding: 0.5rem;

  .top-section {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`, $ie = G.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  border-radius: 0.5rem;
  background-color: #f3f4f6;
  cursor: text;
  margin: 0;
`, jie = G.input`
  flex: 1;
  background-color: transparent;
  outline: none;
  min-width: 3rem;
  color: #000000;
  font-size: 0.875rem;
`, Fie = G(Ue)`
  flex: none;
  color: ${({ theme: e }) => e.darkMode ? "white" : "black"};
`, Wie = ({ onSetLink: e, initialOpenInNewTab: t, initialUrl: n }) => {
  const r = Bie({ onSetLink: e, initialOpenInNewTab: t, initialUrl: n });
  return /* @__PURE__ */ C(Hie, { children: /* @__PURE__ */ ie("div", { className: "top-section", children: [
    /* @__PURE__ */ ie($ie, { children: [
      /* @__PURE__ */ C(Fie, { name: "Link" }),
      /* @__PURE__ */ C(jie, { type: "url", placeholder: "Enter URL", value: r.url, onChange: r.onChange })
    ] }),
    /* @__PURE__ */ C(v1, { onClick: r.handleClick, variant: "primary", buttonSize: "small", disabled: !r.isValidUrl, children: "Set Link" })
  ] }) });
}, qie = ({ onSetLink: e }) => /* @__PURE__ */ ie(dc, { children: [
  /* @__PURE__ */ C(uc, { asChild: !0, children: /* @__PURE__ */ C(zn.Button, { tooltip: "Set Link", children: /* @__PURE__ */ C(Ue, { name: "Link" }) }) }),
  /* @__PURE__ */ C(hc, { children: /* @__PURE__ */ C(Wie, { onSetLink: e, initialOpenInNewTab: !0 }) })
] }), _5 = [
  {
    label: "Sans Serif",
    options: [
      { label: "Alicorp", value: "AlicorpSans-Regular" },
      { label: "Arial", value: "Arial" },
      { label: "Helvetica", value: "Helvetica" }
    ]
  },
  {
    label: "Serif",
    options: [
      { label: "Times New Roman", value: "Times" },
      { label: "Garamond", value: "Garamond" },
      { label: "Georgia", value: "Georgia" }
    ]
  },
  {
    label: "Monospace",
    options: [
      { label: "Courier", value: "Courier" },
      { label: "Courier New", value: "Courier New" }
    ]
  }
], _ie = _5.flatMap((e) => [e.options]).flat(), Gie = ({ onChange: e, value: t }) => {
  const n = _ie.find((i) => i.value === t), r = (n == null ? void 0 : n.label.split(" ")[0]) || "Alicorp", a = ue((i) => () => e(i), [e]);
  return /* @__PURE__ */ ie(qp, { children: [
    /* @__PURE__ */ C(_p, { asChild: !0, children: /* @__PURE__ */ ie(zn.Button, { active: !!(n != null && n.value), children: [
      r,
      /* @__PURE__ */ C(Ue, { name: "ChevronDown", size: 10 })
    ] }) }),
    /* @__PURE__ */ C(Gp, { asChild: !0, children: /* @__PURE__ */ C(Br, { className: "flex flex-col gap-1 px-2 py-4", children: _5.map((i) => /* @__PURE__ */ ie("div", { className: "mt-2.5 first:mt-0 gap-0.5 flex flex-col", children: [
      /* @__PURE__ */ C(q5, { children: i.label }),
      i.options.map((o) => /* @__PURE__ */ C(
        x1,
        {
          isActive: t === o.value,
          onClick: a(o.value),
          children: /* @__PURE__ */ C("span", { style: { fontFamily: o.value }, children: o.label })
        },
        `${o.label}_${o.value}`
      ))
    ] }, i.label)) }) })
  ] });
}, Zie = G(Ue)`
  width: 0.5rem;
  height: 0.5rem;
`, Xie = G(Br)`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 1rem 0.5rem;
`, zy = [
  { label: "Smaller", value: "12px" },
  { label: "Small", value: "14px" },
  { label: "Medium", value: "" },
  { label: "Large", value: "18px" },
  { label: "Extra Large", value: "24px" }
], Uie = ({ onChange: e, value: t }) => {
  const n = zy.find((i) => i.value === t), r = (n == null ? void 0 : n.label.split(" ")[0]) || "Medium", a = ue((i) => () => e(i), [e]);
  return /* @__PURE__ */ ie(qp, { children: [
    /* @__PURE__ */ C(_p, { asChild: !0, children: /* @__PURE__ */ ie(zn.Button, { active: !!(n != null && n.value), children: [
      r,
      /* @__PURE__ */ C(Zie, { name: "ChevronDown", size: 10 })
    ] }) }),
    /* @__PURE__ */ C(Gp, { asChild: !0, children: /* @__PURE__ */ C(Xie, { children: zy.map((i) => /* @__PURE__ */ C(
      x1,
      {
        isActive: t === i.value,
        onClick: a(i.value),
        children: /* @__PURE__ */ C("span", { style: { fontSize: i.value }, children: i.label })
      },
      `${i.label}_${i.value}`
    )) }) })
  ] });
}, Yie = (e) => {
  const t = ue(() => e.chain().focus().toggleBold().run(), [e]), n = ue(() => e.chain().focus().toggleItalic().run(), [e]), r = ue(() => e.chain().focus().toggleStrike().run(), [e]), a = ue(() => e.chain().focus().toggleCodeBlock().run(), [e]), i = ue(() => e.chain().focus().toggleUnderline().run(), [e]), o = ue(() => e.chain().focus().setTextAlign("left").run(), [e]), s = ue(() => e.chain().focus().setTextAlign("center").run(), [e]), c = ue(() => e.chain().focus().setTextAlign("right").run(), [e]), l = ue(() => e.chain().focus().setTextAlign("justify").run(), [e]), u = ue((k) => e.chain().setColor(k).run(), [e]), h = ue(() => e.chain().focus().unsetColor().run(), [e]), p = ue((k) => e.chain().setHighlight({ color: k }).run(), [e]), f = ue(() => e.chain().focus().unsetHighlight().run(), [e]), y = ue(
    (k, b) => e.chain().focus().setLink({ href: k, target: b ? "_blank" : "" }).run(),
    [e]
  ), m = ue(
    (k) => !k || k.length === 0 ? e.chain().focus().unsetFontFamily().run() : e.chain().focus().setFontFamily(k).run(),
    [e]
  ), v = ue(
    (k) => !k || k.length === 0 ? e.chain().focus().unsetFontSize().run() : e.chain().focus().setFontSize(k).run(),
    [e]
  );
  return {
    onBold: t,
    onItalic: n,
    onStrike: r,
    onUnderline: i,
    onCodeBlock: a,
    onAlignLeft: o,
    onAlignCenter: s,
    onAlignRight: c,
    onAlignJustify: l,
    onChangeColor: u,
    onClearColor: h,
    onChangeHighlight: p,
    onClearHighlight: f,
    onSetFont: m,
    onSetFontSize: v,
    onLink: y
  };
}, Jie = (e) => wt(
  () => [
    {
      type: "category",
      label: "Hierarchy",
      id: "hierarchy"
    },
    {
      icon: "Pilcrow",
      onClick: () => e.chain().focus().liftListItem("listItem").setParagraph().run(),
      id: "paragraph",
      disabled: () => !e.can().setParagraph(),
      isActive: () => e.isActive("paragraph") && !e.isActive("orderedList") && !e.isActive("bulletList") && !e.isActive("taskList"),
      label: "Paragraph",
      type: "option"
    },
    {
      icon: "Heading1",
      onClick: () => e.chain().focus().liftListItem("listItem").setHeading({ level: 1 }).run(),
      id: "heading1",
      disabled: () => !e.can().setHeading({ level: 1 }),
      isActive: () => e.isActive("heading", { level: 1 }),
      label: "Heading 1",
      type: "option"
    },
    {
      icon: "Heading2",
      onClick: () => e.chain().focus().liftListItem("listItem").setHeading({ level: 2 }).run(),
      id: "heading2",
      disabled: () => !e.can().setHeading({ level: 2 }),
      isActive: () => e.isActive("heading", { level: 2 }),
      label: "Heading 2",
      type: "option"
    },
    {
      icon: "Heading3",
      onClick: () => e.chain().focus().liftListItem("listItem").setHeading({ level: 3 }).run(),
      id: "heading3",
      disabled: () => !e.can().setHeading({ level: 3 }),
      isActive: () => e.isActive("heading", { level: 3 }),
      label: "Heading 3",
      type: "option"
    },
    {
      type: "category",
      label: "Lists",
      id: "lists"
    },
    {
      icon: "List",
      onClick: () => e.chain().focus().toggleBulletList().run(),
      id: "bulletList",
      disabled: () => !e.can().toggleBulletList(),
      isActive: () => e.isActive("bulletList"),
      label: "Bullet list",
      type: "option"
    },
    {
      icon: "ListOrdered",
      onClick: () => e.chain().focus().toggleOrderedList().run(),
      id: "orderedList",
      disabled: () => !e.can().toggleOrderedList(),
      isActive: () => e.isActive("orderedList"),
      label: "Numbered list",
      type: "option"
    }
    // {
    //   icon: 'ListTodo',
    //   onClick: () => editor.chain().focus().toggleTaskList().run(),
    //   id: 'todoList',
    //   disabled: () => !editor.can().toggleTaskList(),
    //   isActive: () => editor.isActive('taskList'),
    //   label: 'Todo list',
    //   type: 'option',
    // },
  ],
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [e, e.state]
), Kie = (e) => {
  let t = e;
  for (; t && !["TD", "TH"].includes(t.tagName); )
    t = t.parentElement;
  const n = t && t.querySelector && t.querySelector("a.grip-column.selected"), r = t && t.querySelector && t.querySelector("a.grip-row.selected");
  return !!(n || r);
}, Qie = (e, t) => [].some((r) => e.isActive(r)) || Kie(t), eoe = ({ editor: e }) => {
  const {
    state: {
      doc: t,
      selection: n,
      selection: { empty: r, from: a, to: i }
    }
  } = e, o = !t.textBetween(a, i).length && l1(n);
  return !(r || o || !e.isEditable);
}, toe = (e) => {
  var n, r, a, i;
  const t = ue(
    ({ view: o, from: s }) => {
      if (!o)
        return !1;
      const c = o.domAtPos(s || 0).node, u = o.nodeDOM(s || 0) || c;
      return Qie(e, u) ? !1 : eoe({ editor: e });
    },
    [e]
  );
  return {
    isBold: e.isActive("bold"),
    isItalic: e.isActive("italic"),
    isStrike: e.isActive("strike"),
    isUnderline: e.isActive("underline"),
    isCode: e.isActive("code"),
    isSubscript: e.isActive("subscript"),
    isSuperscript: e.isActive("superscript"),
    isAlignLeft: e.isActive({ textAlign: "left" }),
    isAlignCenter: e.isActive({ textAlign: "center" }),
    isAlignRight: e.isActive({ textAlign: "right" }),
    isAlignJustify: e.isActive({ textAlign: "justify" }),
    currentColor: ((n = e.getAttributes("textStyle")) == null ? void 0 : n.color) || void 0,
    currentHighlight: ((r = e.getAttributes("highlight")) == null ? void 0 : r.color) || void 0,
    currentFont: ((a = e.getAttributes("textStyle")) == null ? void 0 : a.fontFamily) || void 0,
    currentSize: ((i = e.getAttributes("textStyle")) == null ? void 0 : i.fontSize) || void 0,
    shouldShow: t
  };
}, By = G(Br)`
  padding: 0.25rem;
`, an = ba(zn.Button), noe = ba(Gie), roe = ba(Uie), Hy = ba(zae), aoe = ba(zie), ioe = ({ editor: e }) => {
  const t = Yie(e), n = toe(e), r = Jie(e);
  return /* @__PURE__ */ C(
    GO,
    {
      tippyOptions: { popperOptions: { placement: "top-start" } },
      editor: e,
      pluginKey: "textMenu",
      shouldShow: n.shouldShow,
      updateDelay: 100,
      children: /* @__PURE__ */ ie(zn.Wrapper, { children: [
        /* @__PURE__ */ C(aoe, { options: r }),
        /* @__PURE__ */ C(noe, { onChange: t.onSetFont, value: n.currentFont || "" }),
        /* @__PURE__ */ C(roe, { onChange: t.onSetFontSize, value: n.currentSize || "" }),
        /* @__PURE__ */ C(zn.Divider, {}),
        /* @__PURE__ */ C(an, { tooltip: "Bold", tooltipShortcut: ["Mod", "B"], onClick: t.onBold, active: n.isBold, children: /* @__PURE__ */ C(Ue, { name: "Bold" }) }),
        /* @__PURE__ */ C(
          an,
          {
            tooltip: "Italic",
            tooltipShortcut: ["Mod", "I"],
            onClick: t.onItalic,
            active: n.isItalic,
            children: /* @__PURE__ */ C(Ue, { name: "Italic" })
          }
        ),
        /* @__PURE__ */ C(
          an,
          {
            tooltip: "Underline",
            tooltipShortcut: ["Mod", "U"],
            onClick: t.onUnderline,
            active: n.isUnderline,
            children: /* @__PURE__ */ C(Ue, { name: "Underline" })
          }
        ),
        /* @__PURE__ */ C(
          an,
          {
            tooltip: "Strikehrough",
            tooltipShortcut: ["Mod", "Shift", "S"],
            onClick: t.onStrike,
            active: n.isStrike,
            children: /* @__PURE__ */ C(Ue, { name: "Strikethrough" })
          }
        ),
        /* @__PURE__ */ C(an, { tooltip: "Code block", onClick: t.onCodeBlock, children: /* @__PURE__ */ C(Ue, { name: "CodeXml" }) }),
        /* @__PURE__ */ C(qie, { onSetLink: t.onLink }),
        /* @__PURE__ */ ie(dc, { children: [
          /* @__PURE__ */ C(uc, { asChild: !0, children: /* @__PURE__ */ C(an, { active: !!n.currentHighlight, tooltip: "Highlight text", children: /* @__PURE__ */ C(Ue, { name: "Highlighter" }) }) }),
          /* @__PURE__ */ C(hc, { side: "top", sideOffset: 8, asChild: !0, children: /* @__PURE__ */ C(By, { children: /* @__PURE__ */ C(
            Hy,
            {
              color: n.currentHighlight,
              onChange: t.onChangeHighlight,
              onClear: t.onClearHighlight
            }
          ) }) })
        ] }),
        /* @__PURE__ */ ie(dc, { children: [
          /* @__PURE__ */ C(uc, { asChild: !0, children: /* @__PURE__ */ C(an, { active: !!n.currentColor, tooltip: "Text color", children: /* @__PURE__ */ C(Ue, { name: "Palette" }) }) }),
          /* @__PURE__ */ C(hc, { side: "top", sideOffset: 8, asChild: !0, children: /* @__PURE__ */ C(By, { children: /* @__PURE__ */ C(
            Hy,
            {
              color: n.currentColor,
              onChange: t.onChangeColor,
              onClear: t.onClearColor
            }
          ) }) })
        ] }),
        /* @__PURE__ */ ie(dc, { children: [
          /* @__PURE__ */ C(uc, { asChild: !0, children: /* @__PURE__ */ C(an, { tooltip: "More options", children: /* @__PURE__ */ C(Ue, { name: "EllipsisVertical" }) }) }),
          /* @__PURE__ */ C(hc, { side: "top", asChild: !0, children: /* @__PURE__ */ ie(zn.Wrapper, { children: [
            /* @__PURE__ */ C(zn.Divider, {}),
            /* @__PURE__ */ C(
              an,
              {
                tooltip: "Align left",
                tooltipShortcut: ["Shift", "Mod", "L"],
                onClick: t.onAlignLeft,
                active: n.isAlignLeft,
                children: /* @__PURE__ */ C(Ue, { name: "AlignLeft" })
              }
            ),
            /* @__PURE__ */ C(
              an,
              {
                tooltip: "Align center",
                tooltipShortcut: ["Shift", "Mod", "E"],
                onClick: t.onAlignCenter,
                active: n.isAlignCenter,
                children: /* @__PURE__ */ C(Ue, { name: "AlignCenter" })
              }
            ),
            /* @__PURE__ */ C(
              an,
              {
                tooltip: "Align right",
                tooltipShortcut: ["Shift", "Mod", "R"],
                onClick: t.onAlignRight,
                active: n.isAlignRight,
                children: /* @__PURE__ */ C(Ue, { name: "AlignRight" })
              }
            ),
            /* @__PURE__ */ C(
              an,
              {
                tooltip: "Justify",
                tooltipShortcut: ["Shift", "Mod", "J"],
                onClick: t.onAlignJustify,
                active: n.isAlignJustify,
                children: /* @__PURE__ */ C(Ue, { name: "AlignJustify" })
              }
            )
          ] }) })
        ] })
      ] })
    }
  );
}, ooe = /^\s*>\s$/, soe = rn.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["blockquote", Ke(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: e }) => e.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: e }) => e.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: e }) => e.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      wo({
        find: ooe,
        type: this.type
      })
    ];
  }
}), coe = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, loe = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, doe = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, uoe = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, hoe = Qt.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (e) => e.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight",
        getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["strong", Ke(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: e }) => e.setMark(this.name),
      toggleBold: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetBold: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      ui({
        find: coe,
        type: this.type
      }),
      ui({
        find: doe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ya({
        find: loe,
        type: this.type
      }),
      ya({
        find: uoe,
        type: this.type
      })
    ];
  }
}), poe = rn.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", Ke(this.options.HTMLAttributes, e), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), $y = Qt.create({
  name: "textStyle",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (e) => e.hasAttribute("style") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", Ke(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ state: e, commands: t }) => {
        const n = rs(e, this.type);
        return Object.entries(n).some(([, a]) => !!a) ? !0 : t.unsetMark(this.name);
      }
    };
  }
}), jy = /^\s*([-+*])\s$/, foe = rn.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", Ke(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: e, chain: t }) => this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(poe.name, this.editor.getAttributes($y.name)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let e = wo({
      find: jy,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = wo({
      find: jy,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes($y.name),
      editor: this.editor
    })), [
      e
    ];
  }
}), yoe = /^```([a-z]+)?[\s\n]$/, moe = /^~~~([a-z]+)?[\s\n]$/, goe = rn.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: null,
        parseHTML: (e) => {
          var t;
          const { languageClassPrefix: n } = this.options, i = [...((t = e.firstElementChild) === null || t === void 0 ? void 0 : t.classList) || []].filter((o) => o.startsWith(n)).map((o) => o.replace(n, ""))[0];
          return i || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    return [
      "pre",
      Ke(this.options.HTMLAttributes, t),
      [
        "code",
        {
          class: e.attrs.language ? this.options.languageClassPrefix + e.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (e) => ({ commands: t }) => t.setNode(this.name, e),
      toggleCodeBlock: (e) => ({ commands: t }) => t.toggleNode(this.name, "paragraph", e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: e, $anchor: t } = this.editor.state.selection, n = t.pos === 1;
        return !e || t.parent.type.name !== this.name ? !1 : n || !t.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: e }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: t } = e, { selection: n } = t, { $from: r, empty: a } = n;
        if (!a || r.parent.type !== this.type)
          return !1;
        const i = r.parentOffset === r.parent.nodeSize - 2, o = r.parent.textContent.endsWith(`

`);
        return !i || !o ? !1 : e.chain().command(({ tr: s }) => (s.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: e }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: t } = e, { selection: n, doc: r } = t, { $from: a, empty: i } = n;
        if (!i || a.parent.type !== this.type || !(a.parentOffset === a.parent.nodeSize - 2))
          return !1;
        const s = a.after();
        return s === void 0 || r.nodeAt(s) ? !1 : e.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      zu({
        find: yoe,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      }),
      zu({
        find: moe,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new At({
        key: new nn("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (e, t) => {
            if (!t.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const n = t.clipboardData.getData("text/plain"), r = t.clipboardData.getData("vscode-editor-data"), a = r ? JSON.parse(r) : void 0, i = a == null ? void 0 : a.mode;
            if (!n || !i)
              return !1;
            const { tr: o } = e.state;
            return e.state.selection.from === e.state.doc.nodeSize - (1 + e.state.selection.$to.depth * 2) ? o.insert(e.state.selection.from - 1, this.type.create({ language: i })) : o.replaceSelectionWith(this.type.create({ language: i })), o.setSelection(De.near(o.doc.resolve(Math.max(0, o.selection.from - 2)))), o.insertText(n.replace(/\r\n?/g, `
`)), o.setMeta("paste", !0), e.dispatch(o), !0;
          }
        }
      })
    ];
  }
}), voe = Qt.create({
  name: "textStyle",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (e) => e.hasAttribute("style") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", Ke(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ state: e, commands: t }) => {
        const n = rs(e, this.type);
        return Object.entries(n).some(([, a]) => !!a) ? !0 : t.unsetMark(this.name);
      }
    };
  }
}), koe = kt.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (e) => {
              var t;
              return (t = e.style.color) === null || t === void 0 ? void 0 : t.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.color ? {
              style: `color: ${e.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (e) => ({ chain: t }) => t().setMark("textStyle", { color: e }).run(),
      unsetColor: () => ({ chain: e }) => e().setMark("textStyle", { color: null }).removeEmptyTextStyle().run()
    };
  }
}), boe = rn.create({
  name: "doc",
  topNode: !0,
  content: "block+"
}), xoe = kt.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (e) => {
              var t;
              return (t = e.style.fontFamily) === null || t === void 0 ? void 0 : t.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.fontFamily ? {
              style: `font-family: ${e.fontFamily.split(",").map((t) => CSS.escape(t.trim())).join(", ")}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (e) => ({ chain: t }) => t().setMark("textStyle", { fontFamily: e }).run(),
      unsetFontFamily: () => ({ chain: e }) => e().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run()
    };
  }
});
class et extends Ie {
  /**
  Create a gap cursor.
  */
  constructor(t) {
    super(t, t);
  }
  map(t, n) {
    let r = t.resolve(n.map(this.head));
    return et.valid(r) ? new et(r) : Ie.near(r);
  }
  content() {
    return ye.empty;
  }
  eq(t) {
    return t instanceof et && t.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new et(t.resolve(n.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new Zp(this.anchor);
  }
  /**
  @internal
  */
  static valid(t) {
    let n = t.parent;
    if (n.isTextblock || !Moe(t) || !woe(t))
      return !1;
    let r = n.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let a = n.contentMatchAt(t.index()).defaultType;
    return a && a.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(t, n, r = !1) {
    e:
      for (; ; ) {
        if (!r && et.valid(t))
          return t;
        let a = t.pos, i = null;
        for (let o = t.depth; ; o--) {
          let s = t.node(o);
          if (n > 0 ? t.indexAfter(o) < s.childCount : t.index(o) > 0) {
            i = s.child(n > 0 ? t.indexAfter(o) : t.index(o) - 1);
            break;
          } else if (o == 0)
            return null;
          a += n;
          let c = t.doc.resolve(a);
          if (et.valid(c))
            return c;
        }
        for (; ; ) {
          let o = n > 0 ? i.firstChild : i.lastChild;
          if (!o) {
            if (i.isAtom && !i.isText && !xe.isSelectable(i)) {
              t = t.doc.resolve(a + i.nodeSize * n), r = !1;
              continue e;
            }
            break;
          }
          i = o, a += n;
          let s = t.doc.resolve(a);
          if (et.valid(s))
            return s;
        }
        return null;
      }
  }
}
et.prototype.visible = !1;
et.findFrom = et.findGapCursorFrom;
Ie.jsonID("gapcursor", et);
class Zp {
  constructor(t) {
    this.pos = t;
  }
  map(t) {
    return new Zp(t.map(this.pos));
  }
  resolve(t) {
    let n = t.resolve(this.pos);
    return et.valid(n) ? new et(n) : Ie.near(n);
  }
}
function Moe(e) {
  for (let t = e.depth; t >= 0; t--) {
    let n = e.index(t), r = e.node(t);
    if (n == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let a = r.child(n - 1); ; a = a.lastChild) {
      if (a.childCount == 0 && !a.inlineContent || a.isAtom || a.type.spec.isolating)
        return !0;
      if (a.inlineContent)
        return !1;
    }
  }
  return !0;
}
function woe(e) {
  for (let t = e.depth; t >= 0; t--) {
    let n = e.indexAfter(t), r = e.node(t);
    if (n == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let a = r.child(n); ; a = a.firstChild) {
      if (a.childCount == 0 && !a.inlineContent || a.isAtom || a.type.spec.isolating)
        return !0;
      if (a.inlineContent)
        return !1;
    }
  }
  return !0;
}
function Coe() {
  return new At({
    props: {
      decorations: Eoe,
      createSelectionBetween(e, t, n) {
        return t.pos == n.pos && et.valid(n) ? new et(n) : null;
      },
      handleClick: Aoe,
      handleKeyDown: Soe,
      handleDOMEvents: { beforeinput: Ooe }
    }
  });
}
const Soe = jk({
  ArrowLeft: Ws("horiz", -1),
  ArrowRight: Ws("horiz", 1),
  ArrowUp: Ws("vert", -1),
  ArrowDown: Ws("vert", 1)
});
function Ws(e, t) {
  const n = e == "vert" ? t > 0 ? "down" : "up" : t > 0 ? "right" : "left";
  return function(r, a, i) {
    let o = r.selection, s = t > 0 ? o.$to : o.$from, c = o.empty;
    if (o instanceof De) {
      if (!i.endOfTextblock(n) || s.depth == 0)
        return !1;
      c = !1, s = r.doc.resolve(t > 0 ? s.after() : s.before());
    }
    let l = et.findGapCursorFrom(s, t, c);
    return l ? (a && a(r.tr.setSelection(new et(l))), !0) : !1;
  };
}
function Aoe(e, t, n) {
  if (!e || !e.editable)
    return !1;
  let r = e.state.doc.resolve(t);
  if (!et.valid(r))
    return !1;
  let a = e.posAtCoords({ left: n.clientX, top: n.clientY });
  return a && a.inside > -1 && xe.isSelectable(e.state.doc.nodeAt(a.inside)) ? !1 : (e.dispatch(e.state.tr.setSelection(new et(r))), !0);
}
function Ooe(e, t) {
  if (t.inputType != "insertCompositionText" || !(e.state.selection instanceof et))
    return !1;
  let { $from: n } = e.state.selection, r = n.parent.contentMatchAt(n.index()).findWrapping(e.state.schema.nodes.text);
  if (!r)
    return !1;
  let a = oe.empty;
  for (let o = r.length - 1; o >= 0; o--)
    a = oe.from(r[o].createAndFill(null, a));
  let i = e.state.tr.replace(n.pos, n.pos, new ye(a, 0, 0));
  return i.setSelection(De.near(i.doc.resolve(n.pos + 1))), e.dispatch(i), !1;
}
function Eoe(e) {
  if (!(e.selection instanceof et))
    return null;
  let t = document.createElement("div");
  return t.className = "ProseMirror-gapcursor", tt.create(e.doc, [Ht.widget(e.selection.head, t, { key: "gapcursor" })]);
}
const Ioe = kt.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      Coe()
    ];
  },
  extendNodeSchema(e) {
    var t;
    const n = {
      name: e.name,
      options: e.options,
      storage: e.storage
    };
    return {
      allowGapCursor: (t = Ee(ge(e, "allowGapCursor", n))) !== null && t !== void 0 ? t : null
    };
  }
}), Doe = rn.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((e) => ({
      tag: `h${e}`,
      attrs: { level: e }
    }));
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    return [`h${this.options.levels.includes(e.attrs.level) ? e.attrs.level : this.options.levels[0]}`, Ke(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.setNode(this.name, e) : !1,
      toggleHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.toggleNode(this.name, "paragraph", e) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((e, t) => ({
      ...e,
      [`Mod-Alt-${t}`]: () => this.editor.commands.toggleHeading({ level: t })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((e) => zu({
      find: new RegExp(`^(#{1,${e}})\\s$`),
      type: this.type,
      getAttributes: {
        level: e
      }
    }));
  }
}), Toe = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))$/, Noe = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))/g, Poe = Qt.create({
  name: "highlight",
  addOptions() {
    return {
      multicolor: !1,
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return this.options.multicolor ? {
      color: {
        default: null,
        parseHTML: (e) => e.getAttribute("data-color") || e.style.backgroundColor,
        renderHTML: (e) => e.color ? {
          "data-color": e.color,
          style: `background-color: ${e.color}; color: inherit`
        } : {}
      }
    } : {};
  },
  parseHTML() {
    return [
      {
        tag: "mark"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["mark", Ke(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHighlight: (e) => ({ commands: t }) => t.setMark(this.name, e),
      toggleHighlight: (e) => ({ commands: t }) => t.toggleMark(this.name, e),
      unsetHighlight: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-h": () => this.editor.commands.toggleHighlight()
    };
  },
  addInputRules() {
    return [
      ui({
        find: Toe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ya({
        find: Noe,
        type: this.type
      })
    ];
  }
}), Loe = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, G5 = rn.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {}
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["img", Ke(this.options.HTMLAttributes, e)];
  },
  addCommands() {
    return {
      setImage: (e) => ({ commands: t }) => t.insertContent({
        type: this.name,
        attrs: e
      })
    };
  },
  addInputRules() {
    return [
      eA({
        find: Loe,
        type: this.type,
        getAttributes: (e) => {
          const [, , t, n, r] = e;
          return { src: n, alt: t, title: r };
        }
      })
    ];
  }
}), Roe = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, Voe = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, zoe = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, Boe = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, Hoe = Qt.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (e) => e.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["em", Ke(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: e }) => e.setMark(this.name),
      toggleItalic: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetItalic: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      ui({
        find: Roe,
        type: this.type
      }),
      ui({
        find: zoe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ya({
        find: Voe,
        type: this.type
      }),
      ya({
        find: Boe,
        type: this.type
      })
    ];
  }
}), $oe = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4vianca6w0s2x0a2z0ure5ba0by2idu3namex3narepublic11d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2ntley5rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0cast4mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dabur3d1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0ardian6cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6logistics9properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3ncaster6d0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2psy3ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2tura4vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9dnavy5lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0a1b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp2w2ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4finity6ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", joe = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", bi = (e, t) => {
  for (const n in t)
    e[n] = t[n];
  return e;
}, rh = "numeric", ah = "ascii", ih = "alpha", pc = "asciinumeric", qs = "alphanumeric", oh = "domain", Z5 = "emoji", Foe = "scheme", Woe = "slashscheme", Fy = "whitespace";
function qoe(e, t) {
  return e in t || (t[e] = []), t[e];
}
function Qr(e, t, n) {
  t[rh] && (t[pc] = !0, t[qs] = !0), t[ah] && (t[pc] = !0, t[ih] = !0), t[pc] && (t[qs] = !0), t[ih] && (t[qs] = !0), t[qs] && (t[oh] = !0), t[Z5] && (t[oh] = !0);
  for (const r in t) {
    const a = qoe(r, n);
    a.indexOf(e) < 0 && a.push(e);
  }
}
function _oe(e, t) {
  const n = {};
  for (const r in t)
    t[r].indexOf(e) >= 0 && (n[r] = !0);
  return n;
}
function Bt(e) {
  e === void 0 && (e = null), this.j = {}, this.jr = [], this.jd = null, this.t = e;
}
Bt.groups = {};
Bt.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(e) {
    const t = this, n = t.j[e];
    if (n)
      return n;
    for (let r = 0; r < t.jr.length; r++) {
      const a = t.jr[r][0], i = t.jr[r][1];
      if (i && a.test(e))
        return i;
    }
    return t.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(e, t) {
    return t === void 0 && (t = !1), t ? e in this.j : !!this.go(e);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(e, t, n, r) {
    for (let a = 0; a < e.length; a++)
      this.tt(e[a], t, n, r);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(e, t, n, r) {
    r = r || Bt.groups;
    let a;
    return t && t.j ? a = t : (a = new Bt(t), n && r && Qr(t, n, r)), this.jr.push([e, a]), a;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(e, t, n, r) {
    let a = this;
    const i = e.length;
    if (!i)
      return a;
    for (let o = 0; o < i - 1; o++)
      a = a.tt(e[o]);
    return a.tt(e[i - 1], t, n, r);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(e, t, n, r) {
    r = r || Bt.groups;
    const a = this;
    if (t && t.j)
      return a.j[e] = t, t;
    const i = t;
    let o, s = a.go(e);
    if (s ? (o = new Bt(), bi(o.j, s.j), o.jr.push.apply(o.jr, s.jr), o.jd = s.jd, o.t = s.t) : o = new Bt(), i) {
      if (r)
        if (o.t && typeof o.t == "string") {
          const c = bi(_oe(o.t, r), n);
          Qr(i, c, r);
        } else
          n && Qr(i, n, r);
      o.t = i;
    }
    return a.j[e] = o, o;
  }
};
const Oe = (e, t, n, r, a) => e.ta(t, n, r, a), on = (e, t, n, r, a) => e.tr(t, n, r, a), Wy = (e, t, n, r, a) => e.ts(t, n, r, a), ce = (e, t, n, r, a) => e.tt(t, n, r, a), Yn = "WORD", sh = "UWORD", Po = "LOCALHOST", ch = "TLD", lh = "UTLD", fc = "SCHEME", _a = "SLASH_SCHEME", Xp = "NUM", X5 = "WS", Up = "NL", co = "OPENBRACE", lo = "CLOSEBRACE", Uc = "OPENBRACKET", Yc = "CLOSEBRACKET", Jc = "OPENPAREN", Kc = "CLOSEPAREN", Qc = "OPENANGLEBRACKET", el = "CLOSEANGLEBRACKET", tl = "FULLWIDTHLEFTPAREN", nl = "FULLWIDTHRIGHTPAREN", rl = "LEFTCORNERBRACKET", al = "RIGHTCORNERBRACKET", il = "LEFTWHITECORNERBRACKET", ol = "RIGHTWHITECORNERBRACKET", sl = "FULLWIDTHLESSTHAN", cl = "FULLWIDTHGREATERTHAN", ll = "AMPERSAND", dl = "APOSTROPHE", ul = "ASTERISK", gr = "AT", hl = "BACKSLASH", pl = "BACKTICK", fl = "CARET", kr = "COLON", Yp = "COMMA", yl = "DOLLAR", An = "DOT", ml = "EQUALS", Jp = "EXCLAMATION", On = "HYPHEN", gl = "PERCENT", vl = "PIPE", kl = "PLUS", bl = "POUND", xl = "QUERY", Kp = "QUOTE", Qp = "SEMI", En = "SLASH", uo = "TILDE", Ml = "UNDERSCORE", U5 = "EMOJI", wl = "SYM";
var Y5 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  WORD: Yn,
  UWORD: sh,
  LOCALHOST: Po,
  TLD: ch,
  UTLD: lh,
  SCHEME: fc,
  SLASH_SCHEME: _a,
  NUM: Xp,
  WS: X5,
  NL: Up,
  OPENBRACE: co,
  CLOSEBRACE: lo,
  OPENBRACKET: Uc,
  CLOSEBRACKET: Yc,
  OPENPAREN: Jc,
  CLOSEPAREN: Kc,
  OPENANGLEBRACKET: Qc,
  CLOSEANGLEBRACKET: el,
  FULLWIDTHLEFTPAREN: tl,
  FULLWIDTHRIGHTPAREN: nl,
  LEFTCORNERBRACKET: rl,
  RIGHTCORNERBRACKET: al,
  LEFTWHITECORNERBRACKET: il,
  RIGHTWHITECORNERBRACKET: ol,
  FULLWIDTHLESSTHAN: sl,
  FULLWIDTHGREATERTHAN: cl,
  AMPERSAND: ll,
  APOSTROPHE: dl,
  ASTERISK: ul,
  AT: gr,
  BACKSLASH: hl,
  BACKTICK: pl,
  CARET: fl,
  COLON: kr,
  COMMA: Yp,
  DOLLAR: yl,
  DOT: An,
  EQUALS: ml,
  EXCLAMATION: Jp,
  HYPHEN: On,
  PERCENT: gl,
  PIPE: vl,
  PLUS: kl,
  POUND: bl,
  QUERY: xl,
  QUOTE: Kp,
  SEMI: Qp,
  SLASH: En,
  TILDE: uo,
  UNDERSCORE: Ml,
  EMOJI: U5,
  SYM: wl
});
const Ra = /[a-z]/, Bd = /\p{L}/u, Hd = /\p{Emoji}/u, $d = /\d/, qy = /\s/, _y = `
`, Goe = "️", Zoe = "‍";
let _s = null, Gs = null;
function Xoe(e) {
  e === void 0 && (e = []);
  const t = {};
  Bt.groups = t;
  const n = new Bt();
  _s == null && (_s = Gy($oe)), Gs == null && (Gs = Gy(joe)), ce(n, "'", dl), ce(n, "{", co), ce(n, "}", lo), ce(n, "[", Uc), ce(n, "]", Yc), ce(n, "(", Jc), ce(n, ")", Kc), ce(n, "<", Qc), ce(n, ">", el), ce(n, "（", tl), ce(n, "）", nl), ce(n, "「", rl), ce(n, "」", al), ce(n, "『", il), ce(n, "』", ol), ce(n, "＜", sl), ce(n, "＞", cl), ce(n, "&", ll), ce(n, "*", ul), ce(n, "@", gr), ce(n, "`", pl), ce(n, "^", fl), ce(n, ":", kr), ce(n, ",", Yp), ce(n, "$", yl), ce(n, ".", An), ce(n, "=", ml), ce(n, "!", Jp), ce(n, "-", On), ce(n, "%", gl), ce(n, "|", vl), ce(n, "+", kl), ce(n, "#", bl), ce(n, "?", xl), ce(n, '"', Kp), ce(n, "/", En), ce(n, ";", Qp), ce(n, "~", uo), ce(n, "_", Ml), ce(n, "\\", hl);
  const r = on(n, $d, Xp, {
    [rh]: !0
  });
  on(r, $d, r);
  const a = on(n, Ra, Yn, {
    [ah]: !0
  });
  on(a, Ra, a);
  const i = on(n, Bd, sh, {
    [ih]: !0
  });
  on(i, Ra), on(i, Bd, i);
  const o = on(n, qy, X5, {
    [Fy]: !0
  });
  ce(n, _y, Up, {
    [Fy]: !0
  }), ce(o, _y), on(o, qy, o);
  const s = on(n, Hd, U5, {
    [Z5]: !0
  });
  on(s, Hd, s), ce(s, Goe, s);
  const c = ce(s, Zoe);
  on(c, Hd, s);
  const l = [[Ra, a]], u = [[Ra, null], [Bd, i]];
  for (let h = 0; h < _s.length; h++)
    hr(n, _s[h], ch, Yn, l);
  for (let h = 0; h < Gs.length; h++)
    hr(n, Gs[h], lh, sh, u);
  Qr(ch, {
    tld: !0,
    ascii: !0
  }, t), Qr(lh, {
    utld: !0,
    alpha: !0
  }, t), hr(n, "file", fc, Yn, l), hr(n, "mailto", fc, Yn, l), hr(n, "http", _a, Yn, l), hr(n, "https", _a, Yn, l), hr(n, "ftp", _a, Yn, l), hr(n, "ftps", _a, Yn, l), Qr(fc, {
    scheme: !0,
    ascii: !0
  }, t), Qr(_a, {
    slashscheme: !0,
    ascii: !0
  }, t), e = e.sort((h, p) => h[0] > p[0] ? 1 : -1);
  for (let h = 0; h < e.length; h++) {
    const p = e[h][0], y = e[h][1] ? {
      [Foe]: !0
    } : {
      [Woe]: !0
    };
    p.indexOf("-") >= 0 ? y[oh] = !0 : Ra.test(p) ? $d.test(p) ? y[pc] = !0 : y[ah] = !0 : y[rh] = !0, Wy(n, p, p, y);
  }
  return Wy(n, "localhost", Po, {
    ascii: !0
  }), n.jd = new Bt(wl), {
    start: n,
    tokens: bi({
      groups: t
    }, Y5)
  };
}
function Uoe(e, t) {
  const n = Yoe(t.replace(/[A-Z]/g, (s) => s.toLowerCase())), r = n.length, a = [];
  let i = 0, o = 0;
  for (; o < r; ) {
    let s = e, c = null, l = 0, u = null, h = -1, p = -1;
    for (; o < r && (c = s.go(n[o])); )
      s = c, s.accepts() ? (h = 0, p = 0, u = s) : h >= 0 && (h += n[o].length, p++), l += n[o].length, i += n[o].length, o++;
    i -= h, o -= p, l -= h, a.push({
      t: u.t,
      // token type/name
      v: t.slice(i - l, i),
      // string value
      s: i - l,
      // start index
      e: i
      // end index (excluding)
    });
  }
  return a;
}
function Yoe(e) {
  const t = [], n = e.length;
  let r = 0;
  for (; r < n; ) {
    let a = e.charCodeAt(r), i, o = a < 55296 || a > 56319 || r + 1 === n || (i = e.charCodeAt(r + 1)) < 56320 || i > 57343 ? e[r] : e.slice(r, r + 2);
    t.push(o), r += o.length;
  }
  return t;
}
function hr(e, t, n, r, a) {
  let i;
  const o = t.length;
  for (let s = 0; s < o - 1; s++) {
    const c = t[s];
    e.j[c] ? i = e.j[c] : (i = new Bt(r), i.jr = a.slice(), e.j[c] = i), e = i;
  }
  return i = new Bt(n), i.jr = a.slice(), e.j[t[o - 1]] = i, i;
}
function Gy(e) {
  const t = [], n = [];
  let r = 0, a = "0123456789";
  for (; r < e.length; ) {
    let i = 0;
    for (; a.indexOf(e[r + i]) >= 0; )
      i++;
    if (i > 0) {
      t.push(n.join(""));
      for (let o = parseInt(e.substring(r, r + i), 10); o > 0; o--)
        n.pop();
      r += i;
    } else
      n.push(e[r]), r++;
  }
  return t;
}
const Lo = {
  defaultProtocol: "http",
  events: null,
  format: Zy,
  formatHref: Zy,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function e2(e, t) {
  t === void 0 && (t = null);
  let n = bi({}, Lo);
  e && (n = bi(n, e instanceof e2 ? e.o : e));
  const r = n.ignoreTags, a = [];
  for (let i = 0; i < r.length; i++)
    a.push(r[i].toUpperCase());
  this.o = n, t && (this.defaultRender = t), this.ignoreTags = a;
}
e2.prototype = {
  o: Lo,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(e) {
    return e;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(e) {
    return this.get("validate", e.toString(), e);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(e, t, n) {
    const r = t != null;
    let a = this.o[e];
    return a && (typeof a == "object" ? (a = n.t in a ? a[n.t] : Lo[e], typeof a == "function" && r && (a = a(t, n))) : typeof a == "function" && r && (a = a(t, n.t, n)), a);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(e, t, n) {
    let r = this.o[e];
    return typeof r == "function" && t != null && (r = r(t, n.t, n)), r;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(e) {
    const t = e.render(this);
    return (this.get("render", null, e) || this.defaultRender)(t, e.t, e);
  }
};
function Zy(e) {
  return e;
}
function J5(e, t) {
  this.t = "token", this.v = e, this.tk = t;
}
J5.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
  */
  toHref(e) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(e) {
    const t = this.toString(), n = e.get("truncate", t, this), r = e.get("format", t, this);
    return n && r.length > n ? r.substring(0, n) + "…" : r;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(e) {
    return e.get("formatHref", this.toHref(e.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(e) {
    return e === void 0 && (e = Lo.defaultProtocol), {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(e) {
    return {
      type: this.t,
      value: this.toFormattedString(e),
      isLink: this.isLink,
      href: this.toFormattedHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(e) {
    return e.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(e) {
    const t = this, n = this.toHref(e.get("defaultProtocol")), r = e.get("formatHref", n, this), a = e.get("tagName", n, t), i = this.toFormattedString(e), o = {}, s = e.get("className", n, t), c = e.get("target", n, t), l = e.get("rel", n, t), u = e.getObj("attributes", n, t), h = e.getObj("events", n, t);
    return o.href = r, s && (o.class = s), c && (o.target = c), l && (o.rel = l), u && bi(o, u), {
      tagName: a,
      attributes: o,
      content: i,
      eventListeners: h
    };
  }
};
function M1(e, t) {
  class n extends J5 {
    constructor(a, i) {
      super(a, i), this.t = e;
    }
  }
  for (const r in t)
    n.prototype[r] = t[r];
  return n.t = e, n;
}
const Xy = M1("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), Uy = M1("text"), Joe = M1("nl"), Zs = M1("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(e) {
    return e === void 0 && (e = Lo.defaultProtocol), this.hasProtocol() ? this.v : `${e}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const e = this.tk;
    return e.length >= 2 && e[0].t !== Po && e[1].t === kr;
  }
}), sn = (e) => new Bt(e);
function Koe(e) {
  let {
    groups: t
  } = e;
  const n = t.domain.concat([ll, ul, gr, hl, pl, fl, yl, ml, On, Xp, gl, vl, kl, bl, En, wl, uo, Ml]), r = [dl, kr, Yp, An, Jp, xl, Kp, Qp, Qc, el, co, lo, Yc, Uc, Jc, Kc, tl, nl, rl, al, il, ol, sl, cl], a = [ll, dl, ul, hl, pl, fl, yl, ml, On, co, lo, gl, vl, kl, bl, xl, En, wl, uo, Ml], i = sn(), o = ce(i, uo);
  Oe(o, a, o), Oe(o, t.domain, o);
  const s = sn(), c = sn(), l = sn();
  Oe(i, t.domain, s), Oe(i, t.scheme, c), Oe(i, t.slashscheme, l), Oe(s, a, o), Oe(s, t.domain, s);
  const u = ce(s, gr);
  ce(o, gr, u), ce(c, gr, u), ce(l, gr, u);
  const h = ce(o, An);
  Oe(h, a, o), Oe(h, t.domain, o);
  const p = sn();
  Oe(u, t.domain, p), Oe(p, t.domain, p);
  const f = ce(p, An);
  Oe(f, t.domain, p);
  const y = sn(Xy);
  Oe(f, t.tld, y), Oe(f, t.utld, y), ce(u, Po, y);
  const m = ce(p, On);
  Oe(m, t.domain, p), Oe(y, t.domain, p), ce(y, An, f), ce(y, On, m);
  const v = ce(y, kr);
  Oe(v, t.numeric, Xy);
  const k = ce(s, On), b = ce(s, An);
  Oe(k, t.domain, s), Oe(b, a, o), Oe(b, t.domain, s);
  const x = sn(Zs);
  Oe(b, t.tld, x), Oe(b, t.utld, x), Oe(x, t.domain, s), Oe(x, a, o), ce(x, An, b), ce(x, On, k), ce(x, gr, u);
  const g = ce(x, kr), w = sn(Zs);
  Oe(g, t.numeric, w);
  const M = sn(Zs), S = sn();
  Oe(M, n, M), Oe(M, r, S), Oe(S, n, M), Oe(S, r, S), ce(x, En, M), ce(w, En, M);
  const D = ce(c, kr), A = ce(l, kr), $ = ce(A, En), F = ce($, En);
  Oe(c, t.domain, s), ce(c, An, b), ce(c, On, k), Oe(l, t.domain, s), ce(l, An, b), ce(l, On, k), Oe(D, t.domain, M), ce(D, En, M), Oe(F, t.domain, M), Oe(F, n, M), ce(F, En, M);
  const Z = [
    [co, lo],
    // {}
    [Uc, Yc],
    // []
    [Jc, Kc],
    // ()
    [Qc, el],
    // <>
    [tl, nl],
    // （）
    [rl, al],
    // 「」
    [il, ol],
    // 『』
    [sl, cl]
    // ＜＞
  ];
  for (let B = 0; B < Z.length; B++) {
    const [O, I] = Z[B], N = ce(M, O);
    ce(S, O, N), ce(N, I, M);
    const R = sn(Zs);
    Oe(N, n, R);
    const L = sn();
    Oe(N, r), Oe(R, n, R), Oe(R, r, L), Oe(L, n, R), Oe(L, r, L), ce(R, I, M), ce(L, I, M);
  }
  return ce(i, Po, x), ce(i, Up, Joe), {
    start: i,
    tokens: Y5
  };
}
function Qoe(e, t, n) {
  let r = n.length, a = 0, i = [], o = [];
  for (; a < r; ) {
    let s = e, c = null, l = null, u = 0, h = null, p = -1;
    for (; a < r && !(c = s.go(n[a].t)); )
      o.push(n[a++]);
    for (; a < r && (l = c || s.go(n[a].t)); )
      c = null, s = l, s.accepts() ? (p = 0, h = s) : p >= 0 && p++, a++, u++;
    if (p < 0)
      a -= u, a < r && (o.push(n[a]), a++);
    else {
      o.length > 0 && (i.push(jd(Uy, t, o)), o = []), a -= p, u -= p;
      const f = h.t, y = n.slice(a - u, a);
      i.push(jd(f, t, y));
    }
  }
  return o.length > 0 && i.push(jd(Uy, t, o)), i;
}
function jd(e, t, n) {
  const r = n[0].s, a = n[n.length - 1].e, i = t.slice(r, a);
  return new e(i, n);
}
const ese = typeof console < "u" && console && console.warn || (() => {
}), tse = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", Je = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function nse() {
  Bt.groups = {}, Je.scanner = null, Je.parser = null, Je.tokenQueue = [], Je.pluginQueue = [], Je.customSchemes = [], Je.initialized = !1;
}
function Yy(e, t) {
  if (t === void 0 && (t = !1), Je.initialized && ese(`linkifyjs: already initialized - will not register custom scheme "${e}" ${tse}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(e))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  Je.customSchemes.push([e, t]);
}
function rse() {
  Je.scanner = Xoe(Je.customSchemes);
  for (let e = 0; e < Je.tokenQueue.length; e++)
    Je.tokenQueue[e][1]({
      scanner: Je.scanner
    });
  Je.parser = Koe(Je.scanner.tokens);
  for (let e = 0; e < Je.pluginQueue.length; e++)
    Je.pluginQueue[e][1]({
      scanner: Je.scanner,
      parser: Je.parser
    });
  Je.initialized = !0;
}
function K5(e) {
  return Je.initialized || rse(), Qoe(Je.parser.start, e, Uoe(Je.scanner.start, e));
}
function Q5(e, t, n) {
  if (t === void 0 && (t = null), n === void 0 && (n = null), t && typeof t == "object") {
    if (n)
      throw Error(`linkifyjs: Invalid link type ${t}; must be a string`);
    n = t, t = null;
  }
  const r = new e2(n), a = K5(e), i = [];
  for (let o = 0; o < a.length; o++) {
    const s = a[o];
    s.isLink && (!t || s.t === t) && r.check(s) && i.push(s.toFormattedObject(r));
  }
  return i;
}
function ase(e) {
  return e.length === 1 ? e[0].isLink : e.length === 3 && e[1].isLink ? ["()", "[]"].includes(e[0].value + e[2].value) : !1;
}
function ise(e) {
  return new At({
    key: new nn("autolink"),
    appendTransaction: (t, n, r) => {
      const a = t.some((l) => l.docChanged) && !n.doc.eq(r.doc), i = t.some((l) => l.getMeta("preventAutolink"));
      if (!a || i)
        return;
      const { tr: o } = r, s = hS(n.doc, [...t]);
      if (xS(s).forEach(({ newRange: l }) => {
        const u = fS(r.doc, l, (f) => f.isTextblock);
        let h, p;
        if (u.length > 1 ? (h = u[0], p = r.doc.textBetween(h.pos, h.pos + h.node.nodeSize, void 0, " ")) : u.length && r.doc.textBetween(l.from, l.to, " ", " ").endsWith(" ") && (h = u[0], p = r.doc.textBetween(h.pos, l.to, void 0, " ")), h && p) {
          const f = p.split(" ").filter((k) => k !== "");
          if (f.length <= 0)
            return !1;
          const y = f[f.length - 1], m = h.pos + p.lastIndexOf(y);
          if (!y)
            return !1;
          const v = K5(y).map((k) => k.toObject());
          if (!ase(v))
            return !1;
          v.filter((k) => k.isLink).map((k) => ({
            ...k,
            from: m + k.start + 1,
            to: m + k.end + 1
          })).filter((k) => r.schema.marks.code ? !r.doc.rangeHasMark(k.from, k.to, r.schema.marks.code) : !0).filter((k) => e.validate ? e.validate(k.value) : !0).forEach((k) => {
            kp(k.from, k.to, r.doc).some((b) => b.mark.type === e.type) || o.addMark(k.from, k.to, e.type.create({
              href: k.href
            }));
          });
        }
      }), !!o.steps.length)
        return o;
    }
  });
}
function ose(e) {
  return new At({
    key: new nn("handleClickLink"),
    props: {
      handleClick: (t, n, r) => {
        var a, i;
        if (e.whenNotEditable && t.editable || r.button !== 0)
          return !1;
        let o = r.target;
        const s = [];
        for (; o.nodeName !== "DIV"; )
          s.push(o), o = o.parentNode;
        if (!s.find((p) => p.nodeName === "A"))
          return !1;
        const c = n4(t.state, e.type.name), l = r.target, u = (a = l == null ? void 0 : l.href) !== null && a !== void 0 ? a : c.href, h = (i = l == null ? void 0 : l.target) !== null && i !== void 0 ? i : c.target;
        return l && u ? (window.open(u, h), !0) : !1;
      }
    }
  });
}
function sse(e) {
  return new At({
    key: new nn("handlePasteLink"),
    props: {
      handlePaste: (t, n, r) => {
        const { state: a } = t, { selection: i } = a, { empty: o } = i;
        if (o)
          return !1;
        let s = "";
        r.content.forEach((l) => {
          s += l.textContent;
        });
        const c = Q5(s).find((l) => l.isLink && l.value === s);
        return !s || !c ? !1 : (e.editor.commands.setMark(e.type, {
          href: c.href
        }), !0);
      }
    }
  });
}
const cse = Qt.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  onCreate() {
    this.options.protocols.forEach((e) => {
      if (typeof e == "string") {
        Yy(e);
        return;
      }
      Yy(e.scheme, e.optionalSlashes);
    });
  },
  onDestroy() {
    nse();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      validate: void 0
    };
  },
  addAttributes() {
    return {
      href: {
        default: null
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [{ tag: 'a[href]:not([href *= "javascript:" i])' }];
  },
  renderHTML({ HTMLAttributes: e }) {
    var t;
    return !((t = e.href) === null || t === void 0) && t.startsWith("javascript:") ? ["a", Ke(this.options.HTMLAttributes, { ...e, href: "" }), 0] : ["a", Ke(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setLink: (e) => ({ chain: t }) => t().setMark(this.name, e).setMeta("preventAutolink", !0).run(),
      toggleLink: (e) => ({ chain: t }) => t().toggleMark(this.name, e, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run(),
      unsetLink: () => ({ chain: e }) => e().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      ya({
        find: (e) => {
          const t = [];
          if (e) {
            const n = Q5(e).filter((r) => r.isLink);
            n.length && n.forEach((r) => t.push({
              text: r.value,
              data: {
                href: r.href
              },
              index: r.start
            }));
          }
          return t;
        },
        type: this.type,
        getAttributes: (e) => {
          var t;
          return {
            href: (t = e.data) === null || t === void 0 ? void 0 : t.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const e = [];
    return this.options.autolink && e.push(ise({
      type: this.type,
      validate: this.options.validate
    })), this.options.openOnClick && e.push(ose({
      type: this.type,
      whenNotEditable: this.options.openOnClick === "whenNotEditable"
    })), this.options.linkOnPaste && e.push(sse({
      editor: this.editor,
      type: this.type
    })), e;
  }
}), lse = rn.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", Ke(this.options.HTMLAttributes, e), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), dse = rn.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", Ke(this.options.HTMLAttributes, e), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), Jy = Qt.create({
  name: "textStyle",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (e) => e.hasAttribute("style") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", Ke(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ state: e, commands: t }) => {
        const n = rs(e, this.type);
        return Object.entries(n).some(([, a]) => !!a) ? !0 : t.unsetMark(this.name);
      }
    };
  }
}), Ky = /^(\d+)\.\s$/, use = rn.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (e) => e.hasAttribute("start") ? parseInt(e.getAttribute("start") || "", 10) : 1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    const { start: t, ...n } = e;
    return t === 1 ? ["ol", Ke(this.options.HTMLAttributes, n), 0] : ["ol", Ke(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: e, chain: t }) => this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(dse.name, this.editor.getAttributes(Jy.name)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let e = wo({
      find: Ky,
      type: this.type,
      getAttributes: (t) => ({ start: +t[1] }),
      joinPredicate: (t, n) => n.childCount + n.attrs.start === +t[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = wo({
      find: Ky,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (t) => ({ start: +t[1], ...this.editor.getAttributes(Jy.name) }),
      joinPredicate: (t, n) => n.childCount + n.attrs.start === +t[1],
      editor: this.editor
    })), [
      e
    ];
  }
}), hse = rn.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["p", Ke(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: e }) => e.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), pse = kt.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      considerAnyAsEmpty: !1,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    return [
      new At({
        key: new nn("placeholder"),
        props: {
          decorations: ({ doc: e, selection: t }) => {
            var n;
            const r = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: a } = t, i = [];
            if (!r)
              return null;
            const { firstChild: o } = e.content, s = o && o.type.isLeaf, c = o && o.isAtom, l = this.options.considerAnyAsEmpty ? !0 : o && o.type.name === ((n = e.type.contentMatch.defaultType) === null || n === void 0 ? void 0 : n.name), u = e.content.childCount <= 1 && o && l && o.nodeSize <= 2 && (!s || !c);
            return e.descendants((h, p) => {
              const f = a >= p && a <= p + h.nodeSize, y = !h.isLeaf && !h.childCount;
              if ((f || !this.options.showOnlyCurrent) && y) {
                const m = [this.options.emptyNodeClass];
                u && m.push(this.options.emptyEditorClass);
                const v = Ht.node(p, p + h.nodeSize, {
                  class: m.join(" "),
                  "data-placeholder": typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: h,
                    pos: p,
                    hasAnchor: f
                  }) : this.options.placeholder
                });
                i.push(v);
              }
              return this.options.includeChildren;
            }), tt.create(e, i);
          }
        }
      })
    ];
  }
}), fse = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, yse = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, mse = Qt.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["s", Ke(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: e }) => e.setMark(this.name),
      toggleStrike: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetStrike: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      ui({
        find: fse,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ya({
        find: yse,
        type: this.type
      })
    ];
  }
}), gse = rn.create({
  name: "text",
  group: "inline"
}), vse = kt.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: "left"
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (e) => e.style.textAlign || this.options.defaultAlignment,
            renderHTML: (e) => e.textAlign === this.options.defaultAlignment ? {} : { style: `text-align: ${e.textAlign}` }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (e) => ({ commands: t }) => this.options.alignments.includes(e) ? this.options.types.map((n) => t.updateAttributes(n, { textAlign: e })).every((n) => n) : !1,
      unsetTextAlign: () => ({ commands: e }) => this.options.types.map((t) => e.resetAttributes(t, "textAlign")).every((t) => t)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), kse = Qt.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["u", Ke(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: e }) => e.setMark(this.name),
      toggleUnderline: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetUnderline: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
}), bse = kt.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: ["paragraph"],
        attributes: {
          class: {}
        }
      },
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            parseHTML: (e) => e.style.fontSize.replace(/['"]+/g, ""),
            renderHTML: (e) => e.fontSize ? {
              style: `font-size: ${e.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (e) => ({ chain: t }) => t().setMark("textStyle", { fontSize: e }).run(),
      unsetFontSize: () => ({ chain: e }) => e().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run()
    };
  }
}), xse = G5.extend({
  group: "block"
}), Mse = G.div`
  width: ${(e) => e.width};
  ${(e) => e.align === "left" ? "margin-left: auto;" : "margin-left: 0;"}
  ${(e) => e.align === "right" ? "margin-right: auto" : "margin-right: 0;"}
  ${(e) => e.align === "center" && "margin-top: auto; margin-bottom: auto;"}

  img {
    display: block;
  }
`, wse = (e) => {
  const { editor: t, getPos: n, node: r } = e, a = he(null), { src: i } = r.attrs, o = ue(() => {
    t.commands.setNodeSelection(n());
  }, [n, t.commands]);
  return /* @__PURE__ */ C(O4, { children: /* @__PURE__ */ C(Mse, { align: r.attrs.align, width: r.attrs.width, children: /* @__PURE__ */ C("div", { contentEditable: !1, ref: a, children: /* @__PURE__ */ C("img", { src: i, alt: "", onClick: o }) }) }) });
}, Cse = xse.extend({
  name: "imageBlock",
  group: "block",
  defining: !0,
  isolating: !0,
  addAttributes() {
    return {
      src: {
        default: "",
        parseHTML: (e) => e.getAttribute("src"),
        renderHTML: (e) => ({
          src: e.src
        })
      },
      width: {
        default: "100%",
        parseHTML: (e) => e.getAttribute("data-width"),
        renderHTML: (e) => ({
          "data-width": e.width
        })
      },
      align: {
        default: "center",
        parseHTML: (e) => e.getAttribute("data-align"),
        renderHTML: (e) => ({
          "data-align": e.align
        })
      },
      alt: {
        default: void 0,
        parseHTML: (e) => e.getAttribute("alt"),
        renderHTML: (e) => ({
          alt: e.alt
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: 'img[src*="tiptap.dev"]:not([src^="data:"]), img[src*="windows.net"]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["img", Ke(this.options.HTMLAttributes, e)];
  },
  addCommands() {
    return {
      setImageBlock: (e) => ({ commands: t }) => t.insertContent({ type: "imageBlock", attrs: { src: e.src } }),
      setImageBlockAt: (e) => ({ commands: t }) => t.insertContentAt(e.pos, { type: "imageBlock", attrs: { src: e.src } }),
      setImageBlockAlign: (e) => ({ commands: t }) => t.updateAttributes("imageBlock", { align: e }),
      setImageBlockWidth: (e) => ({ commands: t }) => t.updateAttributes("imageBlock", { width: `${Math.max(0, Math.min(100, e))}%` })
    };
  },
  addNodeView() {
    return I4(wse);
  }
}), Sse = G.div`
  animation: spin 1s linear infinite;
  border-style: solid;
  border-width: 2px;
  border-color: currentColor;
  border-top-color: transparent;
  border-radius: 9999px;
  height: 1rem;
  width: 1rem;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`, eb = Ae(({ ...e }, t) => /* @__PURE__ */ C(Sse, { ref: t, ...e }));
eb.displayName = "Spinner";
const Ase = () => {
  const { uploadImage: e, onImageUploadError: t } = Ct(N4);
  return { uploadImage: e, onImageUploadError: t };
}, Ose = ({ uploader: e }) => {
  const [t, n] = fe(!1), [r, a] = fe(!1);
  be(() => {
    const c = () => {
      n(!0);
    }, l = () => {
      n(!1);
    };
    return document.body.addEventListener("dragstart", c), document.body.addEventListener("dragend", l), () => {
      document.body.removeEventListener("dragstart", c), document.body.removeEventListener("dragend", l);
    };
  }, []);
  const i = ue(
    (c) => {
      if (a(!1), c.dataTransfer.files.length === 0)
        return;
      const l = c.dataTransfer.files, u = [];
      for (let f = 0; f < l.length; f += 1) {
        const y = l.item(f);
        y && u.push(y);
      }
      if (u.some((f) => f.type.indexOf("image") === -1))
        return;
      c.preventDefault();
      const h = u.filter((f) => f.type.indexOf("image") !== -1), p = h.length > 0 ? h[0] : void 0;
      p && e(p);
    },
    [e]
  );
  return { isDragging: t, draggedInside: r, onDragEnter: () => {
    a(!0);
  }, onDragLeave: () => {
    a(!1);
  }, onDrop: i };
}, Ese = () => {
  const e = he(null), t = ue(() => {
    var n;
    (n = e.current) == null || n.click();
  }, []);
  return { ref: e, handleUploadClick: t };
}, Ise = ({ uploader: e, onUpload: t, onError: n }) => {
  const [r, a] = fe(!1), i = ue(
    async (o) => {
      a(!0);
      try {
        const s = await e(o);
        t(s);
      } catch (s) {
        n(s);
      }
      a(!1);
    },
    [n, t, e]
  );
  return { loading: r, uploadFile: i };
}, Dse = G.div`
  display: grid;
  place-items: center;
  gap: 1rem;
  padding-right: 2rem;
  padding-left: 2rem;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
  border-radius: 0.5rem;
  ${(e) => e.draggedInside && "background: background-color: rgb(245 245 245);"}
`, Tse = G(Ue)`
  margin-bottom: 1rem;
  color: black;
  opacity: 0.2;
`, Nse = G.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`, Pse = G.input`
  width: 0;
  height: 0;
  overflow: hidden;
  opacity: 0;
`, Lse = G.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  border-radius: 0.5rem;
  min-height: 10rem;
  background-color: rgba(255, 255, 255, 0.8);
`, Rse = G(eb)`
  color: #9ca3af;
  font-size: 24px;
`, Vse = ({ onUpload: e }) => {
  const { uploadImage: t, onImageUploadError: n } = Ase(), { loading: r, uploadFile: a } = Ise({ uploader: t, onUpload: e, onError: n }), { handleUploadClick: i, ref: o } = Ese(), { draggedInside: s, onDrop: c, onDragEnter: l, onDragLeave: u } = Ose({ uploader: a }), h = ue(
    (p) => p.target.files ? a(p.target.files[0]) : null,
    [a]
  );
  return r ? /* @__PURE__ */ C(Lse, { children: /* @__PURE__ */ C(Rse, { size: 1.5 }) }) : /* @__PURE__ */ ie(
    Dse,
    {
      draggedInside: s,
      onDrop: c,
      onDragOver: l,
      onDragLeave: u,
      contentEditable: !1,
      children: [
        /* @__PURE__ */ C(Tse, { name: "Image", size: 30 }),
        /* @__PURE__ */ C(Nse, { children: /* @__PURE__ */ C("div", { children: /* @__PURE__ */ ie(
          v1,
          {
            type: "button",
            disabled: s,
            onClick: i,
            variant: "primary",
            buttonSize: "small",
            children: [
              /* @__PURE__ */ C(Ue, { name: "Upload" }),
              "Upload an image"
            ]
          }
        ) }) }),
        /* @__PURE__ */ C(Pse, { ref: o, type: "file", accept: ".png", onChange: h })
      ]
    }
  );
}, zse = ({ getPos: e, editor: t }) => {
  const n = ue(
    (r) => {
      r && t.chain().setImageBlock({ src: r }).deleteRange({ from: e(), to: e() }).focus().run();
    },
    [e, t]
  );
  return /* @__PURE__ */ C(O4, { children: /* @__PURE__ */ C("div", { style: { padding: 0, margin: 0 }, "data-drag-handle": !0, children: /* @__PURE__ */ C(Vse, { onUpload: n }) }) });
}, Bse = rn.create({
  name: "imageUpload",
  isolating: !0,
  defining: !0,
  group: "block",
  draggable: !0,
  selectable: !0,
  inline: !1,
  parseHTML() {
    return [
      {
        tag: `div[data-type="${this.name}"]`
      }
    ];
  },
  renderHTML() {
    return ["div", { "data-type": this.name }];
  },
  addCommands() {
    return {
      setImageUpload: () => ({ commands: e }) => e.insertContent(`<div data-type="${this.name}"></div>`)
    };
  },
  addNodeView() {
    return I4(zse);
  }
});
function Hse(e) {
  var t;
  const { char: n, allowSpaces: r, allowedPrefixes: a, startOfLine: i, $position: o } = e, s = rA(n), c = new RegExp(`\\s${s}$`), l = i ? "^" : "", u = r ? new RegExp(`${l}${s}.*?(?=\\s${s}|$)`, "gm") : new RegExp(`${l}(?:^)?${s}[^\\s${s}]*`, "gm"), h = ((t = o.nodeBefore) === null || t === void 0 ? void 0 : t.isText) && o.nodeBefore.text;
  if (!h)
    return null;
  const p = o.pos - h.length, f = Array.from(h.matchAll(u)).pop();
  if (!f || f.input === void 0 || f.index === void 0)
    return null;
  const y = f.input.slice(Math.max(0, f.index - 1), f.index), m = new RegExp(`^[${a == null ? void 0 : a.join("")}\0]?$`).test(y);
  if (a !== null && !m)
    return null;
  const v = p + f.index;
  let k = v + f[0].length;
  return r && c.test(h.slice(k - 1, k + 1)) && (f[0] += " ", k += 1), v < o.pos && k >= o.pos ? {
    range: {
      from: v,
      to: k
    },
    query: f[0].slice(n.length),
    text: f[0]
  } : null;
}
const $se = new nn("suggestion");
function jse({ pluginKey: e = $se, editor: t, char: n = "@", allowSpaces: r = !1, allowedPrefixes: a = [" "], startOfLine: i = !1, decorationTag: o = "span", decorationClass: s = "suggestion", command: c = () => null, items: l = () => [], render: u = () => ({}), allow: h = () => !0, findSuggestionMatch: p = Hse }) {
  let f;
  const y = u == null ? void 0 : u(), m = new At({
    key: e,
    view() {
      return {
        update: async (v, k) => {
          var b, x, g, w, M, S, D;
          const A = (b = this.key) === null || b === void 0 ? void 0 : b.getState(k), $ = (x = this.key) === null || x === void 0 ? void 0 : x.getState(v.state), F = A.active && $.active && A.range.from !== $.range.from, Z = !A.active && $.active, B = A.active && !$.active, O = !Z && !B && A.query !== $.query, I = Z || F, N = O && !F, R = B || F;
          if (!I && !N && !R)
            return;
          const L = R && !I ? A : $, W = v.dom.querySelector(`[data-decoration-id="${L.decorationId}"]`);
          f = {
            editor: t,
            range: L.range,
            query: L.query,
            text: L.text,
            items: [],
            command: (E) => c({
              editor: t,
              range: L.range,
              props: E
            }),
            decorationNode: W,
            // virtual node for popper.js or tippy.js
            // this can be used for building popups without a DOM node
            clientRect: W ? () => {
              var E;
              const { decorationId: q } = (E = this.key) === null || E === void 0 ? void 0 : E.getState(t.state), z = v.dom.querySelector(`[data-decoration-id="${q}"]`);
              return (z == null ? void 0 : z.getBoundingClientRect()) || null;
            } : null
          }, I && ((g = y == null ? void 0 : y.onBeforeStart) === null || g === void 0 || g.call(y, f)), N && ((w = y == null ? void 0 : y.onBeforeUpdate) === null || w === void 0 || w.call(y, f)), (N || I) && (f.items = await l({
            editor: t,
            query: L.query
          })), R && ((M = y == null ? void 0 : y.onExit) === null || M === void 0 || M.call(y, f)), N && ((S = y == null ? void 0 : y.onUpdate) === null || S === void 0 || S.call(y, f)), I && ((D = y == null ? void 0 : y.onStart) === null || D === void 0 || D.call(y, f));
        },
        destroy: () => {
          var v;
          f && ((v = y == null ? void 0 : y.onExit) === null || v === void 0 || v.call(y, f));
        }
      };
    },
    state: {
      // Initialize the plugin's internal state.
      init() {
        return {
          active: !1,
          range: {
            from: 0,
            to: 0
          },
          query: null,
          text: null,
          composing: !1
        };
      },
      // Apply changes to the plugin state from a view transaction.
      apply(v, k, b, x) {
        const { isEditable: g } = t, { composing: w } = t.view, { selection: M } = v, { empty: S, from: D } = M, A = { ...k };
        if (A.composing = w, g && (S || t.view.composing)) {
          (D < k.range.from || D > k.range.to) && !w && !k.composing && (A.active = !1);
          const $ = p({
            char: n,
            allowSpaces: r,
            allowedPrefixes: a,
            startOfLine: i,
            $position: M.$from
          }), F = `id_${Math.floor(Math.random() * 4294967295)}`;
          $ && h({ editor: t, state: x, range: $.range }) ? (A.active = !0, A.decorationId = k.decorationId ? k.decorationId : F, A.range = $.range, A.query = $.query, A.text = $.text) : A.active = !1;
        } else
          A.active = !1;
        return A.active || (A.decorationId = null, A.range = { from: 0, to: 0 }, A.query = null, A.text = null), A;
      }
    },
    props: {
      // Call the keydown hook if suggestion is active.
      handleKeyDown(v, k) {
        var b;
        const { active: x, range: g } = m.getState(v.state);
        return x && ((b = y == null ? void 0 : y.onKeyDown) === null || b === void 0 ? void 0 : b.call(y, { view: v, event: k, range: g })) || !1;
      },
      // Setup decorator on the currently active suggestion.
      decorations(v) {
        const { active: k, range: b, decorationId: x } = m.getState(v);
        return k ? tt.create(v.doc, [
          Ht.inline(b.from, b.to, {
            nodeName: o,
            class: s,
            "data-decoration-id": x
          })
        ]) : null;
      }
    }
  });
  return m;
}
const Fse = [
  {
    name: "format",
    title: "Format",
    commands: [
      {
        name: "heading1",
        label: "Heading 1",
        iconName: "Heading1",
        description: "High priority section title",
        aliases: ["h1"],
        action: (e) => {
          e.chain().focus().setHeading({ level: 1 }).run();
        }
      },
      {
        name: "heading2",
        label: "Heading 2",
        iconName: "Heading2",
        description: "Medium priority section title",
        aliases: ["h2"],
        action: (e) => {
          e.chain().focus().setHeading({ level: 2 }).run();
        }
      },
      {
        name: "heading3",
        label: "Heading 3",
        iconName: "Heading3",
        description: "Low priority section title",
        aliases: ["h3"],
        action: (e) => {
          e.chain().focus().setHeading({ level: 3 }).run();
        }
      },
      {
        name: "bulletList",
        label: "Bullet List",
        iconName: "List",
        description: "Unordered list of items",
        aliases: ["ul"],
        action: (e) => {
          e.chain().focus().toggleBulletList().run();
        }
      },
      {
        name: "numberedList",
        label: "Numbered List",
        iconName: "ListOrdered",
        description: "Ordered list of items",
        aliases: ["ol"],
        action: (e) => {
          e.chain().focus().toggleOrderedList().run();
        }
      },
      {
        name: "blockquote",
        label: "Blockquote",
        iconName: "Quote",
        description: "Element for quoting",
        action: (e) => {
          e.chain().focus().setBlockquote().run();
        }
      }
    ]
  },
  {
    name: "insert",
    title: "Insert",
    commands: [
      {
        name: "image",
        label: "Image",
        iconName: "Image",
        description: "Insert an image",
        aliases: ["img"],
        action: (e) => {
          e.chain().focus().setImageUpload().run();
        }
      }
    ]
  }
], Wse = G(Ue)`
  margin-right: 0.25rem;
`, qse = G.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 0.125rem;
`, _se = G.div`
  color: #6b7280;
  font-size: 0.65rem;
  grid-column: 1 / -1;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  margin-top: 1rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  user-select: none;
  text-transform: uppercase;
  &:first-child {
    margin-top: 0.125rem;
  }
`, Gse = G(Br)`
  color: #000;
  max-height: min(80vh, 24rem);
  overflow: auto;
  flex-wrap: wrap;
  margin-bottom: 2rem;
  padding: 0.5rem;
`, tb = V.forwardRef((e, t) => {
  const n = he(null), r = he(null), [a, i] = fe(0), [o, s] = fe(0);
  be(() => {
    i(0), s(0);
  }, [e.items]);
  const c = ue(
    (u, h) => {
      const p = e.items[u].commands[h];
      e.command(p);
    },
    [e]
  );
  V.useImperativeHandle(t, () => ({
    onKeyDown: ({ event: u }) => {
      var h;
      if (u.key === "ArrowDown") {
        if (!e.items.length)
          return !1;
        const { commands: p } = e.items[a];
        let f = o + 1, y = a;
        return p.length - 1 < f && (f = 0, y = a + 1), e.items.length - 1 < y && (y = 0), s(f), i(y), !0;
      }
      if (u.key === "ArrowUp") {
        if (!e.items.length)
          return !1;
        let p = o - 1, f = a;
        return p < 0 && (f = a - 1, p = ((h = e.items[f]) == null ? void 0 : h.commands.length) - 1 || 0), f < 0 && (f = e.items.length - 1, p = e.items[f].commands.length - 1), s(p), i(f), !0;
      }
      return u.key === "Enter" ? !e.items.length || a === -1 || o === -1 ? !1 : (c(a, o), !0) : !1;
    }
  })), be(() => {
    if (r.current && n.current) {
      const { offsetTop: u } = r.current, { offsetHeight: h } = r.current;
      n.current.scrollTop = u - h;
    }
  }, [o, a]);
  const l = ue(
    (u, h) => () => {
      c(u, h);
    },
    [c]
  );
  return e.items.length ? /* @__PURE__ */ C(Gse, { ref: n, children: /* @__PURE__ */ C(qse, { children: e.items.map((u, h) => /* @__PURE__ */ ie(V.Fragment, { children: [
    /* @__PURE__ */ C(_se, { children: u.title }, u.title),
    u.commands.map((p, f) => /* @__PURE__ */ ie(
      x1,
      {
        isActive: a === h && o === f,
        onClick: l(h, f),
        children: [
          /* @__PURE__ */ C(Wse, { name: p.iconName }),
          p.label
        ]
      },
      `${p.label}`
    ))
  ] }, `${u.title}-wrapper`)) }) }) : null;
});
tb.displayName = "MenuList";
const Wr = "slashCommand";
let We;
const Zse = kt.create({
  name: Wr,
  priority: 200,
  onCreate() {
    We = Ii("body", {
      interactive: !0,
      trigger: "manual",
      placement: "bottom-start",
      theme: "slash-command",
      maxWidth: "16rem",
      offset: [16, 8],
      popperOptions: {
        strategy: "fixed",
        modifiers: [
          {
            name: "flip",
            enabled: !1
          }
        ]
      }
    });
  },
  addProseMirrorPlugins() {
    return [
      jse({
        editor: this.editor,
        char: "/",
        allowSpaces: !0,
        startOfLine: !0,
        pluginKey: new nn(Wr),
        allow: ({ state: e, range: t }) => {
          var l, u, h;
          const n = e.doc.resolve(t.from), r = n.depth === 1, a = n.parent.type.name === "paragraph", i = ((l = n.parent.textContent) == null ? void 0 : l.charAt(0)) === "/", o = this.editor.isActive("column"), s = (h = n.parent.textContent) == null ? void 0 : h.substring((u = n.parent.textContent) == null ? void 0 : u.indexOf("/")), c = !(s != null && s.endsWith("  "));
          return (r && a && i || o && a && i) && c;
        },
        command: ({ editor: e, props: t }) => {
          var l, u;
          const { view: n, state: r } = e, { $head: a, $from: i } = n.state.selection, o = i.pos, s = a != null && a.nodeBefore ? o - (((u = a.nodeBefore.text) == null ? void 0 : u.substring((l = a.nodeBefore.text) == null ? void 0 : l.indexOf("/")).length) ?? 0) : i.start(), c = r.tr.deleteRange(s, o);
          n.dispatch(c), t.action(e), n.focus();
        },
        items: ({ query: e }) => Fse.map((a) => ({
          ...a,
          commands: a.commands.filter((i) => {
            const o = i.label.toLowerCase().trim(), s = e.toLowerCase().trim();
            if (i.aliases) {
              const c = i.aliases.map((l) => l.toLowerCase().trim());
              return o.includes(s) || c.includes(s);
            }
            return o.includes(s);
          }).filter((i) => i.shouldBeHidden ? !i.shouldBeHidden(this.editor) : !0)
        })).filter((a) => a.commands.length > 0).map((a) => ({
          ...a,
          commands: a.commands.map((i) => ({
            ...i,
            isEnabled: !0
          }))
        })),
        render: () => {
          let e, t = null;
          return {
            onStart: (n) => {
              var i;
              e = new E4(tb, {
                props: n,
                editor: n.editor
              });
              const { view: r } = n.editor, a = () => {
                if (!n.clientRect)
                  return n.editor.storage[Wr].rect;
                const o = n.clientRect();
                if (!o)
                  return n.editor.storage[Wr].rect;
                let s = o.y;
                if (o.top + e.element.offsetHeight + 40 > window.innerHeight) {
                  const c = o.top + e.element.offsetHeight - window.innerHeight + 40;
                  s = o.y - c;
                }
                return new DOMRect(o.x, s, o.width, o.height);
              };
              t = () => {
                We == null || We[0].setProps({
                  getReferenceClientRect: a
                });
              }, (i = r.dom.parentElement) == null || i.addEventListener("scroll", t), We == null || We[0].setProps({
                getReferenceClientRect: a,
                appendTo: () => document.body,
                content: e.element
              }), We == null || We[0].show();
            },
            onUpdate(n) {
              var o;
              e.updateProps(n);
              const { view: r } = n.editor, a = () => {
                if (!n.clientRect)
                  return n.editor.storage[Wr].rect;
                const s = n.clientRect();
                return s ? new DOMRect(s.x, s.y, s.width, s.height) : n.editor.storage[Wr].rect;
              }, i = () => {
                We == null || We[0].setProps({
                  getReferenceClientRect: a
                });
              };
              (o = r.dom.parentElement) == null || o.addEventListener("scroll", i), n.editor.storage[Wr].rect = n.clientRect ? a() : {
                width: 0,
                height: 0,
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
              }, We == null || We[0].setProps({
                getReferenceClientRect: a
              });
            },
            onKeyDown(n) {
              var r;
              return n.event.key === "Escape" ? (We == null || We[0].hide(), !0) : (We != null && We[0].state.isShown || We == null || We[0].show(), (r = e.ref) == null ? void 0 : r.onKeyDown(n));
            },
            onExit(n) {
              var r;
              if (We == null || We[0].hide(), t) {
                const { view: a } = n.editor;
                (r = a.dom.parentElement) == null || r.removeEventListener("scroll", t);
              }
              e.destroy();
            }
          };
        }
      })
    ];
  },
  addStorage() {
    return {
      rect: {
        width: 0,
        height: 0,
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      }
    };
  }
}), Xse = [
  boe,
  hse,
  gse,
  Doe,
  hoe,
  Hoe,
  lse,
  foe,
  use,
  soe,
  goe,
  Ioe,
  G5.configure({
    inline: !0
  }),
  cse.configure(),
  mse,
  voe,
  xoe,
  koe,
  Bse,
  Cse,
  Zse,
  bse,
  kse.configure(),
  Poe.configure({
    multicolor: !0
  }),
  pse.configure({
    placeholder: "Escribe / para ver las opciones"
  }),
  vse.configure({
    types: ["heading", "paragraph"]
  }),
  zO.configure({})
], R4e = ({ value: e, onChange: t, onUploadImage: n, onImageUploadError: r }) => {
  const a = qO({
    content: e,
    extensions: Xse,
    onUpdate: ({ editor: o }) => {
      t(o.getHTML());
    }
  }), i = wt(
    () => ({
      uploadImage: n ?? D4,
      onImageUploadError: r ?? T4
    }),
    [r, n]
  );
  return /* @__PURE__ */ C(N4.Provider, { value: i, children: /* @__PURE__ */ ie(Y8, { children: [
    a && /* @__PURE__ */ C(ioe, { editor: a }),
    /* @__PURE__ */ C(FO, { editor: a })
  ] }) });
};
function Ce() {
  return Ce = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ce.apply(this, arguments);
}
function Use(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function Yse(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Jse = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(a) {
      var i;
      r.tags.length === 0 ? r.insertionPoint ? i = r.insertionPoint.nextSibling : r.prepend ? i = r.container.firstChild : i = r.before : i = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(a, i), r.tags.push(a);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Yse(this));
    var a = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = r.charCodeAt(0) === 64 && r.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + r + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var o = Use(a);
      try {
        o.insertRule(r, o.cssRules.length);
      } catch (s) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(r) && console.error('There was a problem inserting the following rule: "' + r + '"', s);
      }
    } else
      a.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      return r.parentNode && r.parentNode.removeChild(r);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), bt = "-ms-", Cl = "-moz-", ze = "-webkit-", t2 = "comm", n2 = "rule", r2 = "decl", Kse = "@import", nb = "@keyframes", Qse = "@layer", ece = Math.abs, w1 = String.fromCharCode, tce = Object.assign;
function nce(e, t) {
  return yt(e, 0) ^ 45 ? (((t << 2 ^ yt(e, 0)) << 2 ^ yt(e, 1)) << 2 ^ yt(e, 2)) << 2 ^ yt(e, 3) : 0;
}
function rb(e) {
  return e.trim();
}
function rce(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Be(e, t, n) {
  return e.replace(t, n);
}
function dh(e, t) {
  return e.indexOf(t);
}
function yt(e, t) {
  return e.charCodeAt(t) | 0;
}
function Ro(e, t, n) {
  return e.slice(t, n);
}
function Tn(e) {
  return e.length;
}
function a2(e) {
  return e.length;
}
function Xs(e, t) {
  return t.push(e), e;
}
function ace(e, t) {
  return e.map(t).join("");
}
var C1 = 1, xi = 1, ab = 0, Wt = 0, rt = 0, Pi = "";
function S1(e, t, n, r, a, i, o) {
  return { value: e, root: t, parent: n, type: r, props: a, children: i, line: C1, column: xi, length: o, return: "" };
}
function ji(e, t) {
  return tce(S1("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function ice() {
  return rt;
}
function oce() {
  return rt = Wt > 0 ? yt(Pi, --Wt) : 0, xi--, rt === 10 && (xi = 1, C1--), rt;
}
function Kt() {
  return rt = Wt < ab ? yt(Pi, Wt++) : 0, xi++, rt === 10 && (xi = 1, C1++), rt;
}
function Hn() {
  return yt(Pi, Wt);
}
function yc() {
  return Wt;
}
function ds(e, t) {
  return Ro(Pi, e, t);
}
function Vo(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function ib(e) {
  return C1 = xi = 1, ab = Tn(Pi = e), Wt = 0, [];
}
function ob(e) {
  return Pi = "", e;
}
function mc(e) {
  return rb(ds(Wt - 1, uh(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function sce(e) {
  for (; (rt = Hn()) && rt < 33; )
    Kt();
  return Vo(e) > 2 || Vo(rt) > 3 ? "" : " ";
}
function cce(e, t) {
  for (; --t && Kt() && !(rt < 48 || rt > 102 || rt > 57 && rt < 65 || rt > 70 && rt < 97); )
    ;
  return ds(e, yc() + (t < 6 && Hn() == 32 && Kt() == 32));
}
function uh(e) {
  for (; Kt(); )
    switch (rt) {
      case e:
        return Wt;
      case 34:
      case 39:
        e !== 34 && e !== 39 && uh(rt);
        break;
      case 40:
        e === 41 && uh(e);
        break;
      case 92:
        Kt();
        break;
    }
  return Wt;
}
function lce(e, t) {
  for (; Kt() && e + rt !== 47 + 10; )
    if (e + rt === 42 + 42 && Hn() === 47)
      break;
  return "/*" + ds(t, Wt - 1) + "*" + w1(e === 47 ? e : Kt());
}
function dce(e) {
  for (; !Vo(Hn()); )
    Kt();
  return ds(e, Wt);
}
function uce(e) {
  return ob(gc("", null, null, null, [""], e = ib(e), 0, [0], e));
}
function gc(e, t, n, r, a, i, o, s, c) {
  for (var l = 0, u = 0, h = o, p = 0, f = 0, y = 0, m = 1, v = 1, k = 1, b = 0, x = "", g = a, w = i, M = r, S = x; v; )
    switch (y = b, b = Kt()) {
      case 40:
        if (y != 108 && yt(S, h - 1) == 58) {
          dh(S += Be(mc(b), "&", "&\f"), "&\f") != -1 && (k = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        S += mc(b);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        S += sce(y);
        break;
      case 92:
        S += cce(yc() - 1, 7);
        continue;
      case 47:
        switch (Hn()) {
          case 42:
          case 47:
            Xs(hce(lce(Kt(), yc()), t, n), c);
            break;
          default:
            S += "/";
        }
        break;
      case 123 * m:
        s[l++] = Tn(S) * k;
      case 125 * m:
      case 59:
      case 0:
        switch (b) {
          case 0:
          case 125:
            v = 0;
          case 59 + u:
            k == -1 && (S = Be(S, /\f/g, "")), f > 0 && Tn(S) - h && Xs(f > 32 ? em(S + ";", r, n, h - 1) : em(Be(S, " ", "") + ";", r, n, h - 2), c);
            break;
          case 59:
            S += ";";
          default:
            if (Xs(M = Qy(S, t, n, l, u, a, s, x, g = [], w = [], h), i), b === 123)
              if (u === 0)
                gc(S, t, M, M, g, i, h, s, w);
              else
                switch (p === 99 && yt(S, 3) === 110 ? 100 : p) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    gc(e, M, M, r && Xs(Qy(e, M, M, 0, 0, a, s, x, a, g = [], h), w), a, w, h, s, r ? g : w);
                    break;
                  default:
                    gc(S, M, M, M, [""], w, 0, s, w);
                }
        }
        l = u = f = 0, m = k = 1, x = S = "", h = o;
        break;
      case 58:
        h = 1 + Tn(S), f = y;
      default:
        if (m < 1) {
          if (b == 123)
            --m;
          else if (b == 125 && m++ == 0 && oce() == 125)
            continue;
        }
        switch (S += w1(b), b * m) {
          case 38:
            k = u > 0 ? 1 : (S += "\f", -1);
            break;
          case 44:
            s[l++] = (Tn(S) - 1) * k, k = 1;
            break;
          case 64:
            Hn() === 45 && (S += mc(Kt())), p = Hn(), u = h = Tn(x = S += dce(yc())), b++;
            break;
          case 45:
            y === 45 && Tn(S) == 2 && (m = 0);
        }
    }
  return i;
}
function Qy(e, t, n, r, a, i, o, s, c, l, u) {
  for (var h = a - 1, p = a === 0 ? i : [""], f = a2(p), y = 0, m = 0, v = 0; y < r; ++y)
    for (var k = 0, b = Ro(e, h + 1, h = ece(m = o[y])), x = e; k < f; ++k)
      (x = rb(m > 0 ? p[k] + " " + b : Be(b, /&\f/g, p[k]))) && (c[v++] = x);
  return S1(e, t, n, a === 0 ? n2 : s, c, l, u);
}
function hce(e, t, n) {
  return S1(e, t, n, t2, w1(ice()), Ro(e, 2, -2), 0);
}
function em(e, t, n, r) {
  return S1(e, t, n, r2, Ro(e, 0, r), Ro(e, r + 1, -1), r);
}
function ni(e, t) {
  for (var n = "", r = a2(e), a = 0; a < r; a++)
    n += t(e[a], a, e, t) || "";
  return n;
}
function pce(e, t, n, r) {
  switch (e.type) {
    case Qse:
      if (e.children.length)
        break;
    case Kse:
    case r2:
      return e.return = e.return || e.value;
    case t2:
      return "";
    case nb:
      return e.return = e.value + "{" + ni(e.children, r) + "}";
    case n2:
      e.value = e.props.join(",");
  }
  return Tn(n = ni(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function fce(e) {
  var t = a2(e);
  return function(n, r, a, i) {
    for (var o = "", s = 0; s < t; s++)
      o += e[s](n, r, a, i) || "";
    return o;
  };
}
function yce(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function mce(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var gce = function(t, n, r) {
  for (var a = 0, i = 0; a = i, i = Hn(), a === 38 && i === 12 && (n[r] = 1), !Vo(i); )
    Kt();
  return ds(t, Wt);
}, vce = function(t, n) {
  var r = -1, a = 44;
  do
    switch (Vo(a)) {
      case 0:
        a === 38 && Hn() === 12 && (n[r] = 1), t[r] += gce(Wt - 1, n, r);
        break;
      case 2:
        t[r] += mc(a);
        break;
      case 4:
        if (a === 44) {
          t[++r] = Hn() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += w1(a);
    }
  while (a = Kt());
  return t;
}, kce = function(t, n) {
  return ob(vce(ib(t), n));
}, tm = /* @__PURE__ */ new WeakMap(), bce = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, a = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r)
        return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !tm.get(r)) && !a) {
      tm.set(t, !0);
      for (var i = [], o = kce(n, i), s = r.props, c = 0, l = 0; c < o.length; c++)
        for (var u = 0; u < s.length; u++, l++)
          t.props[l] = i[c] ? o[c].replace(/&\f/g, s[u]) : s[u] + " " + o[c];
    }
  }
}, xce = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
}, Mce = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", wce = function(t) {
  return t.type === "comm" && t.children.indexOf(Mce) > -1;
}, Cce = function(t) {
  return function(n, r, a) {
    if (!(n.type !== "rule" || t.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var o = !!n.parent, s = o ? n.parent.children : (
          // global rule at the root level
          a
        ), c = s.length - 1; c >= 0; c--) {
          var l = s[c];
          if (l.line < n.line)
            break;
          if (l.column < n.column) {
            if (wce(l))
              return;
            break;
          }
        }
        i.forEach(function(u) {
          console.error('The pseudo class "' + u + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + u.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, sb = function(t) {
  return t.type.charCodeAt(1) === 105 && t.type.charCodeAt(0) === 64;
}, Sce = function(t, n) {
  for (var r = t - 1; r >= 0; r--)
    if (!sb(n[r]))
      return !0;
  return !1;
}, nm = function(t) {
  t.type = "", t.value = "", t.return = "", t.children = "", t.props = "";
}, Ace = function(t, n, r) {
  sb(t) && (t.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), nm(t)) : Sce(n, r) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), nm(t)));
};
function cb(e, t) {
  switch (nce(e, t)) {
    case 5103:
      return ze + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return ze + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return ze + e + Cl + e + bt + e + e;
    case 6828:
    case 4268:
      return ze + e + bt + e + e;
    case 6165:
      return ze + e + bt + "flex-" + e + e;
    case 5187:
      return ze + e + Be(e, /(\w+).+(:[^]+)/, ze + "box-$1$2" + bt + "flex-$1$2") + e;
    case 5443:
      return ze + e + bt + "flex-item-" + Be(e, /flex-|-self/, "") + e;
    case 4675:
      return ze + e + bt + "flex-line-pack" + Be(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return ze + e + bt + Be(e, "shrink", "negative") + e;
    case 5292:
      return ze + e + bt + Be(e, "basis", "preferred-size") + e;
    case 6060:
      return ze + "box-" + Be(e, "-grow", "") + ze + e + bt + Be(e, "grow", "positive") + e;
    case 4554:
      return ze + Be(e, /([^-])(transform)/g, "$1" + ze + "$2") + e;
    case 6187:
      return Be(Be(Be(e, /(zoom-|grab)/, ze + "$1"), /(image-set)/, ze + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Be(e, /(image-set\([^]*)/, ze + "$1$`$1");
    case 4968:
      return Be(Be(e, /(.+:)(flex-)?(.*)/, ze + "box-pack:$3" + bt + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + ze + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Be(e, /(.+)-inline(.+)/, ze + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Tn(e) - 1 - t > 6)
        switch (yt(e, t + 1)) {
          case 109:
            if (yt(e, t + 4) !== 45)
              break;
          case 102:
            return Be(e, /(.+:)(.+)-([^]+)/, "$1" + ze + "$2-$3$1" + Cl + (yt(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~dh(e, "stretch") ? cb(Be(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (yt(e, t + 1) !== 115)
        break;
    case 6444:
      switch (yt(e, Tn(e) - 3 - (~dh(e, "!important") && 10))) {
        case 107:
          return Be(e, ":", ":" + ze) + e;
        case 101:
          return Be(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + ze + (yt(e, 14) === 45 ? "inline-" : "") + "box$3$1" + ze + "$2$3$1" + bt + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (yt(e, t + 11)) {
        case 114:
          return ze + e + bt + Be(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return ze + e + bt + Be(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return ze + e + bt + Be(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return ze + e + bt + e + e;
  }
  return e;
}
var Oce = function(t, n, r, a) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case r2:
        t.return = cb(t.value, t.length);
        break;
      case nb:
        return ni([ji(t, {
          value: Be(t.value, "@", "@" + ze)
        })], a);
      case n2:
        if (t.length)
          return ace(t.props, function(i) {
            switch (rce(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ni([ji(t, {
                  props: [Be(i, /:(read-\w+)/, ":" + Cl + "$1")]
                })], a);
              case "::placeholder":
                return ni([ji(t, {
                  props: [Be(i, /:(plac\w+)/, ":" + ze + "input-$1")]
                }), ji(t, {
                  props: [Be(i, /:(plac\w+)/, ":" + Cl + "$1")]
                }), ji(t, {
                  props: [Be(i, /:(plac\w+)/, bt + "input-$1")]
                })], a);
            }
            return "";
          });
    }
}, Ece = [Oce], Ice = function(t) {
  var n = t.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(m) {
      var v = m.getAttribute("data-emotion");
      v.indexOf(" ") !== -1 && (document.head.appendChild(m), m.setAttribute("data-s", ""));
    });
  }
  var a = t.stylisPlugins || Ece;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, o, s = [];
  o = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(m) {
      for (var v = m.getAttribute("data-emotion").split(" "), k = 1; k < v.length; k++)
        i[v[k]] = !0;
      s.push(m);
    }
  );
  var c, l = [bce, xce];
  process.env.NODE_ENV !== "production" && l.push(Cce({
    get compat() {
      return y.compat;
    }
  }), Ace);
  {
    var u, h = [pce, process.env.NODE_ENV !== "production" ? function(m) {
      m.root || (m.return ? u.insert(m.return) : m.value && m.type !== t2 && u.insert(m.value + "{}"));
    } : yce(function(m) {
      u.insert(m);
    })], p = fce(l.concat(a, h)), f = function(v) {
      return ni(uce(v), p);
    };
    c = function(v, k, b, x) {
      u = b, process.env.NODE_ENV !== "production" && k.map !== void 0 && (u = {
        insert: function(w) {
          b.insert(w + k.map);
        }
      }), f(v ? v + "{" + k.styles + "}" : k.styles), x && (y.inserted[k.name] = !0);
    };
  }
  var y = {
    key: n,
    sheet: new Jse({
      key: n,
      container: o,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return y.sheet.hydrate(s), y;
}, Dce = !0;
function lb(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(a) {
    e[a] !== void 0 ? t.push(e[a] + ";") : r += a + " ";
  }), r;
}
var i2 = function(t, n, r) {
  var a = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Dce === !1) && t.registered[a] === void 0 && (t.registered[a] = n.styles);
}, o2 = function(t, n, r) {
  i2(t, n, r);
  var a = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var i = n;
    do
      t.insert(n === i ? "." + a : "", i, t.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function Tce(e) {
  for (var t = 0, n, r = 0, a = e.length; a >= 4; ++r, a -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Nce = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, rm = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Pce = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Lce = /[A-Z]|^ms/g, db = /_EMO_([^_]+?)_([^]*?)_EMO_/g, s2 = function(t) {
  return t.charCodeAt(1) === 45;
}, am = function(t) {
  return t != null && typeof t != "boolean";
}, Fd = /* @__PURE__ */ mce(function(e) {
  return s2(e) ? e : e.replace(Lce, "-$&").toLowerCase();
}), Sl = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(db, function(r, a, i) {
          return gn = {
            name: a,
            styles: i,
            next: gn
          }, a;
        });
  }
  return Nce[t] !== 1 && !s2(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var Rce = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Vce = ["normal", "none", "initial", "inherit", "unset"], zce = Sl, Bce = /^-ms-/, Hce = /-(.)/g, im = {};
  Sl = function(t, n) {
    if (t === "content" && (typeof n != "string" || Vce.indexOf(n) === -1 && !Rce.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var r = zce(t, n);
    return r !== "" && !s2(t) && t.indexOf("-") !== -1 && im[t] === void 0 && (im[t] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + t.replace(Bce, "ms-").replace(Hce, function(a, i) {
      return i.toUpperCase();
    }) + "?")), r;
  };
}
var ub = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function zo(e, t, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(ub);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return gn = {
          name: n.name,
          styles: n.styles,
          next: gn
        }, n.name;
      if (n.styles !== void 0) {
        var r = n.next;
        if (r !== void 0)
          for (; r !== void 0; )
            gn = {
              name: r.name,
              styles: r.styles,
              next: gn
            }, r = r.next;
        var a = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (a += n.map), a;
      }
      return $ce(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = gn, o = n(e);
        return gn = i, zo(e, t, o);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var s = [], c = n.replace(db, function(u, h, p) {
          var f = "animation" + s.length;
          return s.push("const " + f + " = keyframes`" + p.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + f + "}";
        });
        s.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(s, ["`" + c + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + c + "`"));
      }
      break;
  }
  if (t == null)
    return n;
  var l = t[n];
  return l !== void 0 ? l : n;
}
function $ce(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var a = 0; a < n.length; a++)
      r += zo(e, t, n[a]) + ";";
  else
    for (var i in n) {
      var o = n[i];
      if (typeof o != "object")
        t != null && t[o] !== void 0 ? r += i + "{" + t[o] + "}" : am(o) && (r += Fd(i) + ":" + Sl(i, o) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(ub);
        if (Array.isArray(o) && typeof o[0] == "string" && (t == null || t[o[0]] === void 0))
          for (var s = 0; s < o.length; s++)
            am(o[s]) && (r += Fd(i) + ":" + Sl(i, o[s]) + ";");
        else {
          var c = zo(e, t, o);
          switch (i) {
            case "animation":
            case "animationName": {
              r += Fd(i) + ":" + c + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Pce), r += i + "{" + c + "}";
          }
        }
      }
    }
  return r;
}
var om = /label:\s*([^\s;\n{]+)\s*(;|$)/g, hb;
process.env.NODE_ENV !== "production" && (hb = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var gn, Bo = function(t, n, r) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var a = !0, i = "";
  gn = void 0;
  var o = t[0];
  o == null || o.raw === void 0 ? (a = !1, i += zo(r, n, o)) : (process.env.NODE_ENV !== "production" && o[0] === void 0 && console.error(rm), i += o[0]);
  for (var s = 1; s < t.length; s++)
    i += zo(r, n, t[s]), a && (process.env.NODE_ENV !== "production" && o[s] === void 0 && console.error(rm), i += o[s]);
  var c;
  process.env.NODE_ENV !== "production" && (i = i.replace(hb, function(p) {
    return c = p, "";
  })), om.lastIndex = 0;
  for (var l = "", u; (u = om.exec(i)) !== null; )
    l += "-" + // $FlowFixMe we know it's not null
    u[1];
  var h = Tce(i) + l;
  return process.env.NODE_ENV !== "production" ? {
    name: h,
    styles: i,
    map: c,
    next: gn,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: h,
    styles: i,
    next: gn
  };
}, jce = function(t) {
  return t();
}, pb = ne["useInsertionEffect"] ? ne["useInsertionEffect"] : !1, fb = pb || jce, sm = pb || ne.useLayoutEffect, c2 = {}.hasOwnProperty, l2 = /* @__PURE__ */ ne.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Ice({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (l2.displayName = "EmotionCacheContext");
l2.Provider;
var d2 = function(t) {
  return /* @__PURE__ */ Ae(function(n, r) {
    var a = Ct(l2);
    return t(n, a, r);
  });
}, A1 = /* @__PURE__ */ ne.createContext({});
process.env.NODE_ENV !== "production" && (A1.displayName = "EmotionThemeContext");
var cm = function(t) {
  var n = t.split(".");
  return n[n.length - 1];
}, Fce = function(t) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(t);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(t), n))
    return cm(n[1]);
}, Wce = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), qce = function(t) {
  return t.replace(/\$/g, "-");
}, _ce = function(t) {
  if (t)
    for (var n = t.split(`
`), r = 0; r < n.length; r++) {
      var a = Fce(n[r]);
      if (a) {
        if (Wce.has(a))
          break;
        if (/^[A-Z]/.test(a))
          return qce(a);
      }
    }
}, hh = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", ph = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", Gce = function(t, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var r = {};
  for (var a in n)
    c2.call(n, a) && (r[a] = n[a]);
  if (r[hh] = t, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = _ce(new Error().stack);
    i && (r[ph] = i);
  }
  return r;
}, Zce = function(t) {
  var n = t.cache, r = t.serialized, a = t.isStringTag;
  return i2(n, r, a), fb(function() {
    return o2(n, r, a);
  }), null;
}, yb = /* @__PURE__ */ d2(function(e, t, n) {
  var r = e.css;
  typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
  var a = e[hh], i = [r], o = "";
  typeof e.className == "string" ? o = lb(t.registered, i, e.className) : e.className != null && (o = e.className + " ");
  var s = Bo(i, void 0, ne.useContext(A1));
  if (process.env.NODE_ENV !== "production" && s.name.indexOf("-") === -1) {
    var c = e[ph];
    c && (s = Bo([s, "label:" + c + ";"]));
  }
  o += t.key + "-" + s.name;
  var l = {};
  for (var u in e)
    c2.call(e, u) && u !== "css" && u !== hh && (process.env.NODE_ENV === "production" || u !== ph) && (l[u] = e[u]);
  return l.ref = n, l.className = o, /* @__PURE__ */ ne.createElement(ne.Fragment, null, /* @__PURE__ */ ne.createElement(Zce, {
    cache: t,
    serialized: s,
    isStringTag: typeof a == "string"
  }), /* @__PURE__ */ ne.createElement(a, l));
});
process.env.NODE_ENV !== "production" && (yb.displayName = "EmotionCssPropInternal");
var Xce = yb, Uce = {
  name: "@emotion/react",
  version: "11.11.1",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        default: "./dist/emotion-react.esm.js"
      },
      import: "./dist/emotion-react.cjs.mjs",
      default: "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      import: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
      default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      import: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
      default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      import: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
      default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": {
      types: {
        import: "./macro.d.mts",
        default: "./macro.d.ts"
      },
      default: "./macro.js"
    }
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.*"
  ],
  sideEffects: !1,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.11.0",
    "@emotion/cache": "^11.11.0",
    "@emotion/serialize": "^1.1.2",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
    "@emotion/utils": "^1.2.1",
    "@emotion/weak-memoize": "^0.3.1",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.11.0",
    "@emotion/css-prettifier": "1.1.3",
    "@emotion/server": "11.11.0",
    "@emotion/styled": "11.11.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
          types: {
            import: "./macro.d.mts",
            default: "./macro.d.ts"
          },
          default: "./macro.js"
        }
      }
    }
  }
}, we = function(t, n) {
  var r = arguments;
  if (n == null || !c2.call(n, "css"))
    return ne.createElement.apply(void 0, r);
  var a = r.length, i = new Array(a);
  i[0] = Xce, i[1] = Gce(t, n);
  for (var o = 2; o < a; o++)
    i[o] = r[o];
  return ne.createElement.apply(null, i);
}, lm = !1, Yce = /* @__PURE__ */ d2(function(e, t) {
  process.env.NODE_ENV !== "production" && !lm && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (e.className || e.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), lm = !0);
  var n = e.styles, r = Bo([n], void 0, ne.useContext(A1)), a = ne.useRef();
  return sm(function() {
    var i = t.key + "-global", o = new t.sheet.constructor({
      key: i,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), s = !1, c = document.querySelector('style[data-emotion="' + i + " " + r.name + '"]');
    return t.sheet.tags.length && (o.before = t.sheet.tags[0]), c !== null && (s = !0, c.setAttribute("data-emotion", i), o.hydrate([c])), a.current = [o, s], function() {
      o.flush();
    };
  }, [t]), sm(function() {
    var i = a.current, o = i[0], s = i[1];
    if (s) {
      i[1] = !1;
      return;
    }
    if (r.next !== void 0 && o2(t, r.next, !0), o.tags.length) {
      var c = o.tags[o.tags.length - 1].nextElementSibling;
      o.before = c, o.flush();
    }
    t.insert("", r, o, !1);
  }, [t, r.name]), null;
});
process.env.NODE_ENV !== "production" && (Yce.displayName = "EmotionGlobal");
function u2() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Bo(t);
}
var Jce = function() {
  var t = u2.apply(void 0, arguments), n = "animation-" + t.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, Kce = function e(t) {
  for (var n = t.length, r = 0, a = ""; r < n; r++) {
    var i = t[r];
    if (i != null) {
      var o = void 0;
      switch (typeof i) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(i))
            o = e(i);
          else {
            process.env.NODE_ENV !== "production" && i.styles !== void 0 && i.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), o = "";
            for (var s in i)
              i[s] && s && (o && (o += " "), o += s);
          }
          break;
        }
        default:
          o = i;
      }
      o && (a && (a += " "), a += o);
    }
  }
  return a;
};
function Qce(e, t, n) {
  var r = [], a = lb(e, r, n);
  return r.length < 2 ? n : a + t(r);
}
var ele = function(t) {
  var n = t.cache, r = t.serializedArr;
  return fb(function() {
    for (var a = 0; a < r.length; a++)
      o2(n, r[a], !1);
  }), null;
}, mb = /* @__PURE__ */ d2(function(e, t) {
  var n = !1, r = [], a = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var l = arguments.length, u = new Array(l), h = 0; h < l; h++)
      u[h] = arguments[h];
    var p = Bo(u, t.registered);
    return r.push(p), i2(t, p, !1), t.key + "-" + p.name;
  }, i = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var l = arguments.length, u = new Array(l), h = 0; h < l; h++)
      u[h] = arguments[h];
    return Qce(t.registered, a, Kce(u));
  }, o = {
    css: a,
    cx: i,
    theme: ne.useContext(A1)
  }, s = e.children(o);
  return n = !0, /* @__PURE__ */ ne.createElement(ne.Fragment, null, /* @__PURE__ */ ne.createElement(ele, {
    cache: t,
    serializedArr: r
  }), s);
});
process.env.NODE_ENV !== "production" && (mb.displayName = "EmotionClassNames");
if (process.env.NODE_ENV !== "production") {
  var dm = !0, tle = typeof jest < "u" || typeof vi < "u";
  if (dm && !tle) {
    var um = (
      // $FlowIgnore
      typeof globalThis < "u" ? globalThis : dm ? window : global
    ), hm = "__EMOTION_REACT_" + Uce.version.split(".")[0] + "__";
    um[hm] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), um[hm] = !0;
  }
}
function nle(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function rle(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function Li(e, t) {
  if (e == null)
    return {};
  var n = rle(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function ale(e) {
  if (Array.isArray(e))
    return e;
}
function ile(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, a, i, o, s = [], c = !0, l = !1;
    try {
      if (i = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        c = !1;
      } else
        for (; !(c = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); c = !0)
          ;
    } catch (u) {
      l = !0, a = u;
    } finally {
      try {
        if (!c && n.return != null && (o = n.return(), Object(o) !== o))
          return;
      } finally {
        if (l)
          throw a;
      }
    }
    return s;
  }
}
function fh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function gb(e, t) {
  if (e) {
    if (typeof e == "string")
      return fh(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return fh(e, t);
  }
}
function ole() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ho(e, t) {
  return ale(e) || ile(e, t) || gb(e, t) || ole();
}
function Mi(e) {
  "@babel/helpers - typeof";
  return Mi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mi(e);
}
function h2(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function sle(e, t) {
  if (Mi(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Mi(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function vb(e) {
  var t = sle(e, "string");
  return Mi(t) === "symbol" ? t : String(t);
}
function pm(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, vb(r.key), r);
  }
}
function p2(e, t, n) {
  return t && pm(e.prototype, t), n && pm(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function yh(e, t) {
  return yh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, yh(e, t);
}
function f2(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && yh(e, t);
}
function Un(e, t, n) {
  return t = vb(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function cle(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function fm(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ze(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fm(Object(n), !0).forEach(function(r) {
      cle(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fm(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Al(e) {
  return Al = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Al(e);
}
function lle() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function dle(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ule(e, t) {
  return t && (typeof t == "object" || typeof t == "function") ? t : dle(e);
}
function y2(e) {
  var t = lle();
  return function() {
    var r = Al(e), a;
    if (t) {
      var i = Al(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return ule(this, a);
  };
}
var hle = ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], Ol = function() {
};
function ple(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function fle(e, t, n) {
  var r = [n];
  if (t && e)
    for (var a in t)
      t.hasOwnProperty(a) && t[a] && r.push("".concat(ple(e, a)));
  return r.filter(function(i) {
    return i;
  }).map(function(i) {
    return String(i).trim();
  }).join(" ");
}
var ym = function(t) {
  return Cle(t) ? t.filter(Boolean) : Mi(t) === "object" && t !== null ? [t] : [];
}, kb = function(t) {
  t.className, t.clearValue, t.cx, t.getStyles, t.getValue, t.hasValue, t.isMulti, t.isRtl, t.options, t.selectOption, t.selectProps, t.setValue, t.theme;
  var n = Li(t, hle);
  return Ze({}, n);
};
function O1(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function yle(e) {
  return O1(e) ? window.innerHeight : e.clientHeight;
}
function bb(e) {
  return O1(e) ? window.pageYOffset : e.scrollTop;
}
function El(e, t) {
  if (O1(e)) {
    window.scrollTo(0, t);
    return;
  }
  e.scrollTop = t;
}
function mle(e) {
  var t = getComputedStyle(e), n = t.position === "absolute", r = /(auto|scroll)/;
  if (t.position === "fixed")
    return document.documentElement;
  for (var a = e; a = a.parentElement; )
    if (t = getComputedStyle(a), !(n && t.position === "static") && r.test(t.overflow + t.overflowY + t.overflowX))
      return a;
  return document.documentElement;
}
function gle(e, t, n, r) {
  return n * ((e = e / r - 1) * e * e + 1) + t;
}
function Us(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Ol, a = bb(e), i = t - a, o = 10, s = 0;
  function c() {
    s += o;
    var l = gle(s, a, i, n);
    El(e, l), s < n ? window.requestAnimationFrame(c) : r(e);
  }
  c();
}
function vle(e, t) {
  var n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), a = t.offsetHeight / 3;
  r.bottom + a > n.bottom ? El(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + a, e.scrollHeight)) : r.top - a < n.top && El(e, Math.max(t.offsetTop - a, 0));
}
function kle(e) {
  var t = e.getBoundingClientRect();
  return {
    bottom: t.bottom,
    height: t.height,
    left: t.left,
    right: t.right,
    top: t.top,
    width: t.width
  };
}
function mm() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function ble() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var xb = !1, xle = {
  get passive() {
    return xb = !0;
  }
}, Ys = typeof window < "u" ? window : {};
Ys.addEventListener && Ys.removeEventListener && (Ys.addEventListener("p", Ol, xle), Ys.removeEventListener("p", Ol, !1));
var Mle = xb;
function wle(e) {
  return e != null;
}
function Cle(e) {
  return Array.isArray(e);
}
function Js(e, t, n) {
  return e ? t : n;
}
var Sle = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
    r[a - 1] = arguments[a];
  var i = Object.entries(t).filter(function(o) {
    var s = ho(o, 1), c = s[0];
    return !r.includes(c);
  });
  return i.reduce(function(o, s) {
    var c = ho(s, 2), l = c[0], u = c[1];
    return o[l] = u, o;
  }, {});
};
function Ale(e) {
  var t = e.maxHeight, n = e.menuEl, r = e.minHeight, a = e.placement, i = e.shouldScroll, o = e.isFixedPosition, s = e.theme, c = s.spacing, l = mle(n), u = {
    placement: "bottom",
    maxHeight: t
  };
  if (!n || !n.offsetParent)
    return u;
  var h = l.getBoundingClientRect(), p = h.height, f = n.getBoundingClientRect(), y = f.bottom, m = f.height, v = f.top, k = n.offsetParent.getBoundingClientRect(), b = k.top, x = o ? window.innerHeight : yle(l), g = bb(l), w = parseInt(getComputedStyle(n).marginBottom, 10), M = parseInt(getComputedStyle(n).marginTop, 10), S = b - M, D = x - v, A = S + g, $ = p - g - v, F = y - x + g + w, Z = g + v - M, B = 160;
  switch (a) {
    case "auto":
    case "bottom":
      if (D >= m)
        return {
          placement: "bottom",
          maxHeight: t
        };
      if ($ >= m && !o)
        return i && Us(l, F, B), {
          placement: "bottom",
          maxHeight: t
        };
      if (!o && $ >= r || o && D >= r) {
        i && Us(l, F, B);
        var O = o ? D - w : $ - w;
        return {
          placement: "bottom",
          maxHeight: O
        };
      }
      if (a === "auto" || o) {
        var I = t, N = o ? S : A;
        return N >= r && (I = Math.min(N - w - c.controlHeight, t)), {
          placement: "top",
          maxHeight: I
        };
      }
      if (a === "bottom")
        return i && El(l, F), {
          placement: "bottom",
          maxHeight: t
        };
      break;
    case "top":
      if (S >= m)
        return {
          placement: "top",
          maxHeight: t
        };
      if (A >= m && !o)
        return i && Us(l, Z, B), {
          placement: "top",
          maxHeight: t
        };
      if (!o && A >= r || o && S >= r) {
        var R = t;
        return (!o && A >= r || o && S >= r) && (R = o ? S - M : A - M), i && Us(l, Z, B), {
          placement: "top",
          maxHeight: R
        };
      }
      return {
        placement: "bottom",
        maxHeight: t
      };
    default:
      throw new Error('Invalid placement provided "'.concat(a, '".'));
  }
  return u;
}
function Ole(e) {
  var t = {
    bottom: "top",
    top: "bottom"
  };
  return e ? t[e] : "bottom";
}
var mh = function(t) {
  return t === "auto" ? "bottom" : t;
}, Ele = function(t) {
  var n, r = t.placement, a = t.theme, i = a.borderRadius, o = a.spacing, s = a.colors;
  return n = {
    label: "menu"
  }, Un(n, Ole(r), "100%"), Un(n, "backgroundColor", s.neutral0), Un(n, "borderRadius", i), Un(n, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), Un(n, "marginBottom", o.menuGutter), Un(n, "marginTop", o.menuGutter), Un(n, "position", "absolute"), Un(n, "width", "100%"), Un(n, "zIndex", 1), n;
}, Mb = /* @__PURE__ */ $n({
  getPortalPlacement: null
}), wb = /* @__PURE__ */ function(e) {
  f2(n, e);
  var t = y2(n);
  function n() {
    var r;
    h2(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), r.state = {
      maxHeight: r.props.maxMenuHeight,
      placement: null
    }, r.context = void 0, r.getPlacement = function(s) {
      var c = r.props, l = c.minMenuHeight, u = c.maxMenuHeight, h = c.menuPlacement, p = c.menuPosition, f = c.menuShouldScrollIntoView, y = c.theme;
      if (s) {
        var m = p === "fixed", v = f && !m, k = Ale({
          maxHeight: u,
          menuEl: s,
          minHeight: l,
          placement: h,
          shouldScroll: v,
          isFixedPosition: m,
          theme: y
        }), b = r.context.getPortalPlacement;
        b && b(k), r.setState(k);
      }
    }, r.getUpdatedProps = function() {
      var s = r.props.menuPlacement, c = r.state.placement || mh(s);
      return Ze(Ze({}, r.props), {}, {
        placement: c,
        maxHeight: r.state.maxHeight
      });
    }, r;
  }
  return p2(n, [{
    key: "render",
    value: function() {
      var a = this.props.children;
      return a({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]), n;
}(Si);
wb.contextType = Mb;
var Ile = function(t) {
  var n = t.children, r = t.className, a = t.cx, i = t.getStyles, o = t.innerRef, s = t.innerProps;
  return we("div", Ce({
    css: i("menu", t),
    className: a({
      menu: !0
    }, r),
    ref: o
  }, s), n);
}, Dle = function(t) {
  var n = t.maxHeight, r = t.theme.spacing.baseUnit;
  return {
    maxHeight: n,
    overflowY: "auto",
    paddingBottom: r,
    paddingTop: r,
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  };
}, Tle = function(t) {
  var n = t.children, r = t.className, a = t.cx, i = t.getStyles, o = t.innerProps, s = t.innerRef, c = t.isMulti;
  return we("div", Ce({
    css: i("menuList", t),
    className: a({
      "menu-list": !0,
      "menu-list--is-multi": c
    }, r),
    ref: s
  }, o), n);
}, Cb = function(t) {
  var n = t.theme, r = n.spacing.baseUnit, a = n.colors;
  return {
    color: a.neutral40,
    padding: "".concat(r * 2, "px ").concat(r * 3, "px"),
    textAlign: "center"
  };
}, Nle = Cb, Ple = Cb, Sb = function(t) {
  var n = t.children, r = t.className, a = t.cx, i = t.getStyles, o = t.innerProps;
  return we("div", Ce({
    css: i("noOptionsMessage", t),
    className: a({
      "menu-notice": !0,
      "menu-notice--no-options": !0
    }, r)
  }, o), n);
};
Sb.defaultProps = {
  children: "No options"
};
var Ab = function(t) {
  var n = t.children, r = t.className, a = t.cx, i = t.getStyles, o = t.innerProps;
  return we("div", Ce({
    css: i("loadingMessage", t),
    className: a({
      "menu-notice": !0,
      "menu-notice--loading": !0
    }, r)
  }, o), n);
};
Ab.defaultProps = {
  children: "Loading..."
};
var Lle = function(t) {
  var n = t.rect, r = t.offset, a = t.position;
  return {
    left: n.left,
    position: a,
    top: r,
    width: n.width,
    zIndex: 1
  };
}, Rle = /* @__PURE__ */ function(e) {
  f2(n, e);
  var t = y2(n);
  function n() {
    var r;
    h2(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), r.state = {
      placement: null
    }, r.getPortalPlacement = function(s) {
      var c = s.placement, l = mh(r.props.menuPlacement);
      c !== l && r.setState({
        placement: c
      });
    }, r;
  }
  return p2(n, [{
    key: "render",
    value: function() {
      var a = this.props, i = a.appendTo, o = a.children, s = a.className, c = a.controlElement, l = a.cx, u = a.innerProps, h = a.menuPlacement, p = a.menuPosition, f = a.getStyles, y = p === "fixed";
      if (!i && !y || !c)
        return null;
      var m = this.state.placement || mh(h), v = kle(c), k = y ? 0 : window.pageYOffset, b = v[m] + k, x = {
        offset: b,
        position: p,
        rect: v
      }, g = we("div", Ce({
        css: f("menuPortal", x),
        className: l({
          "menu-portal": !0
        }, s)
      }, u), o);
      return we(Mb.Provider, {
        value: {
          getPortalPlacement: this.getPortalPlacement
        }
      }, i ? /* @__PURE__ */ Eg(g, i) : g);
    }
  }]), n;
}(Si), Vle = function(t) {
  var n = t.isDisabled, r = t.isRtl;
  return {
    label: "container",
    direction: r ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, zle = function(t) {
  var n = t.children, r = t.className, a = t.cx, i = t.getStyles, o = t.innerProps, s = t.isDisabled, c = t.isRtl;
  return we("div", Ce({
    css: i("container", t),
    className: a({
      "--is-disabled": s,
      "--is-rtl": c
    }, r)
  }, o), n);
}, Ble = function(t) {
  var n = t.theme.spacing, r = t.isMulti, a = t.hasValue, i = t.selectProps.controlShouldRenderValue;
  return {
    alignItems: "center",
    display: r && a && i ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    padding: "".concat(n.baseUnit / 2, "px ").concat(n.baseUnit * 2, "px"),
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  };
}, Hle = function(t) {
  var n = t.children, r = t.className, a = t.cx, i = t.innerProps, o = t.isMulti, s = t.getStyles, c = t.hasValue;
  return we("div", Ce({
    css: s("valueContainer", t),
    className: a({
      "value-container": !0,
      "value-container--is-multi": o,
      "value-container--has-value": c
    }, r)
  }, i), n);
}, $le = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, jle = function(t) {
  var n = t.children, r = t.className, a = t.cx, i = t.innerProps, o = t.getStyles;
  return we("div", Ce({
    css: o("indicatorsContainer", t),
    className: a({
      indicators: !0
    }, r)
  }, i), n);
}, gm, Fle = ["size"];
function Wle() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var qle = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGljYXRvcnMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXdCSSIsImZpbGUiOiJpbmRpY2F0b3JzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVhY3ROb2RlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4LCBrZXlmcmFtZXMgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmltcG9ydCB7XG4gIENvbW1vblByb3BzQW5kQ2xhc3NOYW1lLFxuICBDU1NPYmplY3RXaXRoTGFiZWwsXG4gIEdyb3VwQmFzZSxcbn0gZnJvbSAnLi4vdHlwZXMnO1xuXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbi8vIERyb3Bkb3duICYgQ2xlYXIgSWNvbnNcbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuXG5jb25zdCBTdmcgPSAoe1xuICBzaXplLFxuICAuLi5wcm9wc1xufTogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzdmcnXSAmIHsgc2l6ZTogbnVtYmVyIH0pID0+IChcbiAgPHN2Z1xuICAgIGhlaWdodD17c2l6ZX1cbiAgICB3aWR0aD17c2l6ZX1cbiAgICB2aWV3Qm94PVwiMCAwIDIwIDIwXCJcbiAgICBhcmlhLWhpZGRlbj1cInRydWVcIlxuICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICBjc3M9e3tcbiAgICAgIGRpc3BsYXk6ICdpbmxpbmUtYmxvY2snLFxuICAgICAgZmlsbDogJ2N1cnJlbnRDb2xvcicsXG4gICAgICBsaW5lSGVpZ2h0OiAxLFxuICAgICAgc3Ryb2tlOiAnY3VycmVudENvbG9yJyxcbiAgICAgIHN0cm9rZVdpZHRoOiAwLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IHR5cGUgQ3Jvc3NJY29uUHJvcHMgPSBKU1guSW50cmluc2ljRWxlbWVudHNbJ3N2ZyddICYgeyBzaXplPzogbnVtYmVyIH07XG5leHBvcnQgY29uc3QgQ3Jvc3NJY29uID0gKHByb3BzOiBDcm9zc0ljb25Qcm9wcykgPT4gKFxuICA8U3ZnIHNpemU9ezIwfSB7Li4ucHJvcHN9PlxuICAgIDxwYXRoIGQ9XCJNMTQuMzQ4IDE0Ljg0OWMtMC40NjkgMC40NjktMS4yMjkgMC40NjktMS42OTcgMGwtMi42NTEtMy4wMzAtMi42NTEgMy4wMjljLTAuNDY5IDAuNDY5LTEuMjI5IDAuNDY5LTEuNjk3IDAtMC40NjktMC40NjktMC40NjktMS4yMjkgMC0xLjY5N2wyLjc1OC0zLjE1LTIuNzU5LTMuMTUyYy0wLjQ2OS0wLjQ2OS0wLjQ2OS0xLjIyOCAwLTEuNjk3czEuMjI4LTAuNDY5IDEuNjk3IDBsMi42NTIgMy4wMzEgMi42NTEtMy4wMzFjMC40NjktMC40NjkgMS4yMjgtMC40NjkgMS42OTcgMHMwLjQ2OSAxLjIyOSAwIDEuNjk3bC0yLjc1OCAzLjE1MiAyLjc1OCAzLjE1YzAuNDY5IDAuNDY5IDAuNDY5IDEuMjI5IDAgMS42OTh6XCIgLz5cbiAgPC9Tdmc+XG4pO1xuZXhwb3J0IHR5cGUgRG93bkNoZXZyb25Qcm9wcyA9IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snc3ZnJ10gJiB7IHNpemU/OiBudW1iZXIgfTtcbmV4cG9ydCBjb25zdCBEb3duQ2hldnJvbiA9IChwcm9wczogRG93bkNoZXZyb25Qcm9wcykgPT4gKFxuICA8U3ZnIHNpemU9ezIwfSB7Li4ucHJvcHN9PlxuICAgIDxwYXRoIGQ9XCJNNC41MTYgNy41NDhjMC40MzYtMC40NDYgMS4wNDMtMC40ODEgMS41NzYgMGwzLjkwOCAzLjc0NyAzLjkwOC0zLjc0N2MwLjUzMy0wLjQ4MSAxLjE0MS0wLjQ0NiAxLjU3NCAwIDAuNDM2IDAuNDQ1IDAuNDA4IDEuMTk3IDAgMS42MTUtMC40MDYgMC40MTgtNC42OTUgNC41MDItNC42OTUgNC41MDItMC4yMTcgMC4yMjMtMC41MDIgMC4zMzUtMC43ODcgMC4zMzVzLTAuNTctMC4xMTItMC43ODktMC4zMzVjMCAwLTQuMjg3LTQuMDg0LTQuNjk1LTQuNTAycy0wLjQzNi0xLjE3IDAtMS42MTV6XCIgLz5cbiAgPC9Tdmc+XG4pO1xuXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbi8vIERyb3Bkb3duICYgQ2xlYXIgQnV0dG9uc1xuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG5cbmV4cG9ydCBpbnRlcmZhY2UgRHJvcGRvd25JbmRpY2F0b3JQcm9wczxcbiAgT3B0aW9uID0gdW5rbm93bixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4gPSBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+ID0gR3JvdXBCYXNlPE9wdGlvbj5cbj4gZXh0ZW5kcyBDb21tb25Qcm9wc0FuZENsYXNzTmFtZTxPcHRpb24sIElzTXVsdGksIEdyb3VwPiB7XG4gIC8qKiBUaGUgY2hpbGRyZW4gdG8gYmUgcmVuZGVyZWQgaW5zaWRlIHRoZSBpbmRpY2F0b3IuICovXG4gIGNoaWxkcmVuPzogUmVhY3ROb2RlO1xuICAvKiogUHJvcHMgdGhhdCB3aWxsIGJlIHBhc3NlZCBvbiB0byB0aGUgY2hpbGRyZW4uICovXG4gIGlubmVyUHJvcHM6IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snZGl2J107XG4gIC8qKiBUaGUgZm9jdXNlZCBzdGF0ZSBvZiB0aGUgc2VsZWN0LiAqL1xuICBpc0ZvY3VzZWQ6IGJvb2xlYW47XG4gIGlzRGlzYWJsZWQ6IGJvb2xlYW47XG59XG5cbmNvbnN0IGJhc2VDU1MgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oe1xuICBpc0ZvY3VzZWQsXG4gIHRoZW1lOiB7XG4gICAgc3BhY2luZzogeyBiYXNlVW5pdCB9LFxuICAgIGNvbG9ycyxcbiAgfSxcbn06XG4gIHwgRHJvcGRvd25JbmRpY2F0b3JQcm9wczxPcHRpb24sIElzTXVsdGksIEdyb3VwPlxuICB8IENsZWFySW5kaWNhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD4pOiBDU1NPYmplY3RXaXRoTGFiZWwgPT4gKHtcbiAgbGFiZWw6ICdpbmRpY2F0b3JDb250YWluZXInLFxuICBjb2xvcjogaXNGb2N1c2VkID8gY29sb3JzLm5ldXRyYWw2MCA6IGNvbG9ycy5uZXV0cmFsMjAsXG4gIGRpc3BsYXk6ICdmbGV4JyxcbiAgcGFkZGluZzogYmFzZVVuaXQgKiAyLFxuICB0cmFuc2l0aW9uOiAnY29sb3IgMTUwbXMnLFxuXG4gICc6aG92ZXInOiB7XG4gICAgY29sb3I6IGlzRm9jdXNlZCA/IGNvbG9ycy5uZXV0cmFsODAgOiBjb2xvcnMubmV1dHJhbDQwLFxuICB9LFxufSk7XG5cbmV4cG9ydCBjb25zdCBkcm9wZG93bkluZGljYXRvckNTUyA9IGJhc2VDU1M7XG5leHBvcnQgY29uc3QgRHJvcGRvd25JbmRpY2F0b3IgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oXG4gIHByb3BzOiBEcm9wZG93bkluZGljYXRvclByb3BzPE9wdGlvbiwgSXNNdWx0aSwgR3JvdXA+XG4pID0+IHtcbiAgY29uc3QgeyBjaGlsZHJlbiwgY2xhc3NOYW1lLCBjeCwgZ2V0U3R5bGVzLCBpbm5lclByb3BzIH0gPSBwcm9wcztcbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICBjc3M9e2dldFN0eWxlcygnZHJvcGRvd25JbmRpY2F0b3InLCBwcm9wcyl9XG4gICAgICBjbGFzc05hbWU9e2N4KFxuICAgICAgICB7XG4gICAgICAgICAgaW5kaWNhdG9yOiB0cnVlLFxuICAgICAgICAgICdkcm9wZG93bi1pbmRpY2F0b3InOiB0cnVlLFxuICAgICAgICB9LFxuICAgICAgICBjbGFzc05hbWVcbiAgICAgICl9XG4gICAgICB7Li4uaW5uZXJQcm9wc31cbiAgICA+XG4gICAgICB7Y2hpbGRyZW4gfHwgPERvd25DaGV2cm9uIC8+fVxuICAgIDwvZGl2PlxuICApO1xufTtcblxuZXhwb3J0IGludGVyZmFjZSBDbGVhckluZGljYXRvclByb3BzPFxuICBPcHRpb24gPSB1bmtub3duLFxuICBJc011bHRpIGV4dGVuZHMgYm9vbGVhbiA9IGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj4gPSBHcm91cEJhc2U8T3B0aW9uPlxuPiBleHRlbmRzIENvbW1vblByb3BzQW5kQ2xhc3NOYW1lPE9wdGlvbiwgSXNNdWx0aSwgR3JvdXA+IHtcbiAgLyoqIFRoZSBjaGlsZHJlbiB0byBiZSByZW5kZXJlZCBpbnNpZGUgdGhlIGluZGljYXRvci4gKi9cbiAgY2hpbGRyZW4/OiBSZWFjdE5vZGU7XG4gIC8qKiBQcm9wcyB0aGF0IHdpbGwgYmUgcGFzc2VkIG9uIHRvIHRoZSBjaGlsZHJlbi4gKi9cbiAgaW5uZXJQcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydkaXYnXTtcbiAgLyoqIFRoZSBmb2N1c2VkIHN0YXRlIG9mIHRoZSBzZWxlY3QuICovXG4gIGlzRm9jdXNlZDogYm9vbGVhbjtcbn1cblxuZXhwb3J0IGNvbnN0IGNsZWFySW5kaWNhdG9yQ1NTID0gYmFzZUNTUztcbmV4cG9ydCBjb25zdCBDbGVhckluZGljYXRvciA9IDxcbiAgT3B0aW9uLFxuICBJc011bHRpIGV4dGVuZHMgYm9vbGVhbixcbiAgR3JvdXAgZXh0ZW5kcyBHcm91cEJhc2U8T3B0aW9uPlxuPihcbiAgcHJvcHM6IENsZWFySW5kaWNhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD5cbikgPT4ge1xuICBjb25zdCB7IGNoaWxkcmVuLCBjbGFzc05hbWUsIGN4LCBnZXRTdHlsZXMsIGlubmVyUHJvcHMgfSA9IHByb3BzO1xuICByZXR1cm4gKFxuICAgIDxkaXZcbiAgICAgIGNzcz17Z2V0U3R5bGVzKCdjbGVhckluZGljYXRvcicsIHByb3BzKX1cbiAgICAgIGNsYXNzTmFtZT17Y3goXG4gICAgICAgIHtcbiAgICAgICAgICBpbmRpY2F0b3I6IHRydWUsXG4gICAgICAgICAgJ2NsZWFyLWluZGljYXRvcic6IHRydWUsXG4gICAgICAgIH0sXG4gICAgICAgIGNsYXNzTmFtZVxuICAgICAgKX1cbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgID5cbiAgICAgIHtjaGlsZHJlbiB8fCA8Q3Jvc3NJY29uIC8+fVxuICAgIDwvZGl2PlxuICApO1xufTtcblxuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyBTZXBhcmF0b3Jcbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuXG5leHBvcnQgaW50ZXJmYWNlIEluZGljYXRvclNlcGFyYXRvclByb3BzPFxuICBPcHRpb24gPSB1bmtub3duLFxuICBJc011bHRpIGV4dGVuZHMgYm9vbGVhbiA9IGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj4gPSBHcm91cEJhc2U8T3B0aW9uPlxuPiBleHRlbmRzIENvbW1vblByb3BzQW5kQ2xhc3NOYW1lPE9wdGlvbiwgSXNNdWx0aSwgR3JvdXA+IHtcbiAgaXNEaXNhYmxlZDogYm9vbGVhbjtcbiAgaXNGb2N1c2VkOiBib29sZWFuO1xuICBpbm5lclByb3BzPzogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ107XG59XG5cbmV4cG9ydCBjb25zdCBpbmRpY2F0b3JTZXBhcmF0b3JDU1MgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oe1xuICBpc0Rpc2FibGVkLFxuICB0aGVtZToge1xuICAgIHNwYWNpbmc6IHsgYmFzZVVuaXQgfSxcbiAgICBjb2xvcnMsXG4gIH0sXG59OiBJbmRpY2F0b3JTZXBhcmF0b3JQcm9wczxPcHRpb24sIElzTXVsdGksIEdyb3VwPik6IENTU09iamVjdFdpdGhMYWJlbCA9PiAoe1xuICBsYWJlbDogJ2luZGljYXRvclNlcGFyYXRvcicsXG4gIGFsaWduU2VsZjogJ3N0cmV0Y2gnLFxuICBiYWNrZ3JvdW5kQ29sb3I6IGlzRGlzYWJsZWQgPyBjb2xvcnMubmV1dHJhbDEwIDogY29sb3JzLm5ldXRyYWwyMCxcbiAgbWFyZ2luQm90dG9tOiBiYXNlVW5pdCAqIDIsXG4gIG1hcmdpblRvcDogYmFzZVVuaXQgKiAyLFxuICB3aWR0aDogMSxcbn0pO1xuXG5leHBvcnQgY29uc3QgSW5kaWNhdG9yU2VwYXJhdG9yID0gPFxuICBPcHRpb24sXG4gIElzTXVsdGkgZXh0ZW5kcyBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+XG4+KFxuICBwcm9wczogSW5kaWNhdG9yU2VwYXJhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD5cbikgPT4ge1xuICBjb25zdCB7IGNsYXNzTmFtZSwgY3gsIGdldFN0eWxlcywgaW5uZXJQcm9wcyB9ID0gcHJvcHM7XG4gIHJldHVybiAoXG4gICAgPHNwYW5cbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgICAgY3NzPXtnZXRTdHlsZXMoJ2luZGljYXRvclNlcGFyYXRvcicsIHByb3BzKX1cbiAgICAgIGNsYXNzTmFtZT17Y3goeyAnaW5kaWNhdG9yLXNlcGFyYXRvcic6IHRydWUgfSwgY2xhc3NOYW1lKX1cbiAgICAvPlxuICApO1xufTtcblxuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyBMb2FkaW5nXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cblxuY29uc3QgbG9hZGluZ0RvdEFuaW1hdGlvbnMgPSBrZXlmcmFtZXNgXG4gIDAlLCA4MCUsIDEwMCUgeyBvcGFjaXR5OiAwOyB9XG4gIDQwJSB7IG9wYWNpdHk6IDE7IH1cbmA7XG5cbmV4cG9ydCBjb25zdCBsb2FkaW5nSW5kaWNhdG9yQ1NTID0gPFxuICBPcHRpb24sXG4gIElzTXVsdGkgZXh0ZW5kcyBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+XG4+KHtcbiAgaXNGb2N1c2VkLFxuICBzaXplLFxuICB0aGVtZToge1xuICAgIGNvbG9ycyxcbiAgICBzcGFjaW5nOiB7IGJhc2VVbml0IH0sXG4gIH0sXG59OiBMb2FkaW5nSW5kaWNhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD4pOiBDU1NPYmplY3RXaXRoTGFiZWwgPT4gKHtcbiAgbGFiZWw6ICdsb2FkaW5nSW5kaWNhdG9yJyxcbiAgY29sb3I6IGlzRm9jdXNlZCA/IGNvbG9ycy5uZXV0cmFsNjAgOiBjb2xvcnMubmV1dHJhbDIwLFxuICBkaXNwbGF5OiAnZmxleCcsXG4gIHBhZGRpbmc6IGJhc2VVbml0ICogMixcbiAgdHJhbnNpdGlvbjogJ2NvbG9yIDE1MG1zJyxcbiAgYWxpZ25TZWxmOiAnY2VudGVyJyxcbiAgZm9udFNpemU6IHNpemUsXG4gIGxpbmVIZWlnaHQ6IDEsXG4gIG1hcmdpblJpZ2h0OiBzaXplLFxuICB0ZXh0QWxpZ246ICdjZW50ZXInLFxuICB2ZXJ0aWNhbEFsaWduOiAnbWlkZGxlJyxcbn0pO1xuXG5pbnRlcmZhY2UgTG9hZGluZ0RvdFByb3BzIHtcbiAgZGVsYXk6IG51bWJlcjtcbiAgb2Zmc2V0OiBib29sZWFuO1xufVxuY29uc3QgTG9hZGluZ0RvdCA9ICh7IGRlbGF5LCBvZmZzZXQgfTogTG9hZGluZ0RvdFByb3BzKSA9PiAoXG4gIDxzcGFuXG4gICAgY3NzPXt7XG4gICAgICBhbmltYXRpb246IGAke2xvYWRpbmdEb3RBbmltYXRpb25zfSAxcyBlYXNlLWluLW91dCAke2RlbGF5fW1zIGluZmluaXRlO2AsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6ICdjdXJyZW50Q29sb3InLFxuICAgICAgYm9yZGVyUmFkaXVzOiAnMWVtJyxcbiAgICAgIGRpc3BsYXk6ICdpbmxpbmUtYmxvY2snLFxuICAgICAgbWFyZ2luTGVmdDogb2Zmc2V0ID8gJzFlbScgOiB1bmRlZmluZWQsXG4gICAgICBoZWlnaHQ6ICcxZW0nLFxuICAgICAgdmVydGljYWxBbGlnbjogJ3RvcCcsXG4gICAgICB3aWR0aDogJzFlbScsXG4gICAgfX1cbiAgLz5cbik7XG5cbmV4cG9ydCBpbnRlcmZhY2UgTG9hZGluZ0luZGljYXRvclByb3BzPFxuICBPcHRpb24gPSB1bmtub3duLFxuICBJc011bHRpIGV4dGVuZHMgYm9vbGVhbiA9IGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj4gPSBHcm91cEJhc2U8T3B0aW9uPlxuPiBleHRlbmRzIENvbW1vblByb3BzQW5kQ2xhc3NOYW1lPE9wdGlvbiwgSXNNdWx0aSwgR3JvdXA+IHtcbiAgLyoqIFByb3BzIHRoYXQgd2lsbCBiZSBwYXNzZWQgb24gdG8gdGhlIGNoaWxkcmVuLiAqL1xuICBpbm5lclByb3BzOiBKU1guSW50cmluc2ljRWxlbWVudHNbJ2RpdiddO1xuICAvKiogVGhlIGZvY3VzZWQgc3RhdGUgb2YgdGhlIHNlbGVjdC4gKi9cbiAgaXNGb2N1c2VkOiBib29sZWFuO1xuICBpc0Rpc2FibGVkOiBib29sZWFuO1xuICAvKiogU2V0IHNpemUgb2YgdGhlIGNvbnRhaW5lci4gKi9cbiAgc2l6ZTogbnVtYmVyO1xufVxuZXhwb3J0IGNvbnN0IExvYWRpbmdJbmRpY2F0b3IgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oXG4gIHByb3BzOiBMb2FkaW5nSW5kaWNhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD5cbikgPT4ge1xuICBjb25zdCB7IGNsYXNzTmFtZSwgY3gsIGdldFN0eWxlcywgaW5uZXJQcm9wcywgaXNSdGwgfSA9IHByb3BzO1xuXG4gIHJldHVybiAoXG4gICAgPGRpdlxuICAgICAgY3NzPXtnZXRTdHlsZXMoJ2xvYWRpbmdJbmRpY2F0b3InLCBwcm9wcyl9XG4gICAgICBjbGFzc05hbWU9e2N4KFxuICAgICAgICB7XG4gICAgICAgICAgaW5kaWNhdG9yOiB0cnVlLFxuICAgICAgICAgICdsb2FkaW5nLWluZGljYXRvcic6IHRydWUsXG4gICAgICAgIH0sXG4gICAgICAgIGNsYXNzTmFtZVxuICAgICAgKX1cbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgID5cbiAgICAgIDxMb2FkaW5nRG90IGRlbGF5PXswfSBvZmZzZXQ9e2lzUnRsfSAvPlxuICAgICAgPExvYWRpbmdEb3QgZGVsYXk9ezE2MH0gb2Zmc2V0IC8+XG4gICAgICA8TG9hZGluZ0RvdCBkZWxheT17MzIwfSBvZmZzZXQ9eyFpc1J0bH0gLz5cbiAgICA8L2Rpdj5cbiAgKTtcbn07XG5Mb2FkaW5nSW5kaWNhdG9yLmRlZmF1bHRQcm9wcyA9IHsgc2l6ZTogNCB9O1xuIl19 */",
  toString: Wle
}, Ob = function(t) {
  var n = t.size, r = Li(t, Fle);
  return we("svg", Ce({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: qle
  }, r));
}, m2 = function(t) {
  return we(Ob, Ce({
    size: 20
  }, t), we("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, Eb = function(t) {
  return we(Ob, Ce({
    size: 20
  }, t), we("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, Ib = function(t) {
  var n = t.isFocused, r = t.theme, a = r.spacing.baseUnit, i = r.colors;
  return {
    label: "indicatorContainer",
    color: n ? i.neutral60 : i.neutral20,
    display: "flex",
    padding: a * 2,
    transition: "color 150ms",
    ":hover": {
      color: n ? i.neutral80 : i.neutral40
    }
  };
}, _le = Ib, Gle = function(t) {
  var n = t.children, r = t.className, a = t.cx, i = t.getStyles, o = t.innerProps;
  return we("div", Ce({
    css: i("dropdownIndicator", t),
    className: a({
      indicator: !0,
      "dropdown-indicator": !0
    }, r)
  }, o), n || we(Eb, null));
}, Zle = Ib, Xle = function(t) {
  var n = t.children, r = t.className, a = t.cx, i = t.getStyles, o = t.innerProps;
  return we("div", Ce({
    css: i("clearIndicator", t),
    className: a({
      indicator: !0,
      "clear-indicator": !0
    }, r)
  }, o), n || we(m2, null));
}, Ule = function(t) {
  var n = t.isDisabled, r = t.theme, a = r.spacing.baseUnit, i = r.colors;
  return {
    label: "indicatorSeparator",
    alignSelf: "stretch",
    backgroundColor: n ? i.neutral10 : i.neutral20,
    marginBottom: a * 2,
    marginTop: a * 2,
    width: 1
  };
}, Yle = function(t) {
  var n = t.className, r = t.cx, a = t.getStyles, i = t.innerProps;
  return we("span", Ce({}, i, {
    css: a("indicatorSeparator", t),
    className: r({
      "indicator-separator": !0
    }, n)
  }));
}, Jle = Jce(gm || (gm = nle([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), Kle = function(t) {
  var n = t.isFocused, r = t.size, a = t.theme, i = a.colors, o = a.spacing.baseUnit;
  return {
    label: "loadingIndicator",
    color: n ? i.neutral60 : i.neutral20,
    display: "flex",
    padding: o * 2,
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: r,
    lineHeight: 1,
    marginRight: r,
    textAlign: "center",
    verticalAlign: "middle"
  };
}, Wd = function(t) {
  var n = t.delay, r = t.offset;
  return we("span", {
    css: /* @__PURE__ */ u2({
      animation: "".concat(Jle, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: r ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, Db = function(t) {
  var n = t.className, r = t.cx, a = t.getStyles, i = t.innerProps, o = t.isRtl;
  return we("div", Ce({
    css: a("loadingIndicator", t),
    className: r({
      indicator: !0,
      "loading-indicator": !0
    }, n)
  }, i), we(Wd, {
    delay: 0,
    offset: o
  }), we(Wd, {
    delay: 160,
    offset: !0
  }), we(Wd, {
    delay: 320,
    offset: !o
  }));
};
Db.defaultProps = {
  size: 4
};
var Qle = function(t) {
  var n = t.isDisabled, r = t.isFocused, a = t.theme, i = a.colors, o = a.borderRadius, s = a.spacing;
  return {
    label: "control",
    alignItems: "center",
    backgroundColor: n ? i.neutral5 : i.neutral0,
    borderColor: n ? i.neutral10 : r ? i.primary : i.neutral20,
    borderRadius: o,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: r ? "0 0 0 1px ".concat(i.primary) : void 0,
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: s.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms",
    "&:hover": {
      borderColor: r ? i.primary : i.neutral30
    }
  };
}, e1e = function(t) {
  var n = t.children, r = t.cx, a = t.getStyles, i = t.className, o = t.isDisabled, s = t.isFocused, c = t.innerRef, l = t.innerProps, u = t.menuIsOpen;
  return we("div", Ce({
    ref: c,
    css: a("control", t),
    className: r({
      control: !0,
      "control--is-disabled": o,
      "control--is-focused": s,
      "control--menu-is-open": u
    }, i)
  }, l), n);
}, t1e = ["data"], n1e = function(t) {
  var n = t.theme.spacing;
  return {
    paddingBottom: n.baseUnit * 2,
    paddingTop: n.baseUnit * 2
  };
}, r1e = function(t) {
  var n = t.children, r = t.className, a = t.cx, i = t.getStyles, o = t.Heading, s = t.headingProps, c = t.innerProps, l = t.label, u = t.theme, h = t.selectProps;
  return we("div", Ce({
    css: i("group", t),
    className: a({
      group: !0
    }, r)
  }, c), we(o, Ce({}, s, {
    selectProps: h,
    theme: u,
    getStyles: i,
    cx: a
  }), l), we("div", null, n));
}, a1e = function(t) {
  var n = t.theme.spacing;
  return {
    label: "group",
    color: "#999",
    cursor: "default",
    display: "block",
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: n.baseUnit * 3,
    paddingRight: n.baseUnit * 3,
    textTransform: "uppercase"
  };
}, i1e = function(t) {
  var n = t.getStyles, r = t.cx, a = t.className, i = kb(t);
  i.data;
  var o = Li(i, t1e);
  return we("div", Ce({
    css: n("groupHeading", t),
    className: r({
      "group-heading": !0
    }, a)
  }, o));
}, o1e = ["innerRef", "isDisabled", "isHidden", "inputClassName"], s1e = function(t) {
  var n = t.isDisabled, r = t.value, a = t.theme, i = a.spacing, o = a.colors;
  return Ze({
    margin: i.baseUnit / 2,
    paddingBottom: i.baseUnit / 2,
    paddingTop: i.baseUnit / 2,
    visibility: n ? "hidden" : "visible",
    color: o.neutral80,
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: r ? "translateZ(0)" : ""
  }, c1e);
}, Tb = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, c1e = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": Ze({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, Tb)
}, l1e = function(t) {
  return Ze({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: t ? 0 : 1,
    width: "100%"
  }, Tb);
}, d1e = function(t) {
  var n = t.className, r = t.cx, a = t.getStyles, i = t.value, o = kb(t), s = o.innerRef, c = o.isDisabled, l = o.isHidden, u = o.inputClassName, h = Li(o, o1e);
  return we("div", {
    className: r({
      "input-container": !0
    }, n),
    css: a("input", t),
    "data-value": i || ""
  }, we("input", Ce({
    className: r({
      input: !0
    }, u),
    ref: s,
    style: l1e(l),
    disabled: c
  }, h)));
}, u1e = function(t) {
  var n = t.theme, r = n.spacing, a = n.borderRadius, i = n.colors;
  return {
    label: "multiValue",
    backgroundColor: i.neutral10,
    borderRadius: a / 2,
    display: "flex",
    margin: r.baseUnit / 2,
    minWidth: 0
    // resolves flex/text-overflow bug
  };
}, h1e = function(t) {
  var n = t.theme, r = n.borderRadius, a = n.colors, i = t.cropWithEllipsis;
  return {
    borderRadius: r / 2,
    color: a.neutral80,
    fontSize: "85%",
    overflow: "hidden",
    padding: 3,
    paddingLeft: 6,
    textOverflow: i || i === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  };
}, p1e = function(t) {
  var n = t.theme, r = n.spacing, a = n.borderRadius, i = n.colors, o = t.isFocused;
  return {
    alignItems: "center",
    borderRadius: a / 2,
    backgroundColor: o ? i.dangerLight : void 0,
    display: "flex",
    paddingLeft: r.baseUnit,
    paddingRight: r.baseUnit,
    ":hover": {
      backgroundColor: i.dangerLight,
      color: i.danger
    }
  };
}, Nb = function(t) {
  var n = t.children, r = t.innerProps;
  return we("div", r, n);
}, f1e = Nb, y1e = Nb;
function m1e(e) {
  var t = e.children, n = e.innerProps;
  return we("div", Ce({
    role: "button"
  }, n), t || we(m2, {
    size: 14
  }));
}
var g1e = function(t) {
  var n = t.children, r = t.className, a = t.components, i = t.cx, o = t.data, s = t.getStyles, c = t.innerProps, l = t.isDisabled, u = t.removeProps, h = t.selectProps, p = a.Container, f = a.Label, y = a.Remove;
  return we(mb, null, function(m) {
    var v = m.css, k = m.cx;
    return we(p, {
      data: o,
      innerProps: Ze({
        className: k(v(s("multiValue", t)), i({
          "multi-value": !0,
          "multi-value--is-disabled": l
        }, r))
      }, c),
      selectProps: h
    }, we(f, {
      data: o,
      innerProps: {
        className: k(v(s("multiValueLabel", t)), i({
          "multi-value__label": !0
        }, r))
      },
      selectProps: h
    }, n), we(y, {
      data: o,
      innerProps: Ze({
        className: k(v(s("multiValueRemove", t)), i({
          "multi-value__remove": !0
        }, r)),
        "aria-label": "Remove ".concat(n || "option")
      }, u),
      selectProps: h
    }));
  });
}, v1e = function(t) {
  var n = t.isDisabled, r = t.isFocused, a = t.isSelected, i = t.theme, o = i.spacing, s = i.colors;
  return {
    label: "option",
    backgroundColor: a ? s.primary : r ? s.primary25 : "transparent",
    color: n ? s.neutral20 : a ? s.neutral0 : "inherit",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    padding: "".concat(o.baseUnit * 2, "px ").concat(o.baseUnit * 3, "px"),
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: n ? void 0 : a ? s.primary : s.primary50
    }
  };
}, k1e = function(t) {
  var n = t.children, r = t.className, a = t.cx, i = t.getStyles, o = t.isDisabled, s = t.isFocused, c = t.isSelected, l = t.innerRef, u = t.innerProps;
  return we("div", Ce({
    css: i("option", t),
    className: a({
      option: !0,
      "option--is-disabled": o,
      "option--is-focused": s,
      "option--is-selected": c
    }, r),
    ref: l,
    "aria-disabled": o
  }, u), n);
}, b1e = function(t) {
  var n = t.theme, r = n.spacing, a = n.colors;
  return {
    label: "placeholder",
    color: a.neutral50,
    gridArea: "1 / 1 / 2 / 3",
    marginLeft: r.baseUnit / 2,
    marginRight: r.baseUnit / 2
  };
}, x1e = function(t) {
  var n = t.children, r = t.className, a = t.cx, i = t.getStyles, o = t.innerProps;
  return we("div", Ce({
    css: i("placeholder", t),
    className: a({
      placeholder: !0
    }, r)
  }, o), n);
}, M1e = function(t) {
  var n = t.isDisabled, r = t.theme, a = r.spacing, i = r.colors;
  return {
    label: "singleValue",
    color: n ? i.neutral40 : i.neutral80,
    gridArea: "1 / 1 / 2 / 3",
    marginLeft: a.baseUnit / 2,
    marginRight: a.baseUnit / 2,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  };
}, w1e = function(t) {
  var n = t.children, r = t.className, a = t.cx, i = t.getStyles, o = t.isDisabled, s = t.innerProps;
  return we("div", Ce({
    css: i("singleValue", t),
    className: a({
      "single-value": !0,
      "single-value--is-disabled": o
    }, r)
  }, s), n);
}, wa = {
  ClearIndicator: Xle,
  Control: e1e,
  DropdownIndicator: Gle,
  DownChevron: Eb,
  CrossIcon: m2,
  Group: r1e,
  GroupHeading: i1e,
  IndicatorsContainer: jle,
  IndicatorSeparator: Yle,
  Input: d1e,
  LoadingIndicator: Db,
  Menu: Ile,
  MenuList: Tle,
  MenuPortal: Rle,
  LoadingMessage: Ab,
  NoOptionsMessage: Sb,
  MultiValue: g1e,
  MultiValueContainer: f1e,
  MultiValueLabel: y1e,
  MultiValueRemove: m1e,
  Option: k1e,
  Placeholder: x1e,
  SelectContainer: zle,
  SingleValue: w1e,
  ValueContainer: Hle
}, C1e = function(t) {
  return Ze(Ze({}, wa), t.components);
}, S1e = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function A1e(e) {
  var t = e.defaultInputValue, n = t === void 0 ? "" : t, r = e.defaultMenuIsOpen, a = r === void 0 ? !1 : r, i = e.defaultValue, o = i === void 0 ? null : i, s = e.inputValue, c = e.menuIsOpen, l = e.onChange, u = e.onInputChange, h = e.onMenuClose, p = e.onMenuOpen, f = e.value, y = Li(e, S1e), m = fe(s !== void 0 ? s : n), v = ho(m, 2), k = v[0], b = v[1], x = fe(c !== void 0 ? c : a), g = ho(x, 2), w = g[0], M = g[1], S = fe(f !== void 0 ? f : o), D = ho(S, 2), A = D[0], $ = D[1], F = ue(function(L, W) {
    typeof l == "function" && l(L, W), $(L);
  }, [l]), Z = ue(function(L, W) {
    var E;
    typeof u == "function" && (E = u(L, W)), b(E !== void 0 ? E : L);
  }, [u]), B = ue(function() {
    typeof p == "function" && p(), M(!0);
  }, [p]), O = ue(function() {
    typeof h == "function" && h(), M(!1);
  }, [h]), I = s !== void 0 ? s : k, N = c !== void 0 ? c : w, R = f !== void 0 ? f : A;
  return Ze(Ze({}, y), {}, {
    inputValue: I,
    menuIsOpen: N,
    onChange: F,
    onInputChange: Z,
    onMenuClose: O,
    onMenuOpen: B,
    value: R
  });
}
function O1e(e) {
  if (Array.isArray(e))
    return fh(e);
}
function E1e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function I1e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Pb(e) {
  return O1e(e) || E1e(e) || gb(e) || I1e();
}
var vm = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function D1e(e, t) {
  return !!(e === t || vm(e) && vm(t));
}
function T1e(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!D1e(e[n], t[n]))
      return !1;
  return !0;
}
function vc(e, t) {
  t === void 0 && (t = T1e);
  var n, r = [], a, i = !1;
  function o() {
    for (var s = [], c = 0; c < arguments.length; c++)
      s[c] = arguments[c];
    return i && n === this && t(s, r) || (a = e.apply(this, s), i = !0, n = this, r = s), a;
  }
  return o;
}
function N1e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var P1e = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: N1e
}, km = function(t) {
  return we("span", Ce({
    css: P1e
  }, t));
}, L1e = {
  guidance: function(t) {
    var n = t.isSearchable, r = t.isMulti, a = t.isDisabled, i = t.tabSelectsValue, o = t.context;
    switch (o) {
      case "menu":
        return "Use Up and Down to choose options".concat(a ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(i ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return "".concat(t["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(r ? " press left to focus selected values" : "");
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(t) {
    var n = t.action, r = t.label, a = r === void 0 ? "" : r, i = t.labels, o = t.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(a, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(i.length > 1 ? "s" : "", " ").concat(i.join(","), ", selected.");
      case "select-option":
        return o ? "option ".concat(a, " is disabled. Select another option.") : "option ".concat(a, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(t) {
    var n = t.context, r = t.focused, a = t.options, i = t.label, o = i === void 0 ? "" : i, s = t.selectValue, c = t.isDisabled, l = t.isSelected, u = function(y, m) {
      return y && y.length ? "".concat(y.indexOf(m) + 1, " of ").concat(y.length) : "";
    };
    if (n === "value" && s)
      return "value ".concat(o, " focused, ").concat(u(s, r), ".");
    if (n === "menu") {
      var h = c ? " disabled" : "", p = "".concat(l ? "selected" : "focused").concat(h);
      return "option ".concat(o, " ").concat(p, ", ").concat(u(a, r), ".");
    }
    return "";
  },
  onFilter: function(t) {
    var n = t.inputValue, r = t.resultsMessage;
    return "".concat(r).concat(n ? " for search term " + n : "", ".");
  }
}, R1e = function(t) {
  var n = t.ariaSelection, r = t.focusedOption, a = t.focusedValue, i = t.focusableOptions, o = t.isFocused, s = t.selectValue, c = t.selectProps, l = t.id, u = c.ariaLiveMessages, h = c.getOptionLabel, p = c.inputValue, f = c.isMulti, y = c.isOptionDisabled, m = c.isSearchable, v = c.menuIsOpen, k = c.options, b = c.screenReaderStatus, x = c.tabSelectsValue, g = c["aria-label"], w = c["aria-live"], M = wt(function() {
    return Ze(Ze({}, L1e), u || {});
  }, [u]), S = wt(function() {
    var O = "";
    if (n && M.onChange) {
      var I = n.option, N = n.options, R = n.removedValue, L = n.removedValues, W = n.value, E = function(Q) {
        return Array.isArray(Q) ? null : Q;
      }, q = R || I || E(W), z = q ? h(q) : "", H = N || L || void 0, _ = H ? H.map(h) : [], X = Ze({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: q && y(q, s),
        label: z,
        labels: _
      }, n);
      O = M.onChange(X);
    }
    return O;
  }, [n, M, y, s, h]), D = wt(function() {
    var O = "", I = r || a, N = !!(r && s && s.includes(r));
    if (I && M.onFocus) {
      var R = {
        focused: I,
        label: h(I),
        isDisabled: y(I, s),
        isSelected: N,
        options: k,
        context: I === r ? "menu" : "value",
        selectValue: s
      };
      O = M.onFocus(R);
    }
    return O;
  }, [r, a, h, y, M, k, s]), A = wt(function() {
    var O = "";
    if (v && k.length && M.onFilter) {
      var I = b({
        count: i.length
      });
      O = M.onFilter({
        inputValue: p,
        resultsMessage: I
      });
    }
    return O;
  }, [i, p, v, M, k, b]), $ = wt(function() {
    var O = "";
    if (M.guidance) {
      var I = a ? "value" : v ? "menu" : "input";
      O = M.guidance({
        "aria-label": g,
        context: I,
        isDisabled: r && y(r, s),
        isMulti: f,
        isSearchable: m,
        tabSelectsValue: x
      });
    }
    return O;
  }, [g, r, a, f, y, m, v, M, s, x]), F = "".concat(D, " ").concat(A, " ").concat($), Z = we(ua, null, we("span", {
    id: "aria-selection"
  }, S), we("span", {
    id: "aria-context"
  }, F)), B = (n == null ? void 0 : n.action) === "initial-input-focus";
  return we(ua, null, we(km, {
    id: l
  }, B && Z), we(km, {
    "aria-live": w,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, o && !B && Z));
}, gh = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], V1e = new RegExp("[" + gh.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), Lb = {};
for (var qd = 0; qd < gh.length; qd++)
  for (var _d = gh[qd], Gd = 0; Gd < _d.letters.length; Gd++)
    Lb[_d.letters[Gd]] = _d.base;
var Rb = function(t) {
  return t.replace(V1e, function(n) {
    return Lb[n];
  });
}, z1e = vc(Rb), bm = function(t) {
  return t.replace(/^\s+|\s+$/g, "");
}, B1e = function(t) {
  return "".concat(t.label, " ").concat(t.value);
}, Vb = function(t) {
  return function(n, r) {
    if (n.data.__isNew__)
      return !0;
    var a = Ze({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: B1e,
      trim: !0,
      matchFrom: "any"
    }, t), i = a.ignoreCase, o = a.ignoreAccents, s = a.stringify, c = a.trim, l = a.matchFrom, u = c ? bm(r) : r, h = c ? bm(s(n)) : s(n);
    return i && (u = u.toLowerCase(), h = h.toLowerCase()), o && (u = z1e(u), h = Rb(h)), l === "start" ? h.substr(0, u.length) === u : h.indexOf(u) > -1;
  };
}, H1e = ["innerRef"];
function $1e(e) {
  var t = e.innerRef, n = Li(e, H1e), r = Sle(n, "onExited", "in", "enter", "exit", "appear");
  return we("input", Ce({
    ref: t
  }, r, {
    css: /* @__PURE__ */ u2({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var j1e = function(t) {
  t.preventDefault(), t.stopPropagation();
};
function F1e(e) {
  var t = e.isEnabled, n = e.onBottomArrive, r = e.onBottomLeave, a = e.onTopArrive, i = e.onTopLeave, o = he(!1), s = he(!1), c = he(0), l = he(null), u = ue(function(v, k) {
    if (l.current !== null) {
      var b = l.current, x = b.scrollTop, g = b.scrollHeight, w = b.clientHeight, M = l.current, S = k > 0, D = g - w - x, A = !1;
      D > k && o.current && (r && r(v), o.current = !1), S && s.current && (i && i(v), s.current = !1), S && k > D ? (n && !o.current && n(v), M.scrollTop = g, A = !0, o.current = !0) : !S && -k > x && (a && !s.current && a(v), M.scrollTop = 0, A = !0, s.current = !0), A && j1e(v);
    }
  }, [n, r, a, i]), h = ue(function(v) {
    u(v, v.deltaY);
  }, [u]), p = ue(function(v) {
    c.current = v.changedTouches[0].clientY;
  }, []), f = ue(function(v) {
    var k = c.current - v.changedTouches[0].clientY;
    u(v, k);
  }, [u]), y = ue(function(v) {
    if (v) {
      var k = Mle ? {
        passive: !1
      } : !1;
      v.addEventListener("wheel", h, k), v.addEventListener("touchstart", p, k), v.addEventListener("touchmove", f, k);
    }
  }, [f, p, h]), m = ue(function(v) {
    v && (v.removeEventListener("wheel", h, !1), v.removeEventListener("touchstart", p, !1), v.removeEventListener("touchmove", f, !1));
  }, [f, p, h]);
  return be(function() {
    if (t) {
      var v = l.current;
      return y(v), function() {
        m(v);
      };
    }
  }, [t, y, m]), function(v) {
    l.current = v;
  };
}
var xm = ["boxSizing", "height", "overflow", "paddingRight", "position"], Mm = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function wm(e) {
  e.preventDefault();
}
function Cm(e) {
  e.stopPropagation();
}
function Sm() {
  var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function Am() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var Om = !!(typeof window < "u" && window.document && window.document.createElement), Fi = 0, Va = {
  capture: !1,
  passive: !1
};
function W1e(e) {
  var t = e.isEnabled, n = e.accountForScrollbars, r = n === void 0 ? !0 : n, a = he({}), i = he(null), o = ue(function(c) {
    if (Om) {
      var l = document.body, u = l && l.style;
      if (r && xm.forEach(function(y) {
        var m = u && u[y];
        a.current[y] = m;
      }), r && Fi < 1) {
        var h = parseInt(a.current.paddingRight, 10) || 0, p = document.body ? document.body.clientWidth : 0, f = window.innerWidth - p + h || 0;
        Object.keys(Mm).forEach(function(y) {
          var m = Mm[y];
          u && (u[y] = m);
        }), u && (u.paddingRight = "".concat(f, "px"));
      }
      l && Am() && (l.addEventListener("touchmove", wm, Va), c && (c.addEventListener("touchstart", Sm, Va), c.addEventListener("touchmove", Cm, Va))), Fi += 1;
    }
  }, [r]), s = ue(function(c) {
    if (Om) {
      var l = document.body, u = l && l.style;
      Fi = Math.max(Fi - 1, 0), r && Fi < 1 && xm.forEach(function(h) {
        var p = a.current[h];
        u && (u[h] = p);
      }), l && Am() && (l.removeEventListener("touchmove", wm, Va), c && (c.removeEventListener("touchstart", Sm, Va), c.removeEventListener("touchmove", Cm, Va)));
    }
  }, [r]);
  return be(function() {
    if (t) {
      var c = i.current;
      return o(c), function() {
        s(c);
      };
    }
  }, [t, o, s]), function(c) {
    i.current = c;
  };
}
function q1e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _1e = function() {
  return document.activeElement && document.activeElement.blur();
}, G1e = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNjcm9sbE1hbmFnZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQStDVSIsImZpbGUiOiJTY3JvbGxNYW5hZ2VyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgRnJhZ21lbnQsIFJlYWN0RWxlbWVudCwgUmVmQ2FsbGJhY2sgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgdXNlU2Nyb2xsQ2FwdHVyZSBmcm9tICcuL3VzZVNjcm9sbENhcHR1cmUnO1xuaW1wb3J0IHVzZVNjcm9sbExvY2sgZnJvbSAnLi91c2VTY3JvbGxMb2NrJztcblxuaW50ZXJmYWNlIFByb3BzIHtcbiAgcmVhZG9ubHkgY2hpbGRyZW46IChyZWY6IFJlZkNhbGxiYWNrPEhUTUxFbGVtZW50PikgPT4gUmVhY3RFbGVtZW50O1xuICByZWFkb25seSBsb2NrRW5hYmxlZDogYm9vbGVhbjtcbiAgcmVhZG9ubHkgY2FwdHVyZUVuYWJsZWQ6IGJvb2xlYW47XG4gIHJlYWRvbmx5IG9uQm90dG9tQXJyaXZlPzogKGV2ZW50OiBXaGVlbEV2ZW50IHwgVG91Y2hFdmVudCkgPT4gdm9pZDtcbiAgcmVhZG9ubHkgb25Cb3R0b21MZWF2ZT86IChldmVudDogV2hlZWxFdmVudCB8IFRvdWNoRXZlbnQpID0+IHZvaWQ7XG4gIHJlYWRvbmx5IG9uVG9wQXJyaXZlPzogKGV2ZW50OiBXaGVlbEV2ZW50IHwgVG91Y2hFdmVudCkgPT4gdm9pZDtcbiAgcmVhZG9ubHkgb25Ub3BMZWF2ZT86IChldmVudDogV2hlZWxFdmVudCB8IFRvdWNoRXZlbnQpID0+IHZvaWQ7XG59XG5cbmNvbnN0IGJsdXJTZWxlY3RJbnB1dCA9ICgpID0+XG4gIGRvY3VtZW50LmFjdGl2ZUVsZW1lbnQgJiYgKGRvY3VtZW50LmFjdGl2ZUVsZW1lbnQgYXMgSFRNTEVsZW1lbnQpLmJsdXIoKTtcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gU2Nyb2xsTWFuYWdlcih7XG4gIGNoaWxkcmVuLFxuICBsb2NrRW5hYmxlZCxcbiAgY2FwdHVyZUVuYWJsZWQgPSB0cnVlLFxuICBvbkJvdHRvbUFycml2ZSxcbiAgb25Cb3R0b21MZWF2ZSxcbiAgb25Ub3BBcnJpdmUsXG4gIG9uVG9wTGVhdmUsXG59OiBQcm9wcykge1xuICBjb25zdCBzZXRTY3JvbGxDYXB0dXJlVGFyZ2V0ID0gdXNlU2Nyb2xsQ2FwdHVyZSh7XG4gICAgaXNFbmFibGVkOiBjYXB0dXJlRW5hYmxlZCxcbiAgICBvbkJvdHRvbUFycml2ZSxcbiAgICBvbkJvdHRvbUxlYXZlLFxuICAgIG9uVG9wQXJyaXZlLFxuICAgIG9uVG9wTGVhdmUsXG4gIH0pO1xuICBjb25zdCBzZXRTY3JvbGxMb2NrVGFyZ2V0ID0gdXNlU2Nyb2xsTG9jayh7IGlzRW5hYmxlZDogbG9ja0VuYWJsZWQgfSk7XG5cbiAgY29uc3QgdGFyZ2V0UmVmOiBSZWZDYWxsYmFjazxIVE1MRWxlbWVudD4gPSAoZWxlbWVudCkgPT4ge1xuICAgIHNldFNjcm9sbENhcHR1cmVUYXJnZXQoZWxlbWVudCk7XG4gICAgc2V0U2Nyb2xsTG9ja1RhcmdldChlbGVtZW50KTtcbiAgfTtcblxuICByZXR1cm4gKFxuICAgIDxGcmFnbWVudD5cbiAgICAgIHtsb2NrRW5hYmxlZCAmJiAoXG4gICAgICAgIDxkaXZcbiAgICAgICAgICBvbkNsaWNrPXtibHVyU2VsZWN0SW5wdXR9XG4gICAgICAgICAgY3NzPXt7IHBvc2l0aW9uOiAnZml4ZWQnLCBsZWZ0OiAwLCBib3R0b206IDAsIHJpZ2h0OiAwLCB0b3A6IDAgfX1cbiAgICAgICAgLz5cbiAgICAgICl9XG4gICAgICB7Y2hpbGRyZW4odGFyZ2V0UmVmKX1cbiAgICA8L0ZyYWdtZW50PlxuICApO1xufVxuIl19 */",
  toString: q1e
};
function Z1e(e) {
  var t = e.children, n = e.lockEnabled, r = e.captureEnabled, a = r === void 0 ? !0 : r, i = e.onBottomArrive, o = e.onBottomLeave, s = e.onTopArrive, c = e.onTopLeave, l = F1e({
    isEnabled: a,
    onBottomArrive: i,
    onBottomLeave: o,
    onTopArrive: s,
    onTopLeave: c
  }), u = W1e({
    isEnabled: n
  }), h = function(f) {
    l(f), u(f);
  };
  return we(ua, null, n && we("div", {
    onClick: _1e,
    css: G1e
  }), t(h));
}
var X1e = function(t) {
  return t.label;
}, U1e = function(t) {
  return t.label;
}, Y1e = function(t) {
  return t.value;
}, J1e = function(t) {
  return !!t.isDisabled;
}, K1e = {
  clearIndicator: Zle,
  container: Vle,
  control: Qle,
  dropdownIndicator: _le,
  group: n1e,
  groupHeading: a1e,
  indicatorsContainer: $le,
  indicatorSeparator: Ule,
  input: s1e,
  loadingIndicator: Kle,
  loadingMessage: Ple,
  menu: Ele,
  menuList: Dle,
  menuPortal: Lle,
  multiValue: u1e,
  multiValueLabel: h1e,
  multiValueRemove: p1e,
  noOptionsMessage: Nle,
  option: v1e,
  placeholder: b1e,
  singleValue: M1e,
  valueContainer: Ble
}, Q1e = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, ede = 4, zb = 4, tde = 38, nde = zb * 2, rde = {
  baseUnit: zb,
  controlHeight: tde,
  menuGutter: nde
}, Zd = {
  borderRadius: ede,
  colors: Q1e,
  spacing: rde
}, ade = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: mm(),
  captureMenuScroll: !mm(),
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: Vb(),
  formatGroupLabel: X1e,
  getOptionLabel: U1e,
  getOptionValue: Y1e,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: J1e,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !ble(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(t) {
    var n = t.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0
};
function Em(e, t, n, r) {
  var a = jb(e, t, n), i = Fb(e, t, n), o = $b(e, t), s = Il(e, t);
  return {
    type: "option",
    data: t,
    isDisabled: a,
    isSelected: i,
    label: o,
    value: s,
    index: r
  };
}
function Bb(e, t) {
  return e.options.map(function(n, r) {
    if ("options" in n) {
      var a = n.options.map(function(o, s) {
        return Em(e, o, t, s);
      }).filter(function(o) {
        return Im(e, o);
      });
      return a.length > 0 ? {
        type: "group",
        data: n,
        options: a,
        index: r
      } : void 0;
    }
    var i = Em(e, n, t, r);
    return Im(e, i) ? i : void 0;
  }).filter(wle);
}
function Hb(e) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, Pb(n.options.map(function(r) {
      return r.data;
    }))) : t.push(n.data), t;
  }, []);
}
function ide(e, t) {
  return Hb(Bb(e, t));
}
function Im(e, t) {
  var n = e.inputValue, r = n === void 0 ? "" : n, a = t.data, i = t.isSelected, o = t.label, s = t.value;
  return (!qb(e) || !i) && Wb(e, {
    label: o,
    value: s,
    data: a
  }, r);
}
function ode(e, t) {
  var n = e.focusedValue, r = e.selectValue, a = r.indexOf(n);
  if (a > -1) {
    var i = t.indexOf(n);
    if (i > -1)
      return n;
    if (a < t.length)
      return t[a];
  }
  return null;
}
function sde(e, t) {
  var n = e.focusedOption;
  return n && t.indexOf(n) > -1 ? n : t[0];
}
var $b = function(t, n) {
  return t.getOptionLabel(n);
}, Il = function(t, n) {
  return t.getOptionValue(n);
};
function jb(e, t, n) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(t, n) : !1;
}
function Fb(e, t, n) {
  if (n.indexOf(t) > -1)
    return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, n);
  var r = Il(e, t);
  return n.some(function(a) {
    return Il(e, a) === r;
  });
}
function Wb(e, t, n) {
  return e.filterOption ? e.filterOption(t, n) : !0;
}
var qb = function(t) {
  var n = t.hideSelectedOptions, r = t.isMulti;
  return n === void 0 ? r : n;
}, cde = 1, _b = /* @__PURE__ */ function(e) {
  f2(n, e);
  var t = y2(n);
  function n(r) {
    var a;
    return h2(this, n), a = t.call(this, r), a.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0
    }, a.blockOptionHover = !1, a.isComposing = !1, a.commonProps = void 0, a.initialTouchX = 0, a.initialTouchY = 0, a.instancePrefix = "", a.openAfterFocus = !1, a.scrollToFocusedOptionOnUpdate = !1, a.userIsDragging = void 0, a.controlRef = null, a.getControlRef = function(i) {
      a.controlRef = i;
    }, a.focusedOptionRef = null, a.getFocusedOptionRef = function(i) {
      a.focusedOptionRef = i;
    }, a.menuListRef = null, a.getMenuListRef = function(i) {
      a.menuListRef = i;
    }, a.inputRef = null, a.getInputRef = function(i) {
      a.inputRef = i;
    }, a.focus = a.focusInput, a.blur = a.blurInput, a.onChange = function(i, o) {
      var s = a.props, c = s.onChange, l = s.name;
      o.name = l, a.ariaOnChange(i, o), c(i, o);
    }, a.setValue = function(i, o, s) {
      var c = a.props, l = c.closeMenuOnSelect, u = c.isMulti, h = c.inputValue;
      a.onInputChange("", {
        action: "set-value",
        prevInputValue: h
      }), l && (a.setState({
        inputIsHiddenAfterUpdate: !u
      }), a.onMenuClose()), a.setState({
        clearFocusValueOnUpdate: !0
      }), a.onChange(i, {
        action: o,
        option: s
      });
    }, a.selectOption = function(i) {
      var o = a.props, s = o.blurInputOnSelect, c = o.isMulti, l = o.name, u = a.state.selectValue, h = c && a.isOptionSelected(i, u), p = a.isOptionDisabled(i, u);
      if (h) {
        var f = a.getOptionValue(i);
        a.setValue(u.filter(function(y) {
          return a.getOptionValue(y) !== f;
        }), "deselect-option", i);
      } else if (!p)
        c ? a.setValue([].concat(Pb(u), [i]), "select-option", i) : a.setValue(i, "select-option");
      else {
        a.ariaOnChange(i, {
          action: "select-option",
          option: i,
          name: l
        });
        return;
      }
      s && a.blurInput();
    }, a.removeValue = function(i) {
      var o = a.props.isMulti, s = a.state.selectValue, c = a.getOptionValue(i), l = s.filter(function(h) {
        return a.getOptionValue(h) !== c;
      }), u = Js(o, l, l[0] || null);
      a.onChange(u, {
        action: "remove-value",
        removedValue: i
      }), a.focusInput();
    }, a.clearValue = function() {
      var i = a.state.selectValue;
      a.onChange(Js(a.props.isMulti, [], null), {
        action: "clear",
        removedValues: i
      });
    }, a.popValue = function() {
      var i = a.props.isMulti, o = a.state.selectValue, s = o[o.length - 1], c = o.slice(0, o.length - 1), l = Js(i, c, c[0] || null);
      a.onChange(l, {
        action: "pop-value",
        removedValue: s
      });
    }, a.getValue = function() {
      return a.state.selectValue;
    }, a.cx = function() {
      for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
        o[s] = arguments[s];
      return fle.apply(void 0, [a.props.classNamePrefix].concat(o));
    }, a.getOptionLabel = function(i) {
      return $b(a.props, i);
    }, a.getOptionValue = function(i) {
      return Il(a.props, i);
    }, a.getStyles = function(i, o) {
      var s = K1e[i](o);
      s.boxSizing = "border-box";
      var c = a.props.styles[i];
      return c ? c(s, o) : s;
    }, a.getElementId = function(i) {
      return "".concat(a.instancePrefix, "-").concat(i);
    }, a.getComponents = function() {
      return C1e(a.props);
    }, a.buildCategorizedOptions = function() {
      return Bb(a.props, a.state.selectValue);
    }, a.getCategorizedOptions = function() {
      return a.props.menuIsOpen ? a.buildCategorizedOptions() : [];
    }, a.buildFocusableOptions = function() {
      return Hb(a.buildCategorizedOptions());
    }, a.getFocusableOptions = function() {
      return a.props.menuIsOpen ? a.buildFocusableOptions() : [];
    }, a.ariaOnChange = function(i, o) {
      a.setState({
        ariaSelection: Ze({
          value: i
        }, o)
      });
    }, a.onMenuMouseDown = function(i) {
      i.button === 0 && (i.stopPropagation(), i.preventDefault(), a.focusInput());
    }, a.onMenuMouseMove = function(i) {
      a.blockOptionHover = !1;
    }, a.onControlMouseDown = function(i) {
      if (!i.defaultPrevented) {
        var o = a.props.openMenuOnClick;
        a.state.isFocused ? a.props.menuIsOpen ? i.target.tagName !== "INPUT" && i.target.tagName !== "TEXTAREA" && a.onMenuClose() : o && a.openMenu("first") : (o && (a.openAfterFocus = !0), a.focusInput()), i.target.tagName !== "INPUT" && i.target.tagName !== "TEXTAREA" && i.preventDefault();
      }
    }, a.onDropdownIndicatorMouseDown = function(i) {
      if (!(i && i.type === "mousedown" && i.button !== 0) && !a.props.isDisabled) {
        var o = a.props, s = o.isMulti, c = o.menuIsOpen;
        a.focusInput(), c ? (a.setState({
          inputIsHiddenAfterUpdate: !s
        }), a.onMenuClose()) : a.openMenu("first"), i.preventDefault();
      }
    }, a.onClearIndicatorMouseDown = function(i) {
      i && i.type === "mousedown" && i.button !== 0 || (a.clearValue(), i.preventDefault(), a.openAfterFocus = !1, i.type === "touchend" ? a.focusInput() : setTimeout(function() {
        return a.focusInput();
      }));
    }, a.onScroll = function(i) {
      typeof a.props.closeMenuOnScroll == "boolean" ? i.target instanceof HTMLElement && O1(i.target) && a.props.onMenuClose() : typeof a.props.closeMenuOnScroll == "function" && a.props.closeMenuOnScroll(i) && a.props.onMenuClose();
    }, a.onCompositionStart = function() {
      a.isComposing = !0;
    }, a.onCompositionEnd = function() {
      a.isComposing = !1;
    }, a.onTouchStart = function(i) {
      var o = i.touches, s = o && o.item(0);
      s && (a.initialTouchX = s.clientX, a.initialTouchY = s.clientY, a.userIsDragging = !1);
    }, a.onTouchMove = function(i) {
      var o = i.touches, s = o && o.item(0);
      if (s) {
        var c = Math.abs(s.clientX - a.initialTouchX), l = Math.abs(s.clientY - a.initialTouchY), u = 5;
        a.userIsDragging = c > u || l > u;
      }
    }, a.onTouchEnd = function(i) {
      a.userIsDragging || (a.controlRef && !a.controlRef.contains(i.target) && a.menuListRef && !a.menuListRef.contains(i.target) && a.blurInput(), a.initialTouchX = 0, a.initialTouchY = 0);
    }, a.onControlTouchEnd = function(i) {
      a.userIsDragging || a.onControlMouseDown(i);
    }, a.onClearIndicatorTouchEnd = function(i) {
      a.userIsDragging || a.onClearIndicatorMouseDown(i);
    }, a.onDropdownIndicatorTouchEnd = function(i) {
      a.userIsDragging || a.onDropdownIndicatorMouseDown(i);
    }, a.handleInputChange = function(i) {
      var o = a.props.inputValue, s = i.currentTarget.value;
      a.setState({
        inputIsHiddenAfterUpdate: !1
      }), a.onInputChange(s, {
        action: "input-change",
        prevInputValue: o
      }), a.props.menuIsOpen || a.onMenuOpen();
    }, a.onInputFocus = function(i) {
      a.props.onFocus && a.props.onFocus(i), a.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (a.openAfterFocus || a.props.openMenuOnFocus) && a.openMenu("first"), a.openAfterFocus = !1;
    }, a.onInputBlur = function(i) {
      var o = a.props.inputValue;
      if (a.menuListRef && a.menuListRef.contains(document.activeElement)) {
        a.inputRef.focus();
        return;
      }
      a.props.onBlur && a.props.onBlur(i), a.onInputChange("", {
        action: "input-blur",
        prevInputValue: o
      }), a.onMenuClose(), a.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, a.onOptionHover = function(i) {
      a.blockOptionHover || a.state.focusedOption === i || a.setState({
        focusedOption: i
      });
    }, a.shouldHideSelectedOptions = function() {
      return qb(a.props);
    }, a.onKeyDown = function(i) {
      var o = a.props, s = o.isMulti, c = o.backspaceRemovesValue, l = o.escapeClearsValue, u = o.inputValue, h = o.isClearable, p = o.isDisabled, f = o.menuIsOpen, y = o.onKeyDown, m = o.tabSelectsValue, v = o.openMenuOnFocus, k = a.state, b = k.focusedOption, x = k.focusedValue, g = k.selectValue;
      if (!p && !(typeof y == "function" && (y(i), i.defaultPrevented))) {
        switch (a.blockOptionHover = !0, i.key) {
          case "ArrowLeft":
            if (!s || u)
              return;
            a.focusValue("previous");
            break;
          case "ArrowRight":
            if (!s || u)
              return;
            a.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (u)
              return;
            if (x)
              a.removeValue(x);
            else {
              if (!c)
                return;
              s ? a.popValue() : h && a.clearValue();
            }
            break;
          case "Tab":
            if (a.isComposing || i.shiftKey || !f || !m || !b || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            v && a.isOptionSelected(b, g))
              return;
            a.selectOption(b);
            break;
          case "Enter":
            if (i.keyCode === 229)
              break;
            if (f) {
              if (!b || a.isComposing)
                return;
              a.selectOption(b);
              break;
            }
            return;
          case "Escape":
            f ? (a.setState({
              inputIsHiddenAfterUpdate: !1
            }), a.onInputChange("", {
              action: "menu-close",
              prevInputValue: u
            }), a.onMenuClose()) : h && l && a.clearValue();
            break;
          case " ":
            if (u)
              return;
            if (!f) {
              a.openMenu("first");
              break;
            }
            if (!b)
              return;
            a.selectOption(b);
            break;
          case "ArrowUp":
            f ? a.focusOption("up") : a.openMenu("last");
            break;
          case "ArrowDown":
            f ? a.focusOption("down") : a.openMenu("first");
            break;
          case "PageUp":
            if (!f)
              return;
            a.focusOption("pageup");
            break;
          case "PageDown":
            if (!f)
              return;
            a.focusOption("pagedown");
            break;
          case "Home":
            if (!f)
              return;
            a.focusOption("first");
            break;
          case "End":
            if (!f)
              return;
            a.focusOption("last");
            break;
          default:
            return;
        }
        i.preventDefault();
      }
    }, a.instancePrefix = "react-select-" + (a.props.instanceId || ++cde), a.state.selectValue = ym(r.value), a;
  }
  return p2(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput();
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      var i = this.props, o = i.isDisabled, s = i.menuIsOpen, c = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (c && !o && a.isDisabled || // ensure focus is on the Input when the menu opens
      c && s && !a.menuIsOpen) && this.focusInput(), c && o && !a.isDisabled && this.setState({
        isFocused: !1
      }, this.onMenuClose), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (vle(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(a, i) {
      this.props.onInputChange(a, i);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(a) {
      var i = this, o = this.state, s = o.selectValue, c = o.isFocused, l = this.buildFocusableOptions(), u = a === "first" ? 0 : l.length - 1;
      if (!this.props.isMulti) {
        var h = l.indexOf(s[0]);
        h > -1 && (u = h);
      }
      this.scrollToFocusedOptionOnUpdate = !(c && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: l[u]
      }, function() {
        return i.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(a) {
      var i = this.state, o = i.selectValue, s = i.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var c = o.indexOf(s);
        s || (c = -1);
        var l = o.length - 1, u = -1;
        if (o.length) {
          switch (a) {
            case "previous":
              c === 0 ? u = 0 : c === -1 ? u = l : u = c - 1;
              break;
            case "next":
              c > -1 && c < l && (u = c + 1);
              break;
          }
          this.setState({
            inputIsHidden: u !== -1,
            focusedValue: o[u]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", i = this.props.pageSize, o = this.state.focusedOption, s = this.getFocusableOptions();
      if (s.length) {
        var c = 0, l = s.indexOf(o);
        o || (l = -1), a === "up" ? c = l > 0 ? l - 1 : s.length - 1 : a === "down" ? c = (l + 1) % s.length : a === "pageup" ? (c = l - i, c < 0 && (c = 0)) : a === "pagedown" ? (c = l + i, c > s.length - 1 && (c = s.length - 1)) : a === "last" && (c = s.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: s[c],
          focusedValue: null
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(Zd) : Ze(Ze({}, Zd), this.props.theme) : Zd;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var a = this.clearValue, i = this.cx, o = this.getStyles, s = this.getValue, c = this.selectOption, l = this.setValue, u = this.props, h = u.isMulti, p = u.isRtl, f = u.options, y = this.hasValue();
      return {
        clearValue: a,
        cx: i,
        getStyles: o,
        getValue: s,
        hasValue: y,
        isMulti: h,
        isRtl: p,
        options: f,
        selectOption: c,
        selectProps: u,
        setValue: l,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var a = this.state.selectValue;
      return a.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var a = this.props, i = a.isClearable, o = a.isMulti;
      return i === void 0 ? o : i;
    }
  }, {
    key: "isOptionDisabled",
    value: function(a, i) {
      return jb(this.props, a, i);
    }
  }, {
    key: "isOptionSelected",
    value: function(a, i) {
      return Fb(this.props, a, i);
    }
  }, {
    key: "filterOption",
    value: function(a, i) {
      return Wb(this.props, a, i);
    }
  }, {
    key: "formatOptionLabel",
    value: function(a, i) {
      if (typeof this.props.formatOptionLabel == "function") {
        var o = this.props.inputValue, s = this.state.selectValue;
        return this.props.formatOptionLabel(a, {
          context: i,
          inputValue: o,
          selectValue: s
        });
      } else
        return this.getOptionLabel(a);
    }
  }, {
    key: "formatGroupLabel",
    value: function(a) {
      return this.props.formatGroupLabel(a);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var a = this.props, i = a.isDisabled, o = a.isSearchable, s = a.inputId, c = a.inputValue, l = a.tabIndex, u = a.form, h = a.menuIsOpen, p = this.getComponents(), f = p.Input, y = this.state, m = y.inputIsHidden, v = y.ariaSelection, k = this.commonProps, b = s || this.getElementId("input"), x = Ze(Ze(Ze({
          "aria-autocomplete": "list",
          "aria-expanded": h,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          role: "combobox"
        }, h && {
          "aria-controls": this.getElementId("listbox"),
          "aria-owns": this.getElementId("listbox")
        }), !o && {
          "aria-readonly": !0
        }), this.hasValue() ? (v == null ? void 0 : v.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return o ? /* @__PURE__ */ ne.createElement(f, Ce({}, k, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: b,
          innerRef: this.getInputRef,
          isDisabled: i,
          isHidden: m,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: l,
          form: u,
          type: "text",
          value: c
        }, x)) : /* @__PURE__ */ ne.createElement($1e, Ce({
          id: b,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: Ol,
          onFocus: this.onInputFocus,
          disabled: i,
          tabIndex: l,
          inputMode: "none",
          form: u,
          value: ""
        }, x));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var a = this, i = this.getComponents(), o = i.MultiValue, s = i.MultiValueContainer, c = i.MultiValueLabel, l = i.MultiValueRemove, u = i.SingleValue, h = i.Placeholder, p = this.commonProps, f = this.props, y = f.controlShouldRenderValue, m = f.isDisabled, v = f.isMulti, k = f.inputValue, b = f.placeholder, x = this.state, g = x.selectValue, w = x.focusedValue, M = x.isFocused;
      if (!this.hasValue() || !y)
        return k ? null : /* @__PURE__ */ ne.createElement(h, Ce({}, p, {
          key: "placeholder",
          isDisabled: m,
          isFocused: M,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), b);
      if (v)
        return g.map(function(D, A) {
          var $ = D === w, F = "".concat(a.getOptionLabel(D), "-").concat(a.getOptionValue(D));
          return /* @__PURE__ */ ne.createElement(o, Ce({}, p, {
            components: {
              Container: s,
              Label: c,
              Remove: l
            },
            isFocused: $,
            isDisabled: m,
            key: F,
            index: A,
            removeProps: {
              onClick: function() {
                return a.removeValue(D);
              },
              onTouchEnd: function() {
                return a.removeValue(D);
              },
              onMouseDown: function(B) {
                B.preventDefault();
              }
            },
            data: D
          }), a.formatOptionLabel(D, "value"));
        });
      if (k)
        return null;
      var S = g[0];
      return /* @__PURE__ */ ne.createElement(u, Ce({}, p, {
        data: S,
        isDisabled: m
      }), this.formatOptionLabel(S, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var a = this.getComponents(), i = a.ClearIndicator, o = this.commonProps, s = this.props, c = s.isDisabled, l = s.isLoading, u = this.state.isFocused;
      if (!this.isClearable() || !i || c || !this.hasValue() || l)
        return null;
      var h = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ ne.createElement(i, Ce({}, o, {
        innerProps: h,
        isFocused: u
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var a = this.getComponents(), i = a.LoadingIndicator, o = this.commonProps, s = this.props, c = s.isDisabled, l = s.isLoading, u = this.state.isFocused;
      if (!i || !l)
        return null;
      var h = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ ne.createElement(i, Ce({}, o, {
        innerProps: h,
        isDisabled: c,
        isFocused: u
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var a = this.getComponents(), i = a.DropdownIndicator, o = a.IndicatorSeparator;
      if (!i || !o)
        return null;
      var s = this.commonProps, c = this.props.isDisabled, l = this.state.isFocused;
      return /* @__PURE__ */ ne.createElement(o, Ce({}, s, {
        isDisabled: c,
        isFocused: l
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var a = this.getComponents(), i = a.DropdownIndicator;
      if (!i)
        return null;
      var o = this.commonProps, s = this.props.isDisabled, c = this.state.isFocused, l = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ ne.createElement(i, Ce({}, o, {
        innerProps: l,
        isDisabled: s,
        isFocused: c
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var a = this, i = this.getComponents(), o = i.Group, s = i.GroupHeading, c = i.Menu, l = i.MenuList, u = i.MenuPortal, h = i.LoadingMessage, p = i.NoOptionsMessage, f = i.Option, y = this.commonProps, m = this.state.focusedOption, v = this.props, k = v.captureMenuScroll, b = v.inputValue, x = v.isLoading, g = v.loadingMessage, w = v.minMenuHeight, M = v.maxMenuHeight, S = v.menuIsOpen, D = v.menuPlacement, A = v.menuPosition, $ = v.menuPortalTarget, F = v.menuShouldBlockScroll, Z = v.menuShouldScrollIntoView, B = v.noOptionsMessage, O = v.onMenuScrollToTop, I = v.onMenuScrollToBottom;
      if (!S)
        return null;
      var N = function(H, _) {
        var X = H.type, P = H.data, Q = H.isDisabled, U = H.isSelected, ae = H.label, ee = H.value, de = m === P, Y = Q ? void 0 : function() {
          return a.onOptionHover(P);
        }, re = Q ? void 0 : function() {
          return a.selectOption(P);
        }, te = "".concat(a.getElementId("option"), "-").concat(_), me = {
          id: te,
          onClick: re,
          onMouseMove: Y,
          onMouseOver: Y,
          tabIndex: -1
        };
        return /* @__PURE__ */ ne.createElement(f, Ce({}, y, {
          innerProps: me,
          data: P,
          isDisabled: Q,
          isSelected: U,
          key: te,
          label: ae,
          type: X,
          value: ee,
          isFocused: de,
          innerRef: de ? a.getFocusedOptionRef : void 0
        }), a.formatOptionLabel(H.data, "menu"));
      }, R;
      if (this.hasOptions())
        R = this.getCategorizedOptions().map(function(z) {
          if (z.type === "group") {
            var H = z.data, _ = z.options, X = z.index, P = "".concat(a.getElementId("group"), "-").concat(X), Q = "".concat(P, "-heading");
            return /* @__PURE__ */ ne.createElement(o, Ce({}, y, {
              key: P,
              data: H,
              options: _,
              Heading: s,
              headingProps: {
                id: Q,
                data: z.data
              },
              label: a.formatGroupLabel(z.data)
            }), z.options.map(function(U) {
              return N(U, "".concat(X, "-").concat(U.index));
            }));
          } else if (z.type === "option")
            return N(z, "".concat(z.index));
        });
      else if (x) {
        var L = g({
          inputValue: b
        });
        if (L === null)
          return null;
        R = /* @__PURE__ */ ne.createElement(h, y, L);
      } else {
        var W = B({
          inputValue: b
        });
        if (W === null)
          return null;
        R = /* @__PURE__ */ ne.createElement(p, y, W);
      }
      var E = {
        minMenuHeight: w,
        maxMenuHeight: M,
        menuPlacement: D,
        menuPosition: A,
        menuShouldScrollIntoView: Z
      }, q = /* @__PURE__ */ ne.createElement(wb, Ce({}, y, E), function(z) {
        var H = z.ref, _ = z.placerProps, X = _.placement, P = _.maxHeight;
        return /* @__PURE__ */ ne.createElement(c, Ce({}, y, E, {
          innerRef: H,
          innerProps: {
            onMouseDown: a.onMenuMouseDown,
            onMouseMove: a.onMenuMouseMove,
            id: a.getElementId("listbox")
          },
          isLoading: x,
          placement: X
        }), /* @__PURE__ */ ne.createElement(Z1e, {
          captureEnabled: k,
          onTopArrive: O,
          onBottomArrive: I,
          lockEnabled: F
        }, function(Q) {
          return /* @__PURE__ */ ne.createElement(l, Ce({}, y, {
            innerRef: function(ae) {
              a.getMenuListRef(ae), Q(ae);
            },
            isLoading: x,
            maxHeight: P,
            focusedOption: m
          }), R);
        }));
      });
      return $ || A === "fixed" ? /* @__PURE__ */ ne.createElement(u, Ce({}, y, {
        appendTo: $,
        controlElement: this.controlRef,
        menuPlacement: D,
        menuPosition: A
      }), q) : q;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var a = this, i = this.props, o = i.delimiter, s = i.isDisabled, c = i.isMulti, l = i.name, u = this.state.selectValue;
      if (!(!l || s))
        if (c)
          if (o) {
            var h = u.map(function(y) {
              return a.getOptionValue(y);
            }).join(o);
            return /* @__PURE__ */ ne.createElement("input", {
              name: l,
              type: "hidden",
              value: h
            });
          } else {
            var p = u.length > 0 ? u.map(function(y, m) {
              return /* @__PURE__ */ ne.createElement("input", {
                key: "i-".concat(m),
                name: l,
                type: "hidden",
                value: a.getOptionValue(y)
              });
            }) : /* @__PURE__ */ ne.createElement("input", {
              name: l,
              type: "hidden"
            });
            return /* @__PURE__ */ ne.createElement("div", null, p);
          }
        else {
          var f = u[0] ? this.getOptionValue(u[0]) : "";
          return /* @__PURE__ */ ne.createElement("input", {
            name: l,
            type: "hidden",
            value: f
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var a = this.commonProps, i = this.state, o = i.ariaSelection, s = i.focusedOption, c = i.focusedValue, l = i.isFocused, u = i.selectValue, h = this.getFocusableOptions();
      return /* @__PURE__ */ ne.createElement(R1e, Ce({}, a, {
        id: this.getElementId("live-region"),
        ariaSelection: o,
        focusedOption: s,
        focusedValue: c,
        isFocused: l,
        selectValue: u,
        focusableOptions: h
      }));
    }
  }, {
    key: "render",
    value: function() {
      var a = this.getComponents(), i = a.Control, o = a.IndicatorsContainer, s = a.SelectContainer, c = a.ValueContainer, l = this.props, u = l.className, h = l.id, p = l.isDisabled, f = l.menuIsOpen, y = this.state.isFocused, m = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ ne.createElement(s, Ce({}, m, {
        className: u,
        innerProps: {
          id: h,
          onKeyDown: this.onKeyDown
        },
        isDisabled: p,
        isFocused: y
      }), this.renderLiveRegion(), /* @__PURE__ */ ne.createElement(i, Ce({}, m, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: p,
        isFocused: y,
        menuIsOpen: f
      }), /* @__PURE__ */ ne.createElement(c, Ce({}, m, {
        isDisabled: p
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ ne.createElement(o, Ce({}, m, {
        isDisabled: p
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(a, i) {
      var o = i.prevProps, s = i.clearFocusValueOnUpdate, c = i.inputIsHiddenAfterUpdate, l = i.ariaSelection, u = i.isFocused, h = i.prevWasFocused, p = a.options, f = a.value, y = a.menuIsOpen, m = a.inputValue, v = a.isMulti, k = ym(f), b = {};
      if (o && (f !== o.value || p !== o.options || y !== o.menuIsOpen || m !== o.inputValue)) {
        var x = y ? ide(a, k) : [], g = s ? ode(i, k) : null, w = sde(i, x);
        b = {
          selectValue: k,
          focusedOption: w,
          focusedValue: g,
          clearFocusValueOnUpdate: !1
        };
      }
      var M = c != null && a !== o ? {
        inputIsHidden: c,
        inputIsHiddenAfterUpdate: void 0
      } : {}, S = l, D = u && h;
      return u && !D && (S = {
        value: Js(v, k, k[0] || null),
        options: k,
        action: "initial-input-focus"
      }, D = !h), (l == null ? void 0 : l.action) === "initial-input-focus" && (S = null), Ze(Ze(Ze({}, b), M), {}, {
        prevProps: a,
        ariaSelection: S,
        prevWasFocused: D
      });
    }
  }]), n;
}(Si);
_b.defaultProps = ade;
var lde = /* @__PURE__ */ Ae(function(e, t) {
  var n = A1e(e);
  return /* @__PURE__ */ ne.createElement(_b, Ce({
    ref: t
  }, n));
});
const dde = lde, ude = 284, hde = 50, pde = "No hay opciones", fde = "Cargando...", kc = /* @__PURE__ */ new Map([
  ["sm", 2.5],
  ["md", 3],
  ["lg", 3.5]
]), Gb = G(dde)`
  font-family: ${(e) => e.theme.fontFamilyRegular};

  .mpp-autocomplete {
    &__control {
      background-color: ${(e) => e.theme.colorNeutralLightest};
      border-radius: ${(e) => e.theme.borderRadiusMd};
      border: ${({ theme: e, isInvalid: t }) => `${e.borderWidthHairline} solid ${t ? e.colorSupportNegativeMedium : e.colorNeutralDark}`};

      &--sm {
        min-height: ${kc.get("sm")}rem;
        font-size: ${(e) => e.theme.fontSizeQuarck};
      }
      &--md {
        min-height: ${kc.get("md")}rem;
        font-size: ${(e) => e.theme.fontSizeNano};
      }
      &--lg {
        min-height: ${kc.get("lg")}rem;
        font-size: ${(e) => e.theme.fontSizeXxxs};
        align-items: center;
      }
      &:hover {
        border-color: ${({ theme: e, isInvalid: t }) => t ? e.colorSupportNegativeMedium : e.colorNeutralDark};
      }
      &--is-focused {
        box-shadow: 0 0 0 0px;
        outline: none;
      }
      &--is-disabled {
        background-color: ${(e) => e.theme.colorNeutralLight};
        opacity: ${(e) => e.theme.opacitySemiOpaque};
        border: ${(e) => `${e.theme.borderWidthHairline} solid ${e.theme.colorNeutralMedium}`};

        & .mpp-autocomplete__indicator i {
          color: ${(e) => e.theme.colorNeutralDark};
        }
      }

      &--menu-is-open {
        .mpp-autocomplete__dropdown-indicator i {
          transform: rotate(-180deg);
        }
      }
    }

    &__placeholder {
      display: flex;
      align-items: center;

      ${({ theme: e, isInvalid: t }) => t && ke`
          color: ${e.colorSupportNegativeMedium};
        `}
    }

    &__option {
      background-color: ${(e) => e.theme.colorNeutralLightest};
      border: ${(e) => `0 solid ${e.theme.colorNeutralDark}`};
      font-family: ${(e) => e.theme.fontFamilyRegular};
      color: ${(e) => e.theme.colorNeutralDarkest};
      display: flex;
      justify-content: space-between;

      &--sm {
        min-height: 2.5rem;
        font-size: ${(e) => e.theme.fontSizeQuarck};
      }
      &--md {
        min-height: 3rem;
        font-size: ${(e) => e.theme.fontSizeNano};
      }
      &--lg {
        min-height: 3.5rem;
        font-size: ${(e) => e.theme.fontSizeXxxs};
      }
      &:hover {
        background-color: ${(e) => e.theme.colorNeutralLight};
        color: ${(e) => e.theme.brandPrimaryMedium};
      }
      &--is-selected {
        background-color: ${(e) => e.theme.colorNeutralLightest};
        color: ${(e) => e.theme.brandPrimaryMedium};
      }
      &--is-active {
        background-color: ${(e) => e.theme.colorNeutralLightest};
        color: ${(e) => e.theme.brandPrimaryMedium};
      }
      &--is-focused {
        background-color: ${(e) => e.theme.colorNeutralLight};
        color: ${(e) => e.theme.brandPrimaryMedium};
      }
      &--is-disabled {
        background-color: ${(e) => e.theme.colorNeutralLightest};
        color: ${(e) => e.theme.colorNeutralMedium};

        &:hover {
          background-color: ${(e) => e.theme.colorNeutralLightest};
          color: ${(e) => e.theme.colorNeutralMedium};
        }
      }
      &-value {
        margin-left: ${(e) => e.theme.spacingInsetXs};
        color: ${(e) => e.theme.colorNeutralDark};
      }
    }

    &__option-content {
      align-self: center;
      white-space: ${(e) => e.wrap ? "revert" : "nowrap"};
      overflow: ${(e) => e.wrap ? "revert" : "hidden"};
      text-overflow: ${(e) => e.wrap ? "revert" : "ellipsis"};
    }

    &__selected-icon {
      align-self: center;
    }

    &__menu {
      border: ${(e) => `${e.theme.borderWidthHairline} solid ${e.theme.colorNeutralMedium}`};
      box-shadow: ${(e) => e.theme.shadowDown01};

      &-list {
        overflow-y: scroll;

        &::-webkit-scrollbar {
          width: 0.25rem;
        }

        &::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 6px ${(e) => e.theme.colorNeutralLightest};
          box-shadow: inset 0 0 6px ${(e) => e.theme.colorNeutralLightest};
          border-radius: 10px;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          -webkit-box-shadow: inset 0 0 16px ${(e) => e.theme.colorNeutralMedium};
          box-shadow: inset 0 0 6px ${(e) => e.theme.colorNeutralMedium};
        }
      }

      &-notice {
        text-align: left;
        color: ${(e) => e.theme.colorNeutralDarkest};
      }
    }

    &__indicator-container {
      padding: 0 ${(e) => e.theme.spacingInsetXs} 0 0;
    }

    &__indicator {
      &--sm i {
        font-size: ${(e) => e.theme.spacingInlineXxxs};
      }
      &--md i {
        font-size: ${(e) => e.theme.spacingInlineXxs};
      }
      &--lg i {
        font-size: ${(e) => e.theme.spacingInlineXxs};
      }

      & i {
        color: ${({ theme: e, isInvalid: t }) => t ? e.colorSupportNegativeMedium : e.brandPrimaryMedium};
        padding: ${(e) => e.theme.spacingInlineQuarck};

        &:hover {
          background-color: ${(e) => e.theme.colorNeutralLight};
          border-radius: ${(e) => e.theme.borderRadiusCircular};
        }
      }
    }

    &__dropdown-indicator {
      i {
        transform: rotate(0);
        transition: transform 0.25s ease-in-out;
      }
    }

    &__indicator-separator {
      display: none;
    }

    &__single-value {
      ${({ theme: e, isInvalid: t }) => t && ke`
          color: ${e.colorSupportNegativeMedium};
        `}
    }

    &__multi-value {
      background-color: ${(e) => e.theme.colorNeutralLightest};
      border-radius: ${(e) => e.theme.borderRadiusLg};
      border: ${(e) => `${e.theme.borderWidthHairline} solid ${e.theme.colorNeutralMedium}`};

      &__label {
        color: ${(e) => e.theme.colorNeutralDark};
        font-weight: ${(e) => e.theme.fontWeightRegular};
        white-space: ${(e) => e.wrap ? "revert" : "nowrap"};
        overflow: ${(e) => e.wrap ? "revert" : "hidden"};
        text-overflow: ${(e) => e.wrap ? "revert" : "ellipsis"};
      }

      &__remove {
        & i {
          font-size: ${(e) => e.theme.fontSizeXxxs};
        }

        &:hover {
          background-color: transparent;
          color: ${(e) => e.theme.colorNeutralDarkest};
          border: 0;
        }
      }
    }

    &__value-container {
      padding: 0 0 0 ${(e) => e.theme.spacingInsetXs};
    }
  }
`, yde = ({
  apiService: e,
  onChange: t,
  refetchOnChange: n,
  isPaginated: r,
  debounceTimeToFetch: a = 500,
  onInputChange: i,
  loadingMessage: o = () => fde,
  ...s
}) => {
  const [c, l] = fe([]), u = he({}), [h, p] = fe(), [f, y] = fe(""), m = k6(f, a);
  return be(() => {
    let b = !0;
    return (async (g) => {
      const w = g || "nullQuery";
      if (l([]), p(!0), u.current[w] && b)
        l(u.current[w]), p(!1);
      else {
        const M = await e(g);
        M && (u.current[w] = r ? M.slice(0, hde) : M, b && (l(u.current[w]), p(!1)));
      }
    })(m), () => {
      b = !1;
    };
  }, [e, m, r]), /* @__PURE__ */ C("div", { children: /* @__PURE__ */ C(
    Gb,
    {
      ...s,
      options: c,
      onChange: (b, x) => {
        t && t(b, x), n && y("");
      },
      onInputChange: (b, x) => {
        y(b), i && i(b, x);
      },
      loadingMessage: o,
      isLoading: h,
      filterOption: null
    }
  ) });
}, mde = (e) => {
  const {
    selectProps: { classNamePrefix: t, size: n }
  } = e;
  return /* @__PURE__ */ C(wa.ClearIndicator, { className: `${t}__indicator--${n}`, ...e, children: /* @__PURE__ */ C(ot, { name: "x" }) });
}, gde = (e) => {
  const {
    selectProps: { classNamePrefix: t, size: n }
  } = e;
  return /* @__PURE__ */ C(wa.Control, { className: `${t}__control--${n}`, ...e });
}, vde = (e) => {
  const {
    selectProps: { classNamePrefix: t, size: n }
  } = e;
  return /* @__PURE__ */ C(wa.DropdownIndicator, { className: `${t}__indicator--${n}`, ...e, children: /* @__PURE__ */ C(ot, { name: "caret-down" }) });
};
var kde = typeof performance == "object" && typeof performance.now == "function", Dm = kde ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function Tm(e) {
  cancelAnimationFrame(e.id);
}
function bde(e, t) {
  var n = Dm();
  function r() {
    Dm() - n >= t ? e.call(null) : a.id = requestAnimationFrame(r);
  }
  var a = {
    id: requestAnimationFrame(r)
  };
  return a;
}
var Xd = -1;
function Nm(e) {
  if (e === void 0 && (e = !1), Xd === -1 || e) {
    var t = document.createElement("div"), n = t.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", document.body.appendChild(t), Xd = t.offsetWidth - t.clientWidth, document.body.removeChild(t);
  }
  return Xd;
}
var za = null;
function Pm(e) {
  if (e === void 0 && (e = !1), za === null || e) {
    var t = document.createElement("div"), n = t.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", n.direction = "rtl";
    var r = document.createElement("div"), a = r.style;
    return a.width = "100px", a.height = "100px", t.appendChild(r), document.body.appendChild(t), t.scrollLeft > 0 ? za = "positive-descending" : (t.scrollLeft = 1, t.scrollLeft === 0 ? za = "negative" : za = "positive-ascending"), document.body.removeChild(t), za;
  }
  return za;
}
process.env.NODE_ENV;
var xde = 150, Mde = function(t, n) {
  return t;
}, bc = null, xc = null;
process.env.NODE_ENV !== "production" && typeof window < "u" && typeof window.WeakSet < "u" && (bc = /* @__PURE__ */ new WeakSet(), xc = /* @__PURE__ */ new WeakSet());
function wde(e) {
  var t, n = e.getItemOffset, r = e.getEstimatedTotalSize, a = e.getItemSize, i = e.getOffsetForIndexAndAlignment, o = e.getStartIndexForOffset, s = e.getStopIndexForStartIndex, c = e.initInstanceProps, l = e.shouldResetStyleCacheOnItemSizeChange, u = e.validateProps;
  return t = /* @__PURE__ */ function(h) {
    Ig(p, h);
    function p(y) {
      var m;
      return m = h.call(this, y) || this, m._instanceProps = c(m.props, i0(m)), m._outerRef = void 0, m._resetIsScrollingTimeoutId = null, m.state = {
        instance: i0(m),
        isScrolling: !1,
        scrollDirection: "forward",
        scrollOffset: typeof m.props.initialScrollOffset == "number" ? m.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: !1
      }, m._callOnItemsRendered = void 0, m._callOnItemsRendered = vc(function(v, k, b, x) {
        return m.props.onItemsRendered({
          overscanStartIndex: v,
          overscanStopIndex: k,
          visibleStartIndex: b,
          visibleStopIndex: x
        });
      }), m._callOnScroll = void 0, m._callOnScroll = vc(function(v, k, b) {
        return m.props.onScroll({
          scrollDirection: v,
          scrollOffset: k,
          scrollUpdateWasRequested: b
        });
      }), m._getItemStyle = void 0, m._getItemStyle = function(v) {
        var k = m.props, b = k.direction, x = k.itemSize, g = k.layout, w = m._getItemStyleCache(l && x, l && g, l && b), M;
        if (w.hasOwnProperty(v))
          M = w[v];
        else {
          var S = n(m.props, v, m._instanceProps), D = a(m.props, v, m._instanceProps), A = b === "horizontal" || g === "horizontal", $ = b === "rtl", F = A ? S : 0;
          w[v] = M = {
            position: "absolute",
            left: $ ? void 0 : F,
            right: $ ? F : void 0,
            top: A ? 0 : S,
            height: A ? "100%" : D,
            width: A ? D : "100%"
          };
        }
        return M;
      }, m._getItemStyleCache = void 0, m._getItemStyleCache = vc(function(v, k, b) {
        return {};
      }), m._onScrollHorizontal = function(v) {
        var k = v.currentTarget, b = k.clientWidth, x = k.scrollLeft, g = k.scrollWidth;
        m.setState(function(w) {
          if (w.scrollOffset === x)
            return null;
          var M = m.props.direction, S = x;
          if (M === "rtl")
            switch (Pm()) {
              case "negative":
                S = -x;
                break;
              case "positive-descending":
                S = g - b - x;
                break;
            }
          return S = Math.max(0, Math.min(S, g - b)), {
            isScrolling: !0,
            scrollDirection: w.scrollOffset < x ? "forward" : "backward",
            scrollOffset: S,
            scrollUpdateWasRequested: !1
          };
        }, m._resetIsScrollingDebounced);
      }, m._onScrollVertical = function(v) {
        var k = v.currentTarget, b = k.clientHeight, x = k.scrollHeight, g = k.scrollTop;
        m.setState(function(w) {
          if (w.scrollOffset === g)
            return null;
          var M = Math.max(0, Math.min(g, x - b));
          return {
            isScrolling: !0,
            scrollDirection: w.scrollOffset < M ? "forward" : "backward",
            scrollOffset: M,
            scrollUpdateWasRequested: !1
          };
        }, m._resetIsScrollingDebounced);
      }, m._outerRefSetter = function(v) {
        var k = m.props.outerRef;
        m._outerRef = v, typeof k == "function" ? k(v) : k != null && typeof k == "object" && k.hasOwnProperty("current") && (k.current = v);
      }, m._resetIsScrollingDebounced = function() {
        m._resetIsScrollingTimeoutId !== null && Tm(m._resetIsScrollingTimeoutId), m._resetIsScrollingTimeoutId = bde(m._resetIsScrolling, xde);
      }, m._resetIsScrolling = function() {
        m._resetIsScrollingTimeoutId = null, m.setState({
          isScrolling: !1
        }, function() {
          m._getItemStyleCache(-1, null);
        });
      }, m;
    }
    p.getDerivedStateFromProps = function(m, v) {
      return Cde(m, v), u(m), null;
    };
    var f = p.prototype;
    return f.scrollTo = function(m) {
      m = Math.max(0, m), this.setState(function(v) {
        return v.scrollOffset === m ? null : {
          scrollDirection: v.scrollOffset < m ? "forward" : "backward",
          scrollOffset: m,
          scrollUpdateWasRequested: !0
        };
      }, this._resetIsScrollingDebounced);
    }, f.scrollToItem = function(m, v) {
      v === void 0 && (v = "auto");
      var k = this.props, b = k.itemCount, x = k.layout, g = this.state.scrollOffset;
      m = Math.max(0, Math.min(m, b - 1));
      var w = 0;
      if (this._outerRef) {
        var M = this._outerRef;
        x === "vertical" ? w = M.scrollWidth > M.clientWidth ? Nm() : 0 : w = M.scrollHeight > M.clientHeight ? Nm() : 0;
      }
      this.scrollTo(i(this.props, m, v, g, this._instanceProps, w));
    }, f.componentDidMount = function() {
      var m = this.props, v = m.direction, k = m.initialScrollOffset, b = m.layout;
      if (typeof k == "number" && this._outerRef != null) {
        var x = this._outerRef;
        v === "horizontal" || b === "horizontal" ? x.scrollLeft = k : x.scrollTop = k;
      }
      this._callPropsCallbacks();
    }, f.componentDidUpdate = function() {
      var m = this.props, v = m.direction, k = m.layout, b = this.state, x = b.scrollOffset, g = b.scrollUpdateWasRequested;
      if (g && this._outerRef != null) {
        var w = this._outerRef;
        if (v === "horizontal" || k === "horizontal")
          if (v === "rtl")
            switch (Pm()) {
              case "negative":
                w.scrollLeft = -x;
                break;
              case "positive-ascending":
                w.scrollLeft = x;
                break;
              default:
                var M = w.clientWidth, S = w.scrollWidth;
                w.scrollLeft = S - M - x;
                break;
            }
          else
            w.scrollLeft = x;
        else
          w.scrollTop = x;
      }
      this._callPropsCallbacks();
    }, f.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && Tm(this._resetIsScrollingTimeoutId);
    }, f.render = function() {
      var m = this.props, v = m.children, k = m.className, b = m.direction, x = m.height, g = m.innerRef, w = m.innerElementType, M = m.innerTagName, S = m.itemCount, D = m.itemData, A = m.itemKey, $ = A === void 0 ? Mde : A, F = m.layout, Z = m.outerElementType, B = m.outerTagName, O = m.style, I = m.useIsScrolling, N = m.width, R = this.state.isScrolling, L = b === "horizontal" || F === "horizontal", W = L ? this._onScrollHorizontal : this._onScrollVertical, E = this._getRangeToRender(), q = E[0], z = E[1], H = [];
      if (S > 0)
        for (var _ = q; _ <= z; _++)
          H.push(le(v, {
            data: D,
            key: $(_, D),
            index: _,
            isScrolling: I ? R : void 0,
            style: this._getItemStyle(_)
          }));
      var X = r(this.props, this._instanceProps);
      return le(Z || B || "div", {
        className: k,
        onScroll: W,
        ref: this._outerRefSetter,
        style: je({
          position: "relative",
          height: x,
          width: N,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: b
        }, O)
      }, le(w || M || "div", {
        children: H,
        ref: g,
        style: {
          height: L ? "100%" : X,
          pointerEvents: R ? "none" : void 0,
          width: L ? X : "100%"
        }
      }));
    }, f._callPropsCallbacks = function() {
      if (typeof this.props.onItemsRendered == "function") {
        var m = this.props.itemCount;
        if (m > 0) {
          var v = this._getRangeToRender(), k = v[0], b = v[1], x = v[2], g = v[3];
          this._callOnItemsRendered(k, b, x, g);
        }
      }
      if (typeof this.props.onScroll == "function") {
        var w = this.state, M = w.scrollDirection, S = w.scrollOffset, D = w.scrollUpdateWasRequested;
        this._callOnScroll(M, S, D);
      }
    }, f._getRangeToRender = function() {
      var m = this.props, v = m.itemCount, k = m.overscanCount, b = this.state, x = b.isScrolling, g = b.scrollDirection, w = b.scrollOffset;
      if (v === 0)
        return [0, 0, 0, 0];
      var M = o(this.props, w, this._instanceProps), S = s(this.props, M, w, this._instanceProps), D = !x || g === "backward" ? Math.max(1, k) : 1, A = !x || g === "forward" ? Math.max(1, k) : 1;
      return [Math.max(0, M - D), Math.max(0, Math.min(v - 1, S + A)), M, S];
    }, p;
  }(n6), t.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: !1
  }, t;
}
var Cde = function(t, n) {
  var r = t.children, a = t.direction, i = t.height, o = t.layout, s = t.innerTagName, c = t.outerTagName, l = t.width, u = n.instance;
  if (process.env.NODE_ENV !== "production") {
    (s != null || c != null) && xc && !xc.has(u) && (xc.add(u), console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead."));
    var h = a === "horizontal" || o === "horizontal";
    switch (a) {
      case "horizontal":
      case "vertical":
        bc && !bc.has(u) && (bc.add(u), console.warn('The direction prop should be either "ltr" (default) or "rtl". Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.'));
        break;
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + a + '" was specified.'));
    }
    switch (o) {
      case "horizontal":
      case "vertical":
        break;
      default:
        throw Error('An invalid "layout" prop has been specified. Value should be either "horizontal" or "vertical". ' + ('"' + o + '" was specified.'));
    }
    if (r == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (r === null ? "null" : typeof r) + '" was specified.'));
    if (h && typeof l != "number")
      throw Error('An invalid "width" prop has been specified. Horizontal lists must specify a number for width. ' + ('"' + (l === null ? "null" : typeof l) + '" was specified.'));
    if (!h && typeof i != "number")
      throw Error('An invalid "height" prop has been specified. Vertical lists must specify a number for height. ' + ('"' + (i === null ? "null" : typeof i) + '" was specified.'));
  }
}, Sde = 50, Xa = function(t, n, r) {
  var a = t, i = a.itemSize, o = r.itemMetadataMap, s = r.lastMeasuredIndex;
  if (n > s) {
    var c = 0;
    if (s >= 0) {
      var l = o[s];
      c = l.offset + l.size;
    }
    for (var u = s + 1; u <= n; u++) {
      var h = i(u);
      o[u] = {
        offset: c,
        size: h
      }, c += h;
    }
    r.lastMeasuredIndex = n;
  }
  return o[n];
}, Ade = function(t, n, r) {
  var a = n.itemMetadataMap, i = n.lastMeasuredIndex, o = i > 0 ? a[i].offset : 0;
  return o >= r ? Zb(t, n, i, 0, r) : Ode(t, n, Math.max(0, i), r);
}, Zb = function(t, n, r, a, i) {
  for (; a <= r; ) {
    var o = a + Math.floor((r - a) / 2), s = Xa(t, o, n).offset;
    if (s === i)
      return o;
    s < i ? a = o + 1 : s > i && (r = o - 1);
  }
  return a > 0 ? a - 1 : 0;
}, Ode = function(t, n, r, a) {
  for (var i = t.itemCount, o = 1; r < i && Xa(t, r, n).offset < a; )
    r += o, o *= 2;
  return Zb(t, n, Math.min(r, i - 1), Math.floor(r / 2), a);
}, Lm = function(t, n) {
  var r = t.itemCount, a = n.itemMetadataMap, i = n.estimatedItemSize, o = n.lastMeasuredIndex, s = 0;
  if (o >= r && (o = r - 1), o >= 0) {
    var c = a[o];
    s = c.offset + c.size;
  }
  var l = r - o - 1, u = l * i;
  return s + u;
}, Ede = /* @__PURE__ */ wde({
  getItemOffset: function(t, n, r) {
    return Xa(t, n, r).offset;
  },
  getItemSize: function(t, n, r) {
    return r.itemMetadataMap[n].size;
  },
  getEstimatedTotalSize: Lm,
  getOffsetForIndexAndAlignment: function(t, n, r, a, i, o) {
    var s = t.direction, c = t.height, l = t.layout, u = t.width, h = s === "horizontal" || l === "horizontal", p = h ? u : c, f = Xa(t, n, i), y = Lm(t, i), m = Math.max(0, Math.min(y - p, f.offset)), v = Math.max(0, f.offset - p + f.size + o);
    switch (r === "smart" && (a >= v - p && a <= m + p ? r = "auto" : r = "center"), r) {
      case "start":
        return m;
      case "end":
        return v;
      case "center":
        return Math.round(v + (m - v) / 2);
      case "auto":
      default:
        return a >= v && a <= m ? a : a < v ? v : m;
    }
  },
  getStartIndexForOffset: function(t, n, r) {
    return Ade(t, r, n);
  },
  getStopIndexForStartIndex: function(t, n, r, a) {
    for (var i = t.direction, o = t.height, s = t.itemCount, c = t.layout, l = t.width, u = i === "horizontal" || c === "horizontal", h = u ? l : o, p = Xa(t, n, a), f = r + h, y = p.offset + p.size, m = n; m < s - 1 && y < f; )
      m++, y += Xa(t, m, a).size;
    return m;
  },
  initInstanceProps: function(t, n) {
    var r = t, a = r.estimatedItemSize, i = {
      itemMetadataMap: {},
      estimatedItemSize: a || Sde,
      lastMeasuredIndex: -1
    };
    return n.resetAfterIndex = function(o, s) {
      s === void 0 && (s = !0), i.lastMeasuredIndex = Math.min(i.lastMeasuredIndex, o - 1), n._getItemStyleCache(-1), s && n.forceUpdate();
    }, i;
  },
  shouldResetStyleCacheOnItemSizeChange: !1,
  validateProps: function(t) {
    var n = t.itemSize;
    if (process.env.NODE_ENV !== "production" && typeof n != "function")
      throw Error('An invalid "itemSize" prop has been specified. Value should be a function. ' + ('"' + (n === null ? "null" : typeof n) + '" was specified.'));
  }
});
const Ide = (e) => e.reduce((n, r) => {
  const {
    props: { children: a }
  } = r, i = a && Array.isArray(a) ? a : [];
  return [
    ...n,
    V.cloneElement(r, { type: "group" }, []),
    ...i
  ];
}, []), Dde = (e) => (kc.get(e) || 48) * 16, Tde = ({
  size: e,
  groupHeadingStyles: t,
  noOptionsMsgStyles: n,
  optionStyles: r,
  loadingMsgStyles: a
}) => function(o) {
  const {
    props: {
      type: s,
      children: c,
      inputValue: l,
      selectProps: { noOptionsMessage: u, loadingMessage: h }
    }
  } = o, p = Dde(e);
  if (s === "group") {
    const { height: f = p } = t;
    return f;
  }
  if (s === "option") {
    const { height: f = p } = r;
    return f;
  }
  if (typeof u == "function" && c === u({ inputValue: l })) {
    const { height: f = p } = n;
    return f;
  }
  if (typeof h == "function" && c === h({ inputValue: l })) {
    const { height: f = p } = a;
    return f;
  }
  return p;
}, Nde = (e) => {
  const { props: { isFocused: t = !1 } = {} } = e;
  return t === !0;
}, Pde = (e) => Math.max(V.Children.toArray(e).findIndex(Nde), 0), Lde = ({ size: e, children: t, menuListProps: n, itemCount: r }) => {
  const { getStyles: a } = n, i = a("groupHeading", { ...n, data: { options: [] }, id: "" }), o = a("loadingMessage", n), s = a("noOptionsMessage", n), c = a("option", {
    ...n,
    label: "",
    type: "option",
    isDisabled: !1,
    data: {},
    isFocused: !1,
    isSelected: !1
  }), l = Tde({
    size: e,
    groupHeadingStyles: i,
    noOptionsMsgStyles: s,
    optionStyles: c,
    loadingMsgStyles: o
  }), u = V.useMemo(() => t.map(l), [t, l]), [h, p] = V.useState({}), f = V.useMemo(
    () => u.reduce((w, M, S) => h[S] ? w + h[S] : w + M, 0),
    [u, h]
  ), { maxHeight: y, paddingBottom: m = 0, paddingTop: v = 0, ...k } = a("menuList", n), b = f + m + v, x = Math.min(y, b), g = Math.floor(f / r);
  return {
    menuHeight: x,
    estimatedItemSize: g,
    measuredTotalHeights: h,
    setMeasuredTotalHeights: p,
    menuListStyle: k,
    paddingBottom: m,
    paddingTop: v,
    heights: u
  };
}, Rde = (e) => {
  const {
    children: t,
    selectProps: { size: n = "lg" }
  } = e, r = V.useMemo(() => {
    const g = V.Children.toArray(t), w = g[0] || {};
    if (V.isValidElement(w)) {
      const { props: { data: { options: M = [] } = {} } = {} } = w;
      return M.length > 0 ? Ide(g) : g;
    }
    return [];
  }, [t]), a = V.useMemo(() => Pde(r), [r]), i = r.length, {
    menuHeight: o,
    estimatedItemSize: s,
    measuredTotalHeights: c,
    setMeasuredTotalHeights: l,
    menuListStyle: u,
    paddingBottom: h,
    paddingTop: p,
    heights: f
  } = Lde({
    size: n,
    children: r,
    menuListProps: e,
    itemCount: i
  }), { innerRef: y, selectProps: m } = e, { classNamePrefix: v, isMulti: k } = m || {}, b = V.useRef(null), x = ({ index: g, measuredHeight: w }) => {
    c[g] !== void 0 && c[g] === w || (l((M) => ({
      ...M,
      [g]: w
    })), b.current && b.current.resetAfterIndex(g));
  };
  return V.useEffect(() => {
    l({});
  }, [t]), V.useEffect(() => {
    a >= 0 && b.current !== null && b.current.scrollToItem(a);
  }, [a, r, b]), /* @__PURE__ */ C(
    Ede,
    {
      className: v ? `${v}__menu-list${k ? ` ${v}__menu-list--is-multi` : ""}` : "",
      style: u,
      ref: b,
      outerRef: y,
      estimatedItemSize: s,
      innerElementType: V.forwardRef(({ style: g, ...w }, M) => /* @__PURE__ */ C(
        "div",
        {
          ref: M,
          style: {
            ...g,
            height: `${parseFloat(g.height) + h + p}px`
          },
          ...w
        }
      )),
      height: o,
      width: "100%",
      itemCount: i,
      itemData: r,
      itemSize: (g) => c[g] || f[g],
      children: ({ data: g, index: w, style: M }) => /* @__PURE__ */ C(
        "div",
        {
          style: {
            ...M,
            top: `${M.top || 0 + p}px`
          },
          children: /* @__PURE__ */ C(Vde, { data: g[w], index: w, setMeasuredHeight: x })
        }
      )
    }
  );
}, Vde = ({ data: e, index: t, setMeasuredHeight: n }) => {
  const r = V.useRef(null);
  return V.useLayoutEffect(() => {
    if (r.current) {
      const { height: a } = r.current.getBoundingClientRect();
      n({ index: t, measuredHeight: a });
    }
  }, [r.current]), /* @__PURE__ */ C("div", { ref: r, children: e }, `option-${t}`);
}, zde = (e) => /* @__PURE__ */ C(wa.MultiValueRemove, { ...e, children: /* @__PURE__ */ C(ot, { name: "x" }) }), Bde = (e) => {
  const {
    selectProps: { classNamePrefix: t, size: n, encapsulateLabel: r },
    isSelected: a,
    label: i,
    value: o
  } = e;
  return /* @__PURE__ */ ie(wa.Option, { ...e, className: `${t}__option--${n}`, children: [
    /* @__PURE__ */ ie("div", { className: "mpp-autocomplete__option-content", children: [
      /* @__PURE__ */ C("span", { className: "mpp-autocomplete__option-label", children: i }),
      r && /* @__PURE__ */ C("span", { className: "mpp-autocomplete__option-value", children: o })
    ] }),
    a && /* @__PURE__ */ C(ot, { className: `${t}__selected-icon`, name: "check" })
  ] });
}, Hde = (e) => {
  const {
    selectProps: { classNamePrefix: t, size: n }
  } = e;
  return /* @__PURE__ */ C(wa.Placeholder, { className: `${t}__control--${n}`, ...e });
}, $de = ({
  optionsList: e,
  ...t
}) => /* @__PURE__ */ C("div", { children: /* @__PURE__ */ C(Gb, { ...t, options: e }) }), V4e = ({
  source: e = [],
  placeholder: t = "",
  size: n = "lg",
  encapsulateLabel: r = !1,
  refetchOnChange: a = !0,
  className: i = "",
  menuPlacement: o = "auto",
  closeMenuOnSelect: s,
  isClearable: c = !0,
  isSearchable: l = !0,
  wrap: u = !1,
  isPaginated: h = !0,
  virtualization: p = !1,
  shouldFilterOptions: f = !0,
  noOptionsMessage: y = () => pde,
  hideSelectedOptions: m = !1,
  maxMenuHeight: v = ude,
  ...k
}) => {
  const b = {
    className: `mpp-autocomplete ${i}`,
    classNamePrefix: "mpp-autocomplete",
    noOptionsMessage: y,
    hideSelectedOptions: m,
    maxMenuHeight: v,
    components: {
      Control: gde,
      DropdownIndicator: vde,
      Option: Bde,
      ClearIndicator: mde,
      MultiValueRemove: zde,
      Placeholder: Hde,
      ...p && { MenuList: Rde }
    },
    filterOption: f ? Vb({
      ignoreCase: !0,
      ignoreAccents: !0,
      trim: !1,
      matchFrom: "any"
    }) : null,
    isClearable: c,
    isSearchable: l,
    placeholder: t,
    size: n,
    encapsulateLabel: r,
    refetchOnChange: a,
    menuPlacement: o,
    closeMenuOnSelect: s === void 0 ? !k.isMulti : s,
    wrap: u,
    isPaginated: h
  };
  return Array.isArray(e) ? /* @__PURE__ */ C($de, { ...k, ...b, optionsList: e }) : /* @__PURE__ */ C(yde, { ...k, ...b, apiService: e });
};
function E1() {
  return Array.prototype.slice.call(arguments).reduce(function(e, t) {
    return e.concat(t);
  }, []).filter(function(e) {
    return typeof e == "string";
  }).join(" ");
}
var jde = "Expected a function", Xb = "__lodash_hash_undefined__", Fde = "[object Function]", Wde = "[object GeneratorFunction]", qde = /[\\^$.*+?()[\]{}|]/g, _de = /^\[object .+?Constructor\]$/, Gde = typeof _i == "object" && _i && _i.Object === Object && _i, Zde = typeof self == "object" && self && self.Object === Object && self, Ub = Gde || Zde || Function("return this")();
function Xde(e, t) {
  return e == null ? void 0 : e[t];
}
function Ude(e) {
  var t = !1;
  if (e != null && typeof e.toString != "function")
    try {
      t = !!(e + "");
    } catch {
    }
  return t;
}
var Yde = Array.prototype, Jde = Function.prototype, Yb = Object.prototype, Ud = Ub["__core-js_shared__"], Rm = function() {
  var e = /[^.]+$/.exec(Ud && Ud.keys && Ud.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}(), Jb = Jde.toString, g2 = Yb.hasOwnProperty, Kde = Yb.toString, Qde = RegExp(
  "^" + Jb.call(g2).replace(qde, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
), eue = Yde.splice, tue = Kb(Ub, "Map"), Ho = Kb(Object, "create");
function va(e) {
  var t = -1, n = e ? e.length : 0;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
function nue() {
  this.__data__ = Ho ? Ho(null) : {};
}
function rue(e) {
  return this.has(e) && delete this.__data__[e];
}
function aue(e) {
  var t = this.__data__;
  if (Ho) {
    var n = t[e];
    return n === Xb ? void 0 : n;
  }
  return g2.call(t, e) ? t[e] : void 0;
}
function iue(e) {
  var t = this.__data__;
  return Ho ? t[e] !== void 0 : g2.call(t, e);
}
function oue(e, t) {
  var n = this.__data__;
  return n[e] = Ho && t === void 0 ? Xb : t, this;
}
va.prototype.clear = nue;
va.prototype.delete = rue;
va.prototype.get = aue;
va.prototype.has = iue;
va.prototype.set = oue;
function Ri(e) {
  var t = -1, n = e ? e.length : 0;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
function sue() {
  this.__data__ = [];
}
function cue(e) {
  var t = this.__data__, n = I1(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : eue.call(t, n, 1), !0;
}
function lue(e) {
  var t = this.__data__, n = I1(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function due(e) {
  return I1(this.__data__, e) > -1;
}
function uue(e, t) {
  var n = this.__data__, r = I1(n, e);
  return r < 0 ? n.push([e, t]) : n[r][1] = t, this;
}
Ri.prototype.clear = sue;
Ri.prototype.delete = cue;
Ri.prototype.get = lue;
Ri.prototype.has = due;
Ri.prototype.set = uue;
function Ca(e) {
  var t = -1, n = e ? e.length : 0;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
function hue() {
  this.__data__ = {
    hash: new va(),
    map: new (tue || Ri)(),
    string: new va()
  };
}
function pue(e) {
  return D1(this, e).delete(e);
}
function fue(e) {
  return D1(this, e).get(e);
}
function yue(e) {
  return D1(this, e).has(e);
}
function mue(e, t) {
  return D1(this, e).set(e, t), this;
}
Ca.prototype.clear = hue;
Ca.prototype.delete = pue;
Ca.prototype.get = fue;
Ca.prototype.has = yue;
Ca.prototype.set = mue;
function I1(e, t) {
  for (var n = e.length; n--; )
    if (xue(e[n][0], t))
      return n;
  return -1;
}
function gue(e) {
  if (!Qb(e) || kue(e))
    return !1;
  var t = Mue(e) || Ude(e) ? Qde : _de;
  return t.test(bue(e));
}
function D1(e, t) {
  var n = e.__data__;
  return vue(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function Kb(e, t) {
  var n = Xde(e, t);
  return gue(n) ? n : void 0;
}
function vue(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function kue(e) {
  return !!Rm && Rm in e;
}
function bue(e) {
  if (e != null) {
    try {
      return Jb.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
function v2(e, t) {
  if (typeof e != "function" || t && typeof t != "function")
    throw new TypeError(jde);
  var n = function() {
    var r = arguments, a = t ? t.apply(this, r) : r[0], i = n.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, r);
    return n.cache = i.set(a, o), o;
  };
  return n.cache = new (v2.Cache || Ca)(), n;
}
v2.Cache = Ca;
function xue(e, t) {
  return e === t || e !== e && t !== t;
}
function Mue(e) {
  var t = Qb(e) ? Kde.call(e) : "";
  return t == Fde || t == Wde;
}
function Qb(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
var wue = v2;
const e3 = /* @__PURE__ */ Ll(wue);
function t3(e) {
  return JSON.stringify(e);
}
function Cue(e) {
  return e.filter(function(t, n) {
    return t && e.indexOf(t) === n;
  });
}
function Sue(e) {
  return e.map(function(t) {
    if (!t || t.indexOf("-") === -1 || t.toLowerCase() !== t)
      return t;
    var n = t.split("-");
    return n[0] + "-" + n[1].toUpperCase();
  });
}
function Aue(e) {
  var t = e === void 0 ? {} : e, n = t.useFallbackLocale, r = n === void 0 ? !0 : n, a = t.fallbackLocale, i = a === void 0 ? "en-US" : a, o = [];
  if (typeof window < "u") {
    var s = window, c = s.navigator;
    o = o.concat(c.languages, c.language, c.userLanguage, c.browserLanguage, c.systemLanguage);
  }
  return r && o.push(i), Sue(Cue(o));
}
var Oue = e3(Aue, t3);
function Eue(e) {
  return Oue(e)[0] || null;
}
var n3 = e3(Eue, t3);
function ur(e, t, n) {
  return function(a, i) {
    i === void 0 && (i = n);
    var o = e(a) + i;
    return t(o);
  };
}
function us(e) {
  return function(n) {
    return new Date(e(n).getTime() - 1);
  };
}
function hs(e, t) {
  return function(r) {
    return [e(r), t(r)];
  };
}
function Ye(e) {
  if (e instanceof Date)
    return e.getFullYear();
  if (typeof e == "number")
    return e;
  var t = parseInt(e, 10);
  if (typeof e == "string" && !isNaN(t))
    return t;
  throw new Error("Failed to get year from date: ".concat(e, "."));
}
function Hr(e) {
  if (e instanceof Date)
    return e.getMonth();
  throw new Error("Failed to get month from date: ".concat(e, "."));
}
function T1(e) {
  if (e instanceof Date)
    return e.getDate();
  throw new Error("Failed to get year from date: ".concat(e, "."));
}
function ps(e) {
  var t = Ye(e), n = t + (-t + 1) % 100, r = /* @__PURE__ */ new Date();
  return r.setFullYear(n, 0, 1), r.setHours(0, 0, 0, 0), r;
}
var Iue = ur(Ye, ps, -100), r3 = ur(Ye, ps, 100), k2 = us(r3), Due = ur(Ye, k2, -100), a3 = hs(ps, k2);
function Sa(e) {
  var t = Ye(e), n = t + (-t + 1) % 10, r = /* @__PURE__ */ new Date();
  return r.setFullYear(n, 0, 1), r.setHours(0, 0, 0, 0), r;
}
var i3 = ur(Ye, Sa, -10), b2 = ur(Ye, Sa, 10), N1 = us(b2), o3 = ur(Ye, N1, -10), s3 = hs(Sa, N1);
function fs(e) {
  var t = Ye(e), n = /* @__PURE__ */ new Date();
  return n.setFullYear(t, 0, 1), n.setHours(0, 0, 0, 0), n;
}
var c3 = ur(Ye, fs, -1), x2 = ur(Ye, fs, 1), P1 = us(x2), l3 = ur(Ye, P1, -1), Tue = hs(fs, P1);
function M2(e, t) {
  return function(r, a) {
    a === void 0 && (a = t);
    var i = Ye(r), o = Hr(r) + a, s = /* @__PURE__ */ new Date();
    return s.setFullYear(i, o, 1), s.setHours(0, 0, 0, 0), e(s);
  };
}
function Vi(e) {
  var t = Ye(e), n = Hr(e), r = /* @__PURE__ */ new Date();
  return r.setFullYear(t, n, 1), r.setHours(0, 0, 0, 0), r;
}
var d3 = M2(Vi, -1), w2 = M2(Vi, 1), ys = us(w2), u3 = M2(ys, -1), Nue = hs(Vi, ys);
function Pue(e, t) {
  return function(r, a) {
    a === void 0 && (a = t);
    var i = Ye(r), o = Hr(r), s = T1(r) + a, c = /* @__PURE__ */ new Date();
    return c.setFullYear(i, o, s), c.setHours(0, 0, 0, 0), e(c);
  };
}
function L1(e) {
  var t = Ye(e), n = Hr(e), r = T1(e), a = /* @__PURE__ */ new Date();
  return a.setFullYear(t, n, r), a.setHours(0, 0, 0, 0), a;
}
var Lue = Pue(L1, 1), C2 = us(Lue), Rue = hs(L1, C2);
function h3(e) {
  return T1(ys(e));
}
var Wi;
function Vue(e) {
  return $ue(e) || Hue(e) || Bue(e) || zue();
}
function zue() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Bue(e, t) {
  if (e) {
    if (typeof e == "string")
      return vh(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return vh(e, t);
  }
}
function Hue(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function $ue(e) {
  if (Array.isArray(e))
    return vh(e);
}
function vh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Yd(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var nt = {
  ARABIC: "Arabic",
  HEBREW: "Hebrew",
  ISO_8601: "ISO 8601",
  US: "US"
}, Vm = (Wi = {}, Yd(Wi, nt.US, ["en-CA", "en-US", "es-AR", "es-BO", "es-CL", "es-CO", "es-CR", "es-DO", "es-EC", "es-GT", "es-HN", "es-MX", "es-NI", "es-PA", "es-PE", "es-PR", "es-SV", "es-VE", "pt-BR"]), Yd(Wi, nt.ARABIC, [
  // ar-LB, ar-MA intentionally missing
  "ar",
  "ar-AE",
  "ar-BH",
  "ar-DZ",
  "ar-EG",
  "ar-IQ",
  "ar-JO",
  "ar-KW",
  "ar-LY",
  "ar-OM",
  "ar-QA",
  "ar-SA",
  "ar-SD",
  "ar-SY",
  "ar-YE",
  "dv",
  "dv-MV",
  "ps",
  "ps-AR"
]), Yd(Wi, nt.HEBREW, ["he", "he-IL"]), Wi), S2 = Vue(Array(7)).map(function(e, t) {
  return t;
}), Jd = /* @__PURE__ */ new Map();
function jue(e) {
  return function(t, n) {
    var r = t || n3();
    Jd.has(r) || Jd.set(r, /* @__PURE__ */ new Map());
    var a = Jd.get(r);
    return a.has(e) || a.set(e, new Intl.DateTimeFormat(r, e).format), a.get(e)(n);
  };
}
function Fue(e) {
  var t = new Date(e);
  return new Date(t.setHours(12));
}
function Aa(e) {
  return function(t, n) {
    return jue(e)(t, Fue(n));
  };
}
var Wue = {
  day: "numeric"
}, que = {
  day: "numeric",
  month: "long",
  year: "numeric"
}, _ue = {
  month: "long"
}, Gue = {
  month: "long",
  year: "numeric"
}, Zue = {
  weekday: "short"
}, Xue = {
  weekday: "long"
}, Uue = {
  year: "numeric"
}, Yue = Aa(Wue), Jue = Aa(que), Kue = Aa(_ue), p3 = Aa(Gue), Que = Aa(Zue), ehe = Aa(Xue), R1 = Aa(Uue), the = S2[0], nhe = S2[5], zm = S2[6];
function $o(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : nt.ISO_8601, n = e.getDay();
  switch (t) {
    case nt.ISO_8601:
      return (n + 6) % 7;
    case nt.ARABIC:
      return (n + 1) % 7;
    case nt.HEBREW:
    case nt.US:
      return n;
    default:
      throw new Error("Unsupported calendar type.");
  }
}
function rhe(e) {
  var t = ps(e);
  return Ye(t);
}
function ahe(e) {
  var t = Sa(e);
  return Ye(t);
}
function kh(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : nt.ISO_8601, n = Ye(e), r = Hr(e), a = e.getDate() - $o(e, t);
  return new Date(n, r, a);
}
function ihe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : nt.ISO_8601, n = t === nt.US ? nt.US : nt.ISO_8601, r = kh(e, t), a = Ye(e) + 1, i, o;
  do
    i = new Date(a, 0, n === nt.ISO_8601 ? 4 : 1), o = kh(i, t), a -= 1;
  while (e < o);
  return Math.round((r - o) / (864e5 * 7)) + 1;
}
function ca(e, t) {
  switch (e) {
    case "century":
      return ps(t);
    case "decade":
      return Sa(t);
    case "year":
      return fs(t);
    case "month":
      return Vi(t);
    case "day":
      return L1(t);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function ohe(e, t) {
  switch (e) {
    case "century":
      return Iue(t);
    case "decade":
      return i3(t);
    case "year":
      return c3(t);
    case "month":
      return d3(t);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function f3(e, t) {
  switch (e) {
    case "century":
      return r3(t);
    case "decade":
      return b2(t);
    case "year":
      return x2(t);
    case "month":
      return w2(t);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
var she = function(t, n) {
  switch (t) {
    case "decade":
      return i3(n, -100);
    case "year":
      return c3(n, -10);
    case "month":
      return d3(n, -12);
    default:
      throw new Error("Invalid rangeType: ".concat(t));
  }
}, che = function(t, n) {
  switch (t) {
    case "decade":
      return b2(n, 100);
    case "year":
      return x2(n, 10);
    case "month":
      return w2(n, 12);
    default:
      throw new Error("Invalid rangeType: ".concat(t));
  }
};
function y3(e, t) {
  switch (e) {
    case "century":
      return k2(t);
    case "decade":
      return N1(t);
    case "year":
      return P1(t);
    case "month":
      return ys(t);
    case "day":
      return C2(t);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function lhe(e, t) {
  switch (e) {
    case "century":
      return Due(t);
    case "decade":
      return o3(t);
    case "year":
      return l3(t);
    case "month":
      return u3(t);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
var dhe = function(t, n) {
  switch (t) {
    case "decade":
      return o3(n, -100);
    case "year":
      return l3(n, -10);
    case "month":
      return u3(n, -12);
    default:
      throw new Error("Invalid rangeType: ".concat(t));
  }
};
function Bm(e, t) {
  switch (e) {
    case "century":
      return a3(t);
    case "decade":
      return s3(t);
    case "year":
      return Tue(t);
    case "month":
      return Nue(t);
    case "day":
      return Rue(t);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function uhe(e, t, n) {
  var r = [t, n].sort(function(a, i) {
    return a - i;
  });
  return [ca(e, r[0]), y3(e, r[1])];
}
function m3(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : R1, n = arguments.length > 2 ? arguments[2] : void 0;
  return n.map(function(r) {
    return t(e, r);
  }).join(" – ");
}
function hhe(e, t, n) {
  return m3(e, t, a3(n));
}
function g3(e, t, n) {
  return m3(e, t, s3(n));
}
function v3(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : nt.ISO_8601, n = e.getDay();
  switch (t) {
    case nt.ARABIC:
    case nt.HEBREW:
      return n === nhe || n === zm;
    case nt.ISO_8601:
    case nt.US:
      return n === zm || n === the;
    default:
      throw new Error("Unsupported calendar type.");
  }
}
function wi(e) {
  "@babel/helpers - typeof";
  return wi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wi(e);
}
var phe = Object.values(nt), k3 = ["century", "decade", "year", "month"], ms = j.oneOf(phe), Dl = j.oneOfType([j.string, j.arrayOf(j.string)]), A2 = function(t, n, r) {
  var a = t[n];
  if (!a)
    return null;
  if (!(a instanceof Date))
    return new Error("Invalid prop `".concat(n, "` of type `").concat(wi(a), "` supplied to `").concat(r, "`, expected instance of `Date`."));
  var i = t.maxDate;
  return i && a > i ? new Error("Invalid prop `".concat(n, "` of type `").concat(wi(a), "` supplied to `").concat(r, "`, minDate cannot be larger than maxDate.")) : null;
}, O2 = function(t, n, r) {
  var a = t[n];
  if (!a)
    return null;
  if (!(a instanceof Date))
    return new Error("Invalid prop `".concat(n, "` of type `").concat(wi(a), "` supplied to `").concat(r, "`, expected instance of `Date`."));
  var i = t.minDate;
  return i && a < i ? new Error("Invalid prop `".concat(n, "` of type `").concat(wi(a), "` supplied to `").concat(r, "`, maxDate cannot be smaller than minDate.")) : null;
}, fhe = j.oneOfType([j.func, j.shape({
  current: j.any
})]), b3 = j.oneOfType([j.instanceOf(Date), j.arrayOf(j.instanceOf(Date))]), yhe = j.arrayOf(j.oneOf(k3)), jo = function(t, n, r) {
  var a = t[n], i = t.views, o = i || k3;
  return a !== void 0 && o.indexOf(a) === -1 ? new Error("Invalid prop `".concat(n, "` of value `").concat(a, "` supplied to `").concat(r, "`, expected one of [").concat(o.map(function(s) {
    return '"'.concat(s, '"');
  }).join(", "), "].")) : null;
};
jo.isRequired = function(e, t, n) {
  var r = e[t];
  return r ? jo(e, t, n) : new Error("The prop `".concat(t, "` is marked as required in `").concat(n, "`, but its value is `").concat(r, "`."));
};
var gs = {
  activeStartDate: j.instanceOf(Date).isRequired,
  hover: j.instanceOf(Date),
  locale: j.string,
  maxDate: O2,
  minDate: A2,
  onClick: j.func,
  onMouseOver: j.func,
  tileClassName: j.oneOfType([j.func, Dl]),
  tileContent: j.oneOfType([j.func, j.node]),
  value: b3,
  valueType: j.string
}, vs = {
  activeStartDate: j.instanceOf(Date).isRequired,
  classes: j.arrayOf(j.string).isRequired,
  date: j.instanceOf(Date).isRequired,
  locale: j.string,
  maxDate: O2,
  minDate: A2,
  onClick: j.func,
  onMouseOver: j.func,
  style: j.objectOf(j.oneOfType([j.string, j.number])),
  tileClassName: j.oneOfType([j.func, Dl]),
  tileContent: j.oneOfType([j.func, j.node]),
  tileDisabled: j.func
}, Cn = "react-calendar__navigation";
function x3(e) {
  var t = e.activeStartDate, n = e.drillUp, r = e.formatMonthYear, a = r === void 0 ? p3 : r, i = e.formatYear, o = i === void 0 ? R1 : i, s = e.locale, c = e.maxDate, l = e.minDate, u = e.navigationAriaLabel, h = u === void 0 ? "" : u, p = e.navigationAriaLive, f = e.navigationLabel, y = e.next2AriaLabel, m = y === void 0 ? "" : y, v = e.next2Label, k = v === void 0 ? "»" : v, b = e.nextAriaLabel, x = b === void 0 ? "" : b, g = e.nextLabel, w = g === void 0 ? "›" : g, M = e.prev2AriaLabel, S = M === void 0 ? "" : M, D = e.prev2Label, A = D === void 0 ? "«" : D, $ = e.prevAriaLabel, F = $ === void 0 ? "" : $, Z = e.prevLabel, B = Z === void 0 ? "‹" : Z, O = e.setActiveStartDate, I = e.showDoubleView, N = e.view, R = e.views, L = R.indexOf(N) > 0, W = N !== "century", E = ohe(N, t), q = W && she(N, t), z = f3(N, t), H = W && che(N, t), _ = function() {
    if (E.getFullYear() < 0)
      return !0;
    var te = lhe(N, t);
    return l && l >= te;
  }(), X = W && function() {
    if (q.getFullYear() < 0)
      return !0;
    var te = dhe(N, t);
    return l && l >= te;
  }(), P = c && c < z, Q = W && c && c < H;
  function U() {
    O(E, "prev");
  }
  function ae() {
    O(q, "prev2");
  }
  function ee() {
    O(z, "next");
  }
  function de() {
    O(H, "next2");
  }
  function Y(te) {
    var me = function() {
      switch (N) {
        case "century":
          return hhe(s, o, te);
        case "decade":
          return g3(s, o, te);
        case "year":
          return o(s, te);
        case "month":
          return a(s, te);
        default:
          throw new Error("Invalid view: ".concat(N, "."));
      }
    }();
    return f ? f({
      date: te,
      label: me,
      locale: s || n3(),
      view: N
    }) : me;
  }
  function re() {
    var te = "".concat(Cn, "__label");
    return /* @__PURE__ */ V.createElement("button", {
      "aria-label": h,
      "aria-live": p,
      className: te,
      disabled: !L,
      onClick: n,
      style: {
        flexGrow: 1
      },
      type: "button"
    }, /* @__PURE__ */ V.createElement("span", {
      className: "".concat(te, "__labelText ").concat(te, "__labelText--from")
    }, Y(t)), I && /* @__PURE__ */ V.createElement(V.Fragment, null, /* @__PURE__ */ V.createElement("span", {
      className: "".concat(te, "__divider")
    }, " – "), /* @__PURE__ */ V.createElement("span", {
      className: "".concat(te, "__labelText ").concat(te, "__labelText--to")
    }, Y(z))));
  }
  return /* @__PURE__ */ V.createElement("div", {
    className: Cn
  }, A !== null && W && /* @__PURE__ */ V.createElement("button", {
    "aria-label": S,
    className: "".concat(Cn, "__arrow ").concat(Cn, "__prev2-button"),
    disabled: X,
    onClick: ae,
    type: "button"
  }, A), B !== null && /* @__PURE__ */ V.createElement("button", {
    "aria-label": F,
    className: "".concat(Cn, "__arrow ").concat(Cn, "__prev-button"),
    disabled: _,
    onClick: U,
    type: "button"
  }, B), re(), w !== null && /* @__PURE__ */ V.createElement("button", {
    "aria-label": x,
    className: "".concat(Cn, "__arrow ").concat(Cn, "__next-button"),
    disabled: P,
    onClick: ee,
    type: "button"
  }, w), k !== null && W && /* @__PURE__ */ V.createElement("button", {
    "aria-label": m,
    className: "".concat(Cn, "__arrow ").concat(Cn, "__next2-button"),
    disabled: Q,
    onClick: de,
    type: "button"
  }, k));
}
x3.propTypes = {
  activeStartDate: j.instanceOf(Date).isRequired,
  drillUp: j.func.isRequired,
  formatMonthYear: j.func,
  formatYear: j.func,
  locale: j.string,
  maxDate: j.instanceOf(Date),
  minDate: j.instanceOf(Date),
  navigationAriaLabel: j.string,
  navigationAriaLive: j.string,
  navigationLabel: j.func,
  next2AriaLabel: j.string,
  next2Label: j.node,
  nextAriaLabel: j.string,
  nextLabel: j.node,
  prev2AriaLabel: j.string,
  prev2Label: j.node,
  prevAriaLabel: j.string,
  prevLabel: j.node,
  setActiveStartDate: j.func.isRequired,
  showDoubleView: j.bool,
  view: jo.isRequired,
  views: yhe.isRequired
};
var mhe = ["children", "className", "direction", "count", "offset", "style", "wrap"];
function bh() {
  return bh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bh.apply(this, arguments);
}
function Hm(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Kd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hm(Object(n), !0).forEach(function(r) {
      ghe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Hm(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ghe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function vhe(e, t) {
  if (e == null)
    return {};
  var n = khe(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function khe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function $m(e) {
  return "".concat(e, "%");
}
function V1(e) {
  var t = e.children, n = e.className, r = e.direction, a = e.count, i = e.offset, o = e.style, s = e.wrap, c = vhe(e, mhe);
  return /* @__PURE__ */ V.createElement("div", bh({
    className: n,
    style: Kd({
      display: "flex",
      flexDirection: r,
      flexWrap: s ? "wrap" : "no-wrap"
    }, o)
  }, c), V.Children.map(t, function(l, u) {
    return /* @__PURE__ */ V.cloneElement(l, Kd(Kd({}, l.props), {}, {
      style: {
        flexBasis: $m(100 / a),
        flexShrink: 0,
        flexGrow: 0,
        overflow: "hidden",
        marginLeft: i && u === 0 ? $m(100 * i / a) : null
      }
    }));
  }));
}
V1.propTypes = {
  children: j.node,
  className: j.string,
  count: j.number.isRequired,
  direction: j.string,
  offset: j.number,
  style: j.objectOf(j.oneOfType([j.string, j.number])),
  wrap: j.bool
};
function jm(e) {
  return whe(e) || Mhe(e) || xhe(e) || bhe();
}
function bhe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xhe(e, t) {
  if (e) {
    if (typeof e == "string")
      return xh(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return xh(e, t);
  }
}
function Mhe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function whe(e) {
  if (Array.isArray(e))
    return xh(e);
}
function xh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Che(e, t, n) {
  return t && t > e ? t : n && n < e ? n : e;
}
function Fo(e, t) {
  return t[0] <= e && t[1] >= e;
}
function She(e, t) {
  return e[0] <= t[0] && e[1] >= t[1];
}
function M3(e, t) {
  return Fo(e[0], t) || Fo(e[1], t);
}
function Fm(e, t, n) {
  var r = M3(t, e), a = [];
  if (r) {
    a.push(n);
    var i = Fo(e[0], t), o = Fo(e[1], t);
    i && a.push("".concat(n, "Start")), o && a.push("".concat(n, "End")), i && o && a.push("".concat(n, "BothEnds"));
  }
  return a;
}
function Ahe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.value, n = e.valueType, r = e.date, a = e.dateType, i = e.hover, o = "react-calendar__tile", s = [o];
  if (!r)
    return s;
  if (!Array.isArray(r) && !a)
    throw new Error("getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.");
  var c = /* @__PURE__ */ new Date(), l = Array.isArray(r) ? r : Bm(a, r);
  if (Fo(c, l) && s.push("".concat(o, "--now")), !t)
    return s;
  if (!Array.isArray(t) && !n)
    throw new Error("getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.");
  var u = Array.isArray(t) ? t : Bm(n, t);
  She(u, l) ? s.push("".concat(o, "--active")) : M3(u, l) && s.push("".concat(o, "--hasActive"));
  var h = Fm(u, l, "".concat(o, "--range"));
  s.push.apply(s, jm(h));
  var p = [].concat(t);
  if (i && p.length === 1) {
    var f = i > u[0] ? [u[0], i] : [i, u[0]], y = Fm(f, l, "".concat(o, "--hover"));
    s.push.apply(s, jm(y));
  }
  return s;
}
var Ohe = ["className", "count", "dateTransform", "dateType", "end", "hover", "offset", "start", "step", "tile", "value", "valueType"];
function Wm(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function qm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wm(Object(n), !0).forEach(function(r) {
      Ehe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wm(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ehe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Mh() {
  return Mh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mh.apply(this, arguments);
}
function Ihe(e, t) {
  if (e == null)
    return {};
  var n = Dhe(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Dhe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function ks(e) {
  for (var t = e.className, n = e.count, r = n === void 0 ? 3 : n, a = e.dateTransform, i = e.dateType, o = e.end, s = e.hover, c = e.offset, l = e.start, u = e.step, h = u === void 0 ? 1 : u, p = e.tile, f = e.value, y = e.valueType, m = Ihe(e, Ohe), v = [], k = l; k <= o; k += h) {
    var b = a(k);
    v.push(/* @__PURE__ */ V.createElement(p, Mh({
      key: b.getTime(),
      classes: Ahe({
        value: f,
        valueType: y,
        date: b,
        dateType: i,
        hover: s
      }),
      date: b,
      point: k
    }, m)));
  }
  return /* @__PURE__ */ V.createElement(V1, {
    className: t,
    count: r,
    offset: c,
    wrap: !0
  }, v);
}
ks.propTypes = qm(qm({}, gs), {}, {
  activeStartDate: j.instanceOf(Date),
  count: j.number,
  dateTransform: j.func.isRequired,
  dateType: j.string,
  offset: j.number,
  step: j.number,
  tile: j.func.isRequired
});
function wh(e) {
  "@babel/helpers - typeof";
  return wh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wh(e);
}
function _m(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Gm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _m(Object(n), !0).forEach(function(r) {
      C3(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _m(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function The(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Zm(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Nhe(e, t, n) {
  return t && Zm(e.prototype, t), n && Zm(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Phe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ch(e, t);
}
function Ch(e, t) {
  return Ch = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, Ch(e, t);
}
function Lhe(e) {
  var t = Vhe();
  return function() {
    var r = Tl(e), a;
    if (t) {
      var i = Tl(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return Rhe(this, a);
  };
}
function Rhe(e, t) {
  if (t && (wh(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return w3(e);
}
function w3(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Vhe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Tl(e) {
  return Tl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Tl(e);
}
function C3(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Xm(e, t) {
  return e && !t || !e && t || e && t && e.getTime() !== t.getTime();
}
function Um(e, t) {
  var n = e.activeStartDate, r = e.date, a = e.view;
  return typeof t == "function" ? t({
    activeStartDate: n,
    date: r,
    view: a
  }) : t;
}
var bs = /* @__PURE__ */ function(e) {
  Phe(n, e);
  var t = Lhe(n);
  function n() {
    var r;
    The(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), C3(w3(r), "state", {}), r;
  }
  return Nhe(n, [{
    key: "render",
    value: function() {
      var a = this.props, i = a.activeStartDate, o = a.children, s = a.classes, c = a.date, l = a.formatAbbr, u = a.locale, h = a.maxDate, p = a.maxDateTransform, f = a.minDate, y = a.minDateTransform, m = a.onClick, v = a.onMouseOver, k = a.style, b = a.tileDisabled, x = a.view, g = this.state, w = g.tileClassName, M = g.tileContent;
      return /* @__PURE__ */ V.createElement("button", {
        className: E1(s, w),
        disabled: f && y(f) > c || h && p(h) < c || b && b({
          activeStartDate: i,
          date: c,
          view: x
        }),
        onClick: m && function(S) {
          return m(c, S);
        },
        onFocus: v && function() {
          return v(c);
        },
        onMouseOver: v && function() {
          return v(c);
        },
        style: k,
        type: "button"
      }, l ? /* @__PURE__ */ V.createElement("abbr", {
        "aria-label": l(u, c)
      }, o) : o, M);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(a, i) {
      var o = a.activeStartDate, s = a.tileClassName, c = a.tileContent, l = {};
      return (s !== i.tileClassNameProps || Xm(o, i.activeStartDateProps)) && (l.tileClassName = Um(a, s), l.tileClassNameProps = s), (c !== i.tileContentProps || Xm(o, i.activeStartDateProps)) && (l.tileContent = Um(a, c), l.tileContentProps = c), l.activeStartDateProps = o, l;
    }
  }]), n;
}(Si);
bs.propTypes = Gm(Gm({}, vs), {}, {
  children: j.node.isRequired,
  formatAbbr: j.func,
  maxDateTransform: j.func.isRequired,
  minDateTransform: j.func.isRequired
});
var zhe = ["classes", "formatYear"];
function Ym(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Jm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ym(Object(n), !0).forEach(function(r) {
      Bhe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ym(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Bhe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Sh() {
  return Sh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sh.apply(this, arguments);
}
function Hhe(e, t) {
  if (e == null)
    return {};
  var n = $he(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function $he(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var jhe = "react-calendar__century-view__decades__decade";
function S3(e) {
  var t = e.classes, n = e.formatYear, r = n === void 0 ? R1 : n, a = Hhe(e, zhe), i = a.date, o = a.locale;
  return /* @__PURE__ */ V.createElement(bs, Sh({}, a, {
    classes: [].concat(t, jhe),
    maxDateTransform: N1,
    minDateTransform: Sa,
    view: "century"
  }), g3(o, r, i));
}
S3.propTypes = Jm(Jm({}, vs), {}, {
  formatYear: j.func
});
function Km(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Fhe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Km(Object(n), !0).forEach(function(r) {
      Whe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Km(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Whe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ah() {
  return Ah = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ah.apply(this, arguments);
}
function A3(e) {
  var t = e.activeStartDate, n = rhe(t), r = n + 99;
  return /* @__PURE__ */ V.createElement(ks, Ah({}, e, {
    className: "react-calendar__century-view__decades",
    dateTransform: Sa,
    dateType: "decade",
    end: r,
    start: n,
    step: 10,
    tile: S3
  }));
}
A3.propTypes = Fhe({}, gs);
function qhe(e) {
  function t() {
    return /* @__PURE__ */ V.createElement(A3, e);
  }
  return /* @__PURE__ */ V.createElement("div", {
    className: "react-calendar__century-view"
  }, t());
}
var _he = ["classes", "formatYear"];
function Qm(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function eg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Qm(Object(n), !0).forEach(function(r) {
      Ghe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Qm(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ghe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Oh() {
  return Oh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Oh.apply(this, arguments);
}
function Zhe(e, t) {
  if (e == null)
    return {};
  var n = Xhe(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Xhe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var Uhe = "react-calendar__decade-view__years__year";
function O3(e) {
  var t = e.classes, n = e.formatYear, r = n === void 0 ? R1 : n, a = Zhe(e, _he), i = a.date, o = a.locale;
  return /* @__PURE__ */ V.createElement(bs, Oh({}, a, {
    classes: [].concat(t, Uhe),
    maxDateTransform: P1,
    minDateTransform: fs,
    view: "decade"
  }), r(o, i));
}
O3.propTypes = eg(eg({}, vs), {}, {
  formatYear: j.func
});
function tg(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Yhe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tg(Object(n), !0).forEach(function(r) {
      Jhe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : tg(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Jhe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Eh() {
  return Eh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Eh.apply(this, arguments);
}
function E3(e) {
  var t = e.activeStartDate, n = ahe(t), r = n + 9;
  return /* @__PURE__ */ V.createElement(ks, Eh({}, e, {
    className: "react-calendar__decade-view__years",
    dateTransform: function(i) {
      var o = /* @__PURE__ */ new Date();
      return o.setFullYear(i, 0, 1), o.setHours(0, 0, 0, 0), o;
    },
    dateType: "year",
    end: r,
    start: n,
    tile: O3
  }));
}
E3.propTypes = Yhe({}, gs);
function Khe(e) {
  function t() {
    return /* @__PURE__ */ V.createElement(E3, e);
  }
  return /* @__PURE__ */ V.createElement("div", {
    className: "react-calendar__decade-view"
  }, t());
}
var Qhe = ["classes", "formatMonth", "formatMonthYear"];
function ng(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function rg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ng(Object(n), !0).forEach(function(r) {
      epe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ng(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function epe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ih() {
  return Ih = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ih.apply(this, arguments);
}
function tpe(e, t) {
  if (e == null)
    return {};
  var n = npe(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function npe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var rpe = "react-calendar__year-view__months__month";
function I3(e) {
  var t = e.classes, n = e.formatMonth, r = n === void 0 ? Kue : n, a = e.formatMonthYear, i = a === void 0 ? p3 : a, o = tpe(e, Qhe), s = o.date, c = o.locale;
  return /* @__PURE__ */ V.createElement(bs, Ih({}, o, {
    classes: [].concat(t, rpe),
    formatAbbr: i,
    maxDateTransform: ys,
    minDateTransform: Vi,
    view: "year"
  }), r(c, s));
}
I3.propTypes = rg(rg({}, vs), {}, {
  formatMonth: j.func,
  formatMonthYear: j.func
});
function ag(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ig(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ag(Object(n), !0).forEach(function(r) {
      ape(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ag(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ape(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Dh() {
  return Dh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Dh.apply(this, arguments);
}
function D3(e) {
  var t = e.activeStartDate, n = 0, r = 11, a = Ye(t);
  return /* @__PURE__ */ V.createElement(ks, Dh({}, e, {
    className: "react-calendar__year-view__months",
    dateTransform: function(o) {
      var s = /* @__PURE__ */ new Date();
      return s.setFullYear(a, o, 1), s.setHours(0, 0, 0, 0), s;
    },
    dateType: "month",
    end: r,
    start: n,
    tile: I3
  }));
}
D3.propTypes = ig(ig({}, gs), {}, {
  locale: j.string
});
function ipe(e) {
  function t() {
    return /* @__PURE__ */ V.createElement(D3, e);
  }
  return /* @__PURE__ */ V.createElement("div", {
    className: "react-calendar__year-view"
  }, t());
}
var ope = ["formatDay", "formatLongDate", "calendarType", "classes", "currentMonthIndex"];
function og(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function sg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? og(Object(n), !0).forEach(function(r) {
      spe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : og(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function spe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Th() {
  return Th = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Th.apply(this, arguments);
}
function cpe(e, t) {
  if (e == null)
    return {};
  var n = lpe(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function lpe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var Qd = "react-calendar__month-view__days__day";
function T3(e) {
  var t = e.formatDay, n = t === void 0 ? Yue : t, r = e.formatLongDate, a = r === void 0 ? Jue : r, i = e.calendarType, o = e.classes, s = e.currentMonthIndex, c = cpe(e, ope), l = c.date, u = c.locale;
  return /* @__PURE__ */ V.createElement(bs, Th({}, c, {
    classes: [].concat(o, Qd, v3(l, i) ? "".concat(Qd, "--weekend") : null, l.getMonth() !== s ? "".concat(Qd, "--neighboringMonth") : null),
    formatAbbr: a,
    maxDateTransform: C2,
    minDateTransform: L1,
    view: "month"
  }), n(u, l));
}
T3.propTypes = sg(sg({}, vs), {}, {
  currentMonthIndex: j.number.isRequired,
  formatDay: j.func,
  formatLongDate: j.func
});
var dpe = ["showFixedNumberOfWeeks", "showNeighboringMonth"];
function cg(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function upe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cg(Object(n), !0).forEach(function(r) {
      hpe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cg(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function hpe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Nh() {
  return Nh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nh.apply(this, arguments);
}
function ppe(e, t) {
  if (e == null)
    return {};
  var n = fpe(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function fpe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function N3(e) {
  var t = e.activeStartDate, n = e.calendarType, r = e.showFixedNumberOfWeeks, a = e.showNeighboringMonth, i = ppe(e, dpe), o = Ye(t), s = Hr(t), c = r || a, l = $o(t, n), u = c ? 0 : l, h = (c ? -l : 0) + 1, p = function() {
    if (r)
      return h + 6 * 7 - 1;
    var f = h3(t);
    if (a) {
      var y = /* @__PURE__ */ new Date();
      y.setFullYear(o, s, f), y.setHours(0, 0, 0, 0);
      var m = 7 - $o(y, n) - 1;
      return f + m;
    }
    return f;
  }();
  return /* @__PURE__ */ V.createElement(ks, Nh({}, i, {
    className: "react-calendar__month-view__days",
    count: 7,
    currentMonthIndex: s,
    dateTransform: function(y) {
      var m = /* @__PURE__ */ new Date();
      return m.setFullYear(o, s, y), m.setHours(0, 0, 0, 0), m;
    },
    dateType: "day",
    end: p,
    offset: u,
    start: h,
    tile: T3
  }));
}
N3.propTypes = upe({
  calendarType: ms.isRequired,
  showFixedNumberOfWeeks: j.bool,
  showNeighboringMonth: j.bool
}, gs);
var P3 = "react-calendar__month-view__weekdays", lg = "".concat(P3, "__weekday");
function L3(e) {
  for (var t = e.calendarType, n = e.formatShortWeekday, r = n === void 0 ? Que : n, a = e.formatWeekday, i = a === void 0 ? ehe : a, o = e.locale, s = e.onMouseLeave, c = /* @__PURE__ */ new Date(), l = Vi(c), u = Ye(l), h = Hr(l), p = [], f = 1; f <= 7; f += 1) {
    var y = new Date(u, h, f - $o(l, t)), m = i(o, y);
    p.push(/* @__PURE__ */ V.createElement("div", {
      key: f,
      className: E1(lg, v3(y, t) && "".concat(lg, "--weekend"))
    }, /* @__PURE__ */ V.createElement("abbr", {
      "aria-label": m,
      title: m
    }, r(o, y).replace(".", ""))));
  }
  return /* @__PURE__ */ V.createElement(V1, {
    className: P3,
    count: 7,
    onFocus: s,
    onMouseOver: s
  }, p);
}
L3.propTypes = {
  calendarType: ms.isRequired,
  formatShortWeekday: j.func,
  formatWeekday: j.func,
  locale: j.string,
  onMouseLeave: j.func
};
var ype = ["date", "onClickWeekNumber", "weekNumber"];
function Ph() {
  return Ph = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ph.apply(this, arguments);
}
function dg(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function mpe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dg(Object(n), !0).forEach(function(r) {
      gpe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : dg(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function gpe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function vpe(e, t) {
  if (e == null)
    return {};
  var n = kpe(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function kpe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var bpe = "react-calendar__tile";
function R3(e) {
  var t = e.date, n = e.onClickWeekNumber, r = e.weekNumber, a = vpe(e, ype), i = mpe({
    className: bpe
  }, a), o = /* @__PURE__ */ V.createElement("span", null, r);
  return n ? /* @__PURE__ */ V.createElement("button", Ph({}, i, {
    onClick: function(c) {
      return n(r, t, c);
    },
    type: "button"
  }), o) : /* @__PURE__ */ V.createElement("div", i, o);
}
R3.propTypes = {
  date: j.instanceOf(Date).isRequired,
  onClickWeekNumber: j.func,
  weekNumber: j.node.isRequired
};
function V3(e) {
  var t = e.activeStartDate, n = e.calendarType, r = e.onClickWeekNumber, a = e.onMouseLeave, i = e.showFixedNumberOfWeeks, o = function() {
    if (i)
      return 6;
    var l = h3(t), u = $o(t, n), h = l - (7 - u);
    return 1 + Math.ceil(h / 7);
  }(), s = function() {
    for (var l = Ye(t), u = Hr(t), h = T1(t), p = [], f = 0; f < o; f += 1)
      p.push(kh(new Date(l, u, h + f * 7), n));
    return p;
  }(), c = s.map(function(l) {
    return ihe(l, n);
  });
  return /* @__PURE__ */ V.createElement(V1, {
    className: "react-calendar__month-view__weekNumbers",
    count: o,
    direction: "column",
    onFocus: a,
    onMouseOver: a,
    style: {
      flexBasis: "calc(100% * (1 / 8)",
      flexShrink: 0
    }
  }, c.map(function(l, u) {
    return /* @__PURE__ */ V.createElement(R3, {
      key: l,
      date: s[u],
      onClickWeekNumber: r,
      weekNumber: l
    });
  }));
}
V3.propTypes = {
  activeStartDate: j.instanceOf(Date).isRequired,
  calendarType: ms.isRequired,
  onClickWeekNumber: j.func,
  onMouseLeave: j.func,
  showFixedNumberOfWeeks: j.bool
};
var xpe = ["calendarType", "formatShortWeekday", "formatWeekday", "onClickWeekNumber", "showWeekNumbers"];
function Lh() {
  return Lh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Lh.apply(this, arguments);
}
function Mpe(e, t) {
  if (e == null)
    return {};
  var n = wpe(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function wpe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function Cpe(e) {
  return Object.keys(Vm).find(function(t) {
    return Vm[t].includes(e);
  }) || nt.ISO_8601;
}
function z3(e) {
  var t = e.activeStartDate, n = e.locale, r = e.onMouseLeave, a = e.showFixedNumberOfWeeks, i = e.calendarType, o = i === void 0 ? Cpe(n) : i, s = e.formatShortWeekday, c = e.formatWeekday, l = e.onClickWeekNumber, u = e.showWeekNumbers, h = Mpe(e, xpe);
  function p() {
    return /* @__PURE__ */ V.createElement(L3, {
      calendarType: o,
      formatShortWeekday: s,
      formatWeekday: c,
      locale: n,
      onMouseLeave: r
    });
  }
  function f() {
    return u ? /* @__PURE__ */ V.createElement(V3, {
      activeStartDate: t,
      calendarType: o,
      onClickWeekNumber: l,
      onMouseLeave: r,
      showFixedNumberOfWeeks: a
    }) : null;
  }
  function y() {
    return /* @__PURE__ */ V.createElement(N3, Lh({
      calendarType: o
    }, h));
  }
  var m = "react-calendar__month-view";
  return /* @__PURE__ */ V.createElement("div", {
    className: E1(m, u ? "".concat(m, "--weekNumbers") : "")
  }, /* @__PURE__ */ V.createElement("div", {
    style: {
      display: "flex",
      alignItems: "flex-end"
    }
  }, f(), /* @__PURE__ */ V.createElement("div", {
    style: {
      flexGrow: 1,
      width: "100%"
    }
  }, p(), y())));
}
z3.propTypes = {
  activeStartDate: j.instanceOf(Date).isRequired,
  calendarType: ms,
  formatShortWeekday: j.func,
  formatWeekday: j.func,
  locale: j.string,
  onClickWeekNumber: j.func,
  onMouseLeave: j.func,
  showFixedNumberOfWeeks: j.bool,
  showWeekNumbers: j.bool
};
var Spe = ["activeStartDate", "defaultActiveStartDate", "defaultValue", "defaultView", "maxDetail", "minDetail", "value", "view"];
function Ua() {
  return Ua = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ua.apply(this, arguments);
}
function Wo(e) {
  "@babel/helpers - typeof";
  return Wo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Wo(e);
}
function Ape(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ug(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Ope(e, t, n) {
  return t && ug(e.prototype, t), n && ug(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Epe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Rh(e, t);
}
function Rh(e, t) {
  return Rh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, Rh(e, t);
}
function Ipe(e) {
  var t = Tpe();
  return function() {
    var r = Nl(e), a;
    if (t) {
      var i = Nl(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return Dpe(this, a);
  };
}
function Dpe(e, t) {
  if (t && (Wo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return xt(e);
}
function xt(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Tpe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Nl(e) {
  return Nl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Nl(e);
}
function hg(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Vh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hg(Object(n), !0).forEach(function(r) {
      Sn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : hg(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Sn(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Npe(e, t) {
  if (e == null)
    return {};
  var n = Ppe(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Ppe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function Lpe(e) {
  return Bpe(e) || zpe(e) || Vpe(e) || Rpe();
}
function Rpe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Vpe(e, t) {
  if (e) {
    if (typeof e == "string")
      return zh(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return zh(e, t);
  }
}
function zpe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Bpe(e) {
  if (Array.isArray(e))
    return zh(e);
}
function zh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var E2 = /* @__PURE__ */ new Date();
E2.setFullYear(1, 0, 1);
E2.setHours(0, 0, 0, 0);
var Hpe = /* @__PURE__ */ new Date(864e13), Ks = "react-calendar", la = ["century", "decade", "year", "month"], $pe = [].concat(Lpe(la.slice(1)), ["day"]);
function jpe(e) {
  return e instanceof Date ? e : new Date(e);
}
function B3(e, t) {
  return la.slice(la.indexOf(e), la.indexOf(t) + 1);
}
function Fpe(e, t, n) {
  var r = B3(t, n);
  return r.indexOf(e) !== -1;
}
function I2(e, t, n) {
  return Fpe(e, t, n) ? e : n;
}
function H3(e) {
  return $pe[la.indexOf(e)];
}
function Wpe(e, t) {
  if (!e)
    return null;
  var n = Array.isArray(e) && e.length === 2 ? e[t] : e;
  if (!n)
    return null;
  var r = jpe(n);
  if (isNaN(r.getTime()))
    throw new Error("Invalid date: ".concat(e));
  return r;
}
function $3(e, t) {
  var n = e.value, r = e.minDate, a = e.maxDate, i = e.maxDetail, o = Wpe(n, t);
  if (!o)
    return null;
  var s = H3(i), c = [ca, y3][t](s, o);
  return Che(c, r, a);
}
var D2 = function(t) {
  return $3(t, 0);
}, j3 = function(t) {
  return $3(t, 1);
}, qpe = function(t) {
  var n = t.value;
  return Array.isArray(n) ? n : [D2, j3].map(function(r) {
    return r(t);
  });
};
function F3(e) {
  var t = e.maxDate, n = e.maxDetail, r = e.minDate, a = e.minDetail, i = e.value, o = e.view, s = I2(o, a, n), c = D2({
    value: i,
    minDate: r,
    maxDate: t,
    maxDetail: n
  }) || /* @__PURE__ */ new Date();
  return ca(s, c);
}
function _pe(e) {
  var t = e.activeStartDate, n = e.defaultActiveStartDate, r = e.defaultValue, a = e.defaultView, i = e.maxDetail, o = e.minDetail, s = e.value, c = e.view, l = Npe(e, Spe), u = I2(c, o, i), h = t || n;
  return h ? ca(u, h) : F3(Vh({
    maxDetail: i,
    minDetail: o,
    value: s || r,
    view: c || a
  }, l));
}
var eu = function(t) {
  return t && [].concat(t).length === 1;
}, T2 = /* @__PURE__ */ function(e) {
  Epe(n, e);
  var t = Ipe(n);
  function n() {
    var r;
    Ape(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Sn(xt(r), "state", {
      activeStartDate: r.props.defaultActiveStartDate,
      value: r.props.defaultValue,
      view: r.props.defaultView
    }), Sn(xt(r), "setStateAndCallCallbacks", function(s, c, l) {
      var u = xt(r), h = u.activeStartDate, p = u.view, f = r.props, y = f.allowPartialRange, m = f.onActiveStartDateChange, v = f.onChange, k = f.onViewChange, b = f.selectRange, x = {
        activeStartDate: h,
        view: p
      };
      r.setState(s, function() {
        var g = {
          action: s.action,
          activeStartDate: s.activeStartDate || r.activeStartDate,
          value: s.value || r.value,
          view: s.view || r.view
        };
        function w(S) {
          return (
            // Key must exist, and…
            S in s && // …key changed from undefined to defined or the other way around, or…
            (Wo(s[S]) !== Wo(x[S]) || // …value changed.
            (s[S] instanceof Date ? s[S].getTime() !== x[S].getTime() : s[S] !== x[S]))
          );
        }
        if (w("activeStartDate") && m && m(g), w("view") && k && k(g), w("value") && v)
          if (b) {
            var M = eu(s.value);
            M ? y && v([s.value], c) : v(s.value, c);
          } else
            v(s.value, c);
        l && l(g);
      });
    }), Sn(xt(r), "setActiveStartDate", function(s, c) {
      r.setStateAndCallCallbacks({
        action: c,
        activeStartDate: s
      });
    }), Sn(xt(r), "drillDown", function(s, c) {
      if (r.drillDownAvailable) {
        r.onClickTile(s, c);
        var l = xt(r), u = l.view, h = l.views, p = r.props.onDrillDown, f = h[h.indexOf(u) + 1];
        r.setStateAndCallCallbacks({
          action: "drillDown",
          activeStartDate: s,
          view: f
        }, void 0, p);
      }
    }), Sn(xt(r), "drillUp", function() {
      if (r.drillUpAvailable) {
        var s = xt(r), c = s.activeStartDate, l = s.view, u = s.views, h = r.props.onDrillUp, p = u[u.indexOf(l) - 1], f = ca(p, c);
        r.setStateAndCallCallbacks({
          action: "drillUp",
          activeStartDate: f,
          view: p
        }, void 0, h);
      }
    }), Sn(xt(r), "onChange", function(s, c) {
      var l = xt(r), u = l.value, h = r.props, p = h.goToRangeStartOnSelect, f = h.selectRange;
      r.onClickTile(s, c);
      var y = f && !eu(u), m;
      if (f) {
        var v = xt(r), k = v.valueType;
        y ? m = ca(k, s) : m = uhe(k, u, s);
      } else
        m = r.getProcessedValue(s);
      var b = (
        // Range selection turned off
        !f || // Range selection turned on, first value
        y || // Range selection turned on, second value, goToRangeStartOnSelect toggled on
        p ? F3(Vh(Vh({}, r.props), {}, {
          value: m
        })) : null
      );
      c.persist(), r.setStateAndCallCallbacks({
        action: "onChange",
        activeStartDate: b,
        value: m
      }, c);
    }), Sn(xt(r), "onClickTile", function(s, c) {
      var l = xt(r), u = l.view, h = r.props, p = h.onClickDay, f = h.onClickDecade, y = h.onClickMonth, m = h.onClickYear, v = function() {
        switch (u) {
          case "century":
            return f;
          case "decade":
            return m;
          case "year":
            return y;
          case "month":
            return p;
          default:
            throw new Error("Invalid view: ".concat(u, "."));
        }
      }();
      v && v(s, c);
    }), Sn(xt(r), "onMouseOver", function(s) {
      r.setState(function(c) {
        return c.hover && c.hover.getTime() === s.getTime() ? null : {
          hover: s
        };
      });
    }), Sn(xt(r), "onMouseLeave", function() {
      r.setState({
        hover: null
      });
    }), r;
  }
  return Ope(n, [{
    key: "activeStartDate",
    get: function() {
      var a = this.props.activeStartDate, i = this.state.activeStartDate;
      return a || i || _pe(this.props);
    }
  }, {
    key: "value",
    get: function() {
      var a = this.props, i = a.selectRange, o = a.value, s = this.state.value;
      return i && eu(s) ? s : o !== void 0 ? o : s;
    }
  }, {
    key: "valueType",
    get: function() {
      var a = this.props.maxDetail;
      return H3(a);
    }
  }, {
    key: "view",
    get: function() {
      var a = this.props, i = a.minDetail, o = a.maxDetail, s = a.view, c = this.state.view;
      return I2(s || c, i, o);
    }
  }, {
    key: "views",
    get: function() {
      var a = this.props, i = a.minDetail, o = a.maxDetail;
      return B3(i, o);
    }
  }, {
    key: "hover",
    get: function() {
      var a = this.props.selectRange, i = this.state.hover;
      return a ? i : null;
    }
  }, {
    key: "drillDownAvailable",
    get: function() {
      var a = this.view, i = this.views;
      return i.indexOf(a) < i.length - 1;
    }
  }, {
    key: "drillUpAvailable",
    get: function() {
      var a = this.view, i = this.views;
      return i.indexOf(a) > 0;
    }
    /**
     * Gets current value in a desired format.
     */
  }, {
    key: "getProcessedValue",
    value: function(a) {
      var i = this.props, o = i.minDate, s = i.maxDate, c = i.maxDetail, l = i.returnValue, u = function() {
        switch (l) {
          case "start":
            return D2;
          case "end":
            return j3;
          case "range":
            return qpe;
          default:
            throw new Error("Invalid returnValue.");
        }
      }();
      return u({
        value: a,
        minDate: o,
        maxDate: s,
        maxDetail: c
      });
    }
  }, {
    key: "renderContent",
    value: function(a) {
      var i = this.activeStartDate, o = this.onMouseOver, s = this.valueType, c = this.value, l = this.view, u = this.props, h = u.calendarType, p = u.locale, f = u.maxDate, y = u.minDate, m = u.selectRange, v = u.tileClassName, k = u.tileContent, b = u.tileDisabled, x = this.hover, g = a ? f3(l, i) : ca(l, i), w = this.drillDownAvailable ? this.drillDown : this.onChange, M = {
        activeStartDate: g,
        hover: x,
        locale: p,
        maxDate: f,
        minDate: y,
        onClick: w,
        onMouseOver: m ? o : null,
        tileClassName: v,
        tileContent: k,
        tileDisabled: b,
        value: c,
        valueType: s
      };
      switch (l) {
        case "century": {
          var S = this.props.formatYear;
          return /* @__PURE__ */ V.createElement(qhe, Ua({
            formatYear: S
          }, M));
        }
        case "decade": {
          var D = this.props.formatYear;
          return /* @__PURE__ */ V.createElement(Khe, Ua({
            formatYear: D
          }, M));
        }
        case "year": {
          var A = this.props, $ = A.formatMonth, F = A.formatMonthYear;
          return /* @__PURE__ */ V.createElement(ipe, Ua({
            formatMonth: $,
            formatMonthYear: F
          }, M));
        }
        case "month": {
          var Z = this.props, B = Z.formatDay, O = Z.formatLongDate, I = Z.formatShortWeekday, N = Z.formatWeekday, R = Z.onClickWeekNumber, L = Z.showDoubleView, W = Z.showFixedNumberOfWeeks, E = Z.showNeighboringMonth, q = Z.showWeekNumbers, z = this.onMouseLeave;
          return /* @__PURE__ */ V.createElement(z3, Ua({
            calendarType: h,
            formatDay: B,
            formatLongDate: O,
            formatShortWeekday: I,
            formatWeekday: N,
            onClickWeekNumber: R,
            onMouseLeave: m ? z : null,
            showFixedNumberOfWeeks: typeof W < "u" ? W : L,
            showNeighboringMonth: E,
            showWeekNumbers: q
          }, M));
        }
        default:
          throw new Error("Invalid view: ".concat(l, "."));
      }
    }
  }, {
    key: "renderNavigation",
    value: function() {
      var a = this.props.showNavigation;
      if (!a)
        return null;
      var i = this.activeStartDate, o = this.view, s = this.views, c = this.props, l = c.formatMonthYear, u = c.formatYear, h = c.locale, p = c.maxDate, f = c.minDate, y = c.navigationAriaLabel, m = c.navigationAriaLive, v = c.navigationLabel, k = c.next2AriaLabel, b = c.next2Label, x = c.nextAriaLabel, g = c.nextLabel, w = c.prev2AriaLabel, M = c.prev2Label, S = c.prevAriaLabel, D = c.prevLabel, A = c.showDoubleView;
      return /* @__PURE__ */ V.createElement(x3, {
        activeStartDate: i,
        drillUp: this.drillUp,
        formatMonthYear: l,
        formatYear: u,
        locale: h,
        maxDate: p,
        minDate: f,
        navigationAriaLabel: y,
        navigationAriaLive: m,
        navigationLabel: v,
        next2AriaLabel: k,
        next2Label: b,
        nextAriaLabel: x,
        nextLabel: g,
        prev2AriaLabel: w,
        prev2Label: M,
        prevAriaLabel: S,
        prevLabel: D,
        setActiveStartDate: this.setActiveStartDate,
        showDoubleView: A,
        view: o,
        views: s
      });
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props, i = a.className, o = a.inputRef, s = a.selectRange, c = a.showDoubleView, l = this.onMouseLeave, u = this.value, h = [].concat(u);
      return /* @__PURE__ */ V.createElement("div", {
        className: E1(Ks, s && h.length === 1 && "".concat(Ks, "--selectRange"), c && "".concat(Ks, "--doubleView"), i),
        ref: o
      }, this.renderNavigation(), /* @__PURE__ */ V.createElement("div", {
        className: "".concat(Ks, "__viewContainer"),
        onBlur: s ? l : null,
        onMouseLeave: s ? l : null
      }, this.renderContent(), c && this.renderContent(!0)));
    }
  }]), n;
}(Si);
T2.defaultProps = {
  goToRangeStartOnSelect: !0,
  maxDate: Hpe,
  maxDetail: "month",
  minDate: E2,
  minDetail: "century",
  returnValue: "start",
  showNavigation: !0,
  showNeighboringMonth: !0
};
var pg = j.instanceOf(Date), fg = j.oneOfType([j.string, b3]);
T2.propTypes = {
  activeStartDate: pg,
  allowPartialRange: j.bool,
  calendarType: ms,
  className: Dl,
  defaultActiveStartDate: pg,
  defaultValue: fg,
  defaultView: jo,
  formatDay: j.func,
  formatLongDate: j.func,
  formatMonth: j.func,
  formatMonthYear: j.func,
  formatShortWeekday: j.func,
  formatWeekday: j.func,
  formatYear: j.func,
  goToRangeStartOnSelect: j.bool,
  inputRef: fhe,
  locale: j.string,
  maxDate: O2,
  maxDetail: j.oneOf(la),
  minDate: A2,
  minDetail: j.oneOf(la),
  navigationAriaLabel: j.string,
  navigationAriaLive: j.oneOf(["off", "polite", "assertive"]),
  navigationLabel: j.func,
  next2AriaLabel: j.string,
  next2Label: j.node,
  nextAriaLabel: j.string,
  nextLabel: j.node,
  onActiveStartDateChange: j.func,
  onChange: j.func,
  onClickDay: j.func,
  onClickDecade: j.func,
  onClickMonth: j.func,
  onClickWeekNumber: j.func,
  onClickYear: j.func,
  onDrillDown: j.func,
  onDrillUp: j.func,
  onViewChange: j.func,
  prev2AriaLabel: j.string,
  prev2Label: j.node,
  prevAriaLabel: j.string,
  prevLabel: j.node,
  returnValue: j.oneOf(["start", "end", "range"]),
  selectRange: j.bool,
  showDoubleView: j.bool,
  showFixedNumberOfWeeks: j.bool,
  showNavigation: j.bool,
  showNeighboringMonth: j.bool,
  showWeekNumbers: j.bool,
  tileClassName: j.oneOfType([j.func, Dl]),
  tileContent: j.oneOfType([j.func, j.node]),
  tileDisabled: j.func,
  value: fg,
  view: jo
};
function xs(e, t) {
  return {
    role: "button",
    tabIndex: t || 0,
    onClick: e
  };
}
G.pre`
  display: block;
  font-size: ${(e) => e.theme.fontSizeQuarck};
  width: 50%;
  border: ${(e) => e.theme.borderWidthHairline} solid ${(e) => e.theme.colorNeutralDark};
  padding: ${(e) => e.theme.spacingInsetSmRem};
  background-color: ${(e) => e.theme.colorNeutralDarkest};
  color: ${(e) => e.theme.colorNeutralLightest};
  margin-top: ${(e) => e.theme.spacingInsetSmRem};
`;
G.pre`
  display: block;
  font-size: ${(e) => e.theme.fontSizeQuarck};
  width: 100%;
  border: ${(e) => e.theme.borderWidthHairline} solid ${(e) => e.theme.colorNeutralDark};
  padding: ${(e) => e.theme.spacingInsetSmRem};
  background-color: ${(e) => e.theme.colorNeutralDarkest};
  color: ${(e) => e.theme.colorNeutralLightest};
  margin-top: ${(e) => e.theme.spacingInsetSmRem};
`;
const ea = (e, t = 2) => {
  const n = e.toFixed(t).split(".");
  return n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","), n.join(".");
}, Dt = ".react-calendar__month-view__days", Vt = ".react-calendar__year-view__months", zt = ".react-calendar__decade-view__years", Gpe = (e) => {
  switch (e.size.toString()) {
    case "sm":
      return "2.5rem";
    case "md":
      return "3rem";
    case "lg":
      return "3.5rem";
  }
}, Zpe = (e) => {
  switch (e.size) {
    case "sm":
      return e.theme.fontSizeXxxs;
    case "md":
      return e.theme.fontSizeXxxs;
    case "lg":
      return e.theme.fontSizeXxxs;
  }
}, Xpe = (e) => e.disabled ? e.theme.colorNeutralMedium : e.$isInvalid ? e.theme.colorSupportNegativeMedium : e.theme.brandPrimaryMedium, Upe = ke`
  .react-calendar--doubleView {
    width: 700px;
  }
  .react-calendar--doubleView .react-calendar__viewContainer {
    display: flex;
    margin: -0.5em;
  }
  .react-calendar--doubleView .react-calendar__viewContainer > * {
    width: 50%;
    margin: 0.5em;
  }
  .react-calendar,
  .react-calendar *,
  .react-calendar *:before,
  .react-calendar *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .react-calendar button {
    margin: 0;
    outline: none;
  }
  .react-calendar button:enabled:hover {
    cursor: pointer;
  }

  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75em;
    font-weight: bold;
  }

  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 2em 0.5em;
  }
  .react-calendar__tile {
    max-width: 100%;
    padding: 10px 6.6667px;
    background: none;
    text-align: center;
    line-height: ${(e) => e.theme.lineHeightTight}rem;
  }
`, Ype = G.div`
  position: relative;
`, Jpe = G.button`
  display: flex;
  align-items: center;
  width: 100%;
  background-color: ${(e) => e.disabled ? e.theme.colorNeutralLight : e.theme.colorNeutralLightest};
  border: ${(e) => `${e.theme.borderWidthHairline} solid ${e.theme.colorNeutralDark}`};
  height: ${Gpe};
  border-radius: ${(e) => e.theme.borderRadiusMd};
  line-height: ${(e) => e.theme.lineHeightFair}rem;
  padding: ${(e) => e.theme.spacingInlineNanoRem};
  &:disabled {
    border-color: ${(e) => e.theme.colorNeutralMedium};
    pointer-events: none;
  }
  &:not(:disabled) {
    &:hover,
    &:focus,
    &:active {
      outline: none;
      border-color: ${(e) => e.theme.colorNeutralDarkest};
    }
  }

  ${(e) => e.$isInvalid && ke`
      border-color: ${(t) => t.theme.colorSupportNegativeMedium};
    `}
`, Kpe = G.div`
  cursor: pointer;
  color: ${(e) => e.theme.colorNeutralDark};
  margin: 0;
  padding: 0 ${(e) => e.theme.spacingInsetSmRem};
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  font-size: ${Zpe};
  flex: 1;
  ${(e) => e.$isInvalid && ke`
      color: ${(t) => t.theme.colorSupportNegativeMedium};
    `}
  ${(e) => e.disabled && ke`
      color: ${(t) => t.theme.colorNeutralMedium};
    `}
  &:hover {
    color: ${(e) => e.theme.colorNeutralDarkest};
  }
`, Qpe = G(ot)`
  display: flex;
  align-items: center;
  padding: ${(e) => e.theme.spacingStackQuarckRem};
  color: ${Xpe};
  &:hover {
    background-color: ${(e) => e.theme.colorNeutralLight};
    border-radius: ${(e) => e.theme.borderRadiusCircular};
  }
`, e2e = G.div`
  position: absolute;
  top: calc(100% + 0.5rem);
  z-index: 3;

  .react-calendar {
    font-family: ${(e) => e.theme.fontFamilyRegular};
    border: ${(e) => `${e.theme.borderWidthHairline} solid ${e.theme.colorNeutralMedium}`};
    border-radius: ${(e) => e.theme.borderRadiusMd};
    width: 20.5rem;
    height: 23.563rem;
    max-width: 100%;
    background: white;
    line-height: ${(e) => e.theme.lineHeightTight}rem;

    box-shadow: ${(e) => e.theme.shadowDown01};

    &__month-view__weekdays__weekday {
      font-family: ${(e) => e.theme.fontFamilyBold};
      padding: ${(e) => e.theme.spacingStackNanoRem};
    }
    ${Dt} > .react-calendar__tile--active,
    ${Vt} > .react-calendar__tile--active,
    ${zt} > .react-calendar__tile--active {
      background-color: ${(e) => e.theme.brandPrimaryMedium};
      color: ${(e) => e.theme.colorNeutralLightest};
      border-radius: ${(e) => e.theme.borderRadiusSm};
    }
    .react-calendar__tile--active:enabled:hover:not(.react-calendar__tile--range),
    .react-calendar__tile--active:enabled:focus {
      background-color: ${(e) => e.theme.brandPrimaryMedium};
      color: ${(e) => e.theme.colorNeutralLightest};
    }

    ${Dt} > .react-calendar__tile--range,
    ${Vt} > .react-calendar__tile--range,
    ${zt} > .react-calendar__tile--range {
      background-color: ${(e) => e.theme.brandPrimaryLightest};
      color: ${(e) => e.theme.colorNeutralDarkest};
    }

    ${Dt} > .react-calendar__tile--range:hover,
    ${Vt} > .react-calendar__tile--range:hover,
    ${zt} > .react-calendar__tile--range:hover {
      border: ${(e) => `${e.theme.borderWidthHairline} solid ${e.theme.brandPrimaryLight}}`};
    }

    ${Dt} > .react-calendar__tile--rangeStart:not(.react-calendar__tile--range:hover),
    ${Vt} > .react-calendar__tile--rangeStart:not(.react-calendar__tile--range:hover),
    ${zt} > .react-calendar__tile--rangeStart:not(.react-calendar__tile--range:hover) {
      color: ${(e) => e.theme.colorNeutralLightest};
      background-color: ${(e) => e.theme.brandPrimaryMedium};
    }

    ${Dt} > .react-calendar__tile--rangeEnd:not(.react-calendar__tile--range:hover),
    ${Vt} > .react-calendar__tile--rangeEnd:not(.react-calendar__tile--range:hover),
    ${zt} > .react-calendar__tile--rangeEnd:not(.react-calendar__tile--range:hover) {
      color: ${(e) => e.theme.colorNeutralLightest};
      background-color: ${(e) => e.theme.brandPrimaryMedium};
    }

    ${Dt} > .react-calendar__tile--hover,
    ${Vt} > .react-calendar__tile--hover,
    ${zt} > .react-calendar__tile--hover {
      background-color: ${(e) => e.theme.brandPrimaryLightest};
      color: ${(e) => e.theme.colorNeutralDarkest};
    }

    .react-calendar__month-view {
      padding-top: ${(e) => e.theme.spacingInlineXxxsRem};
    }

    .react-calendar__month-view__weekdays {
      text-align: center;
      text-transform: uppercase;
      font-size: ${(e) => e.theme.fontSizeNano};
      background-color: ${(e) => e.theme.colorNeutralLight};
      height: 3.313rem;
      padding-left: ${(e) => e.theme.spacingInlineXxxsRem};
      padding-right: ${(e) => e.theme.spacingInlineXxxsRem};
    }

    .react-calendar__month-view__weekdays__weekday {
      display: table;
      text-align: center;
    }

    .react-calendar__month-view__weekdays__weekday > abbr {
      text-decoration: none;
      display: table-cell;
      vertical-align: middle;
      cursor: default;
      color: ${(e) => e.theme.colorNeutralDarkest};
      font-size: ${(e) => e.theme.fontSizeNano};
    }

    ${Dt} > .react-calendar__tile--now:not(.react-calendar__tile--active, .react-calendar__tile--hasActive),
    ${Vt} > .react-calendar__tile--now:not(.react-calendar__tile--active, .react-calendar__tile--hasActive),
    ${zt} > .react-calendar__tile--now:not(.react-calendar__tile--active, .react-calendar__tile--hasActive) {
      color: ${(e) => e.theme.brandPrimaryMedium};
    }

    ${Dt}>.react-calendar__tile--now :after {
      font-weight: bold;
      color: ${(e) => e.theme.brandPrimaryMedium};
      content: '.';
      position: relative;
      display: flex;
      margin-top: -${(e) => e.theme.spacingInlineMicroRem};
      margin-left: -${(e) => e.theme.spacingInlineQuarckRem};
      font-size: ${(e) => e.theme.fontSizeSm};
      left: 50%;
    }

    .react-calendar__navigation {
      display: flex;
      height: 2.75rem;
      padding-top: ${(e) => e.theme.spacingInlineXxxsRem};
    }

    .react-calendar__navigation > button {
      min-width: ${(e) => e.theme.spacingStackXsRem};
      background: none;
      border: ${(e) => e.theme.borderWidthNone};
    }

    .react-calendar__navigation button:enabled:hover,
    .react-calendar__navigation button:enabled:focus {
      background-color: ${(e) => e.theme.colorNeutralLight};
    }

    .react-calendar__navigation__label:not(:disabled) > .react-calendar__navigation__label__labelText {
      font-size: ${(e) => e.theme.fontSizeXxxs};
      font-weight: ${(e) => e.theme.fontWeightSemibold};
      display: block;
      color: ${(e) => e.theme.colorNeutralDark};
    }

    .react-calendar__navigation__label__labelText:first-letter {
      text-transform: uppercase;
    }

    ${Dt} {
      padding-left: ${(e) => e.theme.spacingInlineXxxsRem};
      padding-right: ${(e) => e.theme.spacingInlineXxxsRem};
      padding-top: ${(e) => e.theme.spacingInlineNanoRem};
    }

    ${Dt} > button {
      font-size: ${(e) => e.theme.fontSizeNano};
      color: ${(e) => e.theme.colorNeutralDarkest};
      border: ${(e) => `${e.theme.borderWidthHairline} solid transparent`};
    }

    ${Dt}>button:hover:not(:disabled):not(.react-calendar__tile--active), 
    ${Vt}>button:hover:not(:disabled):not(.react-calendar__tile--active),
    ${zt}>button:hover:not(:disabled):not(.react-calendar__tile--active) {
      border-radius: ${(e) => e.theme.borderRadiusSm};
      background-color: ${(e) => e.theme.brandPrimaryLightest};
      border: ${(e) => `${e.theme.borderWidthHairline} solid ${e.theme.brandPrimaryLight}}`};
      color: ${(e) => e.theme.brandPrimaryMedium};
    }

    ${Dt}>button:hover,
    ${Vt}>button:hover,
    ${zt}>button:hover {
      color: ${(e) => e.theme.brandPrimaryMedium};
    }

    ${Dt}__day--neighboringmonth {
      color: ${(e) => e.theme.colorNeutralDark};
    }

    ${Vt} > button {
      font-size: ${(e) => e.theme.fontSizeNano};
      color: ${(e) => e.theme.colorNeutralDarkest};
      border: ${(e) => `${e.theme.borderWidthHairline} solid transparent`};
    }

    ${Vt}>button:hover {
      border-radius: ${(e) => e.theme.borderRadiusSm};
      background-color: ${(e) => e.theme.brandPrimaryLightest};
      border: ${(e) => `${e.theme.borderWidthHairline} solid ${e.theme.brandPrimaryLight}}`};
    }

    ${Vt} {
      padding-left: ${(e) => e.theme.spacingInlineXxxsRem};
      padding-right: ${(e) => e.theme.spacingInlineXxxsRem};
      padding-top: ${(e) => e.theme.spacingInlineNanoRem};
    }

    ${zt} > button {
      font-size: ${(e) => e.theme.fontSizeNano};
      color: ${(e) => e.theme.colorNeutralDarkest};
      border: ${(e) => `${e.theme.borderWidthHairline} solid transparent`};
    }

    ${zt}>button:hover {
      border-radius: ${(e) => e.theme.borderRadiusSm};
      background-color: ${(e) => e.theme.brandPrimaryLightest};
      border: ${(e) => `${e.theme.borderWidthHairline} solid ${e.theme.brandPrimaryLight}}`};
    }

    ${zt} {
      padding-left: ${(e) => e.theme.spacingInlineXxxsRem};
      padding-right: ${(e) => e.theme.spacingInlineXxxsRem};
      padding-top: ${(e) => e.theme.spacingInlineNanoRem};
    }

    ${Dt} > .react-calendar__tile:disabled,
    ${Vt} > .react-calendar__tile:disabled,
    ${zt} > .react-calendar__tile:disabled {
      color: ${(e) => e.theme.colorNeutralMedium};
      background-color: ${(e) => e.theme.colorNeutralLightest};
      border: ${(e) => `${e.theme.borderWidthHairline} solid transparent`};
    }

    ${Dt} > .react-calendar__tile--hasActive,
    ${Vt} > .react-calendar__tile--hasActive,
    ${zt} > .react-calendar__tile--hasActive {
      background: ${(e) => e.theme.brandPrimaryMedium};
      color: ${(e) => e.theme.colorNeutralLightest};
    }

    ${Upe}
  }
`;
var un = /* @__PURE__ */ ((e) => (e.DAY = "day", e.MONTH = "month", e.YEAR = "year", e.DECADE = "decade", e))(un || {}), W3 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(_i, function() {
    var n = 1e3, r = 6e4, a = 36e5, i = "millisecond", o = "second", s = "minute", c = "hour", l = "day", u = "week", h = "month", p = "quarter", f = "year", y = "date", m = "Invalid Date", v = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, k = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, b = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(O) {
      var I = ["th", "st", "nd", "rd"], N = O % 100;
      return "[" + O + (I[(N - 20) % 10] || I[N] || I[0]) + "]";
    } }, x = function(O, I, N) {
      var R = String(O);
      return !R || R.length >= I ? O : "" + Array(I + 1 - R.length).join(N) + O;
    }, g = { s: x, z: function(O) {
      var I = -O.utcOffset(), N = Math.abs(I), R = Math.floor(N / 60), L = N % 60;
      return (I <= 0 ? "+" : "-") + x(R, 2, "0") + ":" + x(L, 2, "0");
    }, m: function O(I, N) {
      if (I.date() < N.date())
        return -O(N, I);
      var R = 12 * (N.year() - I.year()) + (N.month() - I.month()), L = I.clone().add(R, h), W = N - L < 0, E = I.clone().add(R + (W ? -1 : 1), h);
      return +(-(R + (N - L) / (W ? L - E : E - L)) || 0);
    }, a: function(O) {
      return O < 0 ? Math.ceil(O) || 0 : Math.floor(O);
    }, p: function(O) {
      return { M: h, y: f, w: u, d: l, D: y, h: c, m: s, s: o, ms: i, Q: p }[O] || String(O || "").toLowerCase().replace(/s$/, "");
    }, u: function(O) {
      return O === void 0;
    } }, w = "en", M = {};
    M[w] = b;
    var S = "$isDayjsObject", D = function(O) {
      return O instanceof Z || !(!O || !O[S]);
    }, A = function O(I, N, R) {
      var L;
      if (!I)
        return w;
      if (typeof I == "string") {
        var W = I.toLowerCase();
        M[W] && (L = W), N && (M[W] = N, L = W);
        var E = I.split("-");
        if (!L && E.length > 1)
          return O(E[0]);
      } else {
        var q = I.name;
        M[q] = I, L = q;
      }
      return !R && L && (w = L), L || !R && w;
    }, $ = function(O, I) {
      if (D(O))
        return O.clone();
      var N = typeof I == "object" ? I : {};
      return N.date = O, N.args = arguments, new Z(N);
    }, F = g;
    F.l = A, F.i = D, F.w = function(O, I) {
      return $(O, { locale: I.$L, utc: I.$u, x: I.$x, $offset: I.$offset });
    };
    var Z = function() {
      function O(N) {
        this.$L = A(N.locale, null, !0), this.parse(N), this.$x = this.$x || N.x || {}, this[S] = !0;
      }
      var I = O.prototype;
      return I.parse = function(N) {
        this.$d = function(R) {
          var L = R.date, W = R.utc;
          if (L === null)
            return /* @__PURE__ */ new Date(NaN);
          if (F.u(L))
            return /* @__PURE__ */ new Date();
          if (L instanceof Date)
            return new Date(L);
          if (typeof L == "string" && !/Z$/i.test(L)) {
            var E = L.match(v);
            if (E) {
              var q = E[2] - 1 || 0, z = (E[7] || "0").substring(0, 3);
              return W ? new Date(Date.UTC(E[1], q, E[3] || 1, E[4] || 0, E[5] || 0, E[6] || 0, z)) : new Date(E[1], q, E[3] || 1, E[4] || 0, E[5] || 0, E[6] || 0, z);
            }
          }
          return new Date(L);
        }(N), this.init();
      }, I.init = function() {
        var N = this.$d;
        this.$y = N.getFullYear(), this.$M = N.getMonth(), this.$D = N.getDate(), this.$W = N.getDay(), this.$H = N.getHours(), this.$m = N.getMinutes(), this.$s = N.getSeconds(), this.$ms = N.getMilliseconds();
      }, I.$utils = function() {
        return F;
      }, I.isValid = function() {
        return this.$d.toString() !== m;
      }, I.isSame = function(N, R) {
        var L = $(N);
        return this.startOf(R) <= L && L <= this.endOf(R);
      }, I.isAfter = function(N, R) {
        return $(N) < this.startOf(R);
      }, I.isBefore = function(N, R) {
        return this.endOf(R) < $(N);
      }, I.$g = function(N, R, L) {
        return F.u(N) ? this[R] : this.set(L, N);
      }, I.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, I.valueOf = function() {
        return this.$d.getTime();
      }, I.startOf = function(N, R) {
        var L = this, W = !!F.u(R) || R, E = F.p(N), q = function(ae, ee) {
          var de = F.w(L.$u ? Date.UTC(L.$y, ee, ae) : new Date(L.$y, ee, ae), L);
          return W ? de : de.endOf(l);
        }, z = function(ae, ee) {
          return F.w(L.toDate()[ae].apply(L.toDate("s"), (W ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ee)), L);
        }, H = this.$W, _ = this.$M, X = this.$D, P = "set" + (this.$u ? "UTC" : "");
        switch (E) {
          case f:
            return W ? q(1, 0) : q(31, 11);
          case h:
            return W ? q(1, _) : q(0, _ + 1);
          case u:
            var Q = this.$locale().weekStart || 0, U = (H < Q ? H + 7 : H) - Q;
            return q(W ? X - U : X + (6 - U), _);
          case l:
          case y:
            return z(P + "Hours", 0);
          case c:
            return z(P + "Minutes", 1);
          case s:
            return z(P + "Seconds", 2);
          case o:
            return z(P + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, I.endOf = function(N) {
        return this.startOf(N, !1);
      }, I.$set = function(N, R) {
        var L, W = F.p(N), E = "set" + (this.$u ? "UTC" : ""), q = (L = {}, L[l] = E + "Date", L[y] = E + "Date", L[h] = E + "Month", L[f] = E + "FullYear", L[c] = E + "Hours", L[s] = E + "Minutes", L[o] = E + "Seconds", L[i] = E + "Milliseconds", L)[W], z = W === l ? this.$D + (R - this.$W) : R;
        if (W === h || W === f) {
          var H = this.clone().set(y, 1);
          H.$d[q](z), H.init(), this.$d = H.set(y, Math.min(this.$D, H.daysInMonth())).$d;
        } else
          q && this.$d[q](z);
        return this.init(), this;
      }, I.set = function(N, R) {
        return this.clone().$set(N, R);
      }, I.get = function(N) {
        return this[F.p(N)]();
      }, I.add = function(N, R) {
        var L, W = this;
        N = Number(N);
        var E = F.p(R), q = function(_) {
          var X = $(W);
          return F.w(X.date(X.date() + Math.round(_ * N)), W);
        };
        if (E === h)
          return this.set(h, this.$M + N);
        if (E === f)
          return this.set(f, this.$y + N);
        if (E === l)
          return q(1);
        if (E === u)
          return q(7);
        var z = (L = {}, L[s] = r, L[c] = a, L[o] = n, L)[E] || 1, H = this.$d.getTime() + N * z;
        return F.w(H, this);
      }, I.subtract = function(N, R) {
        return this.add(-1 * N, R);
      }, I.format = function(N) {
        var R = this, L = this.$locale();
        if (!this.isValid())
          return L.invalidDate || m;
        var W = N || "YYYY-MM-DDTHH:mm:ssZ", E = F.z(this), q = this.$H, z = this.$m, H = this.$M, _ = L.weekdays, X = L.months, P = L.meridiem, Q = function(ee, de, Y, re) {
          return ee && (ee[de] || ee(R, W)) || Y[de].slice(0, re);
        }, U = function(ee) {
          return F.s(q % 12 || 12, ee, "0");
        }, ae = P || function(ee, de, Y) {
          var re = ee < 12 ? "AM" : "PM";
          return Y ? re.toLowerCase() : re;
        };
        return W.replace(k, function(ee, de) {
          return de || function(Y) {
            switch (Y) {
              case "YY":
                return String(R.$y).slice(-2);
              case "YYYY":
                return F.s(R.$y, 4, "0");
              case "M":
                return H + 1;
              case "MM":
                return F.s(H + 1, 2, "0");
              case "MMM":
                return Q(L.monthsShort, H, X, 3);
              case "MMMM":
                return Q(X, H);
              case "D":
                return R.$D;
              case "DD":
                return F.s(R.$D, 2, "0");
              case "d":
                return String(R.$W);
              case "dd":
                return Q(L.weekdaysMin, R.$W, _, 2);
              case "ddd":
                return Q(L.weekdaysShort, R.$W, _, 3);
              case "dddd":
                return _[R.$W];
              case "H":
                return String(q);
              case "HH":
                return F.s(q, 2, "0");
              case "h":
                return U(1);
              case "hh":
                return U(2);
              case "a":
                return ae(q, z, !0);
              case "A":
                return ae(q, z, !1);
              case "m":
                return String(z);
              case "mm":
                return F.s(z, 2, "0");
              case "s":
                return String(R.$s);
              case "ss":
                return F.s(R.$s, 2, "0");
              case "SSS":
                return F.s(R.$ms, 3, "0");
              case "Z":
                return E;
            }
            return null;
          }(ee) || E.replace(":", "");
        });
      }, I.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, I.diff = function(N, R, L) {
        var W, E = this, q = F.p(R), z = $(N), H = (z.utcOffset() - this.utcOffset()) * r, _ = this - z, X = function() {
          return F.m(E, z);
        };
        switch (q) {
          case f:
            W = X() / 12;
            break;
          case h:
            W = X();
            break;
          case p:
            W = X() / 3;
            break;
          case u:
            W = (_ - H) / 6048e5;
            break;
          case l:
            W = (_ - H) / 864e5;
            break;
          case c:
            W = _ / a;
            break;
          case s:
            W = _ / r;
            break;
          case o:
            W = _ / n;
            break;
          default:
            W = _;
        }
        return L ? W : F.a(W);
      }, I.daysInMonth = function() {
        return this.endOf(h).$D;
      }, I.$locale = function() {
        return M[this.$L];
      }, I.locale = function(N, R) {
        if (!N)
          return this.$L;
        var L = this.clone(), W = A(N, R, !0);
        return W && (L.$L = W), L;
      }, I.clone = function() {
        return F.w(this.$d, this);
      }, I.toDate = function() {
        return new Date(this.valueOf());
      }, I.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, I.toISOString = function() {
        return this.$d.toISOString();
      }, I.toString = function() {
        return this.$d.toUTCString();
      }, O;
    }(), B = Z.prototype;
    return $.prototype = B, [["$ms", i], ["$s", o], ["$m", s], ["$H", c], ["$W", l], ["$M", h], ["$y", f], ["$D", y]].forEach(function(O) {
      B[O[1]] = function(I) {
        return this.$g(I, O[0], O[1]);
      };
    }), $.extend = function(O, I) {
      return O.$i || (O(I, Z, $), O.$i = !0), $;
    }, $.locale = A, $.isDayjs = D, $.unix = function(O) {
      return $(1e3 * O);
    }, $.en = M[w], $.Ls = M, $.p = {}, $;
  });
})(W3);
var t2e = W3.exports;
const ft = /* @__PURE__ */ Ll(t2e), yg = (e) => {
  switch (e) {
    case un.DAY:
      return { minDetail: "decade", maxDetail: "month" };
    case un.MONTH:
      return { minDetail: "decade", maxDetail: "year" };
    case un.YEAR:
      return { minDetail: "decade", maxDetail: "decade" };
  }
}, mg = (e, t) => {
  if (ft(e).toString() !== "Invalid Date")
    switch (t) {
      case un.DAY:
        return ft(e).format("DD/MM/YYYY");
      case un.MONTH:
        return ft(e).format("MM/YYYY");
      case un.YEAR:
        return ft(e).format("YYYY");
      default:
        return ft(e).format("DD/MM");
    }
  return null;
}, gg = (e, t) => {
  if (!e || (e == null ? void 0 : e.length) < 2)
    return null;
  if (ft(e[0]).toString() !== "Invalid Date" && ft(e[1]).toString() !== "Invalid Date")
    switch (t) {
      case un.DAY:
        return `${ft(e[0]).format("DD/MM/YYYY")} -  ${ft(e[1]).format("DD/MM/YYYY")}`;
      case un.MONTH:
        return `${ft(e[0]).format("MM/YYYY")} -  ${ft(e[1]).format("MM/YYYY")}`;
      case un.YEAR:
        return `${ft(e[0]).format("YYYY")} -  ${ft(e[1]).format("YYYY")}`;
      default:
        return `${ft(e[0]).format("DD/MM")} -  ${ft(e[1]).format("DD/MM")}`;
    }
  else
    return null;
}, n2e = (e) => {
  var A, $;
  const {
    value: t,
    size: n = "md",
    hasIcon: r = !0,
    onChange: a,
    onClear: i,
    onBlur: o,
    disabled: s = !1,
    isInvalid: c = !1,
    placeholder: l,
    minDate: u,
    maxDate: h,
    inputRef: p = void 0,
    selectRange: f,
    view: y = un.DAY,
    className: m,
    ...v
  } = e, [k, b] = fe(!1), x = t != null, g = he(null);
  x6(g, () => {
    o && o(), b(!1);
  });
  const w = () => {
    !k && !s && b(!0);
  }, M = (F) => {
    a && a(f ? gg(F, y) ? F : null : mg(F, y) ? F : null), b(!1);
  }, S = () => {
    i && i();
  }, D = x && i;
  return /* @__PURE__ */ ie(Ype, { className: m, view: y, isRange: !!f, size: n, children: [
    /* @__PURE__ */ ie(Jpe, { type: "button", disabled: s, size: n, $isInvalid: c, onClick: w, children: [
      /* @__PURE__ */ C(Kpe, { size: n, disabled: s, $isInvalid: c, children: (f ? gg(t, y) : mg(t, y)) || l || "Fecha no seleccionada" }),
      r && /* @__PURE__ */ C(
        Qpe,
        {
          ...xs(D ? S : w),
          size: n === "lg" ? "md" : n,
          name: D ? "x" : "calendar",
          disabled: s,
          $isInvalid: c,
          "data-testid": D ? "datePickerClear" : "datePickerCalendar"
        }
      )
    ] }),
    k && /* @__PURE__ */ C(e2e, { ref: g, className: "CalendarContainer", "data-testid": "datePickerCalendarContainer", children: /* @__PURE__ */ C(
      T2,
      {
        value: t,
        onChange: M,
        inputRef: p,
        minDate: u,
        maxDate: h,
        minDetail: (A = yg(y)) == null ? void 0 : A.minDetail,
        maxDetail: ($ = yg(y)) == null ? void 0 : $.maxDetail,
        selectRange: f,
        formatShortWeekday: (F, Z) => ["D", "L", "M", "M", "J", "V", "S"][Z.getDay()],
        ...v
      }
    ) })
  ] });
}, r2e = G.div`
  display: flex;
  height: 2.5rem;
  align-items: center;
  justify-content: space-between;
  border: ${(e) => e.theme.borderWidthHairline} solid ${(e) => e.theme.colorNeutralDark};
  border-radius: ${(e) => e.theme.borderRadiusMd};
  padding: ${(e) => e.theme.spacingInsetSmRem} calc(${(e) => e.theme.spacingInsetSmRem} * 0.8125);
`, a2e = G.div`
  display: flex;
  width: min-content;
  align-items: center;
`, vg = G.input`
  display: flex;
  width: 5.2rem;
  height: 1rem;
  border: none;
  margin: 0;
  padding: 0;
  font-family: ${(e) => e.theme.fontFamilyRegular};
  font-size: ${(e) => e.theme.fontSizeNano};
  ::-webkit-inner-spin-button,
  ::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }
`, i2e = G.span`
  display: flex;
  align-items: center;
  height: 1rem;
  margin: 0 ${(e) => e.theme.spacingStackQuarckRem};
  font-family: ${(e) => e.theme.fontFamilyRegular};
  font-size: ${(e) => e.theme.fontSizeNano};
`, z4e = ({
  className: e = "",
  startDate: t = /* @__PURE__ */ new Date(),
  endDate: n = /* @__PURE__ */ new Date(),
  onChange: r
}) => {
  const a = (s) => {
    try {
      return s.toISOString().split("T")[0];
    } catch {
      return "";
    }
  }, i = (s) => r(s, n), o = (s) => r(t, s);
  return /* @__PURE__ */ ie(r2e, { className: e, children: [
    /* @__PURE__ */ ie(a2e, { children: [
      /* @__PURE__ */ C(
        vg,
        {
          type: "date",
          value: a(t),
          onChange: ({ target: { value: s } }) => i(new Date(s))
        }
      ),
      /* @__PURE__ */ C(i2e, { children: "-" }),
      /* @__PURE__ */ C(
        vg,
        {
          type: "date",
          value: a(n),
          onChange: ({ target: { value: s } }) => o(new Date(s))
        }
      )
    ] }),
    /* @__PURE__ */ C(ot, { name: "calendar", size: "lg" })
  ] });
}, o2e = (e, t) => t === "lg" ? {
  height: e.spacingInlineLgRem,
  fontSize: "1.2rem"
} : t === "md" ? {
  height: e.spacingInlineMdRem,
  fontSize: "1.2rem"
} : {
  height: e.spacingInlineSmRem,
  fontSize: e.fontSizeXxxs
}, s2e = G.input`
  border: ${(e) => e.theme.borderWidthHairline} solid ${(e) => e.theme.colorNeutralDarkest};
  outline: none;
  font-family: ${(e) => e.theme.fontFamilyLight};
  padding: ${(e) => e.theme.spacingInlineQuarck};
  border-radius: ${(e) => e.theme.spacingInlineNano};
  ${(e) => o2e(e.theme, e.inputSize)}
`, c2e = ({ inputSize: e = "md", ...t }) => /* @__PURE__ */ C(s2e, { ...t, inputSize: e }), l2e = G.div``, d2e = G.div`
  padding-bottom: ${(e) => e.theme.spacingStackMicroRem};
  padding-top: ${(e) => e.theme.spacingStackMicroRem};
  font-size: ${(e) => e.theme.fontSizeNano};
  font-weight: ${(e) => e.theme.fontWeightSemibold};
`, u2e = G.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: ${(e) => e.theme.spacingStackXxxsRem};
  row-gap: ${(e) => e.theme.spacingStackNanoRem};
`, h2e = G.div`
  text-align: center;
  max-width: 6.2rem;
  height: 1.875rem;
  background-color: ${(e) => e.theme.colorNeutralLight};
  flex: 1 1 auto;

  [role='button']:not(disabled) {
    cursor: pointer;
  }

  [role='button'][disabled] {
    cursor: default;
  }
`, p2e = G.div`
  padding-left: ${(e) => e.theme.spacingStackNanoRem};
  padding-right: ${(e) => e.theme.spacingStackNanoRem};
  display: inline-block;
  vertical-align: middle;
  font-size: ${(e) => e.theme.fontSizeNano};
  color: ${(e) => e.theme.colorNeutralDarkest};
`, f2e = G.div`
  font-size: ${(e) => e.theme.fontSizeQuarck};
  color: ${(e) => e.theme.colorSupportNegativeMedium};
  padding-top: ${(e) => e.theme.spacingInlineQuarckRem};
`, y2e = G(ot)`
  display: inline-block;
  vertical-align: middle;
  color: ${(e) => e.theme.colorNeutralDarkest};
`, m2e = G(ot)`
  vertical-align: middle;
  margin-left: -0.125rem;
  color: ${(e) => e.disabled ? e.theme.colorNeutralMedium : e.theme.brandPrimaryMedium};
  &:hover {
    background-color: ${(e) => e.theme.colorNeutralLight};
    border-radius: ${(e) => e.theme.borderRadiusCircular};
  }
`, B4e = (e) => {
  const {
    value: t,
    onChange: n,
    labelChips: r = "",
    disabled: a = !1,
    minDate: i,
    maxDate: o,
    viewCalendar: s = un.DAY,
    placeholderDatePicker: c = "dd/mm",
    chipDateFormat: l = "DD/MM",
    size: u = "md",
    error: h = null,
    customClassName: p = ""
  } = e, f = (v) => /* @__PURE__ */ ie(h2e, { children: [
    /* @__PURE__ */ C(y2e, { size: "sm", name: "calendar", "data-testid": "multipleDatePickerCalendar" }),
    /* @__PURE__ */ C(p2e, { children: ft(v).format(l) }),
    /* @__PURE__ */ C(
      m2e,
      {
        ...xs(() => !a && y(v)),
        disabled: a,
        size: "sm",
        name: "x",
        "data-testid": "multipleDatePickerClear"
      }
    )
  ] }, v), y = (v) => {
    n(t.filter((k) => k !== v));
  }, m = (v) => {
    const k = ft(v).format("YYYY-MM-DD");
    if (!t.includes(k)) {
      const b = [...t, k].sort();
      n(b);
    }
  };
  return /* @__PURE__ */ ie(l2e, { className: p, children: [
    /* @__PURE__ */ C(
      n2e,
      {
        value: null,
        placeholder: c,
        onChange: (v) => m(v),
        disabled: a,
        minDate: i,
        maxDate: o,
        view: s,
        size: u
      }
    ),
    h && /* @__PURE__ */ C(f2e, { children: h }),
    /* @__PURE__ */ C(d2e, { children: r }),
    /* @__PURE__ */ C(u2e, { children: t.map((v) => f(v)) })
  ] });
}, g2e = G.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${(e) => e.theme.spacingStackXxxsRem};
`, v2e = G.div`
  user-select: none;
  position: relative;
  display: flex;
  align-items: center;
  height: 1.5rem;
  width: 100%;
`, k2e = G.div`
  display: flex;
  position: relative;
  height: 0.375rem;
  width: 100%;
  opacity: ${(e) => e.theme.opacityIntense};
  background: ${(e) => e.theme.colorNeutralMedium};
  border-radius: 1.5rem;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
`, b2e = G.div`
  display: flex;
  position: absolute;
  height: 0.375rem;
  width: 100%;
  background: ${(e) => e.theme.brandHighlightMedium};
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
`, kg = G.button`
  position: absolute;
  border: none;
  outline: none;
  background: ${(e) => e.theme.brandHighlightMedium};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  :focus {
    outline: none;
  }
`, x2e = G.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${(e) => e.theme.fontSizeNano};
  color: ${(e) => e.theme.colorNeutralDark};
`, H4e = ({
  min: e,
  max: t,
  lowerValue: n,
  setLowerValue: r,
  upperValue: a,
  setUpperValue: i,
  lowerLabel: o = "",
  upperLabel: s = ""
}) => {
  const c = he(null), l = he(null), [u, h] = fe(!1), [p, f] = fe(!1), [y, m] = fe(0), [v, k] = fe(0), [b, x] = fe(0), g = ue(() => {
    c.current && m(
      (n + Math.abs(e)) / (t + Math.abs(e)) * c.current.clientWidth - b / 2
    ), c.current && k(
      (a + Math.abs(e)) / (t + Math.abs(e)) * c.current.clientWidth - b / 2
    );
  }, [n, a, b]);
  be(() => {
    l.current && x(l.current.clientWidth);
  }), be(() => {
    g();
  }, [g, n, a]);
  const w = ue(() => {
    h(!1), f(!1);
  }, []), M = ue(
    (S) => {
      const D = c.current;
      if (!D)
        return;
      let A = S.clientX - D.getBoundingClientRect().left + 1;
      A = Math.min(A, D.clientWidth), A = Math.max(A, 0);
      const $ = Math.round(A / D.clientWidth * (t - e) + e);
      u && $ <= a && r($), p && $ >= n && i($);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [u, p, t, n, a]
  );
  return be(() => (window.addEventListener("mousemove", M), window.addEventListener("mouseup", w), () => {
    window.removeEventListener("mousemove", M), window.removeEventListener("mouseup", w);
  }), [M, w]), /* @__PURE__ */ ie(g2e, { children: [
    /* @__PURE__ */ ie(v2e, { ref: c, children: [
      /* @__PURE__ */ C(k2e, {}),
      /* @__PURE__ */ C(
        b2e,
        {
          style: {
            left: `${y + b / 2}px`,
            width: `${v - y}px`
          }
        }
      ),
      /* @__PURE__ */ C(
        kg,
        {
          ref: l,
          style: {
            left: `${y}px`
          },
          onMouseDown: () => h(!0),
          onMouseUp: () => h(!1)
        }
      ),
      /* @__PURE__ */ C(
        kg,
        {
          style: {
            left: `${v}px`
          },
          onMouseDown: () => f(!0),
          onMouseUp: () => f(!1)
        }
      )
    ] }),
    s && y && /* @__PURE__ */ ie(x2e, { children: [
      /* @__PURE__ */ C("div", { children: o }),
      /* @__PURE__ */ C("div", { children: s })
    ] })
  ] });
}, M2e = G.input`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: ${(e) => e.theme.colorNeutralLightest};
  border: ${({ theme: { borderWidthHairline: e, colorNeutralDark: t } }) => `${e} solid ${t}`};
  color: ${(e) => e.theme.colorNeutralDarkest};
  padding: ${(e) => e.theme.spacingInsetSmRem};
  border-radius: ${(e) => e.theme.borderRadiusMd};
  font-family: ${(e) => e.theme.fontFamilyRegular};
  ${(e) => {
  switch (e.controlSize) {
    case "sm":
      return {
        "font-size": e.theme.fontSizeQuarck,
        height: "2.5rem"
      };
    case "md":
      return {
        "font-size": e.theme.fontSizeNano,
        height: "3rem"
      };
    case "lg":
      return {
        "font-size": e.theme.fontSizeXxxs,
        height: "3.5rem"
      };
  }
}};
  line-height: 1;

  &::-webkit-calendar-picker-indicator {
    display: flex;
    filter: invert(44%) sepia(2%) saturate(1859%) hue-rotate(327deg) brightness(100%) contrast(96%);
  }

  :focus-visible {
    outline: none;
  }

  :disabled {
    background-color: ${(e) => e.theme.colorNeutralLight};
    border: ${({ theme: { borderWidthHairline: e, colorNeutralMedium: t } }) => `${e} solid ${t}`};
    color: ${(e) => e.theme.colorNeutralDark};

    &::-webkit-calendar-picker-indicator {
      visibility: visible;
    }
  }
`, $4e = ({
  className: e = "",
  time: t,
  setTime: n,
  lockHours: r = !1,
  lockMinutes: a = !1,
  size: i = "lg",
  disabled: o = !1
}) => /* @__PURE__ */ C(
  M2e,
  {
    value: t,
    className: e,
    type: "time",
    onChange: ({ target: { value: c } }) => {
      const l = t == null ? void 0 : t.includes(":");
      r && l && (c = `${t.split(":")[0]}:${c.split(":")[1]}`), a && l && (c = `${c.split(":")[0]}:${t.split(":")[1]}`), n(c);
    },
    controlSize: i,
    disabled: o
  }
), w2e = "#00004d", C2e = "#1400a3", S2e = "#3e28d1", A2e = "#8979fd", O2e = "#f2f2ff", E2e = "#4d0000", I2e = "#a60000", D2e = "#e6261e", T2e = "#ff7979", N2e = "#fff2f2", P2e = "#202020", L2e = "#6c6c6c", R2e = "#dedede", V2e = "#f7f7f7", z2e = "#fcfcfc", B2e = "#003c20", H2e = "#006d3e", $2e = "#008656", j2e = "#79d1ab", F2e = "#f2fcf8", W2e = "#4d1b00", q2e = "#a64305", _2e = "#e57334", G2e = "#ffaf7d", Z2e = "#fff7f2", X2e = "#4d0012", U2e = "#a6002f", Y2e = "#d01156", J2e = "#ff799f", K2e = "#fff2f5", Q2e = 0, e0e = "4px", t0e = "8px", n0e = "16px", r0e = "500px", a0e = "1000px", i0e = 0, o0e = "1px", s0e = "2px", c0e = "4px", l0e = "576px", d0e = "1200px", u0e = 0.72, h0e = 0.32, p0e = 0.16, f0e = 0.08, y0e = "0px 0px 4px rgba(136, 128, 128, 0.08), 0px -8px 16px -4px rgba(136, 128, 128, 0.16)", m0e = "0px 0px 8px rgba(136, 128, 128, 0.08), 0px -16px 32px -8px rgba(136, 128, 128, 0.16)", g0e = "0px 0px 16px rgba(136, 128, 128, 0.08), 0px -32px 64px -16px rgba(136, 128, 128, 0.16)", v0e = "0px 0px 4px rgba(136, 128, 128, 0.08), 0px 8px 16px -4px rgba(136, 128, 128, 0.16)", k0e = "0px 0px 8px rgba(136, 128, 128, 0.08), 0px 16px 32px -8px rgba(136, 128, 128, 0.16)", b0e = "0px 0px 16px rgba(136, 128, 128, 0.08), 0px 32px 64px -16px rgba(136, 128, 128, 0.16)", x0e = "4px", M0e = "8px", w0e = "12px", C0e = "16px", S0e = "24px", A0e = "32px", O0e = "40px", E0e = "48px", I0e = "56px", D0e = "80px", T0e = "0.25rem", N0e = "0.5rem", P0e = "0.75rem", L0e = "1rem", R0e = "1.5rem", V0e = "2rem", z0e = "2.5rem", B0e = "3rem", H0e = "3.5rem", $0e = "5rem", j0e = "4px", F0e = "8px", W0e = "16px", q0e = "24px", _0e = "32px", G0e = "48px", Z0e = "0.25rem", X0e = "0.5rem", U0e = "1rem", Y0e = "1.5rem", J0e = "2rem", K0e = "3rem", Q0e = "4px 8px", efe = "8px 16px", tfe = "16px 24px", nfe = "16px 32px", rfe = "0.25rem 0.5rem", afe = "0.5rem 1rem", ife = "1rem 1.5rem", ofe = "1rem 2rem", sfe = "4px", cfe = "8px", lfe = "12px", dfe = "16px", ufe = "24px", hfe = "32px", pfe = "40px", ffe = "48px", yfe = "56px", mfe = "72px", gfe = "96px", vfe = "120px", kfe = "160px", bfe = "0.25rem", xfe = "0.5rem", Mfe = "0.75rem", wfe = "1rem", Cfe = "1.5rem", Sfe = "2rem", Afe = "2.5rem", Ofe = "3rem", Efe = "3.5rem", Ife = "4.5rem", Dfe = "6rem", Tfe = "7.5rem", Nfe = "10rem", Pfe = "'AlicorpSans-Light', Helvetica, Arial, sans-serif", Lfe = "'AlicorpSans-Regular', Helvetica, Arial, sans-serif", Rfe = "'AlicorpSans-Bold', Helvetica, Arial, sans-serif", Vfe = "'AlicorpSans-Semibold', Helvetica, Arial, sans-serif", zfe = "SFMono-Regular, Menlo, Monaco, Consolas,  'Liberation Mono', 'Courier New', monospace", Bfe = "80px", Hfe = "64px", $fe = "48px", jfe = "40px", Ffe = "32px", Wfe = "24px", qfe = "20px", _fe = "16px", Gfe = "14px", Zfe = "12px", Xfe = 300, Ufe = 400, Yfe = 600, Jfe = 700, Kfe = "1", Qfe = "1.28", eye = "1.52", tye = {
  brandPrimaryDarkest: w2e,
  brandPrimaryDark: C2e,
  brandPrimaryMedium: S2e,
  brandPrimaryLight: A2e,
  brandPrimaryLightest: O2e,
  brandHighlightDarkest: E2e,
  brandHighlightDark: I2e,
  brandHighlightMedium: D2e,
  brandHighlightLight: T2e,
  brandHighlightLightest: N2e,
  colorNeutralDarkest: P2e,
  colorNeutralDark: L2e,
  colorNeutralMedium: R2e,
  colorNeutralLight: V2e,
  colorNeutralLightest: z2e,
  colorSupportPositiveDarkest: B2e,
  colorSupportPositiveDark: H2e,
  colorSupportPositiveMedium: $2e,
  colorSupportPositiveLight: j2e,
  colorSupportPositiveLightest: F2e,
  colorSupportWarningDarkest: W2e,
  colorSupportWarningDark: q2e,
  colorSupportWarningMedium: _2e,
  colorSupportWarningLight: G2e,
  colorSupportWarningLightest: Z2e,
  colorSupportNegativeDarkest: X2e,
  colorSupportNegativeDark: U2e,
  colorSupportNegativeMedium: Y2e,
  colorSupportNegativeLight: J2e,
  colorSupportNegativeLightest: K2e,
  borderRadiusSharp: Q2e,
  borderRadiusSm: e0e,
  borderRadiusMd: t0e,
  borderRadiusLg: n0e,
  borderRadiusPill: r0e,
  borderRadiusCircular: a0e,
  borderWidthNone: i0e,
  borderWidthHairline: o0e,
  borderWidthThick: s0e,
  borderWidthHeavy: c0e,
  gridBreakpointMobile: l0e,
  gridBreakpointDesktop: d0e,
  opacitySemiOpaque: u0e,
  opacityIntense: h0e,
  opacityLight: p0e,
  opacitySemiTransparent: f0e,
  shadowUp01: y0e,
  shadowUp02: m0e,
  shadowUp03: g0e,
  shadowDown01: v0e,
  shadowDown02: k0e,
  shadowDown03: b0e,
  spacingInlineQuarck: x0e,
  spacingInlineNano: M0e,
  spacingInlineMicro: w0e,
  spacingInlineXxxs: C0e,
  spacingInlineXxs: S0e,
  spacingInlineXs: A0e,
  spacingInlineSm: O0e,
  spacingInlineMd: E0e,
  spacingInlineLg: I0e,
  spacingInlineXl: D0e,
  spacingInlineQuarckRem: T0e,
  spacingInlineNanoRem: N0e,
  spacingInlineMicroRem: P0e,
  spacingInlineXxxsRem: L0e,
  spacingInlineXxsRem: R0e,
  spacingInlineXsRem: V0e,
  spacingInlineSmRem: z0e,
  spacingInlineMdRem: B0e,
  spacingInlineLgRem: H0e,
  spacingInlineXlRem: $0e,
  spacingInsetNano: j0e,
  spacingInsetXs: F0e,
  spacingInsetSm: W0e,
  spacingInsetMd: q0e,
  spacingInsetLg: _0e,
  spacingInsetXl: G0e,
  spacingInsetNanoRem: Z0e,
  spacingInsetXsRem: X0e,
  spacingInsetSmRem: U0e,
  spacingInsetMdRem: Y0e,
  spacingInsetLgRem: J0e,
  spacingInsetXlRem: K0e,
  spacingSquishNano: Q0e,
  spacingSquishXs: efe,
  spacingSquishSm: tfe,
  spacingSquishMd: nfe,
  spacingSquishNanoRem: rfe,
  spacingSquishXsRem: afe,
  spacingSquishSmRem: ife,
  spacingSquishMdRem: ofe,
  spacingStackQuarck: sfe,
  spacingStackNano: cfe,
  spacingStackMicro: lfe,
  spacingStackXxxs: dfe,
  spacingStackXxs: ufe,
  spacingStackXs: hfe,
  spacingStackSm: pfe,
  spacingStackMd: ffe,
  spacingStackLg: yfe,
  spacingStackXl: mfe,
  spacingStackXxl: gfe,
  spacingStackXxxl: vfe,
  spacingStackHuge: kfe,
  spacingStackQuarckRem: bfe,
  spacingStackNanoRem: xfe,
  spacingStackMicroRem: Mfe,
  spacingStackXxxsRem: wfe,
  spacingStackXxsRem: Cfe,
  spacingStackXsRem: Sfe,
  spacingStackSmRem: Afe,
  spacingStackMdRem: Ofe,
  spacingStackLgRem: Efe,
  spacingStackXlRem: Ife,
  spacingStackXxlRem: Dfe,
  spacingStackXxxlRem: Tfe,
  spacingStackHugeRem: Nfe,
  fontFamilyLight: Pfe,
  fontFamilyRegular: Lfe,
  fontFamilyBold: Rfe,
  fontFamilySemibold: Vfe,
  fontFamilyMonospace: zfe,
  fontSizeXxl: Bfe,
  fontSizeXl: Hfe,
  fontSizeLg: $fe,
  fontSizeMd: jfe,
  fontSizeSm: Ffe,
  fontSizeXs: Wfe,
  fontSizeXxs: qfe,
  fontSizeXxxs: _fe,
  fontSizeNano: Gfe,
  fontSizeQuarck: Zfe,
  fontWeightLight: Xfe,
  fontWeightRegular: Ufe,
  fontWeightSemibold: Yfe,
  fontWeightBold: Jfe,
  lineHeightTight: Kfe,
  lineHeightFair: Qfe,
  lineHeightConfy: eye
}, j4e = ({
  isVisible: e = !1,
  minVisibleDistance: t = 666,
  zIndex: n = 5,
  bottom: r = "3%",
  right: a = "5%"
}) => {
  const [i, o] = fe(!1), s = () => {
    window.scroll(0, 0);
  };
  return be(() => {
    const c = () => {
      const l = document.documentElement, u = (window.pageYOffset || l.scrollTop) - (l.clientTop || 0);
      u && u > t ? o(!0) : o(!1);
    };
    return window.addEventListener("scroll", c), () => {
      window.removeEventListener("scroll", c);
    };
  }, [t]), !i || !e ? null : /* @__PURE__ */ C(
    lr,
    {
      iconName: "arrow-up",
      variant: "primary",
      isIconOnly: !0,
      onClick: s,
      style: {
        position: "fixed",
        bottom: r,
        right: a,
        zIndex: n,
        boxShadow: tye.shadowUp01
      }
    }
  );
}, nye = G.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`, rye = G.span`
  font-family: ${(e) => e.theme.fontFamilyRegular};
  font-size: ${(e) => e.theme.fontSizeQuarck};
  color: ${(e) => e.theme.colorSupportPositiveDark};
`, aye = G.span`
  font-family: ${(e) => e.theme.fontFamilySemibold};
  font-size: ${(e) => e.theme.fontSizeQuarck};
  color: ${(e) => e.theme.colorSupportPositiveDark};
  font-weight: ${(e) => e.theme.fontWeightBold};
`, iye = ({ currencySymbol: e, promo: t }) => /* @__PURE__ */ ie(nye, { "data-testid": "promo-item", children: [
  /* @__PURE__ */ C(rye, { children: t.description }),
  !!t.totalValue && /* @__PURE__ */ ie(aye, { children: [
    "-",
    e,
    " ",
    ea(t.totalValue)
  ] })
] }), oye = G.button`
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  margin: 0;
  width: 100%;
  color: ${(e) => e.theme.colorSupportPositiveMedium};
  font-weight: ${(e) => e.theme.fontWeightSemibold};

  &:focus {
    outline: none;
  }
`, sye = G.span`
  font-family: ${(e) => e.theme.fontFamilySemibold};
  font-size: ${(e) => e.theme.fontSizeQuarck};
  padding-top: ${(e) => e.theme.spacingStackNanoRem};
`, cye = G.div`
  background-color: ${(e) => e.theme.colorSupportPositiveLightest};
  padding: ${(e) => `${e.theme.spacingInsetXsRem} ${e.theme.spacingInsetSmRem}`};
  border-radius: ${(e) => e.theme.borderRadiusMd};
  margin: ${(e) => e.theme.spacingStackNanoRem} 0;
  display: flex;
  flex-direction: column;
  gap: ${(e) => e.theme.spacingStackNanoRem};
`, lye = ({ promos: e, currencySymbol: t }) => {
  const [n, r] = fe(!0), a = e.length, i = a > 1;
  return /* @__PURE__ */ ie("div", { children: [
    i && /* @__PURE__ */ ie(oye, { type: "button", onClick: () => {
      r(!n);
    }, children: [
      /* @__PURE__ */ C(sye, { children: "Ver descuentos aplicados" }),
      /* @__PURE__ */ C(ot, { size: "sm", name: n ? "caret-up" : "caret-down", weight: "bold" })
    ] }),
    /* @__PURE__ */ C(xx, { show: n && a > 0, unmountOnExit: !0, children: /* @__PURE__ */ C(cye, { role: "presentation", children: e.map((s, c) => /* @__PURE__ */ C(iye, { currencySymbol: t, promo: s }, `discount-${c}`)) }) })
  ] });
};
var Bh = /* @__PURE__ */ ((e) => (e.UNIT = "UND", e.PACKAGE = "PQT", e))(Bh || {});
const dye = (e) => e.map((r) => ({
  description: r.description,
  totalValue: r.totalValue || 0
})).some((r) => r.totalValue ?? r.totalValue > 0), bg = "data:image/png;base64,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", uye = G.div`
  height: 2.688rem;
  margin-right: 0.625rem;
  width: 100%;
  max-width: 2.813rem;

  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    object-position: center;
    mix-blend-mode: multiply;
  }
`, hye = G.picture`
  display: flex;
  height: 100%;
  width: 100%;
  text-align: center;
  position: relative;
`, pye = ({ imageUrl: e, displayName: t }) => {
  const [n, r] = fe(e);
  return /* @__PURE__ */ C(uye, { children: /* @__PURE__ */ C(hye, { children: /* @__PURE__ */ C(
    Vl,
    {
      src: n || bg,
      alt: t || "product-cover",
      onError: () => r(bg)
    }
  ) }) });
}, fye = G.div`
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`, yye = G.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`, mye = G.div`
  color: ${(e) => e.theme.colorNeutralDarkest};
  font-size: ${(e) => e.theme.fontSizeNano};
  font-weight: ${(e) => e.theme.fontWeightRegular};
  width: 100%;

  @media (min-width: 22.5rem) and (max-width: ${(e) => e.theme.gridBreakpointMobile}) {
    width: 80%;
  }
`, gye = G.div`
  margin-bottom: ${(e) => e.theme.spacingInsetXsRem};
  line-height: ${(e) => e.theme.lineHeightConfy};
  width: 18.75rem;
  padding-right: ${(e) => e.theme.spacingStackXxsRem};
  overflow: hidden;
  text-overflow: ellipsis;
`, vye = G.div`
  margin-bottom: ${(e) => e.theme.spacingStackQuarckRem};
  font-size: ${(e) => e.theme.fontSizeQuarck};
  color: ${(e) => e.theme.colorNeutralDark};

  i {
    transform: translate(0, 30%);
  }

  span {
    margin-left: ${(e) => e.theme.spacingStackNanoRem};
  }
`, kye = G.div`
  padding-top: ${(e) => e.theme.spacingStackNanoRem};
`, bye = G.div`
  font-size: ${(e) => e.theme.fontSizeNano};
  color: ${(e) => e.theme.colorNeutralDark};
  display: flex;
  align-self: flex-end;
  justify-content: space-between;
  width: 100%;
`, xye = G.span`
  ${(e) => e.hasDiscount ? "text-decoration-line: line-through;" : ""}
`, Mye = G.div`
  font-weight: ${(e) => e.theme.fontWeightBold};
  color: ${(e) => e.theme.colorNeutralDarkest};
  padding-right: ${(e) => e.theme.spacingStackQuarckRem};
`, wye = ({ product: e }) => {
  const {
    imageUrl: t,
    displayName: n,
    presentation: r,
    currencySymbol: a,
    unitPrice: i,
    quantity: o,
    finalPrice: s,
    promos: c,
    presentationType: l = Bh.UNIT
  } = e, u = l === Bh.UNIT ? "box-milk" : "package";
  return /* @__PURE__ */ ie(fye, { children: [
    /* @__PURE__ */ ie(yye, { children: [
      /* @__PURE__ */ C(pye, { imageUrl: t, displayName: n }),
      /* @__PURE__ */ ie(mye, { children: [
        /* @__PURE__ */ C(gye, { children: n }),
        /* @__PURE__ */ ie(vye, { children: [
          /* @__PURE__ */ C(ot, { "data-testid": "icon-presentation", size: "sm", name: u }),
          /* @__PURE__ */ C("span", { children: r })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ C(lye, { promos: c, currencySymbol: a }),
    /* @__PURE__ */ C(kye, { children: /* @__PURE__ */ ie(bye, { children: [
      /* @__PURE__ */ ie("span", { children: [
        a,
        " ",
        /* @__PURE__ */ C(xye, { "data-testid": "unit-price", hasDiscount: dye(c), children: ea(i) }),
        " ",
        "x ",
        o,
        " ",
        o > 1 ? "Unidades" : "Unidad",
        " "
      ] }),
      /* @__PURE__ */ ie(Mye, { children: [
        "Total: ",
        a,
        " ",
        ea(s)
      ] })
    ] }) })
  ] });
}, $r = "39rem", Cye = G.div`
  position: relative;
  background-color: ${(e) => e.theme.colorNeutralLightest};
  @media (min-width: ${$r}) {
    border-radius: ${(e) => e.theme.borderRadiusLg};
  }
`, Sye = G.div`
  font-size: ${(e) => e.theme.fontSizeXxxs};
  font-weight: ${(e) => e.theme.fontWeightBold};
  margin: ${(e) => `${e.theme.spacingStackXxsRem} ${e.theme.spacingStackXxsRem}`};
`, Aye = G.div`
  padding: ${(e) => `${e.theme.spacingStackXsRem} ${e.theme.spacingStackXsRem} ${e.theme.spacingStackXxsRem} ${e.theme.spacingStackXsRem}`};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  z-index: 10;
  box-shadow: ${(e) => e.theme.shadowDown02};

  @media (min-width: ${$r}) {
    height: 100%;
  }
`, Oye = G.h1`
  font-size: ${(e) => e.theme.fontSizeXs};
  font-weight: ${(e) => e.theme.fontWeightBold};
  line-height: ${(e) => e.theme.lineHeightFair};
  font-style: normal;

  @media (min-width: ${$r}) {
    font-size: ${(e) => e.theme.fontSizeXs};
    font-weight: ${(e) => e.theme.fontWeightBold};
    line-height: ${(e) => e.theme.lineHeightTight};
  }
`, Eye = G.div`
  padding-top: 0.688rem;
  font-size: ${(e) => e.theme.fontSizeNano};
  font-weight: ${(e) => e.theme.fontWeightRegular};
  line-height: 0.875rem;
  color: ${(e) => e.theme.colorNeutralDarkest};
  margin-bottom: ${(e) => e.theme.spacingInlineXxxsRem};

  @media (min-width: ${$r}) {
    line-height: ${(e) => e.theme.lineHeightConfy};
    padding-top: ${(e) => e.theme.spacingStackNanoRem};
  }
`, tu = G.span`
  padding-right: 0.763rem;

  @media (min-width: ${$r}) {
    padding-right: ${(e) => e.theme.spacingStackXxxsRem};
  }
`, Iye = G.div`
  gap: ${(e) => e.theme.spacingInlineQuarckRem};
  font-size: ${(e) => e.theme.fontSizeNano};
  margin-bottom: ${(e) => e.theme.spacingInlineQuarckRem};

  @media (min-width: ${(e) => e.theme.gridBreakpointMobile}) {
    display: flex;
  }
`, Dye = G.p`
  color: ${(e) => e.theme.colorNeutralDarkest};
`, Tye = G.p`
  color: ${(e) => e.theme.colorNeutralDark};
`, Nye = G.div`
  position: absolute;
  height: 0;
  width: 0;
  top: 1rem;
  right: 3.5rem;
  padding: 0;

  .dl-btn-icon-only:not(.dl-btn-interactive).dl-btn-md {
    color: ${(e) => e.theme.colorNeutralDarkest};
  }
`, Pye = G.div`
  scrollbar-width: thin;
  scrollbar-color: ${(e) => `${e.theme.colorNeutralDark} ${e.theme.colorNeutralMedium}`};
  overflow-y: auto;
  overflow-x: hidden;

  max-height: 22rem;
  padding: ${(e) => `${e.platform === "BO" ? e.theme.spacingInlineNanoRem : e.theme.spacingInlineXsRem} ${e.theme.spacingInlineXsRem} 0;`}
  

  &::-webkit-scrollbar {
    width: 0.25rem;
  }
  &::-webkit-scrollbar-track {
    background-color: ${(e) => e.theme.colorNeutralMedium};
    border-radius: ${(e) => e.theme.borderRadiusLg};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${(e) => e.theme.colorNeutralDark};
    border-radius: ${(e) => e.theme.borderRadiusLg};
  }
`, Lye = G.div`
  font-size: ${(e) => e.theme.fontSizeNano};
  line-height: ${(e) => e.theme.lineHeightFair};
  color: ${(e) => e.theme.colorNeutralDarkest};
  width: 100%;

  ${(e) => e.platform === "MKP" ? `box-shadow: ${e.theme.shadowUp02};` : ""}
  padding: ${(e) => `${e.platform === "BO" ? 0 : e.theme.spacingStackXxsRem} ${e.theme.spacingStackXsRem} ${e.theme.spacingStackXxsRem} ${e.theme.spacingStackXsRem}`};

  @media (min-width: ${$r}) {
    font-weight: ${(e) => e.theme.fontFamilyRegular};
  }
`, xg = G.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: ${(e) => e.theme.spacingStackNanoRem};
`, nu = G.span`
  font-weight: ${(e) => e.theme.fontFamilyBold};
`, Rye = G.div`
  display: flex;
  justify-content: space-between;
  color: ${(e) => e.theme.colorNeutralDarkest};
  padding-bottom: ${(e) => e.theme.spacingStackNanoRem};
  color: ${(e) => e.theme.colorSupportPositiveMedium};
`, Vye = G.div`
  display: flex;
  justify-content: space-between;
  font-weight: ${(e) => e.theme.fontWeightBold};
  color: ${(e) => e.theme.colorNeutralDarkest};
  padding-bottom: ${(e) => e.theme.spacingStackNanoRem};
`, zye = G.div`
  display: flex;
  justify-content: space-between;
  font-weight: ${(e) => e.theme.fontWeightBold};
  color: ${(e) => e.theme.colorNeutralDarkest};
  padding-bottom: ${(e) => e.theme.spacingStackXxxsRem};
  font-size: ${(e) => e.theme.fontSizeXxxs};
`, Bye = G.div`
  display: flex;
  justify-content: space-between;
  font-weight: ${(e) => e.theme.fontWeightBold};
  font-size: ${(e) => e.theme.fontSizeXxxs};
  color: ${(e) => e.theme.colorNeutralDarkest};
  padding-top: ${(e) => e.theme.spacingInlineXxxs};
  padding-bottom: ${(e) => e.theme.spacingInlineXxxsRem};

  @media (min-width: ${$r}) {
    padding-top: ${(e) => e.theme.spacingStackNanoRem};
  }
`, Hye = G.hr`
  margin-top: ${(e) => e.theme.spacingStackXxsRem};
  margin-bottom: ${(e) => e.theme.spacingInlineXxsRem};

  @media screen and (min-width: ${$r}) {
    margin-top: ${(e) => e.theme.spacingStackNanoRem};
    margin-bottom: ${(e) => e.theme.spacingInlineXxxsRem};
  }
`, F4e = ({ orderDetail: e, platform: t, onBack: n }) => {
  const {
    id: r,
    totalCountProducts: a,
    descriptionTotalDiscount: i = "Total de descuentos",
    totalDiscount: o,
    products: s,
    currencySymbol: c,
    subTotal: l,
    perception: u,
    finalTotal: h,
    paymentType: p,
    deliveryDate: f,
    address: y
  } = e, m = o !== null && o > 0, v = () => {
    switch (t) {
      case "BO":
        return /* @__PURE__ */ C(Sye, { children: "Detalle de pedidos" });
      case "MKP":
        return /* @__PURE__ */ ie(Aye, { children: [
          /* @__PURE__ */ ie("div", { children: [
            /* @__PURE__ */ C(Oye, { className: "main", children: `Pedido N° ${r}` }),
            /* @__PURE__ */ ie(Eye, { children: [
              /* @__PURE__ */ C(tu, { children: ` ${a} productos ` }),
              /* @__PURE__ */ C(tu, { children: " | " }),
              /* @__PURE__ */ ie(tu, { children: [
                "Fecha de entrega: ",
                f
              ] })
            ] }),
            /* @__PURE__ */ ie(Iye, { children: [
              /* @__PURE__ */ C(Dye, { children: "Dirección de entrega: " }),
              /* @__PURE__ */ C(Tye, { children: y })
            ] })
          ] }),
          /* @__PURE__ */ C(Nye, { children: /* @__PURE__ */ C(lr, { variant: "tertiary", title: "close", isIconOnly: !0, iconName: "x", size: "md", onClick: n }) })
        ] });
      default:
        return null;
    }
  }, k = () => /* @__PURE__ */ ie(xg, { children: [
    /* @__PURE__ */ C("span", { children: " Percepción " }),
    /* @__PURE__ */ C(nu, { children: `${c} ${ea(u)}` })
  ] }), b = () => t === "MKP" && /* @__PURE__ */ ie(da, { children: [
    /* @__PURE__ */ C(Hye, {}),
    /* @__PURE__ */ ie(xg, { children: [
      /* @__PURE__ */ C("span", { children: " Método de pago " }),
      /* @__PURE__ */ ie(nu, { children: [
        " ",
        p,
        " "
      ] })
    ] })
  ] });
  return /* @__PURE__ */ ie(Cye, { children: [
    v(),
    /* @__PURE__ */ C(Pye, { platform: t, children: s.map((x, g) => /* @__PURE__ */ ie("div", { children: [
      /* @__PURE__ */ C(wye, { product: x }),
      /* @__PURE__ */ C("hr", {})
    ] }, `${x.id} - ${g}`)) }),
    /* @__PURE__ */ ie(Lye, { platform: t, children: [
      t === "BO" && /* @__PURE__ */ C("hr", {}),
      /* @__PURE__ */ C(zye, { children: /* @__PURE__ */ C("span", { children: "Resumen del Pedido" }) }),
      /* @__PURE__ */ ie(Vye, { children: [
        /* @__PURE__ */ C("span", { children: "Sub total (Inc. IGV):" }),
        /* @__PURE__ */ C("span", { children: `${c} ${ea(l)}` })
      ] }),
      k(),
      /* @__PURE__ */ ie(Rye, { children: [
        /* @__PURE__ */ C("span", { children: i }),
        /* @__PURE__ */ ie(nu, { children: [
          m && "-",
          " ",
          c,
          " ",
          ea(o)
        ] })
      ] }),
      /* @__PURE__ */ ie(Bye, { children: [
        /* @__PURE__ */ C("span", { children: "Total " }),
        /* @__PURE__ */ ie("span", { children: [
          c,
          " ",
          ea(h)
        ] })
      ] }),
      b()
    ] })
  ] });
}, $ye = G.img`
  ${(e) => e.variant !== "horizontal" && `margin: ${e.theme.spacingStackMicro}`};
  mix-blend-mode: ${(e) => e.active ? "darken" : "multiply"};
  transition: transform 0.25s ease;
  transform: ${(e) => e.counterExpanded ? "scale(0.652) translateY(calc(-37.5% + 16px))" : "scale(1)"};
  ${(e) => e.variant === "simplified" && "overflow: clip"};
  opacity: ${(e) => e.active ? "100%" : "50%"};
`, N2 = (e) => {
  const { active: t = !0, counterExpanded: n = !1, defaultImageSrc: r, imageSrc: a, variant: i = "default", ...o } = e, [s, c] = fe(a);
  return /* @__PURE__ */ C(
    $ye,
    {
      active: t,
      "data-testid": "product-image",
      src: s ?? r,
      variant: i,
      counterExpanded: n,
      onError: () => c(r),
      ...o
    }
  );
}, jye = G.div`
  color: ${(e) => e.theme.colorSupportPositiveMedium};
  display: flex;
  align-items: center;

  & p {
    font-size: ${(e) => e.theme.fontSizeNano};
    margin: 0 0 0 ${(e) => e.theme.spacingInlineQuarckRem};
  }
`, P2 = (e) => {
  const {
    infoLine: { icon: t, text: n }
  } = e;
  return /* @__PURE__ */ ie(jye, { "data-testid": "info-line", children: [
    t && /* @__PURE__ */ C(ot, { name: t, size: "sm", "data-testid": "info-icon" }),
    /* @__PURE__ */ C("p", { children: n })
  ] });
}, Fye = G.div`
  color: ${(e) => e.theme.colorSupportNegativeMedium};
  display: flex;
  & p {
    font-size: ${(e) => e.theme.fontSizeNano};
    margin: 0 0 0 ${(e) => e.theme.spacingInlineQuarckRem};
  }
`, q3 = (e) => {
  const { children: t } = e;
  return /* @__PURE__ */ ie(Fye, { "data-testid": "max-sale-qty-alert", children: [
    /* @__PURE__ */ C(ot, { name: "info", size: "sm", "data-testid": "info-icon" }),
    /* @__PURE__ */ C("p", { children: t })
  ] });
}, Wye = (e, t) => t ? t > e ? e : t : e, Mg = (e, t = 2) => {
  if (e == null)
    return "0.00";
  const n = 10 ** t, r = Math.round(e * n) / n, a = r == null ? void 0 : r.toFixed(t).split(".");
  return a[0] = a[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","), a.join(".");
}, qye = G.div`
  width: 100%;
  ${(e) => e.variant === "horizontal" ? { display: "flex", "flex-direction": "column" } : { display: "grid", "grid-template-columns": "auto", "justify-content": "flex-start" }};
`, _ye = G.div`
  display: ${(e) => e.variant === "horizontal" ? "contents" : "block"};
`, Gye = G.span`
  display: 'inline';
  color: ${(e) => e.hasDiscount ? e.theme.colorSupportPositiveMedium : e.theme.colorNeutralDarkest};
  font-size: ${(e) => e.variant === "horizontal" ? e.theme.fontSizeNano : e.theme.fontSizeXxxs};
  font-family: ${(e) => e.theme.fontFamilyBold};
  font-weight: ${(e) => e.theme.fontWeightBold};
  line-height: ${(e) => e.variant === "horizontal" ? e.theme.lineHeightConfy : e.theme.lineHeightFair};
  margin-right: ${(e) => e.theme.spacingInlineNanoRem};
`, Zye = G.span`
  display: inline;
  color: ${(e) => e.theme.colorNeutralDark};
  font-size: ${(e) => e.theme.fontSizeQuarck};
  font-style: normal;
  font-weight: ${(e) => e.theme.fontWeightRegular};
  line-height: ${(e) => e.theme.lineHeightFair};
  text-decoration-line: line-through;
`, L2 = (e) => {
  const { currencySymbol: t, finalPrice: n, hasDiscount: r, regularPrice: a, variant: i = "default" } = e;
  return /* @__PURE__ */ C(qye, { variant: i, children: /* @__PURE__ */ ie(_ye, { variant: i, children: [
    /* @__PURE__ */ ie(Gye, { hasDiscount: r, variant: i, "data-testid": "final-price", children: [
      t,
      " ",
      Mg(n)
    ] }),
    r && /* @__PURE__ */ ie(Zye, { "data-testid": "regular-price", children: [
      t,
      " ",
      Mg(a)
    ] })
  ] }) });
};
var po = /* @__PURE__ */ ((e) => (e.POSITIVE = "positive", e.NEGATIVE = "negative", e.NEUTRAL = "neutral", e))(po || {});
const Xye = G.div`
  opacity: ${(e) => !e.active && "50%"};
  ${(e) => e.variant === "horizontal" ? {
  left: 0,
  top: 0,
  "text-align": "left",
  position: "relative",
  "z-index": "1"
} : {
  left: 0,
  top: 0,
  "text-align": "left",
  position: "absolute",
  "z-index": "1"
}}
`, Uye = G.div`
  display: flex;
  flex-direction: ${(e) => e.variant === "horizontal" ? "row" : "column"};
  align-items: normal;
`, Yye = G.label`
  z-index: 1;
  border-radius: ${(e) => e.variant === "horizontal" ? e.theme.borderRadiusSm : "0"};
  font-size: 0.65rem;
  background-color: ${(e) => {
  switch (e.tag.type) {
    case po.POSITIVE:
      return e.theme.colorSupportPositiveMedium;
    case po.NEGATIVE:
      return e.theme.colorSupportNegativeMedium;
    case po.NEUTRAL:
      return e.theme.colorNeutralDark;
    default:
      return e.theme.colorNeutralLightest;
  }
}};
  align-items: center;
  color: ${(e) => e.theme.colorNeutralLightest};
  display: inline-flex;
  font-family: ${(e) => e.theme.fontFamilyRegular};
  font-weight: ${(e) => e.theme.fontWeightRegular};
  justify-content: center;
  line-height: 0.625rem;
  margin: 0;
  margin-right: ${(e) => e.variant === "horizontal" ? e.theme.spacingInlineQuarckRem : "0"};
  margin-bottom: 0.125rem;
  min-height: 1.25rem;
  padding: 0.275rem 0.375rem;
  text-align: ${(e) => e.tag.align};
  white-space: pre-wrap;
  max-width: ${(e) => e.variant === "horizontal" ? "10rem" : "5rem"};

  &:last-child {
    ${(e) => {
  if (e.variant !== "horizontal")
    return { "border-bottom-right-radius": e.theme.borderRadiusMd };
}}
  }

  &:first-child {
    ${(e) => {
  if (e.variant !== "horizontal")
    return { "border-top-left-radius": e.theme.borderRadiusMd };
}}
  }
`, Jye = (e) => {
  const { tag: t } = e, { labelText: n } = t;
  return /* @__PURE__ */ C(Yye, { ...e, "aria-label": n, children: n });
}, R2 = ({ enoughStock: e, tags: t, variant: n = "default", active: r = !0, ...a }) => {
  const i = e ? [] : [{ type: po.NEUTRAL, labelText: "Sin stock" }], o = [...t, ...i];
  return /* @__PURE__ */ C(Xye, { active: r, ...a, variant: n, children: /* @__PURE__ */ C(Uye, { variant: n, children: o.map((s, c) => /* @__PURE__ */ C(Jye, { tag: s, variant: n }, `tag-${c}${s.labelText}`)) }) });
};
var Yi = /* @__PURE__ */ ((e) => (e.MAXIMUM_SALE_QUANTITY = "maximumSaleQuantity", e.STOCK = "stock", e.NONE = "", e))(Yi || {});
const Kye = (e) => {
  const { maximumSaleQuantity: t, minimumSaleQuantity: n = 1, quantity: r, stock: a } = e, [i, o] = fe(Yi.NONE);
  return be(() => {
    t && t === r && t <= a ? o(Yi.MAXIMUM_SALE_QUANTITY) : a >= n && a === r ? o(Yi.STOCK) : o(Yi.NONE);
  }, [t, n, r, a]), {
    alertMaximumReached: i,
    maxPossibleSaleQty: Wye(a, t)
  };
};
var Hh = /* @__PURE__ */ new Map(), Qs = /* @__PURE__ */ new WeakMap(), wg = 0, Qye = void 0;
function eme(e) {
  return e ? (Qs.has(e) || (wg += 1, Qs.set(e, wg.toString())), Qs.get(e)) : "0";
}
function tme(e) {
  return Object.keys(e).sort().filter(
    (t) => e[t] !== void 0
  ).map((t) => `${t}_${t === "root" ? eme(e.root) : e[t]}`).toString();
}
function nme(e) {
  const t = tme(e);
  let n = Hh.get(t);
  if (!n) {
    const r = /* @__PURE__ */ new Map();
    let a;
    const i = new IntersectionObserver((o) => {
      o.forEach((s) => {
        var c;
        const l = s.isIntersecting && a.some((u) => s.intersectionRatio >= u);
        e.trackVisibility && typeof s.isVisible > "u" && (s.isVisible = l), (c = r.get(s.target)) == null || c.forEach((u) => {
          u(l, s);
        });
      });
    }, e);
    a = i.thresholds || (Array.isArray(e.threshold) ? e.threshold : [e.threshold || 0]), n = {
      id: t,
      observer: i,
      elements: r
    }, Hh.set(t, n);
  }
  return n;
}
function rme(e, t, n = {}, r = Qye) {
  if (typeof window.IntersectionObserver > "u" && r !== void 0) {
    const c = e.getBoundingClientRect();
    return t(r, {
      isIntersecting: r,
      target: e,
      intersectionRatio: typeof n.threshold == "number" ? n.threshold : 0,
      time: 0,
      boundingClientRect: c,
      intersectionRect: c,
      rootBounds: c
    }), () => {
    };
  }
  const { id: a, observer: i, elements: o } = nme(n), s = o.get(e) || [];
  return o.has(e) || o.set(e, s), s.push(t), i.observe(e), function() {
    s.splice(s.indexOf(t), 1), s.length === 0 && (o.delete(e), i.unobserve(e)), o.size === 0 && (i.disconnect(), Hh.delete(a));
  };
}
function ame({
  threshold: e,
  delay: t,
  trackVisibility: n,
  rootMargin: r,
  root: a,
  triggerOnce: i,
  skip: o,
  initialInView: s,
  fallbackInView: c,
  onChange: l
} = {}) {
  var u;
  const [h, p] = ne.useState(null), f = ne.useRef(), [y, m] = ne.useState({
    inView: !!s,
    entry: void 0
  });
  f.current = l, ne.useEffect(
    () => {
      if (o || !h)
        return;
      let x;
      return x = rme(
        h,
        (g, w) => {
          m({
            inView: g,
            entry: w
          }), f.current && f.current(g, w), w.isIntersecting && i && x && (x(), x = void 0);
        },
        {
          root: a,
          rootMargin: r,
          threshold: e,
          // @ts-ignore
          trackVisibility: n,
          // @ts-ignore
          delay: t
        },
        c
      ), () => {
        x && x();
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(e) ? e.toString() : e,
      h,
      a,
      r,
      i,
      o,
      n,
      c,
      t
    ]
  );
  const v = (u = y.entry) == null ? void 0 : u.target, k = ne.useRef();
  !h && v && !i && !o && k.current !== v && (k.current = v, m({
    inView: !!s,
    entry: void 0
  }));
  const b = [p, y.inView, y.entry];
  return b.ref = b[0], b.inView = b[1], b.entry = b[2], b;
}
const V2 = (e, t) => ke`
  word-wrap: break-word;
  background: ${(n) => n.theme.colorNeutralLightest};
  background-clip: content-box;
  display: grid;
  position: relative;
  width: 13rem;
  row-gap: ${(n) => n.theme.spacingStackNanoRem};
  ${() => {
  if (!t)
    return {
      "pointer-events": "none"
    };
  if (!e)
    return {
      "-webkit-filter": "grayscale(1)",
      filter: "grayscale(1)",
      "pointer-events": "none"
    };
}}
  &:hover {
    box-shadow: ${(n) => e ? n.theme.shadowDown01 : "none"};
  }
`, z2 = ke`
  align-items: center;
  background: ${(e) => e.theme.colorNeutralLight};
  border-radius: ${(e) => e.theme.borderRadiusMd};
  display: flex;
  justify-content: center;
  position: relative;
`, B2 = ke`
  display: grid;
  grid-template-rows: auto;
  margin-bottom: auto;
`, H2 = G.p`
  color: ${(e) => e.theme.colorNeutralDarkest};
  font-family: ${(e) => e.theme.fontFamilyBold};
  font-size: ${(e) => e.theme.fontSizeNano};
  line-height: ${(e) => e.theme.lineHeightFair};
  margin-bottom: ${(e) => e.theme.spacingStackQuarckRem};
  font-weight: ${(e) => e.theme.fontWeightBold};
  word-break: break-word;
`, $2 = G.p`
  color: ${(e) => e.theme.colorNeutralDarkest};
  font-family: ${(e) => e.theme.fontFamilyRegular};
  font-size: ${(e) => e.theme.fontSizeQuarck};
  line-height: ${(e) => e.theme.lineHeightFair};
  margin-bottom: ${(e) => e.theme.spacingStackNanoRem};
`, j2 = G.div`
  opacity: ${(e) => !e.active && "50%"};
`, ime = G.div`
  display: grid;
  grid-template-columns: 1fr 140px;
  margin-bottom: auto;
  justify-content: flex-start;
`, F2 = ke`
  background-color: ${(e) => e.theme.colorSupportWarningLightest};
  border: ${(e) => e.theme.borderWidthHairline} solid ${(e) => e.theme.colorSupportWarningMedium};
  border-radius: ${(e) => e.theme.borderRadiusSm};
  color: ${(e) => e.theme.colorSupportWarningDark};
  font-size: ${(e) => e.theme.fontSizeQuarck};
  line-height: ${(e) => e.theme.lineHeightTight};
  padding: ${(e) => e.theme.spacingInsetNanoRem} 0;
  position: absolute;
  text-align: center;
  width: 90%;
  display: block;
  z-index: 1;
`, W2 = G.p`
  color: ${(e) => e.theme.colorSupportWarningDark};
  font-size: ${(e) => e.theme.fontSizeQuarck};
  margin-bottom: ${(e) => e.theme.spacingStackQuarckRem};
`, q2 = G.div`
  color: ${(e) => e.theme.colorSupportNegativeMedium};
  font-weight: ${(e) => e.theme.fontWeightSemibold};
  font-size: 0.875rem;
  text-align: center;
`, ome = G.article`
  ${(e) => V2(e.hasStock, e.active)}

  padding:  ${(e) => e.theme.spacingInsetSmRem};
  transition: box-shadow 0.2s ease-in;
  height: 22rem;
  border-radius: ${(e) => e.theme.borderRadiusLg};
  grid-template-rows: auto 1fr;
`, sme = G.div`
  ${z2}

  height: 11rem;
  & img {
    max-width: 8rem;
    max-height: 8rem;
  }
`, cme = G.div`
  ${B2}
`, lme = G.div`
  ${F2}
`, Cg = (e, t) => {
  const n = he(!0);
  be(() => {
    if (n.current)
      n.current = !1;
    else
      return e();
  }, t);
};
var ta = /* @__PURE__ */ ((e) => (e.KEYBOARD = "keyboard", e.MOUSE = "mouse", e))(ta || {});
const Sg = /\D/, _3 = (e, t, n) => {
  e === "" && n(t);
}, G3 = (e) => {
  const { onInputChange: t, inputValue: n, maxPossibleSaleQty: r, minimumSaleQuantity: a, quantity: i, setInputValue: o, isLoading: s } = e, l = n === "" ? n : ((u) => u < a && u > 0 ? a : u > r ? r : u)(+n).toString();
  o(l), +l !== i && l !== "" && !s && t(+l);
}, dme = (e) => {
  const {
    onInputChange: t,
    inputValue: n,
    isLoading: r,
    maxPossibleSaleQty: a,
    minimumSaleQuantity: i = 1,
    quantity: o,
    setInputValue: s,
    setInteractionOrigin: c
  } = e;
  return { onChange: (v) => {
    Sg.test(v.target.value) || s(v.target.value.replace(Sg, ""));
  }, onBlur: () => {
    _3(n, o.toString(), s);
  }, onInputClick: (v) => {
    v.stopPropagation();
  }, onDecrementClick: (v) => {
    v.stopPropagation(), c(ta.MOUSE), +n === i ? s("0") : s((+n - 1).toString());
  }, onIncrementClick: (v) => {
    v.stopPropagation(), c(ta.MOUSE), s((+n + 1).toString());
  }, onKeyDown: (v) => {
    c(ta.KEYBOARD), v.key === "Enter" && (n === "" ? s("0") : G3({
      inputValue: n,
      isLoading: r,
      maxPossibleSaleQty: a,
      minimumSaleQuantity: i,
      onInputChange: t,
      quantity: o,
      setInputValue: s
    }));
  }, onFirstAddButtonClick: (v) => {
    v.stopPropagation(), c(ta.MOUSE), s(i.toString());
  } };
}, ume = (e) => {
  const { active: t, expandCounter: n, inputValue: r, quantity: a, variant: i } = e, [o, s] = fe(!1), c = i === "simplified";
  return be(() => {
    s((a >= 1 || +r >= 1) && !c && t);
  }, [t, r, c, a]), be(() => {
    n && n(o);
  }, [n, o]), { isCounterExpanded: o };
}, hme = 800, pme = 300, fme = 5e3, yme = (e) => {
  const {
    clickingDelay: t,
    inputValue: n,
    interactionOrigin: r,
    isLoading: a,
    maxPossibleSaleQty: i,
    minimumSaleQuantity: o = 1,
    onInputChange: s,
    quantity: c,
    setInputValue: l,
    typingDelay: u
  } = e;
  o0(
    () => {
      _3(n, c.toString(), l);
    },
    fme,
    [n]
  ), o0(
    () => G3({
      onInputChange: s,
      inputValue: n,
      maxPossibleSaleQty: i,
      minimumSaleQuantity: o,
      quantity: c,
      setInputValue: l,
      isLoading: a
    }),
    r === ta.KEYBOARD ? u : t,
    [n]
  );
}, mme = (e, t, n) => {
  if (t)
    return n === "lg" ? e.spacingInlineLgRem : n === "md" ? e.spacingInlineMdRem : e.spacingInlineSmRem;
  if (!t)
    return n === "lg" ? "12rem" : n === "md" ? "10rem" : "9.5rem";
}, Z3 = (e, t) => t === "lg" ? e.spacingInlineLgRem : t === "md" ? e.spacingInlineMdRem : e.spacingInlineSmRem, gme = G.div`
  display: flex;
  justify-content: flex-end;
  padding: ${(e) => e.variant === "horizontal" ? "0" : e.theme.spacingStackNanoRem};
`, vme = G.div`
  display: flex;
  min-width: auto;
  align-items: center;
`, Ag = G(lr)`
  height: ${(e) => Z3(e.theme, e.size)};
`, kme = G(c2e)`
  margin: 0 ${(e) => e.theme.spacingInlineNanoRem};
  line-height: ${(e) => e.theme.lineHeightTight};
  text-align: center;
  background-color: ${(e) => e.theme.colorNeutralLightest};
  width: ${(e) => {
  switch (e.inputSize) {
    case "lg":
      return "4.9rem";
    case "sm":
      return "3.7rem";
    case "md":
    default:
      return "3.75rem";
  }
}};
`, bme = G(lr)`
  &::before {
    position: relative;
    right: 0;
  }
  height: ${(e) => Z3(e.theme, e.size)};
  width: ${(e) => mme(e.theme, e.isIconOnly, e.size)};
  display: ${(e) => e.hidden ? "none" : "flex"};
  justify-content: center;
`, _2 = (e) => {
  const {
    active: t = !0,
    clickingDelay: n = pme,
    expandCounter: r = () => {
    },
    isLoading: a,
    label: i,
    maxPossibleSaleQty: o,
    minimumSaleQuantity: s = 1,
    onAbort: c,
    onInputChange: l,
    quantity: u = 0,
    size: h = "sm",
    typingDelay: p = hme,
    variant: f = "default",
    ...y
  } = e, [m, v] = fe(u.toString()), [k, b] = fe(ta.MOUSE);
  yme({
    clickingDelay: n,
    inputValue: m,
    interactionOrigin: k,
    isLoading: a,
    maxPossibleSaleQty: o,
    minimumSaleQuantity: s,
    onInputChange: l,
    quantity: u,
    setInputValue: v,
    typingDelay: p
  });
  const { isCounterExpanded: x } = ume({ active: t, quantity: u, inputValue: m, variant: f, expandCounter: r }), { onChange: g, onBlur: w, onDecrementClick: M, onIncrementClick: S, onKeyDown: D, onFirstAddButtonClick: A, onInputClick: $ } = dme({
    isLoading: a,
    inputValue: m,
    maxPossibleSaleQty: o,
    minimumSaleQuantity: s,
    onInputChange: l,
    quantity: u,
    setInputValue: v,
    setInteractionOrigin: b
  });
  return Cg(() => {
    a || v(u.toString());
  }, [a, u]), Cg(
    () => () => {
      c && c();
    },
    [m]
  ), /* @__PURE__ */ C(gme, { variant: f, ...y, children: x ? /* @__PURE__ */ ie(vme, { "data-testid": "full-counter", children: [
    /* @__PURE__ */ C(
      Ag,
      {
        "aria-label": "Disminuir cantidad",
        variant: "secondary",
        onClick: M,
        size: h,
        iconName: +m === s ? "trash" : "minus",
        disabled: +m <= 0 || a,
        isLoading: a,
        isIconOnly: !0
      }
    ),
    /* @__PURE__ */ C(
      kme,
      {
        "aria-label": "Caja de texto",
        value: m,
        onBlur: w,
        onChange: g,
        disabled: a,
        type: "tel",
        inputSize: h,
        onKeyDown: D,
        onClick: $
      }
    ),
    /* @__PURE__ */ C(
      Ag,
      {
        "aria-label": "Aumentar cantidad",
        variant: "primary",
        onClick: S,
        size: h,
        iconName: "plus",
        isLoading: a,
        disabled: +m <= 0 || a || +m === o,
        isIconOnly: !0
      }
    )
  ] }) : /* @__PURE__ */ C(
    bme,
    {
      hidden: !t,
      "data-testid": "single-button",
      variant: "primary",
      hasIcon: i ? "left" : void 0,
      iconName: "plus",
      onClick: A,
      isLoading: a,
      size: h,
      disabled: !t,
      isIconOnly: !i,
      children: i
    }
  ) });
}, xme = Ae((e, t) => {
  const {
    active: n,
    alertMaximumReached: r,
    clickingDelay: a,
    defaultImageSrc: i,
    infoLine: o,
    isLoading: s,
    typingDelay: c,
    maxPossibleSaleQty: l,
    maximumSaleQuantityText: u,
    minimumSaleQuantityText: h,
    onAbort: p,
    onCardClick: f,
    onChangeQuantity: y,
    outOfStockText: m,
    product: v,
    quantity: k,
    tags: b,
    ...x
  } = e, {
    currencySymbol: g,
    finalPrice: w,
    hasDiscount: M,
    image: S,
    minimumSaleQuantity: D = 1,
    title: A,
    subtitle: $,
    regularPrice: F,
    stock: Z
  } = v, [B, O] = fe(!1), I = "default", N = Z >= D, R = { active: n, hasStock: N };
  return /* @__PURE__ */ ie(ome, { ref: t, ...R, ...x, "data-testid": "container", ...xs(f), children: [
    /* @__PURE__ */ ie(sme, { ...R, role: "button", children: [
      /* @__PURE__ */ C(R2, { active: n, enoughStock: Z >= D, tags: b }),
      r === "stock" && /* @__PURE__ */ C(lme, { "data-testid": "max-stock-alert", children: m }),
      /* @__PURE__ */ C(
        N2,
        {
          active: n,
          alt: A,
          imageSrc: S,
          counterExpanded: B,
          defaultImageSrc: i
        },
        S
      ),
      /* @__PURE__ */ C(
        _2,
        {
          active: N && n,
          clickingDelay: a,
          expandCounter: O,
          isLoading: s,
          maxPossibleSaleQty: l,
          minimumSaleQuantity: D,
          onAbort: p,
          onInputChange: (L) => y(L, L < k),
          quantity: k,
          size: "sm",
          style: { position: "absolute", right: "0", bottom: "0" },
          typingDelay: c,
          variant: I
        }
      )
    ] }),
    /* @__PURE__ */ ie(cme, { children: [
      /* @__PURE__ */ ie(j2, { active: n, children: [
        r === "maximumSaleQuantity" && /* @__PURE__ */ C(q3, { children: u }),
        o && /* @__PURE__ */ C(P2, { infoLine: o }),
        /* @__PURE__ */ C(H2, { children: A }),
        /* @__PURE__ */ C($2, { children: $ }),
        D > 1 && /* @__PURE__ */ C(W2, { children: h })
      ] }),
      n ? /* @__PURE__ */ C(
        L2,
        {
          currencySymbol: g,
          finalPrice: w,
          hasDiscount: M,
          regularPrice: F
        }
      ) : /* @__PURE__ */ C(q2, { children: "No se puede comprar" })
    ] })
  ] });
}), Mme = G.article`
  ${(e) => V2(e.hasStock, e.active)}

  padding: ${(e) => e.theme.spacingInsetXsRem};
  transition: none 0s ease;
  border-radius: ${(e) => e.theme.borderRadiusMd};
  max-width: 100%;
  min-width: 20rem;
  grid-template-rows: auto;
  column-gap: ${(e) => e.theme.spacingInsetXsRem};
  grid-template-columns: 64px 1fr;
  margin: -${(e) => e.theme.spacingInsetXsRem};
`, wme = G.div`
  ${z2}

  & img {
    width: 4rem;
    max-height: 4rem;
    transform: none;
  }
`, Cme = G.div`
  ${B2}
  gap: ${(e) => e.theme.spacingStackQuarckRem};
  & input {
    max-width: 2.75rem;
  }
`, Sme = G.div`
  ${F2}
  bottom: ${(e) => e.theme.spacingStackNanoRem};
`, Ame = Ae((e, t) => {
  const {
    active: n,
    alertMaximumReached: r,
    clickingDelay: a,
    defaultImageSrc: i,
    infoLine: o,
    isLoading: s,
    maxPossibleSaleQty: c,
    maximumSaleQuantityText: l,
    minimumSaleQuantityText: u,
    onAbort: h,
    onCardClick: p,
    onChangeQuantity: f,
    outOfStockText: y,
    product: m,
    quantity: v,
    tags: k,
    typingDelay: b,
    ...x
  } = e, {
    currencySymbol: g,
    finalPrice: w,
    hasDiscount: M,
    image: S,
    minimumSaleQuantity: D = 1,
    title: A,
    subtitle: $,
    regularPrice: F,
    stock: Z
  } = m, [B, O] = fe(!1), I = "horizontal", N = Z >= D, R = { active: n, hasStock: N };
  return /* @__PURE__ */ ie(Mme, { ref: t, ...R, ...x, ...xs(p), children: [
    /* @__PURE__ */ ie(wme, { ...R, role: "button", children: [
      r === "stock" && /* @__PURE__ */ C(Sme, { "data-testid": "max-stock-alert", children: y }),
      /* @__PURE__ */ C(
        N2,
        {
          active: n,
          alt: A,
          imageSrc: S,
          counterExpanded: B,
          defaultImageSrc: i
        },
        S
      )
    ] }),
    /* @__PURE__ */ ie(Cme, { children: [
      /* @__PURE__ */ C(R2, { active: n, enoughStock: Z >= D, tags: k, variant: I }),
      /* @__PURE__ */ ie(j2, { active: n, children: [
        r === "maximumSaleQuantity" && /* @__PURE__ */ C(q3, { children: l }),
        o && /* @__PURE__ */ C(P2, { infoLine: o }),
        /* @__PURE__ */ C(H2, { children: A }),
        /* @__PURE__ */ C($2, { children: $ }),
        D > 1 && /* @__PURE__ */ C(W2, { children: u })
      ] }),
      /* @__PURE__ */ ie(ime, { children: [
        n && /* @__PURE__ */ C(
          L2,
          {
            currencySymbol: g,
            finalPrice: w,
            hasDiscount: M,
            regularPrice: F,
            variant: I
          }
        ),
        /* @__PURE__ */ C(
          _2,
          {
            active: N && n,
            clickingDelay: a,
            expandCounter: O,
            isLoading: s,
            maxPossibleSaleQty: c,
            minimumSaleQuantity: D,
            onAbort: h,
            onInputChange: (L) => f(L, L < v),
            quantity: v,
            size: "sm",
            typingDelay: b,
            variant: I
          }
        )
      ] }),
      !n && /* @__PURE__ */ C(q2, { children: "No se puede comprar" })
    ] })
  ] });
}), Ome = G.article`
  ${(e) => V2(e.hasStock, e.active)}
  padding: 0.75rem;
  transition: none 0s ease;
  min-height: 14rem;
  border-radius: ${(e) => e.theme.borderRadiusMd};
  max-width: 13rem;
  grid-template-rows: auto 1fr;
`, Eme = G.div`
  ${z2}
  height: 5rem;
  overflow: hidden;

  & img {
    width: auto;
    max-height: 100%;
  }
`, Ime = G.div`
  ${B2}
`;
G.div`
  ${F2}
`;
const Dme = Ae((e, t) => {
  const {
    active: n,
    clickingDelay: r,
    defaultImageSrc: a,
    infoLine: i,
    isLoading: o,
    minimumSaleQuantityText: s,
    onAbort: c,
    onCardClick: l,
    onChangeQuantity: u,
    product: h,
    quantity: p,
    tags: f,
    ...y
  } = e, {
    currencySymbol: m,
    finalPrice: v,
    hasDiscount: k,
    image: b,
    minimumSaleQuantity: x = 1,
    title: g,
    subtitle: w,
    regularPrice: M,
    stock: S
  } = h, D = "simplified", A = S >= x, $ = { active: n, hasStock: A };
  return /* @__PURE__ */ ie(Ome, { ref: t, ...$, ...y, ...xs(l), children: [
    /* @__PURE__ */ ie(Eme, { ...$, role: "button", children: [
      /* @__PURE__ */ C(R2, { active: n, enoughStock: S >= x, tags: f }),
      /* @__PURE__ */ C(
        N2,
        {
          active: n,
          alt: g,
          imageSrc: b,
          variant: D,
          counterExpanded: !1,
          defaultImageSrc: a
        },
        b
      ),
      /* @__PURE__ */ C(
        _2,
        {
          active: A && n,
          clickingDelay: r,
          isLoading: o,
          maxPossibleSaleQty: S,
          minimumSaleQuantity: x,
          onAbort: c,
          onInputChange: (F) => u(F, !1),
          quantity: p,
          size: "xs",
          style: { position: "absolute", right: "0", bottom: "0" },
          variant: D
        }
      )
    ] }),
    /* @__PURE__ */ ie(Ime, { children: [
      /* @__PURE__ */ ie(j2, { active: n, children: [
        i && /* @__PURE__ */ C(P2, { infoLine: i }),
        /* @__PURE__ */ C(H2, { children: g }),
        /* @__PURE__ */ C($2, { children: w }),
        x > 1 && /* @__PURE__ */ C(W2, { children: s })
      ] }),
      n ? /* @__PURE__ */ C(
        L2,
        {
          currencySymbol: m,
          finalPrice: v,
          hasDiscount: k,
          regularPrice: M
        }
      ) : /* @__PURE__ */ C(q2, { children: "No se puede comprar" })
    ] })
  ] });
}), W4e = (e) => {
  const {
    active: t = !0,
    infoLine: n = { text: "", icon: "" },
    isLoading: r,
    maximumSaleQuantityText: a = "Máximo de productos",
    product: i,
    minimumSaleQuantityText: o = `Mínimo ${i.minimumSaleQuantity} unidades`,
    quantity: s,
    onChangeQuantity: c,
    outOfStockText: l = `Máximo ${i.stock} unidades`,
    variant: u = "default",
    isObservable: h = !1,
    triggerOnce: p = !1,
    threshold: f = 0,
    onVisible: y,
    ...m
  } = e, { maximumSaleQuantity: v, minimumSaleQuantity: k = 1, stock: b } = i, { ref: x } = ame({
    onChange: (S) => y && y(S),
    skip: !h,
    triggerOnce: p,
    threshold: f
  }), { alertMaximumReached: g, maxPossibleSaleQty: w } = Kye({
    quantity: s,
    stock: b,
    maximumSaleQuantity: v,
    minimumSaleQuantity: k
  }), M = {
    active: t,
    infoLine: n,
    isLoading: r,
    product: i,
    alertMaximumReached: g,
    maxPossibleSaleQty: w,
    maximumSaleQuantityText: a,
    minimumSaleQuantityText: o,
    outOfStockText: l,
    quantity: s,
    onChangeQuantity: c,
    ref: x,
    ...m
  };
  switch (u) {
    case "simplified":
      return /* @__PURE__ */ C(Dme, { ...M });
    case "horizontal":
      return /* @__PURE__ */ C(Ame, { ...M });
    default:
      return /* @__PURE__ */ C(xme, { ...M });
  }
}, Tme = Pr`
  0% { transform: translate3d( 200%, 0, 0); }
  100% { transform: translate3d( 0, 0, 0); }
`, Nme = Pr`
  0% { transform: translate3d( 0, 0, 0); }
  100% { transform: translate3d( 200%, 0, 0); }
`, Pme = G.div`
  position: fixed;
  z-index: 2;
  box-shadow: ${(e) => e.theme.shadowDown02};
  background-color: ${(e) => e.theme.colorNeutralLightest};
  overflow: hidden;
  animation-fill-mode: forwards;
  top: 0;
  right: 0;
  bottom: 0;

  animation-duration: ${(e) => e.animationDuration}ms;
  animation-timing-function: ease-out;
  ${(e) => e.isVisible === !0 && ke`
      animation-name: ${Tme};
    `}
  ${(e) => e.isVisible === !1 && ke`
      animation-name: ${Nme};
    `}
`, G2 = "0.72", Lme = Pr`
  0% { opacity: 0; }
  100% { opacity: ${G2}; }
`, Rme = Pr`
  0% { opacity: ${G2}; }
  100% { opacity: 0; }
`, Vme = G.button`
  position: fixed;
  z-index: 1;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
  padding: 0;
  margin: 0;

  background-color: ${(e) => e.theme.colorNeutralDarkest};
  cursor: auto !important;
  border: 0;
  width: 100%;

  animation-duration: ${(e) => e.animationDuration}ms;
  ${(e) => e.isVisible === !0 && ke`
      animation-name: ${Lme};
    `}
  ${(e) => e.isVisible === !1 && ke`
      animation-name: ${Rme};
    `}
`, q4e = ({
  isVisible: e = !1,
  setIsVisible: t,
  animationDuration: n = 400,
  width: r = "auto",
  children: a,
  className: i = "",
  onDismiss: o
}) => {
  const [s, c] = fe(e), l = () => {
    o && o(), t(!e);
  };
  return be(() => {
    e ? c(!0) : setTimeout(() => {
      c(!1);
    }, n);
  }, [e]), s ? /* @__PURE__ */ ie(da, { children: [
    /* @__PURE__ */ C(
      Vme,
      {
        isVisible: e,
        onClick: l,
        animationDuration: n,
        style: {
          opacity: e ? G2 : 0
        }
      }
    ),
    /* @__PURE__ */ C(
      Pme,
      {
        className: i,
        isVisible: e,
        animationDuration: n,
        style: { width: r },
        children: a
      }
    )
  ] }) : null;
}, zme = (e) => Pr`
  0% { opacity: ${e.theme.opacityIntense}; }
  50% { opacity: ${e.theme.opacityLight}; }
  100% { opacity: ${e.theme.opacityIntense}; }
`, Bme = G.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: ${(e) => e.theme.borderRadiusMd};
  background: ${(e) => e.theme.colorNeutralMedium};
  opacity: ${(e) => e.theme.opacityIntense};
  animation: ${zme} 1s infinite;
  animation-timing-function: ease-out;
`, _4e = (e) => /* @__PURE__ */ C(Bme, { ...e }), G4e = ({ loading: e, skeleton: t, children: n }) => e ? /* @__PURE__ */ C(da, { children: t }) : /* @__PURE__ */ C(da, { children: n }), Hme = Pr`
  0% {transform: translate3d(0,200%,0) scale(.6); opacity:.5;}
  100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $me = Pr`
  0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
  100% {transform: translate3d(0,150%,-1px) scale(.6); opacity:0;}
`, jme = G.div`
  border: 1px solid ${(e) => e.theme.colorNeutralMedium};
  box-shadow: ${(e) => e.theme.shadowDown02};
  border-radius: ${(e) => e.theme.borderRadiusMd};
  background-color: ${(e) => e.theme.colorNeutralLightest};
  overflow: hidden;
  width: calc(min(90vw, 340px));
  animation-fill-mode: forwards;

  ${(e) => e.visible === !0 && ke`
      animation: 200ms ${Hme};
    `}
  ${(e) => e.visible === !1 && ke`
      animation: 200ms ${$me};
      opacity: 0;
    `}
`, Fme = G.div`
  padding: ${(e) => e.theme.spacingStackXxxsRem};
  padding-top: 0;
  display: flex;
  align-items: center;
  ${(e) => e.variant === "inline" && ke`
      flex-flow: row no-wrap;
      gap: ${(t) => t.theme.spacingStackXxxsRem};
    `}
  ${(e) => e.variant === "stacked" && ke`
      flex-flow: row wrap;
      gap: ${(t) => t.theme.spacingStackXxsRem};
    `}
`, Wme = G.span`
  font-family: ${(e) => e.theme.fontFamilyRegular};
  font-size: ${(e) => e.theme.fontSizeNano};
  line-height: ${(e) => e.theme.lineHeightConfy};
  flex-grow: 1;
`, qme = G.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;
`, _me = G.button`
  border: none;
  font-family: ${(e) => e.theme.fontFamilySemibold};
  font-weight: ${(e) => e.theme.fontWeightSemibold};
  color: ${(e) => e.theme.brandPrimaryMedium};
  background-color: transparent;
  padding: ${(e) => e.theme.spacingInsetXs};
  cursor: pointer;

  &::focus {
    outline: none;
  }
`, Gme = Pr`
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
`, Zme = G.div`
  width: 0;
  height: ${(e) => e.theme.spacingStackQuarck};
  border-radius: ${(e) => e.theme.borderRadiusMd};
  margin-bottom: ${(e) => e.theme.spacingStackXxxsRem};
  ${(e) => e.duration && e.visible === !0 && ke`
      animation: ${Gme};
      animation-duration: ${e.duration}ms;
      animation-timing-function: linear;
    `}

  ${(e) => e.type === "success" && ke`
      background-color: ${(t) => t.theme.colorSupportPositiveMedium};
    `}
  ${(e) => e.type === "warning" && ke`
      background-color: ${(t) => t.theme.colorSupportWarningMedium};
    `}
  ${(e) => e.type === "error" && ke`
      background-color: ${(t) => t.theme.colorSupportNegativeMedium};
    `}
`, Xme = G.div`
  width: fit-content;
  z-index: 999;
  position: fixed;
  bottom: ${(e) => e.theme.spacingStackXxxsRem};
  left: 50%;
  transform: translateX(-50%);
`, Ume = ({
  variant: e = "inline",
  type: t = "success",
  message: n,
  action: r,
  duration: a = 500,
  visible: i = !0
}) => /* @__PURE__ */ ie(jme, { visible: i, children: [
  /* @__PURE__ */ C(Zme, { visible: i, duration: a, type: t }),
  /* @__PURE__ */ ie(Fme, { variant: e, children: [
    /* @__PURE__ */ C(Wme, { children: n }),
    /* @__PURE__ */ C(qme, { children: /* @__PURE__ */ C(_me, { type: "button", onClick: () => {
      r.cb && r.cb();
    }, children: r.text }) })
  ] })
] });
var z1 = /* @__PURE__ */ ((e) => (e[e.ADD_NOTIFICATION = 0] = "ADD_NOTIFICATION", e[e.DISMISS_NOTIFICATION = 1] = "DISMISS_NOTIFICATION", e[e.POP_NOTIFICATION = 2] = "POP_NOTIFICATION", e[e.CLEAR_NOTIFICATIONS = 3] = "CLEAR_NOTIFICATIONS", e))(z1 || {});
const Yme = () => {
  setTimeout(() => {
    B1({
      type: 2
      /* POP_NOTIFICATION */
    });
  }, 500);
}, Jme = (e, t) => {
  switch (t.type) {
    case 0: {
      const r = t.notification;
      return e.notifications.filter((i) => i.visible === !0) && (r.visible = !0), {
        ...e,
        notifications: [...e.notifications, r]
      };
    }
    case 1: {
      const r = [...e.notifications];
      return r.length > 0 && (r[0].visible = !1), r.length > 1 && (r[1].visible = !0), Yme(), {
        ...e,
        notifications: r
      };
    }
    case 2:
      let n = [...e.notifications];
      return e.notifications.length > 0 && e.notifications[0].visible === !1 && (n = n.slice(1)), {
        ...e,
        notifications: n
      };
    case 3:
      return {
        ...e,
        notifications: e.notifications.length > 0 ? [e.notifications[0]] : []
      };
  }
}, Mc = [];
let wc = { notifications: [] };
const B1 = (e) => {
  wc = Jme(wc, e), Mc.forEach((t) => {
    t(wc);
  });
}, Kme = () => {
  const [e, t] = fe(wc);
  return be(() => (Mc.push(t), () => {
    const n = Mc.indexOf(t);
    n > -1 && Mc.splice(n, 1);
  }), [e]), {
    notifications: e.notifications
  };
}, H1 = (e) => (t, n) => {
  const r = {
    message: t,
    duration: (n == null ? void 0 : n.duration) || 5e3,
    type: e,
    visible: !1,
    createdAt: Date.now(),
    action: n == null ? void 0 : n.action
  };
  (n == null ? void 0 : n.clear) === !0 && U3(), B1({
    type: z1.ADD_NOTIFICATION,
    notification: r
  });
}, X3 = () => {
  B1({
    type: z1.DISMISS_NOTIFICATION
  });
}, U3 = () => {
  B1({
    type: z1.CLEAR_NOTIFICATIONS
  }), X3();
}, ka = (e, t) => H1("success")(e, t);
ka.error = H1("error");
ka.warning = H1("warning");
ka.success = H1("success");
ka.dismiss = X3;
ka.clear = U3;
const Z4e = () => {
  const { notifications: e } = Kme(), t = e.length > 0 ? e[0] : null;
  return be(() => {
    let n;
    return t && (n = setTimeout(() => {
      ka.dismiss();
    }, t.duration)), () => n && clearTimeout(n);
  }, [t]), /* @__PURE__ */ C(Xme, { children: t && /* @__PURE__ */ C(
    Ume,
    {
      duration: t.duration,
      message: t.message,
      action: t.action || {
        text: "Cerrar",
        cb: () => ka.dismiss()
      },
      type: t.type,
      visible: t.visible
    }
  ) });
}, Qme = G.span`
  font-size: ${(e) => e.theme.fontSizeNano};
  font-weight: ${(e) => e.theme.fontWeightRegular};
`, Og = G.span`
  font-weight: ${(e) => e.theme.fontWeightBold};
`, ege = G.div`
  margin-bottom: ${(e) => e.theme.spacingInsetSmRem};
  margin-top: ${(e) => e.theme.spacingInsetSmRem};
  padding-left: ${(e) => e.theme.spacingInlineMicroRem};
  padding-left: ${(e) => e.theme.spacingInlineMicroRem};
  width: 100%;
  height: 100%;
  column-gap: 3%;
`, tge = G.div`
  height: 0.375rem;
  border-radius: ${(e) => e.theme.borderRadiusLg};
  background-color: ${(e) => e.isComplete ? e.theme.brandHighlightMedium : e.theme.colorNeutralMedium};
`, X4e = ({ steps: e, currentStep: t }) => {
  const n = e[t];
  return /* @__PURE__ */ ie("div", { children: [
    /* @__PURE__ */ ie(Qme, { children: [
      "PASO ",
      /* @__PURE__ */ C(Og, { children: t + 1 }),
      " DE",
      " ",
      /* @__PURE__ */ C(Og, { children: e.length })
    ] }),
    /* @__PURE__ */ C(ege, { className: "row", children: e.map((r, a) => /* @__PURE__ */ C(tge, { isComplete: t >= a, className: "col", role: "tab" }, a)) }),
    /* @__PURE__ */ C("div", { children: n })
  ] });
}, nge = G.div`
  overflow-x: auto;
  overflow-y: hidden;
  padding: ${(e) => e.theme.spacingInsetMdRem};
  padding-bottom: 0;
  background-color: ${(e) => e.theme.colorNeutralLightest};
  border: 1px solid rgba(186, 189, 204, 0.32);
  border-radius: ${(e) => e.theme.borderRadiusLg};
`, rge = G.table`
  width: 100%;
  border-collapse: collapse;
  color: ${(e) => e.theme.colorNeutralDarkest};
`, Y3 = G.tbody`
  width: 100%;
`, Z2 = G.tr`
  width: 100%;
`, J3 = (e, t) => e.isVisible !== void 0 && e.isVisible === !1 || (t && t[e.accessor]) === !1, age = G.thead`
  tr:first-of-type {
    border-bottom: 1px solid ${(e) => e.theme.colorNeutralMedium};
  }
`, ige = G.th`
  font-family: ${(e) => e.theme.fontFamilyBold};
  padding: ${(e) => `${e.theme.spacingInsetXsRem} 0 ${e.theme.spacingInsetMdRem}`};
  white-space: nowrap;
}
`, oge = ({ columns: e, visibleColumns: t }) => /* @__PURE__ */ C(age, { children: /* @__PURE__ */ C(Z2, { children: e.map((n, r) => J3(n, t) ? null : /* @__PURE__ */ C(ige, { children: n.header }, `header-${n.header}-${r}`)) }) }), sge = (e, t) => {
  const [n, r] = fe([]);
  return be(() => {
    let a = [];
    if (e > 1) {
      const o = t - 1, s = e - t;
      let c = 1, l = 3, u = !1, h = !1;
      if (o - c > 0 ? u = !0 : o - c <= 0 && (c = o, l += c - o), s - l <= 0 && (l = s), s - l > 0 && (h = !0), u && (c -= 1), h && (l -= 1), u && h) {
        a.push("...");
        for (let p = t - c; p <= t + l; p += 1)
          a.push(p);
        a.push("...");
      } else if (u && !h) {
        a.push("...");
        for (let p = t - c; p <= t + l; p += 1)
          a.push(p);
      } else if (!u && h) {
        for (let p = t - c; p <= t + l; p += 1)
          a.push(p);
        a.push("...");
      } else if (!u && !h)
        for (let p = t - c; p <= t + l; p += 1)
          a.push(p);
    } else
      a = [1];
    const i = a.map((o, s) => ({
      type: o === "..." ? "ellipsis" : "number",
      value: o,
      index: s
    }));
    r(i);
  }, [t, e]), { items: n };
}, cge = G.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${(e) => e.theme.spacingInlineXxsRem};
`, lge = G.ul`
  display: flex;
  margin: 0;
  padding: 0;
  font-family: ${(e) => e.theme.fontFamilyRegular};
  list-style: none;
`, dge = (e) => {
  let t = "";
  return e.typeButton === "number" && (t += `
      cursor: pointer;
      &:hover {
        background-color: ${e.theme.colorNeutralLight};
      }`), e.isSelected && (t += `
      background-color: ${e.theme.brandPrimaryMedium};
      color: ${e.theme.colorNeutralLightest};
      font-family: ${e.theme.fontFamilySemibold};
      &:hover {
        background-color: ${e.theme.brandPrimaryMedium};
      }`), t;
}, uge = G.button`
  background-color: transparent;
  border: none;
  padding: 0;
  width: ${(e) => e.theme.spacingStackXsRem};
  height: ${(e) => e.theme.spacingStackXsRem};
  display: grid;
  place-items: center;
  border-radius: ${(e) => e.theme.borderRadiusLg};
  margin: 0 ${(e) => e.theme.spacingInlineQuarckRem};
  color: ${(e) => e.theme.colorNeutralDarkest};
  font-size: ${(e) => e.theme.fontSizeXxxs};
  transition: 100ms ease -in -out;
  &:focus {
    border: none;
    outline: none;
  }

  ${dge};
`, hge = ({ item: e, selected: t, onClick: n, disabled: r }) => {
  const a = (i) => () => {
    n && e.type === "number" && n(+i);
  };
  return /* @__PURE__ */ C("li", { children: /* @__PURE__ */ C(
    uge,
    {
      isSelected: t,
      typeButton: e.type,
      type: "button",
      onClick: a(e.value.toString()),
      disabled: r,
      children: /* @__PURE__ */ C("span", { children: e.value })
    }
  ) }, `pagination-item-${e.index}`);
}, pge = ({ paginationModel: e, disabled: t = !1 }) => {
  const { totalPages: n, currentPage: r, onChangePage: a } = e, { items: i } = sge(n, r), o = (s) => () => {
    a && a(+s);
  };
  return /* @__PURE__ */ C(cge, { children: /* @__PURE__ */ C(lge, { children: i.map((s) => /* @__PURE__ */ C(
    hge,
    {
      onClick: o(s.value),
      item: s,
      selected: s.value === r + 1,
      disabled: t
    },
    `pagination-item-${s.index}`
  )) }) });
}, fge = G.td`
  font-family: ${(e) => e.theme.fontFamilyRegular};
  padding: ${(e) => e.theme.spacingInsetMdRem} 0;
  min-width: ${(e) => e.theme.spacingInlineXlRem};
`, yge = ({ data: e, headers: t, pageSize: n, visibleColumns: r }) => /* @__PURE__ */ C(Y3, { children: e.slice(0, n).map((a, i) => /* @__PURE__ */ C(Z2, { children: t.map((o, s) => J3(o, r) ? null : /* @__PURE__ */ C(fge, { children: /* @__PURE__ */ C("div", { className: o.className, children: o.render ? /* @__PURE__ */ C("span", { children: o.render(a) }) : /* @__PURE__ */ C("span", { children: a[o.accessor] }) }) }, `row-${i}-col-${s}`)) }, `row-${i}`)) }), mge = G.td`
  background-color: ${(e) => e.theme.colorNeutralLightest};
  padding: 1.875rem;
  text-align: center;
  border-radius: ${(e) => e.theme.borderRadiusLg};
`, gge = ({ rowsCount: e, noDataMessage: t }) => /* @__PURE__ */ C(Y3, { children: /* @__PURE__ */ C(Z2, { children: /* @__PURE__ */ C(mge, { colSpan: e, children: t || "Sin datos." }) }, "0") });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var Er = function() {
  return Er = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Er.apply(this, arguments);
};
function vge(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
var kge = function() {
  return Math.random().toString(36).substring(6);
}, bge = function(e) {
  var t = e.animate, n = t === void 0 ? !0 : t, r = e.animateBegin, a = e.backgroundColor, i = a === void 0 ? "#f5f6f7" : a, o = e.backgroundOpacity, s = o === void 0 ? 1 : o, c = e.baseUrl, l = c === void 0 ? "" : c, u = e.children, h = e.foregroundColor, p = h === void 0 ? "#eee" : h, f = e.foregroundOpacity, y = f === void 0 ? 1 : f, m = e.gradientRatio, v = m === void 0 ? 2 : m, k = e.gradientDirection, b = k === void 0 ? "left-right" : k, x = e.uniqueKey, g = e.interval, w = g === void 0 ? 0.25 : g, M = e.rtl, S = M === void 0 ? !1 : M, D = e.speed, A = D === void 0 ? 1.2 : D, $ = e.style, F = $ === void 0 ? {} : $, Z = e.title, B = Z === void 0 ? "Loading..." : Z, O = e.beforeMask, I = O === void 0 ? null : O, N = vge(e, ["animate", "animateBegin", "backgroundColor", "backgroundOpacity", "baseUrl", "children", "foregroundColor", "foregroundOpacity", "gradientRatio", "gradientDirection", "uniqueKey", "interval", "rtl", "speed", "style", "title", "beforeMask"]), R = x || kge(), L = R + "-diff", W = R + "-animated-diff", E = R + "-aria", q = S ? { transform: "scaleX(-1)" } : null, z = "0; " + w + "; 1", H = A + "s", _ = b === "top-bottom" ? "rotate(90)" : void 0;
  return le(
    "svg",
    Er({ "aria-labelledby": E, role: "img", style: Er(Er({}, F), q) }, N),
    B ? le("title", { id: E }, B) : null,
    I && fo(I) ? I : null,
    le("rect", { role: "presentation", x: "0", y: "0", width: "100%", height: "100%", clipPath: "url(" + l + "#" + L + ")", style: { fill: "url(" + l + "#" + W + ")" } }),
    le(
      "defs",
      null,
      le("clipPath", { id: L }, u),
      le(
        "linearGradient",
        { id: W, gradientTransform: _ },
        le("stop", { offset: "0%", stopColor: i, stopOpacity: s }, n && le("animate", { attributeName: "offset", values: -v + "; " + -v + "; 1", keyTimes: z, dur: H, repeatCount: "indefinite", begin: r })),
        le("stop", { offset: "50%", stopColor: p, stopOpacity: y }, n && le("animate", { attributeName: "offset", values: -v / 2 + "; " + -v / 2 + "; " + (1 + v / 2), keyTimes: z, dur: H, repeatCount: "indefinite", begin: r })),
        le("stop", { offset: "100%", stopColor: i, stopOpacity: s }, n && le("animate", { attributeName: "offset", values: "0; 0; " + (1 + v), keyTimes: z, dur: H, repeatCount: "indefinite", begin: r }))
      )
    )
  );
}, K3 = function(e) {
  return e.children ? le(bge, Er({}, e)) : le(xge, Er({}, e));
}, xge = function(e) {
  return le(
    K3,
    Er({ viewBox: "0 0 476 124" }, e),
    le("rect", { x: "48", y: "8", width: "88", height: "6", rx: "3" }),
    le("rect", { x: "48", y: "26", width: "52", height: "6", rx: "3" }),
    le("rect", { x: "0", y: "56", width: "410", height: "6", rx: "3" }),
    le("rect", { x: "0", y: "72", width: "380", height: "6", rx: "3" }),
    le("rect", { x: "0", y: "88", width: "178", height: "6", rx: "3" }),
    le("circle", { cx: "20", cy: "20", r: "20" })
  );
};
const Mge = K3, wge = ({ columnsCount: e }) => {
  const t = [];
  for (let n = 0; n < e; n += 1) {
    const r = Math.floor(100 / e);
    t.push({ x: 0 + (n * r - 2), width: r - 5 });
  }
  return /* @__PURE__ */ ie(Mge, { viewBox: "0 0 100 44", children: [
    t.map((n, r) => /* @__PURE__ */ C("rect", { y: "2", rx: "0.5", ry: "0.5", x: n.x, width: n.width, height: "4" }, `headerSkeleton${r}`)),
    /* @__PURE__ */ C("rect", { y: "7", rx: "0.5", ry: "0.5", width: "100", height: "8" }),
    /* @__PURE__ */ C("rect", { y: "16", rx: "0.5", ry: "0.5", width: "100", height: "8" }),
    /* @__PURE__ */ C("rect", { y: "25", rx: "0.5", ry: "0.5", width: "100", height: "8" }),
    /* @__PURE__ */ C("rect", { y: "34", rx: "0.5", ry: "0.5", width: "100", height: "8" })
  ] });
}, U4e = ({
  rows: e,
  columns: t,
  visibleColumns: n,
  isLoading: r,
  noDataMessage: a = "",
  paginationModel: i
}) => /* @__PURE__ */ ie(da, { children: [
  /* @__PURE__ */ C(nge, { children: r ? /* @__PURE__ */ C(wge, { columnsCount: t.length }) : /* @__PURE__ */ ie(rge, { children: [
    /* @__PURE__ */ C(oge, { columns: t, visibleColumns: n }),
    e.length === 0 ? /* @__PURE__ */ C(gge, { noDataMessage: a, rowsCount: t.length }) : /* @__PURE__ */ C(
      yge,
      {
        data: e,
        headers: t,
        visibleColumns: n,
        pageSize: (i == null ? void 0 : i.pageSize) || e.length
      }
    )
  ] }) }),
  !r && e.length !== 0 && i && /* @__PURE__ */ C(pge, { paginationModel: i })
] }), $h = $n({
  currentTab: void 0,
  setCurrentTab: () => {
  }
}), Cge = ({ children: e, defaultTab: t }) => {
  const [n, r] = fe(t), a = wt(
    () => ({ currentTab: n, setCurrentTab: r }),
    [n, r]
  );
  return /* @__PURE__ */ C($h.Provider, { value: a, children: e });
}, Q3 = () => {
  const { currentTab: e, setCurrentTab: t } = Ct($h);
  if (!$h)
    throw new Error("useTabs should be used inside Tabs Component");
  return {
    currentTab: e,
    setCurrentTab: t
  };
}, Sge = G.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${(e) => e.theme.spacingStackXsRem};
  overflow-x: auto;
  white-space: nowrap;
`, Age = G.div`
  display: flex;
`, Oge = G.button`
  border: none;
  background-color: transparent;
  font-family: ${(e) => e.theme.fontFamilySemibold};
  color: ${(e) => e.active ? e.theme.brandPrimaryMedium : e.theme.colorNeutralDark};
  padding: ${(e) => e.theme.spacingInsetSmRem};
  border-bottom-width: 0.1875rem;
  border-bottom-style: solid;
  border-bottom-color: transparent;
  display: flex;
  align-items: center;
  border-bottom-color: ${(e) => e.active ? e.theme.brandPrimaryMedium : "none"};
  &:disabled {
    opacity: 0.5;
  }

  &:focus {
    outline: none;
  }
`, Ege = G.span`
  display: flex;
  align-items: stretch;
  margin-right: ${(e) => e.theme.spacingInlineNanoRem};
`, Ige = G.div`
  margin-top: ${(e) => e.theme.spacingStackXsRem};
  ${(e) => e.active ? { display: "block", opacity: "1" } : { display: "none", opacity: "0" }}
`, Dge = ({ iconName: e, iconSize: t = "sm", state: n = !0, title: r, value: a }) => {
  const { currentTab: i, setCurrentTab: o } = Q3();
  return /* @__PURE__ */ ie(
    Oge,
    {
      active: i === a,
      type: "button",
      onClick: () => o(a),
      disabled: !n,
      "aria-label": `button-${a}`,
      children: [
        e && /* @__PURE__ */ C(Ege, { children: /* @__PURE__ */ C(ot, { name: e, size: t }) }),
        r
      ]
    },
    r
  );
}, Tge = ({ value: e, children: t }) => {
  const { currentTab: n } = Q3();
  return e == null ? null : /* @__PURE__ */ C(Ige, { active: e === n, children: t });
}, Nge = ({ children: e }) => /* @__PURE__ */ C(Sge, { children: /* @__PURE__ */ C(Age, { children: e }) }), X2 = ({ children: e, defaultTab: t }) => /* @__PURE__ */ C(Cge, { defaultTab: t, children: /* @__PURE__ */ C("div", { children: e }) });
X2.List = Nge;
X2.Tab = Dge;
X2.Panel = Tge;
const Pge = G.div`
  ${(e) => e.isBlock === !0 ? ke`
          width: 100%;
        ` : ke`
          width: max-content;
        `}
  height: 1.8125rem;
  display: flex;
  align-items: center;
  border-radius: ${(e) => e.theme.borderRadiusSm};
  border: 1px solid ${(e) => e.theme.colorNeutralMedium};
  ${(e) => e.type === "positive" && ke`
      background-color: ${(t) => t.theme.colorSupportPositiveLightest};
    `}
  ${(e) => e.type === "warning" && ke`
      background-color: ${(t) => t.theme.colorSupportWarningLightest};
    `}
  ${(e) => e.type === "danger" && ke`
      background-color: ${(t) => t.theme.colorSupportNegativeLightest};
    `}
`, Lge = G.div`
  padding-left: ${(e) => e.theme.spacingInlineQuarckRem};
  padding-right: ${(e) => e.theme.spacingInlineQuarckRem};
  display: flex;
  margin: auto;
  align-items: center;
  gap: ${(e) => e.theme.spacingInlineNanoRem};
`, Rge = G.div`
  font-family: ${(e) => e.theme.fontFamilyRegular};
  font-size: ${(e) => e.theme.fontSizeNano};
  line-height: ${(e) => e.theme.lineHeightConfy};
  ${(e) => e.type === "positive" && ke`
      color: ${(t) => t.theme.colorSupportPositiveDark};
    `}
  ${(e) => e.type === "warning" && ke`
      color: ${(t) => t.theme.colorSupportWarningDark};
    `}
  ${(e) => e.type === "danger" && ke`
      color: ${(t) => t.theme.colorSupportNegativeDark};
    `}
`, Vge = G(Vl)`
  order: ${(e) => e.position === "right" ? 1 : 0};
  width: ${(e) => e.size};
  height: ${(e) => e.size};
`;
var e6 = /* @__PURE__ */ ((e) => (e.POSITIVE = "positive", e.WARNING = "warning", e.DANGER = "danger", e))(e6 || {});
const Y4e = Ae(
  ({
    type: e = e6.POSITIVE,
    message: t,
    image: n = "",
    isBlock: r = !1,
    imgSize: a = "1rem",
    children: i,
    className: o = "",
    imagePosition: s = "right",
    ...c
  }, l) => /* @__PURE__ */ C(Pge, { ref: l, "data-testid": "tag-section", isBlock: r, type: e, className: o, ...c, children: /* @__PURE__ */ ie(Lge, { children: [
    n && /* @__PURE__ */ C(Vge, { src: n, size: a, position: s }),
    /* @__PURE__ */ C(Rge, { type: e, children: t || i })
  ] }) })
), zge = ke`
  bottom: ${({ direction: e }) => e != null && e.includes("top") ? "100%" : "auto"};
  top: ${({ direction: e }) => e != null && e.includes("bottom") ? "100%" : "auto"};
  right: ${({ direction: e }) => e != null && e.includes("left") ? "-16px" : "auto"};
  left: ${({ direction: e }) => e != null && e.includes("right") ? "-16px" : "auto"};
`, Bge = ke`
  bottom: ${({ direction: e }) => e != null && e.includes("bottom") ? "calc(100% - 12px)" : "auto"};
  top: ${({ direction: e }) => e != null && e.includes("top") ? "calc(100% - 12px)" : "auto"};
  right: ${({ direction: e }) => e != null && e.includes("left") ? "16px" : "auto"};
  left: ${({ direction: e }) => e != null && e.includes("right") ? "16px" : "auto"};
`, Hge = G.div`
  position: relative;
  width: fit-content;

  button[disabled] {
    pointer-events: none;
  }

  @keyframes appear-top {
    0% {
      opacity: 0;
      bottom: 20%;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes appear-bottom {
    0% {
      opacity: 0;
      top: 20%;
    }
    100% {
      opacity: 1;
    }
  }

  .mpp-tooltip__content {
    text-align: center;
    font-size: ${(e) => e.theme.fontSizeQuarck};
    line-height: ${(e) => e.theme.lineHeightConfy};
    position: absolute;
    display: flex;
    background-color: ${(e) => e.theme.colorSupportWarningDarkest};
    color: ${(e) => e.theme.colorNeutralLightest};
    border-radius: ${(e) => e.theme.borderRadiusMd};
    cursor: auto;
    padding: ${(e) => e.theme.spacingInsetSmRem};
    box-shadow: ${(e) => e.theme.shadowDown01};
    width: max-content;
    max-width: 15.5rem;
    z-index: 4;
    animation: appear-${(e) => {
  var t;
  return (t = e.direction) != null && t.includes("top") ? "top" : "bottom";
}} 0.15s ease-out;
    ${zge}
  }

  .mpp-tooltip__tail {
    z-index: 1;
    position: absolute;
    display: flex;
    background-color: ${(e) => e.theme.colorSupportWarningDarkest};
    width: ${(e) => e.theme.spacingInsetSm};
    height: ${(e) => e.theme.spacingInsetSm};
    transform: rotate(45deg);
    ${Bge}
  }
`, J4e = ({ content: e, children: t, id: n, direction: r = "top-left", className: a = "", hide: i = !1 }) => {
  const [o, s] = fe(!1), [c] = fe(n || crypto.randomUUID());
  return /* @__PURE__ */ ie(
    Hge,
    {
      direction: r,
      className: `tooltip ${a}`,
      onMouseEnter: () => !i && s(!0),
      onMouseLeave: () => s(!1),
      "aria-describedby": c,
      children: [
        t,
        o && /* @__PURE__ */ ie("div", { role: "tooltip", id: c, className: "mpp-tooltip__content", children: [
          e,
          /* @__PURE__ */ C("div", { className: "mpp-tooltip__tail" })
        ] })
      ]
    }
  );
}, $ge = "#400000", jge = "#9f0f00", Fge = "#ec3a0e", Wge = "#ff8679", qge = "#fff2f2", _ge = "#001840", Gge = "#003d9f", Zge = "#0064d1", Xge = "#79acff", Uge = "#f2f7ff", Yge = "#202020", Jge = "#6c6c6c", Kge = "#dedede", Qge = "#f7f7f7", eve = "#fcfcfc", tve = "#003421", nve = "#006e4a", rve = "#0e9069", ave = "#79d6b7", ive = "#f2fdf9", ove = "#402200", sve = "#9f5200", cve = "#d97d08", lve = "#ffbe79", dve = "#fff9f2", uve = "#400016", hve = "#9f003c", pve = "#e20867", fve = "#ff79ac", yve = "#fff2f7", mve = 0, gve = "4px", vve = "8px", kve = "16px", bve = "500px", xve = "1000px", Mve = 0, wve = "1px", Cve = "2px", Sve = "4px", Ave = "576px", Ove = "1200px", Eve = 0.72, Ive = 0.32, Dve = 0.16, Tve = 0.08, Nve = "0px 0px 4px rgba(136, 128, 128, 0.08), 0px -8px 16px -4px rgba(136, 128, 128, 0.16)", Pve = "0px 0px 8px rgba(136, 128, 128, 0.08), 0px -16px 32px -8px rgba(136, 128, 128, 0.16)", Lve = "0px 0px 16px rgba(136, 128, 128, 0.08), 0px -32px 64px -16px rgba(136, 128, 128, 0.16)", Rve = "0px 0px 4px rgba(136, 128, 128, 0.08), 0px 8px 16px -4px rgba(136, 128, 128, 0.16)", Vve = "0px 0px 8px rgba(136, 128, 128, 0.08), 0px 16px 32px -8px rgba(136, 128, 128, 0.16)", zve = "0px 0px 16px rgba(136, 128, 128, 0.08), 0px 32px 64px -16px rgba(136, 128, 128, 0.16)", Bve = "4px", Hve = "8px", $ve = "12px", jve = "16px", Fve = "24px", Wve = "32px", qve = "40px", _ve = "48px", Gve = "56px", Zve = "80px", Xve = "0.25rem", Uve = "0.5rem", Yve = "0.75rem", Jve = "1rem", Kve = "1.5rem", Qve = "2rem", eke = "2.5rem", tke = "3rem", nke = "3.5rem", rke = "5rem", ake = "4px", ike = "8px", oke = "16px", ske = "24px", cke = "32px", lke = "48px", dke = "0.25rem", uke = "0.5rem", hke = "1rem", pke = "1.5rem", fke = "2rem", yke = "3rem", mke = "4px 8px", gke = "8px 16px", vke = "16px 24px", kke = "16px 32px", bke = "0.25rem 0.5rem", xke = "0.5rem 1rem", Mke = "1rem 1.5rem", wke = "1rem 2rem", Cke = "4px", Ske = "8px", Ake = "12px", Oke = "16px", Eke = "24px", Ike = "32px", Dke = "40px", Tke = "48px", Nke = "56px", Pke = "72px", Lke = "96px", Rke = "120px", Vke = "160px", zke = "0.25rem", Bke = "0.5rem", Hke = "0.75rem", $ke = "1rem", jke = "1.5rem", Fke = "2rem", Wke = "2.5rem", qke = "3rem", _ke = "3.5rem", Gke = "4.5rem", Zke = "6rem", Xke = "7.5rem", Uke = "10rem", Yke = "'AlicorpSans-Light', Helvetica, Arial, sans-serif", Jke = "'AlicorpSans-Regular', Helvetica, Arial, sans-serif", Kke = "'AlicorpSans-Bold', Helvetica, Arial, sans-serif", Qke = "'AlicorpSans-Semibold', Helvetica, Arial, sans-serif", e4e = "SFMono-Regular, Menlo, Monaco, Consolas,  'Liberation Mono', 'Courier New', monospace", t4e = "80px", n4e = "64px", r4e = "48px", a4e = "40px", i4e = "32px", o4e = "24px", s4e = "20px", c4e = "16px", l4e = "14px", d4e = "12px", u4e = 300, h4e = 400, p4e = 600, f4e = 700, y4e = "1", m4e = "1.28", g4e = "1.52", K4e = {
  brandPrimaryDarkest: $ge,
  brandPrimaryDark: jge,
  brandPrimaryMedium: Fge,
  brandPrimaryLight: Wge,
  brandPrimaryLightest: qge,
  brandHighlightDarkest: _ge,
  brandHighlightDark: Gge,
  brandHighlightMedium: Zge,
  brandHighlightLight: Xge,
  brandHighlightLightest: Uge,
  colorNeutralDarkest: Yge,
  colorNeutralDark: Jge,
  colorNeutralMedium: Kge,
  colorNeutralLight: Qge,
  colorNeutralLightest: eve,
  colorSupportPositiveDarkest: tve,
  colorSupportPositiveDark: nve,
  colorSupportPositiveMedium: rve,
  colorSupportPositiveLight: ave,
  colorSupportPositiveLightest: ive,
  colorSupportWarningDarkest: ove,
  colorSupportWarningDark: sve,
  colorSupportWarningMedium: cve,
  colorSupportWarningLight: lve,
  colorSupportWarningLightest: dve,
  colorSupportNegativeDarkest: uve,
  colorSupportNegativeDark: hve,
  colorSupportNegativeMedium: pve,
  colorSupportNegativeLight: fve,
  colorSupportNegativeLightest: yve,
  borderRadiusSharp: mve,
  borderRadiusSm: gve,
  borderRadiusMd: vve,
  borderRadiusLg: kve,
  borderRadiusPill: bve,
  borderRadiusCircular: xve,
  borderWidthNone: Mve,
  borderWidthHairline: wve,
  borderWidthThick: Cve,
  borderWidthHeavy: Sve,
  gridBreakpointMobile: Ave,
  gridBreakpointDesktop: Ove,
  opacitySemiOpaque: Eve,
  opacityIntense: Ive,
  opacityLight: Dve,
  opacitySemiTransparent: Tve,
  shadowUp01: Nve,
  shadowUp02: Pve,
  shadowUp03: Lve,
  shadowDown01: Rve,
  shadowDown02: Vve,
  shadowDown03: zve,
  spacingInlineQuarck: Bve,
  spacingInlineNano: Hve,
  spacingInlineMicro: $ve,
  spacingInlineXxxs: jve,
  spacingInlineXxs: Fve,
  spacingInlineXs: Wve,
  spacingInlineSm: qve,
  spacingInlineMd: _ve,
  spacingInlineLg: Gve,
  spacingInlineXl: Zve,
  spacingInlineQuarckRem: Xve,
  spacingInlineNanoRem: Uve,
  spacingInlineMicroRem: Yve,
  spacingInlineXxxsRem: Jve,
  spacingInlineXxsRem: Kve,
  spacingInlineXsRem: Qve,
  spacingInlineSmRem: eke,
  spacingInlineMdRem: tke,
  spacingInlineLgRem: nke,
  spacingInlineXlRem: rke,
  spacingInsetNano: ake,
  spacingInsetXs: ike,
  spacingInsetSm: oke,
  spacingInsetMd: ske,
  spacingInsetLg: cke,
  spacingInsetXl: lke,
  spacingInsetNanoRem: dke,
  spacingInsetXsRem: uke,
  spacingInsetSmRem: hke,
  spacingInsetMdRem: pke,
  spacingInsetLgRem: fke,
  spacingInsetXlRem: yke,
  spacingSquishNano: mke,
  spacingSquishXs: gke,
  spacingSquishSm: vke,
  spacingSquishMd: kke,
  spacingSquishNanoRem: bke,
  spacingSquishXsRem: xke,
  spacingSquishSmRem: Mke,
  spacingSquishMdRem: wke,
  spacingStackQuarck: Cke,
  spacingStackNano: Ske,
  spacingStackMicro: Ake,
  spacingStackXxxs: Oke,
  spacingStackXxs: Eke,
  spacingStackXs: Ike,
  spacingStackSm: Dke,
  spacingStackMd: Tke,
  spacingStackLg: Nke,
  spacingStackXl: Pke,
  spacingStackXxl: Lke,
  spacingStackXxxl: Rke,
  spacingStackHuge: Vke,
  spacingStackQuarckRem: zke,
  spacingStackNanoRem: Bke,
  spacingStackMicroRem: Hke,
  spacingStackXxxsRem: $ke,
  spacingStackXxsRem: jke,
  spacingStackXsRem: Fke,
  spacingStackSmRem: Wke,
  spacingStackMdRem: qke,
  spacingStackLgRem: _ke,
  spacingStackXlRem: Gke,
  spacingStackXxlRem: Zke,
  spacingStackXxxlRem: Xke,
  spacingStackHugeRem: Uke,
  fontFamilyLight: Yke,
  fontFamilyRegular: Jke,
  fontFamilyBold: Kke,
  fontFamilySemibold: Qke,
  fontFamilyMonospace: e4e,
  fontSizeXxl: t4e,
  fontSizeXl: n4e,
  fontSizeLg: r4e,
  fontSizeMd: a4e,
  fontSizeSm: i4e,
  fontSizeXs: o4e,
  fontSizeXxs: s4e,
  fontSizeXxxs: c4e,
  fontSizeNano: l4e,
  fontSizeQuarck: d4e,
  fontWeightLight: u4e,
  fontWeightRegular: h4e,
  fontWeightSemibold: p4e,
  fontWeightBold: f4e,
  lineHeightTight: y4e,
  lineHeightFair: m4e,
  lineHeightConfy: g4e
};
export {
  V4e as Autocomplete,
  S4e as ButtonLink,
  xx as Collapse,
  n2e as DatePicker,
  z4e as DateRangePicker,
  xme as DefaultProductCard,
  un as EDatePickerViewType,
  Yi as EMaximumAlertType,
  po as EProductCardTagType,
  e6 as ETagSectionType,
  w4e as Fade,
  j4e as GoTopButton,
  A4e as HTMLContentWrapper,
  Ame as HorizontalProductCard,
  c2e as Input,
  B4e as MultipleDatePicker,
  F4e as OrderDetail,
  lye as OrderPromosList,
  W4e as ProductCard,
  _2 as ProductCounter,
  H4e as RangeInput,
  R4e as RichEditor,
  q4e as Sidebar,
  Dme as SimplifiedProductCard,
  _4e as Skeleton,
  G4e as SkeletonPlaceHolder,
  C4e as Slide,
  Ume as Snackbar,
  Z4e as SnackbarGlobal,
  X4e as Stepper,
  J8 as StyledEditorRendererWrapper,
  Y8 as StyledEditorWrapper,
  U4e as Table,
  X2 as Tabs,
  Y4e as TagSection,
  M4e as ThemeProvider,
  $4e as TimePickerInput,
  J4e as Tooltip,
  tye as diadiaTheme,
  Wye as getMaximumPossibleSaleQuantity,
  K4e as insumaTheme,
  ka as notification,
  x4e as useCSS,
  k6 as useDebounce,
  o0 as useDebounceCallback,
  _h as useForkRef,
  Kye as useMaximumPossibleQuantity,
  x6 as useOnClickOutside,
  Kme as useStore,
  b6 as useTimeout
};
